/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Binary data encoded as a base64 string */
  Base64: { input: unknown; output: unknown; }
  /** The BigDecimal value, transported as a string */
  BigDecimal: { input: string; output: string; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: string | number; output: string | number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: unknown; output: unknown; }
  /** A JSON object (key-value pairs). Arrays and primitives are rejected. */
  JsonHash: { input: unknown; output: unknown; }
};

/** Account held by the user. */
export type Account = {
  __typename?: 'Account';
  /** The display name of the account, without the provider name. May not be the official name of the account. */
  accountName: Scalars['String']['output'];
  /** The custodial account number of the account. */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Open account sleeves for the account. Sleeves Orion has stopped reporting are hidden. */
  accountSleeves: Maybe<Array<AccountSleeve>>;
  /** Whether the account is an IRA or personal account */
  accountType: Maybe<Scalars['String']['output']>;
  /** Active enrollment task if any */
  activeEnrollmentTask: Maybe<Task>;
  /**
   * The active Savvy fee schedule on the account's household, if any. Distinct
   * from the Orion-sourced billing fields (e.g. orionFeeSchedule,
   * orionBillFrequency).
   */
  activeFeeSchedule: Maybe<HouseholdFeeSchedule>;
  /** Active swim request if any */
  activeSwimRequest: Maybe<SwimRequest>;
  /** Available cash (current balance minus pending trade amounts in Created or Processed status). */
  availableCash: Value;
  /** Available credit amount for loan type of accounts - ie PAL */
  availableCredit: Maybe<Scalars['BigDecimal']['output']>;
  /** List of beneficiaries for the account */
  beneficiaries: Array<Beneficiary>;
  /**
   * Combined cash and money market balance for the account, sourced from
   * denormalized columns. Null when both columns are unset.
   */
  cashAndMoneyMarket: Maybe<CashAndMoneyMarket>;
  /** Whether a co manager, if they exist, is an account holder */
  coManagerIsAccountHolder: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account was created this year */
  createdThisYear: Scalars['Boolean']['output'];
  /** Credit limit amount for loan type of accounts - ie PAL */
  creditLimit: Maybe<Scalars['BigDecimal']['output']>;
  /** The custody status of the account. */
  custody: AccountCustodyName;
  /** Advisor created name for a managed acccount */
  customName: Maybe<Scalars['String']['output']>;
  /** Advisor created note for a managed acccount */
  customNote: Maybe<Scalars['String']['output']>;
  /**
   * Whether this account is enrolled in Direct Indexing (product_type ==
   * direct_index). Used to gate Direct Index Report eligibility.
   */
  directIndexing: Scalars['Boolean']['output'];
  /**
   * Whether to label this account as Direct Indexing: the Savvy product, or
   * sub-advised by Orion Custom Indexing. Display only - use directIndexing for
   * report eligibility.
   */
  directIndexingDisplay: Scalars['Boolean']['output'];
  /** The current balance of the account. */
  displayBalance: Value;
  /** The display name of the account, possibly with the provider name. May not be the official name of the account. */
  displayName: Scalars['String']['output'];
  /**
   * Transactions for the account with pending (pre-settlement) rows and reversed
   * rows superseded by a matching complete row hidden — for the client/advisor
   * portfolio view.
   */
  displayableTransactions: Maybe<Array<Transaction>>;
  /**
   * Balances for ECI accounts, sourced live from Fidelity; null otherwise. Batched
   * across accounts, so safe to select over an account list (e.g. the picker).
   */
  eciBalances: Maybe<EciBalances>;
  /**
   * Holdings for ECI accounts, sourced live from Fidelity; null otherwise. Batched
   * across accounts, so safe to select over an account list.
   */
  eciHoldings: Maybe<EciHoldings>;
  /** Whether the account is enrolled in a SWIM (Savvy) strategy based on strategy name */
  enrolledInSwimStrategy: Scalars['Boolean']['output'];
  /** Current enrollment status of the account */
  enrollmentStatus: AccountEnrollmentStatus;
  /** The name of the firm associated with this account */
  firmName: Maybe<Scalars['String']['output']>;
  /** List of Savvy IDs of the funding destinations for this account */
  fundingDestinations: Array<Scalars['ID']['output']>;
  /** List of Savvy IDs of the funding sources for this account */
  fundingSources: Array<Scalars['ID']['output']>;
  /** Whether the account has multiple accounts */
  hasMultipleAccounts: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account has mutual funds */
  hasMutualFunds: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from client */
  hiddenFromClient: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  hiddenFromNetWorth: Maybe<Scalars['Boolean']['output']>;
  /** The primary account holder client profile */
  holder: Maybe<Client>;
  /** List of holdings for the account */
  holdings: Array<Holding>;
  /** The household this account belongs to (via the primary client). */
  household: Maybe<Household>;
  /** The Savvy ID of the account. */
  id: Scalars['ID']['output'];
  /** If this is a new transfering account, the type of that transfer */
  initialTransferType: Maybe<InitialTransferTypeName>;
  /** The interest rate of a loan (on top of SOFR) */
  interestRate: Maybe<Scalars['BigDecimal']['output']>;
  /** The type of IRA the account is. Present only if account_type is IRA */
  iraType: Maybe<Scalars['String']['output']>;
  /**
   * True for a live-data ECI account (Fidelity-NFS + advisor enabled). Lets the
   * client tell "not ECI" from "ECI, fetch failed" (isEci && eciBalances == null).
   */
  isEci: Scalars['Boolean']['output'];
  /** The timestamp the account was last updated with information from the source provider. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** External bank accounts authorized for transfers to/from this Savvy-managed account. Filtered to active authorizations. */
  linkedBankAccounts: Array<LinkedBankAccount>;
  /** The provider of a loan, like a PAL */
  loanProvider: Maybe<Scalars['String']['output']>;
  /** The last 2-4 alphanumeric characters of an account's official account number. */
  mask: Maybe<Scalars['String']['output']>;
  /**
   * The display name of the account. May not be the official name of the account.
   * @deprecated Name is ambiguous, use display name or account name instead.
   */
  name: Scalars['String']['output'];
  /** The custodian of a new account, for use with the account confirmation flow */
  newAccountCustodian: Maybe<Scalars['String']['output']>;
  /** Whether an account is a savvy offered (but not managed) product */
  offeredBySavvy: Scalars['Boolean']['output'];
  /** The official name of the account, provided from a source like Plaid. */
  officialName: Maybe<Scalars['String']['output']>;
  /** The account start date from Orion. */
  orionAccountStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The billing frequency from Orion. */
  orionBillFrequency: Maybe<Scalars['String']['output']>;
  /** The bill pay method from Orion. */
  orionBillPayMethod: Maybe<Scalars['String']['output']>;
  /** The bill style from Orion (Arrear/Advance). */
  orionBillStyle: Maybe<Scalars['String']['output']>;
  /** The account id from Orion Eclipse. */
  orionCustodialAccountId: Maybe<Scalars['String']['output']>;
  /** The fee schedule name from Orion. */
  orionFeeSchedule: Maybe<Scalars['String']['output']>;
  /** Information about the performance of a managed account */
  performance: Maybe<Array<Performance>>;
  /** Type of personal account */
  personalAccountType: Maybe<Scalars['String']['output']>;
  /** The portfolio the account belongs to */
  portfolio: Maybe<Portfolio>;
  /** Whether the primary client is an account holder on this account */
  primaryClientIsAccountHolder: Maybe<Scalars['Boolean']['output']>;
  /** Specific Savvy product type - either Direct Index or Cash Management */
  productType: Maybe<AccountProductTypeName>;
  /** The Savvy Provider Account associated with the account */
  providerAccount: Maybe<ProviderAccount>;
  /** The Savvy ID of the provider account associated with the account */
  providerAccountId: Maybe<Scalars['ID']['output']>;
  /** The URL for the logo of the provider. */
  providerLogoUrl: Maybe<Scalars['String']['output']>;
  /** Purpose of this account */
  purpose: Maybe<Scalars['String']['output']>;
  /** Only present if purpose is other */
  purposeOther: Maybe<Scalars['String']['output']>;
  /** The recurring adjustment bill end date from Orion. */
  recurringAdjustmentBillEndDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The recurring adjustment bill schedule name from Orion. */
  recurringAdjustmentBillScheduleName: Maybe<Scalars['String']['output']>;
  /** The recurring adjustment bill start date from Orion. */
  recurringAdjustmentBillStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Registration type, either individual or joint */
  registrationType: Maybe<Scalars['String']['output']>;
  /** The registration type of the account when other is selected */
  registrationTypeOther: Maybe<Scalars['String']['output']>;
  /** The sleeve strategy aggregate name from Eclipse for sleeved accounts */
  sleeveStrategyAggregateName: Maybe<Scalars['String']['output']>;
  /** The source provider. */
  source: Maybe<ProviderAccountSource>;
  /** Source of the funds for this Account */
  sourceOfFunds: Maybe<Scalars['String']['output']>;
  /** Only present if source_of_funds is other */
  sourceOfFundsOther: Maybe<Scalars['String']['output']>;
  /** The unique account identifier from the source provider. */
  sourceProviderId: Maybe<Scalars['String']['output']>;
  /** Box folder id for uploading account statements into. */
  statementsBoxFolderId: Maybe<Scalars['String']['output']>;
  status: AccountStatusName;
  /** The id of the PortfolioStrategy the account is associated with */
  strategyId: Maybe<Scalars['ID']['output']>;
  /** The name of the strategy the account is associated with */
  strategyName: Maybe<Scalars['String']['output']>;
  /** The type of strategy the account is associated with */
  strategyType: Maybe<StrategyTypeName>;
  /** The subtype of the account mainly from Plaid, Orion, and Crypto */
  subtype: Maybe<AccountSubtypeName>;
  /**
   * Raw, unfiltered transactions for the account, including pending and superseded
   * reversed rows — most callers want displayableTransactions instead.
   */
  transactions: Maybe<Array<Transaction>>;
  /** Box folder id for uploading account trust documents into. */
  trustDocumentsBoxFolderId: Maybe<Scalars['String']['output']>;
  type: PortfolioItemTypeName;
  /** Whether a voided check is requested for this account */
  voidedCheckRequested: Maybe<Scalars['Boolean']['output']>;
  /** Box folder id for uploading account voided checks into. */
  voidedChecksBoxFolderId: Maybe<Scalars['String']['output']>;
};

/** Information about an account beneficiary */
export type AccountBeneficiaryInput = {
  contactId: Scalars['ID']['input'];
  percentage: Scalars['Float']['input'];
  type: AccountBeneficiaryTypeName;
};

/** Type of account beneficiary */
export type AccountBeneficiaryTypeName =
  /** contingent */
  | 'contingent'
  /** primary */
  | 'primary';

/** Information about the account for account opening */
export type AccountConfirmationAccountInfoInput = {
  /** Account holder. Could be the primary client or the co-client. Required only for personal individual accounts */
  accountHolder?: InputMaybe<AccountHolder>;
  /** Name of the destination account */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Type of the account */
  accountType: AccountOpeningTypeName;
  /** Beneficiaries to associate with the account */
  beneficiaries: Array<AccountBeneficiaryInput>;
  /** Type of the IRA account. Required if account type is IRA */
  iraType?: InputMaybe<IraTypeName>;
  /** Type of the Personal account. Required if account type is Personal */
  personalAccountType?: InputMaybe<PersonalAccountTypeName>;
  /** Purpose of account. Required if account type is Personal */
  purpose?: InputMaybe<AccountPurposeName>;
  /** Description of the purpose when Other is selected */
  purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Type of the registration. Required if account type is Personal */
  registrationType?: InputMaybe<RegistrationTypeName>;
  /** Source account for transfer of funds (TOA / ACAT) */
  sourceAccount?: InputMaybe<SourceAccountInput>;
  /** Source of funds for the account. Required if account type is Personal */
  sourceOfFunds?: InputMaybe<SourceOfFundsName>;
  /** Description of the source of funds when Other is selected */
  sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
};

/** Address information for account opening */
export type AccountConfirmationAddressInfoInput = {
  /** Address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Optional address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Client information for account confirmation. Similar to
 * InputObjects::AccountOpeningInputs::ClientInfoInput, but with less required fields
 */
export type AccountConfirmationClientInfoInput = {
  /** 2 letter country code for client citizenship */
  citizenship: Scalars['String']['input'];
  /** Client date of birth. Format: YYYY-MM-DD */
  dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Client email */
  email: Scalars['String']['input'];
  /** Client employer name. Required if employment status is employed */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Client employment status */
  employmentStatus?: InputMaybe<EmploymentStatusName>;
  /** Client first name */
  firstName: Scalars['String']['input'];
  /** Client home address */
  homeAddress?: InputMaybe<AccountConfirmationAddressInfoInput>;
  /** Client job title. Only required if employment status is employed */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client last name */
  lastName: Scalars['String']['input'];
  /** Client legal residence if other than USA */
  legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Client occupation */
  occupation?: InputMaybe<ClientOccupation>;
  /** Client phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Client Social Security Number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** Savvy user ID. If provided, the existing client will be updated */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** Account consolidation variant: a single source account consolidated into a single destination */
export type AccountConsolidationInput = {
  /** Whether to close the empty source account after consolidation */
  closeSourceAccountAfterConsolidation: Scalars['Boolean']['input'];
  /** Account to consolidate into */
  destinationAccountId: Scalars['ID']['input'];
  /** Account to consolidate from */
  sourceAccountId: Scalars['ID']['input'];
};

export type AccountCustodyName =
  /** held_away */
  | 'held_away'
  /** managed */
  | 'managed'
  /** to_be_managed */
  | 'to_be_managed'
  /** unmanaged */
  | 'unmanaged';

/** An edge in a connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Account>;
};

/** The enrollment status of an account for strategy enrollment */
export type AccountEnrollmentStatus =
  /** Account has an active enrollment task that is in progress */
  | 'IN_PROGRESS'
  /** Account is not currently enrolled in a strategy and has no active enrollment task */
  | 'NOT_ENROLLED'
  /** Account has an active enrollment task that has not been started */
  | 'PENDING';

/** A single account row for report pages that list accounts (cover page, appendix, etc.). */
export type AccountEntry = {
  __typename?: 'AccountEntry';
  /** Internal Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Orion management style / strategy name (e.g. "Managed"). Null when unavailable. */
  managementStyle: Maybe<Scalars['String']['output']>;
  /** Current market value of this account, in USD. Null when unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Masked account number in the format XXX-XX####. */
  maskedNumber: Scalars['String']['output'];
  /** Account display name (e.g. "Glenn Cooper - IRA"). */
  name: Scalars['String']['output'];
  /** Human-readable registration type (e.g. "IRA", "Roth IRA", "Individual"). */
  registrationLabel: Scalars['String']['output'];
};

/** Available filter options for accounts */
export type AccountFilterOptions = {
  __typename?: 'AccountFilterOptions';
  /** Available fee schedule options */
  feeSchedules: Array<Scalars['String']['output']>;
  /** Available household options */
  households: Array<HouseholdOption>;
  /** Available primary advisor options */
  primaryAdvisors: Array<PrimaryAdvisor>;
  /** Available strategy names */
  strategies: Array<Scalars['String']['output']>;
};

/** Type of account holder */
export type AccountHolder =
  /** co_client */
  | 'co_client'
  /** joint */
  | 'joint'
  /** primary_client */
  | 'primary_client';

/** Information about account limits that were exceeded */
export type AccountLimitExceeded = {
  __typename?: 'AccountLimitExceeded';
  /** Type of account (Primary Client, Co-Client, Joint) */
  accountType: Scalars['String']['output'];
  /** Accounts of this type */
  accounts: Array<AccountSummary>;
  /** Number of accounts of this type */
  count: Scalars['Int']['output'];
  /** Maximum allowed accounts of this type */
  limit: Scalars['Int']['output'];
};

/** A single beneficiary on an account in a beneficiary update request */
export type AccountMaintenanceBeneficiaryInput = {
  /** Existing contact in the household pool */
  contactId: Scalars['ID']['input'];
  /** Beneficiary percentage (1-100) */
  percentage: Scalars['Int']['input'];
  /** Whether the beneficiary is primary or contingent */
  relationType: BeneficiaryRelationTypeName;
};

/** Account maintenance request data associated with a task */
export type AccountMaintenanceRequest = {
  __typename?: 'AccountMaintenanceRequest';
  /** One entry per account on the request (Add Advisor variant) */
  advisorAccounts: Array<AccountMaintenanceRequestAdvisorAccount>;
  /** Annual income (Add Options and Margin variant) */
  annualIncome: Maybe<Scalars['Float']['output']>;
  /** Bank account number (Link a Bank variant) */
  bankAccountNumber: Maybe<Scalars['String']['output']>;
  /** Bank account type (Link a Bank variant) */
  bankAccountType: Maybe<BankAccountTypeName>;
  /** Name of the bank (Link a Bank variant) */
  bankName: Maybe<Scalars['String']['output']>;
  /** Names of the bank account owners (Link a Bank variant) */
  bankOwners: Maybe<Scalars['String']['output']>;
  /** Beneficiaries recorded on the request (Beneficiary Update variant) */
  beneficiaries: Array<AccountMaintenanceRequestBeneficiary>;
  /** Household member who holds the account (Add Advisor variant) */
  clientUser: Maybe<User>;
  /** Whether to close the source account after consolidation (Account Consolidation variant) */
  closeSourceAccountAfterConsolidation: Maybe<Scalars['Boolean']['output']>;
  /** Custodial account number (Add Advisor variant) */
  custodialAccountNumber: Maybe<Scalars['String']['output']>;
  /** Custodian (Add Advisor variant) */
  custodian: Maybe<CustodianName>;
  /** Whether the account is already managed (Add Advisor variant) */
  existingManagedAccount: Maybe<Scalars['Boolean']['output']>;
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Trading experience grid recorded with the request (Add Options and Margin variant) */
  investmentExperience: Maybe<InvestmentExperience>;
  /** Investment objective (Add Options and Margin variant) */
  investmentObjective: Maybe<Scalars['String']['output']>;
  /** Requested options level (Add Options and Margin variant) */
  level: Maybe<Scalars['String']['output']>;
  /** Liquid net worth (Add Options and Margin variant) */
  liquidNetWorth: Maybe<Scalars['Float']['output']>;
  /** Whether margin is requested (Add Options and Margin variant) */
  margin: Maybe<Scalars['Boolean']['output']>;
  /** Marital status of the account holder (Add Options and Margin variant) */
  maritalStatus: Maybe<Scalars['String']['output']>;
  /** Number of dependents (Add Options and Margin variant) */
  numberOfDependents: Maybe<Scalars['Int']['output']>;
  /** Whether options trading is requested (Add Options and Margin variant) */
  options: Maybe<Scalars['Boolean']['output']>;
  /** Accounts associated with the request (used by Link a Bank, Account Consolidation) */
  requestAccounts: Array<AccountMaintenanceRequestAccount>;
  /** The variant of the request (e.g. beneficiary_update, account_consolidation) */
  requestType: RequestTypeName;
  /** ABA routing number (Link a Bank variant) */
  routingNumber: Maybe<Scalars['String']['output']>;
  /** Total net worth (Add Options and Margin variant) */
  totalNetWorth: Maybe<Scalars['Float']['output']>;
};

/** An account associated with an account maintenance request */
export type AccountMaintenanceRequestAccount = {
  __typename?: 'AccountMaintenanceRequestAccount';
  /** The associated account */
  account: Maybe<Account>;
  /** The Savvy ID of the join record. */
  id: Scalars['ID']['output'];
  /** Role of the account on the request — source or destination */
  role: AccountRoleName;
};

/** One entry on an Add-Advisor-to-Account request: custodian, account number, holder, and whether it is already managed. */
export type AccountMaintenanceRequestAdvisorAccount = {
  __typename?: 'AccountMaintenanceRequestAdvisorAccount';
  /** Household member (primary or co-client) selected as the account holder */
  clientUser: User;
  /** Account number at the custodian */
  custodialAccountNumber: Scalars['String']['output'];
  /** Custodian — schwab or fidelity */
  custodian: CustodianName;
  /** Whether the account is already managed */
  existingManagedAccount: Scalars['Boolean']['output'];
  /** The Savvy ID of the entry. */
  id: Scalars['ID']['output'];
};

/** A beneficiary recorded on an account inside an account maintenance request */
export type AccountMaintenanceRequestBeneficiary = {
  __typename?: 'AccountMaintenanceRequestBeneficiary';
  /** Account the beneficiary applies to */
  account: Account;
  /** Contact recorded as the beneficiary */
  contact: Contact;
  /** The Savvy ID of the join record. */
  id: Scalars['ID']['output'];
  /** Beneficiary percentage (1-100). Derived from the underlying ContactRelation. */
  percentage: Maybe<Scalars['Int']['output']>;
  /** Beneficiary relation — primary or contingent. Derived from the underlying ContactRelation. */
  relationType: Maybe<BeneficiaryRelationTypeName>;
};

/** Account maintenance request — exactly one variant must be set (oneOf). */
export type AccountMaintenanceRequestTaskInput =
  /** Account consolidation variant */
  { accountConsolidation: AccountConsolidationInput; addAdvisorToAccount?: never; addOptionsAndMargin?: never; beneficiaryUpdate?: never; linkABank?: never; }
  |  /** Add advisor to existing account variant */
  { accountConsolidation?: never; addAdvisorToAccount: AddAdvisorToAccountInput; addOptionsAndMargin?: never; beneficiaryUpdate?: never; linkABank?: never; }
  |  /** Add options & margin variant */
  { accountConsolidation?: never; addAdvisorToAccount?: never; addOptionsAndMargin: AddOptionsAndMarginInput; beneficiaryUpdate?: never; linkABank?: never; }
  |  /** Beneficiary update variant */
  { accountConsolidation?: never; addAdvisorToAccount?: never; addOptionsAndMargin?: never; beneficiaryUpdate: BeneficiaryUpdateInput; linkABank?: never; }
  |  /** Link a bank variant */
  { accountConsolidation?: never; addAdvisorToAccount?: never; addOptionsAndMargin?: never; beneficiaryUpdate?: never; linkABank: LinkABankInput; };

/** Type of account being opened */
export type AccountOpeningTypeName =
  /** ira */
  | 'ira'
  /** personal */
  | 'personal';

/** Type of account owner */
export type AccountOwner =
  /** co_client */
  | 'co_client'
  /** joint */
  | 'joint'
  /** primary_client */
  | 'primary_client';

/** Per-account block of the Account Performance section: header row + cumulative-return time series. */
export type AccountPerformance = {
  __typename?: 'AccountPerformance';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), when available. */
  accountMask: Maybe<Scalars['String']['output']>;
  /** Display name for the account. */
  accountName: Scalars['String']['output'];
  /** Full account number, when available on the account record. */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Daily cumulative-return points for the account performance line chart. Empty when data is unavailable. */
  cumulativeReturnPoints: Array<ReturnPoint>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  endingMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Per-period total return rows for this account. */
  summaryRows: Array<PeriodReturnRow>;
  /** Strategy / target allocation name shown in the table's Target Name column; falls back to a sensible default when unset. */
  targetName: Scalars['String']['output'];
};

/** Performance breakdown for a specific account within a portfolio performance report. */
export type AccountPerformanceBreakdown = {
  __typename?: 'AccountPerformanceBreakdown';
  /** The Savvy account ID */
  accountId: Scalars['ID']['output'];
  /** The display name of the account */
  accountName: Maybe<Scalars['String']['output']>;
  /** The custodial account number of the account */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Per-sleeve performance breakdowns within this account */
  accountSleeveBreakdowns: Maybe<Array<SleevePerformanceBreakdown>>;
  /** Asset category breakdown for this account (e.g. Equity, Fixed Income) */
  assetCategoryGrouping: Maybe<Array<AssetGrouping>>;
  /** Asset class breakdown for this account (e.g. Large Blend, Intermediate Core Bond) — finer grain than category */
  assetClassGrouping: Maybe<Array<AssetGrouping>>;
  /**
   * Per-account holdings tagged with this account_id. The parent report's
   * `holdings` field is aggregated across accounts and never carries account_id;
   * use this for per-account breakdowns.
   */
  holdings: Maybe<Array<ReportedHolding>>;
  /** The last 2-4 alphanumeric characters of the account number */
  mask: Maybe<Scalars['String']['output']>;
  /** Performance data for this account across time periods */
  performanceOverTime: Array<Performance>;
  /** The custodian or provider name (e.g. Fidelity, Charles Schwab) */
  providerName: Maybe<Scalars['String']['output']>;
  /** The name of the strategy the account is enrolled in */
  strategyName: Maybe<Scalars['String']['output']>;
  /** The subtype of the account (e.g. Brokerage, IRA) */
  subtype: Maybe<AccountSubtypeName>;
};

/**
 * One row of the 'Account Performance' table — per-account market value plus MTD,
 * QTD, YTD, and since-inception time-weighted returns.
 */
export type AccountPerformanceRow = {
  __typename?: 'AccountPerformanceRow';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Display name for the account. */
  accountName: Scalars['String']['output'];
  /** Masked account number (last digits), when available. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Since-inception TWR as a fraction, annualized for windows over one year (Orion parity); null when unavailable. */
  inceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Month-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  mtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return as a fraction; null when data is unavailable. */
  qtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Trailing one-year time-weighted return as a fraction; null when the account has less than one year of history. */
  rollingOneYearReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return as a fraction; null when data is unavailable. */
  ytdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

export type AccountProductTypeName =
  /** cash_management */
  | 'cash_management'
  /** direct_index */
  | 'direct_index';

/** Purpose of the account */
export type AccountPurposeName =
  /** general_investing */
  | 'general_investing'
  /** investing_for_college */
  | 'investing_for_college'
  /** investing_for_estate_planning */
  | 'investing_for_estate_planning'
  /** investing_for_retirement */
  | 'investing_for_retirement'
  /** investing_for_tax_planning */
  | 'investing_for_tax_planning'
  /** investing_of_pooled_assets */
  | 'investing_of_pooled_assets'
  /** other */
  | 'other';

/** Role of an account on an account maintenance request — source or destination */
export type AccountRoleName =
  /** destination */
  | 'destination'
  /** source */
  | 'source';

/** Account setup for an account confirmation task */
export type AccountSetup =
  /** account_opening */
  | 'account_opening'
  /** account_transfer */
  | 'account_transfer';

/** Account sleeve held by the user. */
export type AccountSleeve = {
  __typename?: 'AccountSleeve';
  /** The account the sleeve is associated with */
  account: Account;
  /** Available cash (sleeve balance minus account pending trade amounts in Created or Processed status). */
  availableCash: Value;
  /** When Orion stopped reporting this sleeve. Null while it is still reported. */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Advisor created name for a managed acccount sleeve */
  customName: Maybe<Scalars['String']['output']>;
  /** Advisor created note for a managed acccount sleeve */
  customNote: Maybe<Scalars['String']['output']>;
  /** Whether this sleeve is enrolled in Direct Indexing. Used to gate Direct Index Report eligibility. */
  directIndexing: Scalars['Boolean']['output'];
  /** The current balance of the account. */
  displayBalance: Value;
  /** The display name of the account, possibly with the provider name. May not be the official name of the account. */
  displayName: Scalars['String']['output'];
  /** List of holdings for the account */
  holdings: Array<Holding>;
  /** The Savvy ID of the account. */
  id: Scalars['ID']['output'];
  /** The timestamp the account was last updated with information from the source provider. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The unique account identifier from the source provider. */
  orionAccountId: Maybe<Scalars['String']['output']>;
  /** Information about the performance of a managed account */
  performance: Maybe<Array<Performance>>;
  /** The portfolio the account belongs to */
  portfolio: Maybe<Portfolio>;
  /** The URL for the logo of the provider. */
  providerLogoUrl: Maybe<Scalars['String']['output']>;
  /** The id of the PortfolioStrategy the account is associated with */
  strategyId: Maybe<Scalars['ID']['output']>;
  /** The name of the strategy the account is associated with */
  strategyName: Maybe<Scalars['String']['output']>;
  /** List of transactions for the account */
  transactions: Maybe<Array<Transaction>>;
};

/** Sortable fields for account lists */
export type AccountSortValues =
  /** Sort by account name */
  | 'ACCOUNT_NAME'
  /** Sort by account balance */
  | 'BALANCE'
  /** Sort by combined cash and money market amount */
  | 'CASH_AND_MONEY_MARKET_AMOUNT'
  /** Sort by combined cash and money market percentage of balance */
  | 'CASH_AND_MONEY_MARKET_PERCENT'
  /** Sort by household name */
  | 'HOUSEHOLD_NAME'
  /** Sort by account start date */
  | 'START_DATE';

export type AccountStatusName =
  /** active */
  | 'active'
  /** closed */
  | 'closed'
  /** deleted */
  | 'deleted'
  /** hidden */
  | 'hidden'
  /** to_be_opened */
  | 'to_be_opened';

export type AccountSubtypeName =
  | 'annuity'
  | 'auto'
  | 'beneficiary_ira'
  | 'brokerage'
  | 'business'
  | 'cash_isa'
  | 'cash_management'
  | 'cd'
  | 'checking'
  | 'cold_wallet'
  | 'commercial'
  | 'community_property'
  | 'company_daf'
  | 'conservatorship'
  | 'construction'
  | 'consumer'
  | 'contributory_ira'
  | 'contributory_roth'
  | 'conversion_roth'
  | 'corporate_401k'
  | 'corporation'
  | 'credit_card'
  | 'custodial'
  | 'custodial_roth_contributory_ira'
  | 'defined'
  | 'defined_benefit_plan'
  | 'defined_contribution_plan'
  | 'defined_pension'
  | 'donor_advised_fund'
  | 'ebt'
  | 'education_ira'
  | 'education_savings_account'
  | 'educational_savings_account'
  | 'estate'
  | 'exchange'
  | 'financial_planning_fee'
  | 'fixed_annuity'
  | 'foundation'
  | 'gic'
  | 'gst_exempt'
  | 'guardianship'
  | 'hardware_wallet'
  | 'health_reimbursement_arrangement'
  | 'health_savings_account'
  | 'home_equity'
  | 'hot_wallet'
  | 'hsa'
  | 'individual'
  | 'inherited_ira'
  | 'inherited_roth_ira'
  | 'invalid_type'
  | 'ira'
  | 'ira_cont'
  | 'ira_rollover'
  | 'isa'
  | 'iso'
  | 'joint'
  | 'joint_tenant'
  | 'jtwros'
  | 'keogh'
  | 'lif'
  | 'life_insurance'
  | 'line_of_credit'
  | 'lira'
  | 'loan'
  | 'lrif'
  | 'lrsp'
  | 'marital_trust'
  | 'money_market'
  | 'money_purchase_pension_plan'
  | 'mortgage'
  | 'mutual_fund'
  | 'non_custodial_wallet'
  | 'non_profit'
  | 'non_taxable_brokerage_account'
  | 'nso'
  | 'optional_retirement_program'
  | 'other'
  | 'other_annuity'
  | 'other_insurance'
  | 'overdraft'
  | 'partnership'
  | 'paypal'
  | 'paypal_credit_card'
  | 'pension'
  | 'personal_choice_retirement_account'
  | 'plan401a'
  | 'plan401k'
  | 'plan403b'
  | 'plan457b'
  | 'plan529'
  | 'pledged_asset_line'
  | 'prepaid'
  | 'prif'
  | 'private'
  | 'private_equity'
  | 'profit_sharing_plan'
  | 'public'
  | 'qshr'
  | 'rdsp'
  | 'real_estate'
  | 'resp'
  | 'retirement'
  | 'retirement_plan'
  | 'revocable_trust'
  | 'rlif'
  | 'roth'
  | 'roth_401k'
  | 'roth_ira'
  | 'rrif'
  | 'rrsp'
  | 'rsa'
  | 'rsu'
  | 'sarsep'
  | 'savings'
  | 'sep_ira'
  | 'simple'
  | 'simple_ira'
  | 'simplified_employee_pension_plan'
  | 'sipp'
  | 'sole_and_separate_property'
  | 'spouse'
  | 'stock_plan'
  | 'student'
  | 'tax_sheltered_account'
  | 'tenants_by_entirety'
  | 'tenants_in_common'
  | 'tfsa'
  | 'transfer_on_death'
  | 'trust'
  | 'trust_under_will'
  | 'ugma'
  | 'uniform_gift_to_minors_account'
  | 'uniform_transfers_to_minors_account'
  | 'utma'
  | 'variable_annuity';

/** Summary information for an account */
export type AccountSummary = {
  __typename?: 'AccountSummary';
  /** Account number */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Account ID */
  id: Scalars['ID']['output'];
  /** Account name */
  name: Scalars['String']['output'];
};

/** A single row of the 'Accounts Included in this Report' table on page 1 of the PDF. */
export type AccountSummaryRow = {
  __typename?: 'AccountSummaryRow';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Display name for the account. */
  accountName: Scalars['String']['output'];
  /** Masked account number (last digits), when available. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Registration / account-type label (e.g. "Roth IRA"). */
  accountType: Maybe<Scalars['String']['output']>;
  /** Custodian display name (e.g. "Schwab"). */
  custodian: Maybe<Scalars['String']['output']>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
};

/** Information about an account transfer */
export type AccountTransferDatum = {
  __typename?: 'AccountTransferDatum';
  /** The account holder name */
  accountName: Scalars['String']['output'];
  /** The account number */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** The type of account owner */
  accountOwner: AccountOwner;
  /** The Savvy ID of the account transfer information */
  id: Scalars['ID']['output'];
};

/** Input for account transfer information */
export type AccountTransferDatumInput = {
  /** The account holder name */
  accountName: Scalars['String']['input'];
  /** The account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of account owner */
  accountOwner: AccountOwner;
};

export type AccountTransferStatus =
  /** accountcreationandtransfercomplete */
  | 'accountcreationandtransfercomplete'
  /** pendingaccountcreationandtransfer */
  | 'pendingaccountcreationandtransfer'
  /** pendingclientdocusignsignature */
  | 'pendingclientdocusignsignature'
  /** transferpartiallycomplete */
  | 'transferpartiallycomplete';

/** Types for an account transfer setup */
export type AccountTransferTypeName =
  /** fidelity_iws_to_fidelity_iws */
  | 'fidelity_iws_to_fidelity_iws'
  /** schwab_to_schwab */
  | 'schwab_to_schwab';

/**
 * A named group with an aggregate market value — used in Relationship Summary
 * tables (e.g. Taxable Accounts, Retirement Accounts – Tax Deferred).
 */
export type AccountTypeGroup = {
  __typename?: 'AccountTypeGroup';
  /** Row discriminant: "household_total" for the household rollup row, "tax_group" for a tax-treatment sub-group. */
  kind: Scalars['String']['output'];
  /** Display label for this group (e.g. "Taxable Accounts"). */
  label: Scalars['String']['output'];
  /** Total market value across all accounts in this group, in USD. Null when account values are unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
};

export type AccountTypeName =
  | 'credit'
  | 'cryptocurrency'
  | 'depository'
  | 'employer_equity'
  | 'fund_investment'
  | 'insurance'
  | 'investment'
  | 'loan'
  | 'other'
  | 'private_investment';

/** Per-account performance over an arbitrary date range. */
export type AccountWindowPerformance = {
  __typename?: 'AccountWindowPerformance';
  /** Savvy Account id this row belongs to. */
  accountId: Scalars['ID']['output'];
  /** Effective window end. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Account market value at window end. */
  endValue: Maybe<Value>;
  /** Effective window start. May differ from the requested start when Orion clamps to the account funded date. */
  startDate: Scalars['ISO8601Date']['output'];
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). */
  twr: Maybe<Scalars['Float']['output']>;
};

/** Account numbers grouped by signer role for the LPOA layer of the repaper envelope */
export type AccountsInfoInput = {
  /** Account numbers held solely by the co-client (reserved for future co-client-only flow; send [] when unused) */
  coClientAccounts: Array<Scalars['String']['input']>;
  /** Account numbers held jointly by primary + co-client */
  jointClientAccounts: Array<Scalars['String']['input']>;
  /** Account numbers held solely by the primary client */
  primaryClientAccounts: Array<Scalars['String']['input']>;
};

/** Autogenerated input type of AcknowledgeAlert */
export type AcknowledgeAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Alert ID to acknowledge */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcknowledgeAlert. */
export type AcknowledgeAlertPayload = {
  __typename?: 'AcknowledgeAlertPayload';
  /** The acknowledged alert */
  alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ActivateServiceCalendarForHousehold */
export type ActivateServiceCalendarForHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateServiceCalendarForHousehold. */
export type ActivateServiceCalendarForHouseholdPayload = {
  __typename?: 'ActivateServiceCalendarForHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** One column of the Portfolio Summary (Simple) Activity Summary table. */
export type ActivityPeriod = {
  __typename?: 'ActivityPeriod';
  /** Portfolio market value at the start of the period, in USD. */
  beginningMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at the end of the period, in USD. */
  endingMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Display label for the column header (e.g. "Quarter to Date", "4/1/26 - 5/1/26"). */
  label: Scalars['String']['output'];
  /** Net cash flows (contributions minus withdrawals) during the period, in USD. */
  netAdditions: Maybe<Scalars['BigDecimal']['output']>;
  /** Market-value change minus net additions: EMV − BMV − net_additions, in USD. */
  netGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Which period this column represents. */
  period: PortfolioSummarySimplePeriod;
  /**
   * Display time-weighted return as a fraction: annualized for periods over one
   * year (Orion convention), equal to the cumulative return for shorter periods.
   * This is the value shown in the report. Null when unavailable.
   */
  returnAnnualized: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return for the period as a fraction (e.g. 0.0707 = 7.07%). Null when data is unavailable. */
  returnCumulative: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start date of this period. Null when inception date is unknown. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * One row of the 'Activity Summary' table — beginning market value, net cash
 * flows, dividends and interest, bond accrual movement, and time-weighted return
 * for a single reporting period (QTD, YTD, or Since Inception).
 */
export type ActivitySummaryRow = {
  __typename?: 'ActivitySummaryRow';
  /** Market value at the start of the period including bond accrual, in USD; null when data is unavailable. */
  beginningMarketValueWithBondAccrual: Maybe<Scalars['BigDecimal']['output']>;
  /** Dividends and interest received over the period, in USD; null when data is unavailable. */
  dividendsAndInterest: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period as resolved against the snapshot. */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Bond accrual balance at the end of the period, in USD; null when not tracked for this household. */
  endingBondAccrual: Maybe<Scalars['BigDecimal']['output']>;
  /** Market value at the end of the period including bond accrual, in USD; null when data is unavailable. */
  endingMarketValueWithBondAccrual: Maybe<Scalars['BigDecimal']['output']>;
  /** Change in market value over the period (gain/loss exclusive of cash flows), in USD; null when data is unavailable. */
  marketValueChange: Maybe<Scalars['BigDecimal']['output']>;
  /** Net contributions over the period (deposits minus withdrawals), in USD; null when data is unavailable. */
  netCashFlows: Maybe<Scalars['BigDecimal']['output']>;
  /** Reporting period. */
  period: PerformanceReportConsolidatedPeriod;
  /** Inclusive start date of this period as resolved against the snapshot. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Time-weighted return over the period as a fraction (0.05 = 5%); null when data is unavailable. */
  timeWeightedReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** Deduped touchpoint count for one activity timeline item type */
export type ActivityTimelineContactChannelCount = {
  __typename?: 'ActivityTimelineContactChannelCount';
  /** Number of deduped touchpoints of this type in the window */
  count: Scalars['Int']['output'];
  /** Activity timeline item type the count belongs to */
  type: ItemTypeEnum;
};

/** A contact or beneficiary a household timeline item has been surfaced on */
export type ActivityTimelineContactLink = {
  __typename?: 'ActivityTimelineContactLink';
  /** The contact id */
  contactId: Scalars['ID']['output'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  contactType: Scalars['String']['output'];
  /** Display name for the linked contact */
  name: Scalars['String']['output'];
};

/** Client-facing contact on a household over a date window: how much, how recent, through which channels, about what */
export type ActivityTimelineContactSummary = {
  __typename?: 'ActivityTimelineContactSummary';
  /** Per-item-type breakdown, highest count first */
  countsByType: Array<ActivityTimelineContactChannelCount>;
  /** When the most recent touchpoint on record occurred, ignoring startDate; null when there has never been one */
  lastContactAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Topics tagged on the window's notes, most frequent first */
  topTopics: Array<Scalars['String']['output']>;
  /** Total deduped touchpoints in the window */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AddAdvisorGroupToOrganization */
export type AddAdvisorGroupToOrganizationInput = {
  /** ID of the advisor group to link */
  advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to link the group to */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddAdvisorGroupToOrganization. */
export type AddAdvisorGroupToOrganizationPayload = {
  __typename?: 'AddAdvisorGroupToOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The organization the group was linked to */
  organization: Maybe<Organization>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** A single account entry for the Add Advisor variant */
export type AddAdvisorToAccountEntryInput = {
  /** Household member (primary or co-client) selected as the account holder */
  clientUserId: Scalars['ID']['input'];
  /** Account number at the custodian */
  custodialAccountNumber: Scalars['String']['input'];
  /** Custodian — schwab or fidelity */
  custodian: CustodianName;
  /** Whether the account is already managed */
  existingManagedAccount: Scalars['Boolean']['input'];
};

/** Add advisor to existing account variant */
export type AddAdvisorToAccountInput = {
  /** One entry per account the advisor should be added to (at least one) */
  entries: Array<AddAdvisorToAccountEntryInput>;
};

/** Autogenerated input type of AddAdvisorToExistingAdvisorGroup */
export type AddAdvisorToExistingAdvisorGroupInput = {
  /** ID of the advisor group to add the advisor to */
  advisorGroupId: Scalars['ID']['input'];
  /** User ID of the advisor to add */
  advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAdvisorToExistingAdvisorGroup. */
export type AddAdvisorToExistingAdvisorGroupPayload = {
  __typename?: 'AddAdvisorToExistingAdvisorGroupPayload';
  /** The advisor group the advisor was added to */
  advisorGroup: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddAdvisorsToOrganization */
export type AddAdvisorsToOrganizationInput = {
  advisorUserIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddAdvisorsToOrganization. */
export type AddAdvisorsToOrganizationPayload = {
  __typename?: 'AddAdvisorsToOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Scalars['String']['output']>;
  organization: Maybe<Organization>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddCommentAttachments */
export type AddCommentAttachmentsInput = {
  /** Files to attach, already uploaded to Box by the client. */
  attachments: Array<CommentAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to attach the files to */
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddCommentAttachments. */
export type AddCommentAttachmentsPayload = {
  __typename?: 'AddCommentAttachmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The comment, with its attachments after the add */
  comment: Comment;
};

/** Attributes for adding a family member to a household */
export type AddFamilyMemberInput = {
  /** Street address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in ISO format */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  dependentOfHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  dependentOfUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Entity established date for trusts */
  entityDateEstablished?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Entity date of death for estates */
  entityDateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Tax ID/EIN for entity contacts */
  entityEin?: InputMaybe<Scalars['String']['input']>;
  /** Executor or personal representative for estate entities */
  entityExecutorName?: InputMaybe<Scalars['String']['input']>;
  /** Entity display name for Trust, Organization, or Estate contacts */
  entityName?: InputMaybe<Scalars['String']['input']>;
  /** Organization type (LLC, S-Corp, etc.) */
  entityOrganizationType?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact or role for organization entities */
  entityPrimaryContactRole?: InputMaybe<Scalars['String']['input']>;
  /** Trust type (Revocable, Irrevocable, Testamentary, Other) */
  entityTrustType?: InputMaybe<Scalars['String']['input']>;
  /** Trustee name for trust entities */
  entityTrusteeName?: InputMaybe<Scalars['String']['input']>;
  /** Entity type (trust, organization, estate) */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this contact is a beneficiary */
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection. Sending this
   * makes dependentOfHouseholdId and dependentOfUserId authoritative: a named
   * target replaces the stored one and an omitted pair clears it. Omit all three
   * to leave the dependency untouched
   */
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this contact is a trusted contact */
  isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Preferred nickname */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Freeform notes about the contact */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the household */
  relation?: InputMaybe<Scalars['String']['input']>;
  /** Social Security Number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP / postal code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AddFamilyMembers */
export type AddFamilyMembersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of family members to add */
  familyMembers: Array<AddFamilyMemberInput>;
  /** ID of the household to add family members to */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddFamilyMembers. */
export type AddFamilyMembersPayload = {
  __typename?: 'AddFamilyMembersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  errors: Array<Scalars['String']['output']>;
  /** The created family members */
  familyMembers: Array<FamilyMember>;
};

/** Autogenerated input type of AddHouseholdMember */
export type AddHouseholdMemberInput = {
  /** Whether the member can sign client agreements for the household. Defaults to false. */
  canSignClientAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to add the member to. */
  householdId: Scalars['ID']['input'];
  /** Whether the member is an account holder on household accounts. Defaults to false. */
  isAccountHolder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The member's role in the household. */
  role: HouseholdMembershipRole;
  /** Free-form description of the member's trustee capacity, if applicable. */
  trusteeCapacity?: InputMaybe<Scalars['String']['input']>;
  /** The user being added as a member. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddHouseholdMember. */
export type AddHouseholdMemberPayload = {
  __typename?: 'AddHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created household membership. */
  membership: HouseholdMembership;
};

/** Autogenerated input type of AddNotificationAlertMute */
export type AddNotificationAlertMuteInput = {
  /** A specific account to mute; omit for the whole household. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** The alert type to mute (cash_variance or allocation_variance). */
  alertType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to mute the alert for. */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddNotificationAlertMute. */
export type AddNotificationAlertMutePayload = {
  __typename?: 'AddNotificationAlertMutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created mute. */
  mute: NotificationAlertMute;
};

/** Add options & margin variant — reuses the Open New Account options question set */
export type AddOptionsAndMarginInput = {
  /** Annual income */
  annualIncome?: InputMaybe<Scalars['Float']['input']>;
  /** Custodian — schwab or fidelity (drives the options level set) */
  custodian?: InputMaybe<CustodianName>;
  /** Investment experience grid across all instrument categories */
  investmentExperienceGrid?: InputMaybe<InvestmentExperienceGridInput>;
  /** Investment objective */
  investmentObjective?: InputMaybe<Scalars['String']['input']>;
  /** Options level */
  level?: InputMaybe<Scalars['String']['input']>;
  /** Liquid net worth */
  liquidNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether margin trading is being enabled */
  margin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Marital status */
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Number of dependents */
  numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Whether options trading is being enabled */
  options: Scalars['Boolean']['input'];
  /** Total net worth */
  totalNetWorth?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of AddSecondaryPortfolio */
export type AddSecondaryPortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  secondaryPortfolioId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSecondaryPortfolio. */
export type AddSecondaryPortfolioPayload = {
  __typename?: 'AddSecondaryPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddServiceCatalogItemToGroup */
export type AddServiceCatalogItemToGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item group id */
  serviceCatalogItemGroupId: Scalars['ID']['input'];
  /** Service catalog item id */
  serviceCatalogItemId: Scalars['ID']['input'];
  /** Sort order */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AddServiceCatalogItemToGroup. */
export type AddServiceCatalogItemToGroupPayload = {
  __typename?: 'AddServiceCatalogItemToGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item group membership */
  serviceCatalogItemGroupMembership: Maybe<ServiceCatalogItemGroupMembership>;
};

/** Address belonging to a user. */
export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  addressLine3: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  /** The Savvy ID of the address. */
  id: Scalars['ID']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  type: AddressTypeName;
};

export type AddressInput = {
  /** The first line of the address */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of an existing address */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The type of address */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AddressTypeName =
  | 'office'
  | 'other'
  | 'primary_residence'
  | 'secondary_residence'
  | 'vacation_home';

/** A service object that is available to admins for use in the admin dashboard. */
export type AdminServiceObject = {
  __typename?: 'AdminServiceObject';
  args: Array<AdminServiceObjectArg>;
  className: Scalars['String']['output'];
};

/** A service object argument that is available to admins for use in the admin dashboard. */
export type AdminServiceObjectArg = {
  __typename?: 'AdminServiceObjectArg';
  argName: Scalars['String']['output'];
  defaultValue: Maybe<Scalars['String']['output']>;
  isKeywordArg: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdvanceEciOnboardingToReadyToSend */
export type AdvanceEciOnboardingToReadyToSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdvanceEciOnboardingToReadyToSend. */
export type AdvanceEciOnboardingToReadyToSendPayload = {
  __typename?: 'AdvanceEciOnboardingToReadyToSendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the advance succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdvanceOnboardingAfterSigning */
export type AdvanceOnboardingAfterSigningInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdvanceOnboardingAfterSigning. */
export type AdvanceOnboardingAfterSigningPayload = {
  __typename?: 'AdvanceOnboardingAfterSigningPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

export type Advisor = {
  __typename?: 'Advisor';
  acceptedAiRecommendationsDisclosure: Maybe<Scalars['Boolean']['output']>;
  /** Available filter options for advisor accounts */
  accountFilterOptions: AccountFilterOptions;
  /** Returns a list of accounts accessible to the current user */
  accounts: AccountConnection;
  adv2bLink: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being replaced by advisor_groups. */
  advisorGroup: Maybe<AdvisorGroup>;
  /** All members of the advisor's advisor groups */
  advisorGroupMembers: Array<Advisor>;
  advisorGroups: Maybe<Array<AdvisorGroup>>;
  alertSettings: Maybe<AlertSettings>;
  alerts: Maybe<Array<Alert>>;
  assignedClients: Array<Client>;
  /** Whether the advisor belongs to at least one Group-type advisor group, which gates creating firm-visible templates */
  belongsToAdvisorGroup: Scalars['Boolean']['output'];
  /** The advisor's bill style */
  billStyle: AdvisorProfileBillStyle;
  /** The advisor's billing frequency */
  billingFrequency: AdvisorProfileBillingFrequency;
  bio: Scalars['String']['output'];
  /** Calendar events for the advisor */
  calendarEvents: CalendarEventConnection;
  calendlyLink: Maybe<Scalars['String']['output']>;
  /** Whether the advisor can create a team (firm admin with an organization). Gates the Create team affordance in Settings. */
  canCreateTeam: Scalars['Boolean']['output'];
  /** Whether the advisor can edit the organization */
  canEditOrganization: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the advisor is employed under Savvy's RIA (captive) rather than
   * running their own book (owned). Gates onboarding-wizard steps.
   */
  captive: Scalars['Boolean']['output'];
  centerOfInfluenceReps: Array<CenterOfInfluenceRep>;
  /** The Client Service Associate assigned to this advisor */
  clientAssociate: Maybe<User>;
  /** Salesforce user ID of the assigned Client Service Associate. Temporary addition whilst migrating off Salesforce. */
  clientAssociateSalesforceUserId: Maybe<Scalars['String']['output']>;
  /**
   * Advisor designations from acts_as_taggable_on(:credentials), e.g. ["CFP®",
   * "CLU®"]. Appended after the advisor's name in reports.
   */
  credentials: Array<Scalars['String']['output']>;
  /** The advisor's DBA (Doing Business As) email address for client-facing communications */
  dbaEmail: Maybe<Scalars['String']['output']>;
  /** The email address to display to clients (DBA email if set, otherwise primary email) */
  displayEmail: Scalars['String']['output'];
  /** The advisor's fee schedules */
  feeSchedules: Array<FeeSchedule>;
  fidelityMasterAccountNumber: Scalars['String']['output'];
  hasUnreadAlerts: Maybe<Scalars['Boolean']['output']>;
  /** Households of the advisor that are in the specified lead stage(s) */
  householdsByStage: Array<Household>;
  id: Scalars['ID']['output'];
  mainAdvisorGroup: Maybe<AdvisorGroup>;
  /** Advisor's full name */
  name: Scalars['String']['output'];
  noteTopics: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the advisor joined as a new advisor or was already here with a book. Null when unclassified. */
  onboardingCohort: Maybe<AdvisorOnboardingCohort>;
  /** The organization the advisor belongs to */
  organization: Maybe<Organization>;
  /** Households that are not in the won stage */
  prospectiveHouseholds: Array<Household>;
  prospects: Array<Client>;
  salesforceUserId: Scalars['String']['output'];
  schwabMasterAccountNumber: Scalars['String']['output'];
  serviceCalendarMeetingTypeTemplates: Maybe<Array<ServiceCalendarMeetingTypeTemplate>>;
  serviceCalendarSettingTemplates: Maybe<Array<ServiceCalendarSettingTemplate>>;
  /** The Savvy Client Services ops user, always available as a task assignee */
  taskOpsAssignee: Maybe<User>;
  title: Maybe<Scalars['String']['output']>;
  user: User;
  viewAdvisorGroupClients: Maybe<Scalars['Boolean']['output']>;
  visitedActionCenterAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Ordered stat card keys for the workbench landing page (3-5 items) */
  workbenchStatCardKeys: Array<Scalars['String']['output']>;
  /** When true, stat cards show only the advisor's own households instead of the full practice */
  workbenchStatMyClientsOnly: Scalars['Boolean']['output'];
};


export type AdvisorAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  balanceRange?: InputMaybe<BalanceRangeInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  feeSchedules?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioMustBePresent?: InputMaybe<Scalars['Boolean']['input']>;
  providerNames?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<AccountSortValues>;
  strategyFilter?: InputMaybe<StrategyFilterInput>;
};


export type AdvisorAdvisorGroupMembersArgs = {
  includeNonAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  includeSelf?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdvisorAssignedClientsArgs = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ClientSortValues>;
};


export type AdvisorCalendarEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startsAfter: Scalars['ISO8601DateTime']['input'];
  startsBefore: Scalars['ISO8601DateTime']['input'];
};


export type AdvisorCalendlyLinkArgs = {
  meetingType?: InputMaybe<MeetingTypeName>;
};


export type AdvisorHouseholdsByStageArgs = {
  includeSharedHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  stages: Array<HouseholdStage>;
};


export type AdvisorProspectsArgs = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ClientSortValues>;
};

export type AdvisorActivity = {
  __typename?: 'AdvisorActivity';
  /** URL for the activity call to action */
  actionHref: Maybe<Scalars['String']['output']>;
  /** Label for the activity call to action */
  actionLabel: Maybe<Scalars['String']['output']>;
  /** User id for the actor who performed the activity */
  actorId: Maybe<Scalars['ID']['output']>;
  /** Whether the actor is a client user */
  actorIsClient: Scalars['Boolean']['output'];
  /** Display name for the actor who performed the activity */
  actorName: Maybe<Scalars['String']['output']>;
  /** Alert type when the activity source is an Alert */
  alertType: Maybe<Scalars['String']['output']>;
  /** Advisor Activities category */
  category: Scalars['String']['output'];
  /** Short display content, with any withheld counterparty resolved for this reader */
  content: Scalars['String']['output'];
  /** Destination family for advisor click-through */
  destination: Scalars['String']['output'];
  /** Stable event key from the v1 source mapping */
  eventKey: Scalars['String']['output'];
  /** Household associated with this activity, null when the subject is not a household */
  household: Maybe<Household>;
  /** Stable activity id namespaced by source */
  id: Scalars['ID']['output'];
  /** When this activity occurred */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Subject record id, paired with relationType */
  relationId: Maybe<Scalars['ID']['output']>;
  /** Subject family this activity is about, such as Household or CenterOfInfluenceRep */
  relationType: Maybe<Scalars['String']['output']>;
  /** Source family, such as alert or task_activity */
  source: Scalars['String']['output'];
  /** Underlying source record id */
  sourceId: Scalars['ID']['output'];
  /** Underlying source record type */
  sourceType: Scalars['String']['output'];
  /** Name of the related task when this activity links to a task */
  taskName: Maybe<Scalars['String']['output']>;
  /** Visibility scope applied to this activity row */
  visibilityScope: Scalars['String']['output'];
};

/** The connection type for AdvisorActivity. */
export type AdvisorActivityConnection = {
  __typename?: 'AdvisorActivityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AdvisorActivityEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<AdvisorActivity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

export type AdvisorActivityDailyCount = {
  __typename?: 'AdvisorActivityDailyCount';
  /** Number of activities that occurred on this calendar day. */
  count: Scalars['Int']['output'];
  /**
   * Calendar day the activities occurred on, expressed in the advisor's local
   * timezone (see the resolver's `timeZone` argument). Not UTC.
   */
  date: Scalars['ISO8601Date']['output'];
};

/** An edge in a connection. */
export type AdvisorActivityEdge = {
  __typename?: 'AdvisorActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AdvisorActivity>;
};

/** A calendar event on the advisor's calendar, with its household and openable canvas doc id. */
export type AdvisorCalendarEvent = {
  __typename?: 'AdvisorCalendarEvent';
  /** All participants in the event. */
  calendarEventParticipants: Array<CalendarEventParticipant>;
  /**
   * Id of the requester's canvas document for this event: the meeting_recap doc
   * once the meeting has one, otherwise the meeting_prep doc, or null. At most one
   * of each per event; status is not considered.
   */
  canvasDocumentId: Maybe<Scalars['ID']['output']>;
  /**
   * Type of the document `canvasDocumentId` points at, so callers can label a
   * recap CTA differently from a prep one. Null whenever `canvasDocumentId` is null.
   */
  canvasDocumentType: Maybe<CanvasDocumentType>;
  /** The description of the event. */
  description: Maybe<Scalars['String']['output']>;
  /** Event end time with timezone. */
  endsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The household linked to this event, or null. */
  household: Maybe<Household>;
  /** The Savvy ID of the calendar event. */
  id: Scalars['ID']['output'];
  /** The location of the event. */
  location: Maybe<Scalars['String']['output']>;
  /** Video conference or meeting link. */
  meetingLink: Maybe<Scalars['String']['output']>;
  /**
   * The requester's AI-generated meeting prep document for this event (recap +
   * agenda), or null if no prep has been generated. Independent of any recap doc.
   */
  meetingPrep: Maybe<MeetingPrep>;
  /** Event start time with timezone. */
  startsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title/summary of the event. */
  summary: Maybe<Scalars['String']['output']>;
};

/** A client user with associated profile, household, and address data for admin queries */
export type AdvisorClient = {
  __typename?: 'AdvisorClient';
  /** User addresses */
  addresses: Maybe<Array<Address>>;
  /** Client profile data with masked SSN */
  clientProfile: Maybe<Client>;
  /** User creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** User first name */
  firstName: Scalars['String']['output'];
  /** User full name */
  fullName: Scalars['String']['output'];
  /** Household data */
  household: Maybe<Household>;
  /** User ID */
  id: Scalars['ID']['output'];
  /** User last name */
  lastName: Scalars['String']['output'];
  /** User middle name */
  middleName: Maybe<Scalars['String']['output']>;
  /** User phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** User preferred name */
  preferredName: Maybe<Scalars['String']['output']>;
  /** ID of the associated profile */
  profileId: Maybe<Scalars['ID']['output']>;
  /** User profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
  /** Type of user profile */
  profileType: Scalars['String']['output'];
  /** User role */
  role: Scalars['String']['output'];
  /** User status */
  status: Scalars['String']['output'];
  /** User last update timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input type for address data for bulk update */
export type AdvisorClientAddressInput = {
  /** Address line 1 */
  addressLine1: Scalars['String']['input'];
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3 */
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country code */
  countryCode: Scalars['String']['input'];
  /** Address ID. If the value is null, an address will be created */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Address type */
  typeOf: Scalars['String']['input'];
};

/** Input type for advisor client data for bulk update */
export type AdvisorClientInput = {
  /** Client addresses to update */
  addresses?: InputMaybe<Array<AdvisorClientAddressInput>>;
  /** Client profile data to update */
  clientProfile: AdvisorClientProfileInput;
  /** User first name */
  firstName: Scalars['String']['input'];
  /** Client user ID which is going to be updated */
  id: Scalars['ID']['input'];
  /** User last name */
  lastName: Scalars['String']['input'];
  /** User middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** User phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** User preferred name */
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for client profile data for bulk update */
export type AdvisorClientProfileInput = {
  /** Client date of birth */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Client employer name */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Client employment status */
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Client profile ID */
  id: Scalars['ID']['input'];
  /** Client job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client SSN */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type AdvisorDirectedOnboardingSource =
  /** Off — via the flag default (fallthrough), not targeted */
  | 'DEFAULT_OFF'
  /** On — via the flag default (fallthrough), not targeted */
  | 'DEFAULT_ON'
  /** Off — individually targeted to the false variation */
  | 'EXPLICIT_OFF'
  /** On — individually targeted to the true variation */
  | 'EXPLICIT_ON'
  /** Off — the flag is turned off globally */
  | 'FLAG_OFF'
  /** Off — via a targeting rule, not individually targeted */
  | 'RULE_OFF'
  /** On — via a targeting rule, not individually targeted */
  | 'RULE_ON'
  /** Status could not be evaluated (LD error / client not ready) */
  | 'UNAVAILABLE'
  /** Unrecognized evaluation reason (e.g. a prerequisite failure this flag should not have) */
  | 'UNEXPECTED';

export type AdvisorDirectedOnboardingStatus = {
  __typename?: 'AdvisorDirectedOnboardingStatus';
  /**
   * Whether the `advisor-directed-onboarding` LD flag evaluates ON for this
   * advisor. Scope: FE onboarding task-creation + Fee Schedule surfaces only — NOT
   * the backend cockpit / staged-book gate, which is the separate
   * `flag-advisor-onboarding` flag.
   */
  effectiveValue: Scalars['Boolean']['output'];
  /** Why `advisor-directed-onboarding` resolved that way (target vs rule vs fallthrough vs off). */
  source: AdvisorDirectedOnboardingSource;
};

/** A single advisor in the firm-wide directory. */
export type AdvisorDirectoryEntry = {
  __typename?: 'AdvisorDirectoryEntry';
  /** Advisor bio. */
  bio: Maybe<Scalars['String']['output']>;
  /** Scheduling link for the contact row. */
  calendlyLink: Maybe<Scalars['String']['output']>;
  /** Join date; powers the recently-joined lens. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Client-facing DBA email; nil falls back to login email. */
  dbaEmail: Maybe<Scalars['String']['output']>;
  /** The directory entry id (the advisor user id lives on `user`). */
  id: Scalars['ID']['output'];
  /** Directory-facing profile fields. */
  profile: DirectoryProfile;
  /** Team affiliation; null for solo advisors. */
  team: Maybe<DirectoryTeam>;
  /** Advisor title. */
  title: Maybe<Scalars['String']['output']>;
  /** Directory-safe user fields. */
  user: DirectoryUser;
};

/** The connection type for AdvisorDirectoryEntry. */
export type AdvisorDirectoryEntryConnection = {
  __typename?: 'AdvisorDirectoryEntryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AdvisorDirectoryEntryEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<AdvisorDirectoryEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdvisorDirectoryEntryEdge = {
  __typename?: 'AdvisorDirectoryEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AdvisorDirectoryEntry>;
};

/** Sort order for the advisor directory roster. */
export type AdvisorDirectorySortEnum =
  /** By first name, then last name (default). */
  | 'ALPHABETICAL'
  /** Longest tenure first (earliest join date). */
  | 'TENURE_LONGEST_FIRST'
  /** Shortest tenure first (most recent join date). */
  | 'TENURE_SHORTEST_FIRST';

export type AdvisorGroup = {
  __typename?: 'AdvisorGroup';
  advisors: Array<Advisor>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When true, ARR is hidden from support-staff team members (assistants and CSAs) */
  hideRevenueFromSupportRoles: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  members: Array<Advisor>;
  name: Scalars['String']['output'];
  organization: Maybe<Organization>;
  representationType: AdvisorGroupRepresentation;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AdvisorGroupRepresentation =
  /** group */
  | 'group'
  /** individual */
  | 'individual';

export type AdvisorGroupSettingsInput = {
  hideRevenueFromSupportRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An advisor's captured identity profile (voice, per-client tonal override, etc.). */
export type AdvisorIdentityProfile = {
  __typename?: 'AdvisorIdentityProfile';
  /** When extraction last completed */
  extractedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** pending | extracting | review | active | failed | abandoned */
  extractionStatus: Scalars['String']['output'];
  /** Profile ID */
  id: Scalars['ID']['output'];
  /**
   * True when this is the worker-written empty-scan fallback an advisor has never
   * committed (active, source=game, empty traits). The frontend routes this state
   * to a re-scan card / placeholder capture flow instead of treating it as a
   * committed voice.
   */
  isEmptyFallbackPlaceholder: Scalars['Boolean']['output'];
  /** Row type: voice or client_tonal_override */
  kind: Scalars['String']['output'];
  /** Structured voice payload — what SAI drafting consumes */
  payload: VoiceProfilePayload;
  /** Template version of the stored voice_prompt_fragment */
  payloadVersion: Scalars['Int']['output'];
  /** sha256-prefix hash for client_tonal_override; null for voice */
  scopeKey: Maybe<Scalars['String']['output']>;
  /** scan | game | game_plus_scan | seeded */
  source: Scalars['String']['output'];
  /** Last updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Outcome of a non-destructive book re-upload merge, bucketed per staged household. */
export type AdvisorOnboardingBookMergeSummary = {
  __typename?: 'AdvisorOnboardingBookMergeSummary';
  /** Households created by this upload. */
  created: Array<AdvisorOnboardingStagedHousehold>;
  /** Number of households created by this upload. */
  createdCount: Scalars['Int']['output'];
  /** Households from a prior upload not present in this file; preserved, not deleted. */
  preservedButAbsent: Array<AdvisorOnboardingStagedHousehold>;
  /** Number of prior households absent from this upload. */
  preservedButAbsentCount: Scalars['Int']['output'];
  /** Matched households already promoted (in-flight); left untouched. Read `status` for the current stage. */
  skippedInFlight: Array<AdvisorOnboardingStagedHousehold>;
  /** Number of in-flight households left untouched. */
  skippedInFlightCount: Scalars['Int']['output'];
  /** Matched households with no downstream action yet, updated with the new spreadsheet data. */
  updated: Array<AdvisorOnboardingStagedHousehold>;
  /** Number of households updated by this upload. */
  updatedCount: Scalars['Int']['output'];
};

/** Whether the advisor joined Savvy as a new advisor or was already here with a book */
export type AdvisorOnboardingCohort =
  /** existing_advisor */
  | 'existing_advisor'
  /** new_advisor */
  | 'new_advisor';

/** An advisor onboarding enrollment (process root) — the restorable handle backing the intake wizard. */
export type AdvisorOnboardingEnrollment = {
  __typename?: 'AdvisorOnboardingEnrollment';
  /** Wizard resume position. */
  currentStep: Scalars['String']['output'];
  /** Internal enrollment id. */
  id: Scalars['ID']['output'];
  /** Parsed households from the transition spreadsheet. */
  stagedHouseholds: Array<AdvisorOnboardingStagedHousehold>;
  /** Lifecycle state (enrolled / completed). */
  state: Scalars['String']['output'];
  /** Immutable public handle for deeplinks, logs, and wizard resume. */
  uuid: Scalars['ID']['output'];
};

/** Per-advisor onboarding email branding shown on the Personalize screen and reused by the ECI send. */
export type AdvisorOnboardingPersonalization = {
  __typename?: 'AdvisorOnboardingPersonalization';
  /** URL of the uploaded firm logo */
  firmLogoUrl: Maybe<Scalars['String']['output']>;
  /** Advisor firm name used for onboarding email branding */
  firmName: Maybe<Scalars['String']['output']>;
  /** Personalization record id */
  id: Scalars['ID']['output'];
  /** Custom welcome message shown to onboarding clients */
  welcomeMessage: Maybe<Scalars['String']['output']>;
};

/** A staged account parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedAccount = {
  __typename?: 'AdvisorOnboardingStagedAccount';
  /** Account owner/label from the spreadsheet. */
  accountName: Maybe<Scalars['String']['output']>;
  /** Destination-registration stakeholders */
  accountStakeholders: Array<EciAccountOnboardingStakeholder>;
  /** Account type from the spreadsheet. */
  accountType: Maybe<Scalars['String']['output']>;
  /** Inherited IRA beneficiary shape */
  bdaBeneficiaryKind: Maybe<EciBdaBeneficiaryKind>;
  /** Beneficiaries */
  beneficiaries: Array<EciAccountBeneficiary>;
  /**
   * Custodian the account is being transferred FROM, as imported from the
   * spreadsheet. Not the destination — see `destination`.
   */
  custodian: Maybe<Scalars['String']['output']>;
  /** Inherited IRA original-depositor information */
  decedentInformation: Maybe<EciAccountDecedentInformation>;
  /** Custodian this account is headed TO. fidelity_nfs (the default) is the ECI pipe. */
  destination: EciDestinationCustodian;
  /** SIMPLE IRA employer information */
  employerInformation: Maybe<EciAccountEmployerInformation>;
  /** Per-field validation errors keyed by camelCase field name. */
  errors: Scalars['JSON']['output'];
  /** Estimated balance being transferred for this account. */
  estimatedBalance: Maybe<Scalars['BigDecimal']['output']>;
  /** True when the imported account type is an individual transfer-on-death designation. */
  hasTransferOnDeathDesignation: Scalars['Boolean']['output'];
  /** Staging row identifier. */
  id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this account. */
  importErrors: Scalars['JSON']['output'];
  /** Joint owners */
  jointOwners: Array<EciAccountJointOwner>;
  /** Account number from the spreadsheet. */
  number: Maybe<Scalars['String']['output']>;
  /** Recurring transfers (structured records for subform prefill) */
  recurringTransfers: Array<EciAccountRecurringTransfer>;
  /** ECI registration type serialize value derived from the imported label; null when unrecognized. */
  registrationType: Maybe<Scalars['String']['output']>;
  /** Standing instructions (full records for subform prefill) */
  standingInstructions: Array<EciAccountStandingInstruction>;
  /** Transfer method for ECI onboarding. */
  transferMethod: EciAccountTransferType;
  /** Legal-entity information, if required by the registration */
  trustInformation: Maybe<EciAccountTrustInformation>;
  /** ECI subform group derived from the imported account-type label; null when unrecognized. */
  typeGroup: Maybe<EciAccountTypeGroup>;
};

/** A staged client parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedClient = {
  __typename?: 'AdvisorOnboardingStagedClient';
  /** Client date of birth. */
  dob: Maybe<Scalars['ISO8601Date']['output']>;
  /** Client email address. */
  email: Maybe<Scalars['String']['output']>;
  /** Per-field validation errors keyed by camelCase field name. */
  errors: Scalars['JSON']['output'];
  /** Client first name. */
  firstName: Maybe<Scalars['String']['output']>;
  /** Staging row identifier. */
  id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this client. */
  importErrors: Scalars['JSON']['output'];
  /** Client last name. */
  lastName: Maybe<Scalars['String']['output']>;
  /** Client phone number. */
  phone: Maybe<Scalars['String']['output']>;
  /** Client role within the household (primary or co). */
  role: Scalars['String']['output'];
};

/** A staged household parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedHousehold = {
  __typename?: 'AdvisorOnboardingStagedHousehold';
  /** Why the household is blocked, when it is. */
  blockedReason: Maybe<Scalars['String']['output']>;
  /** Household label derived from the primary client, household name, or external key. */
  displayName: Scalars['String']['output'];
  /**
   * True while the advisor can still edit this household. False once it has been
   * sent to the client — upload-review edits are read-only from then on.
   */
  draft: Scalars['Boolean']['output'];
  /** Parent enrollment uuid — needed to re-promote after contact repairs. */
  enrollmentUuid: Scalars['ID']['output'];
  /** Per-field validation errors keyed by camelCase field name. */
  errors: Scalars['JSON']['output'];
  /** Estimated assets under management. */
  estAum: Maybe<Scalars['BigDecimal']['output']>;
  /** Stable key derived from the spreadsheet household name. */
  externalKey: Maybe<Scalars['String']['output']>;
  /** Canonical household id after promotion. Null pre-promotion. */
  householdId: Maybe<Scalars['ID']['output']>;
  /** Household name from the transition spreadsheet. */
  householdName: Maybe<Scalars['String']['output']>;
  /** Canonical household public id (uuid) after promotion. Null pre-promotion. */
  householdUuid: Maybe<Scalars['ID']['output']>;
  /** Staging row identifier. */
  id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this household. */
  importErrors: Scalars['JSON']['output'];
  /** All accounts linked to this household request, including confirmed. For post-confirm detail views. */
  onboardingAccounts: Array<AdvisorOnboardingStagedAccount>;
  /** Accounts staged for this household. */
  stagedAccounts: Array<AdvisorOnboardingStagedAccount>;
  /** Clients staged for this household. */
  stagedClients: Array<AdvisorOnboardingStagedClient>;
  /** Lifecycle status in the cockpit. */
  status: Scalars['String']['output'];
  /** Immutable public handle for confirm/send deeplinks. */
  uuid: Scalars['ID']['output'];
};

/** The advisor's Ops contact (CSA) shown on the onboarding welcome screen. */
export type AdvisorOpsContact = {
  __typename?: 'AdvisorOpsContact';
  /** Ops contact email */
  email: Scalars['String']['output'];
  /** Ops contact first name */
  firstName: Scalars['String']['output'];
  /** Ops contact full name */
  name: Scalars['String']['output'];
};

/** The advisor's bill style */
export type AdvisorProfileBillStyle =
  /** advanced */
  | 'advanced'
  /** arrear */
  | 'arrear';

/** The advisor's billing frequency */
export type AdvisorProfileBillingFrequency =
  /** monthly */
  | 'monthly'
  /** quarterly */
  | 'quarterly';

/**
 * A report schedule visible to the current advisor across every template they can
 * see, with cross-household reach and latest execution status.
 */
export type AdvisorReportSchedule = {
  __typename?: 'AdvisorReportSchedule';
  /** Whether the schedule is currently enabled */
  active: Scalars['Boolean']['output'];
  /** Whether PDFs are uploaded to Box */
  deliverToBox: Scalars['Boolean']['output'];
  /** Whether reports are published to the client portal */
  deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  deliveryMonth: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  frequency: Scalars['String']['output'];
  /** Number of households this schedule currently targets */
  householdCount: Scalars['Int']['output'];
  /** Schedule id */
  id: Scalars['ID']['output'];
  /** When the most recent execution was created (enqueued), not necessarily when it finished */
  lastExecutionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Error message from the most recent execution, if failed */
  lastExecutionError: Maybe<Scalars['String']['output']>;
  /**
   * Status of the most recent execution, across every household this schedule has
   * ever run for -- not limited to its current target set
   */
  lastExecutionStatus: Maybe<Scalars['String']['output']>;
  /** When the schedule last fired */
  lastRunAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  nextDueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The saved template this schedule automates */
  savedReportTemplateId: Scalars['ID']['output'];
  /** Saved report template name */
  templateName: Scalars['String']['output'];
};

export type AdvisorSettingsInput = {
  /** The advisor's ADV Part 2B document link, set by onboarding automation when the 2B is finalized. */
  adv2bLink?: InputMaybe<Scalars['String']['input']>;
  alertsOnForAccountOpenedOrFunded?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForAllocationVariance?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForAutoAdvanceBlockedMissingAum?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForBirthdays?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForCashVariance?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientLogins?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientPortalMessageReceived?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientSubmittedRiskQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientUploadedRequestedFile?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForContributionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForDocusignOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForHubspotLeadCreated?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForLeadEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForNewLeadCampaignStarted?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOutstandingClientTask?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOverdueAdvisorTask?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForQuarterlyReportFailed?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForQuarterlyReportGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForRmds?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarUpcomingMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForStagnantProspect?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForSubtaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForSubtaskDueApproaching?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForTransferIn?: InputMaybe<Scalars['Boolean']['input']>;
  birthdayNotificationDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  birthdayNotificationsForClients?: InputMaybe<Scalars['Boolean']['input']>;
  birthdayNotificationsForProspects?: InputMaybe<Scalars['Boolean']['input']>;
  cashAllocationThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  docusignOutstandingThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  minimumAccountValue?: InputMaybe<Scalars['Int']['input']>;
  newLeadCampaignStartedChannelPreference?: InputMaybe<AlertChannel>;
  preferredWeeksBetweenClientEngagement?: InputMaybe<Scalars['Int']['input']>;
  targetAllocationVarianceThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  viewAdvisorGroupClients?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered array of 3-5 stat card keys for the workbench landing page */
  workbenchStatCardKeys?: InputMaybe<Array<WorkbenchStatKey>>;
  /** When true, stat cards show only the advisor's own households instead of the full practice */
  workbenchStatMyClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A tenure cohort for the advisor directory, derived from the advisor join date. */
export type AdvisorTenureBucketEnum =
  /** Joined within the last 3 months. */
  | 'ONBOARDING'
  /** Joined more than 12 months ago. */
  | 'OVER_TWELVE_MONTHS'
  /** Joined 6 to 12 months ago. */
  | 'SIX_TO_TWELVE_MONTHS'
  /** Joined 3 to 6 months ago. */
  | 'THREE_TO_SIX_MONTHS';

/**
 * Advisor-tier level of a team member. ASSISTANT/ADVISOR/ADMIN, where ADMIN is an
 * advisor with firm administrative privileges
 * (advisor_profile.can_edit_organization).
 */
export type AdvisorTierLevel =
  /** Firm admin (role: advisor with can_edit_organization) */
  | 'ADMIN'
  /** Advisor (role: advisor, no org-edit) */
  | 'ADVISOR'
  /** Assistant (role: assistant) */
  | 'ASSISTANT';

export type Alert = {
  __typename?: 'Alert';
  actorKind: AlertActorKind;
  actorName: Maybe<Scalars['String']['output']>;
  actorProfilePicUrl: Maybe<Scalars['String']['output']>;
  actorUserId: Maybe<Scalars['ID']['output']>;
  actorVerb: Maybe<Scalars['String']['output']>;
  /** TaskActivity id of the comment this alert is about, for deep-linking. */
  commentId: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  /** Dollar amount of the contribution that triggered this alert */
  contributionAmount: Maybe<Scalars['Float']['output']>;
  /** invest_cash / create_enrollment / no_action, per ContributionAlerts::CreateFromRows */
  contributionClassification: Maybe<Scalars['String']['output']>;
  /** Full names of the other advisors this contribution alert was also sent to (excludes the viewer). */
  contributionOtherRecipientNames: Array<Scalars['String']['output']>;
  /** When another advisor already handled this contribution */
  contributionResolvedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Advisor who handled this contribution, if any */
  contributionResolvedByName: Maybe<Scalars['String']['output']>;
  /** Task created by whichever advisor handled this contribution */
  contributionResolvedTaskId: Maybe<Scalars['ID']['output']>;
  /** salesforce_task_id of the resolved task, for click-through */
  contributionResolvedTaskSalesforceId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Number of alerts this node represents; 1 unless collapsed by group_bulk. */
  groupCount: Scalars['Int']['output'];
  /** The individual alerts a collapsed node stands in for; empty on a normal alert. */
  groupMembers: Array<Alert>;
  /** Summary headline for a collapsed bulk node (e.g. "8 accounts drifted past your cash threshold"); null on a normal alert. */
  groupSummary: Maybe<Scalars['String']['output']>;
  /** Null for recipient-only alerts that resolve no household, such as an unattached transcript. */
  household: Maybe<Household>;
  id: Scalars['ID']['output'];
  /** Whether the recipient has archived, snoozed, or opened this alert. */
  isAcknowledged: Scalars['Boolean']['output'];
  /** User the alert is addressed to (its "you"); may differ from the viewer. */
  recipientId: Scalars['ID']['output'];
  /** Full name of the alert's recipient. */
  recipientName: Maybe<Scalars['String']['output']>;
  relatedEntity: AlertEntityItem;
  /**
   * When the alert was archived (status set to removed); null while
   * active/backlogged or for legacy rows removed before this was tracked.
   */
  removedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  shortName: AlertShortName;
  snoozedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: AlertStatusName;
  subject: Maybe<Scalars['String']['output']>;
  surfaceAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Calendar event of the alert's target Canvas document (meeting prep/recap), for
   * deep-linking to the meeting. Null unless the viewer is the recipient and the
   * doc is calendar-anchored.
   */
  targetCalendarEventId: Maybe<Scalars['ID']['output']>;
  /** Recipient-authorized Canvas document target. */
  targetCanvasDocumentId: Maybe<Scalars['ID']['output']>;
  typeOf: AlertTypeName;
};

export type AlertActorKind =
  /** advisor */
  | 'advisor'
  /** client */
  | 'client'
  /** savvy_cs */
  | 'savvy_cs'
  /** system */
  | 'system';

export type AlertArchived = {
  /** Number of inbox alerts archived in one action (a collapsed bulk card fans out over several). */
  count: Scalars['Int']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type AlertChannel =
  | 'email'
  | 'off'
  | 'sms';

/** The connection type for Alert. */
export type AlertConnection = {
  __typename?: 'AlertConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AlertEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Alert>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

export type AlertCountsBy = {
  __typename?: 'AlertCountsBy';
  /** Counts grouped by Action Center filter-chip keys. */
  byType: Array<AlertTypeCount>;
  /** Total active alerts after primary-advisor filtering. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertEdge = {
  __typename?: 'AlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Alert>;
};

/**
 * Households, Users, Tasks, Sub-tasks, Accounts, professional contacts, companies,
 * and transcripts classified together as potential entities that can be related to
 * a co-pilot alert.
 */
export type AlertEntityItem = Account | CenterOfInfluenceRep | Company | DialpadCallTranscript | Household | StateFiling | Subtask | Task | TaxEnrollment | User | ZoomMeetingTranscript;

export type AlertSettings = {
  __typename?: 'AlertSettings';
  alertsOnForAccountOpenedOrFunded: Scalars['Boolean']['output'];
  alertsOnForAllocationVariance: Scalars['Boolean']['output'];
  alertsOnForAutoAdvanceBlockedMissingAum: Scalars['Boolean']['output'];
  alertsOnForBirthdays: Scalars['Boolean']['output'];
  alertsOnForCashVariance: Scalars['Boolean']['output'];
  alertsOnForClientEngagement: Scalars['Boolean']['output'];
  alertsOnForClientLogins: Scalars['Boolean']['output'];
  alertsOnForClientPortalMessageReceived: Scalars['Boolean']['output'];
  alertsOnForClientSubmittedRiskQuestionnaire: Scalars['Boolean']['output'];
  alertsOnForClientUploadedRequestedFile: Scalars['Boolean']['output'];
  alertsOnForContributionReceived: Scalars['Boolean']['output'];
  alertsOnForDocusignOutstanding: Scalars['Boolean']['output'];
  alertsOnForHubspotLeadCreated: Scalars['Boolean']['output'];
  alertsOnForLeadEngagement: Scalars['Boolean']['output'];
  alertsOnForNewLeadCampaignStarted: Scalars['Boolean']['output'];
  alertsOnForOnboardingComplete: Scalars['Boolean']['output'];
  alertsOnForOutstandingClientTask: Scalars['Boolean']['output'];
  alertsOnForOverdueAdvisorTask: Scalars['Boolean']['output'];
  alertsOnForQuarterlyReportFailed: Scalars['Boolean']['output'];
  alertsOnForQuarterlyReportGenerated: Scalars['Boolean']['output'];
  alertsOnForRmds: Scalars['Boolean']['output'];
  alertsOnForServiceCalendarDueDate: Scalars['Boolean']['output'];
  alertsOnForServiceCalendarSetup: Scalars['Boolean']['output'];
  alertsOnForServiceCalendarTaskAssigned: Scalars['Boolean']['output'];
  alertsOnForServiceCalendarUpcomingMeeting: Scalars['Boolean']['output'];
  alertsOnForStagnantProspect: Scalars['Boolean']['output'];
  alertsOnForSubtaskAssigned: Scalars['Boolean']['output'];
  alertsOnForSubtaskDueApproaching: Scalars['Boolean']['output'];
  alertsOnForTaxStatus: Scalars['Boolean']['output'];
  alertsOnForTransferIn: Scalars['Boolean']['output'];
  birthdayNotificationDaysInAdvance: Scalars['Int']['output'];
  birthdayNotificationsForClients: Scalars['Boolean']['output'];
  birthdayNotificationsForProspects: Scalars['Boolean']['output'];
  /** Alert when cash allocation exceeds this percentage */
  cashAllocationThresholdPercentage: Scalars['Float']['output'];
  /** Whether to include money market holdings in cash variance calculations */
  cashVarianceIncludeMoneyMarket: Scalars['Boolean']['output'];
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  docusignOutstandingThresholdDays: Scalars['Int']['output'];
  /** Master toggle for the legacy advisor-notification emails the advisor receives */
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  minimumAccountValue: Scalars['Int']['output'];
  newLeadCampaignStartedChannelPreference: AlertChannel;
  /**
   * When true, onboarding SMS sends from the advisor's Dialpad number instead of
   * the CSA's. Falls back to the CSA when the advisor has no Dialpad number provisioned.
   */
  onboardingSmsFromAdvisor: Scalars['Boolean']['output'];
  /** Custom sender display name used in onboarding SMS. When blank, falls back to the sender's first name. */
  onboardingSmsSenderName: Maybe<Scalars['String']['output']>;
  preferredWeeksBetweenClientEngagement: Scalars['Int']['output'];
  /** Master toggle for the legacy Slack notifications the advisor receives */
  slackNotificationsEnabled: Scalars['Boolean']['output'];
  targetAllocationVarianceThresholdPercentage: Scalars['Int']['output'];
  /** Days before the due date to send advisor task notifications (e.g. [0, 3] = day of and 3 days before) */
  taskNotificationDaysInAdvance: Array<Scalars['Int']['output']>;
  /** Alert when total daily transfers exceed this percentage of account value */
  transferInThresholdPercentage: Scalars['Float']['output'];
  /** Days before a service-calendar meeting to send the advisor reminder (0 = day of) */
  upcomingMeetingReminderDaysInAdvance: Scalars['Int']['output'];
};

export type AlertSettingsInput = {
  alertsOnForAccountOpenedOrFunded?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForAllocationVariance?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForAutoAdvanceBlockedMissingAum?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForBirthdays?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForCashVariance?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientLogins?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientPortalMessageReceived?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientSubmittedRiskQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForClientUploadedRequestedFile?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForContributionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForDocusignOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForHubspotLeadCreated?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForLeadEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForNewLeadCampaignStarted?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOutstandingClientTask?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForOverdueAdvisorTask?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForQuarterlyReportFailed?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForQuarterlyReportGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForRmds?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForServiceCalendarUpcomingMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForStagnantProspect?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForSubtaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForSubtaskDueApproaching?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  alertsOnForTransferIn?: InputMaybe<Scalars['Boolean']['input']>;
  birthdayNotificationDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  birthdayNotificationsForClients?: InputMaybe<Scalars['Boolean']['input']>;
  birthdayNotificationsForProspects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alert when cash allocation exceeds this percentage */
  cashAllocationThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Whether to include money market holdings in cash variance calculations */
  cashVarianceIncludeMoneyMarket?: InputMaybe<Scalars['Boolean']['input']>;
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  docusignOutstandingThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  /** Master toggle for the legacy advisor-notification emails the advisor receives */
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAccountValue?: InputMaybe<Scalars['Int']['input']>;
  newLeadCampaignStartedChannelPreference?: InputMaybe<AlertChannel>;
  /** When true, onboarding SMS sends from the advisor's Dialpad number instead of the CSA's. */
  onboardingSmsFromAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom sender display name used in onboarding SMS. When blank, falls back to the sender's first name. */
  onboardingSmsSenderName?: InputMaybe<Scalars['String']['input']>;
  preferredWeeksBetweenClientEngagement?: InputMaybe<Scalars['Int']['input']>;
  /** Master toggle for the legacy Slack notifications the advisor receives */
  slackNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  targetAllocationVarianceThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Days before the due date to send advisor task notifications */
  taskNotificationDaysInAdvance?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Alert when total daily transfers exceed this percentage of account value */
  transferInThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Days before a service-calendar meeting to send the advisor reminder */
  upcomingMeetingReminderDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertShortName =
  | 'New'
  | 'Todo';

export type AlertSnoozed = {
  /** Number of inbox alerts snoozed in one action (a collapsed bulk card fans out over several). */
  count: Scalars['Int']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** When the snoozed alert(s) will resurface, for measuring how far out advisors defer. */
  surfaceAt?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type AlertStatusName =
  | 'active'
  | 'backlogged'
  | 'deferred'
  | 'removed';

export type AlertTypeCount = {
  __typename?: 'AlertTypeCount';
  /** Number of active alerts in this chip group. */
  count: Scalars['Int']['output'];
  /** Filter-chip key (e.g. EngageWithLead, birthdays). */
  key: Scalars['String']['output'];
};

export type AlertTypeName =
  /** account_linked_or_aggregation_added */
  | 'account_linked_or_aggregation_added'
  /** account_opened_or_funded */
  | 'account_opened_or_funded'
  /** account_setup_confirmation_sent */
  | 'account_setup_confirmation_sent'
  /** advisor_requirements_needed */
  | 'advisor_requirements_needed'
  /** allocation_variance */
  | 'allocation_variance'
  /** auto_advance_blocked_missing_aum */
  | 'auto_advance_blocked_missing_aum'
  /** beneficiary_or_ownership_change */
  | 'beneficiary_or_ownership_change'
  /** birthdays */
  | 'birthdays'
  /** call_step_required */
  | 'call_step_required'
  /** cash_variance */
  | 'cash_variance'
  /** center_of_influence_rep_comment_mention */
  | 'center_of_influence_rep_comment_mention'
  /** client_completed_task */
  | 'client_completed_task'
  /** client_completed_tax_enrollment */
  | 'client_completed_tax_enrollment'
  /** client_engagement */
  | 'client_engagement'
  /** client_logins */
  | 'client_logins'
  /** client_portal_message_received */
  | 'client_portal_message_received'
  /** client_submitted_risk_questionnaire */
  | 'client_submitted_risk_questionnaire'
  /** client_uploaded_requested_file */
  | 'client_uploaded_requested_file'
  /** company_comment_mention */
  | 'company_comment_mention'
  /** contribution_received */
  | 'contribution_received'
  /** docusign_outstanding */
  | 'docusign_outstanding'
  /** email_from_lead */
  | 'email_from_lead'
  /** federal_return_accepted */
  | 'federal_return_accepted'
  /** federal_return_received */
  | 'federal_return_received'
  /** federal_return_rejected */
  | 'federal_return_rejected'
  /** file_upload_request_sent */
  | 'file_upload_request_sent'
  /** household_comment_mention */
  | 'household_comment_mention'
  /** hubspot_lead_created */
  | 'hubspot_lead_created'
  /** inbound_missed_call */
  | 'inbound_missed_call'
  /** intake_invite_reminder_sent */
  | 'intake_invite_reminder_sent'
  /** intake_invite_sent */
  | 'intake_invite_sent'
  /** large_withdrawal_detected */
  | 'large_withdrawal_detected'
  /** meeting_booked_by_client */
  | 'meeting_booked_by_client'
  /** meeting_canceled_or_rescheduled_by_client */
  | 'meeting_canceled_or_rescheduled_by_client'
  /** meeting_prep_ready */
  | 'meeting_prep_ready'
  /** meeting_recap_ready */
  | 'meeting_recap_ready'
  /** meeting_transcript_needs_household */
  | 'meeting_transcript_needs_household'
  /** new_lead_campaign_started */
  | 'new_lead_campaign_started'
  /** onboarding_complete */
  | 'onboarding_complete'
  /** onboarding_invite_reminder_sent */
  | 'onboarding_invite_reminder_sent'
  /** onboarding_invite_sent */
  | 'onboarding_invite_sent'
  /** outbound_missed_call_reminder */
  | 'outbound_missed_call_reminder'
  /** outstanding_client_task */
  | 'outstanding_client_task'
  /** overdue_advisor_task */
  | 'overdue_advisor_task'
  /** pre_review_check_in_sent */
  | 'pre_review_check_in_sent'
  /** quarterly_report_failed */
  | 'quarterly_report_failed'
  /** quarterly_report_generated */
  | 'quarterly_report_generated'
  /** risk_questionnaire_sent */
  | 'risk_questionnaire_sent'
  /** rmds */
  | 'rmds'
  /** service_calendar_booking_reminder_sent */
  | 'service_calendar_booking_reminder_sent'
  /** service_calendar_due_date */
  | 'service_calendar_due_date'
  /** service_calendar_invite_sent */
  | 'service_calendar_invite_sent'
  /** service_calendar_setup */
  | 'service_calendar_setup'
  /** service_calendar_task_assigned */
  | 'service_calendar_task_assigned'
  /** service_calendar_upcoming_meeting */
  | 'service_calendar_upcoming_meeting'
  /** sms_from_lead */
  | 'sms_from_lead'
  /** stagnant_prospect */
  | 'stagnant_prospect'
  /** state_return_accepted */
  | 'state_return_accepted'
  /** state_return_received */
  | 'state_return_received'
  /** state_return_rejected */
  | 'state_return_rejected'
  /** subtask_assigned */
  | 'subtask_assigned'
  /** subtask_due_approaching */
  | 'subtask_due_approaching'
  /** task_comment_created */
  | 'task_comment_created'
  /** task_comment_mention */
  | 'task_comment_mention'
  /** task_created */
  | 'task_created'
  /** task_due_date_changed */
  | 'task_due_date_changed'
  /** task_reassigned */
  | 'task_reassigned'
  /** task_status_changed */
  | 'task_status_changed'
  /** tax_filing_late_or_missed_deadline */
  | 'tax_filing_late_or_missed_deadline'
  /** tax_filing_ready */
  | 'tax_filing_ready'
  /** tax_filing_ready_sent_to_client */
  | 'tax_filing_ready_sent_to_client'
  /** tax_filing_reminder_to_client */
  | 'tax_filing_reminder_to_client'
  /** transfer_in */
  | 'transfer_in';

/** A single (date, asset category) allocation sample for the Allocation Over Time chart. */
export type AllocationOverTimePoint = {
  __typename?: 'AllocationOverTimePoint';
  /** Top-level asset category (e.g. 'Equity', 'Fixed Income', 'Cash & Cash Equivalents', 'Alternatives'). */
  assetCategory: Scalars['String']['output'];
  /** Sample date. */
  date: Scalars['ISO8601Date']['output'];
  /** Market value of this asset category on this date, in USD. Null when unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Share of the portfolio held in this asset category on this date, as a fraction (0.0–1.0). Null when unavailable. */
  percent: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single asset-category or asset-class slice in a portfolio allocation pie. */
export type AllocationSlice = {
  __typename?: 'AllocationSlice';
  /** Slice display name (e.g. "Equity", "Cash & Cash Equivalents", "US Equity"). */
  name: Scalars['String']['output'];
  /** Slice's share of total portfolio market value, expressed as a fraction (0.0–1.0). */
  percent: Scalars['BigDecimal']['output'];
  /** Dollar value of the slice on the as-of date, in USD. */
  value: Scalars['BigDecimal']['output'];
};

export type AlternativeFund = {
  __typename?: 'AlternativeFund';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eligibleInvestorLevelStatus: Maybe<AlternativeFundInvestorStatusName>;
  id: Scalars['ID']['output'];
  investmentManager: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  lockup: Maybe<Scalars['String']['output']>;
  managementFee: Maybe<Scalars['String']['output']>;
  minimumInvestmentSize: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  performanceReturns: Maybe<Scalars['Float']['output']>;
  performanceReturnsType: Maybe<AlternativeFundPerformanceReturnsTypeName>;
  provider: Maybe<AlternativeFundProviderName>;
  status: Maybe<AlternativeFundStatusName>;
  typeOf: Maybe<AlternativeFundTypeName>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AlternativeFundInvestorStatusName =
  | 'accredited_investor'
  | 'non_accredited'
  | 'qualified_client'
  | 'qualified_purchaser'
  | 'sub_accredited';

export type AlternativeFundPerformanceReturnsTypeName =
  | '_1_year'
  | '_5_year'
  | 'target';

export type AlternativeFundProviderName =
  | 'cais'
  | 'equi'
  | 'gridline'
  | 'icapital';

export type AlternativeFundStatusName =
  | 'active'
  | 'closed';

export type AlternativeFundTypeName =
  | 'hedge_fund'
  | 'multi_asset'
  | 'private_credit'
  | 'private_equity'
  | 'real_asset'
  | 'venture_capital';

/** Input for alternative investments purchase task specific data */
export type AlternativeInvestmentsPurchase = {
  /** Whether to enroll in dividend reinvestment plan */
  enrollInDrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the fund */
  fundName: Scalars['String']['input'];
  /** The amount to invest */
  investmentAmount: Scalars['Float']['input'];
  /** Investment experience rows for the household */
  investmentExperienceRows: Array<InvestmentExperienceRowInput>;
  /** The investment objective (income_current_yield, appreciation, principal_protection, speculation) */
  investmentObjective: Scalars['String']['input'];
  /** The liquidity preference (very_important, important, somewhat_important, does_not_matter) */
  liquidity: Scalars['String']['input'];
  /** The risk profile (aggressive_speculative, balanced_neutral, conservative_risk_adverse) */
  riskProfile: Scalars['String']['input'];
  /** The source of wealth (employment, inheritance, investment_returns, sale_of_business, real_estate, other) */
  sourceOfWealth: Scalars['String']['input'];
  /** Description when source of wealth is other */
  sourceOfWealthOther?: InputMaybe<Scalars['String']['input']>;
  /** The investment time horizon in years */
  timeHorizon: Scalars['Int']['input'];
};

/** Alternative investments purchase request data associated with a task */
export type AlternativeInvestmentsPurchaseRequest = {
  __typename?: 'AlternativeInvestmentsPurchaseRequest';
  /** Whether enrolled in DRIP */
  enrollInDrip: Scalars['Boolean']['output'];
  /** The name of the fund */
  fundName: Scalars['String']['output'];
  /** The ID of the request */
  id: Scalars['ID']['output'];
  /** The investment amount */
  investmentAmount: Scalars['Float']['output'];
  /** The associated investment experience */
  investmentExperience: InvestmentExperience;
  /** The investment objective */
  investmentObjective: Scalars['String']['output'];
  /** The liquidity preference */
  liquidity: Scalars['String']['output'];
  /** The risk profile */
  riskProfile: Scalars['String']['output'];
  /** The source of wealth */
  sourceOfWealth: Scalars['String']['output'];
  /** Description when source of wealth is other */
  sourceOfWealthOther: Maybe<Scalars['String']['output']>;
  /** The time horizon in years */
  timeHorizon: Scalars['Int']['output'];
};

/** An announcement configuration */
export type AnnouncementConfig = {
  __typename?: 'AnnouncementConfig';
  /** The announcement name */
  announcementName: Scalars['String']['output'];
  /** The announcement config ID */
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of ApproveScheduledReportExecution */
export type ApproveScheduledReportExecutionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ReportScheduleExecution IDs to approve */
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveScheduledReportExecution. */
export type ApproveScheduledReportExecutionPayload = {
  __typename?: 'ApproveScheduledReportExecutionPayload';
  /** IDs that were approved and delivered */
  approvedIds: Array<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** One error message per failed id, in the same order as failed_ids */
  errors: Array<Scalars['String']['output']>;
  /** IDs that failed to deliver; remain pending_review */
  failedIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of ArchiveHousehold */
export type ArchiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to archive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveHousehold. */
export type ArchiveHouseholdPayload = {
  __typename?: 'ArchiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household stage was updated */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveServiceCatalogItemGroup */
export type ArchiveServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveServiceCatalogItemGroup. */
export type ArchiveServiceCatalogItemGroupPayload = {
  __typename?: 'ArchiveServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of ArchiveServiceCatalogItem */
export type ArchiveServiceCatalogItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Item ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveServiceCatalogItem. */
export type ArchiveServiceCatalogItemPayload = {
  __typename?: 'ArchiveServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item */
  serviceCatalogItem: Maybe<ServiceCatalogItem>;
};

/** Asset held by the user. */
export type Asset = {
  __typename?: 'Asset';
  /** The asset class of the asset */
  assetClass: AssetClassName;
  /** The asset subclass of the asset */
  assetSubclass: Maybe<AssetSubclassName>;
  /** Company name for company equity type assets. */
  companyEquityCompanyName: Maybe<Scalars['String']['output']>;
  /** Company stock ticker for company equity type assets. */
  companyEquityCompanyTicker: Maybe<Scalars['String']['output']>;
  /** Company stock price for company equity type assets. */
  companyEquityCurrentPrice: Maybe<Scalars['BigDecimal']['output']>;
  /** Exercise price for company equity type assets. */
  companyEquityExercisePrice: Maybe<Scalars['BigDecimal']['output']>;
  /** Grant type for company equity type assets. */
  companyEquityGrantType: Maybe<Scalars['String']['output']>;
  /** Number of shares issued for company equity type assets. */
  companyEquitySharesIssued: Maybe<Scalars['BigDecimal']['output']>;
  /** Vesting cliff for company equity type assets. */
  companyEquityVestingCliff: Maybe<Scalars['BigDecimal']['output']>;
  /** Vesting duration for company equity type assets. */
  companyEquityVestingDuration: Maybe<Scalars['Int']['output']>;
  /** Vesting rate for company equity type assets. */
  companyEquityVestingRate: Maybe<Scalars['String']['output']>;
  /** Vesting start date for company equity type assets. */
  companyEquityVestingStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The cost basis of the asset */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** The description of the asset. */
  description: Scalars['String']['output'];
  /** Whether to hide this portfolio item from client */
  hiddenFromClient: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  hiddenFromNetWorth: Maybe<Scalars['Boolean']['output']>;
  /** Daily value history for the asset, forward-filled from each recorded change. */
  historicalValues: Array<HistoricalValue>;
  /** The Savvy ID of the asset. */
  id: Scalars['ID']['output'];
  /** The timestamp the asset was last updated at. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The liabilities attached to this asset. */
  liabilities: Array<Liability>;
  /** Free-form notes about the asset (e.g. account numbers, dates). */
  notes: Maybe<Scalars['String']['output']>;
  /** The status of the asset. */
  status: AccountStatusName;
  /** The timestamp the asset was last updated with information. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The current value of the asset. */
  value: Value;
};

export type AssetClassName =
  /** High value collectible items */
  | 'collectible'
  /** Equity in a company the client works at */
  | 'company_equity'
  /** Insurance policy the client has */
  | 'insurance_policy'
  /** Other types of assets */
  | 'other'
  /** Real estate assets */
  | 'real_estate'
  /** Vehicles */
  | 'vehicle';

/** Ending value and per-period returns (QTD / YTD / Inception) for a single asset class. */
export type AssetClassReturn = {
  __typename?: 'AssetClassReturn';
  /** Asset class display name (e.g. "US Equity", "International Developed", "Cash"). */
  assetClass: Scalars['String']['output'];
  /** Since-inception TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  benchmarkInceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Display name of the firm-configured benchmark (e.g. "S&P 500 (Net TR)"); null when no benchmark is configured. */
  benchmarkName: Maybe<Scalars['String']['output']>;
  /** QTD TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  benchmarkQtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  benchmarkYtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value for the asset class on the report end date, in USD. */
  endingValue: Scalars['BigDecimal']['output'];
  /** Since-inception time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  inceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  qtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  ytdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** Asset grouping information. A single group for a categorization of assets */
export type AssetGrouping = {
  __typename?: 'AssetGrouping';
  name: Scalars['String']['output'];
  percent: Scalars['BigDecimal']['output'];
  performanceOverTime: Maybe<Array<Performance>>;
  targetAllocation: Maybe<Scalars['BigDecimal']['output']>;
  value: Value;
};

export type AssetSubclassName =
  | 'antique'
  | 'art'
  | 'boat'
  | 'car'
  | 'investment_property'
  | 'jewelry'
  | 'non_residence'
  | 'other'
  | 'primary_residence'
  | 'residence'
  | 'secondary_residence';

/** Autogenerated input type of AssignHouseholdFeeSchedule */
export type AssignHouseholdFeeScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor fee schedule to assign (must belong to the household's advisor) */
  feeScheduleId: Scalars['ID']['input'];
  /** Household to assign the fee schedule to */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignHouseholdFeeSchedule. */
export type AssignHouseholdFeeSchedulePayload = {
  __typename?: 'AssignHouseholdFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if the assignment failed */
  error: Maybe<Scalars['String']['output']>;
  /** The active household fee schedule after assignment */
  householdFeeSchedule: Maybe<HouseholdFeeSchedule>;
  /** Whether the assignment succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssignServiceCatalogItemToHousehold */
export type AssignServiceCatalogItemToHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  householdId: Scalars['ID']['input'];
  /** Service (template) being enrolled into. Optional only for compatibility with web bundles that predate 4C1T-571. */
  serviceCatalogItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Service catalog item id */
  serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignServiceCatalogItemToHousehold. */
export type AssignServiceCatalogItemToHouseholdPayload = {
  __typename?: 'AssignServiceCatalogItemToHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item household */
  serviceCatalogItemHousehold: Maybe<ServiceCatalogItemHousehold>;
};

export type AssignableAdvisor = {
  __typename?: 'AssignableAdvisor';
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Advisor's full name */
  name: Scalars['String']['output'];
  /** The advisor's User ID (distinct from this AdvisorProfile's own ID) — for prefilling a task's assignee, which is a User */
  userId: Maybe<Scalars['ID']['output']>;
};

export type AssignedCampaign = {
  __typename?: 'AssignedCampaign';
  activeAlerts: Array<Alert>;
  customerIoCampaignId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mostRecentAlert: Maybe<Alert>;
  status: AssignedCampaignStatus;
  user: User;
};

export type AssignedCampaignStatus =
  /** call_response_required */
  | 'call_response_required'
  /** call_step_required */
  | 'call_step_required'
  /** email_response_required */
  | 'email_response_required'
  /** in_progress */
  | 'in_progress'
  /** lead_engaged */
  | 'lead_engaged'
  /** sms_response_required */
  | 'sms_response_required'
  /** stopped */
  | 'stopped';

export type BackgroundMeetingPrepDocumentOpen = {
  /** Id of the opened meeting-prep Canvas document. */
  canvasDocumentId?: InputMaybe<Scalars['String']['input']>;
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type BackgroundMeetingPrepNotificationClick = {
  /** Id of the meeting-prep Canvas document the notification targets. */
  canvasDocumentId?: InputMaybe<Scalars['String']['input']>;
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** Input type for filtering accounts by balance range */
export type BalanceRangeInput = {
  /** Maximum account balance */
  max?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Minimum account balance */
  min?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Bank account type for a Link a Bank request */
export type BankAccountTypeName =
  /** checking */
  | 'checking'
  /** savings */
  | 'savings';

/** Autogenerated input type of BeginMfaEnrollment */
export type BeginMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BeginMfaEnrollment. */
export type BeginMfaEnrollmentPayload = {
  __typename?: 'BeginMfaEnrollmentPayload';
  channel: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** A single series in the Performance vs Benchmark chart — the household's portfolio or a Morningstar Target Risk benchmark. */
export type BenchmarkSeries = {
  __typename?: 'BenchmarkSeries';
  /** Human-readable label shown in the chart legend and table (e.g. "Demo Household"). */
  displayName: Scalars['String']['output'];
  /** True for the household's own series; false for benchmark series. */
  isHousehold: Scalars['Boolean']['output'];
  /**
   * Stable machine identifier for the series (e.g. "household",
   * "morningstar_moderately_aggressive_target_risk_tr_usd"). Used for chart
   * styling and table joins.
   */
  key: Scalars['String']['output'];
  /** Daily cumulative-return points spanning the report date range. Empty when data is unavailable. */
  points: Array<ReturnPoint>;
  /** Per-period totals for the table beneath the chart. */
  summaryRows: Array<PeriodReturnRow>;
};

/** The beneficiary of an account. */
export type Beneficiary = {
  __typename?: 'Beneficiary';
  contact: Contact;
  contingent: Maybe<Scalars['Boolean']['output']>;
  /** The percentage for this contact represented as an Integer */
  percentage: Maybe<Scalars['Int']['output']>;
};

/** Attributes for creating or updating a beneficiary on an account */
export type BeneficiaryInput = {
  contact: ContactInput;
  contingent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage for this contact represented as an Integer */
  percentage: Scalars['Int']['input'];
};

/** Beneficiary relation type — primary or contingent */
export type BeneficiaryRelationTypeName =
  /** contingent */
  | 'contingent'
  /** primary */
  | 'primary';

export type BeneficiaryRelationship =
  /** child */
  | 'child'
  /** estate */
  | 'estate'
  /** friend */
  | 'friend'
  /** grandchild */
  | 'grandchild'
  /** grandparent */
  | 'grandparent'
  /** niece_nephew */
  | 'niece_nephew'
  /** organization */
  | 'organization'
  /** other_individual */
  | 'other_individual'
  /** parent */
  | 'parent'
  /** sibling */
  | 'sibling'
  /** spouse */
  | 'spouse'
  /** trust */
  | 'trust'
  /** uncle_aunt */
  | 'uncle_aunt';

/** One account and its beneficiaries within a beneficiary update request */
export type BeneficiaryUpdateAccountInput = {
  /** Account whose beneficiaries are being updated */
  accountId: Scalars['ID']['input'];
  /** Beneficiaries to record on the account */
  beneficiaries: Array<AccountMaintenanceBeneficiaryInput>;
};

/** Beneficiary update variant of account maintenance */
export type BeneficiaryUpdateInput = {
  /** Accounts and their beneficiaries */
  accounts: Array<BeneficiaryUpdateAccountInput>;
};

/** Billing Hold variant: temporarily pause invoicing */
export type BillingHoldInput = {
  /** Affected accounts; empty applies to the entire household */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Expected resume date */
  expectedResumeDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Hold start date; omitted when the timing is future */
  holdStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the hold starts immediately or on a future date described in the notes */
  holdStartDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Reason for the hold */
  reasonForHold: Scalars['String']['input'];
};

/**
 * Whether an advisor can receive a book upload, and what is already staged against
 * them. Read-only: lets the admin upload page warn before a file is picked, rather
 * than after the upload has already resolved (and possibly created) an enrollment.
 */
export type BookUploadReadiness = {
  __typename?: 'BookUploadReadiness';
  /** Target advisor display name, for the upload page copy. */
  advisorName: Scalars['String']['output'];
  /** Whether flag-advisor-onboarding is on for the target advisor. False means an upload would be rejected. */
  eligible: Scalars['Boolean']['output'];
  /** Existing enrollment uuid, or null when uploading would create the advisor's first enrollment. */
  enrollmentUuid: Maybe<Scalars['ID']['output']>;
  /** When the most recent book import was created. */
  latestImportAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Most recent book import id, for linking to its detail view. */
  latestImportId: Maybe<Scalars['ID']['output']>;
  /** Households already staged against the enrollment. A further upload adds to this book rather than replacing it. */
  stagedHouseholdCount: Scalars['Int']['output'];
};

/** A file in a household's Box Client Uploads folder, annotated with its Extend extraction status */
export type BoxClientUploadStatement = {
  __typename?: 'BoxClientUploadStatement';
  /** Box file id */
  boxDocumentId: Scalars['String']['output'];
  /** extend_extracted_data id when this file has been processed */
  extractedDatumId: Maybe<Scalars['String']['output']>;
  /** completed, pending, failed, or not_processed */
  extractionStatus: Scalars['String']['output'];
  /** File name as stored in Box */
  fileName: Scalars['String']['output'];
  /** Box content_modified_at timestamp */
  modifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** File size in bytes */
  size: Maybe<Scalars['Int']['output']>;
};

export type BoxConfiguration = {
  __typename?: 'BoxConfiguration';
  /** The access token used for Box UI Elements. */
  accessToken: Maybe<Scalars['String']['output']>;
  /**
   * Lifetime of accessToken, in seconds from when Box minted it. Relative rather
   * than absolute so a skewed client clock cannot make an expired token look
   * valid. Null when no token was minted, or when Box did not report a lifetime.
   */
  accessTokenExpiresInSeconds: Maybe<Scalars['Int']['output']>;
  /** The Root Box folder ID used for initializing the Content Explorer Box UI Element. */
  folderId: Maybe<Scalars['String']['output']>;
  /** IDs of Box subfolders */
  subfolders: Maybe<BoxSubfolderIds>;
  /**
   * Set when no token could be minted. NO_FOLDER_CONFIGURED and NO_BOX_ACCOUNT are
   * permanent for this household; BOX_UNREACHABLE is transient and worth retrying.
   */
  unavailableReason: Maybe<BoxConfigurationUnavailableReasonEnum>;
};

/** Why a Box configuration could not be produced */
export type BoxConfigurationUnavailableReasonEnum =
  /** BOX_UNREACHABLE */
  | 'BOX_UNREACHABLE'
  /** NO_BOX_ACCOUNT */
  | 'NO_BOX_ACCOUNT'
  /** NO_FOLDER_CONFIGURED */
  | 'NO_FOLDER_CONFIGURED';

export type BoxFileItem = {
  __typename?: 'BoxFileItem';
  createdAt: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentPath: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Scalars['String']['output']>>;
};

export type BoxFileThumbnail = {
  __typename?: 'BoxFileThumbnail';
  /** box file ID */
  fileId: Scalars['ID']['output'];
  thumbnailData: Scalars['Base64']['output'];
};

export type BoxFolderFileItems = {
  __typename?: 'BoxFolderFileItems';
  files: Maybe<Array<BoxFileItem>>;
  pathCounts: Maybe<Array<BoxFolderPathCount>>;
};

export type BoxFolderPathCount = {
  __typename?: 'BoxFolderPathCount';
  count: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
};

/** Type of folder to upload to */
export type BoxFolderTypeEnum =
  /** CLIENT_UPLOADS */
  | 'CLIENT_UPLOADS'
  /** CUSTODIAL_FORMS */
  | 'CUSTODIAL_FORMS'
  /** INVOICES */
  | 'INVOICES'
  /** QUARTERLY_REPORTS */
  | 'QUARTERLY_REPORTS'
  /** REPORTS_FOR_REVIEW */
  | 'REPORTS_FOR_REVIEW'
  /** TAX_FORMS */
  | 'TAX_FORMS';

export type BoxMarketingConfiguration = {
  __typename?: 'BoxMarketingConfiguration';
  /** Advisor access token */
  accessToken: Maybe<Scalars['String']['output']>;
  advisorFiles: Maybe<BoxFolderFileItems>;
  advisorGroupFiles: Maybe<BoxFolderFileItems>;
  /** All available tags for box  */
  allTags: Maybe<Array<Scalars['String']['output']>>;
  brandMaterialFiles: Maybe<BoxFolderFileItems>;
  emailTemplatesFiles: Maybe<BoxFolderFileItems>;
  featuredFiles: Maybe<BoxFolderFileItems>;
  resourcesFiles: Maybe<BoxFolderFileItems>;
  socialMediaFiles: Maybe<BoxFolderFileItems>;
};

export type BoxSubfolderIds = {
  __typename?: 'BoxSubfolderIds';
  /** Folder id for box accounts subfolder */
  accountsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for the client-visible Additional Materials subfolder */
  additionalMaterialsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for box client uploads subfolder */
  clientUploadsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for the private Comment Attachments subfolder */
  commentAttachmentsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for box private subfolder */
  privateBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for box public subfolder */
  publicBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for attaching files to tasks subfolder */
  taskAttachmentsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Folder id for the Task Uploads task type subfolder */
  taskUploadsBoxFolderId: Maybe<Scalars['String']['output']>;
};

/** Detail for the US-registered broker-dealer association disclosure (required when the answer is yes). */
export type BrokerDealerDetailInput = {
  /** CRD number of the broker-dealer firm */
  firmCrdNumber: Scalars['String']['input'];
  /** Name of the broker-dealer firm */
  firmName: Scalars['String']['input'];
  /** Your role at the firm */
  role: Scalars['String']['input'];
  /** Supervisor's contact (email or phone) */
  supervisorContact: Scalars['String']['input'];
  /** Supervisor's name */
  supervisorName: Scalars['String']['input'];
};

export type BrokerageAccountStatement = {
  __typename?: 'BrokerageAccountStatement';
  accountData: Scalars['JSON']['output'];
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<Scalars['String']['output']>;
  boxDocumentId: Scalars['String']['output'];
  brokerageName: Maybe<Scalars['String']['output']>;
  classificationData: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentClassification: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  holdings: Maybe<Scalars['JSON']['output']>;
  household: Maybe<Household>;
  id: Scalars['ID']['output'];
  statementDate: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadingUser: User;
  workflowId: Scalars['String']['output'];
  workflowRunId: Scalars['String']['output'];
};

/** Autogenerated input type of BulkCancelTasks */
export type BulkCancelTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs to cancel. Only not-yet-started (todo) tasks are eligible; any other status is counted in ineligible_count. */
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkCancelTasks. */
export type BulkCancelTasksPayload = {
  __typename?: 'BulkCancelTasksPayload';
  /** Number already cancelled (no-op) */
  alreadyCancelledCount: Scalars['Int']['output'];
  /** IDs whose task was already cancelled (no-op) */
  alreadyCancelledIds: Array<Scalars['ID']['output']>;
  /** Number of tasks cancelled by this call */
  cancelledCount: Scalars['Int']['output'];
  /** IDs cancelled by this call */
  cancelledIds: Array<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** IDs whose cancellation raised an error (details in server logs); empty on a clean run */
  failedIds: Array<Scalars['ID']['output']>;
  /** Number whose task is not in a cancellable (todo) status */
  ineligibleCount: Scalars['Int']['output'];
  /** IDs whose task is not in a cancellable (todo) status */
  ineligibleIds: Array<Scalars['ID']['output']>;
  /** Number of ids with no matching task */
  notFoundCount: Scalars['Int']['output'];
  /** IDs with no matching task */
  notFoundIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of BulkCreateOrUpdateHouseholds */
export type BulkCreateOrUpdateHouseholdsInput = {
  /** The ID of the advisor user who owns the households that will be created or updated */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The XLSX file content encoded as base64 to process */
  xlsxFile: Scalars['String']['input'];
};

/** Autogenerated return type of BulkCreateOrUpdateHouseholds. */
export type BulkCreateOrUpdateHouseholdsPayload = {
  __typename?: 'BulkCreateOrUpdateHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during processing */
  errors: Array<Scalars['String']['output']>;
  /** The output XLSX file content encoded as base64 */
  xlsxFile: Scalars['String']['output'];
};

/** Error that occurred during bulk deletion of organization household tags */
export type BulkDeleteOrganizationHouseholdTagsError = {
  __typename?: 'BulkDeleteOrganizationHouseholdTagsError';
  /** The error message */
  message: Scalars['String']['output'];
  /** The ID of the tag that failed to delete */
  tagId: Scalars['ID']['output'];
};

/** Autogenerated input type of BulkDeleteOrganizationHouseholdTags */
export type BulkDeleteOrganizationHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the tags to delete */
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkDeleteOrganizationHouseholdTags. */
export type BulkDeleteOrganizationHouseholdTagsPayload = {
  __typename?: 'BulkDeleteOrganizationHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The IDs of successfully deleted tags */
  deletedIds: Array<Scalars['ID']['output']>;
  /** Errors that occurred during deletion */
  errors: Array<BulkDeleteOrganizationHouseholdTagsError>;
  /** Whether all deletions were successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkGenerateReports */
export type BulkGenerateReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** monthly | quarterly | annually */
  frequency: Scalars['String']['input'];
  /**
   * Households to generate reports for. IDs the current advisor cannot access are
   * silently dropped rather than erroring the whole request.
   */
  householdIds: Array<Scalars['ID']['input']>;
  /** Saved template to render */
  savedReportTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of BulkGenerateReports. */
export type BulkGenerateReportsPayload = {
  __typename?: 'BulkGenerateReportsPayload';
  /** Poll bulkReportGenerationJob with this id */
  bulkReportDownloadId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of eligible households the job was enqueued for */
  totalHouseholds: Scalars['Int']['output'];
};

/** A bulk import operation for processing files with multiple data records */
export type BulkImport = {
  __typename?: 'BulkImport';
  /**
   * The advisor whose onboarding enrollment this import staged into, so the detail
   * view can link to that advisor's cockpit. Null unless this is an advisor
   * onboarding book import.
   */
  advisorOnboardingAdvisorId: Maybe<Scalars['ID']['output']>;
  /** Non-destructive re-upload merge outcome. Null unless this is an advisor onboarding book import. */
  advisorOnboardingMergeSummary: Maybe<AdvisorOnboardingBookMergeSummary>;
  /** Completion percentage of the bulk import */
  completionPercentage: Scalars['Float']['output'];
  /** When the bulk import was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Errors that occurred during the bulk import */
  errors: Array<BulkImportError>;
  /** Whether a file is attached to this bulk import */
  hasFile: Scalars['Boolean']['output'];
  /** The unique identifier for the bulk import */
  id: Scalars['ID']['output'];
  /** The importable ID for the bulk import */
  importableId: Scalars['ID']['output'];
  /** The importable name for the bulk import */
  importableName: Scalars['String']['output'];
  /** The importable type for the bulk import */
  importableType: Scalars['String']['output'];
  /** Progress information for the bulk import */
  progress: BulkImportProgress;
  /** The current status of the bulk import */
  status: Scalars['String']['output'];
  /** When the bulk import was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Display name of the user who initiated this import. Exposed as a scalar (not a
   * User object) so an advisor can read the name of an admin who uploaded on their
   * behalf without failing User authorization. Null for imports created before
   * uploader tracking.
   */
  uploadedByName: Maybe<Scalars['String']['output']>;
};

/** An error that occurred during bulk import processing */
export type BulkImportError = {
  __typename?: 'BulkImportError';
  /** The type of error that occurred */
  errorType: Maybe<Scalars['String']['output']>;
  /** The field where the error occurred */
  field: Maybe<Scalars['String']['output']>;
  /** A formatted error message with context */
  formattedMessage: Scalars['String']['output'];
  /** The unique identifier for the error */
  id: Scalars['ID']['output'];
  /** Whether this is a global import error or item-specific */
  isGlobalError: Scalars['Boolean']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** The data for the row where the error occurred */
  rowData: Maybe<Scalars['JSON']['output']>;
  /** The row number where the error occurred */
  rowNumber: Maybe<Scalars['Int']['output']>;
  /** The sheet name where the error occurred */
  sheetName: Maybe<Scalars['String']['output']>;
};

/** Progress information for a bulk import operation */
export type BulkImportProgress = {
  __typename?: 'BulkImportProgress';
  /** Number of items that failed processing */
  failed: Scalars['Int']['output'];
  /** Status of finalization phase (in_progress, completed, or null if not started) */
  finalizationStatus: Maybe<Scalars['String']['output']>;
  /** Number of items waiting to be processed */
  pending: Scalars['Int']['output'];
  /** Completion percentage (0.0 to 100.0) */
  percentage: Scalars['Float']['output'];
  /** Number of items successfully processed */
  processed: Scalars['Int']['output'];
  /** Number of items currently being processed */
  processing: Scalars['Int']['output'];
  /** Number of items that were skipped */
  skipped: Scalars['Int']['output'];
  /** Total number of items to process */
  total: Scalars['Int']['output'];
};

/** One household that failed to generate in a bulk report generation job */
export type BulkReportGenerationFailure = {
  __typename?: 'BulkReportGenerationFailure';
  /** Error message */
  errorMessage: Scalars['String']['output'];
  /** The household that failed */
  householdId: Scalars['ID']['output'];
  /** Display name of the household */
  householdName: Scalars['String']['output'];
};

/** Tracks a bulk report-generation job — fan-out across households, zip assembly, download. */
export type BulkReportGenerationJob = {
  __typename?: 'BulkReportGenerationJob';
  /** Households successfully generated so far. */
  completedCount: Scalars['Int']['output'];
  /** When the job was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authenticated download path once the zip is ready. Null until status = completed. */
  downloadUrl: Maybe<Scalars['String']['output']>;
  /** When the job (and its zip, if any) expires. */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Households that failed so far. */
  failedCount: Scalars['Int']['output'];
  /** Per-household failure details. */
  failures: Array<BulkReportGenerationFailure>;
  /** monthly | quarterly | annually -- same reason as saved_report_template_id. */
  frequency: Scalars['String']['output'];
  /** The record ID. */
  id: Scalars['ID']['output'];
  /**
   * Template this job was generated from -- lets the client retry failed
   * households without depending on form state that does not survive a page reload.
   */
  savedReportTemplateId: Scalars['ID']['output'];
  /** Current status: pending | processing | completed | failed. */
  status: Scalars['String']['output'];
  /** Number of households the job was enqueued for. */
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of BulkUpdateAlerts */
export type BulkUpdateAlertsInput = {
  /** Array of alert IDs to dismiss (set status to removed) */
  alertsToDismiss?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Array of alert IDs to snooze */
  alertsToSnooze?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time when alerts were snoozed (used for alerts_to_snooze) */
  snoozedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The time when alerts should surface (used for alerts_to_snooze) */
  surfaceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of BulkUpdateAlerts. */
export type BulkUpdateAlertsPayload = {
  __typename?: 'BulkUpdateAlertsPayload';
  /** The updated alerts */
  alerts: Array<Alert>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of error messages if any updates failed */
  errors: Maybe<Array<Scalars['String']['output']>>;
};

/** Error type for bulk update clients */
export type BulkUpdateClientsError = {
  __typename?: 'BulkUpdateClientsError';
  /** Error message */
  message: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** Autogenerated input type of BulkUpdateClients */
export type BulkUpdateClientsInput = {
  /** The ID of the advisor user who owns the clients that will be updated */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The clients to update */
  clients: Array<AdvisorClientInput>;
};

/** Autogenerated return type of BulkUpdateClients. */
export type BulkUpdateClientsPayload = {
  __typename?: 'BulkUpdateClientsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during the update. An error affects 1 client, it does not stop the whole batch */
  errors: Array<BulkUpdateClientsError>;
  /** Whether prospects were included in the update */
  prospectsIncluded: Scalars['Boolean']['output'];
};

/** Error that occurred during bulk update of organization household categories */
export type BulkUpdateOrganizationHouseholdCategoriesError = {
  __typename?: 'BulkUpdateOrganizationHouseholdCategoriesError';
  /** The ID of the category that failed to update */
  categoryId: Scalars['ID']['output'];
  /** The error message */
  message: Scalars['String']['output'];
};

/** Autogenerated input type of BulkUpdateOrganizationHouseholdCategories */
export type BulkUpdateOrganizationHouseholdCategoriesInput = {
  /** The categories to update */
  categories: Array<OrganizationHouseholdCategoryUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpdateOrganizationHouseholdCategories. */
export type BulkUpdateOrganizationHouseholdCategoriesPayload = {
  __typename?: 'BulkUpdateOrganizationHouseholdCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateOrganizationHouseholdCategoriesError>;
  /** The updated categories */
  organizationHouseholdCategories: Array<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of BulkUpdateTaxEnrollmentsToNotInterested */
export type BulkUpdateTaxEnrollmentsToNotInterestedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of client profile IDs to mark not interested */
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateTaxEnrollmentsToNotInterested. */
export type BulkUpdateTaxEnrollmentsToNotInterestedPayload = {
  __typename?: 'BulkUpdateTaxEnrollmentsToNotInterestedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  errors: Maybe<Scalars['String']['output']>;
  /** IDs that failed to update */
  failedIds: Array<Scalars['ID']['output']>;
  /** IDs that updated */
  successIds: Array<Scalars['ID']['output']>;
};

/** Bulk upload to create LPOA documents in a Docusign envelope */
export type BulkUploadDocumentInput = {
  /** Fifth account number */
  accountFive?: InputMaybe<Scalars['String']['input']>;
  /** Fourth account number */
  accountFour?: InputMaybe<Scalars['String']['input']>;
  /** First account number */
  accountOne: Scalars['String']['input'];
  /** Third account number */
  accountThree?: InputMaybe<Scalars['String']['input']>;
  /** Second account number */
  accountTwo?: InputMaybe<Scalars['String']['input']>;
  /** Name of the advisor */
  advisorName: Scalars['String']['input'];
  /** Custodian (Charles Schwab or Fidelity) */
  custodian: Scalars['String']['input'];
  /** Master account number */
  masterAccount: Scalars['String']['input'];
  /** Email of the primary account holder */
  primaryAccountHolderEmail: Scalars['String']['input'];
  /** First name of the primary account holder */
  primaryAccountHolderFirstName: Scalars['String']['input'];
  /** Last name of the primary account holder */
  primaryAccountHolderLastName: Scalars['String']['input'];
  /** Phone number of the primary account holder */
  primaryAccountHolderPhone?: InputMaybe<Scalars['String']['input']>;
  /** Email of the secondary account holder */
  secondaryAccountHolderEmail?: InputMaybe<Scalars['String']['input']>;
  /** First name of the secondary account holder */
  secondaryAccountHolderFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the secondary account holder */
  secondaryAccountHolderLastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the secondary account holder */
  secondaryAccountHolderPhone?: InputMaybe<Scalars['String']['input']>;
};

/** One failed document in a bulk Box upload */
export type BulkUploadFilesToBoxFailure = {
  __typename?: 'BulkUploadFilesToBoxFailure';
  /** Display name of the document */
  documentName: Scalars['String']['output'];
  /** URL to open the document (for link only) */
  documentUrl: Scalars['String']['output'];
  /** Error message */
  errorMessage: Scalars['String']['output'];
  /** Display name of the household */
  householdName: Scalars['String']['output'];
};

/** Autogenerated input type of BulkUploadFilesToBox */
export type BulkUploadFilesToBoxInput = {
  /** Target Box folder type */
  boxFolderType: BoxFolderTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documents to upload */
  items: Array<BulkUploadFilesToBoxItemInput>;
};

/** One document to upload in a bulk Box upload */
export type BulkUploadFilesToBoxItemInput = {
  /** Display name of the document */
  documentName: Scalars['String']['input'];
  /** Document download URL */
  documentUrl: Scalars['String']['input'];
  /** Household ID */
  householdId: Scalars['ID']['input'];
  /** Display name of the household (for failure list) */
  householdName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUploadFilesToBox. */
export type BulkUploadFilesToBoxPayload = {
  __typename?: 'BulkUploadFilesToBoxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if start failed */
  error: Maybe<Scalars['String']['output']>;
  /** Job ID to poll for status */
  jobId: Maybe<Scalars['String']['output']>;
};

/** Status of a bulk file upload to Box */
export type BulkUploadFilesToBoxStatus = {
  __typename?: 'BulkUploadFilesToBoxStatus';
  /** Number completed (success) */
  completed: Scalars['Int']['output'];
  /** Number failed */
  failed: Scalars['Int']['output'];
  /** Same as failed */
  failureCount: Scalars['Int']['output'];
  /** List of failed items */
  failures: Array<BulkUploadFilesToBoxFailure>;
  /** pending, processing, completed, or failed */
  status: Scalars['String']['output'];
  /** Same as completed */
  successCount: Scalars['Int']['output'];
  /** Total number of items */
  total: Scalars['Int']['output'];
};

/** Per-day overflow count when limitPerDay caps the response */
export type CalendarDayOverflow = {
  __typename?: 'CalendarDayOverflow';
  /** Number of work items beyond the per-day limit on this date */
  count: Scalars['Int']['output'];
  /** The calendar date with overflowing work items */
  date: Scalars['ISO8601Date']['output'];
};

/** A calendar event from an advisor's calendar */
export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** All participants in the event. */
  calendarEventParticipants: Array<CalendarEventParticipant>;
  /**
   * Id of the requester's own canvas document for this event: the meeting_recap
   * doc once the meeting has one, otherwise the meeting_prep doc. Null when
   * neither exists or the doc belongs to another user.
   */
  canvasDocumentId: Maybe<Scalars['ID']['output']>;
  /**
   * Type of the document `canvasDocumentId` points at, so callers can label a
   * recap CTA differently from a prep one. Null whenever `canvasDocumentId` is null.
   */
  canvasDocumentType: Maybe<CanvasDocumentType>;
  /** Timestamp when the calendar event was created in Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the event. */
  description: Maybe<Scalars['String']['output']>;
  /** Event end date (for all-day events). */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Event end time with timezone (for timed events). */
  endsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Households linked to this event via participant matching. */
  households: Array<Household>;
  /** The Savvy ID of the calendar event. */
  id: Scalars['ID']['output'];
  /** Whether the event is an all-day event. */
  isAllDay: Scalars['Boolean']['output'];
  /** The location of the event. */
  location: Maybe<Scalars['String']['output']>;
  /** Video conference or meeting link. */
  meetingLink: Maybe<Scalars['String']['output']>;
  /**
   * The Note attached to this CalendarEvent, scoped to the requesting household
   * context. Null when no Note is linked, the Note is out of scope, or the
   * requester is not authorized.
   */
  note: Maybe<Note>;
  /** Event start date (for all-day events). */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Event start time with timezone (for timed events). */
  startsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event status (confirmed, tentative, cancelled). */
  status: Scalars['String']['output'];
  /** The title/summary of the event. */
  summary: Maybe<Scalars['String']['output']>;
  /** Timestamp when the calendar event was last updated in Savvy. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CalendarEvent. */
export type CalendarEventConnection = {
  __typename?: 'CalendarEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CalendarEventEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CalendarEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CalendarEventEdge = {
  __typename?: 'CalendarEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CalendarEvent>;
};

/** A participant in a calendar event with their response status */
export type CalendarEventParticipant = {
  __typename?: 'CalendarEventParticipant';
  /** Timestamp when the participant was added to the event. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the calendar event participant. */
  id: Scalars['ID']['output'];
  /** Whether this participant is optional. */
  isOptional: Scalars['Boolean']['output'];
  /** Whether this participant is the organizer of the event. */
  isOrganizer: Scalars['Boolean']['output'];
  /** The participant details - either a Participant (external) or User (internal). */
  participant: CalendarEventParticipantPersonUnion;
  /** The participant's response status (needs_action, accepted, declined, tentative). */
  responseStatus: Scalars['String']['output'];
  /** Timestamp when the participant was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A person participating in a calendar event - either an external Participant or an internal User */
export type CalendarEventParticipantPersonUnion = Participant | PublicParticipantUser | User;

/** The connection type for WorkItem. */
export type CalendarWorkItemConnection = {
  __typename?: 'CalendarWorkItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WorkItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<WorkItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Per-day overflow counts when limitPerDay is set; empty array when limitPerDay is absent */
  remainingCountPerDay: Array<CalendarDayOverflow>;
  /** Total number of work items matching the query without pagination */
  totalCount: Scalars['Int']['output'];
};

/** A wizard calibration pick mapped to a voice trait. */
export type CalibrationDerivedTraitInput = {
  /** Which option the advisor picked: A | B | neither. */
  choice: Scalars['String']['input'];
  /** Advisor freeform text, present only when choice is neither. */
  neitherText?: InputMaybe<Scalars['String']['input']>;
  /** Provenance of the value; 'calibration' for capture-flow picks. */
  source: Scalars['String']['input'];
  /** Target trait key: warmth | jargon | numbers | directness | sign_off. */
  trait: Scalars['String']['input'];
  /** Short characterization of the chosen option (or the advisor's freeform 'neither' text). */
  value: Scalars['String']['input'];
};

/** A call log entry representing a call between an advisor and a client */
export type CallLog = {
  __typename?: 'CallLog';
  /** The advisor profile associated with this call log. */
  advisorProfile: Advisor;
  /** The COI associated with this call log, if it is COI-scoped. */
  centerOfInfluenceRep: Maybe<CenterOfInfluenceRep>;
  /** The client profile associated with this call log, if it is household-scoped. */
  clientProfile: Maybe<Client>;
  /** The client profile ID associated with this call log, if it is household-scoped. */
  clientProfileId: Maybe<Scalars['ID']['output']>;
  /** Notes or content from the call. */
  content: Scalars['String']['output'];
  /** Timestamp when the call log was created in Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time when the call occurred. */
  date: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the call log. */
  id: Scalars['ID']['output'];
  /** The Salesforce task ID associated with this call log. Needed for dual write for now. */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Timestamp when the call log was last updated in Savvy. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CancelLinkedBankAccountImport */
export type CancelLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the LinkedBankAccountImport to cancel */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelLinkedBankAccountImport. */
export type CancelLinkedBankAccountImportPayload = {
  __typename?: 'CancelLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** The cancelled import record */
  linkedBankAccountImport: Maybe<LinkedBankAccountImport>;
};

export type CanvasBoxToken = {
  __typename?: 'CanvasBoxToken';
  /**
   * Box token (read-level file access + Box AI) for the Savvy Intelligence canvas
   * agent to read documents server-side. Downscoped to `folderId` only when
   * `advisorWideAccess` is false; when true it reaches every folder the advisor
   * can read in Box. Agent-harness use only — not a general-purpose Box token.
   */
  accessToken: Scalars['String']['output'];
  /**
   * True when the token is NOT locked to `folderId` and instead reads every folder
   * the advisor can reach in Box (flag-gated pilot). The canvas prompt swaps its
   * document-scope guidance on this, so callers must thread it through.
   */
  advisorWideAccess: Scalars['Boolean']['output'];
  /**
   * The household Box folder the token was requested for. Box enforces it as a
   * hard boundary only when `advisorWideAccess` is false; otherwise it is the
   * folder the agent is told to treat as its default.
   */
  folderId: Scalars['String']['output'];
};

export type CanvasDocumentType =
  /** communication */
  | 'communication'
  /** meeting_client_deliverable */
  | 'meeting_client_deliverable'
  /** meeting_prep */
  | 'meeting_prep'
  /** meeting_recap */
  | 'meeting_recap'
  /** planning */
  | 'planning';

/** A carry-over selection for one standing instruction or recurring transfer. */
export type CarryOverSelectionInput = {
  /** Standing instruction or recurring transfer identifier */
  id: Scalars['ID']['input'];
  /** Whether this record should be carried over to the new account */
  shouldCarryOver: Scalars['Boolean']['input'];
};

/** Combined cash and money market balance for an account. */
export type CashAndMoneyMarket = {
  __typename?: 'CashAndMoneyMarket';
  /** The combined cash and money market amount, serialized as a decimal string. */
  amount: Scalars['String']['output'];
  /** ISO currency code for the amount. */
  currencyCode: Scalars['String']['output'];
  /** The combined cash and money market amount as a percent of the account balance. */
  percent: Scalars['Float']['output'];
};

export type CashReservesPerAccount = {
  __typename?: 'CashReservesPerAccount';
  accountName: Maybe<Scalars['String']['output']>;
  cashReserves: Maybe<Scalars['String']['output']>;
};

export type CenterOfInfluenceRep = {
  __typename?: 'CenterOfInfluenceRep';
  address: Maybe<Scalars['String']['output']>;
  clientReferralUrl: Scalars['String']['output'];
  /**
   * Comment indicator for a professional-contacts list row or card, scoped to the
   * viewing user. Batched — safe to request across the whole contacts list.
   */
  commentSummary: CommentSummary;
  company: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  feeRate: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Edges where this contact is the target (who referred this contact). Filter by relationshipType. */
  incomingProfessionalRelationships: Array<ProfessionalRelationship>;
  jobTitle: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Edges where this contact is the source (households it serves, contacts it referred). Filter by relationshipType. */
  outgoingProfessionalRelationships: Array<ProfessionalRelationship>;
  ownerAdvisorProfile: Advisor;
  phoneNumber: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
  preferredContactMethod: Maybe<CenterOfInfluenceRepPreferredContactMethod>;
  referredHouseholds: Array<Household>;
  secondaryEmail: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumber: Maybe<Scalars['String']['output']>;
  specialties: Array<CenterOfInfluenceRepSpecialty>;
};

export type CenterOfInfluenceRepPreferredContactMethod =
  /** email */
  | 'email'
  /** mobile */
  | 'mobile'
  /** other */
  | 'other'
  /** phone */
  | 'phone';

export type CenterOfInfluenceRepSpecialty =
  /** coi */
  | 'coi'
  /** estate */
  | 'estate'
  /** insurance */
  | 'insurance'
  /** legal */
  | 'legal'
  /** mortgage */
  | 'mortgage'
  /** other */
  | 'other'
  /** tax */
  | 'tax';

/** Checkbox filter with operator and boolean value */
export type CheckboxFilterInput = {
  /** Checkbox filter operator */
  operator: CheckboxFilterOperatorEnum;
  /** Filter boolean value */
  value: Scalars['Boolean']['input'];
};

/** Checkbox filter operators */
export type CheckboxFilterOperatorEnum =
  /** Is the boolean value */
  | 'IS'
  /** Is not the boolean value */
  | 'IS_NOT';

/** Autogenerated input type of ClearHouseholdBenchmark */
export type ClearHouseholdBenchmarkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update. */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClearHouseholdBenchmark. */
export type ClearHouseholdBenchmarkPayload = {
  __typename?: 'ClearHouseholdBenchmarkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the benchmark was cleared. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ClearRedisCacheForBoxFolder */
export type ClearRedisCacheForBoxFolderInput = {
  boxFolderId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClearRedisCacheForBoxFolder. */
export type ClearRedisCacheForBoxFolderPayload = {
  __typename?: 'ClearRedisCacheForBoxFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the cache was successfully cleared */
  success: Scalars['Boolean']['output'];
};

export type Client = {
  __typename?: 'Client';
  accountSetupTaskId: Maybe<Scalars['ID']['output']>;
  accounts: Maybe<Array<Account>>;
  /** The age of the client in years */
  age: Maybe<Scalars['Int']['output']>;
  /**
   * Every income source annualized and summed, mirroring totalAnnualIncome. Not
   * the client's salary once they record a second source of income.
   */
  annualGrossIncome: Maybe<Scalars['Float']['output']>;
  assets: Maybe<Array<Asset>>;
  assignedAdvisor: Advisor;
  boxFolderUrl: Maybe<Scalars['String']['output']>;
  callLogs: Maybe<Array<CallLog>>;
  /** Client citizenship */
  citizenship: Maybe<Scalars['String']['output']>;
  /** Client agreements for this client */
  clientAgreements: Maybe<Array<ClientAgreement>>;
  clientIntakeData: Maybe<ClientIntakeData>;
  clientIntakeDataUrl: Maybe<Scalars['String']['output']>;
  clientPortfolioCsvUrl: Scalars['String']['output'];
  clientProfileId: Maybe<Scalars['ID']['output']>;
  coManagerSsn: Maybe<Scalars['String']['output']>;
  contacts: Maybe<Array<Contact>>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerIoId: Maybe<Scalars['String']['output']>;
  customerIoUrl: Maybe<Scalars['String']['output']>;
  dateOfBirth: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date the client passed away, if applicable */
  dateOfDeath: Maybe<Scalars['ISO8601Date']['output']>;
  dialpadEvents: Maybe<Array<DialpadEvent>>;
  employerName: Maybe<Scalars['String']['output']>;
  employmentStatus: Maybe<EmploymentStatusName>;
  /** Whether tax tab is enabled, source of truth is from client's primary advisor */
  enableTaxTab: Scalars['Boolean']['output'];
  feeScheduleLines: Maybe<Array<Scalars['String']['output']>>;
  governmentIds: Maybe<Array<GovernmentId>>;
  /**
   * The household this client is associated with. Pass id to scope to a specific
   * household the underlying user is a member of (SV-940); falls back to the
   * ClientProfile household otherwise.
   */
  household: Household;
  id: Scalars['ID']['output'];
  /** The client's recurring income sources, in display order */
  incomeSources: Array<ClientIncomeSource>;
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Client legal residence */
  legalResidence: Maybe<Scalars['String']['output']>;
  liabilities: Maybe<Array<Liability>>;
  mostRecentInboundDialpadSms: Maybe<DialpadEvent>;
  /** The number of post-onboarding tasks remaining for the client household to complete */
  numberOfTodoTasks: Scalars['Int']['output'];
  /** Client occupation */
  occupation: Maybe<Scalars['String']['output']>;
  /** When the onboarding (IAA) task for this client was created */
  onboardingIaaCreatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  opportunities: Maybe<Array<Opportunity>>;
  providerAccounts: Maybe<Array<ProviderAccount>>;
  retirementDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The role of the client in the household (primary or member) */
  role: ClientRole;
  salesforceContactId: Maybe<Scalars['String']['output']>;
  soloPropEntityName: Maybe<Scalars['String']['output']>;
  ssn: Maybe<Scalars['String']['output']>;
  stage: Maybe<ClientStage>;
  tasks: Maybe<Array<Task>>;
  /** Tax enrollments for this client */
  taxEnrollments: Maybe<Array<TaxEnrollment>>;
  /** Tax transcript requests for this client */
  taxTranscriptRequests: Maybe<Array<TaxTranscriptRequest>>;
  /** client tax transcripts */
  taxTranscripts: Maybe<Array<TaxTranscript>>;
  /** Every income source annualized and summed. Resolved here so callers never sum decimals in JS. */
  totalAnnualIncome: Scalars['BigDecimal']['output'];
  university: Maybe<Scalars['String']['output']>;
  user: User;
};


export type ClientAccountSetupTaskIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientAssignedAdvisorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientBoxFolderUrlArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientContactsArgs = {
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientFeeScheduleLinesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientNumberOfTodoTasksArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientProviderAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * A beneficiary designation on one of the viewer's accounts, as shown in the
 * client portal. Deliberately narrower than Types::Beneficiary: it carries the
 * four display values only, so the SSN and date of birth on the underlying Contact
 * cannot be selected from a client surface.
 */
export type ClientAccountBeneficiary = {
  __typename?: 'ClientAccountBeneficiary';
  /** True for a contingent designation, false for a primary one. */
  contingent: Scalars['Boolean']['output'];
  /** Identifier of the designation edge. */
  id: Scalars['ID']['output'];
  /**
   * The beneficiary's display name, built from whichever name parts are on file.
   * Null when the contact carries neither, which the client surface labels rather
   * than dropping the row - a designation with a tier and a share is the thing the
   * client is being asked to confirm.
   */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Their relationship as an unlabelled contact-relation value (e.g. "spouse",
   * "niece_nephew"), read from the account owner's own contact record where there
   * is one and otherwise from another member of the same household. Never from a
   * user outside it. Null when none is on record.
   */
  relationship: Maybe<Scalars['String']['output']>;
  /**
   * The designated share as a whole percent. Shares are per tier, so a primary and
   * a contingent designation can each total 100. Null when no share is on record.
   */
  sharePercent: Maybe<Scalars['Int']['output']>;
};

/** Client agreement (e.g. IAA) for a client profile. */
export type ClientAgreement = {
  __typename?: 'ClientAgreement';
  /** The type of agreement (e.g. iaa). */
  agreementType: Scalars['String']['output'];
  /** When the agreement was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the client agreement. */
  id: Scalars['ID']['output'];
  /** Box file ID for the signable document. */
  signableDocumentBoxFileId: Maybe<Scalars['String']['output']>;
  /** Link to the signable document. */
  signableDocumentLink: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the signature for the client agreement. */
  signatureId: Maybe<Scalars['ID']['output']>;
  /** Box file ID for the signed document. */
  signedDocumentBoxFileId: Maybe<Scalars['String']['output']>;
  /** When the agreement was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Whether cash raising is needed (Final Bill variant) */
export type ClientBillingCashRaisingNeededName =
  /** no */
  | 'no'
  /** unsure */
  | 'unsure'
  /** yes */
  | 'yes';

/** Whether a request date takes effect immediately or on a future date described in the notes */
export type ClientBillingDateTimingName =
  /** future */
  | 'future'
  /** immediate */
  | 'immediate';

/** Fee change direction (Fee Schedule Update variant) */
export type ClientBillingFeeChangeTypeName =
  /** decrease */
  | 'decrease'
  /** increase */
  | 'increase'
  /** no_change */
  | 'no_change';

/** Client Billing — Other variant: catch-all billing request */
export type ClientBillingOtherInput = {
  /** Description of the request */
  description: Scalars['String']['input'];
  /** Urgency — standard or urgent */
  urgency: ClientBillingUrgencyName;
};

/** Payment cadence (New Financial Planning Client variant) */
export type ClientBillingPaymentCadenceName =
  /** annual */
  | 'annual'
  /** monthly */
  | 'monthly'
  /** one_time */
  | 'one_time'
  /** quarterly */
  | 'quarterly'
  /** semi_annual */
  | 'semi_annual';

/** Payment method (New Financial Planning Client variant) */
export type ClientBillingPaymentMethodName =
  /** advicepay */
  | 'advicepay'
  /** deduct */
  | 'deduct';

/** Rebate method (Client Fee Rebate variant) */
export type ClientBillingRebateMethodName =
  /** credit */
  | 'credit'
  /** direct_payment */
  | 'direct_payment';

/** Client billing request data associated with a task */
export type ClientBillingRequest = {
  __typename?: 'ClientBillingRequest';
  /** Whether cash raising is needed (Final Bill variant) */
  cashRaisingNeeded: Maybe<ClientBillingCashRaisingNeededName>;
  /** Current fee, as entered (Fee Schedule Update variant) */
  currentFee: Maybe<Scalars['String']['output']>;
  /** Account number for deduct, free text (New Financial Planning Client variant) */
  deductAccountNumber: Maybe<Scalars['String']['output']>;
  /** Description (Client Billing — Other variant) */
  description: Maybe<Scalars['String']['output']>;
  /** Effective date (Fee Schedule Update, New Financial Planning Client) */
  effectiveDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the effective date is immediate or a future date described in the notes */
  effectiveDateTiming: Maybe<ClientBillingDateTimingName>;
  /** Expected resume date (Billing Hold variant) */
  expectedResumeDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Annual fee amount (New Financial Planning Client variant) */
  feeAmount: Maybe<Scalars['String']['output']>;
  /** Fee change direction (Fee Schedule Update variant) */
  feeChangeType: Maybe<ClientBillingFeeChangeTypeName>;
  /** Hold start date (Billing Hold variant) */
  holdStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the hold start date is immediate or a future date described in the notes */
  holdStartDateTiming: Maybe<ClientBillingDateTimingName>;
  /** Whether a new IAA was confirmed (Fee Schedule Update variant) */
  iaaConfirmed: Maybe<Scalars['Boolean']['output']>;
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Last service date (Final Bill variant) */
  lastServiceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the last service date is immediate or a future date described in the notes */
  lastServiceDateTiming: Maybe<ClientBillingDateTimingName>;
  /** New fee, as entered (Fee Schedule Update variant) */
  newFee: Maybe<Scalars['String']['output']>;
  /** Free-text notes for Ops */
  notes: Maybe<Scalars['String']['output']>;
  /** Payment cadence (New Financial Planning Client variant) */
  paymentCadence: Maybe<ClientBillingPaymentCadenceName>;
  /** Payment method (New Financial Planning Client variant) */
  paymentMethod: Maybe<ClientBillingPaymentMethodName>;
  /** Plan name (Corporate Retirement Billing Question variant) */
  planName: Maybe<Scalars['String']['output']>;
  /** The billing question (Corporate Retirement Billing Question variant) */
  question: Maybe<Scalars['String']['output']>;
  /** Reason for the rebate (Client Fee Rebate variant) */
  reason: Maybe<Scalars['String']['output']>;
  /** Reason for the hold (Billing Hold variant) */
  reasonForHold: Maybe<Scalars['String']['output']>;
  /** Rebate amount (Client Fee Rebate variant) */
  rebateAmount: Maybe<Scalars['String']['output']>;
  /** Rebate method (Client Fee Rebate variant) */
  rebateMethod: Maybe<ClientBillingRebateMethodName>;
  /** Recordkeeper (Corporate Retirement Billing Question variant) */
  recordkeeper: Maybe<Scalars['String']['output']>;
  /** Accounts selected on the request (Fee Schedule Update, Client Fee Rebate, Billing Hold, Final Bill) */
  requestAccounts: Array<ClientBillingRequestAccount>;
  /** The variant of the request (e.g. fee_schedule_update, final_bill) */
  requestType: ClientBillingRequestTypeName;
  /** Responsible party (Client Fee Rebate variant) */
  responsibleParty: Maybe<ClientBillingResponsiblePartyName>;
  /** Urgency (Corporate Retirement Billing Question, Client Billing — Other) */
  urgency: Maybe<ClientBillingUrgencyName>;
};

/** An account associated with a client billing request */
export type ClientBillingRequestAccount = {
  __typename?: 'ClientBillingRequestAccount';
  /** The associated account */
  account: Account;
  /** The Savvy ID of the join record. */
  id: Scalars['ID']['output'];
};

/** Client billing request — exactly one variant must be set (oneOf). */
export type ClientBillingRequestTaskInput =
  /** Billing hold variant */
  { billingHold: BillingHoldInput; clientBillingOther?: never; clientFeeRebate?: never; corporateRetirementBillingQuestion?: never; feeScheduleUpdate?: never; finalBill?: never; newFinancialPlanningClient?: never; }
  |  /** Client billing — other variant */
  { billingHold?: never; clientBillingOther: ClientBillingOtherInput; clientFeeRebate?: never; corporateRetirementBillingQuestion?: never; feeScheduleUpdate?: never; finalBill?: never; newFinancialPlanningClient?: never; }
  |  /** Client fee rebate variant */
  { billingHold?: never; clientBillingOther?: never; clientFeeRebate: ClientFeeRebateInput; corporateRetirementBillingQuestion?: never; feeScheduleUpdate?: never; finalBill?: never; newFinancialPlanningClient?: never; }
  |  /** Corporate retirement plan billing question variant */
  { billingHold?: never; clientBillingOther?: never; clientFeeRebate?: never; corporateRetirementBillingQuestion: CorporateRetirementBillingQuestionInput; feeScheduleUpdate?: never; finalBill?: never; newFinancialPlanningClient?: never; }
  |  /** Fee schedule update variant */
  { billingHold?: never; clientBillingOther?: never; clientFeeRebate?: never; corporateRetirementBillingQuestion?: never; feeScheduleUpdate: FeeScheduleUpdateInput; finalBill?: never; newFinancialPlanningClient?: never; }
  |  /** Final bill variant */
  { billingHold?: never; clientBillingOther?: never; clientFeeRebate?: never; corporateRetirementBillingQuestion?: never; feeScheduleUpdate?: never; finalBill: FinalBillInput; newFinancialPlanningClient?: never; }
  |  /** New financial planning client variant */
  { billingHold?: never; clientBillingOther?: never; clientFeeRebate?: never; corporateRetirementBillingQuestion?: never; feeScheduleUpdate?: never; finalBill?: never; newFinancialPlanningClient: NewFinancialPlanningClientInput; };

/** The variant of a client billing request */
export type ClientBillingRequestTypeName =
  /** billing_hold */
  | 'billing_hold'
  /** client_billing_other */
  | 'client_billing_other'
  /** client_fee_rebate */
  | 'client_fee_rebate'
  /** corporate_retirement_billing_question */
  | 'corporate_retirement_billing_question'
  /** fee_schedule_update */
  | 'fee_schedule_update'
  /** final_bill */
  | 'final_bill'
  /** new_financial_planning_client */
  | 'new_financial_planning_client';

/** Responsible party (Client Fee Rebate variant) */
export type ClientBillingResponsiblePartyName =
  /** advisor */
  | 'advisor'
  /** other */
  | 'other'
  /** savvy */
  | 'savvy';

/** Urgency of a client billing request */
export type ClientBillingUrgencyName =
  /** standard */
  | 'standard'
  /** urgent */
  | 'urgent';

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ClientEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Client>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Client>;
};

/** Client Fee Rebate variant: issue a fee rebate to a client */
export type ClientFeeRebateInput = {
  /** Affected accounts */
  accountIds: Array<Scalars['ID']['input']>;
  /** Notes for Ops */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the rebate */
  reason: Scalars['String']['input'];
  /** Rebate amount */
  rebateAmount: Scalars['Float']['input'];
  /** Rebate method — credit or direct_payment */
  rebateMethod: ClientBillingRebateMethodName;
  /** Responsible party — advisor, savvy, or other */
  responsibleParty: ClientBillingResponsiblePartyName;
};

/** One recurring income source belonging to a client */
export type ClientIncomeSource = {
  __typename?: 'ClientIncomeSource';
  /** The amount paid per `frequency` period. */
  amount: Scalars['BigDecimal']['output'];
  /** `amount` normalized to a yearly figure. */
  annualizedAmount: Scalars['BigDecimal']['output'];
  /** Employer street address line 1, for the employment types. */
  employerAddressLine1: Maybe<Scalars['String']['output']>;
  /** Employer street address line 2 (suite, unit). */
  employerAddressLine2: Maybe<Scalars['String']['output']>;
  /** Employer city. */
  employerCity: Maybe<Scalars['String']['output']>;
  /** Employer, for the employment types only. */
  employerName: Maybe<Scalars['String']['output']>;
  /** Employer ZIP code. */
  employerPostalCode: Maybe<Scalars['String']['output']>;
  /** Employer state, as a two-letter code. */
  employerState: Maybe<Scalars['String']['output']>;
  /** How often `amount` is paid. */
  frequency: IncomeFrequency;
  /** The Savvy ID of the income source. */
  id: Scalars['ID']['output'];
  /** The kind of income this row represents. */
  incomeSourceType: IncomeSourceType;
  /** Display order within the client's income sources. */
  position: Scalars['Int']['output'];
  /** Job title for the employment types; a short descriptor for rental/other. */
  title: Maybe<Scalars['String']['output']>;
};

export type ClientIncomeSourceInput = {
  /** Amount paid per frequency period */
  amount: Scalars['BigDecimal']['input'];
  /** Employer street address line 1 */
  employerAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Employer street address line 2 */
  employerAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Employer city */
  employerCity?: InputMaybe<Scalars['String']['input']>;
  /** Employer, for the employment types */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Employer ZIP code */
  employerPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Employer state, two-letter code */
  employerState?: InputMaybe<Scalars['String']['input']>;
  /** How often the amount is paid */
  frequency: IncomeFrequency;
  /** Existing row to update. Omit to create a new row. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of income */
  incomeSourceType: IncomeSourceType;
  /** Job title, or a descriptor for rental/other */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Client info change request data associated with a task */
export type ClientInfoChangeRequest = {
  __typename?: 'ClientInfoChangeRequest';
  /** Primary street address */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** Secondary street address */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** Box file ID for supporting documentation */
  boxFileId: Maybe<Scalars['String']['output']>;
  /** The type of change: change_name or change_address */
  changeType: Scalars['String']['output'];
  /** City */
  city: Maybe<Scalars['String']['output']>;
  /** New first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** The ID of the client info change request */
  id: Scalars['ID']['output'];
  /** New last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Primary mailing address */
  mailingAddressLine1: Maybe<Scalars['String']['output']>;
  /** Secondary mailing address */
  mailingAddressLine2: Maybe<Scalars['String']['output']>;
  /** Mailing city */
  mailingCity: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  mailingState: Maybe<Scalars['String']['output']>;
  /** Mailing ZIP code */
  mailingZipCode: Maybe<Scalars['String']['output']>;
  /** Reason for name change */
  reason: Maybe<Scalars['String']['output']>;
  /** State */
  state: Maybe<Scalars['String']['output']>;
  /** ZIP code */
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Input for client info change request task specific data */
export type ClientInfoChangeRequestInput = {
  /** Primary street address */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary street address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Box file ID for supporting documentation */
  boxFileId?: InputMaybe<Scalars['String']['input']>;
  /** Type of change: change_address or change_name */
  changeType: Scalars['String']['input'];
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** New first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** New last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Primary mailing address */
  mailingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary mailing address */
  mailingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Mailing city */
  mailingCity?: InputMaybe<Scalars['String']['input']>;
  /** Mailing state */
  mailingState?: InputMaybe<Scalars['String']['input']>;
  /** Mailing ZIP code */
  mailingZipCode?: InputMaybe<Scalars['String']['input']>;
  /** Reason for name change */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Client data entereted during intake flow. */
export type ClientIntakeData = {
  __typename?: 'ClientIntakeData';
  /** The Savvy ID of the client intake data. */
  id: Scalars['ID']['output'];
  /** JSON Blob of all the data entered by client. */
  intakeData: Scalars['JSON']['output'];
};

export type ClientOccupation =
  /** accounting_professional */
  | 'accounting_professional'
  /** business_owner */
  | 'business_owner'
  /** clerical */
  | 'clerical'
  /** consultant */
  | 'consultant'
  /** educator */
  | 'educator'
  /** executive */
  | 'executive'
  /** financial_services */
  | 'financial_services'
  /** foreign_government */
  | 'foreign_government'
  /** it_professional */
  | 'it_professional'
  /** legal_professional */
  | 'legal_professional'
  /** medical_professional */
  | 'medical_professional'
  /** military */
  | 'military'
  /** other */
  | 'other'
  /** other_professional */
  | 'other_professional'
  /** sales_marketing */
  | 'sales_marketing'
  /** trade_service */
  | 'trade_service'
  /** us_government */
  | 'us_government';

/** Onboarding context (primary/co clients, accounts, setup type) consumed synchronously by createRepaperEnvelope. */
export type ClientOnboardingInput = {
  /** Type of account setup (account_opening only for bulk repaper) */
  accountSetupType: AccountSetup;
  /** Destination accounts to confirm */
  accountsInfo: Array<AccountConfirmationAccountInfoInput>;
  /** Optional co-client information */
  coClient?: InputMaybe<AccountConfirmationClientInfoInput>;
  /** Destination custodian for the account confirmation task */
  destinationCustodian?: InputMaybe<DestinationCustodian>;
  /** Primary client information */
  primaryClient: AccountConfirmationClientInfoInput;
};

/**
 * The comparison index a client-portal return figure is measured against, and that
 * index's own return over the same window. Sourced from Orion; never derived from
 * the household's own numbers. Present only when Orion measured from the start
 * date asked for — it clamps to the index's own inception for windows that predate
 * it — so this is always safe to place beside a return over the same window.
 */
export type ClientPortalBenchmarkComparison = {
  __typename?: 'ClientPortalBenchmarkComparison';
  /** Window end (inclusive) the return covers. */
  endDate: Scalars['ISO8601Date']['output'];
  /**
   * The index's cumulative return at each reading across [startDate, endDate], for
   * charting it as a line. Null when not asked for, or when Orion served the
   * summary figures but no per-day readings — an absent series means "do not draw
   * this line", never "the line is flat at zero". Requesting it costs a wider
   * Orion response, so callers that only need the summary figures should leave it
   * out. The household's own line is a separate read,
   * clientPortalPortfolioReturnSeries, so an index Orion cannot serve does not
   * take it down too.
   */
  indexSeries: Maybe<Array<ClientPortalReturnSeriesPoint>>;
  /** The index's own name as Orion reports it, e.g. "Morningstar Moderate Target Risk TR USD". */
  label: Scalars['String']['output'];
  /**
   * The index's annualized time-weighted return over [startDate, endDate], as a
   * fraction; equals the cumulative return for windows of a year or less. Carries
   * no advisory fee, as with returnCumulative.
   */
  returnAnnualized: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The index's cumulative time-weighted return over [startDate, endDate], as a
   * fraction (0.05 = 5%). Null when Orion has no figure. An index carries no
   * advisory fee, so this is not net of fees the way a household TWR is — do not
   * present it as like-for-like outperformance.
   */
  returnCumulative: Maybe<Scalars['BigDecimal']['output']>;
  /** Window start (inclusive) the return covers. */
  startDate: Scalars['ISO8601Date']['output'];
};

/** A message from the advisor to the client that is shown in the client portal, and sent via email. */
export type ClientPortalMessage = {
  __typename?: 'ClientPortalMessage';
  coClientHasRead: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Maybe<Scalars['String']['output']>;
  primaryClientHasRead: Scalars['Boolean']['output'];
  status: ClientPortalMessageStatusName;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ClientPortalMessageStatusName =
  | 'active'
  | 'hidden';

/**
 * One reading on a client-portal return series: the cumulative time-weighted
 * return from the window start through this date. Readings are already cumulated,
 * so a chart plots them directly without compounding per-day factors itself.
 */
export type ClientPortalReturnSeriesPoint = {
  __typename?: 'ClientPortalReturnSeriesPoint';
  /** The date this reading measures through. */
  date: Scalars['ISO8601Date']['output'];
  /** Cumulative time-weighted return from the window start through `date`, as a fraction (0.05 = 5%). */
  returnCumulative: Scalars['BigDecimal']['output'];
};

/** An outside specialist who serves the viewer's household, as shown in the client portal. */
export type ClientProfessionalContact = {
  __typename?: 'ClientProfessionalContact';
  /** Contact email address. */
  email: Scalars['String']['output'];
  /** Name of the firm they work for. Null when no firm is linked. */
  firm: Maybe<Scalars['String']['output']>;
  /** Identifier of the relationship edge. */
  id: Scalars['ID']['output'];
  /** City and state of the linked firm. Null when no firm is linked or the firm has no city on record. */
  location: Maybe<Scalars['String']['output']>;
  /** The specialist's name. */
  name: Scalars['String']['output'];
  /** Contact phone number, falling back to their mobile. */
  phone: Maybe<Scalars['String']['output']>;
  /**
   * Their role toward the household. Null when the advisor has not recorded one,
   * in which case the card falls back to the specialty tags.
   */
  role: Maybe<ProfessionalRelationshipRole>;
  /**
   * When the relationship began, backing the "Working with you since {year}" line.
   * The advisor-entered referral date when there is one, otherwise the date the
   * relationship was recorded — the same rule the advisor Households served column already reads.
   */
  since: Scalars['ISO8601Date']['output'];
  /** Specialty tags for the category label on the card. */
  specialties: Array<CenterOfInfluenceRepSpecialty>;
};

export type ClientProfileInput = {
  /** 2 letter ISO country code for client citizenship */
  citizenship?: InputMaybe<Scalars['String']['input']>;
  /** The date of birth */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The date the client passed away, if applicable */
  dateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Client review presentation request data associated with a task */
export type ClientReviewPresentationRequest = {
  __typename?: 'ClientReviewPresentationRequest';
  /** The ID of the client review presentation request */
  id: Scalars['ID']['output'];
  /** The requested slides for the presentation */
  requestedSlides: Array<Scalars['String']['output']>;
};

/** Client role within a household */
export type ClientRole =
  /** Co-client/member */
  | 'MEMBER'
  /** Primary client */
  | 'PRIMARY';

/** Sortable fields for client lists */
export type ClientSortValues =
  | 'ANNUAL_REVENUE'
  | 'LAST_CONTACT_DATE'
  | 'LAST_MODIFIED_DATE'
  | 'NAME'
  | 'OUTSTANDING_SERVICE_CALENDAR_ITEMS_COUNT'
  | 'OWNER_NAME'
  | 'SAVVY_AUM';

export type ClientStage =
  | 'account_setup_flow'
  | 'fully_onboarded'
  | 'intake_flow'
  | 'onboarding_flow'
  | 'post_intake_waiting_area'
  | 'post_onboarding_waiting_area';

/** A client task email that a task-creation form can preview. */
export type ClientTaskEmailKind =
  | 'account_setup'
  | 'file_upload'
  | 'initial_intake_form'
  | 'pre_review_check_in';

/** Autogenerated input type of CloseEciRemediationSubtask */
export type CloseEciRemediationSubtaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The remediation Subtask to close. */
  subtaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloseEciRemediationSubtask. */
export type CloseEciRemediationSubtaskPayload = {
  __typename?: 'CloseEciRemediationSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the subtask was closed */
  success: Scalars['Boolean']['output'];
};

export type CoClientFromIntakeDataInput = {
  /** The primary address line 1 of the co-client */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The primary address line 2 of the co-client */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The annual gross income of the co-client */
  annualGrossIncome?: InputMaybe<Scalars['Int']['input']>;
  /** The city of the co-client */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the co-client */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The date of birth of the co-client (ISO format) */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the co-client */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The employer name of the co-client */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** The employment status of the co-client */
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the co-client */
  firstName: Scalars['String']['input'];
  /** The job title of the co-client */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the co-client */
  lastName: Scalars['String']['input'];
  /** The phone number of the co-client */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the co-client */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The retirement date of the co-client (ISO format) */
  retirementDate?: InputMaybe<Scalars['String']['input']>;
  /** The SSN of the co-client */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** The state of the co-client */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The university/college attended by the co-client */
  university?: InputMaybe<Scalars['String']['input']>;
};

/** An internal-team comment on a Savvy subject */
export type Comment = {
  __typename?: 'Comment';
  /** Files attached to this comment, in upload order. Empty on a tombstoned comment. */
  attachments: Array<CommentAttachment>;
  /** The user who wrote the comment. */
  author: User;
  /** Display label for the author's role, e.g. "Advisor". */
  authorRoleLabel: Scalars['String']['output'];
  /** Whether the current user may delete this comment. */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the current user may edit this comment. */
  canEdit: Scalars['Boolean']['output'];
  /** Plain text with @Full Name mention syntax. Empty string on a tombstoned comment. */
  content: Scalars['String']['output'];
  /** When the comment was posted. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the comment was tombstoned, null if live. */
  deletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the comment was last edited, null if never. */
  editedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Savvy ID of the comment. */
  id: Scalars['ID']['output'];
  /** Reactions grouped by emoji, most-reacted first. */
  reactions: Array<CommentReactionSummary>;
  /** Replies to this comment, oldest first. Always empty on a reply — threading is capped at one level. */
  replies: Array<Comment>;
  /** Optional one-line header for the thread. Only ever set on a thread's root comment, and null on a tombstoned one. */
  subject: Maybe<Scalars['String']['output']>;
  /** Whether this comment is newer than the current user's read watermark. Always false for their own comments. */
  unread: Scalars['Boolean']['output'];
};

/** A file attached to a comment */
export type CommentAttachment = {
  __typename?: 'CommentAttachment';
  /** The Box file id of the advisor-only copy, in the private Comment Attachments folder. */
  boxFileId: Scalars['String']['output'];
  /** File size in bytes, as reported by the browser at upload time. Null on rows written before it was recorded. */
  byteSize: Maybe<Scalars['Int']['output']>;
  /** Display filename, prefixed with the thread subject when the root comment has one. */
  filename: Scalars['String']['output'];
  /** The Savvy ID of the attachment. */
  id: Scalars['ID']['output'];
  /** Whether a copy of this file is also filed under the client-visible Additional Materials folder. */
  syncedToBox: Scalars['Boolean']['output'];
};

/** A file to attach to a comment, already uploaded to the private Comment Attachments folder by the client. */
export type CommentAttachmentInput = {
  /** The Box file id of the already-uploaded file. */
  boxFileId: Scalars['String']['input'];
  /** File size in bytes, for the size label on the attachment chip. */
  byteSize?: InputMaybe<Scalars['Int']['input']>;
  /** Display filename, prefixed with the thread subject when the root comment has one. */
  filename: Scalars['String']['input'];
};

/** A subject's comment thread, newest top-level comment first */
export type CommentFeed = {
  __typename?: 'CommentFeed';
  /**
   * Whether the current user may post on this subject. False for a viewer who can
   * read the thread but not write to it — a read_only_admin, or an archived
   * household — so the client can omit the composer rather than offer a write that
   * will be denied.
   */
  canComment: Scalars['Boolean']['output'];
  /** Top-level comments, newest first, each carrying its replies */
  comments: Array<Comment>;
  /**
   * True when older top-level comments exist beyond the fetch cap. The single
   * fetch is also the search index, so the UI has to say so rather than report "no
   * matches" for messages that exist.
   */
  truncated: Scalars['Boolean']['output'];
  /** Comments on this subject the current user has not seen, excluding their own */
  unreadCount: Scalars['Int']['output'];
};

/** A comment @mention candidate */
export type CommentMentionCandidate = {
  __typename?: 'CommentMentionCandidate';
  /** User full name, the form stored in comment bodies as @Full Name */
  fullName: Scalars['String']['output'];
  /** User id */
  id: Scalars['ID']['output'];
  /** User profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
  /** Display label for the candidate's role, matching Comment.authorRoleLabel */
  roleLabel: Scalars['String']['output'];
};

/** Aggregated reactions of one emoji on a comment */
export type CommentReactionSummary = {
  __typename?: 'CommentReactionSummary';
  /** How many users reacted with this emoji */
  count: Scalars['Int']['output'];
  /** The emoji reacted with */
  emoji: Scalars['String']['output'];
  /** Whether the current user is one of them */
  mine: Scalars['Boolean']['output'];
};

export type CommentSent = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task the comment was posted on. No comment body is sent. */
  taskId: Scalars['String']['input'];
  urlQueryParams: Scalars['JSON']['input'];
};

/** Comment indicator summary for a list row, scoped to the viewing user */
export type CommentSummary = {
  __typename?: 'CommentSummary';
  /**
   * One of none|inactive|active. Three states, not the task column's four: comment
   * mentions do raise Alert rows, but this indicator is watermark-driven so it
   * clears when the viewer opens the thread, where the task column's
   * active_mention persists until the alert is dismissed.
   */
  state: Scalars['String']['output'];
  /** Total comments on the subject */
  totalCount: Scalars['Int']['output'];
  /** Comments the viewer has not seen, excluding the viewer's own */
  unreadCount: Scalars['Int']['output'];
};

/** A company that a center of influence representative works for */
export type Company = {
  __typename?: 'Company';
  /** The first line of the company address */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** The second line of the company address */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** The professional contacts at this company that the current user can read */
  centerOfInfluenceReps: Array<CenterOfInfluenceRep>;
  /** The number of professional contacts linked to this company that the current user can read */
  centerOfInfluenceRepsCount: Scalars['Int']['output'];
  /** The city of the company address */
  city: Maybe<Scalars['String']['output']>;
  /** The country code of the company address */
  countryCode: Maybe<Scalars['String']['output']>;
  /** When the company was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the company */
  description: Maybe<Scalars['String']['output']>;
  /** The distinct households served by this company's readable contacts that the current user can read */
  householdsServed: Array<CompanyHouseholdServed>;
  /** The number of distinct households served by this company's readable contacts */
  householdsServedCount: Scalars['Int']['output'];
  /** The ID of the company */
  id: Scalars['ID']['output'];
  /** The URL of the company's logo */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** The name of the company */
  name: Scalars['String']['output'];
  /** The organization that owns this company */
  organization: Organization;
  /** The phone number of the company */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** The postal code of the company address */
  postalCode: Maybe<Scalars['String']['output']>;
  /** The number of referrals to this company's readable contacts */
  referralsCount: Scalars['Int']['output'];
  /** The distinct specialties present across every contact at this company, readable or not */
  specialties: Array<CenterOfInfluenceRepSpecialty>;
  /** The state of the company address */
  state: Maybe<Scalars['String']['output']>;
  /** The website of the company */
  website: Maybe<Scalars['String']['output']>;
};

/** One household served by a company, deduplicated across every readable contact at that company that serves it */
export type CompanyHouseholdServed = {
  __typename?: 'CompanyHouseholdServed';
  /** Every readable contact at this company serving this household, ordered by name */
  contacts: Array<CenterOfInfluenceRep>;
  /** The household served */
  household: Household;
  /** Stable key for the row, formatted "<companyId>:<householdId>" */
  id: Scalars['ID']['output'];
  /** The role recorded on the earliest serves edge; later edges may carry a different one */
  role: Maybe<ProfessionalRelationshipRole>;
  /** When the earliest serves edge to this household was created */
  since: Scalars['ISO8601DateTime']['output'];
};

/**
 * Backend-computed performance for an arbitrary comparison window. Resolves an
 * Orion quickDate (MTD/QTD/YTD/PriorMonth/...) or a startDate/endDate pair via
 * Orion /Reporting/Scope on demand.
 */
export type ComparisonPerformanceSummary = {
  __typename?: 'ComparisonPerformanceSummary';
  /** Portfolio market value at window start. */
  beginningMarketValue: Maybe<Value>;
  /** Total contributions in the window. */
  contributions: Maybe<Value>;
  /** Total distributions in the window. */
  distributions: Maybe<Value>;
  /** Total dividends and interest received in the window. */
  dividendsAndInterest: Maybe<Value>;
  /** The effective window end. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at window end. */
  endingMarketValue: Maybe<Value>;
  /** Net gains in the window (end - start - (contributions - distributions)). */
  netGains: Maybe<Value>;
  /** The effective window start. May differ from the requested start by a day if Orion snaps to the nearest valuation date. */
  startDate: Scalars['ISO8601Date']['output'];
  /** Inbound account transfers (Merge In + Journal In) folded into contributions, signed positive. Null when unavailable. */
  transfersIn: Maybe<Value>;
  /** Outbound account transfers (Merge Out + Journal Out) folded into distributions, signed negative. Null when unavailable. */
  transfersOut: Maybe<Value>;
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). Computed by Orion. */
  twr: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CompleteGoogleOAuthFlow */
export type CompleteGoogleOAuthFlowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The code obtained from the OAuth2 redirect */
  code: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteGoogleOAuthFlow. */
export type CompleteGoogleOAuthFlowPayload = {
  __typename?: 'CompleteGoogleOAuthFlowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

/** Autogenerated input type of CompleteSchwabOauthConnect */
export type CompleteSchwabOauthConnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The authorization code returned by the Schwab OAuth2 redirect */
  code: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteSchwabOauthConnect. */
export type CompleteSchwabOauthConnectPayload = {
  __typename?: 'CompleteSchwabOauthConnectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the Schwab OAuth connection was persisted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompleteServiceOccurrence */
export type CompleteServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  revision: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteServiceOccurrence. */
export type CompleteServiceOccurrencePayload = {
  __typename?: 'CompleteServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  occurrence: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ConfirmAccounts */
export type ConfirmAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged accounts to confirm. */
  stagedAccountIds: Array<Scalars['ID']['input']>;
  /** The staged household whose accounts are being confirmed. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmAccounts. */
export type ConfirmAccountsPayload = {
  __typename?: 'ConfirmAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** The staged household after confirmation. */
  stagedHousehold: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConfirmLinkedBankAccountImport */
export type ConfirmLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the LinkedBankAccountImport to confirm */
  id: Scalars['ID']['input'];
  /** Authorization IDs the operator chose to KEEP from the delete-review list; pruned from to_soft_delete before apply. */
  keepAuthorizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated return type of ConfirmLinkedBankAccountImport. */
export type ConfirmLinkedBankAccountImportPayload = {
  __typename?: 'ConfirmLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** The applied import record */
  linkedBankAccountImport: Maybe<LinkedBankAccountImport>;
};

/** Autogenerated input type of ConfirmPortfolio */
export type ConfirmPortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the portfolio to confirm */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmPortfolio. */
export type ConfirmPortfolioPayload = {
  __typename?: 'ConfirmPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors encountered while confirming the portfolio */
  errors: Array<Scalars['String']['output']>;
  /** The confirmed portfolio, if the update succeeds */
  portfolio: Maybe<Portfolio>;
};

export type Contact = {
  __typename?: 'Contact';
  dateOfBirth: Maybe<Scalars['ISO8601Date']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBeneficiary: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  relation: Maybe<Scalars['String']['output']>;
  ssn: Maybe<Scalars['String']['output']>;
};

/** Attributes for using a contact as an input */
export type ContactInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type ContactRelationTypeName =
  | 'beneficiary'
  | 'client_associate'
  | 'contact'
  | 'contingent_beneficiary'
  | 'family_member'
  | 'financial_offering_provider_contact'
  | 'trustee';

/** One parsed row from the CSA-uploaded contribution spreadsheet */
export type ContributionUploadRowInput = {
  /** Account number from the sheet, matched against Account#account_number */
  accountNumber: Scalars['String']['input'];
  /** Contribution amount from the sheet */
  contributionAmount: Scalars['Float']['input'];
  /** Whether the sheet lists a Model for this account */
  modelPresent: Scalars['Boolean']['input'];
  /** Client/household display name from the sheet, used only to disambiguate a duplicate account number */
  name: Scalars['String']['input'];
};

/** Per-row outcome of a contribution alert upload */
export type ContributionUploadRowResult = {
  __typename?: 'ContributionUploadRowResult';
  /** Account number from the sheet */
  accountNumber: Scalars['String']['output'];
  /** invest_cash / create_enrollment / no_action, when resolved */
  classification: Maybe<Scalars['String']['output']>;
  /** Why the row failed to resolve, when unresolved */
  error: Maybe<Scalars['String']['output']>;
  /** Client/household display name from the sheet */
  name: Scalars['String']['output'];
  /** Whether the row matched a real Account */
  resolved: Scalars['Boolean']['output'];
};

/** Corporate Retirement Plan Billing Question variant */
export type CorporateRetirementBillingQuestionInput = {
  /** Plan name */
  planName: Scalars['String']['input'];
  /** The billing question */
  question: Scalars['String']['input'];
  /** Recordkeeper */
  recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Urgency — standard or urgent */
  urgency: ClientBillingUrgencyName;
};

/** Corporate Retirement — Other variant */
export type CorporateRetirementOtherInput = {
  /** Description */
  description: Scalars['String']['input'];
  /** Plan name */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** Urgency — standard or urgent */
  urgency: CorporateRetirementPlanUrgencyName;
};

/** Analysis period (Prospecting Trend Analysis variant) */
export type CorporateRetirementPlanAnalysisPeriodName =
  /** custom */
  | 'custom'
  /** five_year */
  | 'five_year'
  /** prior_vs_current */
  | 'prior_vs_current'
  /** three_year */
  | 'three_year';

/** Onboarding type (Retirement Plan Onboarding variant) */
export type CorporateRetirementPlanOnboardingTypeName =
  /** new_plan */
  | 'new_plan'
  /** recordkeeper_change */
  | 'recordkeeper_change';

/** Corporate retirement plan request data associated with a task */
export type CorporateRetirementPlanRequest = {
  __typename?: 'CorporateRetirementPlanRequest';
  /** Analysis period (Prospecting Trend Analysis variant) */
  analysisPeriod: Maybe<CorporateRetirementPlanAnalysisPeriodName>;
  /** Current fee structure (Proposal Generator variant) */
  currentFeeStructure: Maybe<Scalars['String']['output']>;
  /** Current recordkeeper (Onboarding, Proposal Generator) */
  currentRecordkeeper: Maybe<Scalars['String']['output']>;
  /** Custom analysis period end (Prospecting Trend Analysis variant) */
  customPeriodEnd: Maybe<Scalars['ISO8601Date']['output']>;
  /** Custom analysis period start (Prospecting Trend Analysis variant) */
  customPeriodStart: Maybe<Scalars['ISO8601Date']['output']>;
  /** Description (Corporate Retirement — Other variant) */
  description: Maybe<Scalars['String']['output']>;
  /** Estimated plan AUM (Onboarding, Proposal Generator) */
  estimatedPlanAum: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Metrics to highlight (Prospecting Trend Analysis variant) */
  metricsToHighlight: Maybe<Scalars['String']['output']>;
  /** New recordkeeper (Onboarding variant) */
  newRecordkeeper: Maybe<Scalars['String']['output']>;
  /** Free-text notes (Retirement Plan Onboarding) */
  notes: Maybe<Scalars['String']['output']>;
  /** Number of participants (Onboarding, Proposal Generator) */
  numberOfParticipants: Maybe<Scalars['Int']['output']>;
  /** Onboarding type — new plan or recordkeeper change (Onboarding variant) */
  onboardingType: Maybe<CorporateRetirementPlanOnboardingTypeName>;
  /** Plan effective date (Onboarding variant) */
  planEffectiveDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Plan name (household name when a household is selected, else free text) */
  planName: Maybe<Scalars['String']['output']>;
  /** Plan sponsor contact email (Onboarding variant) */
  planSponsorContactEmail: Maybe<Scalars['String']['output']>;
  /** Plan sponsor contact name (Onboarding variant) */
  planSponsorContactName: Maybe<Scalars['String']['output']>;
  /** Plan sponsor meeting date (Plan Review variant) */
  planSponsorMeetingDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prospect meeting date (Proposal Generator variant) */
  prospectMeetingDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prospect / plan name (Proposal Generator variant) */
  prospectName: Maybe<Scalars['String']['output']>;
  /** Recordkeeper (Plan Review, Prospecting Trend Analysis) */
  recordkeeper: Maybe<Scalars['String']['output']>;
  /** Review kinds selected on the request (Plan Review variant) */
  requestReviewTypes: Array<CorporateRetirementPlanRequestReview>;
  /** The variant of the request (e.g. plan_review, retirement_plan_onboarding) */
  requestType: CorporateRetirementPlanRequestTypeName;
  /** Specific angles to address (Proposal Generator variant) */
  specificAngles: Maybe<Scalars['String']['output']>;
  /** Specific focus areas (Plan Review variant) */
  specificFocusAreas: Maybe<Scalars['String']['output']>;
  /** Target delivery date (Plan Review, Proposal Generator) */
  targetDeliveryDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Urgency (Corporate Retirement — Other variant) */
  urgency: Maybe<CorporateRetirementPlanUrgencyName>;
};

/** A review kind associated with a Plan Review request */
export type CorporateRetirementPlanRequestReview = {
  __typename?: 'CorporateRetirementPlanRequestReview';
  /** The Savvy ID of the join record. */
  id: Scalars['ID']['output'];
  /** The selected review kind */
  reviewType: CorporateRetirementPlanReviewTypeName;
};

/** Corporate retirement plan request — exactly one variant must be set (oneOf). */
export type CorporateRetirementPlanRequestTaskInput =
  /** Corporate Retirement — Other variant */
  { corporateRetirementOther: CorporateRetirementOtherInput; planReview?: never; prospectingTrendAnalysis?: never; retirementPlanOnboarding?: never; retirementPlanProposal?: never; }
  |  /** Plan Review variant */
  { corporateRetirementOther?: never; planReview: PlanReviewInput; prospectingTrendAnalysis?: never; retirementPlanOnboarding?: never; retirementPlanProposal?: never; }
  |  /** Prospecting Trend Analysis variant */
  { corporateRetirementOther?: never; planReview?: never; prospectingTrendAnalysis: ProspectingTrendAnalysisInput; retirementPlanOnboarding?: never; retirementPlanProposal?: never; }
  |  /** Retirement Plan Onboarding variant */
  { corporateRetirementOther?: never; planReview?: never; prospectingTrendAnalysis?: never; retirementPlanOnboarding: RetirementPlanOnboardingInput; retirementPlanProposal?: never; }
  |  /** Retirement Plan Proposal Generator variant */
  { corporateRetirementOther?: never; planReview?: never; prospectingTrendAnalysis?: never; retirementPlanOnboarding?: never; retirementPlanProposal: RetirementPlanProposalInput; };

/** The variant of a corporate retirement plan request */
export type CorporateRetirementPlanRequestTypeName =
  /** corporate_retirement_other */
  | 'corporate_retirement_other'
  /** plan_review */
  | 'plan_review'
  /** prospecting_trend_analysis */
  | 'prospecting_trend_analysis'
  /** retirement_plan_onboarding */
  | 'retirement_plan_onboarding'
  /** retirement_plan_proposal */
  | 'retirement_plan_proposal';

/** A review kind selected on a Plan Review request */
export type CorporateRetirementPlanReviewTypeName =
  /** fee_benchmarking */
  | 'fee_benchmarking'
  /** full_report */
  | 'full_report'
  /** investment_review */
  | 'investment_review'
  /** plan_health */
  | 'plan_health';

/** Urgency (Corporate Retirement — Other variant) */
export type CorporateRetirementPlanUrgencyName =
  /** standard */
  | 'standard'
  /** urgent */
  | 'urgent';

export type CostBasisLot = {
  __typename?: 'CostBasisLot';
  acquiredDate: Maybe<Scalars['ISO8601Date']['output']>;
  costBasisPerUnit: Maybe<Scalars['BigDecimal']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  gainLoss: Maybe<Scalars['BigDecimal']['output']>;
  gainLossPercent: Maybe<Scalars['BigDecimal']['output']>;
  holdingId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isLongTerm: Maybe<Scalars['Boolean']['output']>;
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  marketValueAsOfDate: Maybe<Scalars['ISO8601Date']['output']>;
  totalCostBasis: Maybe<Scalars['BigDecimal']['output']>;
  units: Maybe<Scalars['BigDecimal']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CreateAccountConfirmationTask */
export type CreateAccountConfirmationTaskInput = {
  /** Type of account setup */
  accountSetupType: AccountSetup;
  /** Account transfer information for the household */
  accountTransferData?: InputMaybe<Array<AccountTransferDatumInput>>;
  /** Type of account transfer */
  accountTransferType?: InputMaybe<AccountTransferTypeName>;
  /** Accounts information */
  accountsInfo: Array<AccountConfirmationAccountInfoInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional co-client information. Creates a new one if the household did not
   * have one. If not provided, the co-client will be deleted if it exists.
   */
  coClient?: InputMaybe<AccountConfirmationClientInfoInput>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Destination custodian */
  destinationCustodian?: InputMaybe<DestinationCustodian>;
  /** Serialized form state for wizard-based draft tasks; cleared on canonicalization */
  draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Household ID to which the task will be associated */
  householdId: Scalars['ID']['input'];
  /** If the client is subject to any restrictive covenants */
  nonSolicit: Scalars['Boolean']['input'];
  /** Primary client information */
  primaryClient: AccountConfirmationClientInfoInput;
  /** Save the task as a draft without applying account confirmation side effects */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional information for the task */
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send an email upon task creation */
  taskNotifyUponCreation: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CreateAccountConfirmationTask. */
export type CreateAccountConfirmationTaskPayload = {
  __typename?: 'CreateAccountConfirmationTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created Savvy task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateAccount */
export type CreateAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currentBalance: Scalars['BigDecimal']['input'];
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<AccountStatusName>;
  subtype?: InputMaybe<AccountSubtypeName>;
  type: AccountTypeName;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of CreateAccountMaintenanceTask */
export type CreateAccountMaintenanceTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the account maintenance request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The input for account maintenance task specific data */
  typeSpecificInput?: InputMaybe<AccountMaintenanceRequestTaskInput>;
};

/** Autogenerated return type of CreateAccountMaintenanceTask. */
export type CreateAccountMaintenanceTaskPayload = {
  __typename?: 'CreateAccountMaintenanceTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated return type of CreateAccount. */
export type CreateAccountPayload = {
  __typename?: 'CreateAccountPayload';
  account: Account;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAddress */
export type CreateAddressInput = {
  /** The first line of the address */
  addressLine1: Scalars['String']['input'];
  /** The second line of the address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of address */
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of address, usually two letters */
  countryCode: Scalars['String']['input'];
  /** The postal code */
  postalCode: Scalars['String']['input'];
  /** The state of address */
  state: Scalars['String']['input'];
  /** One of these types: primary, vacation, office, secondary, other */
  type: AddressTypeName;
  /** The ID of the user to create the address for */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAddress. */
export type CreateAddressPayload = {
  __typename?: 'CreateAddressPayload';
  /** Returns the created address */
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAdvisorGroup */
export type CreateAdvisorGroupInput = {
  /** User IDs of advisors to add as members */
  advisorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the advisor group */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAdvisorGroup. */
export type CreateAdvisorGroupPayload = {
  __typename?: 'CreateAdvisorGroupPayload';
  /** The created advisor group */
  advisorGroup: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAdvisor */
export type CreateAdvisorInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  calendlyLink?: InputMaybe<Scalars['String']['input']>;
  /** Whether the advisor is employed under Savvy's RIA (captive) rather than running their own book (owned). Defaults to owned. */
  captive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to create an Orion representative for assistant role */
  createAssistantOrionRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  dialpadUserId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fidelityMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Name for the advisor's personal organization. Defaults to their full name; must be unique. */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Dialpad phone number for the advisor */
  phoneNumber: Scalars['String']['input'];
  role?: InputMaybe<CreateAdvisorUserRole>;
  schwabMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAdvisor. */
export type CreateAdvisorPayload = {
  __typename?: 'CreateAdvisorPayload';
  advisor: Maybe<PublicAdvisor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAdvisorRequest */
export type CreateAdvisorRequestInput = {
  /** form filled out from feedback */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAdvisorRequest. */
export type CreateAdvisorRequestPayload = {
  __typename?: 'CreateAdvisorRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** success of the request */
  success: Scalars['Boolean']['output'];
};

/** User roles allowed for advisor creation */
export type CreateAdvisorUserRole =
  | 'advisor'
  | 'assistant'
  | 'csa';

/** Autogenerated input type of CreateAlert */
export type CreateAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  status: AlertStatusName;
  typeOf: AlertTypeName;
};

/** Autogenerated return type of CreateAlert. */
export type CreateAlertPayload = {
  __typename?: 'CreateAlertPayload';
  alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAlternativeInvestmentsPurchaseTask */
export type CreateAlternativeInvestmentsPurchaseTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the alternative investments purchase request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for alternative investments purchase task specific data */
  typeSpecificInput?: InputMaybe<AlternativeInvestmentsPurchase>;
};

/** Autogenerated return type of CreateAlternativeInvestmentsPurchaseTask. */
export type CreateAlternativeInvestmentsPurchaseTaskPayload = {
  __typename?: 'CreateAlternativeInvestmentsPurchaseTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateAsset */
export type CreateAssetInput = {
  assetClass: AssetClassName;
  assetSubclass?: InputMaybe<AssetSubclassName>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEquityCompanyName?: InputMaybe<Scalars['String']['input']>;
  companyEquityCompanyTicker?: InputMaybe<Scalars['String']['input']>;
  companyEquityCurrentPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityExercisePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityGrantType?: InputMaybe<Scalars['String']['input']>;
  companyEquitySharesIssued?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingCliff?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingDuration?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingRate?: InputMaybe<Scalars['String']['input']>;
  companyEquityVestingStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  currencyCode: Scalars['String']['input'];
  currentValue: Scalars['BigDecimal']['input'];
  description: Scalars['String']['input'];
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAsset. */
export type CreateAssetPayload = {
  __typename?: 'CreateAssetPayload';
  asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBulkImport */
export type CreateBulkImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64 file content (file-based importers only) */
  fileContent?: InputMaybe<Scalars['String']['input']>;
  /** File name (file-based importers only) */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The type of import to perform */
  importType: Scalars['String']['input'];
  /** The ID of the object being imported to */
  importableId: Scalars['ID']['input'];
  /** The type of object being imported */
  importableType: Scalars['String']['input'];
  /** Importer-specific options */
  options?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateBulkImport. */
export type CreateBulkImportPayload = {
  __typename?: 'CreateBulkImportPayload';
  /** The created bulk import */
  bulkImport: Maybe<BulkImport>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type CreateCenterOfInfluenceRepError =
  | 'email_already_exists';

/** Autogenerated input type of CreateCenterOfInfluenceRep */
export type CreateCenterOfInfluenceRepInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company this rep works for */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  feeRate?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerAdvisorProfileId: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  preferredContactMethod?: InputMaybe<CenterOfInfluenceRepPreferredContactMethod>;
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<Array<CenterOfInfluenceRepSpecialty>>;
};

/** Autogenerated return type of CreateCenterOfInfluenceRep. */
export type CreateCenterOfInfluenceRepPayload = {
  __typename?: 'CreateCenterOfInfluenceRepPayload';
  centerOfInfluenceRep: Maybe<CenterOfInfluenceRep>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  softError: Maybe<CreateCenterOfInfluenceRepError>;
};

/** Autogenerated input type of CreateClientBillingTask */
export type CreateClientBillingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the client billing request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for client billing task specific data */
  typeSpecificInput?: InputMaybe<ClientBillingRequestTaskInput>;
};

/** Autogenerated return type of CreateClientBillingTask. */
export type CreateClientBillingTaskPayload = {
  __typename?: 'CreateClientBillingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateClientInfoChangeTask */
export type CreateClientInfoChangeTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the client info change request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The input for client info change request task specific data */
  typeSpecificInput?: InputMaybe<ClientInfoChangeRequestInput>;
};

/** Autogenerated return type of CreateClientInfoChangeTask. */
export type CreateClientInfoChangeTaskPayload = {
  __typename?: 'CreateClientInfoChangeTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateClientOpportunity */
export type CreateClientOpportunityInput = {
  arr?: InputMaybe<Scalars['Int']['input']>;
  aum: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientProfileId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Next steps for opportunity */
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** Due date for next steps */
  nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** The Salesforce Account ID identifying the household this opportunity belongs to */
  salesforceAccountId: Scalars['String']['input'];
  /** Initial opportunity status */
  status: OpportunityStatus;
};

/** Autogenerated return type of CreateClientOpportunity. */
export type CreateClientOpportunityPayload = {
  __typename?: 'CreateClientOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  opportunity: Maybe<Opportunity>;
};

/** Autogenerated input type of CreateClientPortalMessage */
export type CreateClientPortalMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  salesforceAccountId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateClientPortalMessage. */
export type CreateClientPortalMessagePayload = {
  __typename?: 'CreateClientPortalMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientPortalMessage: Maybe<ClientPortalMessage>;
};

/** Autogenerated input type of CreateCoClientFromIntakeData */
export type CreateCoClientFromIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The co-client data from intake */
  coClientData: CoClientFromIntakeDataInput;
  /** The ID of the household */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCoClientFromIntakeData. */
export type CreateCoClientFromIntakeDataPayload = {
  __typename?: 'CreateCoClientFromIntakeDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created co-client profile */
  coClient: Maybe<Client>;
  /** Any errors that occurred */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCoClientUser */
export type CreateCoClientUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coManagerEmail: Scalars['String']['input'];
  primaryUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCoClientUser. */
export type CreateCoClientUserPayload = {
  __typename?: 'CreateCoClientUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of CreateCoiCallLog */
export type CreateCoiCallLogInput = {
  /** Center of influence rep identifier */
  centerOfInfluenceRepId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or content from the call */
  content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateCoiCallLog. */
export type CreateCoiCallLogPayload = {
  __typename?: 'CreateCoiCallLogPayload';
  /** The created call log */
  callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCoiMeeting */
export type CreateCoiMeetingInput = {
  /** Center of influence rep identifier */
  centerOfInfluenceRepId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the meeting in minutes (optional) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCoiMeeting. */
export type CreateCoiMeetingPayload = {
  __typename?: 'CreateCoiMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  meeting: Meeting;
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /**
   * Files to attach, already uploaded to Box by the client. Attaching to a comment
   * that already exists goes through addCommentAttachments.
   */
  attachments?: InputMaybe<Array<CommentAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Plain text, may contain @Full Name mentions */
  content: Scalars['String']['input'];
  /** Users to notify, validated against the subject's own mention candidates. @Full Name text in `content` is never parsed. */
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reply to this comment. Rejected when that comment is itself a reply — threading is capped at one level. */
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the subject being commented on */
  relationId: Scalars['ID']['input'];
  /** Subject type, e.g. "Household" */
  relationType: Scalars['String']['input'];
  /** Optional one-line thread header. Only valid on a thread root — rejected alongside parentCommentId. */
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  comment: Comment;
};

/** Autogenerated input type of CreateCompanyCallLog */
export type CreateCompanyCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier */
  companyId: Scalars['ID']['input'];
  /** Notes or content from the call */
  content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateCompanyCallLog. */
export type CreateCompanyCallLogPayload = {
  __typename?: 'CreateCompanyCallLogPayload';
  /** The created call log */
  callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Errors for creating a company */
export type CreateCompanyError =
  /** name_already_exists */
  | 'name_already_exists'
  /** validation_error */
  | 'validation_error';

/** Autogenerated input type of CreateCompany */
export type CreateCompanyInput = {
  /** The first line of the company address */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the company address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the company address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the company address */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The description of the company */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the company's logo */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company */
  name: Scalars['String']['input'];
  /** The organization that will own this company */
  organizationId: Scalars['ID']['input'];
  /** The phone number of the company */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the company address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state of the company address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The website of the company */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCompanyMeeting */
export type CreateCompanyMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier */
  companyId: Scalars['ID']['input'];
  /** Duration of the meeting in minutes (optional) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCompanyMeeting. */
export type CreateCompanyMeetingPayload = {
  __typename?: 'CreateCompanyMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  meeting: Meeting;
};

/** Autogenerated return type of CreateCompany. */
export type CreateCompanyPayload = {
  __typename?: 'CreateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created company */
  company: Maybe<Company>;
  /** Error encountered during creation */
  softError: Maybe<CreateCompanyError>;
};

/** Autogenerated input type of CreateConquestPlanFromData */
export type CreateConquestPlanFromDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend-built Conquest IntegrationPlanData payload (camelCase) */
  data: Scalars['JSON']['input'];
  /** Household ID to create the financial plan for */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateConquestPlanFromData. */
export type CreateConquestPlanFromDataPayload = {
  __typename?: 'CreateConquestPlanFromDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The Conquest advisor URL for the created plan */
  conquestPlanUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContactCallLog */
export type CreateContactCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household contact identifier */
  contactId: Scalars['ID']['input'];
  /** Notes or content from the call */
  content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateContactCallLog. */
export type CreateContactCallLogPayload = {
  __typename?: 'CreateContactCallLogPayload';
  /** The created call log */
  callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContact */
export type CreateContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateContactMeeting */
export type CreateContactMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household contact identifier */
  contactId: Scalars['ID']['input'];
  /** Duration of the meeting in minutes (optional) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateContactMeeting. */
export type CreateContactMeetingPayload = {
  __typename?: 'CreateContactMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  meeting: Meeting;
};

/** Autogenerated return type of CreateContact. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  contact: Maybe<Contact>;
};

/** Autogenerated input type of CreateContributionAlertsFromUpload */
export type CreateContributionAlertsFromUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Parsed rows from the uploaded contribution sheet */
  rows: Array<ContributionUploadRowInput>;
};

/** Autogenerated return type of CreateContributionAlertsFromUpload. */
export type CreateContributionAlertsFromUploadPayload = {
  __typename?: 'CreateContributionAlertsFromUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Per-row resolution/classification outcome, in the same order as the input rows */
  results: Array<ContributionUploadRowResult>;
};

/** Autogenerated input type of CreateCorporateRetirementPlanTask */
export type CreateCorporateRetirementPlanTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the corporate retirement plan request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for corporate retirement plan task specific data */
  typeSpecificInput?: InputMaybe<CorporateRetirementPlanRequestTaskInput>;
};

/** Autogenerated return type of CreateCorporateRetirementPlanTask. */
export type CreateCorporateRetirementPlanTaskPayload = {
  __typename?: 'CreateCorporateRetirementPlanTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateDataExport */
export type CreateDataExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Column IDs to include in the export */
  columnIds: Array<Scalars['String']['input']>;
  /** Column filters */
  filters?: InputMaybe<Array<ExportFilterInput>>;
  /** Export format: csv, json, xlsx */
  format: Scalars['String']['input'];
  /** Global search query */
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  /** The resource to export (e.g., "households") */
  resourceType: Scalars['String']['input'];
  /** Sort specifications */
  sorting?: InputMaybe<Array<ExportSortInput>>;
};

/** Autogenerated return type of CreateDataExport. */
export type CreateDataExportPayload = {
  __typename?: 'CreateDataExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created export record */
  dataExport: Maybe<DataExport>;
  /** Errors that occurred during the export */
  errors: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateDocumentSignatureForTask */
export type CreateDocumentSignatureForTaskInput = {
  /** A list of attestations that the user has agreed to prior to signing the document, usually by checking boxes. */
  attestations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
  /** The user input value we want to attach as the signature, usually the client's name. */
  value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDocumentSignatureForTask. */
export type CreateDocumentSignatureForTaskPayload = {
  __typename?: 'CreateDocumentSignatureForTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  signatureId: Scalars['ID']['output'];
  signedDocumentLink: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDocusignLpoaEnvelopeBulkUpload */
export type CreateDocusignLpoaEnvelopeBulkUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of documents to process */
  documents: Array<BulkUploadDocumentInput>;
  /** Name of the household */
  householdName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDocusignLpoaEnvelopeBulkUpload. */
export type CreateDocusignLpoaEnvelopeBulkUploadPayload = {
  __typename?: 'CreateDocusignLpoaEnvelopeBulkUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of errors if unsuccessful */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Non-critical error message */
  softError: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateEnrollment */
export type CreateEnrollmentInput = {
  /**
   * Admin-only: resolve the enrollment for this advisor instead of the caller, so
   * an admin can upload a book on the advisor's behalf. Omit for advisor self-serve.
   */
  advisorId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEnrollment. */
export type CreateEnrollmentPayload = {
  __typename?: 'CreateEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The active or newly created enrollment. */
  enrollment: AdvisorOnboardingEnrollment;
};

/** Autogenerated input type of CreateFeeScheduleForAdvisor */
export type CreateFeeScheduleForAdvisorInput = {
  /** The advisor profile ID; must match the household owner in organization mode */
  advisorProfileId: Scalars['ID']['input'];
  /** The type of amount for the fee schedule */
  amountType?: InputMaybe<FeeScheduleAmountTypes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the fee schedule */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of fee schedule */
  feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  flatFeeAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The household UUID */
  householdId?: InputMaybe<Scalars['String']['input']>;
  /** The minimum fee for the fee schedule */
  minimumFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The name of the fee schedule */
  name: Scalars['String']['input'];
  /** The tiers for the fee schedule */
  tiers?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateFeeScheduleForAdvisor. */
export type CreateFeeScheduleForAdvisorPayload = {
  __typename?: 'CreateFeeScheduleForAdvisorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  error: Maybe<Scalars['String']['output']>;
  /** The fee schedule */
  feeSchedule: Maybe<FeeSchedule>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFileUploadTask */
export type CreateFileUploadTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with active status */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateFileUploadTask. */
export type CreateFileUploadTaskPayload = {
  __typename?: 'CreateFileUploadTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateFinancialOffering */
export type CreateFinancialOfferingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional card description (<= 150 chars); placeholder used if omitted */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Offering name */
  name: Scalars['String']['input'];
  /** Offering type; determines which section the card appears in */
  type: FinancialOfferingTypeName;
};

/** Autogenerated return type of CreateFinancialOffering. */
export type CreateFinancialOfferingPayload = {
  __typename?: 'CreateFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created offering */
  financialOffering: Maybe<FinancialOffering>;
};

/** Autogenerated input type of CreateFinancialPlan */
export type CreateFinancialPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household ID to create the financial plan for */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFinancialPlan. */
export type CreateFinancialPlanPayload = {
  __typename?: 'CreateFinancialPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created financial plan */
  financialPlan: Maybe<FinancialPlan>;
};

/** Autogenerated input type of CreateGoal */
export type CreateGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  name: Scalars['String']['input'];
  percentFunded?: InputMaybe<Scalars['BigDecimal']['input']>;
  salesforceAccountId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  status: GoalStatusName;
  targetUsd?: InputMaybe<Scalars['BigDecimal']['input']>;
  type: GoalTypeName;
};

/** Autogenerated return type of CreateGoal. */
export type CreateGoalPayload = {
  __typename?: 'CreateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  goal: Goal;
};

/** Autogenerated input type of CreateLiability */
export type CreateLiabilityInput = {
  acquiredAt: Scalars['ISO8601Date']['input'];
  annualInterestPercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  assetId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  currentBalance: Scalars['BigDecimal']['input'];
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  originalBalance: Scalars['BigDecimal']['input'];
  providerName?: InputMaybe<Scalars['String']['input']>;
  timeToMaturity?: InputMaybe<Scalars['Int']['input']>;
  type: LiabilityTypeName;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateLiability. */
export type CreateLiabilityPayload = {
  __typename?: 'CreateLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  liability: Liability;
};

/** Autogenerated input type of CreateManualOnboardingTask */
export type CreateManualOnboardingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
};

/** Autogenerated return type of CreateManualOnboardingTask. */
export type CreateManualOnboardingTaskPayload = {
  __typename?: 'CreateManualOnboardingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task for the primary client */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created onboarding tasks */
  tasks: Maybe<Array<Task>>;
};

/** Autogenerated input type of CreateMeetingAgendaTemplate */
export type CreateMeetingAgendaTemplateInput = {
  /** The agenda outline */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When to use this template */
  description: Scalars['String']['input'];
  /** Defaults to meeting_agenda */
  templateType?: InputMaybe<MeetingAgendaTemplateType>;
  /** The template title */
  title: Scalars['String']['input'];
  /** private (creator only) or firm-wide */
  visibility: MeetingAgendaTemplateVisibility;
};

/** Autogenerated return type of CreateMeetingAgendaTemplate. */
export type CreateMeetingAgendaTemplatePayload = {
  __typename?: 'CreateMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created template */
  meetingAgendaTemplate: Maybe<MeetingAgendaTemplate>;
};

/** Autogenerated input type of CreateMeeting */
export type CreateMeetingInput = {
  /**
   * IDs of advisor profiles who attended the meeting; must be the household's
   * primary advisor or an advisor with edit access to the household
   */
  advisorAttendeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of client profiles who attended the meeting; at least one is required */
  attendeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the meeting in minutes (optional) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The Savvy household ID to associate the meeting with */
  householdId: Scalars['ID']['input'];
  /** Meeting notes or summary (optional) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMeeting. */
export type CreateMeetingPayload = {
  __typename?: 'CreateMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if the operation failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  meeting: Maybe<Meeting>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateMoneyMovementRequestTask */
export type CreateMoneyMovementRequestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the money movement request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for money movement request task specific data */
  typeSpecificInput: MoneyMovementRequestTaskInput;
};

/** Autogenerated return type of CreateMoneyMovementRequestTask. */
export type CreateMoneyMovementRequestTaskPayload = {
  __typename?: 'CreateMoneyMovementRequestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateNfsAuditExport */
export type CreateNfsAuditExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** "request" or "response" */
  direction?: InputMaybe<NfsAuditDirection>;
  /** "eap" or "esg" */
  gateway?: InputMaybe<NfsAuditGateway>;
  /** Fidelity operation name (e.g. AccountSetup) */
  operation?: InputMaybe<NfsAuditOperation>;
  /** Inclusive lower bound on recorded_at */
  recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Inclusive upper bound on recorded_at */
  recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Full-text match over body content and tracking ID */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Filter by exact Fidelity tracking ID */
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNfsAuditExport. */
export type CreateNfsAuditExportPayload = {
  __typename?: 'CreateNfsAuditExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created export record; poll status, then download */
  dataExport: Maybe<DataExport>;
  /** Errors that occurred creating the export */
  errors: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateNoteForContact */
export type CreateNoteForContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the household Contact to attach the Note to. */
  contactId: Scalars['ID']['input'];
  /** The Note body content (HTML produced by the editor). */
  content: Scalars['String']['input'];
  /** Optional title. Defaults to the contact's name, or "Contact note" when the contact has none. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForContact. */
export type CreateNoteForContactPayload = {
  __typename?: 'CreateNoteForContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created Contact-attached Note. */
  note: Note;
};

/** Autogenerated input type of CreateNoteForDialpadCall */
export type CreateNoteForDialpadCallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Note body content (HTML produced by the editor). */
  content: Scalars['String']['input'];
  /** The Savvy ID of the DialpadCall to attach the Note to. */
  dialpadCallId: Scalars['ID']['input'];
  /** Optional title. Defaults to "Call with <contact name>" (falling back to the number) when omitted. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForDialpadCall. */
export type CreateNoteForDialpadCallPayload = {
  __typename?: 'CreateNoteForDialpadCallPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created DialpadCall-attached Note. */
  note: Note;
};

/** Autogenerated input type of CreateNoteForEvent */
export type CreateNoteForEventInput = {
  /** The Savvy ID of the CalendarEvent to attach the Note to. */
  calendarEventId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Note body content (HTML produced by the editor). */
  content: Scalars['String']['input'];
  /** Optional title. Defaults to the CalendarEvent summary, or "Meeting note" when both are blank. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForEvent. */
export type CreateNoteForEventPayload = {
  __typename?: 'CreateNoteForEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created CalendarEvent-attached Note. */
  note: Note;
};

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /** Center of influence rep identifier. Mutually exclusive with householdIds/salesforceAccountId(s)/companyId. */
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier. Mutually exclusive with householdIds/salesforceAccountId(s)/centerOfInfluenceRepId. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  /**
   * Household identifiers (UUID, salesforce_account_id, or numeric primary key).
   * Mutually exclusive with
   * centerOfInfluenceRepId/companyId/salesforceAccountId(s).
   */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use householdIds instead */
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use householdIds instead */
  salesforceAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNote. */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  note: Note;
};

/** Autogenerated input type of CreateOnboardingTask */
export type CreateOnboardingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fee schedule ID */
  feeScheduleId: Scalars['ID']['input'];
  /** Whether to add calendly scheduling */
  hasCalendlyScheduling: Scalars['Boolean']['input'];
  /** Household ID to which the task will be associated */
  householdId: Scalars['String']['input'];
  /** Household ID to which the task will be associated */
  householdSavvyId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send reminders */
  sendReminders: Scalars['Boolean']['input'];
  /** Description of the task */
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateOnboardingTask. */
export type CreateOnboardingTaskPayload = {
  __typename?: 'CreateOnboardingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  error: Maybe<Scalars['String']['output']>;
  /** Salesforce task ID */
  salesforceTaskId: Maybe<Scalars['ID']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateOpenNewAccountTask */
export type CreateOpenNewAccountTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the open new account request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for open new account request task specific data; required when not saving as draft */
  typeSpecificInput?: InputMaybe<OpenNewAccountRequestInput>;
};

/** Autogenerated return type of CreateOpenNewAccountTask. */
export type CreateOpenNewAccountTaskPayload = {
  __typename?: 'CreateOpenNewAccountTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateOrUpdateCallLog */
export type CreateOrUpdateCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or content from the call */
  content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  date: Scalars['ISO8601DateTime']['input'];
  /** The Salesforce Account ID to identify the household */
  salesforceAccountId: Scalars['String']['input'];
  /** The Salesforce task ID associated with this call log */
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce Contact ID */
  whoId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOrUpdateCallLog. */
export type CreateOrUpdateCallLogPayload = {
  __typename?: 'CreateOrUpdateCallLogPayload';
  /** The created or updated CallLog */
  callLog: Maybe<CallLog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if the operation failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOrUpdateServiceCalendarSettings */
export type CreateOrUpdateServiceCalendarSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdSalesforceId: Scalars['String']['input'];
  updatedServiceCalendarSettingInputs: Array<UpdateServiceCalendarWithAdvisorSettingsInput>;
};

/** Autogenerated return type of CreateOrUpdateServiceCalendarSettings. */
export type CreateOrUpdateServiceCalendarSettingsPayload = {
  __typename?: 'CreateOrUpdateServiceCalendarSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceCalendarSettings: Array<ServiceCalendarSetting>;
};

export type CreateOrganizationBrandingInput = {
  /** Custom intro for onboarding emails */
  customOnboardingEmailIntro?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the organization */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the organization */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded logo image for Cloudinary upload */
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone number for the organization */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Short display name for the organization */
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show Calendly link in emails */
  showCalendlyLinkInEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CreateOrganizationBrandingRow */
export type CreateOrganizationBrandingRowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to create branding for */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateOrganizationBrandingRow. */
export type CreateOrganizationBrandingRowPayload = {
  __typename?: 'CreateOrganizationBrandingRowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The organization branding row */
  organizationBranding: Maybe<OrganizationBranding>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOrganizationHouseholdCategory */
export type CreateOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  hexColorCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrganizationHouseholdCategory. */
export type CreateOrganizationHouseholdCategoryPayload = {
  __typename?: 'CreateOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  organizationHouseholdCategory: Maybe<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of CreateOrganizationHouseholdTag */
export type CreateOrganizationHouseholdTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * For manual tags only: households to apply this tag to immediately. Ignored for
   * smart tags (which are evaluated by the rule).
   */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSmart?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationHouseholdCategoryId: Scalars['ID']['input'];
  ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateOrganizationHouseholdTag. */
export type CreateOrganizationHouseholdTagPayload = {
  __typename?: 'CreateOrganizationHouseholdTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  organizationHouseholdTag: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of CreateOrganization */
export type CreateOrganizationInput = {
  /** IDs of advisors to add to the organization */
  advisorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the organization */
  name: Scalars['String']['input'];
  /** Branding configuration for the organization */
  organizationBranding?: InputMaybe<CreateOrganizationBrandingInput>;
};

/** Autogenerated return type of CreateOrganization. */
export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  organization: Maybe<Organization>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOtherInvestmentTask */
export type CreateOtherInvestmentTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the other-investment request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The base task input */
  taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Other-investment specific data (task_type, account_ids) */
  typeSpecificInput?: InputMaybe<OtherInvestmentTaskInput>;
};

/** Autogenerated return type of CreateOtherInvestmentTask. */
export type CreateOtherInvestmentTaskPayload = {
  __typename?: 'CreateOtherInvestmentTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The ID of the created task */
  taskId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePlaidLinkToken */
export type CreatePlaidLinkTokenInput = {
  accountFilters?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<PlaidProduct>>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePlaidLinkToken. */
export type CreatePlaidLinkTokenPayload = {
  __typename?: 'CreatePlaidLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  linkToken: Scalars['String']['output'];
};

/** Autogenerated input type of CreatePlanFinancialSnapshot */
export type CreatePlanFinancialSnapshotInput = {
  /** Snapshot as-of date */
  asOfDate: Scalars['ISO8601Date']['input'];
  /** Plan assets stored as integer cents */
  assetsCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Number of participants */
  participantCount?: InputMaybe<Scalars['Int']['input']>;
  /** Quarter period (e.g. 2026-Q1) */
  period: Scalars['String']['input'];
  /** The plan to record a snapshot for */
  retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePlanFinancialSnapshot. */
export type CreatePlanFinancialSnapshotPayload = {
  __typename?: 'CreatePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created snapshot */
  planFinancialSnapshot: Maybe<PlanFinancialSnapshot>;
};

/** Autogenerated input type of CreateProfessionalRelationship */
export type CreateProfessionalRelationshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional per-relationship notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The month/year the referral happened (referred relationships only) */
  referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The nature of the relationship */
  relationshipType: ProfessionalRelationshipType;
  /** Category of contact for a RetirementPlan target */
  retirementPlanContactGroup?: InputMaybe<ProfessionalRelationshipContactGroup>;
  /** Active/inactive status of a contact for a RetirementPlan target */
  retirementPlanContactStatus?: InputMaybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role toward the household (serves relationships) */
  role?: InputMaybe<ProfessionalRelationshipRole>;
  /** The source record id */
  sourceId: Scalars['ID']['input'];
  /** Polymorphic source type: User or CenterOfInfluenceRep */
  sourceType: Scalars['String']['input'];
  /** The target record id */
  targetId: Scalars['ID']['input'];
  /** Polymorphic target type: Household, CenterOfInfluenceRep, or RetirementPlan */
  targetType: Scalars['String']['input'];
};

/** Autogenerated return type of CreateProfessionalRelationship. */
export type CreateProfessionalRelationshipPayload = {
  __typename?: 'CreateProfessionalRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created relationship edge */
  professionalRelationship: Maybe<ProfessionalRelationship>;
};

export type CreateProspectOpportunityError =
  | 'box_setup_error'
  | 'co_client_email_already_exists'
  | 'email_already_exists'
  | 'estimated_aum_required'
  | 'household_name_already_exists_for_existing_client'
  | 'household_stage_error'
  | 'prospect_already_exists_without_advisor'
  | 'salesforce_setup_error'
  | 'user_not_created';

/** Autogenerated input type of CreateProspectOpportunity */
export type CreateProspectOpportunityInput = {
  /** The ID of the AdvisorGroup that should own this prospect or null if none */
  advisorGroupAccess?: InputMaybe<Scalars['ID']['input']>;
  advisorLeadSource: Scalars['String']['input'];
  /**
   * Freeform detail describing an "Other" lead source (e.g. "Podcast interview").
   * Optional; ignored unless the lead source is "Other".
   */
  advisorLeadSourceDetail?: InputMaybe<Scalars['String']['input']>;
  advisorSalesforceId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coClientEmail?: InputMaybe<Scalars['String']['input']>;
  coClientFirstName?: InputMaybe<Scalars['String']['input']>;
  coClientLastName?: InputMaybe<Scalars['String']['input']>;
  coClientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  createViaAsyncWorker?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  /** Advisor estimated ARR */
  estimatedArr?: InputMaybe<Scalars['Int']['input']>;
  /** Advisor estimated AUM */
  estimatedAum: Scalars['Int']['input'];
  /** advisor estimated time of closing opportunity */
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Primary client first name */
  firstName: Scalars['String']['input'];
  householdName?: InputMaybe<Scalars['String']['input']>;
  /** Prospect opportunities will map to household stage not opportunity stage */
  householdStage: Scalars['String']['input'];
  /** Primary client last name */
  lastName: Scalars['String']['input'];
  /** Next steps an advisor will take for this opportunity */
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** advisor selected next steps due date */
  nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** The ID of the User that referred this prospect */
  referralSourceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateProspectOpportunity. */
export type CreateProspectOpportunityPayload = {
  __typename?: 'CreateProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created household; null when soft_error is set. Select `{ id name … }` for the fields you need. */
  household: Maybe<Household>;
  /** The ID of the created opportunity */
  opportunityId: Maybe<Scalars['ID']['output']>;
  /** The error that occurred if the opportunity was not created */
  softError: Maybe<CreateProspectOpportunityError>;
};

/** Autogenerated input type of CreateProviderAccount */
export type CreateProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coinbaseCode?: InputMaybe<Scalars['String']['input']>;
  coinbaseProApiKey?: InputMaybe<Scalars['String']['input']>;
  coinbaseProPassphrase?: InputMaybe<Scalars['String']['input']>;
  coinbaseProSecret?: InputMaybe<Scalars['String']['input']>;
  plaidPublicToken?: InputMaybe<Scalars['String']['input']>;
  source: ProviderAccountSource;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateProviderAccount. */
export type CreateProviderAccountPayload = {
  __typename?: 'CreateProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  providerAccount: ProviderAccount;
};

/** Autogenerated input type of CreateRepaperEnvelope */
export type CreateRepaperEnvelopeInput = {
  /** Account numbers grouped by signer role */
  accounts: AccountsInfoInput;
  /** Advisor whose master account number is required for the destination custodian */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Primary/co clients, accounts, account setup. Optional during HAWK-108→109 rollout. */
  clientOnboarding?: InputMaybe<ClientOnboardingInput>;
  /** Destination custodian */
  custodian: Custodian;
  /** Fee schedule attached to the household. Optional during HAWK-108→109 rollout. */
  feeScheduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Pre-filled app PDFs with signer-tab metadata */
  formDocuments: Array<FormDocumentInput>;
  /** Household to attach the envelope to */
  householdId: Scalars['ID']['input'];
  /** Whether the household is subject to restrictive covenants. Optional during HAWK-108→109 rollout. */
  nonSolicit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateRepaperEnvelope. */
export type CreateRepaperEnvelopePayload = {
  __typename?: 'CreateRepaperEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if enqueue failed (e.g. kill switch flipped, advisor missing master account). */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the envelope creation was successfully enqueued (not whether DocuSign accepted it — see polling). */
  success: Scalars['Boolean']['output'];
  /** Tracking ID for the enqueued envelope creation job — FE polls envelope status keyed by this. */
  trackingId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateReportSchedule */
export type CreateReportScheduleInput = {
  /** Defaults to true */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Upload generated PDFs to Box */
  deliverToBox: Scalars['Boolean']['input'];
  /** Publish generated reports to the client portal */
  deliverToPortal: Scalars['Boolean']['input'];
  /** Day of month (1-28) */
  deliveryDay: Scalars['Int']['input'];
  /** Month (1-12) for annual schedules; null uses January */
  deliveryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** monthly | quarterly | annually */
  frequency: Scalars['String']['input'];
  /**
   * Custom PDF filename pattern; supports {template_name}, {household_name},
   * {date}, {quarter}, {year}, {month}. Null uses the default pattern
   */
  pdfFilenamePattern?: InputMaybe<Scalars['String']['input']>;
  /** Require advisor approval before delivering generated reports; defaults to false */
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Saved template to automate */
  savedReportTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReportSchedule. */
export type CreateReportSchedulePayload = {
  __typename?: 'CreateReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created schedule */
  reportSchedule: ReportSchedule;
};

/** Autogenerated input type of CreateRetirementPlanContact */
export type CreateRetirementPlanContactInput = {
  /** Whether this contact is active on the plan (defaults to true) */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company this contact belongs to (free text) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** plan_sponsor | service_provider | internal_team | other */
  contactGroup: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Contact name */
  name: Scalars['String']['input'];
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Retirement plan to add the contact to */
  retirementPlanId: Scalars['ID']['input'];
  /** Job title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanContact. */
export type CreateRetirementPlanContactPayload = {
  __typename?: 'CreateRetirementPlanContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created contact */
  retirementPlanContact: Maybe<RetirementPlanContact>;
};

/** Autogenerated input type of CreateRetirementPlan */
export type CreateRetirementPlanInput = {
  /** Sponsor address(es) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Advisory effective date */
  advisoryEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisory type (e.g. 3(38)) */
  advisoryType?: InputMaybe<Scalars['String']['input']>;
  /** Annual fee stored as integer cents */
  annualFeeCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Billing method (e.g. 'Sponsor pays fee directly to Advisor') */
  billingMethod?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person who signed the contract */
  contractSignedBy?: InputMaybe<Scalars['String']['input']>;
  /** Date the contract was signed */
  contractSignedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Corporate structure (e.g. PLLC, LLC, S-Corp) */
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  /** Employer Identification Number */
  ein?: InputMaybe<Scalars['String']['input']>;
  /** Fee source */
  feeSource?: InputMaybe<Scalars['String']['input']>;
  /** Fee structure */
  feeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Fiduciary type (e.g. 3(21), 3(38)) */
  fiduciaryType?: InputMaybe<Scalars['String']['input']>;
  /** Optional linked household */
  householdId?: InputMaybe<Scalars['ID']['input']>;
  /** Plan name */
  name: Scalars['String']['input'];
  /** Organization this plan belongs to */
  organizationId: Scalars['ID']['input'];
  /** Plan owners/partners */
  owners?: InputMaybe<Scalars['String']['input']>;
  /** Parent company name */
  parentCompany?: InputMaybe<Scalars['String']['input']>;
  /** Plan inception date */
  planInceptionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Unique plan identifier (e.g. PLAN-0421) */
  planNumber: Scalars['String']['input'];
  /** Plan type (e.g. 401(k), 403(b)) */
  planType?: InputMaybe<Scalars['String']['input']>;
  /** Plan year end date */
  planYearEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prior employers whose service counts toward eligibility */
  predecessorService?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper name */
  recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Plan ID at recordkeeper */
  recordkeeperPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Service type */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** TPA name */
  tpa?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor's website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateRetirementPlanMilestone */
export type CreateRetirementPlanMilestoneInput = {
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Due date */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisor profile ID of the team member logging this */
  loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Milestone name */
  name: Scalars['String']['input'];
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Owner contact ID */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** The plan to add a milestone to */
  retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanMilestone. */
export type CreateRetirementPlanMilestonePayload = {
  __typename?: 'CreateRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created milestone */
  retirementPlanMilestone: Maybe<RetirementPlanMilestone>;
};

/** Autogenerated input type of CreateRetirementPlanNote */
export type CreateRetirementPlanNoteInput = {
  /** Author contact ID */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Note body text */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date the note applies to */
  notedOn: Scalars['ISO8601Date']['input'];
  /** The plan to add a note to */
  retirementPlanId: Scalars['ID']['input'];
  /** Optional note title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanNote. */
export type CreateRetirementPlanNotePayload = {
  __typename?: 'CreateRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created note */
  retirementPlanNote: Maybe<RetirementPlanNote>;
};

/** Autogenerated input type of CreateRetirementPlanParticipantLog */
export type CreateRetirementPlanParticipantLogInput = {
  /** Follow-up action item */
  actionItem?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type: education_meeting | enrollment_question | loan_question | distribution_request | follow_up | call | zoom | email */
  interactionType: Scalars['String']['input'];
  /** Advisor profile ID of the team member logging this */
  loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Date of the interaction */
  loggedOn: Scalars['ISO8601Date']['input'];
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Owner contact ID */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Participant email address */
  participantEmail?: InputMaybe<Scalars['String']['input']>;
  /** Participant full name */
  participantName: Scalars['String']['input'];
  /** Participant phone number */
  participantPhone?: InputMaybe<Scalars['String']['input']>;
  /** The plan to log the interaction on */
  retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanParticipantLog. */
export type CreateRetirementPlanParticipantLogPayload = {
  __typename?: 'CreateRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created log entry */
  retirementPlanParticipantLog: Maybe<RetirementPlanParticipantLog>;
};

/** Autogenerated return type of CreateRetirementPlan. */
export type CreateRetirementPlanPayload = {
  __typename?: 'CreateRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created retirement plan */
  retirementPlan: Maybe<RetirementPlan>;
};

/** Autogenerated input type of CreateRetirementPlanProjectFromTemplate */
export type CreateRetirementPlanProjectFromTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project name */
  name: Scalars['String']['input'];
  /** The plan to create the project on */
  retirementPlanId: Scalars['ID']['input'];
  /** Anchor date to compute each row's due date from the template's day offsets */
  startDate: Scalars['ISO8601Date']['input'];
  /** The template to instantiate, if any. Omit to create a blank project with no rows. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanProjectFromTemplate. */
export type CreateRetirementPlanProjectFromTemplatePayload = {
  __typename?: 'CreateRetirementPlanProjectFromTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created project */
  retirementPlanProject: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of CreateRetirementPlanProject */
export type CreateRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Project name */
  name: Scalars['String']['input'];
  /** The plan to add a project to */
  retirementPlanId: Scalars['ID']['input'];
  /** Project status */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanProject. */
export type CreateRetirementPlanProjectPayload = {
  __typename?: 'CreateRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created project */
  retirementPlanProject: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of CreateRetirementPlanProjectRow */
export type CreateRetirementPlanProjectRowInput = {
  /** Advisor from the plan organization assigned to this row */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this row is due */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Row name */
  name: Scalars['String']['input'];
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this row within the project */
  position: Scalars['Int']['input'];
  /** The organization responsible for this row */
  responsibleOrg?: InputMaybe<Scalars['String']['input']>;
  /** The project to add a row to */
  retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanProjectRow. */
export type CreateRetirementPlanProjectRowPayload = {
  __typename?: 'CreateRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created row */
  retirementPlanProjectRow: Maybe<RetirementPlanProjectRow>;
};

/** Autogenerated input type of CreateRetirementPlanProjectTemplate */
export type CreateRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  name: Scalars['String']['input'];
  /** Organization to create the template for (required for admins; defaults to the current advisor's organization) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Ordered steps for this template */
  steps?: InputMaybe<Array<RetirementPlanProjectTemplateStepInput>>;
};

/** Autogenerated return type of CreateRetirementPlanProjectTemplate. */
export type CreateRetirementPlanProjectTemplatePayload = {
  __typename?: 'CreateRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created template */
  retirementPlanProjectTemplate: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of CreateRiskQuestionnaire */
export type CreateRiskQuestionnaireInput = {
  answers: Array<RiskQuestionnaireAnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateRiskQuestionnaire. */
export type CreateRiskQuestionnairePayload = {
  __typename?: 'CreateRiskQuestionnairePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  riskQuestionnaire: Maybe<RiskQuestionnaire>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateServiceCalendarMeetingTypeTemplate */
export type CreateServiceCalendarMeetingTypeTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  sendAutomatedMeetingReminderUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  sendAutomatedMeetingReminderValue?: InputMaybe<Scalars['Int']['input']>;
  sendAutomatedMeetingUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  sendAutomatedMeetingValue?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarMeetingTypeTemplate. */
export type CreateServiceCalendarMeetingTypeTemplatePayload = {
  __typename?: 'CreateServiceCalendarMeetingTypeTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  serviceCalendarMeetingTypeTemplate: Maybe<ServiceCalendarMeetingTypeTemplate>;
};

/** Autogenerated input type of CreateServiceCalendarMeetings */
export type CreateServiceCalendarMeetingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  householdId: Scalars['Int']['input'];
  sendAutomatedMeetingReminderUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  sendAutomatedMeetingReminderValue?: InputMaybe<Scalars['Int']['input']>;
  sendAutomatedMeetingUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  sendAutomatedMeetingValue?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarMeetings. */
export type CreateServiceCalendarMeetingsPayload = {
  __typename?: 'CreateServiceCalendarMeetingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  serviceCalendarMeeting: Maybe<ServiceCalendarMeeting>;
};

/** Autogenerated input type of CreateServiceCalendarSettingTemplate */
export type CreateServiceCalendarSettingTemplateInput = {
  /** Whether the template is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Q1 flag */
  q1?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q2 flag */
  q2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q3 flag */
  q3?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q4 flag */
  q4?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the template is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template title */
  title: Scalars['String']['input'];
  /** Type of template */
  typeOf: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarSettingTemplate. */
export type CreateServiceCalendarSettingTemplatePayload = {
  __typename?: 'CreateServiceCalendarSettingTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  serviceCalendarSettingTemplate: Maybe<ServiceCalendarSettingTemplate>;
};

/** Autogenerated input type of CreateServiceCatalogItemGroup */
export type CreateServiceCatalogItemGroupInput = {
  /** Advisor group id (legacy scope) */
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes */
  attributes: ServiceCatalogItemGroupAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organization id (org scope) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateServiceCatalogItemGroup. */
export type CreateServiceCatalogItemGroupPayload = {
  __typename?: 'CreateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of CreateServiceCatalogItemHouseholdOverride */
export type CreateServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Is skipped */
  isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override date */
  overrideDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override dtstart */
  overrideDtstart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override email body */
  overrideEmailBody?: InputMaybe<Scalars['String']['input']>;
  /** Override email subject */
  overrideEmailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Override rrule */
  overrideRrule?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item household id */
  serviceCatalogItemHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateServiceCatalogItemHouseholdOverride. */
export type CreateServiceCatalogItemHouseholdOverridePayload = {
  __typename?: 'CreateServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item household override */
  serviceCatalogItemHouseholdOverride: Maybe<ServiceCatalogItemHouseholdOverride>;
};

/** Autogenerated input type of CreateServiceCatalogItem */
export type CreateServiceCatalogItemInput = {
  /** Owning advisor group ID (legacy scope) */
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Item attributes */
  attributes: ServiceCatalogItemAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Owning organization ID (org scope) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateServiceCatalogItem. */
export type CreateServiceCatalogItemPayload = {
  __typename?: 'CreateServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created item */
  serviceCatalogItem: Maybe<ServiceCatalogItem>;
};

/** Autogenerated input type of CreateSimpleTask */
export type CreateSimpleTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with active status */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of task (simple tasks only) */
  type: SimpleTaskTypeName;
};

/** Autogenerated return type of CreateSimpleTask. */
export type CreateSimpleTaskPayload = {
  __typename?: 'CreateSimpleTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateSubtask */
export type CreateSubtaskInput = {
  /** When the parent is a recurring task, also add this sub-task to the template and every future occurrence. */
  applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user to assign the sub-task to. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the sub-task. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** When the sub-task is due. */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /**
   * Calendar days before the parent task due date. When the parent is recurring,
   * each occurrence re-computes the sub-task due date.
   */
  dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the sub-task. */
  name: Scalars['String']['input'];
  /** The status of the sub-task. Defaults to "todo". */
  status?: InputMaybe<SubtaskStatus>;
  /** The Savvy ID of the parent task. */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSubtask. */
export type CreateSubtaskPayload = {
  __typename?: 'CreateSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created sub-task. */
  subtask: Maybe<Subtask>;
};

/** Autogenerated input type of CreateSwimRequestTask */
export type CreateSwimRequestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the SWIM request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for swim request task specific data */
  typeSpecificInput: SwimRequestTaskInput;
};

/** Autogenerated return type of CreateSwimRequestTask. */
export type CreateSwimRequestTaskPayload = {
  __typename?: 'CreateSwimRequestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The ID of the task */
  taskId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateTaskActivityEvent */
export type CreateTaskActivityEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTaskActivityEvent. */
export type CreateTaskActivityEventPayload = {
  __typename?: 'CreateTaskActivityEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskActivity: TaskActivity;
};

/** Autogenerated input type of CreateTaskComment */
export type CreateTaskCommentInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  salesforceAccountId: Scalars['String']['input'];
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateTaskComment. */
export type CreateTaskCommentPayload = {
  __typename?: 'CreateTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  comment: TaskActivity;
};

/** Autogenerated input type of CreateTaskFromEmail */
export type CreateTaskFromEmailInput = {
  /** ID of the assignee for the task */
  assigneeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the email message whose thread the task is linked to */
  emailMessageId: Scalars['ID']['input'];
  /** ID of the household to create a task for */
  householdId: Scalars['ID']['input'];
  /** The advisor-typed name for the task */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTaskFromEmail. */
export type CreateTaskFromEmailPayload = {
  __typename?: 'CreateTaskFromEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateTaskFromNote */
export type CreateTaskFromNoteInput = {
  /** ID of the assignee for the task */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household to create a task for */
  householdId: Scalars['ID']['input'];
  /** ID of the note to create a task from */
  noteId: Scalars['ID']['input'];
  /** Deprecated, unused */
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTaskFromNote. */
export type CreateTaskFromNotePayload = {
  __typename?: 'CreateTaskFromNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Input that will be applied to the task object in tasks table */
export type CreateTaskInput = {
  /** Whether to include the calendly scheduling step in a client task */
  addCalendlyScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user that the task is assigned to */
  assigneeId: Scalars['ID']['input'];
  /** The link to the box folder that the task is associated with */
  boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The client user the task is for; omitted for client-less (prospect) tasks such
   * as Corporate Retirement Plan prospect variants
   */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** Who receives the task-completed client email; falls back to every household account holder when unset */
  completedEmailRecipients?: InputMaybe<TaskCompletedEmailRecipients>;
  /** The description of the task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Serialized form state for wizard-based draft tasks; cleared on canonicalization */
  draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether to notify the client when the task is created */
  notifyClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send a client email reminder when the task is due */
  sendClientEmailReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to email the client when the task completes; falls back to the organization default when unset */
  sendEmailWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send a SMS reminder when the task is created */
  smsClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The status of the task. Default: Todo */
  status: TaskStatus;
  /** The title of the task */
  title: Scalars['String']['input'];
};

/** Optional metadata overrides for task creation */
export type CreateTaskMetadataInput = {
  /** Override default assignee */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Override default box folder */
  boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Override default description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Override default due date */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Override default status (Todo) */
  status?: InputMaybe<TaskStatus>;
  /** Override default title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateTaskWorkItem */
export type CreateTaskWorkItemInput = {
  /** The user that the task is assigned to — pass null to create unassigned */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Box folder ID for file attachments */
  boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of client profiles to associate with the work item */
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Serialized form state, so reopening a draft restores the form it was saved from. Ignored unless saving as draft */
  draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** When the task is due */
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** IDs of households to associate with the work item */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Additional instructions for the task */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** The name of the task */
  name: Scalars['String']['input'];
  /** Task priority level. Defaults to NULL if not provided */
  priority?: InputMaybe<TaskPriority>;
  /** Optional recurrence configuration */
  recurrence?: InputMaybe<RecurrenceInput>;
  /** When present, link the created task to this retirement plan project step in the same transaction */
  retirementPlanProjectRowId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with todo status */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional list of subtasks to create atomically with the task. */
  subtasks?: InputMaybe<Array<SubtaskCreationInput>>;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Task type. Defaults to General — the advisor-facing catch-all. Pass Other for Ops queue tasks. */
  typeOf?: InputMaybe<TaskTypeName>;
};

/** Autogenerated return type of CreateTaskWorkItem. */
export type CreateTaskWorkItemPayload = {
  __typename?: 'CreateTaskWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateTaskWorkflowTemplate */
export type CreateTaskWorkflowTemplateInput = {
  /** Editors for a team workflow. Empty means everyone in the group can edit. */
  acl?: InputMaybe<Array<WorkflowTemplateAclInput>>;
  /** Advisor to assign the workflow to. Must be an advisor in your firm. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Workflow description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow name */
  name: Scalars['String']['input'];
  /** The Savvy template this workflow is cloned from, if any. */
  parentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule anchor: launch_date or due_date */
  schedule: TaskWorkflowTemplateSchedule;
  /** Subtasks, each with an optional day offset */
  subtasks?: InputMaybe<Array<SubtaskCreationInput>>;
  /** Visibility: private or firm */
  visibility: TaskWorkflowTemplateVisibility;
};

/** Autogenerated return type of CreateTaskWorkflowTemplate. */
export type CreateTaskWorkflowTemplatePayload = {
  __typename?: 'CreateTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created workflow */
  taskWorkflowTemplate: Maybe<TaskWorkflowTemplate>;
};

/** Autogenerated input type of CreateTaxEnrollment */
export type CreateTaxEnrollmentInput = {
  /** Client who will pay the price */
  billableClientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enum type about enrollment */
  enrollmentType: TaxEnrollmentTypeName;
  /** Whether this is a late filing */
  lateFiling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client who will be filed jointly, will not be charged */
  nonBillableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** Price to charge billable client */
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Tax year for this enrollment */
  taxYear: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateTaxEnrollment. */
export type CreateTaxEnrollmentPayload = {
  __typename?: 'CreateTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  error: Maybe<Scalars['String']['output']>;
  /** success boolean */
  success: Scalars['Boolean']['output'];
  /** object */
  taxEnrollment: Maybe<TaxEnrollment>;
};

/** Autogenerated input type of CreateTeam */
export type CreateTeamInput = {
  /** User IDs of same-firm advisors to seed as members (the creator is always added) */
  advisorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team name, unique within the firm */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTeam. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  /** The created team */
  advisorGroup: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTradingTask */
export type CreateTradingTaskInput = {
  /** The client for whom the task is being created */
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the trading request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional task metadata overrides */
  taskMetadata?: InputMaybe<CreateTaskMetadataInput>;
  /** Trading-specific information */
  tradingRequestInput: TradingRequestInput;
};

/** Autogenerated return type of CreateTradingTask. */
export type CreateTradingTaskPayload = {
  __typename?: 'CreateTradingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the task */
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateTransferOfAssetsTask */
export type CreateTransferOfAssetsTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the transfer of assets request */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  taskInput: CreateTaskInput;
  /** The input for transfer of assets task specific data */
  typeSpecificInput?: InputMaybe<TransferOfAssetsInput>;
};

/** Autogenerated return type of CreateTransferOfAssetsTask. */
export type CreateTransferOfAssetsTaskPayload = {
  __typename?: 'CreateTransferOfAssetsTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created task */
  task: Maybe<Task>;
};

/** Autogenerated input type of CreateUserContact */
export type CreateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in YYYY-MM-DD format */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Email of the contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the contact is a beneficiary */
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  relation?: InputMaybe<BeneficiaryRelationship>;
  /** SSN of the contact */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserContact. */
export type CreateUserContactPayload = {
  __typename?: 'CreateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  contact: Maybe<Contact>;
};

/** Autogenerated input type of CreateUserForHouseholdMember */
export type CreateUserForHouseholdMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for the new user. Must be unique. */
  email: Scalars['String']['input'];
  /** First name. */
  firstName: Scalars['String']['input'];
  /**
   * The household the new user will be added to. Used only for authorization — the
   * caller must be the household's advisor. No ClientProfile#household link is created.
   */
  householdId: Scalars['ID']['input'];
  /** Last name. */
  lastName: Scalars['String']['input'];
  /** Optional phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUserForHouseholdMember. */
export type CreateUserForHouseholdMemberPayload = {
  __typename?: 'CreateUserForHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /**
   * The created User, returned as a lookup-minimal type (the advisor has no
   * HouseholdMembership edge to this user yet, so Models::User read-auth would fail).
   */
  user: UserLookupResult;
};

/** Details about a specific CSA review condition */
export type CsaReviewCondition = {
  __typename?: 'CsaReviewCondition';
  /** Accounts that triggered this condition */
  accounts: Array<AccountSummary>;
  /** Account limits that were exceeded */
  limitsExceeded: Array<AccountLimitExceeded>;
  /** Whether this condition is triggered */
  triggered: Scalars['Boolean']['output'];
  /** Unsupported accounts that triggered this condition */
  unsupportedAccounts: Array<UnsupportedAccount>;
};

/** CSA review conditions for a household */
export type CsaReviewConditions = {
  __typename?: 'CsaReviewConditions';
  /** Multiple source accounts condition details */
  multipleSourceAccounts: CsaReviewCondition;
  /** Mutual funds condition details */
  mutualFunds: CsaReviewCondition;
  /** Whether CSA review is needed */
  needsReview: Scalars['Boolean']['output'];
  /** Transfer account limits condition details */
  transferAccountLimits: CsaReviewCondition;
  /** Unsupported account types condition details */
  unsupportedAccountTypes: CsaReviewCondition;
};

/** The current user */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** Announcement configs that are currently active and not dismissed by the current user */
  activeAnnouncements: Array<AnnouncementConfig>;
  /** The current advisor's own directory entry for self-edit; null until first save (or for non-advisors). */
  advisorDirectory: Maybe<AdvisorDirectoryEntry>;
  salesforceAccessToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

/** Name of the custodian */
export type Custodian =
  /** fidelity */
  | 'fidelity'
  /** schwab */
  | 'schwab';

/** Custodian for an Add Advisor To Existing Account request */
export type CustodianName =
  /** fidelity */
  | 'fidelity'
  /** goldman_sachs */
  | 'goldman_sachs'
  /** schwab */
  | 'schwab';

/** A data export job */
export type DataExport = {
  __typename?: 'DataExport';
  /** When the export was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** URL to download the exported file */
  downloadUrl: Maybe<Scalars['String']['output']>;
  /** Error message if export failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** When the export expires and will be deleted */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the exported file */
  filename: Scalars['String']['output'];
  /** Export format (csv, json, xlsx) */
  format: Scalars['String']['output'];
  /** Unique identifier for the export */
  id: Scalars['ID']['output'];
  /** The type of resource being exported */
  resourceType: Scalars['String']['output'];
  /** Number of rows exported */
  rowCount: Maybe<Scalars['Int']['output']>;
  /** Export status (pending, processing, completed, failed) */
  status: Scalars['String']['output'];
};

/** Date/datetime/time filter with operator and value(s) */
export type DateFilterInput = {
  /** End date/time for between operator */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Date filter operator */
  operator: DateFilterOperatorEnum;
  /** Start date/time for between operator */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Filter value (not required for isEmpty operator) */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Date/datetime/time filter operators */
export type DateFilterOperatorEnum =
  /** After the date */
  | 'AFTER'
  /** Before the date */
  | 'BEFORE'
  /** Between start and end dates */
  | 'BETWEEN'
  /** Equal to date */
  | 'EQ'
  /** Field is empty or null */
  | 'IS_EMPTY';

/** An arbitrary date range with ISO-8601 (YYYY-MM-DD) start and end dates, both inclusive. */
export type DateRangeInput = {
  /** Window end (inclusive). */
  endDate: Scalars['ISO8601Date']['input'];
  /** Window start (inclusive). */
  startDate: Scalars['ISO8601Date']['input'];
};

export type DcaAccountConfig = {
  __typename?: 'DcaAccountConfig';
  accountName: Maybe<Scalars['String']['output']>;
  dcaAmount: Maybe<Scalars['String']['output']>;
  dcaCadenceEvery: Maybe<Scalars['String']['output']>;
  dcaCadenceUnit: Maybe<Scalars['String']['output']>;
};

/** Per-account DCA configuration for a swim request */
export type DcaAccountConfigInput = {
  /** Account name, matching the included accounts string format */
  accountName: Scalars['String']['input'];
  /** Per-installment DCA amount */
  dcaAmount?: InputMaybe<Scalars['String']['input']>;
  /** The N in "every N units" */
  dcaCadenceEvery?: InputMaybe<Scalars['String']['input']>;
  /** Cadence unit: days, weeks, months, or years */
  dcaCadenceUnit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAddress */
export type DeleteAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAddress. */
export type DeleteAddressPayload = {
  __typename?: 'DeleteAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAsset */
export type DeleteAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAsset. */
export type DeleteAssetPayload = {
  __typename?: 'DeleteAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCallLog */
export type DeleteCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the CallLog to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCallLog. */
export type DeleteCallLogPayload = {
  __typename?: 'DeleteCallLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/** Errors for deleting a center of influence representative */
export type DeleteCenterOfInfluenceRepError =
  /** not_found */
  | 'not_found';

/** Autogenerated input type of DeleteCenterOfInfluenceRep */
export type DeleteCenterOfInfluenceRepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the center of influence rep to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCenterOfInfluenceRep. */
export type DeleteCenterOfInfluenceRepPayload = {
  __typename?: 'DeleteCenterOfInfluenceRepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error encountered during deletion */
  softError: Maybe<DeleteCenterOfInfluenceRepError>;
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteClientOpportunity */
export type DeleteClientOpportunityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteClientOpportunity. */
export type DeleteClientOpportunityPayload = {
  __typename?: 'DeleteClientOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCoClient */
export type DeleteCoClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCoClient. */
export type DeleteCoClientPayload = {
  __typename?: 'DeleteCoClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Returns successful deletion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCommentAttachment */
export type DeleteCommentAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The attachment to delete */
  commentAttachmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCommentAttachment. */
export type DeleteCommentAttachmentPayload = {
  __typename?: 'DeleteCommentAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the delete succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteComment */
export type DeleteCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to delete */
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The tombstoned comment when it had replies, null when the row was removed outright */
  comment: Maybe<Comment>;
  /** Whether the delete succeeded */
  success: Scalars['Boolean']['output'];
};

/** Errors for deleting a company */
export type DeleteCompanyError =
  /** not_found */
  | 'not_found';

/** Autogenerated input type of DeleteCompany */
export type DeleteCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the company to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCompany. */
export type DeleteCompanyPayload = {
  __typename?: 'DeleteCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error encountered during deletion */
  softError: Maybe<DeleteCompanyError>;
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteDialpadCall */
export type DeleteDialpadCallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DialpadCall to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDialpadCall. */
export type DeleteDialpadCallPayload = {
  __typename?: 'DeleteDialpadCallPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFamilyMember */
export type DeleteFamilyMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFamilyMember. */
export type DeleteFamilyMemberPayload = {
  __typename?: 'DeleteFamilyMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFeeSchedule */
export type DeleteFeeScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the fee schedule to delete */
  feeScheduleId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFeeSchedule. */
export type DeleteFeeSchedulePayload = {
  __typename?: 'DeleteFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if deleting was not successful */
  error: Maybe<Scalars['String']['output']>;
  /** The fee schedule that was deleted */
  feeSchedule: Maybe<FeeSchedule>;
  /** Whether the fee schedule was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFinancialOffering */
export type DeleteFinancialOfferingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Offering id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFinancialOffering. */
export type DeleteFinancialOfferingPayload = {
  __typename?: 'DeleteFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The deleted offering */
  financialOffering: Maybe<FinancialOffering>;
};

/** Autogenerated input type of DeleteFinancialPlanReportFile */
export type DeleteFinancialPlanReportFileInput = {
  /** Box file ID of the financial plan report to delete */
  boxFileId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household ID that owns the financial plan report */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFinancialPlanReportFile. */
export type DeleteFinancialPlanReportFilePayload = {
  __typename?: 'DeleteFinancialPlanReportFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the file was deleted successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteGoal */
export type DeleteGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteGoal. */
export type DeleteGoalPayload = {
  __typename?: 'DeleteGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteHousehold */
export type DeleteHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to set as inactive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteHousehold. */
export type DeleteHouseholdPayload = {
  __typename?: 'DeleteHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household was set to inactive */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteLiability */
export type DeleteLiabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLiability. */
export type DeleteLiabilityPayload = {
  __typename?: 'DeleteLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMeetingAgendaTemplate */
export type DeleteMeetingAgendaTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The template ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMeetingAgendaTemplate. */
export type DeleteMeetingAgendaTemplatePayload = {
  __typename?: 'DeleteMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the template was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteNote */
export type DeleteNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteNote. */
export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteOrganizationHouseholdCategory */
export type DeleteOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOrganizationHouseholdCategory. */
export type DeleteOrganizationHouseholdCategoryPayload = {
  __typename?: 'DeleteOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePlanFinancialSnapshot */
export type DeletePlanFinancialSnapshotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePlanFinancialSnapshot. */
export type DeletePlanFinancialSnapshotPayload = {
  __typename?: 'DeletePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted snapshot */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteProfessionalRelationship */
export type DeleteProfessionalRelationshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The relationship edge id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProfessionalRelationship. */
export type DeleteProfessionalRelationshipPayload = {
  __typename?: 'DeleteProfessionalRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The id of the removed relationship edge */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteProspectOpportunity */
export type DeleteProspectOpportunityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProspectOpportunity. */
export type DeleteProspectOpportunityPayload = {
  __typename?: 'DeleteProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProviderAccount */
export type DeleteProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProviderAccount. */
export type DeleteProviderAccountPayload = {
  __typename?: 'DeleteProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteReportSchedule */
export type DeleteReportScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schedule to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportSchedule. */
export type DeleteReportSchedulePayload = {
  __typename?: 'DeleteReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted schedule */
  deletedId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeleteReportTemplate */
export type DeleteReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the template to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportTemplate. */
export type DeleteReportTemplatePayload = {
  __typename?: 'DeleteReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted template */
  deletedId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeleteRetirementPlanContact */
export type DeleteRetirementPlanContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Contact ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanContact. */
export type DeleteRetirementPlanContactPayload = {
  __typename?: 'DeleteRetirementPlanContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted contact */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlan */
export type DeleteRetirementPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Retirement plan ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteRetirementPlanMilestone */
export type DeleteRetirementPlanMilestoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Milestone ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanMilestone. */
export type DeleteRetirementPlanMilestonePayload = {
  __typename?: 'DeleteRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted milestone */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanNote */
export type DeleteRetirementPlanNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Note ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanNote. */
export type DeleteRetirementPlanNotePayload = {
  __typename?: 'DeleteRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted note */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanParticipantLog */
export type DeleteRetirementPlanParticipantLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Log entry ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanParticipantLog. */
export type DeleteRetirementPlanParticipantLogPayload = {
  __typename?: 'DeleteRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted log entry */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of DeleteRetirementPlan. */
export type DeleteRetirementPlanPayload = {
  __typename?: 'DeleteRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted retirement plan */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProject */
export type DeleteRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProject. */
export type DeleteRetirementPlanProjectPayload = {
  __typename?: 'DeleteRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted project */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProjectRow */
export type DeleteRetirementPlanProjectRowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Row ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProjectRow. */
export type DeleteRetirementPlanProjectRowPayload = {
  __typename?: 'DeleteRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted row */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProjectTemplate */
export type DeleteRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProjectTemplate. */
export type DeleteRetirementPlanProjectTemplatePayload = {
  __typename?: 'DeleteRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted template */
  deletedId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteServiceCalendarMeeting */
export type DeleteServiceCalendarMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the meeting to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarMeeting. */
export type DeleteServiceCalendarMeetingPayload = {
  __typename?: 'DeleteServiceCalendarMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCalendarMeetingTypeTemplate */
export type DeleteServiceCalendarMeetingTypeTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the meeting type template to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarMeetingTypeTemplate. */
export type DeleteServiceCalendarMeetingTypeTemplatePayload = {
  __typename?: 'DeleteServiceCalendarMeetingTypeTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCalendarSettingTemplate */
export type DeleteServiceCalendarSettingTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the template to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarSettingTemplate. */
export type DeleteServiceCalendarSettingTemplatePayload = {
  __typename?: 'DeleteServiceCalendarSettingTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCatalogItemHouseholdOverride */
export type DeleteServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCatalogItemHouseholdOverride. */
export type DeleteServiceCatalogItemHouseholdOverridePayload = {
  __typename?: 'DeleteServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Deleted override id */
  deletedOverrideId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteSubtask */
export type DeleteSubtaskInput = {
  /** When the parent is a recurring task, also delete the matching sub-task from the template and every future occurrence. */
  applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the sub-task to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSubtask. */
export type DeleteSubtaskPayload = {
  __typename?: 'DeleteSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted sub-task. */
  deletedId: Scalars['ID']['output'];
  /** The parent task. Returned so clients can refresh derived counts. Its status is NOT mutated by this mutation. */
  task: Maybe<Task>;
};

/** Autogenerated input type of DeleteTaskComment */
export type DeleteTaskCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskActivityId: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTaskComment. */
export type DeleteTaskCommentPayload = {
  __typename?: 'DeleteTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTask */
export type DeleteTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Only meaningful when the deleted task is the main (template) task of a
   * recurring series. When true, also remove the future-dated open occurrences
   * (instance_date > the template's instance_date). When false/omitted, the
   * recurrence is ended and the siblings are unlinked but kept as standalone
   * tasks. Ignored for non-template occurrences (which delete only that task) and
   * for non-recurring tasks.
   */
  removeUpcomingOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Salesforce task ID */
  salesforceTaskId: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTask. */
export type DeleteTaskPayload = {
  __typename?: 'DeleteTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTaskWorkflowTemplate */
export type DeleteTaskWorkflowTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The workflow task to delete */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTaskWorkflowTemplate. */
export type DeleteTaskWorkflowTemplatePayload = {
  __typename?: 'DeleteTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted workflow task */
  deletedTaskId: Maybe<Scalars['ID']['output']>;
  /** Whether the deletion succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTaxEnrollment */
export type DeleteTaxEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of Tax Enrollment to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTaxEnrollment. */
export type DeleteTaxEnrollmentPayload = {
  __typename?: 'DeleteTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserContact */
export type DeleteUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the contact to delete */
  id: Scalars['ID']['input'];
  /** The ID of the user whose contact to delete */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserContact. */
export type DeleteUserContactPayload = {
  __typename?: 'DeleteUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the contact was deleted successfully */
  success: Scalars['Boolean']['output'];
};

export type DemoProspectResetterError =
  | 'reset_failed';

/** Shape of the demo book to build. Every field is optional; omitted fields keep the seed defaults. */
export type DemoReseedOptions = {
  /** Top of the per-household AUM range, in dollars. */
  householdAumHigh?: InputMaybe<Scalars['Int']['input']>;
  /** Bottom of the per-household AUM range, in dollars. */
  householdAumLow?: InputMaybe<Scalars['Int']['input']>;
  /** How many households to build. */
  households?: InputMaybe<Scalars['Int']['input']>;
  /** Share of the won book on Savvy's managed platform, 0 to 100. */
  managedPercent?: InputMaybe<Scalars['Int']['input']>;
  /** SOLO for a single advisor, GROUP for a team. */
  practiceType?: InputMaybe<DemoReseedPractice>;
  /** Upper bound on tasks per serviced household. */
  tasksPerHousehold?: InputMaybe<Scalars['Int']['input']>;
};

/** Whether the demo advisor practises alone or as part of a team. */
export type DemoReseedPractice =
  /** A team, so operational work routes to a client service associate. */
  | 'GROUP'
  /** One advisor holding the whole book. */
  | 'SOLO';

/** One wipe-and-reload of a demo environment. */
export type DemoReseedRun = {
  __typename?: 'DemoReseedRun';
  /** Digest of the seeded content, present once the reseed succeeds. Identical parameters give an identical digest. */
  contentDigest: Maybe<Scalars['String']['output']>;
  /** The demo database this reseed targeted. */
  databaseName: Scalars['String']['output'];
  /** Why the reseed failed, when it did. */
  error: Maybe<Scalars['String']['output']>;
  /** When the reseed stopped, whether it succeeded or failed. */
  finishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Poll demoReseedRun with this id for progress. */
  id: Scalars['ID']['output'];
  /** When the reseed began. */
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the reseed is running, has succeeded, or failed. */
  status: DemoReseedRunStatus;
};

/** Lifecycle of a demo environment reseed. */
export type DemoReseedRunStatus =
  /** failed */
  | 'FAILED'
  /** queued */
  | 'QUEUED'
  /** running */
  | 'RUNNING'
  /** succeeded */
  | 'SUCCEEDED';

/** Destination custodian for an account confirmation task */
export type DestinationCustodian =
  /** fidelity_iws */
  | 'fidelity_iws'
  /** goldman_sachs */
  | 'goldman_sachs'
  /** schwab */
  | 'schwab';

export type Detail = {
  __typename?: 'Detail';
  /** Short description for a link/resource row */
  description: Maybe<Scalars['String']['output']>;
  /** Cloudinary icon image for a link/resource row */
  iconUrl: Maybe<Scalars['String']['output']>;
  /** Savvy ID */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Order for quick links */
  quickLinkOrder: Maybe<Scalars['Int']['output']>;
  /** Type of the key fact */
  type: Maybe<DetailTypeName>;
  value: Maybe<Scalars['String']['output']>;
};

export type DetailTypeName =
  | 'fee'
  | 'key_fact'
  | 'link';

/** A Dialpad phone call */
export type DialpadCall = {
  __typename?: 'DialpadCall';
  /** Record created timestamp. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When call ended. */
  dateEnded: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When call started. */
  dateStarted: Scalars['ISO8601DateTime']['output'];
  /** Call direction (inbound/outbound). */
  direction: Scalars['String']['output'];
  /** Duration of the call in seconds. */
  duration: Scalars['Int']['output'];
  /** External phone number (E.164 format). */
  externalNumber: Scalars['String']['output'];
  /** The Savvy ID of the call. */
  id: Scalars['ID']['output'];
  /** Internal phone number (E.164 format). */
  internalNumber: Scalars['String']['output'];
  /**
   * The Note attached to this DialpadCall, scoped to the requesting household
   * context. Null when no Note exists, the per-advisor flag is off, the request
   * lacks household scope, the call is on the legacy track (dialpad_calls.notes
   * populated), or the requester is not authorized to read the Note per NotePolicy.
   */
  note: Maybe<Note>;
  /** Notes associated with the call (legacy column, populated by SF backfill). */
  notes: Maybe<Scalars['String']['output']>;
  /** Call state. */
  state: Scalars['String']['output'];
  /** Call transcription text. */
  transcriptionText: Maybe<Scalars['String']['output']>;
  /** Link to voicemail recording if available. */
  voicemailShareLink: Maybe<Scalars['String']['output']>;
  /** Whether the call was recorded. */
  wasRecorded: Scalars['Boolean']['output'];
};

export type DialpadCallApi = {
  __typename?: 'DialpadCallApi';
  callId: Scalars['String']['output'];
  /** The contact that was spoken to */
  contact: Maybe<DialpadContact>;
  dateEnded: Maybe<Scalars['String']['output']>;
  dateStarted: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['Float']['output']>;
  /** The Savvy Dialpad user on the call */
  target: Maybe<DialpadContact>;
};

/** Transcript of a Dialpad phone call. */
export type DialpadCallTranscript = {
  __typename?: 'DialpadCallTranscript';
  /**
   * The other party's name from the advisor's Dialpad contact book; null when
   * Dialpad supplied none or the DialpadCall row is missing.
   */
  contactName: Maybe<Scalars['String']['output']>;
  /** The Dialpad-side call identifier (used by the dialpadTranscript(dialpadCallId) resolver to fetch the body). */
  dialpadCallId: Scalars['String']['output'];
  /** The Savvy ID of the matching DialpadCall record. */
  dialpadCallRecordId: Maybe<Scalars['ID']['output']>;
  /** Whether the advisor placed or received the call; null when the DialpadCall row is missing. */
  direction: Maybe<DialpadDirection>;
  /** Connected talk time in whole minutes; null for a call that never connected or whose DialpadCall row is missing. */
  durationMinutes: Maybe<Scalars['Int']['output']>;
  /** A bounded plain-text excerpt from the start of the transcript, skipping Dialpad "moment" markers. */
  excerpt: Maybe<Scalars['String']['output']>;
  /** The other party's number in E.164; null when the DialpadCall row is missing. */
  externalNumber: Maybe<Scalars['String']['output']>;
  /** When the transcript was fetched from Dialpad. */
  fetchedAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the household this transcript belongs to. */
  householdName: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the transcript record. */
  id: Scalars['ID']['output'];
  /** When the call started, falling back to when the row was created. */
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Transcript ingestion status: available or unavailable. */
  status: Scalars['String']['output'];
};

/** Person involved in a Dialpad call. */
export type DialpadContact = {
  __typename?: 'DialpadContact';
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  /** Name of the contact */
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  /** Type of contact */
  type: Maybe<Scalars['String']['output']>;
};

export type DialpadDirection =
  /** inbound */
  | 'inbound'
  /** outbound */
  | 'outbound';

export type DialpadEvent = {
  __typename?: 'DialpadEvent';
  /** Dialpad sms tex or calls transcription_text */
  content: Maybe<Scalars['String']['output']>;
  /** Timestamp when the event was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Timestamp when the call ended/sms sent */
  dateEnded: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** External Dialpad service identifier for this event */
  dialpadId: Scalars['BigInt']['output'];
  /** Direction of the call (inbound or outbound) will be our source of truth instead of is_inbound */
  direction: Maybe<DialpadDirection>;
  /** Duration of the call in seconds */
  duration: Maybe<Scalars['Int']['output']>;
  /** Type of dialpad event: call_connected, call_missed, or sms_delivered */
  event: Scalars['String']['output'];
  /** Internal system identifier for the dialpad event */
  id: Scalars['ID']['output'];
  /** Indicates whether the call was inbound or outbound */
  isInbound: Scalars['Boolean']['output'];
};

/** A Dialpad SMS message */
export type DialpadSms = {
  __typename?: 'DialpadSms';
  /** Message content. */
  content: Maybe<Scalars['String']['output']>;
  /** Record created timestamp. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Dialpad message ID. */
  dialpadMessageId: Scalars['BigInt']['output'];
  /** Message direction (inbound/outbound). */
  direction: Scalars['String']['output'];
  /** From phone number (E.164 format). */
  fromNumber: Scalars['String']['output'];
  /** The Savvy ID of the SMS. */
  id: Scalars['ID']['output'];
  /** Whether this is an MMS message. */
  isMms: Scalars['Boolean']['output'];
  /** Message delivery result. */
  messageDeliveryResult: Maybe<Scalars['String']['output']>;
  /** Message delivery status. */
  messageStatus: Maybe<Scalars['String']['output']>;
  /** When message was sent. */
  sentAt: Scalars['ISO8601DateTime']['output'];
  /** To phone number (E.164 format). */
  toNumber: Scalars['String']['output'];
};

/** A group of Dialpad SMS messages */
export type DialpadSmsGroup = {
  __typename?: 'DialpadSmsGroup';
  /** When the conversation started. */
  conversationStartedAt: Scalars['ISO8601DateTime']['output'];
  /** Record created timestamp. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the SMS. */
  id: Scalars['ID']['output'];
  /** The messages in the group. */
  messages: Array<DialpadSms>;
};

export type DialpadTranscript = {
  __typename?: 'DialpadTranscript';
  callId: Scalars['String']['output'];
  /** The lines of the call transcript */
  lines: Maybe<Array<DialpadTranscriptLine>>;
};

/** Transcript line of a Dialpad call. */
export type DialpadTranscriptLine = {
  __typename?: 'DialpadTranscriptLine';
  contactId: Maybe<Scalars['String']['output']>;
  /** Content of the speech */
  content: Maybe<Scalars['String']['output']>;
  /** Name of the speaker */
  name: Maybe<Scalars['String']['output']>;
  /** Time of the transcript */
  time: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Type of transcript line: transcript or moment */
  type: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

/** A digital story/presentation for a Conquest financial plan */
export type DigitalStory = {
  __typename?: 'DigitalStory';
  /** When the story was created */
  createTime: Scalars['ISO8601DateTime']['output'];
  /** The story description */
  description: Scalars['String']['output'];
  /** The Conquest story ID */
  id: Scalars['ID']['output'];
  /** Story metadata (e.g. category) */
  metadata: Maybe<Scalars['JSON']['output']>;
  /** The story name */
  name: Scalars['String']['output'];
  /** The Conquest plan ID */
  planId: Scalars['Int']['output'];
  /** The story status */
  status: DigitalStoryStatus;
  /** When the story was last updated */
  updateTime: Scalars['ISO8601DateTime']['output'];
  /** The advisor URL for the story in Conquest */
  url: Scalars['String']['output'];
};

/** Status of a Conquest digital story/presentation */
export type DigitalStoryStatus =
  /** DRAFT */
  | 'DRAFT'
  /** PUBLISHED */
  | 'PUBLISHED';

/** Detail for the director / 10%+ shareholder disclosure (required when the answer is yes). */
export type DirectorOrShareholderDetailInput = {
  /** Name of the public company */
  companyName: Scalars['String']['input'];
  /** Family member's name (if the affiliation is a household member) */
  familyMemberName?: InputMaybe<Scalars['String']['input']>;
  /** Role/title at the company (e.g. Director, Officer) */
  roleTitle: Scalars['String']['input'];
  /** Ticker symbol of the public company */
  tickerSymbol: Scalars['String']['input'];
};

/** A canonical spoken-language tag from the advisor directory taxonomy. */
export type DirectoryLanguage = {
  __typename?: 'DirectoryLanguage';
  /** Stable identifier. */
  id: Scalars['ID']['output'];
  /** Canonical slug (lower_snake_case). */
  key: Scalars['String']['output'];
  /** Human-readable label. */
  label: Scalars['String']['output'];
};

/** The directory-facing profile fields for an advisor. Whitelisted — never exposes intake_answers or source. */
export type DirectoryProfile = {
  __typename?: 'DirectoryProfile';
  /** Whether the advisor is listed in the directory. False means the advisor deactivated their listing. */
  active: Scalars['Boolean']['output'];
  /** Coarse computed band, e.g. "$50M–$100M". Null unless opted in. */
  aumBand: Maybe<Scalars['String']['output']>;
  /** Whether the advisor opted to show their AUM band. */
  aumShareOptIn: Scalars['Boolean']['output'];
  /** City. */
  city: Maybe<Scalars['String']['output']>;
  /** Designations, e.g. ["CFP®", "CLU®"]. */
  credentials: Array<Scalars['String']['output']>;
  /** Canonical spoken-language tags. */
  languages: Array<DirectoryLanguage>;
  /** LinkedIn profile URL (stored only, never fetched server-side). */
  linkedinUrl: Maybe<Scalars['String']['output']>;
  /** Prior firm. */
  priorFirm: Maybe<Scalars['String']['output']>;
  /** Canonical specialty tags. */
  specialties: Array<DirectorySpecialty>;
  /** State. */
  state: Maybe<Scalars['String']['output']>;
  /** Years of experience. */
  yearsExperience: Maybe<Scalars['Int']['output']>;
};

/** Savvy Intelligence draft: a suggested bio + specialties from intake answers. */
export type DirectoryProfileDraft = {
  __typename?: 'DirectoryProfileDraft';
  /** Drafted bio; null on failure. */
  bio: Maybe<Scalars['String']['output']>;
  /** Canonical credentials extracted from the intake answers. */
  credentials: Array<Scalars['String']['output']>;
  /** False when generation failed; the FE falls back to manual entry. */
  generated: Scalars['Boolean']['output'];
  /** Suggested canonical specialties. */
  specialties: Array<DirectorySpecialty>;
};

/** A canonical advisor specialty tag from the directory taxonomy. */
export type DirectorySpecialty = {
  __typename?: 'DirectorySpecialty';
  /** Stable identifier. */
  id: Scalars['ID']['output'];
  /** Canonical slug (lower_snake_case). */
  key: Scalars['String']['output'];
  /** Human-readable label. */
  label: Scalars['String']['output'];
};

/** An advisor group / team affiliation surfaced in the directory. */
export type DirectoryTeam = {
  __typename?: 'DirectoryTeam';
  /** The advisor group id. */
  id: Scalars['ID']['output'];
  /** Team display name. */
  name: Scalars['String']['output'];
};

/** Directory-safe subset of an advisor User. No book-level fields. */
export type DirectoryUser = {
  __typename?: 'DirectoryUser';
  /** Contact email. */
  email: Scalars['String']['output'];
  /** First name. */
  firstName: Maybe<Scalars['String']['output']>;
  /** Display name (first + last). */
  fullName: Scalars['String']['output'];
  /** The advisor user id. */
  id: Scalars['ID']['output'];
  /** Last name. */
  lastName: Maybe<Scalars['String']['output']>;
  /** Contact phone in E.164. */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Photo URL; null falls back to Avatar initials. */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DismissAllInboxAlerts */
export type DismissAllInboxAlertsInput = {
  /** Optional alert-type filter, matching the inbox query */
  alertTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional primary-advisor filter, matching the inbox query */
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The advisor whose inbox is being cleared */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissAllInboxAlerts. */
export type DismissAllInboxAlertsPayload = {
  __typename?: 'DismissAllInboxAlertsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of alerts archived */
  dismissedCount: Scalars['Int']['output'];
  /** IDs of the alerts that were archived */
  dismissedIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of DismissAnnouncement */
export type DismissAnnouncementInput = {
  /** The ID of the announcement config to dismiss */
  announcementConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DismissAnnouncement. */
export type DismissAnnouncementPayload = {
  __typename?: 'DismissAnnouncementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the announcement was dismissed successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DismissOnboardingHousehold */
export type DismissOnboardingHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to dismiss. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissOnboardingHousehold. */
export type DismissOnboardingHouseholdPayload = {
  __typename?: 'DismissOnboardingHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household was dismissed. */
  success: Scalars['Boolean']['output'];
};

/** Coarse status bucket used by the DocuSign tracker UI to group rows. */
export type DocusignEnvelopeStatusFilter =
  /** Sent but signer has not opened yet */
  | 'AWAITING'
  /** All required signers have signed */
  | 'COMPLETED'
  /** A signer declined to sign */
  | 'DECLINED'
  /** Signer opened the envelope but has not signed yet */
  | 'OPENED'
  /** Envelope was voided by the sender */
  | 'VOIDED';

/**
 * DocuSign envelope status. UI renders "delivered" as "Opened" since DocuSign uses
 * "delivered" to mean the signer opened the envelope.
 */
export type DocusignEnvelopeStatusName =
  /** completed */
  | 'completed'
  /** created */
  | 'created'
  /** declined */
  | 'declined'
  /** delivered */
  | 'delivered'
  /** expired */
  | 'expired'
  /** failed */
  | 'failed'
  /** sent */
  | 'sent'
  /** signed */
  | 'signed'
  /** voided */
  | 'voided';

/** A DocuSign recipient with their name and email information. */
export type DocusignRecipient = {
  __typename?: 'DocusignRecipient';
  /** The email address of the recipient. */
  email: Maybe<Scalars['String']['output']>;
  /** The full name of the recipient. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this recipient. */
  recipientId: Maybe<Scalars['String']['output']>;
  /** The role name assigned to this recipient. */
  roleName: Maybe<Scalars['String']['output']>;
  /** The current status of this recipient. */
  status: Maybe<Scalars['String']['output']>;
};

/** A DocuSign envelope row in the tracker, with derived status, attention flags, and household/advisor metadata. */
export type DocusignTrackerEnvelope = {
  __typename?: 'DocusignTrackerEnvelope';
  /** Human-readable reason for needs_attention. */
  attentionReason: Maybe<Scalars['String']['output']>;
  /** Sort key: 0 = none, 1 = opened-not-signed, 2 = sent-not-opened, 3 = declined. */
  attentionSeverity: Scalars['Int']['output'];
  /** Email of the primary client. */
  clientEmail: Maybe<Scalars['String']['output']>;
  /** Display name of the household. */
  clientName: Scalars['String']['output'];
  /** Latest signer signed_at when status is completed. */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Custodian copied from the underlying onboarding_task_data row, if present. */
  custodian: Maybe<Scalars['String']['output']>;
  /** Whole days since the envelope was completed. */
  daysSinceCompleted: Maybe<Scalars['Int']['output']>;
  /** Whole days since the envelope was last opened (DocuSign "delivered"). */
  daysSinceOpened: Maybe<Scalars['Int']['output']>;
  /** Whole days since the envelope was sent. */
  daysSinceSent: Maybe<Scalars['Int']['output']>;
  /** When a signer declined the envelope. */
  declinedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reason captured on the envelope-declined webhook. */
  declinedReason: Maybe<Scalars['String']['output']>;
  /** Deep link into DocuSign for the envelope (sandbox URL when environment is dev). */
  docusignEnvelopeUrl: Scalars['String']['output'];
  /** DocuSign envelope ID (also used as the GraphQL row identity). */
  envelopeId: Scalars['String']['output'];
  /** When the envelope expires (from DocuSign expireDateTime). Present only for external envelopes. */
  expireAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the envelope has a co-signer. */
  hasCoClient: Scalars['Boolean']['output'];
  /**
   * Public-facing UUID for the resolved household, suitable for linking to
   * /advisor/dashboard/client/<uuid>. Null when the envelope has no resolved
   * household (e.g. unknown signer email).
   */
  householdUuid: Maybe<Scalars['String']['output']>;
  /** When a reminder was last sent for this envelope. */
  lastReminderSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** True when the envelope is stalled or declined and warrants advisor follow-up. */
  needsAttention: Scalars['Boolean']['output'];
  /** When the next reminder may be sent (24h after last_reminder_sent_at, or null if not throttled). */
  nextReminderAvailableAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest time any signer opened the envelope (DocuSign "delivered"). */
  openedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * When the envelope first became "sent" — captured on first sync and never
   * overwritten, so it survives Resend events. Falls back to sent_at on envelopes
   * synced before this column existed.
   */
  originallySentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Display name of the household primary advisor (if assigned). */
  primaryAdvisorName: Maybe<Scalars['String']['output']>;
  /**
   * True when the resend-reminder mutation is supported for this envelope. False
   * for external envelopes (DocusignExternalEnvelope) where no OnboardingTaskDatum exists.
   */
  resendable: Scalars['Boolean']['output'];
  /**
   * When the envelope was most recently sent. DocuSign overwrites this on every
   * Resend, so it reflects the *last* send not the original — see
   * `originally_sent_at` for the original.
   */
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Derived envelope status. UI renders "delivered" as "Opened". */
  status: DocusignEnvelopeStatusName;
  /**
   * The envelope email subject — what DocuSign shows in the signing email (e.g.
   * "Complete with Docusign: Schwab LPOA"). Captured from webhook payloads.
   */
  subject: Maybe<Scalars['String']['output']>;
  /** When the envelope was voided. */
  voidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reason captured on the envelope-voided webhook. */
  voidedReason: Maybe<Scalars['String']['output']>;
  /**
   * True when the envelope has been Resent at least once since it was first sent.
   * Drives the "Resent" sub-caption in the tracker. Linear: 4C1T-57.
   */
  wasResent: Scalars['Boolean']['output'];
};

/**
 * Audience scope for the DocuSign tracker. MINE = households the current user can
 * read; ORG = all households in the current user organization (requires
 * can_edit_organization).
 */
export type DocusignTrackerScope =
  /** The current user's households (default) */
  | 'MINE'
  /** Org-wide (requires advisor_profile.can_edit_organization) */
  | 'ORG';

/** Autogenerated input type of DownloadBoxFileUrl */
export type DownloadBoxFileUrlInput = {
  boxFileId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  fileFormat: Scalars['String']['input'];
};

/** Autogenerated return type of DownloadBoxFileUrl. */
export type DownloadBoxFileUrlPayload = {
  __typename?: 'DownloadBoxFileUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of DuplicateServiceCatalogItemGroup */
export type DuplicateServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the source group to duplicate */
  id: Scalars['ID']['input'];
  /** Name for the new copy */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of DuplicateServiceCatalogItemGroup. */
export type DuplicateServiceCatalogItemGroupPayload = {
  __typename?: 'DuplicateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Duplicated service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/** A beneficiary on an ECI account onboarding. */
export type EciAccountBeneficiary = {
  __typename?: 'EciAccountBeneficiary';
  /** Person's date of birth or trust's date */
  dateOfBirthOrTrustDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** primary or contingent */
  designation: Maybe<Scalars['String']['output']>;
  /** Beneficiary first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** person or trust */
  kind: Maybe<Scalars['String']['output']>;
  /** Beneficiary last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Beneficiary middle name */
  middleName: Maybe<Scalars['String']['output']>;
  /** Whether this beneficiary designation is per stirpes */
  perStirpes: Maybe<Scalars['Boolean']['output']>;
  /** Allocation percentage */
  percentage: Maybe<Scalars['Float']['output']>;
  /** Relationship to the account owner */
  relationship: Maybe<Scalars['String']['output']>;
  /** Full beneficiary tax ID, for subform prefill */
  taxId: Maybe<Scalars['String']['output']>;
  /** Trust or entity name, when the beneficiary is a trust/entity */
  trustEntityName: Maybe<Scalars['String']['output']>;
};

/** Original-depositor information on an inherited ECI account onboarding request. */
export type EciAccountDecedentInformation = {
  __typename?: 'EciAccountDecedentInformation';
  /** Original depositor NFS account number */
  bdaParentAccountNumber: Maybe<Scalars['String']['output']>;
  /** Citizenship country code */
  citizenshipCountryCode: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dateOfBirth: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date of death */
  dateOfDeath: Maybe<Scalars['ISO8601Date']['output']>;
  /** First name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Middle name */
  middleName: Maybe<Scalars['String']['output']>;
  /** Full tax ID for subform prefill */
  taxId: Maybe<Scalars['String']['output']>;
};

/** SIMPLE IRA employer information on an ECI account onboarding. */
export type EciAccountEmployerInformation = {
  __typename?: 'EciAccountEmployerInformation';
  /** Employer legal name */
  entityName: Scalars['String']['output'];
  /** Full employer EIN, for subform prefill */
  taxId: Scalars['String']['output'];
};

/** A funding source for an ECI account onboarding. */
export type EciAccountFundingSource = {
  __typename?: 'EciAccountFundingSource';
  /** Funding amount, in cents */
  amountCents: Maybe<Scalars['BigInt']['output']>;
  /** Optional description */
  description: Maybe<Scalars['String']['output']>;
  /** Funding source type (ach, wire, account_transfer, check, rollover, other) */
  sourceType: Maybe<Scalars['String']['output']>;
};

/** A joint owner on an ECI account onboarding. */
export type EciAccountJointOwner = {
  __typename?: 'EciAccountJointOwner';
  /** Joint owner full name */
  fullName: Maybe<Scalars['String']['output']>;
  /** Ownership percentage for tenants in common */
  ownershipPercentage: Maybe<Scalars['Float']['output']>;
  /** Relationship to the primary owner (`self` designates the primary owner) */
  relationshipToPrimary: Maybe<EciOwnerRelationship>;
};

/** An ECI account onboarding request and its sidecars. */
export type EciAccountOnboarding = {
  __typename?: 'EciAccountOnboarding';
  /** Full source account number (single source only) */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Masked account number (*** + last 3) */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Destination-registration stakeholders */
  accountStakeholders: Array<EciAccountOnboardingStakeholder>;
  /** Account type (brokerage or ira) */
  accountType: Scalars['String']['output'];
  /** Inherited IRA beneficiary shape */
  bdaBeneficiaryKind: Maybe<EciBdaBeneficiaryKind>;
  /** Beneficiaries */
  beneficiaries: Array<EciAccountBeneficiary>;
  /** Inherited IRA original-depositor information */
  decedentInformation: Maybe<EciAccountDecedentInformation>;
  /** Custodian this account is headed TO. fidelity_nfs (the default) is the ECI pipe. */
  destination: EciDestinationCustodian;
  /** SIMPLE IRA employer information */
  employerInformation: Maybe<EciAccountEmployerInformation>;
  /** Funding sources */
  fundingSources: Array<EciAccountFundingSource>;
  /** True when the imported account type is an individual transfer-on-death designation. */
  hasTransferOnDeathDesignation: Scalars['Boolean']['output'];
  /** Joint owners */
  jointOwners: Array<EciAccountJointOwner>;
  /** Linked bank standing instructions for this onboarding request */
  linkedBankAccounts: Array<EciLinkedBankAccount>;
  /**
   * Account owner(s): all destination-registration stakeholders (owners, trustees,
   * grantors) deduped and joined, or nil when none are recorded
   */
  ownerName: Maybe<Scalars['String']['output']>;
  /** Pre-generated Fidelity account number, if reserved */
  pregeneratedAccountNumber: Maybe<Scalars['String']['output']>;
  /** Account purpose required by Schwab / Fidelity-IWS opening envelopes */
  purpose: Maybe<AccountPurposeName>;
  /** Free-text purpose when purpose is other */
  purposeOther: Maybe<Scalars['String']['output']>;
  /** Whether enough info exists to transfer this account */
  readinessStatus: EciAccountReadinessStatus;
  /** Recurring transfer and journal standing instructions for this onboarding request */
  recurringTransferInstructions: Array<Scalars['String']['output']>;
  /** Recurring transfers (structured records for subform prefill) */
  recurringTransfers: Array<EciAccountRecurringTransfer>;
  /** Registration type (individual, joint_*, trust_*, traditional, roth, rollover) */
  registrationType: Scalars['String']['output'];
  /** Savvy account ID of the source account being transferred */
  sourceAccountId: Maybe<Scalars['ID']['output']>;
  /** Source account official name (e.g. "Joint Brokerage") */
  sourceAccountName: Maybe<Scalars['String']['output']>;
  /** Masked name of the source account */
  sourceAccountNameMasked: Maybe<Scalars['String']['output']>;
  /** Source account type */
  sourceAccountType: Maybe<Scalars['String']['output']>;
  /** Source accounts that fund this onboarding request */
  sourceAccounts: Array<EciSourceAccount>;
  /** Custodian of the source (transferred-from) account */
  sourceCustodian: Maybe<Scalars['String']['output']>;
  /** Source account net assets, in cents */
  sourceNetAssetsCents: Maybe<Scalars['BigInt']['output']>;
  /** Source of funds required by Schwab / Fidelity-IWS opening envelopes */
  sourceOfFunds: Maybe<SourceOfFundsName>;
  /** Free-text source of funds when source_of_funds is other */
  sourceOfFundsOther: Maybe<Scalars['String']['output']>;
  /** Standing instructions (full records for subform prefill) */
  standingInstructions: Array<EciAccountStandingInstruction>;
  /** When the account onboarding was started */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the account onboarding was submitted */
  submittedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How the account transfers */
  transferType: EciAccountTransferType;
  /** Legal-entity information, if required by the registration */
  trustInformation: Maybe<EciAccountTrustInformation>;
  /** Account grouping for the subform and panel sort */
  typeGroup: EciAccountTypeGroup;
};

/** A household user with a destination-registration role on an ECI account onboarding request. */
export type EciAccountOnboardingStakeholder = {
  __typename?: 'EciAccountOnboardingStakeholder';
  /** Owner display name captured for the destination registration */
  fullName: Maybe<Scalars['String']['output']>;
  /** Destination-registration role */
  role: EciAccountStakeholderRole;
  /** Household user assigned this role */
  user: User;
};

/** Whether an ECI account onboarding has enough info to transfer the account. */
export type EciAccountReadinessStatus =
  /** missing_details */
  | 'missing_details'
  /** ready */
  | 'ready';

/**
 * A recurring transfer on an ECI account onboarding, exposed structurally for
 * subform prefill (cf. EciAccountOnboarding.recurringTransferInstructions, which
 * is display text).
 */
export type EciAccountRecurringTransfer = {
  __typename?: 'EciAccountRecurringTransfer';
  /** Transfer amount, in cents */
  amountCents: Maybe<Scalars['BigInt']['output']>;
  /** Day of month for monthly+ frequencies (1-31) */
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  /** Day of week for weekly frequency (0=Sunday … 6=Saturday) */
  dayOfWeek: Maybe<Scalars['Int']['output']>;
  /** Frequency (daily, weekly, monthly, quarterly, semi_annually, annually) */
  frequency: Maybe<Scalars['String']['output']>;
  /** Source standing instruction id (deposits) */
  fromStandingInstructionId: Maybe<Scalars['ID']['output']>;
  /** Recurring transfer identifier */
  id: Scalars['ID']['output'];
  /** Transfer kind (deposit, withdrawal, transfer) */
  kind: Maybe<Scalars['String']['output']>;
  /** Whether this recurring transfer should be carried over to the new account (advisors deselect stale ones) */
  shouldCarryOver: Scalars['Boolean']['output'];
  /** Recurring transfer status */
  status: Maybe<Scalars['String']['output']>;
  /** Destination standing instruction id (withdrawals) */
  toStandingInstructionId: Maybe<Scalars['ID']['output']>;
};

/** A destination-registration role on an ECI account onboarding request. */
export type EciAccountStakeholderRole =
  /** estate_fiduciary */
  | 'estate_fiduciary'
  /** grantor */
  | 'grantor'
  /** joint_owner */
  | 'joint_owner'
  /** primary_owner */
  | 'primary_owner'
  /** trustee */
  | 'trustee';

/**
 * A standing instruction on an ECI account onboarding, with every field needed to
 * prefill the Standing Instructions subform (bank account number masked to the
 * last 4 digits). Unlike EciLinkedBankAccount this is not method-filtered and
 * exposes the full record.
 */
export type EciAccountStandingInstruction = {
  __typename?: 'EciAccountStandingInstruction';
  /** Bank account type (checking or savings), ACH only */
  bankAccountType: Maybe<Scalars['String']['output']>;
  /** Bank name */
  bankName: Maybe<Scalars['String']['output']>;
  /** Check memo */
  checkMemo: Maybe<Scalars['String']['output']>;
  /** For-further-credit account number (wire) */
  ffcAccountNumber: Maybe<Scalars['String']['output']>;
  /** For-further-credit name (wire) */
  ffcName: Maybe<Scalars['String']['output']>;
  /** Fidelity standing instruction identifier, if registered */
  fidelityId: Maybe<Scalars['String']['output']>;
  /** Standing instruction identifier */
  id: Scalars['ID']['output'];
  /** Bank account number, masked to the last 4 digits (never the full value) */
  maskedAccountNumber: Scalars['String']['output'];
  /** Disbursement method (ach, wire, check) */
  methodType: Maybe<Scalars['String']['output']>;
  /** Party type (first_party or third_party) */
  partyType: Maybe<Scalars['String']['output']>;
  /** Payee address line 1 */
  payeeAddressLine1: Maybe<Scalars['String']['output']>;
  /** Payee address line 2 */
  payeeAddressLine2: Maybe<Scalars['String']['output']>;
  /** Payee city */
  payeeCity: Maybe<Scalars['String']['output']>;
  /** Payee country (ISO code) */
  payeeCountryCode: Maybe<Scalars['String']['output']>;
  /** Payee name */
  payeeName: Maybe<Scalars['String']['output']>;
  /** Payee postal code */
  payeePostalCode: Maybe<Scalars['String']['output']>;
  /** Payee state */
  payeeState: Maybe<Scalars['String']['output']>;
  /** Bank routing number (public bank identifier) */
  routingNumber: Maybe<Scalars['String']['output']>;
  /** Whether this standing instruction should be carried over to the new account (advisors deselect stale ones) */
  shouldCarryOver: Scalars['Boolean']['output'];
  /** Standing instruction status */
  status: Maybe<Scalars['String']['output']>;
  /** Check stub information */
  stubInformation: Maybe<Scalars['String']['output']>;
};

/** How an ECI account onboarding request transfers. */
export type EciAccountTransferType =
  /** consolidate */
  | 'consolidate'
  /** transfer_as_is */
  | 'transfer_as_is';

/** Trust legal information on an ECI account onboarding. */
export type EciAccountTrustInformation = {
  __typename?: 'EciAccountTrustInformation';
  /** Trust is an accredited investor */
  accreditedInvestor: Maybe<Scalars['Boolean']['output']>;
  /** Country the trust was organized in (ISO code) */
  countryOfOrganizationCode: Maybe<Scalars['String']['output']>;
  /** Trust entity name */
  entityName: Maybe<Scalars['String']['output']>;
  /** Home address line 1 */
  homeAddressLine1: Maybe<Scalars['String']['output']>;
  /** Home address line 2 */
  homeAddressLine2: Maybe<Scalars['String']['output']>;
  /** Home city */
  homeCity: Maybe<Scalars['String']['output']>;
  /** Home country (ISO code) */
  homeCountryCode: Maybe<Scalars['String']['output']>;
  /** Home postal code */
  homePostalCode: Maybe<Scalars['String']['output']>;
  /** Home state */
  homeState: Maybe<Scalars['String']['output']>;
  /** Mailing address line 1 */
  mailingAddressLine1: Maybe<Scalars['String']['output']>;
  /** Mailing address line 2 */
  mailingAddressLine2: Maybe<Scalars['String']['output']>;
  /** Mailing address matches the home address */
  mailingAddressSameAsHome: Maybe<Scalars['Boolean']['output']>;
  /** Mailing city */
  mailingCity: Maybe<Scalars['String']['output']>;
  /** Mailing country (ISO code) */
  mailingCountryCode: Maybe<Scalars['String']['output']>;
  /** Mailing postal code */
  mailingPostalCode: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  mailingState: Maybe<Scalars['String']['output']>;
  /** Trust is a registered broker-dealer */
  registeredBrokerDealer: Maybe<Scalars['Boolean']['output']>;
  /** Trust is a registered investment advisor */
  registeredInvestmentAdvisor: Maybe<Scalars['Boolean']['output']>;
  /** Trust is a registered investment company */
  registeredInvestmentCompany: Maybe<Scalars['Boolean']['output']>;
  /** Full trust tax ID, for subform prefill */
  taxId: Maybe<Scalars['String']['output']>;
  /** Tax ID type */
  taxIdType: Maybe<EciTrustTaxIdType>;
  /** Date the trust was established */
  trustDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Trust revocability */
  trustRevocability: Maybe<EciTrustRevocability>;
  /** Trust type */
  trustType: Maybe<EciTrustType>;
};

/** Account grouping used to pick the per-type subform and order the accounts panel. */
export type EciAccountTypeGroup =
  /** individual_brokerage */
  | 'individual_brokerage'
  /** ira */
  | 'ira'
  /** joint_brokerage */
  | 'joint_brokerage'
  /** other */
  | 'other'
  /** trust */
  | 'trust';

/** The client's assigned advisor, shown in the custodian-transfer flow. */
export type EciAdvisor = {
  __typename?: 'EciAdvisor';
  /** Advisor email */
  email: Maybe<Scalars['String']['output']>;
  /** Advisor first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Advisor last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Advisor profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** Advisory contract a household signs during onboarding — MSA or IAA */
export type EciAgreement =
  /** eci_msa */
  | 'eci_msa'
  /** iaa */
  | 'iaa';

/** Balances for an ECI account, sourced live from Fidelity. */
export type EciBalances = {
  __typename?: 'EciBalances';
  /** Freshness of the balances (ISO-8601). */
  asOf: Maybe<Scalars['String']['output']>;
  /** Cash available to withdraw. */
  availableCash: Maybe<Scalars['Float']['output']>;
  /** Cash buying power. */
  buyingPower: Maybe<Scalars['Float']['output']>;
  /** Total account value (cash + securities). */
  netWorth: Maybe<Scalars['Float']['output']>;
  /** Settled cash available to trade. */
  settledCash: Maybe<Scalars['Float']['output']>;
};

/** Beneficiary or entity shape for an inherited IRA registration. */
export type EciBdaBeneficiaryKind =
  /** entity */
  | 'entity'
  /** estate_administrator */
  | 'estate_administrator'
  /** estate_executor */
  | 'estate_executor'
  /** estate_personal_representative */
  | 'estate_personal_representative'
  /** non_spouse */
  | 'non_spouse'
  /** spouse */
  | 'spouse'
  /** trust */
  | 'trust';

/** A single beneficiary on an ECI account onboarding request */
export type EciBeneficiaryInput = {
  /** Person's date of birth or trust's date; a beneficiary needs a tax ID or a date of birth / trust date */
  dateOfBirthOrTrustDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** primary or contingent */
  designation: Scalars['String']['input'];
  /** Beneficiary first name */
  firstName: Scalars['String']['input'];
  /** person or trust */
  kind: Scalars['String']['input'];
  /** Beneficiary last name */
  lastName: Scalars['String']['input'];
  /** Beneficiary middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this designation is per stirpes */
  perStirpes: Scalars['Boolean']['input'];
  /** Allocation percentage (0-100) */
  percentage: Scalars['Float']['input'];
  /** Relationship to the account owner */
  relationship: Scalars['String']['input'];
  /** Beneficiary SSN or TIN; a beneficiary needs a tax ID or a date of birth / trust date */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Trust or entity name, when the beneficiary is a trust/entity */
  trustEntityName?: InputMaybe<Scalars['String']['input']>;
};

/** Detail for the US-registered broker-dealer association disclosure (present when the answer is yes). */
export type EciBrokerDealerDisclosureDetail = {
  __typename?: 'EciBrokerDealerDisclosureDetail';
  /** CRD number of the broker-dealer firm */
  firmCrdNumber: Scalars['String']['output'];
  /** Name of the broker-dealer firm */
  firmName: Scalars['String']['output'];
  /** Your role at the firm */
  role: Scalars['String']['output'];
  /** Supervisor's contact (email or phone) */
  supervisorContact: Scalars['String']['output'];
  /** Supervisor's name */
  supervisorName: Scalars['String']['output'];
};

/** ECI client citizenship & tax-status answers (read view). */
export type EciCitizenshipTaxStatus = {
  __typename?: 'EciCitizenshipTaxStatus';
  /** Alien registration number (A-Number / USCIS number) */
  alienId: Maybe<Scalars['String']['output']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  citizenshipCodes: Array<Scalars['String']['output']>;
  /** Whether claiming tax treaty benefits */
  claimingTreatyBenefits: Scalars['Boolean']['output'];
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  countryOfTaxResidence: Maybe<Scalars['String']['output']>;
  /** Foreign tax identification number (W-8BEN path) */
  foreignTaxId: Maybe<Scalars['String']['output']>;
  /** Tax treaty article and paragraph */
  treatyArticleParagraph: Maybe<Scalars['String']['output']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  treatyCountryCode: Maybe<Scalars['String']['output']>;
  /** Tax treaty rate of withholding */
  treatyWithholdingRate: Maybe<Scalars['String']['output']>;
  /** US citizenship status: citizen, permanent_resident, or non_citizen */
  usCitizenshipStatus: Maybe<Scalars['String']['output']>;
  /** Whether the applicant is a U.S. resident */
  usTaxResident: Scalars['Boolean']['output'];
  /** Whether the W-9 certification was acknowledged */
  w9Certification: Scalars['Boolean']['output'];
};

/**
 * Canonical citizenship & tax status for one owner.
 * Eci::UpdateCitizenshipTaxStatus replaces the whole slice, so send every required
 * field back — not only the edited ones.
 */
export type EciCitizenshipTaxStatusInput = {
  /** Alien registration number (A-Number / USCIS number) for permanent residents and non-citizens */
  alienId?: InputMaybe<Scalars['String']['input']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  citizenshipCodes: Array<Scalars['String']['input']>;
  /** Whether claiming tax treaty benefits (W-8BEN path) */
  claimingTreatyBenefits: Scalars['Boolean']['input'];
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  /** Foreign tax identification number (W-8BEN path) */
  foreignTaxId?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty article and paragraph */
  treatyArticleParagraph?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  treatyCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty rate of withholding */
  treatyWithholdingRate?: InputMaybe<Scalars['String']['input']>;
  /** US citizenship status: one of citizen, permanent_resident, non_citizen */
  usCitizenshipStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether the applicant is a U.S. resident */
  usTaxResident: Scalars['Boolean']['input'];
  /** Whether the W-9 certification was acknowledged (U.S. path) */
  w9Certification: Scalars['Boolean']['input'];
};

/** An ECI custodian-transfer client onboarding request and its sidecars, read by the magic-link holder. */
export type EciClientOnboarding = {
  __typename?: 'EciClientOnboarding';
  /**
   * Account onboarding requests this client owns. Scoped to the owner, like the
   * documents: a joint applicant sees the joint accounts, not their spouse's
   * individual ones.
   */
  accountOnboardingRequests: Array<EciAccountOnboarding>;
  /** The household's assigned advisor (null when none is assigned) */
  advisor: Maybe<EciAdvisor>;
  /** The household's advisory contract (MSA or IAA). Nil column stamps as the MSA default. */
  agreementType: EciAgreement;
  /** Citizenship & tax-status sidecar */
  citizenshipTaxStatus: Maybe<EciCitizenshipTaxStatus>;
  /** Resume cursor — the furthest step the client has reached. */
  currentStep: EciCurrentStep;
  /** Fidelity customer sequence number (1 or 2) */
  custSeqNbr: Scalars['Int']['output'];
  /** Advisor-composed invite message, echoed on the landing page. Null for requests not sent from the cockpit. */
  emailBody: Maybe<Scalars['String']['output']>;
  /** Financial profile sidecar */
  financialProfile: Maybe<EciFinancialProfile>;
  /**
   * Identity fields the client must confirm before proceeding (any of: last_name,
   * ssn, date_of_birth) — only those we hold on file.
   */
  identityVerificationFields: Array<Scalars['String']['output']>;
  /** Personal information sidecar */
  personalInformation: Maybe<EciPersonalInformation>;
  /** Regulatory disclosure sidecar */
  regulatoryDisclosure: Maybe<EciRegulatoryDisclosure>;
  /** Documents the client must review/sign — the household agreement plus any disclosures and account-opening forms. */
  requiredEciOnboardingDocuments: Array<EciOnboardingDocument>;
  /** Applicant role (primary or joint_owner) */
  role: Scalars['String']['output'];
  /** When the request was submitted (null while in progress) */
  submittedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether this client declined to provide a trusted contact */
  trustedContactOptedOut: Maybe<Scalars['Boolean']['output']>;
  /** Trusted contacts supplied by this client */
  trustedContacts: Array<EciTrustedContact>;
};

/** Resume cursor for an ECI client onboarding request — the furthest step the client has reached */
export type EciCurrentStep =
  /** citizenship */
  | 'citizenship'
  /** done */
  | 'done'
  /** financial_profile */
  | 'financial_profile'
  /** personal_information */
  | 'personal_information'
  /** regulatory_disclosures */
  | 'regulatory_disclosures'
  /** signature */
  | 'signature'
  /** trusted_contact */
  | 'trusted_contact';

/**
 * Where an ECI account onboarding request is headed. fidelity_nfs is the ECI pipe;
 * everything else routes through the custodian account-opening paperwork instead.
 */
export type EciDestinationCustodian =
  /** fidelity_iws */
  | 'fidelity_iws'
  /** fidelity_nfs */
  | 'fidelity_nfs'
  /** goldman_sachs */
  | 'goldman_sachs'
  /** schwab */
  | 'schwab';

/** Detail for the director / 10%+ shareholder disclosure (present when the answer is yes). */
export type EciDirectorOrShareholderDisclosureDetail = {
  __typename?: 'EciDirectorOrShareholderDisclosureDetail';
  /** Name of the public company */
  companyName: Scalars['String']['output'];
  /** Family member's name (present when the affiliation is a household member) */
  familyMemberName: Maybe<Scalars['String']['output']>;
  /** Role held at the public company */
  roleTitle: Scalars['String']['output'];
  /** Ticker symbol of the public company */
  tickerSymbol: Scalars['String']['output'];
};

/** ECI client financial-profile sidecar (read view). */
export type EciFinancialProfile = {
  __typename?: 'EciFinancialProfile';
  /** Annual household income, in cents */
  annualIncomeCents: Scalars['BigInt']['output'];
  /** Investing experience level */
  investingExperience: Scalars['String']['output'];
  /** Investment objective */
  investmentObjective: Scalars['String']['output'];
  /** Liquid net worth, in cents */
  liquidNetWorthCents: Maybe<Scalars['BigInt']['output']>;
  /** Liquidity needs */
  liquidityNeeds: Maybe<Scalars['String']['output']>;
  /** Risk tolerance */
  riskTolerance: Scalars['String']['output'];
  /** Investment time horizon */
  timeHorizon: Scalars['String']['output'];
  /** Total net worth, in cents */
  totalNetWorthCents: Scalars['BigInt']['output'];
};

/** Holdings for an ECI account, sourced live from Fidelity. */
export type EciHoldings = {
  __typename?: 'EciHoldings';
  /** Freshness of the holdings (prior-day close under the current entitlement). */
  asOf: Maybe<Scalars['String']['output']>;
  /** The holdings. */
  positions: Array<FidelityPosition>;
};

/** Inherited Traditional or Inherited Roth registration type. */
export type EciInheritedIraType =
  /** roth */
  | 'roth'
  /** traditional */
  | 'traditional';

/** Joint account registration type chosen on the owner sub-form (JTWROS, TIC, TBE, or community property). */
export type EciJointAccountType =
  /** community_property */
  | 'community_property'
  /** jtwros */
  | 'jtwros'
  /** tbe */
  | 'tbe'
  /** tic */
  | 'tic';

/** Joint/TIC ownership details for the request. */
export type EciJointOwnershipInput = {
  /** JTWROS, TIC, TBE, or community property; sets the request registration type */
  jointAccountType: EciJointAccountType;
  /** The complete owner set (exactly two), exactly one primary (`self`) */
  owners: Array<EciOwnerInput>;
};

/** A linked bank account, sourced from the ECI standing-instruction snapshot. */
export type EciLinkedBankAccount = {
  __typename?: 'EciLinkedBankAccount';
  /** Masked bank account number (**** + last 4). */
  accountNumberMasked: Scalars['String']['output'];
  /** Name of the bank. */
  bankName: Maybe<Scalars['String']['output']>;
};

/**
 * A document the ECI onboarding requires — an agreement (MSA), a disclosure, or a
 * per-account asset-transfer form (IRA Application, Transfer of Assets) — with its
 * category, display label, optional account id, and a preview link.
 */
export type EciOnboardingDocument = {
  __typename?: 'EciOnboardingDocument';
  /** Account onboarding request id for per-account forms (null for household-level) */
  accountId: Maybe<Scalars['ID']['output']>;
  /** agreement | disclosure | account_application | asset_transfer_form */
  category: Scalars['String']['output'];
  /** DocumentTemplate value, e.g. eci_premiere_select_ira_application */
  documentType: Scalars['String']['output'];
  /** Box preview link for reviewing the document (null when unavailable) */
  documentUrl: Maybe<Scalars['String']['output']>;
  /** Human-readable, mobile-friendly label */
  label: Scalars['String']['output'];
};

/** A single joint/TIC owner: a household member plus their ownership details. */
export type EciOwnerInput = {
  /** User ID of the household member who is an owner */
  householdMemberId: Scalars['ID']['input'];
  /** Ownership percentage (TIC only); must total 100% across owners */
  ownershipPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Relationship to the primary owner; `self` designates the primary owner */
  relationshipToPrimary: EciOwnerRelationship;
};

/** A joint/TIC owner's relationship to the primary owner (`self` designates the primary owner). */
export type EciOwnerRelationship =
  /** business_partner */
  | 'business_partner'
  /** child */
  | 'child'
  /** domestic_partner */
  | 'domestic_partner'
  /** other */
  | 'other'
  /** parent */
  | 'parent'
  /** self */
  | 'self'
  /** sibling */
  | 'sibling'
  /** spouse */
  | 'spouse';

/** ECI client personal-information sidecar (read view). */
export type EciPersonalInformation = {
  __typename?: 'EciPersonalInformation';
  /** Date of birth */
  dateOfBirth: Maybe<Scalars['ISO8601Date']['output']>;
  /** Email address */
  email: Maybe<Scalars['String']['output']>;
  /** Employer name */
  employerName: Maybe<Scalars['String']['output']>;
  /** Employment status */
  employmentStatus: Maybe<Scalars['String']['output']>;
  /** Home address line 1 */
  homeAddressLine1: Maybe<Scalars['String']['output']>;
  /** Home address line 2 */
  homeAddressLine2: Maybe<Scalars['String']['output']>;
  /** Home city */
  homeCity: Maybe<Scalars['String']['output']>;
  /** Home country code (ISO-3166-1 alpha-2) */
  homeCountryCode: Maybe<Scalars['String']['output']>;
  /** Home postal code */
  homePostalCode: Maybe<Scalars['String']['output']>;
  /** Home state */
  homeState: Maybe<Scalars['String']['output']>;
  /** Whether the client confirmed information accuracy */
  infoAccuracyConfirmed: Scalars['Boolean']['output'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Legal first name */
  legalFirstName: Maybe<Scalars['String']['output']>;
  /** Legal last name */
  legalLastName: Maybe<Scalars['String']['output']>;
  /** Legal middle name */
  legalMiddleName: Maybe<Scalars['String']['output']>;
  /** Additional legal residence when other than the United States */
  legalResidence: Maybe<Scalars['String']['output']>;
  /** Mailing address line 1 */
  mailingAddressLine1: Maybe<Scalars['String']['output']>;
  /** Mailing address line 2 */
  mailingAddressLine2: Maybe<Scalars['String']['output']>;
  /** Whether the mailing address matches home */
  mailingAddressSameAsHome: Scalars['Boolean']['output'];
  /** Mailing city */
  mailingCity: Maybe<Scalars['String']['output']>;
  /** Mailing country code (ISO-3166-1 alpha-2) */
  mailingCountryCode: Maybe<Scalars['String']['output']>;
  /** Mailing postal code */
  mailingPostalCode: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  mailingState: Maybe<Scalars['String']['output']>;
  /** Occupation category for custodian opening envelopes */
  occupation: Maybe<ClientOccupation>;
  /** Phone number (E.164) */
  phone: Maybe<Scalars['String']['output']>;
  /** Full SSN */
  ssn: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of SSN (masked) */
  ssnLast4: Maybe<Scalars['String']['output']>;
  /** Name suffix */
  suffix: Maybe<Scalars['String']['output']>;
};

/**
 * Canonical personal information for one owner. Eci::UpdatePersonalInformation
 * replaces the whole slice, so send every required field back — not only the edited ones.
 */
export type EciPersonalInformationInput = {
  /** Date of birth (ISO 8601) */
  dateOfBirth: Scalars['ISO8601Date']['input'];
  /** Email address */
  email: Scalars['String']['input'];
  /** Employer name (required by model when employment_status is employed or self_employed) */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** One of: employed, self_employed, student, homemaker, retired, non_employed */
  employmentStatus: Scalars['String']['input'];
  /** Legal first name */
  firstName: Scalars['String']['input'];
  /** Home address */
  homeAddress: StrictAddressInput;
  /** Job title (required by model when employment_status is employed or self_employed) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  lastName: Scalars['String']['input'];
  /** Additional legal residence when other than the United States */
  legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address; required when mailingAddressSameAsHome is false */
  mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Legal middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Occupation category for custodian opening envelopes */
  occupation: ClientOccupation;
  /** Phone number; accepts formatted US input or E.164. Stored as E.164. */
  phoneNumber: Scalars['String']['input'];
  /** SSN; XXX-XX-XXXX format */
  ssn: Scalars['String']['input'];
  /** Suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** ECI client regulatory-disclosure answers (read view). */
export type EciRegulatoryDisclosure = {
  __typename?: 'EciRegulatoryDisclosure';
  /** Is an accredited investor */
  accreditedInvestor: Scalars['Boolean']['output'];
  /** Associated with a US registered broker-dealer */
  brokerDealerAssociated: Scalars['Boolean']['output'];
  /** Detail when broker_dealer_associated is true */
  brokerDealerDetail: Maybe<EciBrokerDealerDisclosureDetail>;
  /** Self or household member is a director / 10%+ shareholder / executive officer of a public company */
  directorOr10pctShareholder: Scalars['Boolean']['output'];
  /** Detail when director_or_10pct_shareholder is true */
  directorOrShareholderDetail: Maybe<EciDirectorOrShareholderDisclosureDetail>;
  /** Self or household member is registered with / employed by a FINRA member firm */
  finraMemberFirmAssociated: Scalars['Boolean']['output'];
  /** Associated with a US registered investment advisor */
  registeredInvestmentAdvisorAssociated: Scalars['Boolean']['output'];
  /** Self or immediate family is a senior political figure */
  seniorPoliticalFigure: Scalars['Boolean']['output'];
  /** Detail when senior_political_figure is true */
  seniorPoliticalFigureDetail: Maybe<EciSeniorPoliticalFigureDisclosureDetail>;
};

/**
 * The editable canonical field set + current values for a remediation subtask.
 * Both the account and TOA resubmit forms read their slice of this shape;
 * remediationType selects the variant.
 */
export type EciRemediationEditableFields = {
  __typename?: 'EciRemediationEditableFields';
  /** The account onboarding request whose canonical data feeds both forms. */
  accountOnboarding: EciAccountOnboarding;
  /** Owners/stakeholders on the request with their canonical PII + citizenship/tax. */
  owners: Array<EciRemediationOwner>;
  /** Which failure branch this subtask remediates; drives the form variant. */
  remediationType: EciRemediationType;
  /**
   * The account_transfer funding source for the TOA form (delivering-firm account
   * number/DTC/firm). Null when the request has no account-transfer source.
   */
  transferFundingSource: Maybe<EciRemediationFundingSource>;
};

/**
 * The account-transfer funding source for a TOA remediation, carrying the
 * delivering-firm details the TOA resubmit form edits. CSA-only surface —
 * reachable only through the admin/advisor/CSA-gated remediation resolver, never
 * the client MagicLink path.
 */
export type EciRemediationFundingSource = {
  __typename?: 'EciRemediationFundingSource';
  /** Delivering-firm account number (decrypted). */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Transfer amount, in cents. */
  amountCents: Maybe<Scalars['BigInt']['output']>;
  /** DTC number of the delivering firm. */
  firmDtcNumber: Maybe<Scalars['String']['output']>;
  /** Name of the delivering firm. */
  firmName: Maybe<Scalars['String']['output']>;
  /** Funding source type (account_transfer for this surface). */
  sourceType: Maybe<Scalars['String']['output']>;
};

/**
 * An owner/stakeholder on a remediation request, with their canonical PII and
 * citizenship/tax sidecars for resubmit-form prefill.
 */
export type EciRemediationOwner = {
  __typename?: 'EciRemediationOwner';
  /** Canonical citizenship & tax status for this owner; null when not captured. */
  citizenshipTaxStatus: Maybe<EciCitizenshipTaxStatus>;
  /** Canonical PII for this owner; null when the owner has no linked personal-information record. */
  personalInformation: Maybe<EciPersonalInformation>;
  /** Destination-registration role (e.g. primary_owner, joint owner, trustee). */
  role: Scalars['String']['output'];
  /** Household user these edits apply to; pass back as ResubmitEciRemediationInput.owners.ownerUserId. */
  userId: Scalars['ID']['output'];
};

/** Edits to one owner on the request. Both slices are optional so a resubmit can carry only the one that changed. */
export type EciRemediationOwnerInput = {
  /** Replacement citizenship & tax status for this owner */
  citizenshipTaxStatus?: InputMaybe<EciCitizenshipTaxStatusInput>;
  /** User ID of the owner/stakeholder these edits apply to */
  ownerUserId: Scalars['ID']['input'];
  /** Replacement personal information for this owner */
  personalInformation?: InputMaybe<EciPersonalInformationInput>;
};

/** Which terminal Fidelity failure branch a remediation subtask addresses; drives the resubmit form variant. */
export type EciRemediationType =
  /** account_setup_error */
  | 'account_setup_error'
  /** account_validate_error */
  | 'account_validate_error'
  /** toa_error */
  | 'toa_error'
  /** toa_nigo */
  | 'toa_nigo';

/** Detail for the senior-political-figure disclosure (present when the answer is yes). */
export type EciSeniorPoliticalFigureDisclosureDetail = {
  __typename?: 'EciSeniorPoliticalFigureDisclosureDetail';
  /** ISO-3166-1 alpha-2 country code */
  countryCode: Scalars['String']['output'];
  /** Family member name (optional; only when applicable) */
  familyMemberName: Maybe<Scalars['String']['output']>;
  /** Office / position held */
  officePosition: Scalars['String']['output'];
  /** Relationship to the senior political figure (self, spouse, parent, child, sibling) */
  relationship: Maybe<Scalars['String']['output']>;
};

/** A consolidated source account funding an ECI onboarding request, from the eci funding-source snapshot. */
export type EciSourceAccount = {
  __typename?: 'EciSourceAccount';
  /** Masked account number (**** + last 4) */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Source account type */
  accountType: Maybe<Scalars['String']['output']>;
  /** Source account net assets, in cents */
  netAssetsCents: Maybe<Scalars['BigInt']['output']>;
};

/** Delivering-firm details on the account_transfer funding source, as consumed by Eci::BuildTransferOfAssetsRequest. */
export type EciTransferFundingSourceInput = {
  /** Account number at the delivering firm */
  accountNumber: Scalars['String']['input'];
  /** Expected transfer amount in cents. Omit to preserve the current amount; sending null does not zero it. */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Delivering firm DTC number. May be blank — the account number is then passed through unformatted. */
  firmDtcNumber?: InputMaybe<Scalars['String']['input']>;
  /** Delivering firm name */
  firmName: Scalars['String']['input'];
};

/**
 * Canonical trust legal information. Eci::SaveTrustDetails replaces the whole
 * slice, so send every required field back — not only the edited ones.
 */
export type EciTrustDetailsInput = {
  /** Whether the entity is an accredited investor */
  accreditedInvestor: Scalars['Boolean']['input'];
  /** ISO country code where the trust was organized */
  countryOfOrganizationCode: Scalars['String']['input'];
  /** Full legal name of the trust entity */
  entityName: Scalars['String']['input'];
  /** Household users acting as grantors */
  grantorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Trust home address */
  homeAddress: StrictAddressInput;
  /** Mailing address; required when mailingAddressSameAsHome is false */
  mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Whether the entity is a registered broker-dealer */
  registeredBrokerDealer: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment advisor */
  registeredInvestmentAdvisor: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment company */
  registeredInvestmentCompany: Scalars['Boolean']['input'];
  /** Tax ID number */
  taxId: Scalars['String']['input'];
  /** Tax ID type */
  taxIdType: EciTrustTaxIdType;
  /** Date the trust was established (ISO 8601) */
  trustDate: Scalars['ISO8601Date']['input'];
  /** Trust revocability */
  trustRevocability: EciTrustRevocability;
  /** Trust type */
  trustType: EciTrustType;
  /** Household users acting as trustees */
  trusteeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Whether an ECI trust is revocable or irrevocable. */
export type EciTrustRevocability =
  /** irrevocable */
  | 'irrevocable'
  /** revocable */
  | 'revocable';

/** Tax ID type for an ECI trust account. */
export type EciTrustTaxIdType =
  /** ein */
  | 'ein'
  /** ssn */
  | 'ssn';

/** Legal basis under which an ECI trust was created. */
export type EciTrustType =
  /** under_agreement */
  | 'under_agreement'
  /** under_will */
  | 'under_will';

/** A trusted contact supplied by an ECI client. */
export type EciTrustedContact = {
  __typename?: 'EciTrustedContact';
  /** Trusted contact address line 1 */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** Trusted contact address line 2 */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** Trusted contact city */
  city: Maybe<Scalars['String']['output']>;
  /** Trusted contact country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Trusted contact email address */
  email: Maybe<Scalars['String']['output']>;
  /** Trusted contact first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Trusted contact last name */
  lastName: Scalars['String']['output'];
  /** Trusted contact middle name */
  middleName: Maybe<Scalars['String']['output']>;
  /** Trusted contact phone number in E.164 format */
  phone: Maybe<Scalars['String']['output']>;
  /** Trusted contact postal code */
  postalCode: Maybe<Scalars['String']['output']>;
  /** Fidelity relationship code describing the contact's relationship to the holder */
  relationshipToHolder: Maybe<EciTrustedContactRelationship>;
  /** Trusted contact state or province */
  state: Maybe<Scalars['String']['output']>;
  /** Whether this is the primary or secondary trusted contact */
  tcpType: Scalars['String']['output'];
};

/** Optional address fields for an ECI trusted contact */
export type EciTrustedContactAddressInput = {
  /** Address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** State or province */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** A trusted contact supplied by an ECI client */
export type EciTrustedContactInput = {
  /** Optional trusted contact address */
  address?: InputMaybe<EciTrustedContactAddressInput>;
  /** Trusted contact email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact last name */
  lastName: Scalars['String']['input'];
  /** Trusted contact middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact phone number in E.164 format */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Fidelity relationship code describing the contact's relationship to the holder */
  relationshipToHolder?: InputMaybe<EciTrustedContactRelationship>;
};

/** A trusted contact's relationship to the account holder, using Fidelity's relationship code */
export type EciTrustedContactRelationship =
  /** AUUN */
  | 'AUUN'
  /** BROT */
  | 'BROT'
  /** DAUT */
  | 'DAUT'
  /** FRND */
  | 'FRND'
  /** FTHR */
  | 'FTHR'
  /** GRDD */
  | 'GRDD'
  /** GRDF */
  | 'GRDF'
  /** GRDM */
  | 'GRDM'
  /** GRDS */
  | 'GRDS'
  /** MTHR */
  | 'MTHR'
  /** NENI */
  | 'NENI'
  /** NHBR */
  | 'NHBR'
  /** OTHR */
  | 'OTHR'
  /** SON */
  | 'SON'
  /** SPS */
  | 'SPS'
  /** SSTR */
  | 'SSTR';

export type EditCenterOfInfluenceRepError =
  | 'email_already_exists'
  | 'not_found'
  | 'validation_error';

/** Autogenerated input type of EditCenterOfInfluenceRep */
export type EditCenterOfInfluenceRepInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company this rep works for */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  feeRate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerAdvisorProfileId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  preferredContactMethod?: InputMaybe<CenterOfInfluenceRepPreferredContactMethod>;
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<Array<CenterOfInfluenceRepSpecialty>>;
};

/** Autogenerated return type of EditCenterOfInfluenceRep. */
export type EditCenterOfInfluenceRepPayload = {
  __typename?: 'EditCenterOfInfluenceRepPayload';
  centerOfInfluenceRep: Maybe<CenterOfInfluenceRep>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  softError: Maybe<EditCenterOfInfluenceRepError>;
};

/** Errors for editing a company */
export type EditCompanyError =
  /** name_already_exists */
  | 'name_already_exists'
  /** not_found */
  | 'not_found'
  /** validation_error */
  | 'validation_error';

/** Autogenerated input type of EditCompany */
export type EditCompanyInput = {
  /** The first line of the company address */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the company address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the company address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the company address */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The description of the company */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the company to edit */
  id: Scalars['ID']['input'];
  /** The URL of the company's logo */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the company */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the company address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state of the company address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The website of the company */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditCompany. */
export type EditCompanyPayload = {
  __typename?: 'EditCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The edited company */
  company: Maybe<Company>;
  /** Error encountered during edit */
  softError: Maybe<EditCompanyError>;
};

export type ElementImpression = {
  /** The name of the element that was viewed - e.g. "create_task_modal" */
  elementName: Scalars['String']['input'];
  /** The type of element that was viewed - e.g. "drawer" or "dialog" */
  elementType: Scalars['String']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type ElementViewDuration = {
  /** The duration of the element view in milliseconds */
  duration: Scalars['Int']['input'];
  /** The name of the item that was clicked or touched - e.g. "create_prospect_button" */
  elementName: Scalars['String']['input'];
  /** The type of element that was viewed - e.g. "drawer" or "dialog" */
  elementType: Scalars['String']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type Email =
  | 'confirmation'
  | 'create_password'
  | 'reset_password';

/** Name of the custodian */
export type EmailDirection =
  /** inbound */
  | 'inbound'
  /** outbound */
  | 'outbound';

/** An email message associated with a household */
export type EmailMessage = {
  __typename?: 'EmailMessage';
  /** The direction of the email message (incoming or outgoing). */
  direction: EmailDirection;
  /** Earlier messages in the same thread (newest first), scoped to the in-context household. */
  earlierThreadMessages: Array<EmailMessage>;
  /** The HTML body of the email message. */
  htmlBody: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the email message. */
  id: Scalars['ID']['output'];
  /** The timestamp when the email was sent. */
  internalDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The mailbox this email message belongs to. */
  mailbox: Maybe<Mailbox>;
  /** The original email addresses associated with the email message. */
  originalEmailAddresses: Maybe<OriginalEmailAddresses>;
  /** The plain text body of the email message. */
  plainTextBody: Maybe<Scalars['String']['output']>;
  /** A snippet of the email message content. */
  snippet: Maybe<Scalars['String']['output']>;
  /** The subject of the email message. */
  subject: Maybe<Scalars['String']['output']>;
  /** Number of earlier messages in the same thread, scoped to the in-context household. */
  threadMessageCount: Scalars['Int']['output'];
};

/** A rendered email preview: the inlined HTML body plus the sender and subject. */
export type EmailPreview = {
  __typename?: 'EmailPreview';
  /** Server-rendered, inlined HTML body for the preview iframe. */
  body: Scalars['String']['output'];
  /** CC recipients the send path adds to the message, in header order. Empty when the email copies nobody. */
  ccRecipients: Array<EmailPreviewRecipient>;
  /** Sender as it appears in the inbox (display name, or address when unnamed). */
  from: Scalars['String']['output'];
  /**
   * Reply-To address the client would reply to. Null when the email carries none,
   * or when it would only repeat the From address.
   */
  replyTo: Maybe<Scalars['String']['output']>;
  /** Email subject line. */
  subject: Scalars['String']['output'];
};

/** A CC recipient carried on the previewed email. */
export type EmailPreviewRecipient = {
  __typename?: 'EmailPreviewRecipient';
  /** Recipient email address. */
  email: Scalars['String']['output'];
  /** Recipient display name; null when the address carries none. */
  name: Maybe<Scalars['String']['output']>;
};

/** Rendered preview of a Service Calendar v2 catalog email template */
export type EmailTemplatePreview = {
  __typename?: 'EmailTemplatePreview';
  /** Configured template CC users added to every send; empty when none is configured (inactive users are dropped). */
  ccRecipients: Array<EmailTemplatePreviewRecipient>;
  /**
   * From-line email: the sender's DBA email when Mailgun can DKIM-sign its domain,
   * else the organization's own verified sending address, else
   * "client-service@savvywealth.com".
   */
  fromEmail: Scalars['String']['output'];
  /**
   * From-line display name: the full name of the sender — the configured template
   * sender when one is set and active, else the advisor the preview is branded from.
   */
  fromName: Scalars['String']['output'];
  /**
   * Full MJML-rendered HTML body of the email. Always rendered; valid merge tags
   * are substituted and any unknown token is left verbatim.
   */
  html: Scalars['String']['output'];
  /** Non-blocking warning naming any unknown {placeholder} token(s); null when all tags are valid. The preview always renders. */
  placeholderError: Maybe<Scalars['String']['output']>;
  /** Reply-To address: the sender's DBA email, else their login address. Null when it would repeat the From address. */
  replyTo: Maybe<Scalars['String']['output']>;
  /** Subject after merge-field substitution; unknown tokens are left verbatim. */
  subject: Scalars['String']['output'];
};

/** A CC recipient the Service Calendar v2 send path adds to every message */
export type EmailTemplatePreviewRecipient = {
  __typename?: 'EmailTemplatePreviewRecipient';
  /** The recipient's email address. */
  email: Scalars['String']['output'];
  /** The recipient's display name. */
  name: Scalars['String']['output'];
};

/** A household-scoped email semantic-search hit, reported from the thread's latest household-visible message. */
export type EmailThreadSemanticSearchHit = {
  __typename?: 'EmailThreadSemanticSearchHit';
  /** CC email address(es) of that message. */
  cc: Array<Scalars['String']['output']>;
  /** Whether that message was inbound (received) or outbound (sent). */
  direction: EmailDirection;
  /** Sender email address(es) of that message. */
  from: Array<Scalars['String']['output']>;
  /** Latest household-visible EmailMessage id for the matched thread (fetch handle). */
  id: Scalars['ID']['output'];
  /** internalDate of that message. */
  internalDate: Scalars['ISO8601DateTime']['output'];
  /**
   * Cosine similarity to the query (higher = closer match); the query-time re-rank
   * similarity when re-rank runs, else the nearest-neighbor similarity.
   */
  score: Scalars['Float']['output'];
  /** Snippet of that message. */
  snippet: Maybe<Scalars['String']['output']>;
  /** Subject of that message. */
  subject: Maybe<Scalars['String']['output']>;
  /** Recipient (To) email address(es) of that message. */
  to: Array<Scalars['String']['output']>;
};

export type EmploymentStatusName =
  | 'employed'
  | 'homemaker'
  | 'non_employed'
  | 'retired'
  | 'self_employed'
  | 'student';

/** Autogenerated input type of EnrollHouseholdsInServiceCatalogItemGroup */
export type EnrollHouseholdsInServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Households to enroll: at least one, at most 25 per call. Duplicates are
   * collapsed; every id must exist and be reachable, or the whole call is refused.
   * At most 200 enrollments (households x the service's active items), so past 8
   * items it is the enrollment cap that binds, not the household one
   */
  householdIds: Array<Scalars['ID']['input']>;
  /** The service (template) to enroll into */
  serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollHouseholdsInServiceCatalogItemGroup. */
export type EnrollHouseholdsInServiceCatalogItemGroupPayload = {
  __typename?: 'EnrollHouseholdsInServiceCatalogItemGroupPayload';
  /**
   * Households refused because they are already enrolled in a *different* service;
   * nothing changed for them. Distinct from `skippedHouseholdCount`, which counts
   * households already on this one
   */
  blockedHouseholdCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Households newly enrolled on at least one item */
  enrolledHouseholdCount: Scalars['Int']['output'];
  /** Households whose enrollment attempt rolled back; the enrollments they already had are unchanged */
  failedHouseholdCount: Scalars['Int']['output'];
  /** Per-household outcome, in the order the households were given */
  results: Array<ServiceCatalogEnrollmentResult>;
  /** Households already enrolled on every item of **this** service; nothing changed for them */
  skippedHouseholdCount: Scalars['Int']['output'];
};

/**
 * A household enrolled in a service, as the service editor's enrolled-households
 * dialog renders it. Scalars rather than Models::Household: a service shared
 * across an advisor group can enroll a household whose read policy denies this
 * viewer, and a denied object raises rather than nulling the field, which would
 * fail the whole editor query
 */
export type EnrolledHousehold = {
  __typename?: 'EnrolledHousehold';
  /** The enrolled household */
  householdId: Scalars['ID']['output'];
  /** The household's display name, which the dialog lists and searches */
  name: Scalars['String']['output'];
};

/** An item in the activity timeline */
export type Entries = {
  __typename?: 'Entries';
  /** Whether entries exist newer than this page. Null unless newerThan was supplied. */
  hasMoreNewer: Maybe<Scalars['Boolean']['output']>;
  /** Whether entries exist older than this page. Null unless olderThan was supplied. */
  hasMoreOlder: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if there is a next page. Describes offset paging only — read hasMoreOlder/hasMoreNewer for a positioned page. */
  hasNextPage: Scalars['Boolean']['output'];
  /**
   * Indicates if there is a previous page. Describes offset paging only — read
   * hasMoreOlder/hasMoreNewer for a positioned page.
   */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** List of activity timeline entries */
  nodes: Array<Entry>;
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Number of entries per page */
  perPage: Scalars['Int']['output'];
  /** Total number of activity timeline entries */
  totalCount: Scalars['Int']['output'];
  /**
   * Total number of pages. Describes offset paging only; meaningless for a
   * positioned page, which is always page 1 of the whole set.
   */
  totalPages: Scalars['Int']['output'];
  /** How far ahead, in days, calendar events surface in the Upcoming section */
  upcomingEventHorizonDays: Scalars['Int']['output'];
};

/** An item in the activity timeline */
export type Entry = {
  __typename?: 'Entry';
  /** Unique identifier for the activity timeline item */
  id: Scalars['ID']['output'];
  /** Whether the entry is pinned to the top of this household timeline */
  isPinned: Scalars['Boolean']['output'];
  /** Polymorphic payload */
  item: ItemTypeUnion;
  /** Contacts and beneficiaries this item has been surfaced on */
  linkedContacts: Array<ActivityTimelineContactLink>;
  /** Timestamp when the activity occurred */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Type of activity timeline item */
  type: ItemTypeEnum;
};

/** An exact position in the activity timeline, taken from an entry the caller already holds. */
export type EntryPositionInput = {
  /** ID of the entry at this position. */
  id: Scalars['ID']['input'];
  /**
   * occurredAt of the entry at this position. Only consulted if that entry has
   * since been deleted: ISO8601DateTime serializes at second precision, so a
   * round-tripped value cannot be compared against stored microseconds and the
   * resolver reads the real sort key by id instead.
   */
  occurredAt: Scalars['ISO8601DateTime']['input'];
};

/** One account row in the "Accounts Included in this Report" header section of the Estimated Cash Flow report. */
export type EstimatedCashFlowAccount = {
  __typename?: 'EstimatedCashFlowAccount';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Display name of the account (Account#display_name). */
  accountName: Scalars['String']['output'];
  /** Last digits of the account number, or full number when no mask is stored. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Humanized account subtype (e.g. "Roth IRA"); falls back to coarse type_of. */
  accountType: Maybe<Scalars['String']['output']>;
  /** Custodian / firm name when known. */
  custodian: Maybe<Scalars['String']['output']>;
  /** Stable identifier for the row. */
  id: Scalars['ID']['output'];
  /** Humanized custody label (e.g. "Managed Account", "Held Away"). */
  managementStrategy: Maybe<Scalars['String']['output']>;
  /** Sum of the account's active holdings' institution_value as of the report's end_date. */
  marketValue: HoldingsSummaryMoney;
};

/**
 * Native Estimated Cash Flow report (HAWK-34) — replaces the Orion-generated
 * Estimated Income PDF. Aggregates the household’s active holdings by asset class
 * and projects an annualized income figure from the trailing 12 months of dividend
 * / interest / income transactions in Postgres.
 */
export type EstimatedCashFlowReport = {
  __typename?: 'EstimatedCashFlowReport';
  /** "Accounts Included in this Report" — every scoped account with its current market value. */
  accounts: Array<EstimatedCashFlowAccount>;
  /** Period end date; doubles as the snapshot date for the holdings rollup. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Stable identifier for this report scope (household or account selection + period). */
  id: Scalars['ID']['output'];
  /** Inclusive number of days between start_date and end_date. */
  periodDays: Scalars['Int']['output'];
  /** One row per asset class with active holdings. */
  rows: Array<EstimatedCashFlowRow>;
  /** Display-only period start date supplied by the caller. */
  startDate: Scalars['ISO8601Date']['output'];
  /** Sum of cost_basis across rows; amount is null if any row lacks cost basis. */
  totalCostBasis: HoldingsSummaryMoney;
  /**
   * Portfolio-weighted current yield: total_estimated_annual_income /
   * total_market_value. Null when total_market_value is zero.
   */
  totalCurrentYield: Maybe<Scalars['BigDecimal']['output']>;
  /** Sum of estimated_annual_income across rows. */
  totalEstimatedAnnualIncome: HoldingsSummaryMoney;
  /** Sum of market_value across rows. */
  totalMarketValue: HoldingsSummaryMoney;
};

/** A single asset-class row in the native Estimated Cash Flow report. */
export type EstimatedCashFlowRow = {
  __typename?: 'EstimatedCashFlowRow';
  /** Asset class label from Security#type_of (e.g. 'equity', 'fixed_income', 'cash'). */
  assetClass: Scalars['String']['output'];
  /** Sum of cost_basis across holdings in this class; amount is null if any holding lacks cost basis. */
  costBasis: HoldingsSummaryMoney;
  /** ISO currency code for the row. */
  currencyCode: Scalars['String']['output'];
  /** estimated_annual_income / market_value as a decimal (e.g. 0.0122 for 1.22%). Null when market_value is zero. */
  currentYield: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Trailing-12-month sum of dividend / interest / income transactions for
   * holdings in this class, taken as the annualized estimate.
   */
  estimatedAnnualIncome: HoldingsSummaryMoney;
  /** Stable identifier for the row (asset class label). */
  id: Scalars['ID']['output'];
  /** Sum of institution_value across holdings in this class. */
  marketValue: HoldingsSummaryMoney;
};

/** One asset-class row of the 'Estimated Income' table — cost basis, market value, estimated annual income, and current yield. */
export type EstimatedIncomeRow = {
  __typename?: 'EstimatedIncomeRow';
  /** Asset class display name (e.g. "US Equity", "International Developed", "Cash"). */
  assetClass: Scalars['String']['output'];
  /** Aggregate cost basis for the asset class; amount is null when any holding lacks cost basis. */
  costBasis: HoldingsSummaryMoney;
  /**
   * Yield = estimated_annual_income / market_value, expressed as a fraction (0.05
   * = 5%); null when market value is zero or income is unavailable.
   */
  currentYield: Maybe<Scalars['BigDecimal']['output']>;
  /** Aggregate forward-looking annualized income for the asset class; amount is null when Orion does not provide it. */
  estimatedAnnualIncome: HoldingsSummaryMoney;
  /** Aggregate market value for the asset class on the report end date. */
  marketValue: HoldingsSummaryMoney;
};

/** Autogenerated input type of ExcludeStagedHouseholdsFromBatch */
export type ExcludeStagedHouseholdsFromBatchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * EciHouseholdOnboardingRequest ids to wipe from the batch. The cockpit surfaces
   * these ids post-HAWK-656; only unpromoted rows are destroyed, a live/promoted
   * request is never touched.
   */
  stagedHouseholdIds: Array<Scalars['ID']['input']>;
  /** The enrollment's uuid. */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of ExcludeStagedHouseholdsFromBatch. */
export type ExcludeStagedHouseholdsFromBatchPayload = {
  __typename?: 'ExcludeStagedHouseholdsFromBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The enrollment after exclusions. */
  enrollment: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** Whether the operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExpirePublishedReport */
export type ExpirePublishedReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the published report to expire. */
  publishedReportId: Scalars['ID']['input'];
};

/** Autogenerated return type of ExpirePublishedReport. */
export type ExpirePublishedReportPayload = {
  __typename?: 'ExpirePublishedReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The report after expiry. */
  publishedReport: PublishedReportSummary;
};

/** A column filter in TanStack Table format */
export type ExportFilterInput = {
  /** Column ID */
  id: Scalars['String']['input'];
  /** Filter value object (operator + value(s)) */
  value: FilterValueInput;
};

/** Service calendar v1 export payload for an advisor */
export type ExportPayload = {
  __typename?: 'ExportPayload';
  advisorFirstName: Scalars['String']['output'];
  advisorLastName: Scalars['String']['output'];
  households: Array<HouseholdExport>;
};

/** A sort specification in TanStack Table format */
export type ExportSortInput = {
  /** Whether to sort descending */
  desc: Scalars['Boolean']['input'];
  /** Column ID */
  id: Scalars['String']['input'];
};

export type ExtendExtractedDatum = {
  __typename?: 'ExtendExtractedDatum';
  accountData: Scalars['JSON']['output'];
  boxDocumentId: Scalars['String']['output'];
  classificationData: Scalars['JSON']['output'];
  classificationDataType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentClassification: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  holdingsData: Maybe<Scalars['JSON']['output']>;
  household: Maybe<Household>;
  id: Scalars['ID']['output'];
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadingUser: Maybe<User>;
  workflowId: Scalars['String']['output'];
  workflowRunId: Scalars['String']['output'];
};

/** Autogenerated input type of ExtractBoxClientUploadStatements */
export type ExtractBoxClientUploadStatementsInput = {
  /** Box file ids to extract */
  boxDocumentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household the files belong to */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ExtractBoxClientUploadStatements. */
export type ExtractBoxClientUploadStatementsPayload = {
  __typename?: 'ExtractBoxClientUploadStatementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Fixed user-facing message when some files could not be processed */
  error: Maybe<Scalars['String']['output']>;
  /** Files that could not be sent to Extend */
  failedCount: Scalars['Int']['output'];
  /** Files not sent to Extend: already extracted, not in the household folder, or already in progress */
  skippedCount: Scalars['Int']['output'];
  /** Files newly sent to Extend */
  triggeredCount: Scalars['Int']['output'];
};

/** A family member associated with a household */
export type FamilyMember = {
  __typename?: 'FamilyMember';
  /** Street address line 1 */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** Street address line 2 */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** Calculated age based on date of birth */
  age: Maybe<Scalars['String']['output']>;
  /** City */
  city: Maybe<Scalars['String']['output']>;
  /** Date of birth in ISO format */
  dateOfBirth: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  dependentOfHouseholdId: Maybe<Scalars['ID']['output']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  dependentOfUserId: Maybe<Scalars['ID']['output']>;
  /** Email address */
  email: Maybe<Scalars['String']['output']>;
  /** Entity establishment date */
  entityDateEstablished: Maybe<Scalars['String']['output']>;
  /** Entity date of death */
  entityDateOfDeath: Maybe<Scalars['String']['output']>;
  /** Entity EIN for entity relations */
  entityEin: Maybe<Scalars['String']['output']>;
  /** Executor name for estate entities */
  entityExecutorName: Maybe<Scalars['String']['output']>;
  /** Entity name for entity relations */
  entityName: Maybe<Scalars['String']['output']>;
  /** Organization type for organization entities */
  entityOrganizationType: Maybe<Scalars['String']['output']>;
  /** Primary contact role for organization entities */
  entityPrimaryContactRole: Maybe<Scalars['String']['output']>;
  /** Trust type for trust entities */
  entityTrustType: Maybe<Scalars['String']['output']>;
  /** Trustee name for trust entities */
  entityTrusteeName: Maybe<Scalars['String']['output']>;
  /** Entity type for entity relations */
  entityType: Maybe<Scalars['String']['output']>;
  /** Legal first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the family member */
  id: Scalars['ID']['output'];
  /** Whether this contact is a beneficiary */
  isBeneficiary: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection
   */
  isDependent: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact is a trusted contact */
  isTrustedContact: Maybe<Scalars['Boolean']['output']>;
  /** Legal last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Legal middle name */
  middleName: Maybe<Scalars['String']['output']>;
  /** Preferred nickname */
  nickname: Maybe<Scalars['String']['output']>;
  /** Freeform notes about the contact */
  notes: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Relationship to the household */
  relation: Maybe<Scalars['String']['output']>;
  /** Social Security Number */
  ssn: Maybe<Scalars['String']['output']>;
  /** State */
  state: Maybe<Scalars['String']['output']>;
  /** ZIP / postal code */
  zipCode: Maybe<Scalars['String']['output']>;
};

/** A fee schedule option for an advisor to choose from for their clients */
export type FeeSchedule = {
  __typename?: 'FeeSchedule';
  /** The advisor profile for the fee schedule */
  advisorProfile: Advisor;
  /** The type of amount for the fee schedule */
  amountType: Maybe<FeeScheduleAmountTypes>;
  /** The description of the fee schedule */
  description: Maybe<Scalars['String']['output']>;
  /** The type of fee schedule */
  feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  flatFeeAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** The ID of the fee schedule */
  id: Scalars['ID']['output'];
  /** The minimum fee for the fee schedule */
  minimumFee: Maybe<Scalars['BigDecimal']['output']>;
  /** The name of the fee schedule */
  name: Scalars['String']['output'];
  /** The tiers for the fee schedule */
  tiers: Maybe<Scalars['JSON']['output']>;
};

/** Name of the fee schedule amount types */
export type FeeScheduleAmountTypes =
  /** dollar */
  | 'dollar'
  /** percentage */
  | 'percentage';

/** Name of the fee schedule fee types */
export type FeeScheduleFeeTypes =
  /** flat */
  | 'flat'
  /** linear */
  | 'linear'
  /** tiered */
  | 'tiered';

/** Fee Schedule Update variant: change a client's advisory fee structure */
export type FeeScheduleUpdateInput = {
  /** Accounts affected; empty applies to all household accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Current fee, as entered (e.g. "0.75%" or "$5,000/yr") */
  currentFee?: InputMaybe<Scalars['String']['input']>;
  /** Effective date of the fee change; omitted when the timing is future */
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the fee change is immediate or on a future date described in the notes */
  effectiveDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Fee change direction — increase, decrease, or no_change */
  feeChangeType: ClientBillingFeeChangeTypeName;
  /** Confirmation a new IAA was initiated (required when fee is increasing) */
  iaaConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** New fee, as entered */
  newFee: Scalars['String']['input'];
  /** Notes for Ops */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of FetchPlaidAccounts */
export type FetchPlaidAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of FetchPlaidAccounts. */
export type FetchPlaidAccountsPayload = {
  __typename?: 'FetchPlaidAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A single Fidelity position (holding) shown in the trade ticket. */
export type FidelityPosition = {
  __typename?: 'FidelityPosition';
  /** Average cost per share (for cost basis = avgCostPerShare × quantity). */
  avgCostPerShare: Maybe<Scalars['Float']['output']>;
  /** Today's market-value change vs prior close, in dollars. Null under CLOSE pricing. */
  dayChange: Maybe<Scalars['Float']['output']>;
  /** Today's market-value change vs prior close, as a percent. Null under CLOSE pricing. */
  dayChangePct: Maybe<Scalars['Float']['output']>;
  /** Security description. */
  description: Maybe<Scalars['String']['output']>;
  /** Market value (prior-day close under the current entitlement). */
  marketValue: Maybe<Scalars['Float']['output']>;
  /** Per-share price. Recent (DELAYED/REAL_TIME) mark when entitled, else prior-day close. */
  price: Maybe<Scalars['Float']['output']>;
  /** Fidelity pricing method for `price` and `market_value`: CLOSE, DELAYED, or REAL_TIME. */
  priceType: Maybe<Scalars['String']['output']>;
  /** Shares held. */
  quantity: Maybe<Scalars['Float']['output']>;
  /** Ticker/symbol (falls back to CUSIP when the symbol is absent). */
  symbol: Maybe<Scalars['String']['output']>;
  /** Unrealized gain/loss vs cost basis. */
  unrealizedGainLoss: Maybe<Scalars['Float']['output']>;
};

/** Filter value discriminated union using oneOf directive */
export type FilterValueInput =
  /** Checkbox filter value */
  { checkbox: CheckboxFilterInput; date?: never; number?: never; select?: never; text?: never; }
  |  /** Date/datetime/time filter value */
  { checkbox?: never; date: DateFilterInput; number?: never; select?: never; text?: never; }
  |  /** Number/currency filter value */
  { checkbox?: never; date?: never; number: NumberFilterInput; select?: never; text?: never; }
  |  /** Select/tag filter value */
  { checkbox?: never; date?: never; number?: never; select: SelectFilterInput; text?: never; }
  |  /** Text filter value */
  { checkbox?: never; date?: never; number?: never; select?: never; text: TextFilterInput; };

/** Final Bill variant: process the final invoice for a departing client */
export type FinalBillInput = {
  /** Accounts to bill */
  accountIds: Array<Scalars['ID']['input']>;
  /** Whether cash raising is needed — yes, no, or unsure */
  cashRaisingNeeded: ClientBillingCashRaisingNeededName;
  /** Last service date; omitted when the timing is future */
  lastServiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the last service date is immediate or a future date described in the notes */
  lastServiceDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Notes for Ops */
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialOffering = {
  __typename?: 'FinancialOffering';
  /** Editable rich-text body (sanitized HTML); when set, overrides the in-code default blocks. */
  bodyHtml: Maybe<Scalars['String']['output']>;
  /** Description of the financial offering. */
  description: Scalars['String']['output'];
  /** The display order of the financial offering. */
  displayOrder: Maybe<Scalars['Int']['output']>;
  /** Optional note shown beneath the Fee structure section. */
  feeStructureDescription: Maybe<Scalars['String']['output']>;
  /** Fees for the financial offering. */
  fees: Maybe<Array<Detail>>;
  /** Savvy ID of financial offering */
  id: Scalars['ID']['output'];
  /** Other facts of the financial offering. */
  keyFacts: Maybe<Array<Detail>>;
  /** Optional note shown beneath the Key facts section. */
  keyFactsDescription: Maybe<Scalars['String']['output']>;
  /** Links of the financial offering. */
  links: Maybe<Array<Detail>>;
  /** Optimistic-locking token; pass back to updateFinancialOffering to detect concurrent edits. */
  lockVersion: Scalars['Int']['output'];
  /** Long description of the financial offering. */
  longDescription: Maybe<Scalars['String']['output']>;
  /** The name of the financial offering. */
  name: Scalars['String']['output'];
  /** Providers of the financial offering. */
  providers: Maybe<Array<FinancialOfferingProvider>>;
  /** Quick links from the financial offering and its providers, ordered by quick_link_order. */
  quickLinks: Maybe<Array<Detail>>;
  /** The status of the financial offering. */
  status: FinancialOfferingStatus;
  /** True when the offering name is coupled to behavioral UI and must stay read-only. */
  systemManaged: Scalars['Boolean']['output'];
  /** The type or category of financial offering. */
  type: FinancialOfferingTypeName;
};

/**
 * A fee or key-fact row on a financial offering. Omit `id` to create a new row;
 * existing rows absent from the payload are deleted.
 */
export type FinancialOfferingDetailInput = {
  /** Detail id of an existing row; omit to create a new one */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Row label (required) */
  label: Scalars['String']['input'];
  /** Row value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A link/document row on a financial offering. Omit `id` to create a new row;
 * existing rows absent from the payload are deleted.
 */
export type FinancialOfferingLinkInput = {
  /** Optional short description shown beside the link in the Resources table */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional Cloudinary-hosted icon image shown beside the link; must be an app Cloudinary asset URL */
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Detail id of an existing link; omit to create a new one */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Link label (required) */
  label: Scalars['String']['input'];
  /** When set, marks this link as a quick link at the given order; must be unique among the offering's links */
  quickLinkOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Link URL — must be a valid http(s) URL */
  value: Scalars['String']['input'];
};

export type FinancialOfferingProvider = {
  __typename?: 'FinancialOfferingProvider';
  /** Editable "Contacts" blurb; when set, overrides the in-code default. */
  contactText: Maybe<Scalars['String']['output']>;
  /** Contacts of the financial offering provider. */
  contacts: Maybe<Array<Contact>>;
  /** The description of the financial offering provider. */
  description: Maybe<Scalars['String']['output']>;
  /** Savvy ID of financial offering provider */
  id: Scalars['ID']['output'];
  /** Links related to the financial offering provider. */
  links: Maybe<Array<Detail>>;
  /** The url for the logo of the financial offering provider. */
  logo: Maybe<Scalars['String']['output']>;
  /** The name of the financial offering provider. */
  name: Scalars['String']['output'];
  /** True when the provider name is coupled to behavioral UI and must stay read-only. */
  systemManaged: Scalars['Boolean']['output'];
};

/** Editable copy for a provider section on the offering. */
export type FinancialOfferingProviderInput = {
  /** Editable "Contacts" blurb; overrides the in-code default */
  contactText?: InputMaybe<Scalars['String']['input']>;
  /** Provider description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Provider id; omit/null to create a new section. Existing providers not present in the payload are removed. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Full set of provider resource links; nil leaves them untouched */
  links?: InputMaybe<Array<FinancialOfferingLinkInput>>;
  /** Provider logo URL */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Provider name (section title); required for new sections, rejected on system-managed providers */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialOfferingStatus =
  /** Active offering shown in app */
  | 'active'
  /** Hidden financial offering not visible to users */
  | 'hidden';

export type FinancialOfferingTypeName =
  | 'AdditionalPartners'
  | 'Alternatives'
  | 'Banking'
  | 'CashManagement'
  | 'Planning'
  | 'ProtectionAndRetirement'
  | 'PublicInvesting'
  | 'SWIM';

/** A financial plan for a household */
export type FinancialPlan = {
  __typename?: 'FinancialPlan';
  /** The Conquest plan ID */
  conquestPlanId: Scalars['String']['output'];
  /** The URL of the Conquest plan */
  conquestPlanUrl: Scalars['String']['output'];
  /** The URL of the Conquest plan story for advisors */
  conquestStoryAdvisorUrl: Maybe<Scalars['String']['output']>;
  /** The URL of the Conquest plan story for clients */
  conquestStoryClientUrl: Maybe<Scalars['String']['output']>;
  /** The Conquest plan story ID */
  conquestStoryId: Maybe<Scalars['String']['output']>;
  /** Whether the Conquest plan story has been published to the client */
  conquestStoryPublished: Scalars['Boolean']['output'];
  /** When the financial plan was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The plan presentations/stories from Conquest */
  digitalStories: Array<DigitalStory>;
  /** The household associated with the financial plan */
  household: Household;
  /** The Savvy ID of the financial plan */
  id: Scalars['ID']['output'];
  /** When the financial plan was last updated in Conquest */
  lastUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the financial plan was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FinancialPlanningBoxFolderData = {
  __typename?: 'FinancialPlanningBoxFolderData';
  /** The access token used for Box UI Elements. */
  accessToken: Maybe<Scalars['String']['output']>;
  /** The ID of the most recently uploaded file in the financial plan report folder */
  financialPlanReportFileId: Maybe<Scalars['String']['output']>;
  /** The upload date of the most recently uploaded file in the financial plan report folder */
  financialPlanReportFileUploadDate: Maybe<Scalars['String']['output']>;
  /** The ID of the financial plan report folder */
  financialPlanReportFolderId: Maybe<Scalars['String']['output']>;
};

export type FinancialRecommendation = {
  __typename?: 'FinancialRecommendation';
  category: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
};

/** An advisor in the current firm who can be seeded into a new team */
export type FirmTeamCandidate = {
  __typename?: 'FirmTeamCandidate';
  /** The advisor's first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** The advisor user id (pass as advisorUserIds) */
  id: Scalars['ID']['output'];
  /** The advisor's last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** The advisor's profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** A single task display item that is not part of a multi-household service-item group */
export type FlatTaskOccurrence = {
  __typename?: 'FlatTaskOccurrence';
  /** The underlying task id */
  id: Scalars['ID']['output'];
  /** The task this display item represents */
  task: Task;
};

/** The kyc status from footprint. */
export type FootprintStatus =
  /** error */
  | 'error'
  /** fail */
  | 'fail'
  /** incomplete */
  | 'incomplete'
  /** manual_review */
  | 'manual_review'
  /** none */
  | 'none'
  /** pass */
  | 'pass';

/** A pre-filled IWS/Schwab app PDF (uploaded to S3 via RequestRepaperPdfUploadUrls) plus its DocuSign signer tabs */
export type FormDocumentInput = {
  /** DEPRECATED — legacy inline base64 PDF. Ignored by the backend; removed after the HAWK-70 FE rollout. */
  base64Pdf?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the document in the DocuSign envelope */
  documentName: Scalars['String']['input'];
  /** Stable form identifier (e.g. fidelity-iws-personal, schwab-app13582) */
  formId: Scalars['String']['input'];
  /** S3 key from requestRepaperPdfUploadUrls. Required at runtime — flag-gated until FE migration completes. */
  s3Key?: InputMaybe<Scalars['String']['input']>;
  /** Signer tabs to bind to this document via anchor strings */
  signerTabs: Array<SignerTabInput>;
};

/** Autogenerated input type of GenerateAllQuarterlyReports */
export type GenerateAllQuarterlyReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of household IDs to generate reports for. If not provided, generates for all eligible households. */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of GenerateAllQuarterlyReports. */
export type GenerateAllQuarterlyReportsPayload = {
  __typename?: 'GenerateAllQuarterlyReportsPayload';
  /** Sidekiq batch ID for tracking */
  batchId: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of households enqueued for processing */
  enqueuedCount: Maybe<Scalars['Int']['output']>;
  /** Status message */
  message: Maybe<Scalars['String']['output']>;
  /** Whether the batch was successfully enqueued */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateCoClientTask */
export type GenerateCoClientTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateCoClientTask. */
export type GenerateCoClientTaskPayload = {
  __typename?: 'GenerateCoClientTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of GenerateDirectoryProfileDraft */
export type GenerateDirectoryProfileDraftInput = {
  /** Free-text about the practice / approach. */
  aboutPractice?: InputMaybe<Scalars['String']['input']>;
  /** Free-text about the advisor's background / story. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Free-text describing the advisor's typical clients. */
  clientTypes?: InputMaybe<Scalars['String']['input']>;
  /** Free-text designations / organizations the advisor listed. */
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An existing bio to refine rather than copy verbatim. */
  currentBio?: InputMaybe<Scalars['String']['input']>;
  /** Three or four topics the advisor wants to be known for. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Years of experience. */
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GenerateInvestmentProposal */
export type GenerateInvestmentProposalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newFileName?: InputMaybe<Scalars['String']['input']>;
  replacementData: InvestmentProposalReplacementData;
  selectedCharts?: InputMaybe<Array<InvestmentProposalCharts>>;
};

/** Autogenerated return type of GenerateInvestmentProposal. */
export type GenerateInvestmentProposalPayload = {
  __typename?: 'GenerateInvestmentProposalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  presentationDownloadAsPdfUrl: Scalars['String']['output'];
  presentationId: Scalars['String']['output'];
  presentationUrl: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateOrionReport */
export type GenerateOrionReportInput = {
  /**
   * Savvy Account ID. Provide exactly one of household_id, account_id, or
   * account_sleeve_id. Use account_id for reports that run at the Orion Account
   * entity level on a parent account (e.g. Direct Index Report on a
   * single-strategy account).
   */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Savvy AccountSleeve ID. Provide exactly one of household_id, account_id, or
   * account_sleeve_id. Use account_sleeve_id when the Direct Indexing strategy
   * lives in a sleeve of a multi-strategy account.
   */
  accountSleeveId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End date (inclusive). Required if start_date is provided. */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Orion Household ID. Provide exactly one of household_id, account_id, or account_sleeve_id. */
  householdId?: InputMaybe<Scalars['String']['input']>;
  /**
   * [DEPRECATED] Quick date period. Valid values: "past_month", "last_quarter",
   * "past_year". Use start_date and end_date instead. If start_date/end_date are
   * also provided, explicit dates take precedence and quick_date is ignored.
   * @deprecated Use start_date and end_date instead. This argument will be removed in a future version.
   */
  quickDate?: InputMaybe<Scalars['String']['input']>;
  /** Which Orion report to generate */
  reportId: Scalars['String']['input'];
  /**
   * Start date (inclusive). Required if end_date is provided. For "from inception"
   * reports, use 1900-01-01 or the household's creation date.
   */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of GenerateOrionReport. */
export type GenerateOrionReportPayload = {
  __typename?: 'GenerateOrionReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /**
   * URL to download the report
   * @deprecated Use orionReportGeneration.downloadUrl for async report generation. This field returns a placeholder in async mode.
   */
  downloadUrl: Scalars['String']['output'];
  /** The async report generation record (only populated when async flag is enabled) */
  orionReportGeneration: Maybe<OrionReportGeneration>;
};

/** Autogenerated input type of GeneratePortfolioInsights */
export type GeneratePortfolioInsightsInput = {
  accountId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GeneratePortfolioInsights. */
export type GeneratePortfolioInsightsPayload = {
  __typename?: 'GeneratePortfolioInsightsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  insights: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateSalesforceAccessToken */
export type GenerateSalesforceAccessTokenInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateSalesforceAccessToken. */
export type GenerateSalesforceAccessTokenPayload = {
  __typename?: 'GenerateSalesforceAccessTokenPayload';
  accessToken: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateServiceEmailDraft */
export type GenerateServiceEmailDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the service calendar event (e.g. "Annual review"). */
  eventName: Scalars['String']['input'];
};

/** Autogenerated input type of GetNotionMcpAccessToken */
export type GetNotionMcpAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetNotionMcpAccessToken. */
export type GetNotionMcpAccessTokenPayload = {
  __typename?: 'GetNotionMcpAccessTokenPayload';
  /** The Notion MCP access token */
  accessToken: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if token retrieval failed */
  error: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GetOrCreateAprilToken */
export type GetOrCreateAprilTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetOrCreateAprilToken. */
export type GetOrCreateAprilTokenPayload = {
  __typename?: 'GetOrCreateAprilTokenPayload';
  /** access token */
  accessToken: Scalars['String']['output'];
  /** auth code */
  authCode: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  error: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GetOrCreateHouseholdMemberAprilFilingToken */
export type GetOrCreateHouseholdMemberAprilFilingTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** client user_id we are requesting april token for */
  clientUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetOrCreateHouseholdMemberAprilFilingToken. */
export type GetOrCreateHouseholdMemberAprilFilingTokenPayload = {
  __typename?: 'GetOrCreateHouseholdMemberAprilFilingTokenPayload';
  /** access token */
  accessToken: Scalars['String']['output'];
  /** auth code */
  authCode: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  error: Maybe<Scalars['String']['output']>;
};

export type Goal = {
  __typename?: 'Goal';
  /** Description of the goal, as well as any client-facing advisor notes. */
  description: Maybe<Scalars['String']['output']>;
  /** The goal end date. */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** A goal's Savvy ID. */
  id: Scalars['ID']['output'];
  /** The name of the goal. */
  name: Scalars['String']['output'];
  /** The percent a goal is funded. */
  percentFunded: Maybe<Scalars['Int']['output']>;
  /** The goal start date. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The status of the goal. */
  status: GoalStatusName;
  /** The target dollar amount for the goal. */
  targetUsd: Maybe<Scalars['BigDecimal']['output']>;
  /** The type of goal. */
  type: GoalTypeName;
};

export type GoalStatusName =
  | 'at_risk'
  | 'completed'
  | 'off_track'
  | 'on_track';

export type GoalTypeName =
  | 'education'
  | 'other'
  | 'planning'
  | 'purchase'
  | 'retirement';

export type GovernmentId = {
  __typename?: 'GovernmentId';
  expirationDate: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idNumber: Maybe<Scalars['String']['output']>;
  issueDate: Maybe<Scalars['String']['output']>;
  issuingAuthority: Maybe<Scalars['String']['output']>;
  typeOf: Maybe<Scalars['String']['output']>;
};

/** A single product line in the Group Performance table (per-holding returns grouped by asset category). */
export type GroupPerformanceRow = {
  __typename?: 'GroupPerformanceRow';
  /** Top-level asset category this row groups under (e.g. 'Equity'). Null when Orion does not categorize the holding. */
  assetCategory: Maybe<Scalars['String']['output']>;
  /** Date the position was opened (Orion inception date). Null when unavailable. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Inception-to-date (all-time) time-weighted return as a fraction (e.g. 0.0490 = 4.90%). Null when unavailable. */
  inceptionToDateReturn: Maybe<Scalars['Float']['output']>;
  /** Market value of the position as of the report date, in USD. Null when unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Product / security display name. */
  name: Scalars['String']['output'];
  /** Trailing one-year time-weighted return as a fraction. Null when the position has under one year of history. */
  oneYearReturn: Maybe<Scalars['Float']['output']>;
  /** Ticker symbol; null for cash or untickered securities. */
  ticker: Maybe<Scalars['String']['output']>;
  /** Year-to-date time-weighted return as a fraction. Null when unavailable. */
  yearToDateReturn: Maybe<Scalars['Float']['output']>;
};

/** Asset-category subtotal row in the Group Performance table. */
export type GroupPerformanceTotal = {
  __typename?: 'GroupPerformanceTotal';
  /** Asset category this subtotal covers (e.g. 'Equity'). */
  assetCategory: Scalars['String']['output'];
  /** Inception-to-date category TWR as a fraction. Null when unavailable. */
  inceptionToDateReturn: Maybe<Scalars['Float']['output']>;
  /** Total market value of the asset category, in USD. Null when unavailable. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Trailing one-year category TWR as a fraction. Null when unavailable. */
  oneYearReturn: Maybe<Scalars['Float']['output']>;
  /** Year-to-date category TWR as a fraction. Null when unavailable. */
  yearToDateReturn: Maybe<Scalars['Float']['output']>;
};

/** Monetary value at a point in time. */
export type HistoricalValue = {
  __typename?: 'HistoricalValue';
  /** The date in time. */
  date: Scalars['ISO8601Date']['output'];
  /** The monetary value at a point in time. */
  value: Value;
};

/** Holding held by the user in an account. */
export type Holding = {
  __typename?: 'Holding';
  /** The Savvy ID of the account associated with the holding */
  accountId: Maybe<Scalars['ID']['output']>;
  /** The average cost basis of this entire holding */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** The cost basis lots associated with this holding */
  costBasisLots: Maybe<Array<CostBasisLot>>;
  /** When the holding was added. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the holding. */
  id: Scalars['ID']['output'];
  /** The timestamp the holding was last updated with information from the source provider. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The quantity held of the security in this holding */
  quantity: Maybe<Scalars['BigDecimal']['output']>;
  /** The Savvy ID of the security associated with the holding */
  security: Maybe<Security>;
  /** The latest value of this holding of the associated security */
  value: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native holdings summary report — replaces the Orion-generated PDF (HAWK-23).
 * Sourced from the Orion Connect snapshot pipeline; only Connect-tracked
 * households are supported. When a householdId is supplied, non-Orion accounts are
 * filtered out silently to match the legacy Holdings Report's behavior. When
 * accountIds are supplied, the resolver raises if any requested account is not Orion-sourced.
 */
export type HoldingsSummary = {
  __typename?: 'HoldingsSummary';
  /**
   * One row per account in scope, used to render the "Appendix – Summary of
   * Accounts" page. Ordered by management_strategy (Managed first, then
   * Unmanaged), then by account_name.
   */
  accountSummaries: Array<HoldingsSummaryAccount>;
  /**
   * Full name of the household's assigned advisor, for the report header ("Your
   * Financial Advisor is {advisorName}"). Null when the household has no advisor.
   */
  advisorName: Maybe<Scalars['String']['output']>;
  /**
   * Effective end date for the report — the date of the snapshot actually
   * rendered. Orion may snap a requested date to a nearby trading day (weekend /
   * holiday / future), so this can differ from `requestedEndDate`.
   */
  endDate: Scalars['ISO8601Date']['output'];
  /** Stable identifier for this report scope (household or account selection). */
  id: Scalars['ID']['output'];
  /**
   * The exact `endDate` the caller supplied, before any Orion snapping. Compare to
   * `endDate` to detect when Orion returned data for a different day than was requested.
   */
  requestedEndDate: Scalars['ISO8601Date']['output'];
  /** One row per active holding across the requested scope. */
  rows: Array<HoldingsSummaryRow>;
  /**
   * Start of the reporting period the caller supplied. Captured for header display
   * ("For the date range of {startDate} to {endDate}"); does not influence which
   * snapshot is read.
   */
  startDate: Scalars['ISO8601Date']['output'];
  /** Sum of cost_basis across rows; amount is null if any row lacks cost_basis. */
  totalCostBasis: HoldingsSummaryMoney;
  /** Sum of estimated_income across rows; amount is null if any row lacks estimated_income. */
  totalEstimatedIncome: HoldingsSummaryMoney;
  /** Sum of market_value across rows. */
  totalMarketValue: HoldingsSummaryMoney;
  /** total_market_value minus total_cost_basis; amount is null if total_cost_basis amount is null. */
  totalUnrealizedGainLoss: HoldingsSummaryMoney;
};

/** One row in the "Appendix – Summary of Accounts" section of the Holdings Summary report. */
export type HoldingsSummaryAccount = {
  __typename?: 'HoldingsSummaryAccount';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Display name of the account (Account#display_name). */
  accountName: Scalars['String']['output'];
  /** Masked account number (Orion-style "XXX-XX####"); null when no mask is stored. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Humanized account subtype (e.g. "Roth IRA"); falls back to coarse type_of. */
  accountType: Maybe<Scalars['String']['output']>;
  /** Custodian / firm name when known. */
  custodian: Maybe<Scalars['String']['output']>;
  /**
   * Per-asset-class all-time TWR for this account, from Orion's Verbose endpoint.
   * Drives the Orion-matching "Since Inception" on the asset-class /
   * sub-asset-class subtotal rows. Empty when the Verbose fetch was unavailable
   * (subtotals then fall back to a weighted average).
   */
  groupReturns: Array<HoldingsSummaryGroupReturn>;
  /** Stable identifier for the row. */
  id: Scalars['ID']['output'];
  /** Humanized custody label (e.g. "Managed", "Unmanaged"). Drives the Appendix sub-grouping. */
  managementStrategy: Maybe<Scalars['String']['output']>;
  /** Sum of the account's holdings at the report's end_date. */
  marketValue: HoldingsSummaryMoney;
};

/**
 * All-time time-weighted return for one asset-class grouping within an account,
 * sourced from Orion's /Reporting/Performance/Verbose endpoint (the same figure
 * Orion's Holdings Report prints on its asset-class / sub-asset-class subtotal
 * rows). Lets the report render Orion-matching group "Since Inception" instead of
 * a market-value-weighted average of per-holding returns, which does not equal the
 * group-level return.
 */
export type HoldingsSummaryGroupReturn = {
  __typename?: 'HoldingsSummaryGroupReturn';
  /**
   * Which subtotal level this applies to: "asset_class" (Orion Asset Category,
   * e.g. Equity) or "sub_asset_class" (Orion Asset Class, e.g. US Equity).
   */
  level: Scalars['String']['output'];
  /** The asset-class / sub-asset-class name, matching the holdings rows' grouping label. */
  name: Scalars['String']['output'];
  /** All-time TWR as a decimal fraction (0.2113 = 21.13%); null when Orion has none. */
  sinceInception: Maybe<Scalars['Float']['output']>;
};

/** Monetary value used by native report payloads. */
export type HoldingsSummaryMoney = {
  __typename?: 'HoldingsSummaryMoney';
  /** Numerical amount; null when no underlying data is available. */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the amount. */
  currencyCode: Scalars['String']['output'];
};

/**
 * A single holding line in the native Holdings Summary report. Most consumers only
 * ever see currently-held positions, but a consumer that opted into retaining sold
 * positions may include a row with zero quantity/market_value representing a
 * position sold during the reporting period, not a data gap.
 */
export type HoldingsSummaryRow = {
  __typename?: 'HoldingsSummaryRow';
  /** Savvy account ID this holding belongs to. */
  accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), when available. */
  accountMask: Maybe<Scalars['String']['output']>;
  /** Display name of the account. */
  accountName: Scalars['String']['output'];
  /** Full account number, when available on the account record. */
  accountNumber: Maybe<Scalars['String']['output']>;
  /**
   * Top-level asset category from Orion (e.g. 'Equity', 'Cash & Cash
   * Equivalents'). Drives the primary template grouping; null when Orion does not
   * categorize the holding.
   */
  assetClass: Maybe<Scalars['String']['output']>;
  /** Coarse asset type from Orion's product type (e.g. equity, etf, bond, cash). Always present. */
  assetType: Scalars['String']['output'];
  /** Total cost basis for the position; null when not tracked. */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the row. */
  currencyCode: Scalars['String']['output'];
  /** Annualized current yield as a decimal (e.g. 0.025 for 2.5%); null when not provided by Orion. */
  currentYield: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized estimated income for the position; null when not provided by Orion. */
  estimatedIncome: Maybe<HoldingsSummaryMoney>;
  /** Market value as of the report date, sourced from the Orion snapshot for that as-of-date. */
  marketValue: HoldingsSummaryMoney;
  /** Security name; falls back to ticker when name isn't set. */
  name: Scalars['String']['output'];
  /** Date the position was opened (Orion 'inception date' for the holding); null when Orion does not provide it. */
  openDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** This row's market_value divided by total_market_value across the report scope. 0 when total is 0. */
  percentOfPortfolio: Scalars['BigDecimal']['output'];
  /** Latest close price per unit; null when not available. */
  pricePerUnit: Maybe<Scalars['BigDecimal']['output']>;
  /** Current quantity held. */
  quantity: Scalars['BigDecimal']['output'];
  /** Savvy security ID for this row, when the Orion product has a matching local security record. */
  securityId: Maybe<Scalars['ID']['output']>;
  /**
   * TWR since position opened: annualized for multi-year periods, cumulative for
   * sub-year (Orion annualize:true). Decimal, e.g. 0.2171. Null when unavailable.
   */
  sinceInceptionReturn: Maybe<Scalars['Float']['output']>;
  /**
   * Sub-asset class within asset_class (e.g. 'US Equity', 'International
   * Developed', 'Cash'). Drives the second-level template grouping; null when
   * Orion does not provide it.
   */
  subAssetClass: Maybe<Scalars['String']['output']>;
  /** Ticker symbol (e.g. AAPL); may be null for cash or untickered securities. */
  ticker: Maybe<Scalars['String']['output']>;
  /** market_value.amount minus cost_basis; null if either is null. */
  unrealizedGainLoss: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return, as a decimal (e.g. 0.0783 for 7.83%). Null when Orion has no YTD TWR for the position. */
  ytdReturn: Maybe<Scalars['Float']['output']>;
};

export type Household = {
  __typename?: 'Household';
  /** Advisor access permissions for this household */
  accessPermissions: Maybe<Array<Permission>>;
  /** The latest open account confirmation task for this household */
  accountConfirmationTask: Maybe<Task>;
  /**
   * Whether the monthly account-connection reminder email is disabled for this
   * household -- true if the advisor silenced it, or if no preference has been set
   */
  accountConnectionReminderDisabled: Scalars['Boolean']['output'];
  /** Number of accounts associated with this household */
  accountCount: Scalars['Int']['output'];
  /** Account transfer information for this household */
  accountTransferData: Array<AccountTransferDatum>;
  /** Accounts associated with this household */
  accounts: Maybe<Array<Account>>;
  /** Box subfolder ID for account documents; null until the household is linked to Box. */
  accountsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Whether this household is an accredited investor */
  accreditedInvestor: Scalars['Boolean']['output'];
  /** The rationale for why this household is an accredited investor */
  accreditedInvestorRationale: Maybe<Scalars['String']['output']>;
  adviceOnly: Maybe<Scalars['Boolean']['output']>;
  /** The advisor for this household */
  advisor: Maybe<Advisor>;
  advisorAnnualRevenue: Maybe<Scalars['BigDecimal']['output']>;
  advisorLeadSource: Maybe<Scalars['String']['output']>;
  /**
   * Freeform detail supplied by the advisor to describe an "Other" lead source
   * (e.g. "Podcast interview"). Only meaningful when advisor_lead_source is "Other".
   */
  advisorLeadSourceDetail: Maybe<Scalars['String']['output']>;
  /** The advisors assigned to this household */
  assignedAdvisors: Array<Advisor>;
  /** The bio for this household */
  bio: Maybe<Scalars['String']['output']>;
  /**
   * Book-transfer onboarding cockpit row for this household, when the household is
   * in an advisor onboarding enrollment and has not been dismissed.
   */
  bookOnboardingCockpit: Maybe<OnboardingCockpitRow>;
  /**
   * Root Box folder for this household. Used to scope the canvas agent's document
   * access; null until the household is linked to Box.
   */
  boxFolderId: Maybe<Scalars['String']['output']>;
  clientPortalMessage: Maybe<ClientPortalMessage>;
  clientReviewDueThisQuarter: Scalars['Boolean']['output'];
  /** Box subfolder ID for client-upload documents; null until the household is linked to Box. */
  clientUploadsBoxFolderId: Maybe<Scalars['String']['output']>;
  coClient: Maybe<Client>;
  /** The onboarding status for the co-client */
  coClientOnboardingStatus: Maybe<OnboardingTaskDatum>;
  /**
   * Comment indicator for a Clients-list row, scoped to the viewing user. Batched
   * — safe to request across a page of households.
   */
  commentSummary: CommentSummary;
  /** The date this household signed the contract */
  contractSignatureDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Creation date for this household */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** CSA review conditions for this household */
  csaReviewConditions: Maybe<CsaReviewConditions>;
  /** Whether this household is enrolled in custodial 1099 reports */
  custodial1099Enrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in custom indexing reports */
  customIndexingReportEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is a demo */
  demo: Scalars['Boolean']['output'];
  /** The reason this household was disqualified */
  disqualifiedReason: Maybe<Scalars['String']['output']>;
  /** Whether prospect tax is enabled for this household */
  enableProspectTax: Scalars['Boolean']['output'];
  /** The family info for this household */
  familyInfo: Maybe<Scalars['String']['output']>;
  /** Family members associated with this household */
  familyMembers: Array<FamilyMember>;
  /** The fee schedule for this household */
  feeSchedule: Maybe<Scalars['String']['output']>;
  firmAnnualRevenue: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether this household has an active (unsubmitted, non-cancelled) ECI custodian-transfer onboarding request */
  hasActiveEciOnboarding: Scalars['Boolean']['output'];
  /**
   * False when this household has no primary_client_profile of its own and the
   * primaryClient field is resolved via the owner-role HouseholdMembership
   * (cross-household reuse).
   */
  hasOwnPrimaryClient: Scalars['Boolean']['output'];
  /** The lead funnel stage of this household */
  householdStage: Maybe<HouseholdStage>;
  /** Household tags for this household */
  householdTags: Maybe<Array<HouseholdTag>>;
  id: Scalars['ID']['output'];
  /** Whether this household is enrolled in income reports */
  incomeReportsEnrolled: Scalars['Boolean']['output'];
  /** Professional relationship edges targeting this household (e.g. contacts that serve it). Filter by relationshipType. */
  incomingProfessionalRelationships: Array<ProfessionalRelationship>;
  /** Investment experience records for this household */
  investmentExperiences: Array<InvestmentExperience>;
  /** Whether this household is enrolled in invoice reports */
  invoicesEnrolled: Scalars['Boolean']['output'];
  /** The last assigned campaign for this household */
  lastAssignedCampaign: Maybe<AssignedCampaign>;
  lastContactAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  leadResponseDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * External bank accounts authorized for transfers to/from any of this
   * household's Savvy-managed accounts. Union across the household.
   */
  linkedBankAccounts: Array<LinkedBankAccount>;
  /** The reason this household was lost */
  lossReason: Maybe<Scalars['String']['output']>;
  /** Second drill-down of the traffic source (e.g. campaign, keyword, or landing page), synced from HubSpot. Read-only. */
  marketingDetail: Maybe<Scalars['String']['output']>;
  /** First drill-down of the traffic source (e.g. platform / search engine), synced from HubSpot. Read-only. */
  marketingSource: Maybe<Scalars['String']['output']>;
  /** Channel the lead first came from, synced from HubSpot Original Traffic Source (e.g. "Paid Social"). Read-only. */
  marketingTrafficSource: Maybe<Scalars['String']['output']>;
  /** Household memberships scoping member users to their role in this household */
  memberships: Array<HouseholdMembership>;
  name: Scalars['String']['output'];
  /**
   * The soonest upcoming service obligation for this household: the earliest due
   * date across pending Service Catalog v2 tasks and incomplete service-calendar
   * meetings, on or before the end of next quarter (overdue items included). Null
   * when none. Read this under flag-service-calendar-v2.
   */
  nextServiceItemDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextUpcomingMeetings: Array<ServiceCalendarMeeting>;
  /** If the client is subject to any restrictive covenants */
  nonSolicit: Maybe<Scalars['Boolean']['output']>;
  /** The onboarding status for this household */
  onboardingStatus: Maybe<OnboardingTaskDatum>;
  /** Opportunities clients in this household have */
  opportunities: Maybe<Array<Opportunity>>;
  /** Organization household categories for this household */
  organizationHouseholdCategories: Maybe<Array<OrganizationHouseholdCategory>>;
  /** Organization household tags for this household */
  organizationHouseholdTags: Maybe<Array<OrganizationHouseholdTag>>;
  orionHouseholdId: Maybe<Scalars['Int']['output']>;
  /** History of Orion quarterly report generations for this household */
  orionQuarterlyReportGenerations: Array<OrionQuarterlyReportGeneration>;
  outstandingServiceCalendarItemCount: Maybe<Scalars['Int']['output']>;
  outstandingServiceCalendarItems: Array<ServiceCalendarItem>;
  /**
   * Count of pending Service Catalog (SC v2) tasks for this household due on or
   * before the end of the current quarter (overdue items included). Null when the
   * household has no Service Catalog assignments at all — render that as "Not set
   * up", distinct from 0, which means "assigned, nothing due". The v2 equivalent
   * of outstandingServiceCalendarItemCount — read this when the viewer is on
   * flag-service-calendar-v2.
   */
  outstandingServiceCatalogTaskCount: Maybe<Scalars['Int']['output']>;
  /** Whether this household is enrolled in performance report allocations reports */
  performanceReportAllocationsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report consolidated reports */
  performanceReportConsolidatedEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report integrated reports */
  performanceReportIntegratedEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report sectors reports */
  performanceReportSectorsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report unified reports */
  performanceReportUnifiedEnrolled: Scalars['Boolean']['output'];
  personalPortfolio: Maybe<Portfolio>;
  /** Whether this household is enrolled in portfolio review portfolio group reports */
  portfolioReviewPortfolioGroupEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in portfolio summary cash flows reports */
  portfolioSummaryCashFlowsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in portfolio summary comprehensive reports */
  portfolioSummaryComprehensiveEnrolled: Scalars['Boolean']['output'];
  portfolios: Array<Portfolio>;
  /**
   * The household primary client_profile, falling back to the
   * HouseholdMembership(owner) user's existing ClientProfile when the household
   * has no primary_client of its own (SV-940 cross-household reuse).
   */
  primaryClient: Client;
  /** Box subfolder ID for advisor-only ("private") household documents; null until the household is linked to Box. */
  privateBoxFolderId: Maybe<Scalars['String']['output']>;
  /** The prospect data for this household */
  prospectData: Maybe<ProspectDatum>;
  /** Box subfolder ID for client-visible ("public") household documents; null until the household is linked to Box. */
  publicBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Whether this household is a qualified client */
  qualifiedClient: Scalars['Boolean']['output'];
  /** The rationale for why this household is a qualified client */
  qualifiedClientRationale: Maybe<Scalars['String']['output']>;
  /** Whether this household is a qualified purchaser */
  qualifiedPurchaser: Scalars['Boolean']['output'];
  /** The rationale for why this household is a qualified purchaser */
  qualifiedPurchaserRationale: Maybe<Scalars['String']['output']>;
  /** Whether this household is enrolled in quarterly reports (long) */
  quarterlyReportsLongEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in quarterly reports (short) */
  quarterlyReportsShortEnrolled: Scalars['Boolean']['output'];
  /** The ID of the entity that referred this household */
  referralEntityId: Maybe<Scalars['ID']['output']>;
  /** The type of the entity that referred this household (User or CenterOfInfluenceRep) */
  referralEntityType: Maybe<Scalars['String']['output']>;
  salesforceAccountId: Maybe<Scalars['String']['output']>;
  savvyAum: Maybe<Scalars['BigDecimal']['output']>;
  serviceCalendarItemsDueNextQuarter: Array<ServiceCalendarItem>;
  serviceCalendarSettings: Array<ServiceCalendarSetting>;
  /** Box subfolder ID for task-attachment documents; null until the household is linked to Box. */
  taskAttachmentsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Box subfolder ID for task-upload documents; null until the household is linked to Box. */
  taskUploadsBoxFolderId: Maybe<Scalars['String']['output']>;
  /** Tasks created for this household */
  tasks: Array<Task>;
  /** Which tax enrollment banner to show, if any */
  taxEnrollmentBannerStatus: TaxEnrollmentBannerStatus;
  /** Tax enrollments for this household */
  taxEnrollments: Maybe<Array<TaxEnrollment>>;
  /** Last update date for this household */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
  /** Public-facing UUID for this household; preferred over salesforce_account_id for new code */
  uuid: Scalars['String']['output'];
  /** The current viewer's membership in this household, if any (null for advisors without a membership) */
  viewerMembership: Maybe<HouseholdMembership>;
};


export type HouseholdAccountConfirmationTaskArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type HouseholdAccountsArgs = {
  source?: InputMaybe<ProviderAccountSource>;
};


export type HouseholdAssignedAdvisorsArgs = {
  advisorRoleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholdAccessAuditResult = {
  __typename?: 'HouseholdAccessAuditResult';
  advisorName: Scalars['String']['output'];
  advisorUserId: Scalars['ID']['output'];
  boxAccess: Scalars['Boolean']['output'];
  householdId: Scalars['ID']['output'];
  householdName: Scalars['String']['output'];
  salesforceAccess: Scalars['Boolean']['output'];
  savvyPermissions: Scalars['Boolean']['output'];
};

export type HouseholdAccessLevel =
  /** Edit access level */
  | 'EDIT'
  /** No access level */
  | 'NO_ACCESS';

/**
 * A blended benchmark available in Orion (e.g. "60% Russell 3000 / 40% BBG US
 * Agg"), selectable in the Report Builder benchmark picker.
 */
export type HouseholdBenchmarkBlend = {
  __typename?: 'HouseholdBenchmarkBlend';
  /** Human-readable blend name shown in the picker (Orion's benchmark name). */
  label: Scalars['String']['output'];
  /** Orion benchmark key to persist on the household, e.g. "5_B". */
  value: Scalars['String']['output'];
};

/** The connection type for Household. */
export type HouseholdConnection = {
  __typename?: 'HouseholdConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<HouseholdEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Household>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Aggregate total advisor annual revenue */
  totalAdvisorAnnualRevenue: Maybe<Scalars['BigInt']['output']>;
  /** Total number of households */
  totalCount: Scalars['Int']['output'];
  /** Aggregate total Savvy AUM */
  totalSavvyAum: Maybe<Scalars['BigInt']['output']>;
};

/** An edge in a connection. */
export type HouseholdEdge = {
  __typename?: 'HouseholdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Household>;
};

/** One service a household is enrolled in, resolved through the enrollment's own service foreign key */
export type HouseholdEnrolledService = {
  __typename?: 'HouseholdEnrolledService';
  /** Colour key for the service identity chip (4C1T-570) */
  colorKey: Scalars['String']['output'];
  /** Long-form description */
  description: Maybe<Scalars['String']['output']>;
  /** Icon key for the service identity chip (4C1T-570) */
  iconKey: Scalars['String']['output'];
  /** The service id. A card links to the service with it */
  id: Scalars['ID']['output'];
  /** One entry per enrolled item — "task" or "event" — so a card can count them itself and read "1 task · 1 event" */
  itemTypes: Array<Scalars['String']['output']>;
  /** Service name */
  name: Scalars['String']['output'];
  /**
   * True when every one of the household's enrollments in this service is paused,
   * which is how unenrolling is recorded. A service with some items still live
   * reads as not paused
   */
  paused: Scalars['Boolean']['output'];
};

/** Household-scoped service calendar v1 export data */
export type HouseholdExport = {
  __typename?: 'HouseholdExport';
  householdId: Scalars['ID']['output'];
  householdName: Scalars['String']['output'];
  householdStage: Scalars['String']['output'];
  meetings: Array<MeetingInstance>;
  primaryClientName: Maybe<Scalars['String']['output']>;
  serviceItems: Array<ServiceItemInstance>;
};

/** A fee schedule for a household, saved on onboarding task creation */
export type HouseholdFeeSchedule = {
  __typename?: 'HouseholdFeeSchedule';
  /** Whether the fee schedule is active on household */
  active: Scalars['Boolean']['output'];
  /** The type of amount for the fee schedule - percentage or dollar */
  amountType: Maybe<FeeScheduleAmountTypes>;
  /** The description of the fee schedule */
  description: Maybe<Scalars['String']['output']>;
  /** The type of fee schedule - flat, tiered, or linear */
  feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  flatFeeAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** associated with household */
  householdId: Scalars['ID']['output'];
  /** household fee schedule id */
  id: Scalars['ID']['output'];
  /** The minimum fee for the fee schedule */
  minimumFee: Maybe<Scalars['BigDecimal']['output']>;
  /** The name of the fee schedule */
  name: Scalars['String']['output'];
  /** The tiers for the fee schedule */
  tiers: Maybe<Scalars['JSON']['output']>;
};

/**
 * A short, durable statement of what has actually been discussed with a household,
 * written by a model and saved once per household
 */
export type HouseholdKeepInMind = {
  __typename?: 'HouseholdKeepInMind';
  /** When the text last changed. A no-op rewrite holds this steady, so a vote cast against it stays attached */
  generatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Zero to three items. Empty means nothing has been written yet — the section mounts on this and polls */
  items: Array<HouseholdKeepInMindItem>;
  /** A rewrite is running. This is what the section polls on, so the frontend never re-derives the freshness comparison */
  refreshing: Scalars['Boolean']['output'];
};

/** Why an advisor marked a "Keep in mind" item unhelpful */
export type HouseholdKeepInMindIssueTypeEnum =
  /** The claim rests on something untrue */
  | 'INCORRECT_ASSUMPTIONS'
  /** The claim is factually wrong */
  | 'INCORRECT_INFORMATION'
  /** True, but not worth surfacing */
  | 'NOT_RELEVANT'
  /** Something else, described in the comment */
  | 'OTHER'
  /** The claim was true and no longer is */
  | 'OUTDATED_INFORMATION'
  /** Too general to act on */
  | 'TOO_VAGUE';

/** One short, durable statement about what has actually been discussed with a household */
export type HouseholdKeepInMindItem = {
  __typename?: 'HouseholdKeepInMindItem';
  /** One or two sentences. Null only on the priorities item, when there is not enough recent client contact to fill it */
  body: Maybe<Scalars['String']['output']>;
  /** Stored rather than inferred, so the section can pin the fixed item first without matching on title text */
  kind: HouseholdKeepInMindItemKindEnum;
  /** The current user's vote on this item at the row's current generation, so a pinned thumb survives a reload */
  myVote: Maybe<HouseholdKeepInMindVoteEnum>;
  /** Always null on the priorities item — its heading is a frontend constant, so the model cannot reword it */
  title: Maybe<Scalars['String']['output']>;
};

/** Which kind of "Keep in mind" item this is */
export type HouseholdKeepInMindItemKindEnum =
  /** The fixed first item: what the household is trying to do with their money */
  | 'PRIORITIES'
  /** A running theme the model titled itself */
  | 'THEME';

/** Advisor feedback on one "Keep in mind" item */
export type HouseholdKeepInMindVoteEnum =
  /** The item was not useful */
  | 'DOWN'
  /** The item was useful */
  | 'UP';

/** Field that matched a household search query, used to explain why a result appeared */
export type HouseholdMatchField =
  /** CLIENT_NAME */
  | 'CLIENT_NAME'
  /** EMAIL */
  | 'EMAIL'
  /** HOUSEHOLD_NAME */
  | 'HOUSEHOLD_NAME'
  /** PHONE */
  | 'PHONE'
  /** SECONDARY_EMAIL */
  | 'SECONDARY_EMAIL'
  /** SECONDARY_PHONE */
  | 'SECONDARY_PHONE';

/**
 * Explains why a household search result matched the query — which field, the
 * matched value, and (for member fields) the owning client
 */
export type HouseholdMatchInfo = {
  __typename?: 'HouseholdMatchInfo';
  /** The owning client's display name; null when the matched field is HOUSEHOLD_NAME */
  context: Maybe<Scalars['String']['output']>;
  /** Which field the query matched */
  field: HouseholdMatchField;
  /** The matched value (e.g. household name, client name, email, phone) */
  value: Scalars['String']['output'];
};

/** Represents a user's role-scoped membership in a household. */
export type HouseholdMembership = {
  __typename?: 'HouseholdMembership';
  /** Whether this member can sign client agreements for the household. */
  canSignClientAgreement: Scalars['Boolean']['output'];
  /**
   * The underlying ClientProfile if the member user is a client. Lets advisor
   * surfaces source the same PII (employment, SSN, DOB, addresses) via memberships
   * instead of household.client_profiles when flagMultiHouseholdAccess is on.
   */
  clientProfile: Maybe<Client>;
  /** When the membership was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The ID of the household. */
  householdId: Scalars['ID']['output'];
  /** The ID of the household membership. */
  id: Scalars['ID']['output'];
  /** Whether this member is an account holder on household accounts. */
  isAccountHolder: Scalars['Boolean']['output'];
  /** The role the user holds in the household. */
  role: HouseholdMembershipRole;
  /** Free-form description of the member's trustee capacity, if applicable. */
  trusteeCapacity: Maybe<Scalars['String']['output']>;
  /** The member user (minimal info for advisor roster UI). */
  user: UserLookupResult;
  /** The ID of the member user. */
  userId: Scalars['ID']['output'];
};

/** The role a user plays within a household they are a member of. */
export type HouseholdMembershipRole =
  /** authorized_viewer */
  | 'authorized_viewer'
  /** beneficiary */
  | 'beneficiary'
  /** co_owner */
  | 'co_owner'
  /** co_trustee */
  | 'co_trustee'
  /** owner */
  | 'owner'
  /** trustee */
  | 'trustee';

/** Simplified household data for filter options */
export type HouseholdOption = {
  __typename?: 'HouseholdOption';
  /** Household ID */
  id: Scalars['ID']['output'];
  /** Household name */
  name: Scalars['String']['output'];
};

/** A report schedule as it applies to a specific household, with latest execution status. */
export type HouseholdReportSchedule = {
  __typename?: 'HouseholdReportSchedule';
  /** Whether the schedule is currently enabled */
  active: Scalars['Boolean']['output'];
  /** Whether PDFs are uploaded to Box */
  deliverToBox: Scalars['Boolean']['output'];
  /** Whether reports are published to the client portal */
  deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  deliveryMonth: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  frequency: Scalars['String']['output'];
  /** Schedule id */
  id: Scalars['ID']['output'];
  /** When the most recent execution ran */
  lastExecutionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Error message from the most recent execution, if failed */
  lastExecutionError: Maybe<Scalars['String']['output']>;
  /** Status of the most recent execution for this household */
  lastExecutionStatus: Maybe<Scalars['String']['output']>;
  /** When the schedule last fired */
  lastRunAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  nextDueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Saved report template name */
  templateName: Scalars['String']['output'];
};

/** The connection type for Household. */
export type HouseholdSearchConnection = {
  __typename?: 'HouseholdSearchConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<HouseholdSearchEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Household>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** Edge wrapping a Household search result with match attribution explaining why it appeared */
export type HouseholdSearchEdge = {
  __typename?: 'HouseholdSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /**
   * Per-field match attributions ordered by field priority then score descending;
   * empty when the result has no attribution (e.g. recent-households fallback).
   */
  matchInfos: Array<HouseholdMatchInfo>;
  /** The item at the end of the edge. */
  node: Maybe<Household>;
};

/** A single service occurrence for one household, in either the Task or the occurrence shape */
export type HouseholdServiceOccurrence = {
  __typename?: 'HouseholdServiceOccurrence';
  /** AfterPrevious cadence in days. Mutually exclusive with a recurrence pattern */
  afterPreviousOffsetDays: Maybe<Scalars['Int']['output']>;
  /** Whether the enrollment is paused. Null when the enrollment is gone */
  assignmentPaused: Maybe<Scalars['Boolean']['output']>;
  /**
   * Structured cadence, for the specific readout. Null on an item predating
   * presets, which still recurs — read the carriers below
   */
  cadencePreset: Maybe<Scalars['JSON']['output']>;
  /**
   * The item's booking link. `MeetingBooking` carries cancel/reschedule/join URLs
   * for an EXISTING booking, and no link to make one
   */
  calendlyLink: Maybe<Scalars['String']['output']>;
  /** When the invite is due to go out, from this occurrence's snapshot */
  computedSendAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Body from this occurrence's own frozen snapshot */
  emailBody: Maybe<Scalars['String']['output']>;
  /** Days before the occurrence date that the email is due to go out */
  emailLeadTimeDays: Scalars['Int']['output'];
  /** Subject from this occurrence's own frozen snapshot */
  emailSubject: Maybe<Scalars['String']['output']>;
  /**
   * Typed occurrence id — "task-123" or "occurrence-456". The two tables'
   * sequences are independent, so a bare integer would be ambiguous
   */
  id: Scalars['ID']['output'];
  /** Long-form description of the catalog item — `itemName`'s sibling, and not the service's own description */
  itemDescription: Maybe<Scalars['String']['output']>;
  /** Name of the catalog item that materialized this occurrence */
  itemName: Scalars['String']['output'];
  /** task or event */
  itemType: Scalars['String']['output'];
  /** Calendly tracking. In the occurrence shape this row IS the booking */
  meetingBooking: Maybe<MeetingBooking>;
  /** Which occurrence of the cadence this is */
  occurrenceDate: Scalars['ISO8601Date']['output'];
  /**
   * Who owes this occurrence: the task's assignee, else the item's default
   * assignee, else the household's advisor. Null when none of the three is set
   */
  ownerName: Maybe<Scalars['String']['output']>;
  /** RRULE recurrence pattern id, when the item recurs on a pattern rather than after the prior item */
  recurrencePatternId: Maybe<Scalars['ID']['output']>;
  /**
   * Opaque concurrency token. Echo it back to an occurrence-scoped mutation and
   * the write is refused if the row has changed since
   */
  revision: Maybe<Scalars['String']['output']>;
  /**
   * Whether the item dispatches email when due. False means `computedSendAt` here
   * describes mail SendDueEmailsJob consumes without delivering
   */
  sendNotification: Scalars['Boolean']['output'];
  /** The enrollment this came from. Null once that enrollment is gone — a past occurrence outlives it */
  serviceCatalogItemHouseholdId: Maybe<Scalars['ID']['output']>;
  /** The service's icon key. Null when the enrollment carries no service */
  serviceIconKey: Maybe<Scalars['String']['output']>;
  /** Id of the service the enrollment belongs to. Null for a historical enrollment that carries none */
  serviceId: Maybe<Scalars['ID']['output']>;
  /** The service the enrollment belongs to. Null for a historical enrollment that carries none */
  serviceName: Maybe<Scalars['String']['output']>;
  /** Derived server-side and never re-derived by the client */
  status: OccurrenceStatus;
  /** When the row's status last moved */
  statusUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type HouseholdStage =
  | 'commitment'
  | 'discovery'
  | 'disqualified'
  | 'inactive'
  | 'lead'
  | 'lost'
  | 'on_hold'
  | 'onboarding'
  | 'proposal'
  | 'prospecting'
  | 'won';

export type HouseholdTag = {
  __typename?: 'HouseholdTag';
  household: Household;
  id: Scalars['ID']['output'];
  organizationHouseholdCategory: OrganizationHouseholdCategory;
  organizationHouseholdTag: OrganizationHouseholdTag;
};

/** Autogenerated input type of HouseholdWorkflowCreationBackfiller */
export type HouseholdWorkflowCreationBackfillerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  daysToBackfill?: InputMaybe<Scalars['Int']['input']>;
  householdId: Scalars['ID']['input'];
};

export type ImageReplacement = {
  /** Text in the template that identifies the placeholder image to be replaced. */
  placeholder: Scalars['String']['input'];
  /** The base64 encoded image data to replace the placeholder with. */
  replaceWithImageBase64: Scalars['String']['input'];
};

/** Autogenerated input type of ImpersonateUser */
export type ImpersonateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ImpersonateUser. */
export type ImpersonateUserPayload = {
  __typename?: 'ImpersonateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: User;
  trueUser: User;
};

/** A single CRM contact destined for the primary/co-client/related slot. */
export type ImportClientSummary = {
  __typename?: 'ImportClientSummary';
  /** ISO-8601 date string, when present. */
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** Principal WB email, or first listed. */
  email: Maybe<Scalars['String']['output']>;
  /** WB contact first name. */
  firstName: Scalars['String']['output'];
  /** WB contact last name. */
  lastName: Scalars['String']['output'];
  /** Principal WB phone, or first listed. */
  phone: Maybe<Scalars['String']['output']>;
  /** primary | co-client | household_member */
  role: Scalars['String']['output'];
  /** Validation note that would prevent or weaken import (e.g. 'missing email'). */
  warning: Maybe<Scalars['String']['output']>;
};

/** One CRM household (or ungrouped contact) destined for import. */
export type ImportHouseholdSummary = {
  __typename?: 'ImportHouseholdSummary';
  /** Members that will become Pinetree primary/co-client (max 2). */
  clientCount: Scalars['Int']['output'];
  /** Per-client breakdown for the primary/co-client/related slots. */
  clients: Array<ImportClientSummary>;
  /** Names of all members in this CRM group. */
  memberNames: Array<Scalars['String']['output']>;
  /** CRM household name (or derived contact name for ungrouped). */
  name: Scalars['String']['output'];
  /** Members beyond the first 2 that will land as related_contacts. */
  relatedContactCount: Scalars['Int']['output'];
  /** Stable key used by household_actions, e.g. "wb:household:42" or "wb:contact:99". */
  stagingKey: Scalars['String']['output'];
  /** Auto-suggested Pinetree household to map to (null = no match). */
  suggestedMatch: Maybe<ImportMatchSuggestion>;
  /** CRM tags collected across all members of this household. */
  tags: Array<Scalars['String']['output']>;
  /** Household-level validation warnings that may block or weaken import. */
  warnings: Array<Scalars['String']['output']>;
};

/** Suggested mapping from a CRM household to an existing Pinetree household. */
export type ImportMatchSuggestion = {
  __typename?: 'ImportMatchSuggestion';
  /** high | medium */
  confidence: Scalars['String']['output'];
  /** The Pinetree Household ID we believe matches. */
  householdId: Scalars['ID']['output'];
  /** Display name of the matched Pinetree household. */
  householdName: Scalars['String']['output'];
};

/** How often a client income source pays out. Recurring cadences only. */
export type IncomeFrequency =
  /** 1 payment a year */
  | 'ANNUALLY'
  /** 26 payments a year */
  | 'BIWEEKLY'
  /** 12 payments a year */
  | 'MONTHLY'
  /** 4 payments a year */
  | 'QUARTERLY'
  /** 2 payments a year */
  | 'SEMI_ANNUALLY'
  /** 24 payments a year */
  | 'SEMI_MONTHLY'
  /** 52 payments a year */
  | 'WEEKLY';

/** The kind of recurring income a client income source represents */
export type IncomeSourceType =
  /** 1099 contract work */
  | 'CONTRACT_1099'
  /** Any other recurring income, e.g. a pension or annuity */
  | 'OTHER'
  /** Rental property income */
  | 'RENTAL'
  /** Self-employment or business ownership */
  | 'SELF_EMPLOYMENT'
  /** W-2 employment */
  | 'W2_EMPLOYMENT';

export type InitialTransferTypeName =
  | 'acat'
  | 'lpoa';

/** A single intake question and the advisor's free-text answer. */
export type IntakeAnswerInput = {
  /** The advisor's free-text answer. */
  answer: Scalars['String']['input'];
  /** The question text as shown to the advisor. */
  question: Scalars['String']['input'];
};

export type InternalAdminAction =
  /** Backfill Conquest financial plans for an advisor */
  | 'BackfillConquestPlans'
  /** Create household and users from Salesforce account id */
  | 'CreateHouseholdAndUsersFromSalesforceAccountWorker';

/** Investment experience data for a household */
export type InvestmentExperience = {
  __typename?: 'InvestmentExperience';
  /** The ID of the investment experience */
  id: Scalars['ID']['output'];
  /** The experience rows */
  investmentExperienceRows: Array<InvestmentExperienceRow>;
  /** The variant of the experience (general or alternative) */
  variant: Scalars['String']['output'];
};

/** Investment experience data for a single instrument category */
export type InvestmentExperienceCategoryInput = {
  /** Average dollar amount per transaction */
  avgDollarPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  /** Average number of trades per year */
  avgTradesPerYear?: InputMaybe<Scalars['Int']['input']>;
  /** Number of years trading this instrument */
  yearsTrading?: InputMaybe<Scalars['Int']['input']>;
};

/** Investment experience grid across all instrument categories */
export type InvestmentExperienceGridInput = {
  /** Bonds trading experience */
  bonds?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Commodities trading experience */
  commodities?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Options trading experience */
  optionsTrading?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Other financial instruments experience */
  otherFinancialInstruments?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Stock trading experience */
  stockTrading?: InputMaybe<InvestmentExperienceCategoryInput>;
};

/** A single row of investment experience data */
export type InvestmentExperienceRow = {
  __typename?: 'InvestmentExperienceRow';
  /** Average dollar amount per transaction */
  avgDollarAmount: Maybe<Scalars['Float']['output']>;
  /** Average trades per year */
  avgTradesPerYear: Maybe<Scalars['Int']['output']>;
  /** The ID of the investment experience row */
  id: Scalars['ID']['output'];
  /** The instrument name */
  instrument: Scalars['String']['output'];
  /** Percentage of holdings */
  pctOfHoldings: Maybe<Scalars['Float']['output']>;
  /** Years of experience */
  years: Maybe<Scalars['Int']['output']>;
};

/** Input for a single investment experience row */
export type InvestmentExperienceRowInput = {
  /** The instrument name (e.g., stocks, bonds, options_and_futures, real_estate, private_equity_and_hedge_fund, other) */
  instrument: Scalars['String']['input'];
  /** Percentage of holdings for this instrument */
  pctOfHoldings?: InputMaybe<Scalars['Float']['input']>;
  /** Years of experience with this instrument */
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentObjectiveName =
  | 'aggressive_growth'
  | 'conservative'
  | 'growth'
  | 'growth_and_income'
  | 'income';

export type InvestmentProposalCharts =
  /** Asset_Class_Exposure */
  | 'Asset_Class_Exposure'
  /** Client_Top_Holdings */
  | 'Client_Top_Holdings'
  /** Cumulative_And_Periodic_Returns */
  | 'Cumulative_And_Periodic_Returns'
  /** Expense_Ratio */
  | 'Expense_Ratio'
  /** Key_Metrics */
  | 'Key_Metrics'
  /** Max_Drawdown */
  | 'Max_Drawdown'
  /** Portfolio_Yield */
  | 'Portfolio_Yield'
  /** Region_Exposure */
  | 'Region_Exposure'
  /** Sector_Exposure */
  | 'Sector_Exposure'
  /** Top_Holdings */
  | 'Top_Holdings';

/** An Orion Connect trading model explicitly enabled for investment proposals by advisor group */
export type InvestmentProposalOrionModel = {
  __typename?: 'InvestmentProposalOrionModel';
  /** The Savvy advisor group that grants access to this model */
  advisorGroupId: Scalars['ID']['output'];
  /** The Savvy advisor group name that grants access to this model */
  advisorGroupName: Scalars['String']['output'];
  /** The Orion model display name */
  name: Scalars['String']['output'];
  /** The Orion Connect Trading Model id */
  orionConnectModelId: Scalars['String']['output'];
};

export type InvestmentProposalReplacementData = {
  /** An array of image replacement data. */
  imageReplacements: Array<ImageReplacement>;
  /** An array of text replacement data. */
  textReplacements: Array<TextReplacement>;
};

/** Investment proposal request data associated with a task */
export type InvestmentProposalRequest = {
  __typename?: 'InvestmentProposalRequest';
  /** URL to the account statements */
  accountStatementsUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the investment proposal request */
  id: Scalars['ID']['output'];
  /** The type of investment proposal request */
  requestType: InvestmentProposalRequestTypeName;
  /** The target model and allocation information */
  targetModelAndAllocation: Scalars['String']['output'];
};

/** The type of investment proposal request */
export type InvestmentProposalRequestTypeName =
  /** current_vs_target_portfolio */
  | 'current_vs_target_portfolio'
  /** target_portfolio_only */
  | 'target_portfolio_only';

/** A household member the ECI onboarding invite is addressed to. */
export type InviteRecipient = {
  __typename?: 'InviteRecipient';
  /**
   * Whether this member can be selected for a resend: false once they have
   * submitted, and false when there is no email to send to.
   */
  canResend: Scalars['Boolean']['output'];
  /** Where the invite is mailed. Null when the client has no user or no email. */
  email: Maybe<Scalars['String']['output']>;
  /** The client onboarding request id — pass this back to resend. */
  id: Scalars['ID']['output'];
  /** Client display name, from intake data when present. */
  name: Maybe<Scalars['String']['output']>;
  /** Applicant role (primary or joint_owner). */
  role: Scalars['String']['output'];
  /** Whether this client already submitted their intake. */
  submitted: Scalars['Boolean']['output'];
};

/**
 * Native Invoice (Fee Review) report — replaces the Orion-generated Client Invoice
 * PDF (HAWK-32). Bill header and footer (invoice number, period, totals) come from
 * Orion via /Billing/Bills; per-account rows come from Orion's authoritative bill
 * line items (/Billing/BillGenerator/BillItems).
 */
export type InvoiceFeeReview = {
  __typename?: 'InvoiceFeeReview';
  /** Display name of the household's primary advisor (Orion representative). Null when unknown. */
  financialAdvisorName: Maybe<Scalars['String']['output']>;
  /** Household display name shown in the report header. */
  householdName: Scalars['String']['output'];
  /** Stable identifier for this report (household + bill id). */
  id: Scalars['ID']['output'];
  /** Invoice date (the bill's calcDate). */
  invoiceDate: Scalars['ISO8601Date']['output'];
  /** Orion's invoiceNumber for this bill (e.g. "16178-109264"). */
  invoiceNumber: Scalars['String']['output'];
  /** End of the bill's billing period. */
  periodEnd: Scalars['ISO8601Date']['output'];
  /** Start of the bill's billing period. */
  periodStart: Scalars['ISO8601Date']['output'];
  /** One row per billable account on this bill. */
  rows: Array<InvoiceFeeReviewRow>;
  /** Footnotes shown beneath the rows (e.g. indirect "paid by another account" instructions). Empty when none. */
  specialInstructions: Array<Scalars['String']['output']>;
  /** Sum of adjustments on the bill (Orion adjustments field). */
  totalAdjustments: InvoiceFeeReviewMoney;
  /** Authoritative bill total from Orion's initialAmount. */
  totalAdvisoryFee: InvoiceFeeReviewMoney;
  /** The report footer's Total Billed Market Value — the sum of this bill's own-account rows. */
  totalBilledValue: InvoiceFeeReviewMoney;
  /** Net total fee after adjustments — Orion balanceDue. */
  totalFee: InvoiceFeeReviewMoney;
};

/**
 * A single adjustment line under a per-account row on the Invoice (Fee Review)
 * report — e.g. "Client Payment ($24.05) Paid date 04/14/25". Sourced from Orion's
 * bill-account-item adjustment ledger.
 */
export type InvoiceFeeReviewAdjustment = {
  __typename?: 'InvoiceFeeReviewAdjustment';
  /** Signed change amount for this adjustment. */
  amount: InvoiceFeeReviewMoney;
  /** Date the adjustment occurred. Null when Orion did not supply one. */
  date: Maybe<Scalars['ISO8601Date']['output']>;
  /** Display label for the adjustment (e.g. "Client Payment"). */
  label: Scalars['String']['output'];
};

/** One selectable Orion bill (invoice) for a household — populates the Invoice (Fee Review) report's invoice/quarter picker. */
export type InvoiceFeeReviewBillOption = {
  __typename?: 'InvoiceFeeReviewBillOption';
  /** Orion bill id (pass as `billId` to the invoiceFeeReview query). */
  id: Scalars['ID']['output'];
  /** Human-readable bill label, e.g. "1/1/2026–3/31/2026 (Renewal)". */
  label: Scalars['String']['output'];
  /** End of the bill's billing period; null when unparseable. */
  periodEnd: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Monetary value used by the Invoice (Fee Review) report. */
export type InvoiceFeeReviewMoney = {
  __typename?: 'InvoiceFeeReviewMoney';
  /** Numerical amount; null when no underlying data is available. */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the amount. */
  currencyCode: Scalars['String']['output'];
};

/** A single per-account row in the Invoice (Fee Review) report. */
export type InvoiceFeeReviewRow = {
  __typename?: 'InvoiceFeeReviewRow';
  /** Savvy account ID this row belongs to. */
  accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), shown as e.g. "XXX-XX4792". */
  accountMask: Maybe<Scalars['String']['output']>;
  /** Net per-account adjustment applied to this bill (Orion appliedAdjustment). Zero when none. */
  adjustment: InvoiceFeeReviewMoney;
  /** Itemized adjustment ledger for this account (e.g. "Client Payment" with a paid date). Empty when none. */
  adjustmentLines: Array<InvoiceFeeReviewAdjustment>;
  /** This account's advisory fee for the period — Orion's authoritative bill line-item initialAmount. */
  advisoryFee: InvoiceFeeReviewMoney;
  /** Annual advisory-fee rate as a decimal (e.g. 0.014 for 1.40%). Authoritative — Orion's bill line-item feePercent. */
  annualFeeRate: Scalars['BigDecimal']['output'];
  /** Billing frequency for the account (e.g. "Monthly", "Quarterly"). */
  billCycle: Scalars['String']['output'];
  /** Authoritative billed market value for this account from Orion's bill line item (totalMarketValue). */
  billedValue: InvoiceFeeReviewMoney;
  /** Custodian name from Orion (e.g. "Fidelity"). */
  custodian: Maybe<Scalars['String']['output']>;
  /** Days this account was billed for (Orion daysInCycle; e.g. 6 or 5 on a partial period). */
  daysInCycle: Scalars['Int']['output'];
  /** Denominator used for prorating the annual fee (Orion daysInYear, typically 365). */
  daysInYear: Scalars['Int']['output'];
  /** How the fee is paid (e.g. "Direct", "Indirect"). */
  payMethod: Maybe<Scalars['String']['output']>;
  /** End of this account's billed period (Orion endDate). */
  periodEnd: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start of this account's billed period (Orion startDate). Can differ per account on a partial cycle. */
  periodStart: Maybe<Scalars['ISO8601Date']['output']>;
  /** Display name of the account / registration (e.g. "Glenn Cooper - TODI"). */
  registrationName: Scalars['String']['output'];
  /** Account registration type (e.g. "Individual", "Roth IRA", "Trust"). */
  registrationType: Maybe<Scalars['String']['output']>;
  /** Management style / strategy name (e.g. "Managed Account"). */
  strategy: Maybe<Scalars['String']['output']>;
  /** advisory_fee minus adjustment. */
  totalFee: InvoiceFeeReviewMoney;
};

/** Type of IRA account */
export type IraTypeName =
  /** contributory_ira */
  | 'contributory_ira'
  /** rollover_ira */
  | 'rollover_ira'
  /** roth_contributory */
  | 'roth_contributory'
  /** sep_ira */
  | 'sep_ira'
  /** simple */
  | 'simple';

/** Enumeration of activity timeline item types */
export type ItemTypeEnum =
  /** CalendarEvent */
  | 'CalendarEvent'
  /** CallLog */
  | 'CallLog'
  /** DialpadCall */
  | 'DialpadCall'
  /** DialpadCallTranscript */
  | 'DialpadCallTranscript'
  /** DialpadSms */
  | 'DialpadSms'
  /** DialpadSmsGroup */
  | 'DialpadSmsGroup'
  /** EmailMessage */
  | 'EmailMessage'
  /** Meeting */
  | 'Meeting'
  /** MeetingSummary */
  | 'MeetingSummary'
  /** Note */
  | 'Note'
  /** SmsLog */
  | 'SmsLog'
  /** Task */
  | 'Task'
  /** ZoomMeetingTranscript */
  | 'ZoomMeetingTranscript';

/**
 * A unified activity timeline item representing calendar events, dialpad calls,
 * dialpad SMS, tasks, notes, and logged meetings for a household
 */
export type ItemTypeUnion = CalendarEvent | CallLog | DialpadCall | DialpadCallTranscript | DialpadSms | DialpadSmsGroup | EmailMessage | Meeting | MeetingSummary | Note | SmsLog | Task | ZoomMeetingTranscript;

/** A field relevant to KYC readiness validation */
export type KycField =
  /** address_city */
  | 'address_city'
  /** address_country */
  | 'address_country'
  /** address_line1 */
  | 'address_line1'
  /** address_state */
  | 'address_state'
  /** address_zip */
  | 'address_zip'
  /** country_code */
  | 'country_code'
  /** date_of_birth */
  | 'date_of_birth'
  /** email */
  | 'email'
  /** first_name */
  | 'first_name'
  /** last_name */
  | 'last_name'
  /** phone_number */
  | 'phone_number'
  /** primary_residence */
  | 'primary_residence'
  /** ssn */
  | 'ssn';

/** Autogenerated input type of LaunchTaskWorkflowTemplate */
export type LaunchTaskWorkflowTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Launch date (launch_date schedule) or target due date (due_date schedule) */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The households to launch the workflow into */
  householdIds: Array<Scalars['ID']['input']>;
  /** Schedule anchor for this run: launch_date or due_date (overrides the template default) */
  schedule: TaskWorkflowTemplateSchedule;
  /** The workflow task to launch */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of LaunchTaskWorkflowTemplate. */
export type LaunchTaskWorkflowTemplatePayload = {
  __typename?: 'LaunchTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The launched tasks, one per household */
  tasks: Maybe<Array<Task>>;
};

/** Liability held by the user. */
export type Liability = {
  __typename?: 'Liability';
  /** The date on which the user acquired the liability. */
  acquiredAt: Scalars['ISO8601Date']['output'];
  /** Annual interest in percentage */
  annualInterestPercent: Maybe<Scalars['BigDecimal']['output']>;
  /** The current balance of the liability. */
  currentBalance: Value;
  /** Whether to hide this portfolio item from client */
  hiddenFromClient: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  hiddenFromNetWorth: Maybe<Scalars['Boolean']['output']>;
  /** Daily balance history for the liability, forward-filled from each recorded change. */
  historicalValues: Array<HistoricalValue>;
  /** The Savvy ID of the liability. */
  id: Scalars['ID']['output'];
  /** The timestamp the liability was last updated at. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the liability. */
  name: Scalars['String']['output'];
  /** The original balance of the liability. */
  originalBalance: Value;
  /** The name of the provider of the liability. */
  providerName: Maybe<Scalars['String']['output']>;
  /** The status of the liability. */
  status: AccountStatusName;
  /** Length of time until maturity */
  timeToMaturity: Maybe<Scalars['Int']['output']>;
  /** Time unit for time_to_maturity */
  timeToMaturityUnit: Maybe<Scalars['String']['output']>;
  /** The type of liability */
  type: PortfolioItemTypeName;
  /** The timestamp the liability was last updated with information. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LiabilityTypeName =
  | 'auto'
  | 'commercial'
  | 'consumer'
  | 'general'
  | 'home_equity'
  | 'line_of_credit'
  | 'mortgage'
  | 'other'
  | 'student';

/** Link a bank variant: link an external bank account to one or more managed accounts */
export type LinkABankInput = {
  /** Managed accounts to which the bank should be linked */
  accountIds: Array<Scalars['ID']['input']>;
  /** Bank account number */
  bankAccountNumber: Scalars['String']['input'];
  /** Bank account type — checking or savings */
  bankAccountType: BankAccountTypeName;
  /** Name of the bank */
  bankName: Scalars['String']['input'];
  /** Names of the bank account owners */
  bankOwners: Scalars['String']['input'];
  /** ABA routing number */
  routingNumber: Scalars['String']['input'];
};

/** Autogenerated input type of LinkTimelineItemToContact */
export type LinkTimelineItemToContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contact id */
  contactId: Scalars['ID']['input'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  contactType: Scalars['String']['input'];
  /** The timeline item id */
  timelineItemId: Scalars['ID']['input'];
  /** The timeline item type */
  timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of LinkTimelineItemToContact. */
export type LinkTimelineItemToContactPayload = {
  __typename?: 'LinkTimelineItemToContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** True when the item is linked to the contact */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LinkTranscript */
export type LinkTranscriptInput = {
  /** Professional contact to link the transcript to. Mutually exclusive with householdId. */
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household to attach the transcript to. Mutually exclusive with centerOfInfluenceRepId. */
  householdId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the transcript to link. */
  transcriptId: Scalars['ID']['input'];
  /**
   * Which transcript class transcriptId names — the same value as the alert entity's __typename.
   * Both tables are bigserial, so an id alone is ambiguous. Defaults to ZoomMeetingTranscript.
   */
  transcriptKind?: InputMaybe<TranscriptKind>;
};

/** Autogenerated return type of LinkTranscript. */
export type LinkTranscriptPayload = {
  __typename?: 'LinkTranscriptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /**
   * ID of the linked transcript. Differs from the input when a natively-matched
   * row already existed and the placeholder converged onto it.
   */
  transcriptId: Scalars['ID']['output'];
};

/** An external bank account that one or more Savvy-managed accounts can transfer to/from. */
export type LinkedBankAccount = {
  __typename?: 'LinkedBankAccount';
  /** Full (decrypted) bank account number. Gated to the owning advisor / admin by this type's read policies. */
  accountNumber: Scalars['String']['output'];
  /**
   * Type of bank account (Checking, Savings, BusinessChecking, BusinessSavings).
   * Null for partial (advisor-sourced) rows not yet enriched.
   */
  accountType: Maybe<Scalars['String']['output']>;
  /** Name of the bank. */
  bankName: Scalars['String']['output'];
  /** When this bank account was first added to Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the linked bank account. */
  id: Scalars['ID']['output'];
  /** Masked bank account number with only the last 4 digits visible. */
  maskedAccountNumber: Scalars['String']['output'];
  /** Name(s) on the bank account registration. */
  registrationName: Scalars['String']['output'];
  /** ABA routing number. Null for partial (advisor-sourced) rows not yet enriched. */
  routingNumber: Maybe<Scalars['String']['output']>;
};

/** A run of the Linked Bank Accounts seed-tool importer (admin-only). Tracks one CSV/XLSX upload through preview and confirm. */
export type LinkedBankAccountImport = {
  __typename?: 'LinkedBankAccountImport';
  /** When applying completed successfully */
  appliedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the operator confirmed the diff and applying began */
  confirmedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the import was uploaded */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custodian (schwab or fidelity) */
  custodian: Scalars['String']['output'];
  /** Error message if the import failed during parsing or applying */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the linked bank account import */
  id: Scalars['ID']['output'];
  /** JSON diff payload populated when status is awaiting_confirmation; buckets: to_create, to_soft_delete, unchanged, skipped */
  previewDiff: Maybe<Scalars['JSON']['output']>;
  /** The lifecycle state: pending, parsing, awaiting_confirmation, applying, completed, failed, cancelled */
  status: Scalars['String']['output'];
  /** The user that uploaded the import */
  uploadedBy: User;
};

export type LinkedBankAccountImportDocType =
  /** advisor */
  | 'advisor'
  /** savvy_wide */
  | 'savvy_wide'
  /** schwab_api */
  | 'schwab_api';

/** Autogenerated input type of LogTaskAttachment */
export type LogTaskAttachmentInput = {
  /** One of "added" or "removed". */
  action: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable file name to render on the timeline. */
  filename: Scalars['String']['input'];
  /** The Savvy task ID. */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of LogTaskAttachment. */
export type LogTaskAttachmentPayload = {
  __typename?: 'LogTaskAttachmentPayload';
  /** The TaskActivity row written for this event. */
  activity: Maybe<TaskActivity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the activity row was written. */
  success: Scalars['Boolean']['output'];
};

/** A mailbox associated with an advisor */
export type Mailbox = {
  __typename?: 'Mailbox';
  /** The email address of the mailbox. */
  email: Scalars['String']['output'];
  /** The unique identifier of the mailbox. */
  id: Scalars['ID']['output'];
};

export type MailgunMessage = {
  __typename?: 'MailgunMessage';
  deliveredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  failedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  from: Scalars['String']['output'];
  mailgunMessageId: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  status: MailgunMessageStatus;
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type MailgunMessageStatus =
  | 'delivered'
  | 'failed'
  | 'opened';

/** Autogenerated input type of MarkAdvisorRequirementsDone */
export type MarkAdvisorRequirementsDoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the advisor-blocked task to mark done. */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkAdvisorRequirementsDone. */
export type MarkAdvisorRequirementsDonePayload = {
  __typename?: 'MarkAdvisorRequirementsDonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The task after the sub_status has been moved to reviewed_ready_for_work. */
  task: Task;
};

/** Autogenerated input type of MarkCommentsSeen */
export type MarkCommentsSeenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The newest comment id the client displayed. The watermark clamps to this, so a
   * comment that arrived while the tab sat open is not marked read without ever
   * having been shown.
   */
  newestRenderedCommentId: Scalars['ID']['input'];
  /** ID of the subject whose comments were seen */
  relationId: Scalars['ID']['input'];
  /** Subject type, e.g. "Household" */
  relationType: Scalars['String']['input'];
};

/** Autogenerated return type of MarkCommentsSeen. */
export type MarkCommentsSeenPayload = {
  __typename?: 'MarkCommentsSeenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /**
   * True when the call was accepted, whether the watermark moved or already
   * covered the request. Failures surface as errors, not as false.
   */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkHouseholdComplete */
export type MarkHouseholdCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to mark complete. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkHouseholdComplete. */
export type MarkHouseholdCompletePayload = {
  __typename?: 'MarkHouseholdCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** Whether the household was marked complete. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkServiceCatalogItemHouseholdDone */
export type MarkServiceCatalogItemHouseholdDoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkServiceCatalogItemHouseholdDone. */
export type MarkServiceCatalogItemHouseholdDonePayload = {
  __typename?: 'MarkServiceCatalogItemHouseholdDonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated assignment */
  serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
};

/** Autogenerated input type of MarkServiceCatalogItemHouseholdSkipped */
export type MarkServiceCatalogItemHouseholdSkippedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkServiceCatalogItemHouseholdSkipped. */
export type MarkServiceCatalogItemHouseholdSkippedPayload = {
  __typename?: 'MarkServiceCatalogItemHouseholdSkippedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created or updated skip override */
  serviceCatalogItemHouseholdOverride: ServiceCatalogItemHouseholdOverride;
};

/** Autogenerated input type of MarkTaskCommentsSeen */
export type MarkTaskCommentsSeenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkTaskCommentsSeen. */
export type MarkTaskCommentsSeenPayload = {
  __typename?: 'MarkTaskCommentsSeenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A single point in a portfolio market-value / net-additions time series. */
export type MarketValuePoint = {
  __typename?: 'MarketValuePoint';
  /** Valuation date. */
  date: Scalars['ISO8601Date']['output'];
  /** Ending market value on this date, in USD. */
  marketValue: Scalars['BigDecimal']['output'];
  /**
   * Cumulative net amount invested as of this date, in USD; null when the snapshot
   * did not record contributions for this point.
   */
  netInvested: Maybe<Scalars['BigDecimal']['output']>;
};

/** A manually logged meeting between an advisor and either household members or a center of influence rep */
export type Meeting = {
  __typename?: 'Meeting';
  /** Users recorded as attendees for this meeting. */
  attendees: Array<User>;
  /** Timestamp when this meeting record was created in Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Duration of the meeting in minutes. */
  durationMinutes: Maybe<Scalars['Int']['output']>;
  /** The Savvy ID of the meeting. */
  id: Scalars['ID']['output'];
  /** Notes or summary from the meeting. */
  notes: Maybe<Scalars['String']['output']>;
  /** The date and time when the meeting took place. */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** The title or subject of the meeting. */
  title: Scalars['String']['output'];
};

/** A meeting agenda template an advisor authors for Savvy Intelligence to use during meeting prep */
export type MeetingAgendaTemplate = {
  __typename?: 'MeetingAgendaTemplate';
  /** ID of the advisor profile that created the template */
  advisorProfileId: Scalars['ID']['output'];
  /** The agenda outline the advisor authored */
  body: Scalars['String']['output'];
  /** When the template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When to use this template; the primary AI-selection signal */
  description: Scalars['String']['output'];
  /** The ID of the meeting agenda template */
  id: Scalars['ID']['output'];
  /** Avatar URL of the advisor who last edited the template */
  lastEditedByAvatarUrl: Maybe<Scalars['String']['output']>;
  /** Display name of the advisor who last edited the template */
  lastEditedByName: Scalars['String']['output'];
  /** The kind of template: meeting_agenda shapes a prep agenda, meeting_recap shapes a meeting summary */
  templateType: MeetingAgendaTemplateType;
  /** The template title; also a signal for AI selection */
  title: Scalars['String']['output'];
  /** When the template was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Whether the current advisor may edit/delete this template: the creator of a
   * private template, or a co-owning member of a group a firm template is shared to
   */
  viewerCanManage: Scalars['Boolean']['output'];
  /** Who can see the template: private (creator only) or firm-wide */
  visibility: MeetingAgendaTemplateVisibility;
};

/** The connection type for MeetingAgendaTemplate. */
export type MeetingAgendaTemplateConnection = {
  __typename?: 'MeetingAgendaTemplateConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MeetingAgendaTemplateEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<MeetingAgendaTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MeetingAgendaTemplateEdge = {
  __typename?: 'MeetingAgendaTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MeetingAgendaTemplate>;
};

/** The kind of template: meeting_agenda shapes a prep agenda, meeting_recap shapes a meeting summary */
export type MeetingAgendaTemplateType =
  /** meeting_agenda */
  | 'meeting_agenda'
  /** meeting_recap */
  | 'meeting_recap';

/** Visibility of a meeting agenda template: private (creator only) or firm-wide */
export type MeetingAgendaTemplateVisibility =
  /** firm */
  | 'firm'
  /** private */
  | 'private';

/** Calendly booking tracking for a Service Calendar v2 meeting occurrence */
export type MeetingBooking = {
  __typename?: 'MeetingBooking';
  /** When the client booked the meeting via Calendly. Nil until a booking is received. */
  bookedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Calendly cancellation URL captured at booking time */
  calendlyCancelUrl: Maybe<Scalars['String']['output']>;
  /** Calendly's URI for the invitee on the currently booked event */
  calendlyInviteeUri: Maybe<Scalars['String']['output']>;
  /** Calendly reschedule URL captured at booking time */
  calendlyRescheduleUrl: Maybe<Scalars['String']['output']>;
  /** Calendly's URI for the currently booked event. A reschedule replaces it — not a booking history. */
  calendlyScheduledEventUri: Maybe<Scalars['String']['output']>;
  /** When the client canceled the meeting via Calendly. Set on invitee.canceled; cleared on a fresh booking. */
  canceledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The occurrence moment — the same column the schedule page and send crons order by */
  dueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The row ID */
  id: Scalars['ID']['output'];
  /**
   * Conferencing join URL, set only when the event type has a provider. Not
   * cleared on cancel — suppress it when canceledAt is set
   */
  meetingJoinUrl: Maybe<Scalars['String']['output']>;
  /**
   * Calendly location type as sent — zoom, physical, custom, and so on. A plain
   * string, so an unrecognised type still reads back.
   */
  meetingLocationType: Maybe<Scalars['String']['output']>;
  /** The meeting's name, taken from its catalog item */
  name: Maybe<Scalars['String']['output']>;
  /** Which occurrence of the cadence this row is */
  occurrenceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The catalog item that materialized this meeting */
  sourceCatalogItem: Maybe<ServiceCatalogItem>;
  /** Households this meeting is for */
  workItemHouseholds: Array<Household>;
};

/** Historical service calendar v1 meeting instance for export */
export type MeetingInstance = {
  __typename?: 'MeetingInstance';
  dueDate: Scalars['ISO8601DateTime']['output'];
  meetingDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** The AI-generated meeting prep document for a calendar event (recap + agenda). */
export type MeetingPrep = {
  __typename?: 'MeetingPrep';
  /** The meeting agenda as sanitized HTML, or null if absent. */
  agendaHtml: Maybe<Scalars['String']['output']>;
  /** The since-last-meeting recap section, or null if absent. */
  recap: Maybe<MeetingPrepRecap>;
};

/** A single recap bullet from a meeting prep document. */
export type MeetingPrepBullet = {
  __typename?: 'MeetingPrepBullet';
  /** The bullet text. */
  text: Scalars['String']['output'];
};

/** The "since last meeting" recap section of a meeting prep document. */
export type MeetingPrepRecap = {
  __typename?: 'MeetingPrepRecap';
  /** A paragraph summarizing account performance since the last meeting. */
  accountPerformance: Scalars['String']['output'];
  /** Bullets describing what changed since the last meeting. */
  whatsChanged: Array<MeetingPrepBullet>;
  /** Bullets worth keeping in mind for this meeting. */
  worthKeepingInMind: Array<MeetingPrepBullet>;
};

export type MeetingSummary = {
  __typename?: 'MeetingSummary';
  /** The Savvy ID of the meeting summary. */
  id: Scalars['ID']['output'];
  /** End time */
  meetingEndTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name of the meeting. */
  meetingName: Maybe<Scalars['String']['output']>;
  /** Start time */
  meetingStartTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The note backing this meeting summary, when one exists. */
  note: Maybe<Note>;
  /** Where the last requested regeneration got to; null when none has been requested. Poll this after regenerateMeetingSummary. */
  regenerationStatus: Maybe<MeetingSummaryRegenerationStatus>;
  /** The source of the meeting summary (e.g. "zoom", "dialpad", "savvy"). */
  source: Scalars['String']['output'];
};

/** Where an advisor-requested recap regeneration has got to. Absent means none has been requested */
export type MeetingSummaryRegenerationStatus =
  /** failed */
  | 'failed'
  /** queued */
  | 'queued'
  /** running */
  | 'running'
  /** succeeded */
  | 'succeeded';

export type MeetingTypeName =
  | 'client_review'
  | 'intake_review'
  | 'intro_call'
  | 'management_agreement_kickoff'
  | 'onboarding_review';

/** Autogenerated input type of MergeOrganizationHouseholdTags */
export type MergeOrganizationHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationHouseholdCategoryId: Scalars['ID']['input'];
  organizationHouseholdTagIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MergeOrganizationHouseholdTags. */
export type MergeOrganizationHouseholdTagsPayload = {
  __typename?: 'MergeOrganizationHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  organizationHouseholdTag: Maybe<OrganizationHouseholdTag>;
};

export type MoneyMovementRequest = {
  __typename?: 'MoneyMovementRequest';
  additionalInformation: Maybe<MoneyMovementRequestAdditionalInformation>;
  amount: Scalars['String']['output'];
  fromAccount: Maybe<MoneyMovementRequestAccount>;
  id: Scalars['ID']['output'];
  itemVersion: Maybe<Scalars['Int']['output']>;
  securities: Maybe<Scalars['String']['output']>;
  toAccount: Maybe<MoneyMovementRequestAccount>;
  transferType: Scalars['String']['output'];
};

export type MoneyMovementRequestAccount = {
  __typename?: 'MoneyMovementRequestAccount';
  accountDetails: MoneyMovementRequestAccountDetails;
  /**
   * The linked Savvy-managed Account when transferAccountType is the Savvy-managed
   * branch. Surfaces mask, account_number, subtype so the task panel can
   * distinguish two same-holder accounts. Null for LinkedBank and EnterManually branches.
   */
  savvyManagedAccount: Maybe<Account>;
  transferAccountType: Scalars['String']['output'];
};

export type MoneyMovementRequestAccountDetails = {
  __typename?: 'MoneyMovementRequestAccountDetails';
  abaTransitRoutingNumber: Maybe<Scalars['String']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<Scalars['String']['output']>;
  additionalInstructions: Maybe<Scalars['String']['output']>;
  addressRecipientName: Maybe<Scalars['String']['output']>;
  bankAbaNumber: Maybe<Scalars['String']['output']>;
  bankAccountNumber: Maybe<Scalars['String']['output']>;
  bankAccountType: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  grossOrNet: Maybe<Scalars['String']['output']>;
  holderName: Maybe<Scalars['String']['output']>;
  /** Savvy id of the selected account, for the branches that reference one. */
  id: Maybe<Scalars['ID']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  maskedAccountNumber: Maybe<Scalars['String']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  newBank: Maybe<MoneyMovementRequestNewLinkedBank>;
  otherFinancialInstitutionName: Maybe<Scalars['String']['output']>;
  payeeName: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  referenceName: Maybe<Scalars['String']['output']>;
  registrationName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
  taxWithholdingInstructions: Maybe<Scalars['String']['output']>;
  withholdingPercent: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type MoneyMovementRequestAdditionalInformation = {
  __typename?: 'MoneyMovementRequestAdditionalInformation';
  additionalDetails: Maybe<Scalars['String']['output']>;
  clientInstructionType: Scalars['String']['output'];
  tradeDetails: Maybe<Scalars['String']['output']>;
  tradeNeeded: Scalars['String']['output'];
};

export type MoneyMovementRequestNewLinkedBank = {
  __typename?: 'MoneyMovementRequestNewLinkedBank';
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  bankOwners: Maybe<Scalars['String']['output']>;
  routingNumber: Maybe<Scalars['String']['output']>;
};

/** Input for money movement task specific data */
export type MoneyMovementRequestTaskInput = {
  additionalInformation: Scalars['JSON']['input'];
  amount: Scalars['BigDecimal']['input'];
  fromAccount: Scalars['JSON']['input'];
  /**
   * Optional new-bank info — when present, the mutation also creates an Account
   * Maintenance "Link a bank" task so ops can establish the linkage at the custodian.
   */
  linkABank?: InputMaybe<LinkABankInput>;
  securities?: InputMaybe<Scalars['String']['input']>;
  toAccount: Scalars['JSON']['input'];
  transferType: Scalars['String']['input'];
};

/** Autogenerated input type of MoneykitCreateLinkSession */
export type MoneykitCreateLinkSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Existing MoneyKit ProviderAccount id; presence flips this to a re-link session. */
  providerAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Override the configured redirect URI (sandbox / preview URLs). */
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-on-behalf: target user id; defaults to current user. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoneykitCreateLinkSession. */
export type MoneykitCreateLinkSessionPayload = {
  __typename?: 'MoneykitCreateLinkSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** JWT for the @moneykit/connect SDK */
  linkSessionToken: Scalars['String']['output'];
};

/** Autogenerated input type of MoneykitExchangeLinkToken */
export type MoneykitExchangeLinkTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short-lived token returned by @moneykit/connect on link success. */
  exchangeToken: Scalars['String']['input'];
  /** When present, the named Plaid ProviderAccount is marked DEPRECATED after the MoneyKit PA is created. */
  replacingProviderAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Advisor-on-behalf: target user id; defaults to current user. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoneykitExchangeLinkToken. */
export type MoneykitExchangeLinkTokenPayload = {
  __typename?: 'MoneykitExchangeLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Institution display name (may be nil if MoneyKit has not finished link enrichment) */
  institutionName: Maybe<Scalars['String']['output']>;
  /** The MoneyKit link_id (also stored on the ProviderAccount) */
  linkId: Scalars['String']['output'];
  /** The newly-created MoneyKit ProviderAccount */
  providerAccount: ProviderAccount;
};

/** Autogenerated input type of MoneykitRefreshLink */
export type MoneykitRefreshLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** MoneyKit ProviderAccount to refresh. */
  providerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoneykitRefreshLink. */
export type MoneykitRefreshLinkPayload = {
  __typename?: 'MoneykitRefreshLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The refreshed ProviderAccount (now in LOADING). */
  providerAccount: ProviderAccount;
};

/** A calendar month that has activity in a household timeline (powers the month-rail navigator) */
export type Month = {
  __typename?: 'Month';
  /** Number of deduped timeline entries in this month */
  count: Scalars['Int']['output'];
  /** Month number, 1-12 (UTC) */
  month: Scalars['Int']['output'];
  /** Calendar year (UTC) */
  year: Scalars['Int']['output'];
};

/** Autogenerated input type of MoveClientToAdvisor */
export type MoveClientToAdvisorInput = {
  advisorGroupId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientUserId: Scalars['String']['input'];
  newAdvisorUserId: Scalars['String']['input'];
};

/** Autogenerated return type of MoveClientToAdvisor. */
export type MoveClientToAdvisorPayload = {
  __typename?: 'MoveClientToAdvisorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mark an alert as acknowledged by its recipient, hiding it from the Canvas review section. */
  acknowledgeAlert: Maybe<AcknowledgeAlertPayload>;
  activateServiceCalendarForHousehold: Maybe<ActivateServiceCalendarForHouseholdPayload>;
  /** Link an advisor group and its members to an organization */
  addAdvisorGroupToOrganization: Maybe<AddAdvisorGroupToOrganizationPayload>;
  /** Add an advisor to an existing advisor group */
  addAdvisorToExistingAdvisorGroup: Maybe<AddAdvisorToExistingAdvisorGroupPayload>;
  /** Add advisors to an organization */
  addAdvisorsToOrganization: Maybe<AddAdvisorsToOrganizationPayload>;
  /**
   * Attach more files to your own comment, for a file remembered after it was
   * posted. createComment carries the first batch; this carries every one after it.
   */
  addCommentAttachments: Maybe<AddCommentAttachmentsPayload>;
  /** Add family members to a household */
  addFamilyMembers: Maybe<AddFamilyMembersPayload>;
  /** Advisor-only: add a user to a household with the given role. */
  addHouseholdMember: Maybe<AddHouseholdMemberPayload>;
  /** Mute a cash/allocation alert for one account or a whole household. */
  addNotificationAlertMute: Maybe<AddNotificationAlertMutePayload>;
  addSecondaryPortfolio: Maybe<AddSecondaryPortfolioPayload>;
  /** Add a service catalog item to a group */
  addServiceCatalogItemToGroup: Maybe<AddServiceCatalogItemToGroupPayload>;
  /**
   * Advance the advisor onboarding status from confirm_account to ready_to_send at
   * the Confirm->Email boundary, writing only the cockpit status (no commit side effects).
   */
  advanceEciOnboardingToReadyToSend: Maybe<AdvanceEciOnboardingToReadyToSendPayload>;
  /** Repair a household stuck in the DocuSign signed loop by advancing past the completed signing (HAWK-444). */
  advanceOnboardingAfterSigning: Maybe<AdvanceOnboardingAfterSigningPayload>;
  /** Approve pending-review scheduled report executions, delivering each */
  approveScheduledReportExecution: Maybe<ApproveScheduledReportExecutionPayload>;
  /** Archive a client household: set stage to inactive */
  archiveHousehold: Maybe<ArchiveHouseholdPayload>;
  /** Archive a service catalog item */
  archiveServiceCatalogItem: Maybe<ArchiveServiceCatalogItemPayload>;
  /** Archive a service catalog item group */
  archiveServiceCatalogItemGroup: Maybe<ArchiveServiceCatalogItemGroupPayload>;
  /** Assign an advisor fee schedule to a household during confirm-accounts */
  assignHouseholdFeeSchedule: Maybe<AssignHouseholdFeeSchedulePayload>;
  /** Assign a service catalog item to a household */
  assignServiceCatalogItemToHousehold: Maybe<AssignServiceCatalogItemToHouseholdPayload>;
  beginMfaEnrollment: Maybe<BeginMfaEnrollmentPayload>;
  /** Cancel not-yet-started (todo) tasks in bulk by id */
  bulkCancelTasks: Maybe<BulkCancelTasksPayload>;
  /** Admin tool to bulk create or update households from an XLSX file */
  bulkCreateOrUpdateHouseholds: Maybe<BulkCreateOrUpdateHouseholdsPayload>;
  /** Bulk delete organization household tags */
  bulkDeleteOrganizationHouseholdTags: Maybe<BulkDeleteOrganizationHouseholdTagsPayload>;
  /** Kick off bulk PDF generation for the current advisor across the given households */
  bulkGenerateReports: Maybe<BulkGenerateReportsPayload>;
  bulkUpdateAlerts: Maybe<BulkUpdateAlertsPayload>;
  /** Admin tool to bulk update advisor clients */
  bulkUpdateClients: Maybe<BulkUpdateClientsPayload>;
  /** Bulk update organization household categories */
  bulkUpdateOrganizationHouseholdCategories: Maybe<BulkUpdateOrganizationHouseholdCategoriesPayload>;
  /** Bulk update endpoint to  mark client tax enrollment type */
  bulkUpdateTaxEnrollmentsToNotInterested: Maybe<BulkUpdateTaxEnrollmentsToNotInterestedPayload>;
  /** Start async bulk upload of documents to Box; poll bulkUploadFilesToBoxStatus for progress */
  bulkUploadFilesToBox: Maybe<BulkUploadFilesToBoxPayload>;
  /** Admin: cancel a Linked Bank Accounts import that has not been applied yet */
  cancelLinkedBankAccountImport: Maybe<CancelLinkedBankAccountImportPayload>;
  /** Remove the Orion benchmark for a household. */
  clearHouseholdBenchmark: Maybe<ClearHouseholdBenchmarkPayload>;
  /** Clears Redis cache for a specified Box folder for Marketing Center */
  clearRedisCacheForBoxFolder: Maybe<ClearRedisCacheForBoxFolderPayload>;
  /** Close a remediation subtask the CSA resolved outside Savvy. */
  closeEciRemediationSubtask: Maybe<CloseEciRemediationSubtaskPayload>;
  completeGoogleOAuthFlow: Maybe<CompleteGoogleOAuthFlowPayload>;
  /** Complete the Schwab OAuth connect flow and persist the shared client tokens (admin only) */
  completeSchwabOauthConnect: Maybe<CompleteSchwabOauthConnectPayload>;
  /** Mark one service occurrence as done */
  completeServiceOccurrence: Maybe<CompleteServiceOccurrencePayload>;
  /** Confirm selected staged accounts for a promoted onboarding household and advance it to ready_to_send. */
  confirmAdvisorOnboardingAccounts: Maybe<ConfirmAccountsPayload>;
  /** Admin: confirm a previewed Linked Bank Accounts import — applies the diff in a single transaction */
  confirmLinkedBankAccountImport: Maybe<ConfirmLinkedBankAccountImportPayload>;
  /** Confirm a portfolio's investment policy */
  confirmPortfolio: Maybe<ConfirmPortfolioPayload>;
  createAccount: Maybe<CreateAccountPayload>;
  /** Create an account confirmation task */
  createAccountConfirmationTask: Maybe<CreateAccountConfirmationTaskPayload>;
  /** Create an account maintenance task */
  createAccountMaintenanceTask: Maybe<CreateAccountMaintenanceTaskPayload>;
  createAddress: Maybe<CreateAddressPayload>;
  createAdvisor: Maybe<CreateAdvisorPayload>;
  /** Create an advisor group (team) and provision its Box/Wrike folders */
  createAdvisorGroup: Maybe<CreateAdvisorGroupPayload>;
  /** Create a new advisor onboarding enrollment (process root) for the intake wizard. */
  createAdvisorOnboardingEnrollment: Maybe<CreateEnrollmentPayload>;
  /** Giving feedback as admin or advisor */
  createAdvisorRequest: Maybe<CreateAdvisorRequestPayload>;
  createAlert: Maybe<CreateAlertPayload>;
  /** Create an alternative investments purchase task */
  createAlternativeInvestmentsPurchaseTask: Maybe<CreateAlternativeInvestmentsPurchaseTaskPayload>;
  createAsset: Maybe<CreateAssetPayload>;
  /** Create a bulk import operation for processing files with multiple data records */
  createBulkImport: Maybe<CreateBulkImportPayload>;
  createCenterOfInfluenceRep: Maybe<CreateCenterOfInfluenceRepPayload>;
  /** Create a client billing task */
  createClientBillingTask: Maybe<CreateClientBillingTaskPayload>;
  /** Create a client info change task */
  createClientInfoChangeTask: Maybe<CreateClientInfoChangeTaskPayload>;
  createClientOpportunity: Maybe<CreateClientOpportunityPayload>;
  createClientPortalMessage: Maybe<CreateClientPortalMessagePayload>;
  createCoClientFromIntakeData: Maybe<CreateCoClientFromIntakeDataPayload>;
  createCoClientUser: Maybe<CreateCoClientUserPayload>;
  /** Log a call with a center of influence rep */
  createCoiCallLog: Maybe<CreateCoiCallLogPayload>;
  /** Create a new Meeting log for a center of influence rep */
  createCoiMeeting: Maybe<CreateCoiMeetingPayload>;
  /**
   * Post an internal-team comment on a subject, or a reply to an existing comment.
   * Mentions are stored as @Full Name text and notify nobody.
   */
  createComment: Maybe<CreateCommentPayload>;
  /** Create a company */
  createCompany: Maybe<CreateCompanyPayload>;
  /** Log a call with a company */
  createCompanyCallLog: Maybe<CreateCompanyCallLogPayload>;
  /** Create a new Meeting log for a company */
  createCompanyMeeting: Maybe<CreateCompanyMeetingPayload>;
  /** Create a Conquest plan for a household from a frontend-built Conquest-shaped payload */
  createConquestPlanFromData: Maybe<CreateConquestPlanFromDataPayload>;
  createContact: Maybe<CreateContactPayload>;
  /** Log a call with a household contact */
  createContactCallLog: Maybe<CreateContactCallLogPayload>;
  /** Create a new Meeting log for a household contact */
  createContactMeeting: Maybe<CreateContactMeetingPayload>;
  /** Resolve, classify, and dispatch ContributionReceived alerts from a CSA-uploaded contribution sheet */
  createContributionAlertsFromUpload: Maybe<CreateContributionAlertsFromUploadPayload>;
  /** Create a corporate retirement plan task */
  createCorporateRetirementPlanTask: Maybe<CreateCorporateRetirementPlanTaskPayload>;
  /** Create a data export */
  createDataExport: Maybe<CreateDataExportPayload>;
  createDocumentSignatureForTask: Maybe<CreateDocumentSignatureForTaskPayload>;
  createDocusignLpoaEnvelopeBulkUpload: Maybe<CreateDocusignLpoaEnvelopeBulkUploadPayload>;
  /** Create a fee schedule for an advisor */
  createFeeScheduleForAdvisor: Maybe<CreateFeeScheduleForAdvisorPayload>;
  /** Create a file upload task for a client */
  createFileUploadTask: Maybe<CreateFileUploadTaskPayload>;
  /** Admin-only: create a new Financial Offering shell (name + type) to fill in via the offering editor */
  createFinancialOffering: Maybe<CreateFinancialOfferingPayload>;
  /** Create a financial plan for a household */
  createFinancialPlan: Maybe<CreateFinancialPlanPayload>;
  createGoal: Maybe<CreateGoalPayload>;
  createLiability: Maybe<CreateLiabilityPayload>;
  /** Create manual onboarding task(s) for a client/household */
  createManualOnboardingTask: Maybe<CreateManualOnboardingTaskPayload>;
  /** Create a new Meeting log for a household */
  createMeeting: Maybe<CreateMeetingPayload>;
  /** Create a meeting agenda template */
  createMeetingAgendaTemplate: Maybe<CreateMeetingAgendaTemplatePayload>;
  /** Create a money movement request task */
  createMoneyMovementRequestTask: Maybe<CreateMoneyMovementRequestTaskPayload>;
  /** Create an NFS audit regulator export bundle. Admin-only. */
  createNfsAuditExport: Maybe<CreateNfsAuditExportPayload>;
  createNote: Maybe<CreateNotePayload>;
  /** Create a Note attached to a household Contact. */
  createNoteForContact: Maybe<CreateNoteForContactPayload>;
  /** Create a Note attached to a DialpadCall. */
  createNoteForDialpadCall: Maybe<CreateNoteForDialpadCallPayload>;
  /** Create a Note attached to a CalendarEvent. */
  createNoteForEvent: Maybe<CreateNoteForEventPayload>;
  /** Create onboarding task */
  createOnboardingTask: Maybe<CreateOnboardingTaskPayload>;
  /** Create an open new account task */
  createOpenNewAccountTask: Maybe<CreateOpenNewAccountTaskPayload>;
  /** Create or update a CallLog from a Salesforce task */
  createOrUpdateCallLog: Maybe<CreateOrUpdateCallLogPayload>;
  createOrUpdateServiceCalendarSettings: Maybe<CreateOrUpdateServiceCalendarSettingsPayload>;
  /** Create a new organization */
  createOrganization: Maybe<CreateOrganizationPayload>;
  /** Create an empty organization branding row for an organization */
  createOrganizationBranding: Maybe<CreateOrganizationBrandingRowPayload>;
  /** Create an organization household category */
  createOrganizationHouseholdCategory: Maybe<CreateOrganizationHouseholdCategoryPayload>;
  /** Create an organization household tag */
  createOrganizationHouseholdTag: Maybe<CreateOrganizationHouseholdTagPayload>;
  /** Create an other-investment task with structured sidecar data */
  createOtherInvestmentTask: Maybe<CreateOtherInvestmentTaskPayload>;
  /** @deprecated Use refreshProviderAccount or moneykitCreateLinkSession instead. Plaid-based account linking is being removed. */
  createPlaidLinkToken: Maybe<CreatePlaidLinkTokenPayload>;
  /** Add a quarterly financial snapshot to a retirement plan (gated behind retirementPlans flag) */
  createPlanFinancialSnapshot: Maybe<CreatePlanFinancialSnapshotPayload>;
  /** Create a professional relationship edge between two network nodes */
  createProfessionalRelationship: Maybe<CreateProfessionalRelationshipPayload>;
  /** New create an opportunity for a client not in Savvy system */
  createProspectOpportunity: Maybe<CreateProspectOpportunityPayload>;
  createProviderAccount: Maybe<CreateProviderAccountPayload>;
  /** Create a draft DocuSign envelope (LPOA + pre-filled IWS/Schwab app PDFs) for the Erik-Midas repaper flow */
  createRepaperEnvelope: Maybe<CreateRepaperEnvelopePayload>;
  /** Create an automated delivery schedule for a saved report template */
  createReportSchedule: Maybe<CreateReportSchedulePayload>;
  /** Create a new retirement plan (gated behind retirementPlans flag) */
  createRetirementPlan: Maybe<CreateRetirementPlanPayload>;
  /** Add a contact to a retirement plan */
  createRetirementPlanContact: Maybe<CreateRetirementPlanContactPayload>;
  /** Create a compliance milestone on a retirement plan */
  createRetirementPlanMilestone: Maybe<CreateRetirementPlanMilestonePayload>;
  /** Add a note to a retirement plan */
  createRetirementPlanNote: Maybe<CreateRetirementPlanNotePayload>;
  /** Create a participant interaction log entry on a retirement plan */
  createRetirementPlanParticipantLog: Maybe<CreateRetirementPlanParticipantLogPayload>;
  /** Create a special project on a retirement plan */
  createRetirementPlanProject: Maybe<CreateRetirementPlanProjectPayload>;
  /** Create a retirement plan project by instantiating a project template */
  createRetirementPlanProjectFromTemplate: Maybe<CreateRetirementPlanProjectFromTemplatePayload>;
  /** Add a row to a retirement plan project */
  createRetirementPlanProjectRow: Maybe<CreateRetirementPlanProjectRowPayload>;
  /** Create a retirement plan project template for the current advisor's organization */
  createRetirementPlanProjectTemplate: Maybe<CreateRetirementPlanProjectTemplatePayload>;
  createRiskQuestionnaire: Maybe<CreateRiskQuestionnairePayload>;
  /** Creates a new service calendar meeting type template */
  createServiceCalendarMeetingTypeTemplate: Maybe<CreateServiceCalendarMeetingTypeTemplatePayload>;
  /** Creates new recurring service calendar meetings and a meeting type */
  createServiceCalendarMeetings: Maybe<CreateServiceCalendarMeetingsPayload>;
  /** Creates a new service calendar setting template */
  createServiceCalendarSettingTemplates: Maybe<CreateServiceCalendarSettingTemplatePayload>;
  /** Create a service catalog item */
  createServiceCatalogItem: Maybe<CreateServiceCatalogItemPayload>;
  /** Create a service catalog item group */
  createServiceCatalogItemGroup: Maybe<CreateServiceCatalogItemGroupPayload>;
  /** Create a per-assignment override */
  createServiceCatalogItemHouseholdOverride: Maybe<CreateServiceCatalogItemHouseholdOverridePayload>;
  /** Create a task with minimal required input */
  createSimpleTask: Maybe<CreateSimpleTaskPayload>;
  /** Create a sub-task on a parent task */
  createSubtask: Maybe<CreateSubtaskPayload>;
  /** Create a swim request task */
  createSwimRequestTask: Maybe<CreateSwimRequestTaskPayload>;
  createTaskActivityEvent: Maybe<CreateTaskActivityEventPayload>;
  createTaskComment: Maybe<CreateTaskCommentPayload>;
  /** Create a task linked to an email message */
  createTaskFromEmail: Maybe<CreateTaskFromEmailPayload>;
  /** Create a task from a note */
  createTaskFromNote: Maybe<CreateTaskFromNotePayload>;
  /** Create a task and its associated work item in a single operation */
  createTaskWorkItem: Maybe<CreateTaskWorkItemPayload>;
  /** Create a reusable workflow template */
  createTaskWorkflowTemplate: Maybe<CreateTaskWorkflowTemplatePayload>;
  /** Create a tax enrollment */
  createTaxEnrollment: Maybe<CreateTaxEnrollmentPayload>;
  /** Self-serve: a firm admin creates a team in their firm and seeds same-firm members */
  createTeam: Maybe<CreateTeamPayload>;
  /** Create a trading task with associated trading request and quick trades */
  createTradingTask: Maybe<CreateTradingTaskPayload>;
  /** Create a transfer of assets task */
  createTransferOfAssetsTask: Maybe<CreateTransferOfAssetsTaskPayload>;
  /** Create a contact for a user */
  createUserContact: Maybe<CreateUserContactPayload>;
  /** Advisor-only: create a new User for the Add Household Member dialog when no existing match is found. */
  createUserForHouseholdMember: Maybe<CreateUserForHouseholdMemberPayload>;
  deleteAccount: Maybe<DeleteAccountPayload>;
  deleteAddress: Maybe<DeleteAddressPayload>;
  deleteAsset: Maybe<DeleteAssetPayload>;
  /** Soft delete a CallLog */
  deleteCallLog: Maybe<DeleteCallLogPayload>;
  /** Delete a center of influence representative by ID */
  deleteCenterOfInfluenceRep: Maybe<DeleteCenterOfInfluenceRepPayload>;
  /** Delete an opportunity belonging to a client household */
  deleteClientOpportunity: Maybe<DeleteClientOpportunityPayload>;
  /** Delete a co-client from a household */
  deleteCoClient: Maybe<DeleteCoClientPayload>;
  /** Delete your own comment. A comment carrying replies is tombstoned instead of removed so its replies stay reachable. */
  deleteComment: Maybe<DeleteCommentPayload>;
  /**
   * Delete one file attached to your own comment. Savvy removes the Box file
   * itself as well — both the private copy and the client-visible one under
   * Additional Materials when the attachment was filed for the client.
   */
  deleteCommentAttachment: Maybe<DeleteCommentAttachmentPayload>;
  /** Delete a company */
  deleteCompany: Maybe<DeleteCompanyPayload>;
  /** Soft delete a DialpadCall */
  deleteDialpadCall: Maybe<DeleteDialpadCallPayload>;
  deleteFamilyMember: Maybe<DeleteFamilyMemberPayload>;
  /** Delete a fee schedule */
  deleteFeeSchedule: Maybe<DeleteFeeSchedulePayload>;
  /** Admin-only: delete a Financial Offering card (soft delete — the offering is hidden, not destroyed) */
  deleteFinancialOffering: Maybe<DeleteFinancialOfferingPayload>;
  /** Delete a financial plan report PDF from Box */
  deleteFinancialPlanReportFile: Maybe<DeleteFinancialPlanReportFilePayload>;
  deleteGoal: Maybe<DeleteGoalPayload>;
  /** Delete a household from the database and Salesforce. (@deprecated) */
  deleteHousehold: Maybe<DeleteHouseholdPayload>;
  deleteLiability: Maybe<DeleteLiabilityPayload>;
  /** Delete a meeting agenda template */
  deleteMeetingAgendaTemplate: Maybe<DeleteMeetingAgendaTemplatePayload>;
  deleteNote: Maybe<DeleteNotePayload>;
  /** Delete an organization household category */
  deleteOrganizationHouseholdCategory: Maybe<DeleteOrganizationHouseholdCategoryPayload>;
  /** Delete a quarterly financial snapshot */
  deletePlanFinancialSnapshot: Maybe<DeletePlanFinancialSnapshotPayload>;
  /** Remove a professional relationship edge */
  deleteProfessionalRelationship: Maybe<DeleteProfessionalRelationshipPayload>;
  /** Delete the household and all associated data for a prospect opportunity */
  deleteProspectOpportunity: Maybe<DeleteProspectOpportunityPayload>;
  deleteProviderAccount: Maybe<DeleteProviderAccountPayload>;
  /** Delete an automated delivery schedule */
  deleteReportSchedule: Maybe<DeleteReportSchedulePayload>;
  /** Delete a saved report template */
  deleteReportTemplate: Maybe<DeleteReportTemplatePayload>;
  /** Delete a retirement plan and all of its associated data (gated behind retirementPlans flag) */
  deleteRetirementPlan: Maybe<DeleteRetirementPlanPayload>;
  /** Delete a retirement plan contact */
  deleteRetirementPlanContact: Maybe<DeleteRetirementPlanContactPayload>;
  /** Delete a retirement plan milestone */
  deleteRetirementPlanMilestone: Maybe<DeleteRetirementPlanMilestonePayload>;
  /** Delete a retirement plan note */
  deleteRetirementPlanNote: Maybe<DeleteRetirementPlanNotePayload>;
  /** Delete a participant interaction log entry */
  deleteRetirementPlanParticipantLog: Maybe<DeleteRetirementPlanParticipantLogPayload>;
  /** Delete a retirement plan project */
  deleteRetirementPlanProject: Maybe<DeleteRetirementPlanProjectPayload>;
  /** Delete a retirement plan project row */
  deleteRetirementPlanProjectRow: Maybe<DeleteRetirementPlanProjectRowPayload>;
  /** Delete a retirement plan project template */
  deleteRetirementPlanProjectTemplate: Maybe<DeleteRetirementPlanProjectTemplatePayload>;
  /** Deletes a service calendar meeting */
  deleteServiceCalendarMeeting: Maybe<DeleteServiceCalendarMeetingPayload>;
  /** Deletes a service calendar meeting type template */
  deleteServiceCalendarMeetingTypeTemplate: Maybe<DeleteServiceCalendarMeetingTypeTemplatePayload>;
  /** Deletes a service calendar setting template */
  deleteServiceCalendarSettingTemplates: Maybe<DeleteServiceCalendarSettingTemplatePayload>;
  /** Delete a per-assignment override */
  deleteServiceCatalogItemHouseholdOverride: Maybe<DeleteServiceCatalogItemHouseholdOverridePayload>;
  /** Delete a sub-task. Hard delete. Never mutates parent task status. */
  deleteSubtask: Maybe<DeleteSubtaskPayload>;
  /** Delete a task by its Salesforce task ID */
  deleteTask: Maybe<DeleteTaskPayload>;
  deleteTaskComment: Maybe<DeleteTaskCommentPayload>;
  /** Delete a workflow template */
  deleteTaskWorkflowTemplate: Maybe<DeleteTaskWorkflowTemplatePayload>;
  /** Delete a tax enrollment */
  deleteTaxEnrollment: Maybe<DeleteTaxEnrollmentPayload>;
  /** Delete a contact for a user */
  deleteUserContact: Maybe<DeleteUserContactPayload>;
  dismissAllInboxAlerts: Maybe<DismissAllInboxAlertsPayload>;
  /** Mark an announcement as dismissed for the current user */
  dismissAnnouncement: Maybe<DismissAnnouncementPayload>;
  /** Dismiss a completed onboarding household from the cockpit. */
  dismissOnboardingHousehold: Maybe<DismissOnboardingHouseholdPayload>;
  downloadBoxFileUrl: Maybe<DownloadBoxFileUrlPayload>;
  /** Duplicate a service catalog item group under a new name */
  duplicateServiceCatalogItemGroup: Maybe<DuplicateServiceCatalogItemGroupPayload>;
  editCenterOfInfluenceRep: Maybe<EditCenterOfInfluenceRepPayload>;
  /** Edit a company */
  editCompany: Maybe<EditCompanyPayload>;
  /**
   * Enroll households in every active item of one service, transactionally per
   * household: a household lands on all of the active items or on none. Idempotent
   * — a household already active on every item comes back ALREADY_ENROLLED. A
   * household already enrolled in a *different* service comes back
   * BLOCKED_BY_OTHER_SERVICE with that service named, and nothing is written for
   * it: v3 allows one service per household. Duplicate ids are collapsed, and
   * `results` is in the order the ids were given.
   */
  enrollHouseholdsInServiceCatalogItemGroup: Maybe<EnrollHouseholdsInServiceCatalogItemGroupPayload>;
  /** Remove staged households excluded during advisor book upload review */
  excludeAdvisorOnboardingStagedHouseholdsFromBatch: Maybe<ExcludeStagedHouseholdsFromBatchPayload>;
  /** Immediately expire a published report link */
  expirePublishedReport: Maybe<ExpirePublishedReportPayload>;
  /** Trigger Extend extraction for selected Box Client Uploads files (on-demand; already-extracted files skipped) */
  extractBoxClientUploadStatements: Maybe<ExtractBoxClientUploadStatementsPayload>;
  fetchPlaidAccounts: Maybe<FetchPlaidAccountsPayload>;
  /** Admin: Trigger generation of Orion quarterly reports for all eligible households or specific household IDs */
  generateAllQuarterlyReports: Maybe<GenerateAllQuarterlyReportsPayload>;
  /** Generate the missing co-client onboarding task for a blocked household (HAWK-446). */
  generateCoClientTask: Maybe<GenerateCoClientTaskPayload>;
  /** Draft a directory bio + suggested specialties from intake answers */
  generateDirectoryProfileDraft: DirectoryProfileDraft;
  generateInvestmentProposal: Maybe<GenerateInvestmentProposalPayload>;
  /** Generate an Orion report and return a download URL */
  generateOrionReport: Maybe<GenerateOrionReportPayload>;
  generatePortfolioInsights: Maybe<GeneratePortfolioInsightsPayload>;
  generateSalesforceAccessToken: Maybe<GenerateSalesforceAccessTokenPayload>;
  /** Draft an email subject + body for a service calendar event using AI */
  generateServiceEmailDraft: ServiceEmailDraft;
  /** Get the access token for the remote Notion MCP server */
  getNotionMcpAccessToken: Maybe<GetNotionMcpAccessTokenPayload>;
  /** Client user fetch for april tokens */
  getOrCreateAprilToken: Maybe<GetOrCreateAprilTokenPayload>;
  /** Endpoint for users to request their or someone in their households token */
  getOrCreateHouseholdMemberAprilFilingToken: Maybe<GetOrCreateHouseholdMemberAprilFilingTokenPayload>;
  householdWorkflowCreationBackfiller: Scalars['Boolean']['output'];
  impersonateUser: Maybe<ImpersonateUserPayload>;
  /** Launch a workflow into a household */
  launchTaskWorkflowTemplate: Maybe<LaunchTaskWorkflowTemplatePayload>;
  /** Link a household timeline item to a contact (CenterOfInfluenceRep or Contact) */
  linkTimelineItemToContact: Maybe<LinkTimelineItemToContactPayload>;
  /** Attach an unattached Zoom transcript to a household or a professional contact. */
  linkTranscript: Maybe<LinkTranscriptPayload>;
  /** Log a task-level file attachment event (added / removed) on the audit-log timeline */
  logTaskAttachment: Maybe<LogTaskAttachmentPayload>;
  /** Clear an advisor-blocked sub_status on a task by marking advisor requirements as done. */
  markAdvisorRequirementsDone: Maybe<MarkAdvisorRequirementsDonePayload>;
  /** Advance the caller's read watermark on a subject. */
  markCommentsSeen: Maybe<MarkCommentsSeenPayload>;
  /** Admin-only: force an in_progress or blocked onboarding household to complete (HAWK-583). */
  markOnboardingHouseholdComplete: Maybe<MarkHouseholdCompletePayload>;
  /** Stamp last_completed_at = now on an assignment */
  markServiceCatalogItemHouseholdDone: Maybe<MarkServiceCatalogItemHouseholdDonePayload>;
  /** Skip the next occurrence of an assignment */
  markServiceCatalogItemHouseholdSkipped: Maybe<MarkServiceCatalogItemHouseholdSkippedPayload>;
  markTaskCommentsSeen: Maybe<MarkTaskCommentsSeenPayload>;
  /** Merge multiple organization household tags into a new one */
  mergeOrganizationHouseholdTags: Maybe<MergeOrganizationHouseholdTagsPayload>;
  /** Create a MoneyKit Connect link session (new link or re-link) and return its session token */
  moneykitCreateLinkSession: Maybe<MoneykitCreateLinkSessionPayload>;
  /** Exchange a MoneyKit Connect exchange_token for a persisted MONEYKIT ProviderAccount */
  moneykitExchangeLinkToken: Maybe<MoneykitExchangeLinkTokenPayload>;
  /** Refresh an existing MoneyKit-backed ProviderAccount after a re-authentication flow */
  moneykitRefreshLink: Maybe<MoneykitRefreshLinkPayload>;
  moveClientToAdvisor: Maybe<MoveClientToAdvisorPayload>;
  processOnboardedClient: Maybe<ProcessOnboardedClientPayload>;
  /** Promote staged households in an advisor onboarding enrollment into canonical households. */
  promoteAdvisorOnboardingEnrollment: Maybe<PromoteEnrollmentPayload>;
  /** Promote a workflow template into a globally-available Savvy template (admin only) */
  promoteToSavvyTemplate: Maybe<PromoteToSavvyTemplatePayload>;
  /** Publish an existing draft task */
  publishDraftTask: Maybe<PublishDraftTaskPayload>;
  /** Publish or unpublish a financial plan */
  publishFinancialPlan: Maybe<PublishFinancialPlanPayload>;
  /** Atomically publish canonical meeting-prep content */
  publishMeetingPrepOperation: Maybe<PublishMeetingPrepOperationPayload>;
  /** Publish a Report Builder snapshot to a household client portal */
  publishReport: Maybe<PublishReportPayload>;
  /** Publish a service catalog item group and materialize tasks for enrolled households */
  publishServiceCatalogItemGroup: Maybe<PublishServiceCatalogItemGroupPayload>;
  /** Re-evaluate the current user's client_profile.stage against their task statuses and advance it if behind */
  reconcileClientProfileStage: Maybe<ReconcileClientProfileStagePayload>;
  /** Refresh any (Plaid or MoneyKit) ProviderAccount via the Aggregator dispatcher; returns a fresh vendor-agnostic link token */
  refreshProviderAccount: Maybe<RefreshProviderAccountPayload>;
  /** Queue a regeneration of a Savvy meeting summary from a different recap template */
  regenerateMeetingSummary: Maybe<RegenerateMeetingSummaryPayload>;
  /** Refresh email_content snapshots on pending tasks for a catalog item */
  regenerateStaleServiceCatalogTasks: Maybe<RegenerateStaleServiceCatalogTasksPayload>;
  /** Register a mobile device push token for the current user */
  registerPushToken: Maybe<RegisterPushTokenPayload>;
  /** Re-issue a household's DocuSign envelope recipients with their current phone to clear a 2FA block (HAWK-447). */
  reissueEnvelopeWithCurrentPhone: Maybe<ReissueEnvelopeWithCurrentPhonePayload>;
  /** Reject pending-review scheduled report executions, discarding each */
  rejectScheduledReportExecution: Maybe<RejectScheduledReportExecutionPayload>;
  /** Release an awaiting-ops household to ready_to_send once the CSA has prepared its custodian paperwork (HAWK-1031). */
  releaseAdvisorOnboardingToSend: Maybe<ReleaseOnboardingToSendPayload>;
  /** Re-link the correct signed DocuSign envelope to a household stuck in the bulk signed loop (HAWK-445). */
  relinkSignedEnvelope: Maybe<RelinkSignedEnvelopePayload>;
  /** Remove an advisor from an advisor group (deactivates membership and revokes shared household access) */
  removeAdvisorFromAdvisorGroup: Maybe<RemoveAdvisorFromAdvisorGroupPayload>;
  /** Remove a staged co-client from a staged household, leaving the household and primary intact. */
  removeAdvisorOnboardingStagedCoClient: Maybe<RemoveStagedCoClientPayload>;
  /** Remove a staged household row, cascading to its staged clients and accounts. */
  removeAdvisorOnboardingStagedHousehold: Maybe<RemoveStagedHouseholdPayload>;
  /** Remove advisors from an organization */
  removeAdvisorsFromOrganization: Maybe<RemoveAdvisorsFromOrganizationPayload>;
  /** Advisor-only: remove a user from a household. Clears active_household if it was the removed one. */
  removeHouseholdMember: Maybe<RemoveHouseholdMemberPayload>;
  /** Remove a scoped alert mute. */
  removeNotificationAlertMute: Maybe<RemoveNotificationAlertMutePayload>;
  /** Admin-only: soft-delete a confirm_account onboarding household from the cockpit (HAWK-972). */
  removeOnboardingHousehold: Maybe<RemoveOnboardingHouseholdPayload>;
  /** Remove a service catalog item from a group */
  removeServiceCatalogItemFromGroup: Maybe<RemoveServiceCatalogItemFromGroupPayload>;
  /** Remove recurrence from a task */
  removeTaskRecurrence: Maybe<RemoveTaskRecurrencePayload>;
  renewInvite: Maybe<RenewInvitePayload>;
  /** Persist drag-drop ordering for a household's service assignments */
  reorderServiceCatalogItemHouseholds: Maybe<ReorderServiceCatalogItemHouseholdsPayload>;
  /**
   * Move a sub-task to a new 1-indexed position within its parent. Other sub-tasks
   * shift to make room. Never mutates parent task status.
   */
  reorderSubtask: Maybe<ReorderSubtaskPayload>;
  /** Client POST for fetching past 7 years of tax history */
  requestPastTranscriptsFromApril: Maybe<RequestPastTranscriptsFromAprilPayload>;
  /**
   * Issue presigned S3 PUT URLs for repaper PDF uploads (HAWK-70). FE PUTs PDFs to
   * S3 then passes s3_keys to createRepaperEnvelope.
   */
  requestRepaperPdfUploadUrls: Maybe<RequestRepaperPdfUploadUrlsPayload>;
  /** Move a missed meeting occurrence to a new date */
  rescheduleServiceOccurrence: Maybe<RescheduleServiceOccurrencePayload>;
  /** Wipe this demo environment and rebuild it from the given shape. */
  reseedDemoEnvironment: Maybe<ReseedDemoEnvironmentPayload>;
  /**
   * Resend the ECI onboarding invite for an awaiting-client household: rotates
   * each unsubmitted client magic link and re-emails, reusing the original
   * message/settings.
   */
  resendAdvisorOnboarding: Maybe<ResendOnboardingInvitePayload>;
  /** Resend the DocuSign signing notification email for an in-flight envelope */
  resendDocusignEnvelope: Maybe<ResendDocusignEnvelopePayload>;
  resendEmail: Maybe<ResendEmailPayload>;
  resendOtp: Maybe<ResendOtpPayload>;
  /** Send the reminder email for a service assignment and stamp last_reminder_sent_at */
  resendServiceCatalogReminder: Maybe<ResendServiceCatalogReminderPayload>;
  /** Resend one occurrence's invite, using that occurrence's own snapshot */
  resendServiceOccurrenceReminder: Maybe<ResendServiceOccurrenceReminderPayload>;
  resetClientIntakeData: Maybe<ResetClientIntakeDataPayload>;
  resetDemoHousehold: Maybe<ResetDemoHouseholdPayload>;
  /** Reset all catalog notification routing overrides for a user. */
  resetNotificationRouting: Maybe<ResetNotificationRoutingPayload>;
  resetPassword: Maybe<ResetPasswordPayload>;
  resetServiceCalendar: Maybe<ResetServiceCalendarPayload>;
  /** Reset all v6 task notification routing overrides for the current user. */
  resetTaskNotificationRouting: Maybe<ResetTaskNotificationRoutingPayload>;
  /** Mark a ContributionReceived alert's group resolved once the advisor creates the SWIM/invest-cash task from it */
  resolveContributionAlert: Maybe<ResolveContributionAlertPayload>;
  /**
   * Write a CSA's corrections back to the canonical ECI tables and re-drive the
   * Fidelity pipeline for a remediation subtask, atomically.
   */
  resubmitEciRemediation: Maybe<ResubmitEciRemediationPayload>;
  /**
   * Run an admin enabled service object. Note that all positional arguments should
   * be given in the order they are expected in the service object. Keyword
   * arguments should be passed after positional arguments and just need the
   * 'keywordArgKey' variable specified
   */
  runAdminServiceObject: Maybe<RunAdminServiceObjectPayload>;
  runInternalAdminAction: Maybe<RunInternalAdminActionPayload>;
  /** Upsert purpose and source of funds for a non-NFS ECI account onboarding request. */
  saveEciAccountPurposeAndSourceOfFunds: Maybe<SaveEciAccountPurposeAndSourceOfFundsPayload>;
  /** Replace all beneficiaries for an ECI account onboarding request. */
  saveEciBeneficiaries: Maybe<SaveEciBeneficiariesPayload>;
  /** Upsert inherited IRA original-depositor information for an ECI account onboarding request. */
  saveEciDecedentDetails: Maybe<SaveEciDecedentDetailsPayload>;
  /** Upsert SIMPLE IRA employer information for an ECI account onboarding request. */
  saveEciEmployerDetails: Maybe<SaveEciEmployerDetailsPayload>;
  /** Upsert joint/TIC owner details for an ECI account onboarding request. */
  saveEciJointOwnerDetails: Maybe<SaveEciJointOwnerDetailsPayload>;
  /** Upsert trust legal information for an ECI account onboarding request. */
  saveEciTrustDetails: Maybe<SaveEciTrustDetailsPayload>;
  /** Replace trusted contacts for an ECI client onboarding request. Authenticated via MagicLink authorization header. */
  saveEciTrustedContacts: Maybe<SaveEciTrustedContactsPayload>;
  /** Record the current user's thumb on one "Keep in mind" item */
  saveHouseholdKeepInMindVote: Maybe<SaveHouseholdKeepInMindVotePayload>;
  /** Save a report builder configuration as a named template */
  saveReportTemplate: Maybe<SaveReportTemplatePayload>;
  /** Snapshot a project's current rows into a new, reusable project template */
  saveRetirementPlanProjectAsTemplate: Maybe<SaveRetirementPlanProjectAsTemplatePayload>;
  /** Schedule a native PDF report for async background generation */
  scheduleNativeReport: Maybe<ScheduleNativeReportPayload>;
  /** Send ECI onboarding invites for a ready-to-send staged household and advance it to awaiting_client. */
  sendAdvisorOnboarding: Maybe<SendOnboardingPayload>;
  /**
   * Send the existing ECI onboarding magic link for an awaiting-client household
   * to the Savvy Ops mailbox without rotating the token or changing
   * status/reminders.
   */
  sendAdvisorOnboardingInviteToOps: Maybe<SendOnboardingInviteToOpsPayload>;
  /** Sends a client booking email */
  sendClientBookingEmail: Maybe<SendClientBookingEmailPayload>;
  sendClientWelcomeEmail: Maybe<SendClientWelcomeEmailPayload>;
  sendCreatePasswordEmail: Maybe<SendCreatePasswordEmailPayload>;
  /** Send an email via Gmail on behalf of the authenticated advisor */
  sendEmailMessage: Maybe<SendEmailMessagePayload>;
  sendFileShareEmail: Maybe<SendFileShareEmailPayload>;
  /** Send onboarding to client, will also update the onboarding task status */
  sendOnboardingToClient: Maybe<SendOnboardingToClientPayload>;
  /** Flip a draft repaper envelope to sent — kicks off DocuSign signing routing */
  sendRepaperEnvelope: Maybe<SendRepaperEnvelopePayload>;
  sendSignOnboardingDocumentsReminder: Maybe<SendSignOnboardingDocumentsReminderPayload>;
  sendTaskEmail: Maybe<SendTaskEmailPayload>;
  /** Enable or disable the account-connection reminder email for a household */
  setAccountConnectionReminderPreference: Maybe<SetAccountConnectionReminderPreferencePayload>;
  /** Pin or unpin an activity timeline entry for its household */
  setActivityEntryPinned: Maybe<SetActivityEntryPinnedPayload>;
  /** Internal-admin: set an advisor-tier team member's level (assistant/advisor/admin). */
  setAdvisorTierLevel: Maybe<SetAdvisorTierLevelPayload>;
  /** Replace a client's full set of recurring income sources */
  setClientIncomeSources: Maybe<SetClientIncomeSourcesPayload>;
  setContactAccountRelation: Maybe<SetContactAccountRelationPayload>;
  setGovernmentId: Maybe<SetGovernmentIdPayload>;
  /** Set the Orion benchmark for a household. */
  setHouseholdBenchmark: Maybe<SetHouseholdBenchmarkPayload>;
  /** Shift the next occurrence of an assignment to a specific future date */
  setServiceCatalogItemHouseholdNextOccurrence: Maybe<SetServiceCatalogItemHouseholdNextOccurrencePayload>;
  /** Admin: replace the Savvy Portfolio Finance loan-length options */
  setSwimLoanLengthOptions: Maybe<SetSwimLoanLengthOptionsPayload>;
  /** Admin: replace the SWIM enrollment strategies and their fees */
  setSwimStrategies: Maybe<SetSwimStrategiesPayload>;
  /** Set or update recurrence on a task */
  setTaskRecurrence: Maybe<SetTaskRecurrencePayload>;
  /** Transactionally create an organization, its advisor group, memberships, org link, and optional branding */
  setUpAdvisorOrganization: Maybe<SetUpAdvisorOrganizationPayload>;
  setupTaskReminders: Maybe<SetupTaskRemindersPayload>;
  /** Share a household with an advisor group */
  shareHouseholdWithAdvisorGroup: Maybe<ShareHouseholdWithAdvisorGroupPayload>;
  /** Surface an already-published report in the client portal */
  sharePublishedReport: Maybe<SharePublishedReportPayload>;
  /** Grant another organization access to a retirement plan */
  shareRetirementPlanWithOrganization: Maybe<ShareRetirementPlanWithOrganizationPayload>;
  /** Sign a tax addendum agreement for the current client user */
  signTaxAddendum: Maybe<SignTaxAddendumPayload>;
  signUpForSavvy: Maybe<SignUpForSavvyPayload>;
  /** Mark one service occurrence as not happening */
  skipServiceOccurrence: Maybe<SkipServiceOccurrencePayload>;
  /**
   * Admin: pull Schwab AS Standing Authorizations over the API for the whole firm
   * into the Linked Bank Accounts pipeline. Takes no arguments; every
   * Schwab-custodied account is paired with its primary advisor's master account.
   */
  startSchwabApiImport: Maybe<StartSchwabApiImportPayload>;
  /** Endpoint to stop impersonation */
  stopImpersonatingUser: Maybe<StopImpersonatingUserPayload>;
  /** Revoke one or more organizations' shared access to a retirement plan */
  stopSharingRetirementPlanOrganizations: Maybe<StopSharingRetirementPlanOrganizationsPayload>;
  /**
   * Terminal cockpit ECI book-onboarding submit: publishes the promoted draft
   * graph, activates account-onboarding tasks, and sends client invites.
   */
  submitEciAccountOnboarding: Maybe<SubmitEciAccountOnboardingPayload>;
  /**
   * Submit ECI client onboarding: creates a Signature and linked ClientAgreement
   * for the MSA, and ClientAgreement-only records for each acknowledged
   * disclosure, then marks the request submitted. Authenticated via MagicLink
   * authorization header.
   */
  submitEciClientOnboarding: Maybe<SubmitEciClientOnboardingPayload>;
  /**
   * Kick off the ECI custodian-transfer onboarding: creates the household +
   * per-client onboarding requests and emails each client a tokenized invite.
   */
  submitEciUpgradeCustodian: Maybe<SubmitEciUpgradeCustodianPayload>;
  /** Switch the viewer's active household. Viewer must be a member of the target household or its advisor. */
  switchActiveHousehold: Maybe<SwitchActiveHouseholdPayload>;
  /** Sync the selected accounts to transfer to ECI; creates tasks for newly-selected accounts and cancels deselected ones. */
  syncEciAccountOnboardingRequestSelection: Maybe<SyncEciAccountOnboardingRequestSelectionPayload>;
  /** Sync Orion data */
  syncOrionData: Maybe<SyncOrionDataPayload>;
  /** Mark which prefilled standing instructions / recurring transfers carry over to the new ECI account. */
  syncStandingInstructionSelections: Maybe<SyncStandingInstructionSelectionsPayload>;
  /** Add or remove your reaction of one emoji on a comment. */
  toggleCommentReaction: Maybe<ToggleCommentReactionPayload>;
  trackEvent: Maybe<TrackEventPayload>;
  /** Unarchive a client household: restore stage from inactive to won */
  unarchiveHousehold: Maybe<UnarchiveHouseholdPayload>;
  /** Unarchive a service catalog item group */
  unarchiveServiceCatalogItemGroup: Maybe<UnarchiveServiceCatalogItemGroupPayload>;
  /** Soft-unassign a service catalog item from a household */
  unassignServiceCatalogItemFromHousehold: Maybe<UnassignServiceCatalogItemFromHouseholdPayload>;
  /**
   * Pause the enrollments one service owns for each household, transactionally per
   * household. An enrollment is this service's when it carries this service's id,
   * or carries none and is on an item no other live service lists, so a household
   * on a second service keeps that one's schedule and its materialized
   * occurrences. An archived service still accepts unenrollment. Duplicate ids are
   * collapsed, and `results` is in the order the ids were given.
   */
  unenrollHouseholdsFromServiceCatalogItemGroup: Maybe<UnenrollHouseholdsFromServiceCatalogItemGroupPayload>;
  /** Clear a household's Orion connection (admin only) */
  unlinkOrionHousehold: Maybe<UnlinkOrionHouseholdPayload>;
  /** Remove a link between a household timeline item and a contact */
  unlinkTimelineItemFromContact: Maybe<UnlinkTimelineItemFromContactPayload>;
  /** Remove a mobile device push token for the current user */
  unregisterPushToken: Maybe<UnregisterPushTokenPayload>;
  updateAccount: Maybe<UpdateAccountPayload>;
  /** Update an account sleeve */
  updateAccountSleeve: Maybe<UpdateAccountSleevePayload>;
  updateAccountTransferDatum: Maybe<UpdateAccountTransferDatumPayload>;
  updateActionCenterVisited: Maybe<UpdateActionCenterVisitedPayload>;
  updateAddress: Maybe<UpdateAddressPayload>;
  updateAdvisorAiDisclosureAcceptance: Maybe<UpdateAdvisorAiDisclosureAcceptancePayload>;
  /** @deprecated Use update_advisor_settings instead */
  updateAdvisorAlertSettings: Maybe<UpdateAdvisorAlertSettingsPayload>;
  /** Set whether an advisor is employed under Savvy's RIA (captive) or runs their own book (owned) */
  updateAdvisorCaptiveStatus: Maybe<UpdateAdvisorCaptiveStatusPayload>;
  updateAdvisorCsa: Maybe<UpdateAdvisorCsaPayload>;
  /** Update the current advisor's own directory profile */
  updateAdvisorDirectoryProfile: AdvisorDirectoryEntry;
  /** Update group-level display settings such as hiding ARR from support staff (assistants and CSAs) */
  updateAdvisorGroupSettings: Maybe<UpdateAdvisorGroupSettingsPayload>;
  /** Set whether an advisor is a new advisor or an existing one, which gates the contract their clients sign */
  updateAdvisorOnboardingCohort: Maybe<UpdateAdvisorOnboardingCohortPayload>;
  /** Advance the advisor onboarding enrollment wizard step for deeplink resume. */
  updateAdvisorOnboardingEnrollment: Maybe<UpdateEnrollmentPayload>;
  /** Admin-only: set the destination custodian on a staged, not-yet-confirmed onboarding account (HAWK-923). */
  updateAdvisorOnboardingStagedAccountDestination: Maybe<UpdateStagedAccountDestinationPayload>;
  /** Edit a staged client field and re-run per-field validation. */
  updateAdvisorOnboardingStagedClient: Maybe<UpdateStagedClientPayload>;
  /** Edit a staged household field and re-run per-field validation. */
  updateAdvisorOnboardingStagedHousehold: Maybe<UpdateStagedHouseholdPayload>;
  /** @deprecated Use update_advisor_settings instead */
  updateAdvisorProfile: Maybe<UpdateAdvisorProfilePayload>;
  updateAdvisorSettings: Maybe<UpdateAdvisorSettingsPayload>;
  updateAlert: Maybe<UpdateAlertPayload>;
  updateAsset: Maybe<UpdateAssetPayload>;
  updateClientDetails: Maybe<UpdateClientDetailsPayload>;
  updateClientEmploymentDetails: Maybe<UpdateClientEmploymentDetailsPayload>;
  updateClientIntakeData: Maybe<UpdateClientIntakeDataPayload>;
  updateClientPortalMessage: Maybe<UpdateClientPortalMessagePayload>;
  updateClientProfile: Maybe<UpdateClientProfilePayload>;
  /** Update client details and roles in a single transaction */
  updateClients: Maybe<UpdateClientsPayload>;
  /** Edit your own comment. Stamps editedAt so the UI can render "(edited)". */
  updateComment: Maybe<UpdateCommentPayload>;
  /**
   * File a copy of an attachment under the household's client-visible Additional
   * Materials folder, or remove that copy. Savvy makes the Box copy and records
   * its id in the same call, so the id stored and the object it names are written
   * by the same actor.
   */
  updateCommentAttachmentSync: Maybe<UpdateCommentAttachmentSyncPayload>;
  updateContact: Maybe<UpdateContactPayload>;
  /** Update notes for a DialpadCall */
  updateDialpadCallNotes: Maybe<UpdateDialpadCallNotesPayload>;
  /** Update content for a DialpadEvent */
  updateDialpadEventContent: Maybe<UpdateDialpadEventContentPayload>;
  /**
   * Upsert the citizenship & tax-status fields on the personal-information row for
   * an ECI client onboarding request. Authenticated via MagicLink authorization header.
   */
  updateEciCitizenshipTaxStatus: Maybe<UpdateEciCitizenshipTaxStatusPayload>;
  /**
   * Move the resume cursor for an ECI client onboarding request as the client
   * advances. Authenticated via MagicLink authorization header.
   */
  updateEciCurrentStep: Maybe<UpdateEciCurrentStepPayload>;
  /**
   * Upsert the financial profile sidecar for an ECI client onboarding request.
   * Authenticated via MagicLink authorization header.
   */
  updateEciFinancialProfile: Maybe<UpdateEciFinancialProfilePayload>;
  /**
   * Upsert the personal information sidecar for an ECI client onboarding request.
   * Authenticated via MagicLink authorization header.
   */
  updateEciPersonalInformation: Maybe<UpdateEciPersonalInformationPayload>;
  /**
   * Upsert the regulatory-disclosures header and detail rows for an ECI client
   * onboarding request. Authenticated via MagicLink authorization header.
   */
  updateEciRegulatoryDisclosure: Maybe<UpdateEciRegulatoryDisclosurePayload>;
  /** Update a family member in a household */
  updateFamilyMember: Maybe<UpdateFamilyMemberPayload>;
  /** Update a fee schedule */
  updateFeeSchedule: Maybe<UpdateFeeSchedulePayload>;
  /** Admin-only: atomically update a Financial Offering and its fees, key facts, links, and provider copy */
  updateFinancialOffering: Maybe<UpdateFinancialOfferingPayload>;
  updateGoal: Maybe<UpdateGoalPayload>;
  /** Update attributes of a household */
  updateHousehold: Maybe<UpdateHouseholdPayload>;
  /** Update household permissions */
  updateHouseholdAccess: Maybe<UpdateHouseholdAccessPayload>;
  /** Advisor-only: update a household membership's role and/or flags. */
  updateHouseholdMember: Maybe<UpdateHouseholdMemberPayload>;
  /** Update tags for a household */
  updateHouseholdTags: Maybe<UpdateHouseholdTagsPayload>;
  updateLiability: Maybe<UpdateLiabilityPayload>;
  /** Update a meeting agenda template */
  updateMeetingAgendaTemplate: Maybe<UpdateMeetingAgendaTemplatePayload>;
  updateNote: Maybe<UpdateNotePayload>;
  /** Set one catalog notification destination for a user. */
  updateNotificationRoute: Maybe<UpdateNotificationRoutePayload>;
  /** Update the current advisor's onboarding personalization (welcome message, firm name, firm logo) */
  updateOnboardingPersonalization: Maybe<UpdateOnboardingPersonalizationPayload>;
  /** Update the data for an onboarding task */
  updateOnboardingTaskData: Maybe<UpdateOnboardingTaskDataPayload>;
  updateOpportunity: Maybe<UpdateOpportunityPayload>;
  /** Update organization branding including logo upload to Cloudinary */
  updateOrganizationBranding: Maybe<UpdateOrganizationBrandingPayload>;
  /** Update an organization household category */
  updateOrganizationHouseholdCategory: Maybe<UpdateOrganizationHouseholdCategoryPayload>;
  /** Update an organization household tag */
  updateOrganizationHouseholdTag: Maybe<UpdateOrganizationHouseholdTagPayload>;
  /** Replace the set of households a manual tag is applied to (smart tags are rule-driven and rejected). */
  updateOrganizationHouseholdTagHouseholds: Maybe<UpdateOrganizationHouseholdTagHouseholdsPayload>;
  /** Update firm-setup settings on the current user's organization, such as whether Organization Branding is available */
  updateOrganizationSettings: Maybe<UpdateOrganizationSettingsPayload>;
  /** Update the current user organization's ops paperwork instructions message */
  updateOrganizationTaskInstructions: Maybe<UpdateOrganizationTaskInstructionsPayload>;
  /** Update Orion report enrollments for multiple households */
  updateOrionReportEnrollments: Maybe<UpdateOrionReportEnrollmentsPayload>;
  /** Update fields on a quarterly financial snapshot (patch semantics) */
  updatePlanFinancialSnapshot: Maybe<UpdatePlanFinancialSnapshotPayload>;
  /** Update a portfolio's investment details */
  updatePortfolio: Maybe<UpdatePortfolioPayload>;
  /** Update a portfolio strategy's name */
  updatePortfolioStrategy: Maybe<UpdatePortfolioStrategyPayload>;
  /** Update the notes on a professional relationship edge */
  updateProfessionalRelationship: Maybe<UpdateProfessionalRelationshipPayload>;
  /** Update an opportunity for a prospect opportunity */
  updateProspectOpportunity: Maybe<UpdateProspectOpportunityPayload>;
  updateProviderAccount: Maybe<UpdateProviderAccountPayload>;
  /** Update an automated delivery schedule */
  updateReportSchedule: Maybe<UpdateReportSchedulePayload>;
  /** Update an existing saved report template */
  updateReportTemplate: Maybe<UpdateReportTemplatePayload>;
  /** Update an existing retirement plan (gated behind retirementPlans flag) */
  updateRetirementPlan: Maybe<UpdateRetirementPlanPayload>;
  /** Update a retirement plan contact */
  updateRetirementPlanContact: Maybe<UpdateRetirementPlanContactPayload>;
  /** Create or update plan design details (upserts the single design record for the plan) */
  updateRetirementPlanDesign: Maybe<UpdateRetirementPlanDesignPayload>;
  /** Update fields on a retirement plan milestone (patch semantics) */
  updateRetirementPlanMilestone: Maybe<UpdateRetirementPlanMilestonePayload>;
  /** Update a retirement plan note (patch semantics) */
  updateRetirementPlanNote: Maybe<UpdateRetirementPlanNotePayload>;
  /** Update a participant interaction log entry (patch semantics) */
  updateRetirementPlanParticipantLog: Maybe<UpdateRetirementPlanParticipantLogPayload>;
  /** Update a retirement plan project (patch semantics) */
  updateRetirementPlanProject: Maybe<UpdateRetirementPlanProjectPayload>;
  /** Update a retirement plan project row (patch semantics) */
  updateRetirementPlanProjectRow: Maybe<UpdateRetirementPlanProjectRowPayload>;
  /** Update a retirement plan project template (patch semantics; steps, when provided, replace the existing set) */
  updateRetirementPlanProjectTemplate: Maybe<UpdateRetirementPlanProjectTemplatePayload>;
  /** Re-sync a project's source template so its steps match the project's current rows */
  updateRetirementPlanProjectTemplateFromProject: Maybe<UpdateRetirementPlanProjectTemplateFromProjectPayload>;
  /** Update an RMD */
  updateRmd: Maybe<UpdateRmdPayload>;
  updateServiceCalendarItem: Maybe<UpdateServiceCalendarItemPayload>;
  updateServiceCalendarMeeting: Maybe<UpdateServiceCalendarMeetingPayload>;
  updateServiceCalendarSettingTemplates: Maybe<UpdateServiceCalendarSettingTemplatesPayload>;
  updateServiceCalendarSettings: Maybe<UpdateServiceCalendarSettingsPayload>;
  /** Update a service catalog item */
  updateServiceCatalogItem: Maybe<UpdateServiceCatalogItemPayload>;
  /** Update a service catalog item group */
  updateServiceCatalogItemGroup: Maybe<UpdateServiceCatalogItemGroupPayload>;
  /** Update a per-assignment override */
  updateServiceCatalogItemHouseholdOverride: Maybe<UpdateServiceCatalogItemHouseholdOverridePayload>;
  /** Update simple tasks */
  updateSimpleTask: Maybe<UpdateSimpleTaskPayload>;
  /** Update a sub-task. Never mutates parent task status. */
  updateSubtask: Maybe<UpdateSubtaskPayload>;
  updateTask: Maybe<UpdateTaskPayload>;
  updateTaskComment: Maybe<UpdateTaskCommentPayload>;
  /** Upsert one v6 task notification routing cell for the current user. */
  updateTaskNotificationRoute: Maybe<UpdateTaskNotificationRoutePayload>;
  updateTaskSuggestion: Maybe<UpdateTaskSuggestionPayload>;
  /** Update a task and its associated work item records in a single operation */
  updateTaskWorkItem: Maybe<UpdateTaskWorkItemPayload>;
  /** Update a workflow template */
  updateTaskWorkflowTemplate: Maybe<UpdateTaskWorkflowTemplatePayload>;
  /** Update a tax enrollment */
  updateTaxEnrollment: Maybe<UpdateTaxEnrollmentPayload>;
  updateUser: Maybe<UpdateUserPayload>;
  /** Update a contact for a user */
  updateUserContact: Maybe<UpdateUserContactPayload>;
  /** Push filing data into april */
  updateUserDataInAprilFiling: Maybe<UpdateUserDataInAprilFilingPayload>;
  updateUserSecurityAttribute: Maybe<UpdateUserSecurityAttributePayload>;
  /** Upload file to Box folder */
  uploadFileToBox: Maybe<UploadToBoxResult>;
  /** Admin: upload a custodian CSV/XLSX for the Linked Bank Accounts seed tool — enqueues background parsing */
  uploadLinkedBankAccountImport: Maybe<UploadLinkedBankAccountImportPayload>;
  /** Upsert saved view/preferences values for the current user */
  upsertUserSavedViews: Maybe<UpsertUserSavedViewsPayload>;
  /** Validate advisor-entered tickers against Orion before adding to a blended investment proposal target. */
  validateInvestmentProposalTickers: Maybe<ValidateInvestmentProposalTickersPayload>;
  /**
   * Verify the client's identity (last name / SSN / DOB) against the values on
   * file before they proceed through ECI onboarding. Authenticated via MagicLink
   * authorization header.
   */
  verifyEciOnboardingIdentity: Maybe<VerifyEciOnboardingIdentityPayload>;
  /** Commit a captured Voice Profile */
  voiceProfileCommit: Maybe<VoiceProfileCommitPayload>;
  /** Remove an example from the voice profile */
  voiceProfileRemoveExample: Maybe<VoiceProfileRemoveExamplePayload>;
  /** Re-run voice extraction */
  voiceProfileRerunCapture: Maybe<VoiceProfileRerunCapturePayload>;
  /** Persist the display-only generated voice sample */
  voiceProfileSetSample: Maybe<VoiceProfileSetSamplePayload>;
  /** Void an in-flight DocuSign envelope */
  voidDocusignEnvelope: Maybe<VoidDocusignEnvelopePayload>;
  /** Preview a Wealthbox API import for an advisor — mutation to guarantee POST transport and prevent access_token URL exposure */
  wealthboxImportPreview: Maybe<WealthboxImportPreviewMutationPayload>;
};


export type MutationAcknowledgeAlertArgs = {
  input: AcknowledgeAlertInput;
};


export type MutationActivateServiceCalendarForHouseholdArgs = {
  input: ActivateServiceCalendarForHouseholdInput;
};


export type MutationAddAdvisorGroupToOrganizationArgs = {
  input: AddAdvisorGroupToOrganizationInput;
};


export type MutationAddAdvisorToExistingAdvisorGroupArgs = {
  input: AddAdvisorToExistingAdvisorGroupInput;
};


export type MutationAddAdvisorsToOrganizationArgs = {
  input: AddAdvisorsToOrganizationInput;
};


export type MutationAddCommentAttachmentsArgs = {
  input: AddCommentAttachmentsInput;
};


export type MutationAddFamilyMembersArgs = {
  input: AddFamilyMembersInput;
};


export type MutationAddHouseholdMemberArgs = {
  input: AddHouseholdMemberInput;
};


export type MutationAddNotificationAlertMuteArgs = {
  input: AddNotificationAlertMuteInput;
};


export type MutationAddSecondaryPortfolioArgs = {
  input: AddSecondaryPortfolioInput;
};


export type MutationAddServiceCatalogItemToGroupArgs = {
  input: AddServiceCatalogItemToGroupInput;
};


export type MutationAdvanceEciOnboardingToReadyToSendArgs = {
  input: AdvanceEciOnboardingToReadyToSendInput;
};


export type MutationAdvanceOnboardingAfterSigningArgs = {
  input: AdvanceOnboardingAfterSigningInput;
};


export type MutationApproveScheduledReportExecutionArgs = {
  input: ApproveScheduledReportExecutionInput;
};


export type MutationArchiveHouseholdArgs = {
  input: ArchiveHouseholdInput;
};


export type MutationArchiveServiceCatalogItemArgs = {
  input: ArchiveServiceCatalogItemInput;
};


export type MutationArchiveServiceCatalogItemGroupArgs = {
  input: ArchiveServiceCatalogItemGroupInput;
};


export type MutationAssignHouseholdFeeScheduleArgs = {
  input: AssignHouseholdFeeScheduleInput;
};


export type MutationAssignServiceCatalogItemToHouseholdArgs = {
  input: AssignServiceCatalogItemToHouseholdInput;
};


export type MutationBeginMfaEnrollmentArgs = {
  input: BeginMfaEnrollmentInput;
};


export type MutationBulkCancelTasksArgs = {
  input: BulkCancelTasksInput;
};


export type MutationBulkCreateOrUpdateHouseholdsArgs = {
  input: BulkCreateOrUpdateHouseholdsInput;
};


export type MutationBulkDeleteOrganizationHouseholdTagsArgs = {
  input: BulkDeleteOrganizationHouseholdTagsInput;
};


export type MutationBulkGenerateReportsArgs = {
  input: BulkGenerateReportsInput;
};


export type MutationBulkUpdateAlertsArgs = {
  input: BulkUpdateAlertsInput;
};


export type MutationBulkUpdateClientsArgs = {
  input: BulkUpdateClientsInput;
};


export type MutationBulkUpdateOrganizationHouseholdCategoriesArgs = {
  input: BulkUpdateOrganizationHouseholdCategoriesInput;
};


export type MutationBulkUpdateTaxEnrollmentsToNotInterestedArgs = {
  input: BulkUpdateTaxEnrollmentsToNotInterestedInput;
};


export type MutationBulkUploadFilesToBoxArgs = {
  input: BulkUploadFilesToBoxInput;
};


export type MutationCancelLinkedBankAccountImportArgs = {
  input: CancelLinkedBankAccountImportInput;
};


export type MutationClearHouseholdBenchmarkArgs = {
  input: ClearHouseholdBenchmarkInput;
};


export type MutationClearRedisCacheForBoxFolderArgs = {
  input: ClearRedisCacheForBoxFolderInput;
};


export type MutationCloseEciRemediationSubtaskArgs = {
  input: CloseEciRemediationSubtaskInput;
};


export type MutationCompleteGoogleOAuthFlowArgs = {
  input: CompleteGoogleOAuthFlowInput;
};


export type MutationCompleteSchwabOauthConnectArgs = {
  input: CompleteSchwabOauthConnectInput;
};


export type MutationCompleteServiceOccurrenceArgs = {
  input: CompleteServiceOccurrenceInput;
};


export type MutationConfirmAdvisorOnboardingAccountsArgs = {
  input: ConfirmAccountsInput;
};


export type MutationConfirmLinkedBankAccountImportArgs = {
  input: ConfirmLinkedBankAccountImportInput;
};


export type MutationConfirmPortfolioArgs = {
  input: ConfirmPortfolioInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAccountConfirmationTaskArgs = {
  input: CreateAccountConfirmationTaskInput;
};


export type MutationCreateAccountMaintenanceTaskArgs = {
  input: CreateAccountMaintenanceTaskInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAdvisorArgs = {
  input: CreateAdvisorInput;
};


export type MutationCreateAdvisorGroupArgs = {
  input: CreateAdvisorGroupInput;
};


export type MutationCreateAdvisorOnboardingEnrollmentArgs = {
  input: CreateEnrollmentInput;
};


export type MutationCreateAdvisorRequestArgs = {
  input: CreateAdvisorRequestInput;
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateAlternativeInvestmentsPurchaseTaskArgs = {
  input: CreateAlternativeInvestmentsPurchaseTaskInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateBulkImportArgs = {
  input: CreateBulkImportInput;
};


export type MutationCreateCenterOfInfluenceRepArgs = {
  input: CreateCenterOfInfluenceRepInput;
};


export type MutationCreateClientBillingTaskArgs = {
  input: CreateClientBillingTaskInput;
};


export type MutationCreateClientInfoChangeTaskArgs = {
  input: CreateClientInfoChangeTaskInput;
};


export type MutationCreateClientOpportunityArgs = {
  input: CreateClientOpportunityInput;
};


export type MutationCreateClientPortalMessageArgs = {
  input: CreateClientPortalMessageInput;
};


export type MutationCreateCoClientFromIntakeDataArgs = {
  input: CreateCoClientFromIntakeDataInput;
};


export type MutationCreateCoClientUserArgs = {
  input: CreateCoClientUserInput;
};


export type MutationCreateCoiCallLogArgs = {
  input: CreateCoiCallLogInput;
};


export type MutationCreateCoiMeetingArgs = {
  input: CreateCoiMeetingInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyCallLogArgs = {
  input: CreateCompanyCallLogInput;
};


export type MutationCreateCompanyMeetingArgs = {
  input: CreateCompanyMeetingInput;
};


export type MutationCreateConquestPlanFromDataArgs = {
  input: CreateConquestPlanFromDataInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContactCallLogArgs = {
  input: CreateContactCallLogInput;
};


export type MutationCreateContactMeetingArgs = {
  input: CreateContactMeetingInput;
};


export type MutationCreateContributionAlertsFromUploadArgs = {
  input: CreateContributionAlertsFromUploadInput;
};


export type MutationCreateCorporateRetirementPlanTaskArgs = {
  input: CreateCorporateRetirementPlanTaskInput;
};


export type MutationCreateDataExportArgs = {
  input: CreateDataExportInput;
};


export type MutationCreateDocumentSignatureForTaskArgs = {
  input: CreateDocumentSignatureForTaskInput;
};


export type MutationCreateDocusignLpoaEnvelopeBulkUploadArgs = {
  input: CreateDocusignLpoaEnvelopeBulkUploadInput;
};


export type MutationCreateFeeScheduleForAdvisorArgs = {
  input: CreateFeeScheduleForAdvisorInput;
};


export type MutationCreateFileUploadTaskArgs = {
  input: CreateFileUploadTaskInput;
};


export type MutationCreateFinancialOfferingArgs = {
  input: CreateFinancialOfferingInput;
};


export type MutationCreateFinancialPlanArgs = {
  input: CreateFinancialPlanInput;
};


export type MutationCreateGoalArgs = {
  input: CreateGoalInput;
};


export type MutationCreateLiabilityArgs = {
  input: CreateLiabilityInput;
};


export type MutationCreateManualOnboardingTaskArgs = {
  input: CreateManualOnboardingTaskInput;
};


export type MutationCreateMeetingArgs = {
  input: CreateMeetingInput;
};


export type MutationCreateMeetingAgendaTemplateArgs = {
  input: CreateMeetingAgendaTemplateInput;
};


export type MutationCreateMoneyMovementRequestTaskArgs = {
  input: CreateMoneyMovementRequestTaskInput;
};


export type MutationCreateNfsAuditExportArgs = {
  input: CreateNfsAuditExportInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateNoteForContactArgs = {
  input: CreateNoteForContactInput;
};


export type MutationCreateNoteForDialpadCallArgs = {
  input: CreateNoteForDialpadCallInput;
};


export type MutationCreateNoteForEventArgs = {
  input: CreateNoteForEventInput;
};


export type MutationCreateOnboardingTaskArgs = {
  input: CreateOnboardingTaskInput;
};


export type MutationCreateOpenNewAccountTaskArgs = {
  input: CreateOpenNewAccountTaskInput;
};


export type MutationCreateOrUpdateCallLogArgs = {
  input: CreateOrUpdateCallLogInput;
};


export type MutationCreateOrUpdateServiceCalendarSettingsArgs = {
  input: CreateOrUpdateServiceCalendarSettingsInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationBrandingArgs = {
  input: CreateOrganizationBrandingRowInput;
};


export type MutationCreateOrganizationHouseholdCategoryArgs = {
  input: CreateOrganizationHouseholdCategoryInput;
};


export type MutationCreateOrganizationHouseholdTagArgs = {
  input: CreateOrganizationHouseholdTagInput;
};


export type MutationCreateOtherInvestmentTaskArgs = {
  input: CreateOtherInvestmentTaskInput;
};


export type MutationCreatePlaidLinkTokenArgs = {
  input: CreatePlaidLinkTokenInput;
};


export type MutationCreatePlanFinancialSnapshotArgs = {
  input: CreatePlanFinancialSnapshotInput;
};


export type MutationCreateProfessionalRelationshipArgs = {
  input: CreateProfessionalRelationshipInput;
};


export type MutationCreateProspectOpportunityArgs = {
  input: CreateProspectOpportunityInput;
};


export type MutationCreateProviderAccountArgs = {
  input: CreateProviderAccountInput;
};


export type MutationCreateRepaperEnvelopeArgs = {
  input: CreateRepaperEnvelopeInput;
};


export type MutationCreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


export type MutationCreateRetirementPlanArgs = {
  input: CreateRetirementPlanInput;
};


export type MutationCreateRetirementPlanContactArgs = {
  input: CreateRetirementPlanContactInput;
};


export type MutationCreateRetirementPlanMilestoneArgs = {
  input: CreateRetirementPlanMilestoneInput;
};


export type MutationCreateRetirementPlanNoteArgs = {
  input: CreateRetirementPlanNoteInput;
};


export type MutationCreateRetirementPlanParticipantLogArgs = {
  input: CreateRetirementPlanParticipantLogInput;
};


export type MutationCreateRetirementPlanProjectArgs = {
  input: CreateRetirementPlanProjectInput;
};


export type MutationCreateRetirementPlanProjectFromTemplateArgs = {
  input: CreateRetirementPlanProjectFromTemplateInput;
};


export type MutationCreateRetirementPlanProjectRowArgs = {
  input: CreateRetirementPlanProjectRowInput;
};


export type MutationCreateRetirementPlanProjectTemplateArgs = {
  input: CreateRetirementPlanProjectTemplateInput;
};


export type MutationCreateRiskQuestionnaireArgs = {
  input: CreateRiskQuestionnaireInput;
};


export type MutationCreateServiceCalendarMeetingTypeTemplateArgs = {
  input: CreateServiceCalendarMeetingTypeTemplateInput;
};


export type MutationCreateServiceCalendarMeetingsArgs = {
  input: CreateServiceCalendarMeetingsInput;
};


export type MutationCreateServiceCalendarSettingTemplatesArgs = {
  input: CreateServiceCalendarSettingTemplateInput;
};


export type MutationCreateServiceCatalogItemArgs = {
  input: CreateServiceCatalogItemInput;
};


export type MutationCreateServiceCatalogItemGroupArgs = {
  input: CreateServiceCatalogItemGroupInput;
};


export type MutationCreateServiceCatalogItemHouseholdOverrideArgs = {
  input: CreateServiceCatalogItemHouseholdOverrideInput;
};


export type MutationCreateSimpleTaskArgs = {
  input: CreateSimpleTaskInput;
};


export type MutationCreateSubtaskArgs = {
  input: CreateSubtaskInput;
};


export type MutationCreateSwimRequestTaskArgs = {
  input: CreateSwimRequestTaskInput;
};


export type MutationCreateTaskActivityEventArgs = {
  input: CreateTaskActivityEventInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateTaskFromEmailArgs = {
  input: CreateTaskFromEmailInput;
};


export type MutationCreateTaskFromNoteArgs = {
  input: CreateTaskFromNoteInput;
};


export type MutationCreateTaskWorkItemArgs = {
  input: CreateTaskWorkItemInput;
};


export type MutationCreateTaskWorkflowTemplateArgs = {
  input: CreateTaskWorkflowTemplateInput;
};


export type MutationCreateTaxEnrollmentArgs = {
  input: CreateTaxEnrollmentInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTradingTaskArgs = {
  input: CreateTradingTaskInput;
};


export type MutationCreateTransferOfAssetsTaskArgs = {
  input: CreateTransferOfAssetsTaskInput;
};


export type MutationCreateUserContactArgs = {
  input: CreateUserContactInput;
};


export type MutationCreateUserForHouseholdMemberArgs = {
  input: CreateUserForHouseholdMemberInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteCallLogArgs = {
  input: DeleteCallLogInput;
};


export type MutationDeleteCenterOfInfluenceRepArgs = {
  input: DeleteCenterOfInfluenceRepInput;
};


export type MutationDeleteClientOpportunityArgs = {
  input: DeleteClientOpportunityInput;
};


export type MutationDeleteCoClientArgs = {
  input: DeleteCoClientInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCommentAttachmentArgs = {
  input: DeleteCommentAttachmentInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteDialpadCallArgs = {
  input: DeleteDialpadCallInput;
};


export type MutationDeleteFamilyMemberArgs = {
  input: DeleteFamilyMemberInput;
};


export type MutationDeleteFeeScheduleArgs = {
  input: DeleteFeeScheduleInput;
};


export type MutationDeleteFinancialOfferingArgs = {
  input: DeleteFinancialOfferingInput;
};


export type MutationDeleteFinancialPlanReportFileArgs = {
  input: DeleteFinancialPlanReportFileInput;
};


export type MutationDeleteGoalArgs = {
  input: DeleteGoalInput;
};


export type MutationDeleteHouseholdArgs = {
  input: DeleteHouseholdInput;
};


export type MutationDeleteLiabilityArgs = {
  input: DeleteLiabilityInput;
};


export type MutationDeleteMeetingAgendaTemplateArgs = {
  input: DeleteMeetingAgendaTemplateInput;
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeleteOrganizationHouseholdCategoryArgs = {
  input: DeleteOrganizationHouseholdCategoryInput;
};


export type MutationDeletePlanFinancialSnapshotArgs = {
  input: DeletePlanFinancialSnapshotInput;
};


export type MutationDeleteProfessionalRelationshipArgs = {
  input: DeleteProfessionalRelationshipInput;
};


export type MutationDeleteProspectOpportunityArgs = {
  input: DeleteProspectOpportunityInput;
};


export type MutationDeleteProviderAccountArgs = {
  input: DeleteProviderAccountInput;
};


export type MutationDeleteReportScheduleArgs = {
  input: DeleteReportScheduleInput;
};


export type MutationDeleteReportTemplateArgs = {
  input: DeleteReportTemplateInput;
};


export type MutationDeleteRetirementPlanArgs = {
  input: DeleteRetirementPlanInput;
};


export type MutationDeleteRetirementPlanContactArgs = {
  input: DeleteRetirementPlanContactInput;
};


export type MutationDeleteRetirementPlanMilestoneArgs = {
  input: DeleteRetirementPlanMilestoneInput;
};


export type MutationDeleteRetirementPlanNoteArgs = {
  input: DeleteRetirementPlanNoteInput;
};


export type MutationDeleteRetirementPlanParticipantLogArgs = {
  input: DeleteRetirementPlanParticipantLogInput;
};


export type MutationDeleteRetirementPlanProjectArgs = {
  input: DeleteRetirementPlanProjectInput;
};


export type MutationDeleteRetirementPlanProjectRowArgs = {
  input: DeleteRetirementPlanProjectRowInput;
};


export type MutationDeleteRetirementPlanProjectTemplateArgs = {
  input: DeleteRetirementPlanProjectTemplateInput;
};


export type MutationDeleteServiceCalendarMeetingArgs = {
  input: DeleteServiceCalendarMeetingInput;
};


export type MutationDeleteServiceCalendarMeetingTypeTemplateArgs = {
  input: DeleteServiceCalendarMeetingTypeTemplateInput;
};


export type MutationDeleteServiceCalendarSettingTemplatesArgs = {
  input: DeleteServiceCalendarSettingTemplateInput;
};


export type MutationDeleteServiceCatalogItemHouseholdOverrideArgs = {
  input: DeleteServiceCatalogItemHouseholdOverrideInput;
};


export type MutationDeleteSubtaskArgs = {
  input: DeleteSubtaskInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskCommentArgs = {
  input: DeleteTaskCommentInput;
};


export type MutationDeleteTaskWorkflowTemplateArgs = {
  input: DeleteTaskWorkflowTemplateInput;
};


export type MutationDeleteTaxEnrollmentArgs = {
  input: DeleteTaxEnrollmentInput;
};


export type MutationDeleteUserContactArgs = {
  input: DeleteUserContactInput;
};


export type MutationDismissAllInboxAlertsArgs = {
  input: DismissAllInboxAlertsInput;
};


export type MutationDismissAnnouncementArgs = {
  input: DismissAnnouncementInput;
};


export type MutationDismissOnboardingHouseholdArgs = {
  input: DismissOnboardingHouseholdInput;
};


export type MutationDownloadBoxFileUrlArgs = {
  input: DownloadBoxFileUrlInput;
};


export type MutationDuplicateServiceCatalogItemGroupArgs = {
  input: DuplicateServiceCatalogItemGroupInput;
};


export type MutationEditCenterOfInfluenceRepArgs = {
  input: EditCenterOfInfluenceRepInput;
};


export type MutationEditCompanyArgs = {
  input: EditCompanyInput;
};


export type MutationEnrollHouseholdsInServiceCatalogItemGroupArgs = {
  input: EnrollHouseholdsInServiceCatalogItemGroupInput;
};


export type MutationExcludeAdvisorOnboardingStagedHouseholdsFromBatchArgs = {
  input: ExcludeStagedHouseholdsFromBatchInput;
};


export type MutationExpirePublishedReportArgs = {
  input: ExpirePublishedReportInput;
};


export type MutationExtractBoxClientUploadStatementsArgs = {
  input: ExtractBoxClientUploadStatementsInput;
};


export type MutationFetchPlaidAccountsArgs = {
  input: FetchPlaidAccountsInput;
};


export type MutationGenerateAllQuarterlyReportsArgs = {
  input: GenerateAllQuarterlyReportsInput;
};


export type MutationGenerateCoClientTaskArgs = {
  input: GenerateCoClientTaskInput;
};


export type MutationGenerateDirectoryProfileDraftArgs = {
  input: GenerateDirectoryProfileDraftInput;
};


export type MutationGenerateInvestmentProposalArgs = {
  input: GenerateInvestmentProposalInput;
};


export type MutationGenerateOrionReportArgs = {
  input: GenerateOrionReportInput;
};


export type MutationGeneratePortfolioInsightsArgs = {
  input: GeneratePortfolioInsightsInput;
};


export type MutationGenerateSalesforceAccessTokenArgs = {
  input: GenerateSalesforceAccessTokenInput;
};


export type MutationGenerateServiceEmailDraftArgs = {
  input: GenerateServiceEmailDraftInput;
};


export type MutationGetNotionMcpAccessTokenArgs = {
  input: GetNotionMcpAccessTokenInput;
};


export type MutationGetOrCreateAprilTokenArgs = {
  input: GetOrCreateAprilTokenInput;
};


export type MutationGetOrCreateHouseholdMemberAprilFilingTokenArgs = {
  input: GetOrCreateHouseholdMemberAprilFilingTokenInput;
};


export type MutationHouseholdWorkflowCreationBackfillerArgs = {
  input: HouseholdWorkflowCreationBackfillerInput;
};


export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};


export type MutationLaunchTaskWorkflowTemplateArgs = {
  input: LaunchTaskWorkflowTemplateInput;
};


export type MutationLinkTimelineItemToContactArgs = {
  input: LinkTimelineItemToContactInput;
};


export type MutationLinkTranscriptArgs = {
  input: LinkTranscriptInput;
};


export type MutationLogTaskAttachmentArgs = {
  input: LogTaskAttachmentInput;
};


export type MutationMarkAdvisorRequirementsDoneArgs = {
  input: MarkAdvisorRequirementsDoneInput;
};


export type MutationMarkCommentsSeenArgs = {
  input: MarkCommentsSeenInput;
};


export type MutationMarkOnboardingHouseholdCompleteArgs = {
  input: MarkHouseholdCompleteInput;
};


export type MutationMarkServiceCatalogItemHouseholdDoneArgs = {
  input: MarkServiceCatalogItemHouseholdDoneInput;
};


export type MutationMarkServiceCatalogItemHouseholdSkippedArgs = {
  input: MarkServiceCatalogItemHouseholdSkippedInput;
};


export type MutationMarkTaskCommentsSeenArgs = {
  input: MarkTaskCommentsSeenInput;
};


export type MutationMergeOrganizationHouseholdTagsArgs = {
  input: MergeOrganizationHouseholdTagsInput;
};


export type MutationMoneykitCreateLinkSessionArgs = {
  input: MoneykitCreateLinkSessionInput;
};


export type MutationMoneykitExchangeLinkTokenArgs = {
  input: MoneykitExchangeLinkTokenInput;
};


export type MutationMoneykitRefreshLinkArgs = {
  input: MoneykitRefreshLinkInput;
};


export type MutationMoveClientToAdvisorArgs = {
  input: MoveClientToAdvisorInput;
};


export type MutationProcessOnboardedClientArgs = {
  input: ProcessOnboardedClientInput;
};


export type MutationPromoteAdvisorOnboardingEnrollmentArgs = {
  input: PromoteEnrollmentInput;
};


export type MutationPromoteToSavvyTemplateArgs = {
  input: PromoteToSavvyTemplateInput;
};


export type MutationPublishDraftTaskArgs = {
  input: PublishDraftTaskInput;
};


export type MutationPublishFinancialPlanArgs = {
  input: PublishFinancialPlanInput;
};


export type MutationPublishMeetingPrepOperationArgs = {
  input: PublishMeetingPrepOperationInput;
};


export type MutationPublishReportArgs = {
  input: PublishReportInput;
};


export type MutationPublishServiceCatalogItemGroupArgs = {
  input: PublishServiceCatalogItemGroupInput;
};


export type MutationReconcileClientProfileStageArgs = {
  input: ReconcileClientProfileStageInput;
};


export type MutationRefreshProviderAccountArgs = {
  input: RefreshProviderAccountInput;
};


export type MutationRegenerateMeetingSummaryArgs = {
  input: RegenerateMeetingSummaryInput;
};


export type MutationRegenerateStaleServiceCatalogTasksArgs = {
  input: RegenerateStaleServiceCatalogTasksInput;
};


export type MutationRegisterPushTokenArgs = {
  input: RegisterPushTokenInput;
};


export type MutationReissueEnvelopeWithCurrentPhoneArgs = {
  input: ReissueEnvelopeWithCurrentPhoneInput;
};


export type MutationRejectScheduledReportExecutionArgs = {
  input: RejectScheduledReportExecutionInput;
};


export type MutationReleaseAdvisorOnboardingToSendArgs = {
  input: ReleaseOnboardingToSendInput;
};


export type MutationRelinkSignedEnvelopeArgs = {
  input: RelinkSignedEnvelopeInput;
};


export type MutationRemoveAdvisorFromAdvisorGroupArgs = {
  input: RemoveAdvisorFromAdvisorGroupInput;
};


export type MutationRemoveAdvisorOnboardingStagedCoClientArgs = {
  input: RemoveStagedCoClientInput;
};


export type MutationRemoveAdvisorOnboardingStagedHouseholdArgs = {
  input: RemoveStagedHouseholdInput;
};


export type MutationRemoveAdvisorsFromOrganizationArgs = {
  input: RemoveAdvisorsFromOrganizationInput;
};


export type MutationRemoveHouseholdMemberArgs = {
  input: RemoveHouseholdMemberInput;
};


export type MutationRemoveNotificationAlertMuteArgs = {
  input: RemoveNotificationAlertMuteInput;
};


export type MutationRemoveOnboardingHouseholdArgs = {
  input: RemoveOnboardingHouseholdInput;
};


export type MutationRemoveServiceCatalogItemFromGroupArgs = {
  input: RemoveServiceCatalogItemFromGroupInput;
};


export type MutationRemoveTaskRecurrenceArgs = {
  input: RemoveTaskRecurrenceInput;
};


export type MutationRenewInviteArgs = {
  input: RenewInviteInput;
};


export type MutationReorderServiceCatalogItemHouseholdsArgs = {
  input: ReorderServiceCatalogItemHouseholdsInput;
};


export type MutationReorderSubtaskArgs = {
  input: ReorderSubtaskInput;
};


export type MutationRequestPastTranscriptsFromAprilArgs = {
  input: RequestPastTranscriptsFromAprilInput;
};


export type MutationRequestRepaperPdfUploadUrlsArgs = {
  input: RequestRepaperPdfUploadUrlsInput;
};


export type MutationRescheduleServiceOccurrenceArgs = {
  input: RescheduleServiceOccurrenceInput;
};


export type MutationReseedDemoEnvironmentArgs = {
  input: ReseedDemoEnvironmentInput;
};


export type MutationResendAdvisorOnboardingArgs = {
  input: ResendOnboardingInviteInput;
};


export type MutationResendDocusignEnvelopeArgs = {
  input: ResendDocusignEnvelopeInput;
};


export type MutationResendEmailArgs = {
  input: ResendEmailInput;
};


export type MutationResendOtpArgs = {
  input: ResendOtpInput;
};


export type MutationResendServiceCatalogReminderArgs = {
  input: ResendServiceCatalogReminderInput;
};


export type MutationResendServiceOccurrenceReminderArgs = {
  input: ResendServiceOccurrenceReminderInput;
};


export type MutationResetClientIntakeDataArgs = {
  input: ResetClientIntakeDataInput;
};


export type MutationResetDemoHouseholdArgs = {
  input: ResetDemoHouseholdInput;
};


export type MutationResetNotificationRoutingArgs = {
  input: ResetNotificationRoutingInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetServiceCalendarArgs = {
  input: ResetServiceCalendarInput;
};


export type MutationResetTaskNotificationRoutingArgs = {
  input: ResetTaskNotificationRoutingInput;
};


export type MutationResolveContributionAlertArgs = {
  input: ResolveContributionAlertInput;
};


export type MutationResubmitEciRemediationArgs = {
  input: ResubmitEciRemediationInput;
};


export type MutationRunAdminServiceObjectArgs = {
  input: RunAdminServiceObjectInput;
};


export type MutationRunInternalAdminActionArgs = {
  input: RunInternalAdminActionInput;
};


export type MutationSaveEciAccountPurposeAndSourceOfFundsArgs = {
  input: SaveEciAccountPurposeAndSourceOfFundsInput;
};


export type MutationSaveEciBeneficiariesArgs = {
  input: SaveEciBeneficiariesInput;
};


export type MutationSaveEciDecedentDetailsArgs = {
  input: SaveEciDecedentDetailsInput;
};


export type MutationSaveEciEmployerDetailsArgs = {
  input: SaveEciEmployerDetailsInput;
};


export type MutationSaveEciJointOwnerDetailsArgs = {
  input: SaveEciJointOwnerDetailsInput;
};


export type MutationSaveEciTrustDetailsArgs = {
  input: SaveEciTrustDetailsInput;
};


export type MutationSaveEciTrustedContactsArgs = {
  input: SaveEciTrustedContactsInput;
};


export type MutationSaveHouseholdKeepInMindVoteArgs = {
  input: SaveHouseholdKeepInMindVoteInput;
};


export type MutationSaveReportTemplateArgs = {
  input: SaveReportTemplateInput;
};


export type MutationSaveRetirementPlanProjectAsTemplateArgs = {
  input: SaveRetirementPlanProjectAsTemplateInput;
};


export type MutationScheduleNativeReportArgs = {
  input: ScheduleNativeReportInput;
};


export type MutationSendAdvisorOnboardingArgs = {
  input: SendOnboardingInput;
};


export type MutationSendAdvisorOnboardingInviteToOpsArgs = {
  input: SendOnboardingInviteToOpsInput;
};


export type MutationSendClientBookingEmailArgs = {
  input: SendClientBookingEmailInput;
};


export type MutationSendClientWelcomeEmailArgs = {
  input: SendClientWelcomeEmailInput;
};


export type MutationSendCreatePasswordEmailArgs = {
  input: SendCreatePasswordEmailInput;
};


export type MutationSendEmailMessageArgs = {
  input: SendEmailMessageInput;
};


export type MutationSendFileShareEmailArgs = {
  input: SendFileShareEmailInput;
};


export type MutationSendOnboardingToClientArgs = {
  input: SendOnboardingToClientInput;
};


export type MutationSendRepaperEnvelopeArgs = {
  input: SendRepaperEnvelopeInput;
};


export type MutationSendSignOnboardingDocumentsReminderArgs = {
  input: SendSignOnboardingDocumentsReminderInput;
};


export type MutationSendTaskEmailArgs = {
  input: SendTaskEmailInput;
};


export type MutationSetAccountConnectionReminderPreferenceArgs = {
  input: SetAccountConnectionReminderPreferenceInput;
};


export type MutationSetActivityEntryPinnedArgs = {
  input: SetActivityEntryPinnedInput;
};


export type MutationSetAdvisorTierLevelArgs = {
  input: SetAdvisorTierLevelInput;
};


export type MutationSetClientIncomeSourcesArgs = {
  input: SetClientIncomeSourcesInput;
};


export type MutationSetContactAccountRelationArgs = {
  input: SetContactAccountRelationInput;
};


export type MutationSetGovernmentIdArgs = {
  input: SetGovernmentIdInput;
};


export type MutationSetHouseholdBenchmarkArgs = {
  input: SetHouseholdBenchmarkInput;
};


export type MutationSetServiceCatalogItemHouseholdNextOccurrenceArgs = {
  input: SetServiceCatalogItemHouseholdNextOccurrenceInput;
};


export type MutationSetSwimLoanLengthOptionsArgs = {
  input: SetSwimLoanLengthOptionsInput;
};


export type MutationSetSwimStrategiesArgs = {
  input: SetSwimStrategiesInput;
};


export type MutationSetTaskRecurrenceArgs = {
  input: SetTaskRecurrenceInput;
};


export type MutationSetUpAdvisorOrganizationArgs = {
  input: SetUpAdvisorOrganizationInput;
};


export type MutationSetupTaskRemindersArgs = {
  input: SetupTaskRemindersInput;
};


export type MutationShareHouseholdWithAdvisorGroupArgs = {
  input: ShareHouseholdWithAdvisorGroupInput;
};


export type MutationSharePublishedReportArgs = {
  input: SharePublishedReportInput;
};


export type MutationShareRetirementPlanWithOrganizationArgs = {
  input: ShareRetirementPlanWithOrganizationInput;
};


export type MutationSignTaxAddendumArgs = {
  input: SignTaxAddendumInput;
};


export type MutationSignUpForSavvyArgs = {
  input: SignUpForSavvyInput;
};


export type MutationSkipServiceOccurrenceArgs = {
  input: SkipServiceOccurrenceInput;
};


export type MutationStartSchwabApiImportArgs = {
  input: StartSchwabApiImportInput;
};


export type MutationStopImpersonatingUserArgs = {
  input: StopImpersonatingUserInput;
};


export type MutationStopSharingRetirementPlanOrganizationsArgs = {
  input: StopSharingRetirementPlanOrganizationsInput;
};


export type MutationSubmitEciAccountOnboardingArgs = {
  input: SubmitEciAccountOnboardingInput;
};


export type MutationSubmitEciClientOnboardingArgs = {
  input: SubmitEciClientOnboardingInput;
};


export type MutationSubmitEciUpgradeCustodianArgs = {
  input: SubmitEciUpgradeCustodianInput;
};


export type MutationSwitchActiveHouseholdArgs = {
  input: SwitchActiveHouseholdInput;
};


export type MutationSyncEciAccountOnboardingRequestSelectionArgs = {
  input: SyncEciAccountOnboardingRequestSelectionInput;
};


export type MutationSyncOrionDataArgs = {
  input: SyncOrionDataInput;
};


export type MutationSyncStandingInstructionSelectionsArgs = {
  input: SyncStandingInstructionSelectionsInput;
};


export type MutationToggleCommentReactionArgs = {
  input: ToggleCommentReactionInput;
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationUnarchiveHouseholdArgs = {
  input: UnarchiveHouseholdInput;
};


export type MutationUnarchiveServiceCatalogItemGroupArgs = {
  input: UnarchiveServiceCatalogItemGroupInput;
};


export type MutationUnassignServiceCatalogItemFromHouseholdArgs = {
  input: UnassignServiceCatalogItemFromHouseholdInput;
};


export type MutationUnenrollHouseholdsFromServiceCatalogItemGroupArgs = {
  input: UnenrollHouseholdsFromServiceCatalogItemGroupInput;
};


export type MutationUnlinkOrionHouseholdArgs = {
  input: UnlinkOrionHouseholdInput;
};


export type MutationUnlinkTimelineItemFromContactArgs = {
  input: UnlinkTimelineItemFromContactInput;
};


export type MutationUnregisterPushTokenArgs = {
  input: UnregisterPushTokenInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountSleeveArgs = {
  input: UpdateAccountSleeveInput;
};


export type MutationUpdateAccountTransferDatumArgs = {
  input: UpdateAccountTransferDatumInput;
};


export type MutationUpdateActionCenterVisitedArgs = {
  input: UpdateActionCenterVisitedInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAdvisorAiDisclosureAcceptanceArgs = {
  input: UpdateAdvisorAiDisclosureAcceptanceInput;
};


export type MutationUpdateAdvisorAlertSettingsArgs = {
  input: UpdateAdvisorAlertSettingsInput;
};


export type MutationUpdateAdvisorCaptiveStatusArgs = {
  input: UpdateAdvisorCaptiveStatusInput;
};


export type MutationUpdateAdvisorCsaArgs = {
  input: UpdateAdvisorCsaInput;
};


export type MutationUpdateAdvisorDirectoryProfileArgs = {
  input: UpdateAdvisorDirectoryProfileInput;
};


export type MutationUpdateAdvisorGroupSettingsArgs = {
  input: UpdateAdvisorGroupSettingsInput;
};


export type MutationUpdateAdvisorOnboardingCohortArgs = {
  input: UpdateAdvisorOnboardingCohortInput;
};


export type MutationUpdateAdvisorOnboardingEnrollmentArgs = {
  input: UpdateEnrollmentInput;
};


export type MutationUpdateAdvisorOnboardingStagedAccountDestinationArgs = {
  input: UpdateStagedAccountDestinationInput;
};


export type MutationUpdateAdvisorOnboardingStagedClientArgs = {
  input: UpdateStagedClientInput;
};


export type MutationUpdateAdvisorOnboardingStagedHouseholdArgs = {
  input: UpdateStagedHouseholdInput;
};


export type MutationUpdateAdvisorProfileArgs = {
  input: UpdateAdvisorProfileInput;
};


export type MutationUpdateAdvisorSettingsArgs = {
  input: UpdateAdvisorSettingsInput;
};


export type MutationUpdateAlertArgs = {
  input: UpdateAlertInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateClientDetailsArgs = {
  input: UpdateClientDetailsInput;
};


export type MutationUpdateClientEmploymentDetailsArgs = {
  input: UpdateClientEmploymentDetailsInput;
};


export type MutationUpdateClientIntakeDataArgs = {
  input: UpdateClientIntakeDataInput;
};


export type MutationUpdateClientPortalMessageArgs = {
  input: UpdateClientPortalMessageInput;
};


export type MutationUpdateClientProfileArgs = {
  input: UpdateClientProfileInput;
};


export type MutationUpdateClientsArgs = {
  input: UpdateClientsInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCommentAttachmentSyncArgs = {
  input: UpdateCommentAttachmentSyncInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateDialpadCallNotesArgs = {
  input: UpdateDialpadCallNotesInput;
};


export type MutationUpdateDialpadEventContentArgs = {
  input: UpdateDialpadEventContentInput;
};


export type MutationUpdateEciCitizenshipTaxStatusArgs = {
  input: UpdateEciCitizenshipTaxStatusInput;
};


export type MutationUpdateEciCurrentStepArgs = {
  input: UpdateEciCurrentStepInput;
};


export type MutationUpdateEciFinancialProfileArgs = {
  input: UpdateEciFinancialProfileInput;
};


export type MutationUpdateEciPersonalInformationArgs = {
  input: UpdateEciPersonalInformationInput;
};


export type MutationUpdateEciRegulatoryDisclosureArgs = {
  input: UpdateEciRegulatoryDisclosureInput;
};


export type MutationUpdateFamilyMemberArgs = {
  input: UpdateFamilyMemberInput;
};


export type MutationUpdateFeeScheduleArgs = {
  input: UpdateFeeScheduleInput;
};


export type MutationUpdateFinancialOfferingArgs = {
  input: UpdateFinancialOfferingInput;
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type MutationUpdateHouseholdArgs = {
  input: UpdateHouseholdInput;
};


export type MutationUpdateHouseholdAccessArgs = {
  input: UpdateHouseholdAccessInput;
};


export type MutationUpdateHouseholdMemberArgs = {
  input: UpdateHouseholdMemberInput;
};


export type MutationUpdateHouseholdTagsArgs = {
  input: UpdateHouseholdTagsInput;
};


export type MutationUpdateLiabilityArgs = {
  input: UpdateLiabilityInput;
};


export type MutationUpdateMeetingAgendaTemplateArgs = {
  input: UpdateMeetingAgendaTemplateInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationRouteArgs = {
  input: UpdateNotificationRouteInput;
};


export type MutationUpdateOnboardingPersonalizationArgs = {
  input: UpdateOnboardingPersonalizationInput;
};


export type MutationUpdateOnboardingTaskDataArgs = {
  input: UpdateOnboardingTaskDataInput;
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateOrganizationBrandingArgs = {
  input: UpdateOrganizationBrandingInput;
};


export type MutationUpdateOrganizationHouseholdCategoryArgs = {
  input: UpdateOrganizationHouseholdCategoryInput;
};


export type MutationUpdateOrganizationHouseholdTagArgs = {
  input: UpdateOrganizationHouseholdTagInput;
};


export type MutationUpdateOrganizationHouseholdTagHouseholdsArgs = {
  input: UpdateOrganizationHouseholdTagHouseholdsInput;
};


export type MutationUpdateOrganizationSettingsArgs = {
  input: UpdateOrganizationSettingsInput;
};


export type MutationUpdateOrganizationTaskInstructionsArgs = {
  input: UpdateOrganizationTaskInstructionsInput;
};


export type MutationUpdateOrionReportEnrollmentsArgs = {
  input: UpdateOrionReportEnrollmentsInput;
};


export type MutationUpdatePlanFinancialSnapshotArgs = {
  input: UpdatePlanFinancialSnapshotInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdatePortfolioStrategyArgs = {
  input: UpdatePortfolioStrategyInput;
};


export type MutationUpdateProfessionalRelationshipArgs = {
  input: UpdateProfessionalRelationshipInput;
};


export type MutationUpdateProspectOpportunityArgs = {
  input: UpdateProspectOpportunityInput;
};


export type MutationUpdateProviderAccountArgs = {
  input: UpdateProviderAccountInput;
};


export type MutationUpdateReportScheduleArgs = {
  input: UpdateReportScheduleInput;
};


export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationUpdateRetirementPlanArgs = {
  input: UpdateRetirementPlanInput;
};


export type MutationUpdateRetirementPlanContactArgs = {
  input: UpdateRetirementPlanContactInput;
};


export type MutationUpdateRetirementPlanDesignArgs = {
  input: UpdateRetirementPlanDesignInput;
};


export type MutationUpdateRetirementPlanMilestoneArgs = {
  input: UpdateRetirementPlanMilestoneInput;
};


export type MutationUpdateRetirementPlanNoteArgs = {
  input: UpdateRetirementPlanNoteInput;
};


export type MutationUpdateRetirementPlanParticipantLogArgs = {
  input: UpdateRetirementPlanParticipantLogInput;
};


export type MutationUpdateRetirementPlanProjectArgs = {
  input: UpdateRetirementPlanProjectInput;
};


export type MutationUpdateRetirementPlanProjectRowArgs = {
  input: UpdateRetirementPlanProjectRowInput;
};


export type MutationUpdateRetirementPlanProjectTemplateArgs = {
  input: UpdateRetirementPlanProjectTemplateInput;
};


export type MutationUpdateRetirementPlanProjectTemplateFromProjectArgs = {
  input: UpdateRetirementPlanProjectTemplateFromProjectInput;
};


export type MutationUpdateRmdArgs = {
  input: UpdateRmdInput;
};


export type MutationUpdateServiceCalendarItemArgs = {
  input: UpdateServiceCalendarItemInput;
};


export type MutationUpdateServiceCalendarMeetingArgs = {
  input: UpdateServiceCalendarMeetingInput;
};


export type MutationUpdateServiceCalendarSettingTemplatesArgs = {
  input: UpdateServiceCalendarSettingTemplatesInput;
};


export type MutationUpdateServiceCalendarSettingsArgs = {
  input: UpdateServiceCalendarSettingsInput;
};


export type MutationUpdateServiceCatalogItemArgs = {
  input: UpdateServiceCatalogItemInput;
};


export type MutationUpdateServiceCatalogItemGroupArgs = {
  input: UpdateServiceCatalogItemGroupInput;
};


export type MutationUpdateServiceCatalogItemHouseholdOverrideArgs = {
  input: UpdateServiceCatalogItemHouseholdOverrideInput;
};


export type MutationUpdateSimpleTaskArgs = {
  input: UpdateSimpleTaskInput;
};


export type MutationUpdateSubtaskArgs = {
  input: UpdateSubtaskInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationUpdateTaskNotificationRouteArgs = {
  input: UpdateTaskNotificationRouteInput;
};


export type MutationUpdateTaskSuggestionArgs = {
  input: UpdateTaskSuggestionInput;
};


export type MutationUpdateTaskWorkItemArgs = {
  input: UpdateTaskWorkItemInput;
};


export type MutationUpdateTaskWorkflowTemplateArgs = {
  input: UpdateTaskWorkflowTemplateInput;
};


export type MutationUpdateTaxEnrollmentArgs = {
  input: UpdateTaxEnrollmentInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserContactArgs = {
  input: UpdateUserContactInput;
};


export type MutationUpdateUserDataInAprilFilingArgs = {
  input: UpdateUserDataInAprilFilingInput;
};


export type MutationUpdateUserSecurityAttributeArgs = {
  input: UpdateUserSecurityAttributeInput;
};


export type MutationUploadFileToBoxArgs = {
  input: UploadFileToBoxInput;
};


export type MutationUploadLinkedBankAccountImportArgs = {
  input: UploadLinkedBankAccountImportInput;
};


export type MutationUpsertUserSavedViewsArgs = {
  input: UpsertUserSavedViewsInput;
};


export type MutationValidateInvestmentProposalTickersArgs = {
  input: ValidateInvestmentProposalTickersInput;
};


export type MutationVerifyEciOnboardingIdentityArgs = {
  input: VerifyEciOnboardingIdentityInput;
};


export type MutationVoiceProfileCommitArgs = {
  input: VoiceProfileCommitInput;
};


export type MutationVoiceProfileRemoveExampleArgs = {
  input: VoiceProfileRemoveExampleInput;
};


export type MutationVoiceProfileRerunCaptureArgs = {
  input: VoiceProfileRerunCaptureInput;
};


export type MutationVoiceProfileSetSampleArgs = {
  input: VoiceProfileSetSampleInput;
};


export type MutationVoidDocusignEnvelopeArgs = {
  input: VoidDocusignEnvelopeInput;
};


export type MutationWealthboxImportPreviewArgs = {
  input: WealthboxImportPreviewMutationInput;
};

/** Error type for mutations */
export type MutationError = {
  __typename?: 'MutationError';
  /** The field where the error occurred */
  field: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** An async native PDF report record — tracks scheduling → generation → completion. */
export type NativeReport = {
  __typename?: 'NativeReport';
  /** When the report completed or failed. */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the report was scheduled. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * JSON-serialised report data. Non-null only when status = completed AND the
   * Redis TTL (1 h) has not expired. A null value with status = completed means
   * the data expired — re-schedule the report. Pass to the Next.js download
   * endpoint to render the PDF.
   */
  dataJson: Maybe<Scalars['String']['output']>;
  /** Error detail when status is failed. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The record ID. */
  id: Scalars['ID']['output'];
  /** Current status: pending | processing | completed | failed. */
  status: Scalars['String']['output'];
};

/** A user's entire financial portfolio. */
export type NetWorthPortfolioData = {
  __typename?: 'NetWorthPortfolioData';
  /** An array of accounts, contains liability accounts from Plaid */
  accounts: Array<Account>;
  /** An array of assets */
  assets: Array<Asset>;
  /** The client profile of the who owns this portfolio */
  clientProfile: Maybe<Client>;
  /** Id of either the account or the portfolio that this object is representing */
  id: Maybe<Scalars['ID']['output']>;
  /** An array of liabilities */
  liabilities: Array<Liability>;
  /** A user's total net worth. */
  netWorth: Value;
  /**
   * Portfolio items groups that make up the net worth.
   * @deprecated Use the accounts, liabilities, and assets fields instead
   */
  portfolioItemGroups: Array<PortfolioItemGroup>;
  /** A user's total net worth that is managed by Savvy */
  savvyAccounts: Value;
};

/** New Financial Planning Client variant: set up flat-fee billing for a new planning client */
export type NewFinancialPlanningClientInput = {
  /** Account number to deduct from, free text (required when payment_method is deduct) */
  deductAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Effective date; omitted when the timing is future */
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether billing starts immediately or on a future date described in the notes */
  effectiveDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Annual fee amount */
  feeAmount: Scalars['Float']['input'];
  /** Notes for Ops */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Payment cadence — monthly, quarterly, semi_annual, annual, or one_time */
  paymentCadence: ClientBillingPaymentCadenceName;
  /** Payment method — advicepay or deduct */
  paymentMethod: ClientBillingPaymentMethodName;
};

export type NewsArticle = {
  __typename?: 'NewsArticle';
  publishedDate: Scalars['ISO8601DateTime']['output'];
  sentiment: NewsSentimentName;
  sourceName: Scalars['String']['output'];
  text: Scalars['String']['output'];
  tickers: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NewsSentimentName =
  | 'Negative'
  | 'Neutral'
  | 'Positive';

/** "request" or "response" */
export type NfsAuditDirection =
  | 'request'
  | 'response';

/** A single Fidelity NFS request/response leg captured for compliance retention. */
export type NfsAuditEntry = {
  __typename?: 'NfsAuditEntry';
  /** UTC timestamp of confirmed S3 write */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Redacted body. Served from Postgres until archival; after archival the
   * Postgres copy is scrubbed (claim check) and the body is fetched from the WORM
   * S3 object. Null when the payload could not be parsed, the S3 read failed, or
   * the reader IAM user is not yet provisioned. Expensive on list queries: each
   * archived node issues one synchronous S3 GET — omit this field on connection selections.
   */
  body: Maybe<Scalars['String']['output']>;
  /** "application/json" or "text/xml" */
  contentType: Scalars['String']['output'];
  /** When the row was captured. ReconcileNfsAuditArchivalWorker alerts on unarchived rows past 6h old by this timestamp. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** "request" or "response" */
  direction: NfsAuditDirection;
  /** "eap" or "esg" */
  gateway: NfsAuditGateway;
  /** HTTP response status; absent on request legs */
  httpStatus: Maybe<Scalars['Int']['output']>;
  /** UUID primary key */
  id: Scalars['ID']['output'];
  /** When the ship worker last attempted this leg */
  lastAttemptedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last S3 ship error message if archival failed */
  lastErrorMessage: Maybe<Scalars['String']['output']>;
  /** Fidelity operation name (e.g. AccountSetup) */
  operation: NfsAuditOperation;
  /** UTC timestamp when the leg was captured */
  recordedAt: Scalars['ISO8601DateTime']['output'];
  /** S3 object key after successful archival */
  s3Key: Maybe<Scalars['String']['output']>;
  /** OutboxEvent archival status */
  status: NfsAuditStatus;
  /** Fidelity FID-LOG-TRACKING-ID correlation ID */
  trackingId: Scalars['String']['output'];
  /** Number of S3 ship attempts made */
  tryCount: Scalars['Int']['output'];
};

/** The connection type for NfsAuditEntry. */
export type NfsAuditEntryConnection = {
  __typename?: 'NfsAuditEntryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NfsAuditEntryEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NfsAuditEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NfsAuditEntryEdge = {
  __typename?: 'NfsAuditEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<NfsAuditEntry>;
};

/** "eap" or "esg" */
export type NfsAuditGateway =
  | 'eap'
  | 'esg';

/** Fidelity NFS operation name */
export type NfsAuditOperation =
  | 'AccountProfileInquire'
  | 'AccountProfileMaintain'
  | 'AccountSetup'
  | 'AccountValidate'
  | 'CaptureServicesUpload'
  | 'DetermineTransferability'
  | 'GetCompatibleRegistrations'
  | 'GetCusipInfo'
  | 'GetCustodianData'
  | 'PregenAccount'
  | 'SearchCustodian'
  | 'TOAInitiate'
  | 'TOAValidate';

/** A Fidelity NFS audit leg matched by the search index. */
export type NfsAuditSearchHit = {
  __typename?: 'NfsAuditSearchHit';
  /** Indexed body copy (redacted at capture). Authoritative bytes live in the WORM object. */
  bodyText: Scalars['String']['output'];
  /** "application/json" or "text/xml" */
  contentType: Scalars['String']['output'];
  /** "request" or "response" */
  direction: NfsAuditDirection;
  /** Base64 SHA-256 of the archived envelope (integrity anchor) */
  envelopeSha256: Scalars['String']['output'];
  /** "eap" or "esg" */
  gateway: NfsAuditGateway;
  /** HTTP response status; absent on request legs */
  httpStatus: Maybe<Scalars['Int']['output']>;
  /** Fidelity operation name (e.g. AccountSetup) */
  operation: NfsAuditOperation;
  /** OutboxEvent id of the archived leg — join key into nfsAuditEntries */
  outboxEventId: Scalars['ID']['output'];
  /** UTC timestamp when the leg was captured */
  recordedAt: Scalars['ISO8601DateTime']['output'];
  /** WORM S3 object key; doubles as the search document id */
  s3Key: Scalars['String']['output'];
  /** Fidelity FID-LOG-TRACKING-ID correlation ID */
  trackingId: Scalars['String']['output'];
};

/** A page of NFS audit search hits plus the total match count. */
export type NfsAuditSearchResults = {
  __typename?: 'NfsAuditSearchResults';
  /** Matches for the requested page, newest first */
  hits: Array<NfsAuditSearchHit>;
  /** Total matches across all pages */
  total: Scalars['Int']['output'];
};

/** OutboxEvent archival status */
export type NfsAuditStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | 'processing';

/** Note related to a Savvy object */
export type Note = {
  __typename?: 'Note';
  /** The HTML content of the note */
  content: Scalars['String']['output'];
  /** When the note was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the user who created the note */
  createdByName: Maybe<Scalars['String']['output']>;
  /** Users in the household this note belongs to */
  householdUsers: Maybe<Array<User>>;
  /** Households this note belongs to */
  households: Maybe<Array<Household>>;
  /** The Savvy ID of the note. */
  id: Scalars['ID']['output'];
  /** Whether the note is pinned in the Advisor Dashboard. */
  isPinned: Scalars['Boolean']['output'];
  /** The Dialpad transcript backing this Note, when one exists. */
  linkedDialpadCallTranscript: Maybe<DialpadCallTranscript>;
  /** The Zoom transcript backing this Note, when one exists. */
  linkedZoomMeetingTranscript: Maybe<ZoomMeetingTranscript>;
  /** ID of the recap template the backing summary was generated from. Null when none was used. */
  meetingAgendaTemplateId: Maybe<Scalars['ID']['output']>;
  /** Title of that recap template, including one since deleted, so the source stays displayable. */
  meetingAgendaTemplateTitle: Maybe<Scalars['String']['output']>;
  /** End time */
  meetingEndTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The source of the meeting summary (e.g. "zoom", "dialpad"). Null when the note is not backed by a MeetingSummary. */
  meetingSource: Maybe<Scalars['String']['output']>;
  /** Start time */
  meetingStartTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Whether the recap in this note has been hand-edited since it was generated, so
   * regenerating would discard that work. Null when there is nothing to compare against.
   */
  meetingSummaryEditedSinceGeneration: Maybe<Scalars['Boolean']['output']>;
  /** ID of the backing MeetingSummary, for mutations that act on it. Null when the note is not summary-backed. */
  meetingSummaryId: Maybe<Scalars['ID']['output']>;
  /** The name of the owner of the note */
  ownerName: Scalars['String']['output'];
  /** Where the last requested regeneration of the backing summary got to; null when none has been requested. */
  regenerationStatus: Maybe<MeetingSummaryRegenerationStatus>;
  /** Relation Type */
  relationType: Scalars['String']['output'];
  taskSuggestions: Maybe<Array<TaskSuggestion>>;
  tasks: Maybe<Array<Task>>;
  /** The title of the note */
  title: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
  /** The timestamp the note was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the user who last updated the note */
  updatedByName: Maybe<Scalars['String']['output']>;
  userCanUpdateAndDelete: Scalars['Boolean']['output'];
};

export type NoteDetailOpen = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source of the backing meeting summary — "savvy", "zoom", or "dialpad". Absent for advisor-authored notes. */
  meetingSource?: InputMaybe<Scalars['String']['input']>;
  /** Id of the opened note. */
  noteId: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type NoteDetailViewDuration = {
  /** How long the note detail view stayed open, in milliseconds. */
  duration: Scalars['Int']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source of the backing meeting summary — "savvy", "zoom", or "dialpad". Absent for advisor-authored notes. */
  meetingSource?: InputMaybe<Scalars['String']['input']>;
  /** Id of the note that was open. */
  noteId: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type NotificationAlertMute = {
  __typename?: 'NotificationAlertMute';
  /** Masked account number, when account-scoped. */
  accountMask: Maybe<Scalars['String']['output']>;
  /** Display label of the muted account, when account-scoped. */
  accountName: Maybe<Scalars['String']['output']>;
  /** The muted alert type (cash_variance or allocation_variance). */
  alertType: Scalars['String']['output'];
  /** Display name of the muted household. */
  householdName: Scalars['String']['output'];
  /** Public identifier of the muted household. */
  householdPublicId: Maybe<Scalars['String']['output']>;
  /** The mute id. */
  id: Scalars['ID']['output'];
  /** The mute scope: "account" or "household". */
  scope: Scalars['String']['output'];
};

/** Catalog alert types with configurable notification routes */
export type NotificationRouteAlert =
  | 'account_linked_or_aggregation_added'
  | 'account_opened_or_funded'
  | 'account_setup_confirmation_sent'
  | 'advisor_requirements_needed'
  | 'allocation_variance'
  | 'auto_advance_blocked_missing_aum'
  | 'beneficiary_or_ownership_change'
  | 'birthdays'
  | 'call_step_required'
  | 'cash_variance'
  | 'center_of_influence_rep_comment_mention'
  | 'client_completed_task'
  | 'client_completed_tax_enrollment'
  | 'client_engagement'
  | 'client_logins'
  | 'client_portal_message_received'
  | 'client_submitted_risk_questionnaire'
  | 'client_uploaded_requested_file'
  | 'company_comment_mention'
  | 'contribution_received'
  | 'docusign_outstanding'
  | 'email_from_lead'
  | 'federal_return_accepted'
  | 'federal_return_received'
  | 'federal_return_rejected'
  | 'file_upload_request_sent'
  | 'household_comment_mention'
  | 'hubspot_lead_created'
  | 'inbound_missed_call'
  | 'intake_invite_reminder_sent'
  | 'intake_invite_sent'
  | 'large_withdrawal_detected'
  | 'meeting_booked_by_client'
  | 'meeting_canceled_or_rescheduled_by_client'
  | 'meeting_prep_ready'
  | 'meeting_recap_ready'
  | 'meeting_transcript_needs_household'
  | 'new_lead_campaign_started'
  | 'new_lead_created'
  | 'onboarding_complete'
  | 'onboarding_invite_reminder_sent'
  | 'onboarding_invite_sent'
  | 'outbound_missed_call_reminder'
  | 'outstanding_client_task'
  | 'pre_review_check_in_sent'
  | 'prospect_converted'
  | 'quarterly_report_failed'
  | 'quarterly_report_generated'
  | 'recurring_investment_reminder'
  | 'risk_questionnaire_sent'
  | 'rmds'
  | 'service_calendar_booking_reminder_sent'
  | 'service_calendar_due_date'
  | 'service_calendar_invite_sent'
  | 'service_calendar_setup'
  | 'service_calendar_task_assigned'
  | 'sms_from_lead'
  | 'stagnant_prospect'
  | 'state_return_accepted'
  | 'state_return_received'
  | 'state_return_rejected'
  | 'task_created'
  | 'task_due_date_changed'
  | 'task_reassigned_notification'
  | 'tax_filing_late_or_missed_deadline'
  | 'tax_filing_ready'
  | 'tax_filing_ready_sent_to_client'
  | 'tax_filing_reminder_to_client'
  | 'transfer_in';

/** A notification route destination */
export type NotificationRouteDestination =
  /** activity */
  | 'activity'
  /** inbox */
  | 'inbox'
  /** off */
  | 'off';

export type NotificationRoutePreference = {
  __typename?: 'NotificationRoutePreference';
  /** The catalog alert type. */
  alertType: NotificationRouteAlert;
  /** The effective notification destination. */
  destination: NotificationRouteDestination;
  /** Whether the effective destination is the server-owned default. */
  isDefault: Scalars['Boolean']['output'];
};

export type NotificationTaskRoutingCell = {
  __typename?: 'NotificationTaskRoutingCell';
  /** The effective destination: inbox, activity, or off. */
  destination: Scalars['String']['output'];
  /** The task event: tasks_due, comments, or status. */
  event: Scalars['String']['output'];
  /** Whether the destination matches the default. */
  isDefault: Scalars['Boolean']['output'];
  /** The viewer relationship: assignee, creator, primary, or all_other. */
  relationship: Scalars['String']['output'];
};

/** Number/currency filter with operator and value(s) */
export type NumberFilterInput = {
  /** Maximum value for between operator */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value for between operator */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** Number filter operator */
  operator: NumberFilterOperatorEnum;
  /** Filter value (not required for isEmpty operator) */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Number/currency filter operators */
export type NumberFilterOperatorEnum =
  /** Between min and max values */
  | 'BETWEEN'
  /** Equal to */
  | 'EQ'
  /** Greater than */
  | 'GT'
  /** Greater than or equal */
  | 'GTE'
  /** Field is empty or null */
  | 'IS_EMPTY'
  /** Less than */
  | 'LT'
  /** Less than or equal */
  | 'LTE';

export type OccurrenceStatus =
  /** booked */
  | 'booked'
  /** booking_canceled */
  | 'booking_canceled'
  /** completed */
  | 'completed'
  /** invited */
  | 'invited'
  /** missed */
  | 'missed'
  /** scheduled */
  | 'scheduled'
  /** send_failed */
  | 'send_failed'
  /** skipped */
  | 'skipped';

/** A book-transfer household row for the onboarding cockpit table. */
export type OnboardingCockpitRow = {
  __typename?: 'OnboardingCockpitRow';
  /**
   * Accounts this household is expected to bring over: the advisor's confirmed
   * selection once confirm has run, otherwise the imported candidate set.
   */
  accountsTotal: Scalars['Int']['output'];
  /**
   * Accounts whose assets have arrived at Savvy. Always 0 until Step 8 resolves
   * the custodian feed — no signal today distinguishes a settled account from a confirmed one.
   */
  accountsTransferred: Scalars['Int']['output'];
  /** Why the household is blocked, when status is blocked. */
  blockedReason: Maybe<Scalars['String']['output']>;
  /** Estimated AUM captured at import. */
  estAum: Maybe<Scalars['Float']['output']>;
  /** External identifier from the imported book. */
  externalKey: Maybe<Scalars['String']['output']>;
  /** Whether any client ECI request still has day 3/7/14 auto-reminders outstanding. */
  hasActiveReminders: Scalars['Boolean']['output'];
  /** Display name for the household. */
  householdName: Scalars['String']['output'];
  /**
   * Canonical household public id (uuid) after promotion, for Overview deeplinks.
   * Null until StagingPromoter links a household.
   */
  householdUuid: Maybe<Scalars['ID']['output']>;
  /** Household onboarding request id. */
  id: Scalars['ID']['output'];
  /**
   * Every household member the onboarding invite is addressed to, primary first.
   * The resend panel selects from these; a resend hits exactly who is selected.
   */
  inviteRecipients: Array<InviteRecipient>;
  /** Most recent client contact (ECI intake send or reminder). Null until sent. */
  lastContactedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Clients who have signed the ECI MSA. */
  msaSigned: Scalars['Int']['output'];
  /** Clients expected to sign (signer count). */
  msaTotal: Scalars['Int']['output'];
  /** Primary client email. */
  primaryClientEmail: Maybe<Scalars['String']['output']>;
  /** Primary client full name. */
  primaryClientName: Maybe<Scalars['String']['output']>;
  /** When the household entered the book. */
  startDate: Scalars['ISO8601DateTime']['output'];
  /** Advisor onboarding phase. */
  status: OnboardingCockpitStatus;
  /** Dollars transferred. Null until Step 8 resolves the custodian feed. */
  transferredAmount: Maybe<Scalars['Float']['output']>;
  /** Immutable public handle for confirm/send deeplinks. */
  uuid: Scalars['ID']['output'];
};

/** The connection type for OnboardingCockpitRow. */
export type OnboardingCockpitRowConnection = {
  __typename?: 'OnboardingCockpitRowConnection';
  /** Sum of estimated AUM for the status-scoped book (All = every in-flight household). Ignores search and pagination. */
  aumInFlight: Maybe<Scalars['Float']['output']>;
  /**
   * Households whose cockpit status transitioned to complete during the current
   * calendar month. Ignores search and status filter.
   */
  completeThisMonth: Scalars['Int']['output'];
  /** A list of edges. */
  edges: Maybe<Array<Maybe<OnboardingCockpitRowEdge>>>;
  /**
   * Median days from first awaiting_client to complete across finished households.
   * Null when none qualify. Ignores search and status filter.
   */
  medianOnboardingDays: Maybe<Scalars['Float']['output']>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<OnboardingCockpitRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Row count per status across the full filtered set; powers the "All · N" filter chips. */
  statusCounts: Array<OnboardingStatusCount>;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OnboardingCockpitRowEdge = {
  __typename?: 'OnboardingCockpitRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OnboardingCockpitRow>;
};

/** Sortable fields for the onboarding cockpit table */
export type OnboardingCockpitSortField =
  /** EST_AUM */
  | 'EST_AUM'
  /** HOUSEHOLD_NAME */
  | 'HOUSEHOLD_NAME'
  /** LAST_CONTACTED_AT */
  | 'LAST_CONTACTED_AT'
  /** START_DATE */
  | 'START_DATE'
  /** STATUS */
  | 'STATUS';

export type OnboardingCockpitStatus =
  /** awaiting_client */
  | 'awaiting_client'
  /** awaiting_ops */
  | 'awaiting_ops'
  /** blocked */
  | 'blocked'
  /** complete */
  | 'complete'
  /** confirm_account */
  | 'confirm_account'
  /** in_progress */
  | 'in_progress'
  /** ready_to_send */
  | 'ready_to_send';

export type OnboardingDocument =
  /** custodial */
  | 'custodial'
  /** investment */
  | 'investment';

/** Number of cockpit rows in a given status, for the filter chips. */
export type OnboardingStatusCount = {
  __typename?: 'OnboardingStatusCount';
  /** Rows in this status across the full filtered set. */
  count: Scalars['Int']['output'];
  /** The staged household status. */
  status: OnboardingCockpitStatus;
};

export type OnboardingTaskDatum = {
  __typename?: 'OnboardingTaskDatum';
  /** Status of transferring the client accounts to custodian */
  accountTransferStatus: Maybe<AccountTransferStatus>;
  /** When the co-client signed via DocuSign. */
  coClientDocusignSignedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the co-client signed the IAA. */
  coClientIaaSignedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the onboarding task datum was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custodian for the client. */
  custodian: Maybe<Scalars['String']['output']>;
  /** When the DocuSign envelope was delivered to the custodian. */
  docusignEnvelopeCustodianDeliveredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The DocuSign environment used for the envelope. */
  docusignEnvelopeEnvironment: Maybe<Scalars['String']['output']>;
  /** DocuSign envelope ID associated with the task. */
  docusignEnvelopeId: Maybe<Scalars['String']['output']>;
  /** Whether the DocuSign envelope has been shared with the custodian. */
  docusignEnvelopeSharedWithCustodian: Maybe<Scalars['Boolean']['output']>;
  /** DocuSign envelope status. */
  docusignEnvelopeStatus: Maybe<Scalars['String']['output']>;
  /** Whether this onboarding includes a co-client. */
  hasCoClient: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** When the last IAA email was sent to the co-client. */
  lastCoClientIaaEmailSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last LPOA email was sent to the co-client. */
  lastCoClientLpoaEmailSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last IAA email was sent to the primary client. */
  lastPrimaryClientIaaEmailSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last LPOA email was sent to the primary client. */
  lastPrimaryClientLpoaEmailSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Previous wealth management firm for a transferring client */
  previousWmFirm: Maybe<Scalars['String']['output']>;
  /** When the primary client signed via DocuSign. */
  primaryClientDocusignSignedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the primary client signed the IAA. */
  primaryClientIaaSignedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the onboarding task is ready to be sent to the client. */
  readyToSendToClient: Scalars['Boolean']['output'];
  /** Box File ID for IAA */
  signableDocumentBoxFileId: Maybe<Scalars['String']['output']>;
  /** Download link for a natively signable document. */
  signableDocumentDownloadLink: Maybe<Scalars['String']['output']>;
  /** View link for a natively signable document. */
  signableDocumentLink: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the signature for the signable document. */
  signatureId: Maybe<Scalars['ID']['output']>;
  /** The associated task. */
  task: Task;
  /** The Savvy ID of the associated task. */
  taskId: Scalars['ID']['output'];
  /** When the onboarding task datum was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A beneficiary recorded on an open new account request */
export type OpenNewAccountBeneficiary = {
  __typename?: 'OpenNewAccountBeneficiary';
  /** Whether this is a primary or contingent beneficiary. */
  beneficiaryType: Scalars['String']['output'];
  /** Phone number of the beneficiary. */
  cellPhone: Maybe<Scalars['String']['output']>;
  /** Savvy id of the contact this beneficiary is. */
  contactId: Scalars['ID']['output'];
  /** Date of birth of the beneficiary (ISO-8601: YYYY-MM-DD). */
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** Email address of the beneficiary. */
  email: Maybe<Scalars['String']['output']>;
  /** Name of the beneficiary. */
  name: Maybe<Scalars['String']['output']>;
  /** Whether per stirpes distribution applies. */
  perStirpes: Maybe<Scalars['Boolean']['output']>;
  /** Percentage of the account allocated to this beneficiary. */
  percentage: Maybe<Scalars['String']['output']>;
  /** Relationship of the beneficiary to the account holder. */
  relationship: Maybe<Scalars['String']['output']>;
  /** Masked SSN of the beneficiary (***-**-XXXX). */
  ssn: Maybe<Scalars['String']['output']>;
};

/** Input for a beneficiary of an open new account request */
export type OpenNewAccountBeneficiaryInput = {
  /** Type of beneficiary (primary, contingent) */
  beneficiaryType: Scalars['String']['input'];
  /** Cell phone number */
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  /** ID of an existing contact to associate as beneficiary */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** Date of birth (YYYY-MM-DD) */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the beneficiary */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the share passes per stirpes */
  perStirpes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Percentage allocated to this beneficiary */
  percentage?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the account holder */
  relationship?: InputMaybe<Scalars['String']['input']>;
  /** Social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Open new account request data associated with a task */
export type OpenNewAccountRequest = {
  __typename?: 'OpenNewAccountRequest';
  /** The account holder type (e.g. Individual, Joint). */
  accountHolder: Maybe<Scalars['String']['output']>;
  /** The bank account mode (e.g. checking, savings). */
  accountMode: Maybe<Scalars['String']['output']>;
  /** The account name at the contra custodian. */
  accountName: Maybe<Scalars['String']['output']>;
  /** The legal registration of the account. */
  accountRegistration: Maybe<Scalars['String']['output']>;
  /** The type of account to open. */
  accountType: Maybe<Scalars['String']['output']>;
  /** Additional information about the request. */
  additionalInfo: Maybe<Scalars['String']['output']>;
  /** Annual income of the account holder. */
  annualIncome: Maybe<Scalars['Float']['output']>;
  /** The bank account number. */
  bankAccountNumber: Maybe<Scalars['String']['output']>;
  /** The bank name for MoneyLink. */
  bankName: Maybe<Scalars['String']['output']>;
  /** The bank account owners. */
  bankOwners: Maybe<Scalars['String']['output']>;
  /** Primary and contingent beneficiaries. */
  beneficiaries: Maybe<Array<OpenNewAccountBeneficiary>>;
  /** The sending institution for transfer. */
  contraCustodian: Maybe<Scalars['String']['output']>;
  /** The custodian (e.g. Schwab, Fidelity). */
  custodian: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Trading experience grid recorded with the request (options accounts). */
  investmentExperience: Maybe<InvestmentExperience>;
  /** The investment objective (e.g. growth, income). */
  investmentObjective: Maybe<Scalars['String']['output']>;
  /** The options trading level. */
  level: Maybe<Scalars['String']['output']>;
  /** Liquid net worth of the account holder. */
  liquidNetWorth: Maybe<Scalars['Float']['output']>;
  /** Whether this is a managed account. */
  managedAccount: Maybe<Scalars['Boolean']['output']>;
  /** Whether margin trading is requested. */
  margin: Maybe<Scalars['Boolean']['output']>;
  /** The marital status of the account holder. */
  maritalStatus: Maybe<Scalars['String']['output']>;
  /** Whether MoneyLink is requested. */
  moneyLink: Maybe<Scalars['Boolean']['output']>;
  /** The money manager name. */
  moneyManager: Maybe<Scalars['String']['output']>;
  /** The number of dependents. */
  numberOfDependents: Maybe<Scalars['Int']['output']>;
  /** Whether options trading is requested. */
  options: Maybe<Scalars['Boolean']['output']>;
  /** Details for a partial transfer. */
  partialTransferDetails: Maybe<Scalars['String']['output']>;
  /** The bank routing number. */
  routingNumber: Maybe<Scalars['String']['output']>;
  /** The investment strategy. */
  strategy: Maybe<Scalars['String']['output']>;
  /** Total net worth of the account holder. */
  totalNetWorth: Maybe<Scalars['Float']['output']>;
  /** Whether a transfer in is requested. */
  transfer: Maybe<Scalars['Boolean']['output']>;
  /** The account number at the contra custodian. */
  transferAccountNumber: Maybe<Scalars['String']['output']>;
  /** Whether the transfer is full or partial. */
  transferType: Maybe<Scalars['String']['output']>;
  /** The mailing address of the trusted contact. */
  trustedContactMailingAddress: Maybe<Scalars['String']['output']>;
  /** The name of the trusted contact. */
  trustedContactName: Maybe<Scalars['String']['output']>;
  /** The phone number of the trusted contact. */
  trustedContactPhone: Maybe<Scalars['String']['output']>;
  /** The relationship of the trusted contact. */
  trustedContactRelationship: Maybe<Scalars['String']['output']>;
};

/** Input for open new account request task specific data */
export type OpenNewAccountRequestInput = {
  /** Name of the account holder */
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Account mode */
  accountMode?: InputMaybe<Scalars['String']['input']>;
  /** Account name for transfer */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Bank account number for money link */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account registration for transfer */
  accountRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Type of account to open */
  accountType: Scalars['String']['input'];
  /** Additional notes or instructions */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Annual income */
  annualIncome?: InputMaybe<Scalars['Float']['input']>;
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Bank account owners */
  bankOwners?: InputMaybe<Scalars['String']['input']>;
  /** List of beneficiaries */
  beneficiaries?: InputMaybe<Array<OpenNewAccountBeneficiaryInput>>;
  /** Contra custodian for transfer */
  contraCustodian?: InputMaybe<Scalars['String']['input']>;
  /** Account custodian */
  custodian?: InputMaybe<Scalars['String']['input']>;
  /** Custom fee percentage when not using the household fee */
  customFee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee schedule ID */
  feeScheduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Investment experience grid across all instrument categories */
  investmentExperienceGrid?: InputMaybe<InvestmentExperienceGridInput>;
  /** Investment objective */
  investmentObjective?: InputMaybe<Scalars['String']['input']>;
  /** Options level */
  level?: InputMaybe<Scalars['String']['input']>;
  /** Liquid net worth */
  liquidNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this is a managed account */
  managedAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether margin trading is enabled */
  margin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Marital status */
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether MoneyLink is enabled */
  moneyLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Money manager */
  moneyManager?: InputMaybe<Scalars['String']['input']>;
  /** Number of dependents */
  numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Whether options trading is enabled */
  options?: InputMaybe<Scalars['Boolean']['input']>;
  /** Details for a partial transfer */
  partialTransferDetails?: InputMaybe<Scalars['String']['input']>;
  /** Bank routing number */
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the request should use the household fee */
  sameAsHouseholdFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Investment strategy */
  strategy?: InputMaybe<Scalars['String']['input']>;
  /** Total net worth */
  totalNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this involves a transfer */
  transfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account number for transfer in */
  transferAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of transfer (full, partial) */
  transferType?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact mailing address */
  trustedContactMailingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact full name */
  trustedContactName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact phone number */
  trustedContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact relationship to account holder */
  trustedContactRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunitiesTableHeader = {
  __typename?: 'OpportunitiesTableHeader';
  /** Aggregate # of new leads */
  newLeadCount: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of onboarding opportunities */
  onboardingCount: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of to_dos */
  toDoCount: Maybe<Scalars['Int']['output']>;
  /** Aggregate estimated ARR */
  totalArr: Maybe<Scalars['BigInt']['output']>;
  /** Aggregate estimated AUM */
  totalAum: Maybe<Scalars['BigInt']['output']>;
  /** Aggregate # of clients */
  totalClients: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of prospects */
  totalProspects: Maybe<Scalars['Int']['output']>;
};

export type OpportunitiesTableRow = {
  __typename?: 'OpportunitiesTableRow';
  /** The lead source of the opportunity */
  advisorLeadSource: Maybe<Scalars['String']['output']>;
  /** The short name of the alert */
  alertShortName: Maybe<AlertShortName>;
  /** The ARR of the opportunity */
  arr: Maybe<Scalars['Int']['output']>;
  /** The AUM of the opportunity */
  aum: Maybe<Scalars['Int']['output']>;
  /** The client profile id of the opportunity */
  clientProfileId: Scalars['ID']['output'];
  /** The co-client of the opportunity */
  coClient: Maybe<OpportunitiesTableRowContact>;
  /** The created_at timestamp of the opportunity */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the opportunity */
  description: Maybe<Scalars['String']['output']>;
  /** The expected close date of the opportunity */
  expectedCloseDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The household associated with the opportunity */
  household: Household;
  /** The household_id associated with the opportunity */
  householdId: Scalars['ID']['output'];
  /** The name of the household */
  householdName: Scalars['String']['output'];
  /** The stage of the household */
  householdStage: HouseholdStage;
  /** The id associated with the opportunity */
  id: Scalars['ID']['output'];
  /** Whether the opportunity is a prospect */
  isProspect: Scalars['Boolean']['output'];
  /** The next steps of the opportunity */
  nextSteps: Maybe<Scalars['String']['output']>;
  /** The next steps due date of the opportunity */
  nextStepsDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Organization household categories for this opportunity */
  organizationHouseholdCategories: Maybe<Array<OrganizationHouseholdCategory>>;
  /** Organization household tags for this opportunity */
  organizationHouseholdTags: Maybe<Array<OrganizationHouseholdTag>>;
  /** The primary advisor for this prospect */
  primaryAdvisor: Maybe<PrimaryAdvisor>;
  /** The primary client of the opportunity */
  primaryClient: OpportunitiesTableRowContact;
  /** The probability of closing of the opportunity */
  probabilityOfClosing: Maybe<ProbabilityOfClosing>;
  /** The salesforce account id of the household */
  salesforceAccountId: Maybe<Scalars['String']['output']>;
  /** The status of the opportunity */
  status: OpportunityStatus;
  /** The updated_at timestamp of the opportunity */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OpportunitiesTableRow. */
export type OpportunitiesTableRowConnection = {
  __typename?: 'OpportunitiesTableRowConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<OpportunitiesTableRowEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<OpportunitiesTableRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of opportunities */
  totalCount: Scalars['Int']['output'];
};

export type OpportunitiesTableRowContact = {
  __typename?: 'OpportunitiesTableRowContact';
  /** The user email */
  email: Scalars['String']['output'];
  /** The user first name */
  firstName: Scalars['String']['output'];
  /** The user ID */
  id: Scalars['ID']['output'];
  /** The user last name */
  lastName: Scalars['String']['output'];
  /** The user phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
};

/** Edge type that transforms Opportunity records into OpportunitiesTableRow structs */
export type OpportunitiesTableRowEdge = {
  __typename?: 'OpportunitiesTableRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OpportunitiesTableRow>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  /** The estimated ARR of the opportunity */
  arr: Maybe<Scalars['Int']['output']>;
  /** The estimated AUM of the opportunity */
  aum: Maybe<Scalars['Int']['output']>;
  /** Access client information related to opportunity */
  client: Maybe<Client>;
  /** The ID of the client profile */
  clientProfileId: Scalars['ID']['output'];
  /** The date the opportunity was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the opportunity */
  description: Maybe<Scalars['String']['output']>;
  /** The expected close date of the opportunity */
  expectedCloseDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The ID of the opportunity */
  id: Scalars['ID']['output'];
  /** Whether this opportunity is a prospect */
  isProspect: Scalars['Boolean']['output'];
  /** The next steps for the opportunity */
  nextSteps: Maybe<Scalars['String']['output']>;
  /** The due date of the next steps for the opportunity */
  nextStepsDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date the opportunity was won */
  onboardDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The probability of closing the opportunity */
  probabilityOfClosing: Maybe<ProbabilityOfClosing>;
  /** The ID of the prospect datum */
  prospectDatumId: Maybe<Scalars['ID']['output']>;
  /** The current status of the opportunity */
  status: OpportunityStatus;
  /** The date the opportunity was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Sort values for opportunities table */
export type OpportunitySortValues =
  /** CREATED_AT */
  | 'CREATED_AT'
  /** DUE_DATE */
  | 'DUE_DATE'
  /** ESTIMATED_AUM */
  | 'ESTIMATED_AUM'
  /** ESTIMATED_CLOSE_DATE */
  | 'ESTIMATED_CLOSE_DATE'
  /** HOUSEHOLD_NAME */
  | 'HOUSEHOLD_NAME'
  /** PRIMARY_ADVISOR */
  | 'PRIMARY_ADVISOR'
  /** STAGE_STEP */
  | 'STAGE_STEP'
  /** STATUS */
  | 'STATUS';

export type OpportunityStatus =
  | 'commitment'
  | 'discovery'
  | 'disqualified'
  | 'lost'
  | 'on_hold'
  | 'onboarding'
  | 'proposal'
  | 'won';

/** Filter opportunities by type */
export type OpportunityTypeFilter =
  /** Show all opportunities */
  | 'ALL'
  /** Show only client opportunities */
  | 'CLIENT'
  /** Show only prospect opportunities */
  | 'PROSPECT';

export type Organization = {
  __typename?: 'Organization';
  advisorGroups: Maybe<Array<AdvisorGroup>>;
  advisorProfiles: Maybe<Array<Advisor>>;
  /**
   * Whether Organization Branding is available to this organization. Null defers
   * to the legacy advisorGroupBranding LaunchDarkly gate.
   */
  brandingEnabled: Maybe<Scalars['Boolean']['output']>;
  clientHouseholds: Maybe<Array<Household>>;
  householdTags: Maybe<Array<HouseholdTag>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationBranding: Maybe<OrganizationBranding>;
  organizationHouseholdCategories: Maybe<Array<OrganizationHouseholdCategory>>;
  organizationHouseholdTags: Maybe<Array<OrganizationHouseholdTag>>;
  /** Whether completing a client's task emails the account holders. Null means unset; the send path treats that as on. */
  sendEmailWhenTaskCompleted: Maybe<Scalars['Boolean']['output']>;
  /** Ops paperwork reminder shown to CSAs on completed client-services tasks for this organization */
  taskInstructionsForOps: Maybe<Scalars['String']['output']>;
  users: Maybe<Array<User>>;
};

/** Organization Branding information */
export type OrganizationBranding = {
  __typename?: 'OrganizationBranding';
  /** Hex accent color for report dividers, section headers, and rule lines */
  accentColor: Maybe<Scalars['String']['output']>;
  /** When the branding was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Custom intro for onboarding emails */
  customOnboardingEmailIntro: Maybe<Scalars['String']['output']>;
  /** Compliance/disclosure text appended to generated report footers */
  disclosureText: Maybe<Scalars['String']['output']>;
  /** Display name for the organization */
  displayName: Maybe<Scalars['String']['output']>;
  /** Email for the organization */
  email: Maybe<Scalars['String']['output']>;
  /** Curated font family applied across generated advisor reports */
  fontFamily: Maybe<ReportFontFamilyEnum>;
  /** Font size scale preset applied across generated advisor reports and proposals */
  fontSizeScale: ReportFontSizeScaleEnum;
  /** The ID of the organization branding */
  id: Scalars['ID']['output'];
  /** URL of the logo image */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** The associated organization */
  organization: Organization;
  /** The ID of the associated organization */
  organizationId: Scalars['ID']['output'];
  /** Phone number for the organization */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** The From address client emails actually send from, when the organization is provisioned to send as itself. Read-only. */
  sendingFromEmail: Maybe<Scalars['String']['output']>;
  /** Short display name for the organization */
  shortDisplayName: Maybe<Scalars['String']['output']>;
  /** Whether to show Calendly link in emails */
  showCalendlyLinkInEmails: Maybe<Scalars['Boolean']['output']>;
  /** When the branding was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization's own authenticated email sending domain. Read-only; null means mail sends on Savvy's shared domain. */
  verifiedSendingDomain: Maybe<Scalars['String']['output']>;
};

export type OrganizationBrandingInput = {
  /** Hex accent color for report dividers, section headers, and rule lines */
  accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Custom intro onboarding emails */
  customOnboardingEmailIntro?: InputMaybe<Scalars['String']['input']>;
  /** Compliance/disclosure text appended to generated report footers */
  disclosureText?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the organization */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Curated font family applied across generated advisor reports */
  fontFamily?: InputMaybe<ReportFontFamilyEnum>;
  /** Font size scale preset applied across generated advisor reports and proposals */
  fontSizeScale?: InputMaybe<ReportFontSizeScaleEnum>;
  /** Base64 encoded logo image for Cloudinary upload */
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization */
  organizationId: Scalars['ID']['input'];
  /** Short display name for the organization */
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to delete the logo */
  shouldDeleteLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Organization>;
};

export type OrganizationHouseholdCategory = {
  __typename?: 'OrganizationHouseholdCategory';
  emoji: Maybe<Scalars['String']['output']>;
  hexColorCode: Maybe<Scalars['String']['output']>;
  householdTags: Maybe<Array<HouseholdTag>>;
  households: Maybe<Array<Household>>;
  householdsCount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  organizationHouseholdTags: Maybe<Array<OrganizationHouseholdTag>>;
};

/** Input for updating an organization household category in a bulk operation */
export type OrganizationHouseholdCategoryUpdateInput = {
  /** The ID of the category to update */
  id: Scalars['ID']['input'];
  /** The new name for the category */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationHouseholdTag = {
  __typename?: 'OrganizationHouseholdTag';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  householdCount: Scalars['Int']['output'];
  householdTags: Maybe<Array<HouseholdTag>>;
  households: Maybe<Array<Household>>;
  id: Scalars['ID']['output'];
  isSmart: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationHouseholdCategory: OrganizationHouseholdCategory;
  ruleJson: Maybe<Scalars['JSON']['output']>;
};

export type OrganizationSettingsInput = {
  /** Whether the Organization Branding feature is available to this organization */
  brandingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether completing a client's task emails the account holders, across the whole organization */
  sendEmailWhenTaskCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Original email addresses for each participant role in an email message */
export type OriginalEmailAddresses = {
  __typename?: 'OriginalEmailAddresses';
  /** The original BCC email address */
  bcc: Maybe<Array<Scalars['String']['output']>>;
  /** The original CC email address */
  cc: Maybe<Array<Scalars['String']['output']>>;
  /** The original sender email address */
  from: Maybe<Array<Scalars['String']['output']>>;
  /** The original reply-to email address */
  replyTo: Maybe<Array<Scalars['String']['output']>>;
  /** The original recipient email address */
  to: Maybe<Array<Scalars['String']['output']>>;
};

/** Orion reports that can be generated ad-hoc in the Generate Orion Report mutation */
export type OrionAdHocReport = {
  __typename?: 'OrionAdHocReport';
  /** The description of the report */
  desc: Scalars['String']['output'];
  /** The ID of the report */
  id: Scalars['String']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The slug of the report */
  slug: Scalars['String']['output'];
};

/** Orion Portfolio Document */
export type OrionPortfolioDocument = {
  __typename?: 'OrionPortfolioDocument';
  /** The category of the document */
  category: Scalars['String']['output'];
  /** The description of the document */
  description: Scalars['String']['output'];
  /** The URL to download the document */
  downloadUrl: Scalars['String']['output'];
  /** The user who edited the document */
  editedBy: Scalars['String']['output'];
  /** The date the document was edited */
  editedDate: Scalars['String']['output'];
  /** The ID of the document */
  id: Scalars['String']['output'];
  /** Whether the document was generated by the system */
  systemGenerated: Scalars['Boolean']['output'];
};

/** Orion quarterly reports available for generation in the current environment */
export type OrionQuarterlyReport = {
  __typename?: 'OrionQuarterlyReport';
  /** Optional description of the report type */
  description: Maybe<Scalars['String']['output']>;
  /** The Orion report ID for this report type in the current environment */
  id: Scalars['String']['output'];
  /** Human-readable name for the report type */
  name: Scalars['String']['output'];
  /** The slug/type of the quarterly report (e.g., performance-simplified) */
  slug: Scalars['String']['output'];
};

/** Orion quarterly report generation record tracking the status of report generation. */
export type OrionQuarterlyReportGeneration = {
  __typename?: 'OrionQuarterlyReportGeneration';
  /** Box file ID of the uploaded report if successful. */
  boxFileId: Maybe<Scalars['String']['output']>;
  /** When the report generation completed (or failed). */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Error message if the report generation failed. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Name of the generated file if successful. */
  fileName: Maybe<Scalars['String']['output']>;
  /** The ID of the household this report is for. */
  householdId: Scalars['ID']['output'];
  /** The ID of the report generation record. */
  id: Scalars['ID']['output'];
  /** The type of report (e.g., performance-detailed, performance-simplified). */
  reportType: Scalars['String']['output'];
  /** When the report generation started. */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The current status of the report generation (pending, processing, completed, failed). */
  status: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Orion report types that households can be enrolled in */
export type OrionReport =
  /** custodial1099 */
  | 'custodial1099'
  /** custom_indexing_report */
  | 'custom_indexing_report'
  /** income_reports */
  | 'income_reports'
  /** invoices */
  | 'invoices'
  /** performance_report_allocations */
  | 'performance_report_allocations'
  /** performance_report_consolidated */
  | 'performance_report_consolidated'
  /** performance_report_integrated */
  | 'performance_report_integrated'
  /** performance_report_sectors */
  | 'performance_report_sectors'
  /** performance_report_unified */
  | 'performance_report_unified'
  /** portfolio_review_portfolio_group */
  | 'portfolio_review_portfolio_group'
  /** portfolio_summary_cash_flows */
  | 'portfolio_summary_cash_flows'
  /** portfolio_summary_comprehensive */
  | 'portfolio_summary_comprehensive'
  /** quarterly_reports_long */
  | 'quarterly_reports_long'
  /** quarterly_reports_short */
  | 'quarterly_reports_short';

/** Orion report generation record tracking the status of report generation. */
export type OrionReportGeneration = {
  __typename?: 'OrionReportGeneration';
  /** When the report generation completed (or failed). */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** URL to download the generated PDF report. */
  downloadUrl: Maybe<Scalars['String']['output']>;
  /** Error message if the report generation failed. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The ID of the report generation record. */
  id: Scalars['ID']['output'];
  /** The current status of the report generation (pending, processing, completed, failed). */
  status: Scalars['String']['output'];
};

/** Orion Report Template */
export type OrionReportTemplate = {
  __typename?: 'OrionReportTemplate';
  /** Category of the report */
  category: Scalars['String']['output'];
  /** Defaults type of the report template */
  defaultsType: Maybe<Scalars['String']['output']>;
  /** Disclaimer text for the report template */
  disclaimer: Maybe<Scalars['String']['output']>;
  /** Entities applicable */
  entities: Maybe<Scalars['String']['output']>;
  /** Whether the template has entity defaults */
  hasEntityDefaults: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template has report defaults */
  hasReportDefaults: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template supports storable parameters */
  hasStorableParameters: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template has user defaults */
  hasUserDefaults: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the report template */
  id: Scalars['String']['output'];
  /** Last run date of the report */
  lastRunDate: Maybe<Scalars['String']['output']>;
  /** Layout type of the report template */
  layoutType: Maybe<Scalars['String']['output']>;
  /** Parent category of the report */
  parentCategory: Scalars['String']['output'];
  /** Description of the report */
  reportDescription: Scalars['String']['output'];
  /** Name of the report */
  reportName: Scalars['String']['output'];
  /** Whether to run assigned version */
  runAssignedVersion: Maybe<Scalars['Boolean']['output']>;
  /** Run to target */
  runTo: Maybe<Scalars['String']['output']>;
  /** Whether to show internal only warning */
  showInternalOnlyWarning: Maybe<Scalars['Boolean']['output']>;
  /** Storable parameters definition */
  storable: Maybe<Scalars['String']['output']>;
  /** Unstorable parameters definition */
  unstorable: Maybe<Scalars['String']['output']>;
};

/** Product search data from Orion Eclipse */
export type OrionSearch = {
  __typename?: 'OrionSearch';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  ticker: Scalars['String']['output'];
};

/** Security data from Orion Eclipse */
export type OrionSecurity = {
  __typename?: 'OrionSecurity';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  ticker: Scalars['String']['output'];
};

/** Orion data sync status for a user */
export type OrionSyncStatus = {
  __typename?: 'OrionSyncStatus';
  /** When the sync completed */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the sync was started */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current sync status: idle, pending, or complete */
  status: Scalars['String']['output'];
};

/** Input for other-investment task specific data */
export type OtherInvestmentTaskInput = {
  /** Managed accounts this task applies to */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** What the investment ops team needs to do */
  taskType: OtherInvestmentTaskTypeName;
};

/** Structured data for an other-investment task */
export type OtherInvestmentTaskRequest = {
  __typename?: 'OtherInvestmentTaskRequest';
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Managed accounts this task applies to. */
  requestAccounts: Array<OtherInvestmentTaskRequestAccount>;
  /** What the investment ops team needs to do. */
  taskType: OtherInvestmentTaskTypeName;
};

/** An account linked to an other-investment task request */
export type OtherInvestmentTaskRequestAccount = {
  __typename?: 'OtherInvestmentTaskRequestAccount';
  /** The associated account. */
  account: Account;
  /** The Savvy ID of the join record. */
  id: Scalars['ID']['output'];
};

/** The variant of an other-investment task request */
export type OtherInvestmentTaskTypeName =
  /** invest_cash */
  | 'invest_cash'
  /** other */
  | 'other'
  /** raise_cash */
  | 'raise_cash'
  /** rebalance_account */
  | 'rebalance_account';

export type PageImpression = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PageViewDuration = {
  /** The duration of the page view in milliseconds */
  duration: Scalars['Int']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** A participant in a calendar event, identified by email address */
export type Participant = {
  __typename?: 'Participant';
  /** Timestamp when the participant was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email address of the participant. */
  email: Scalars['String']['output'];
  /** The Savvy ID of the participant. */
  id: Scalars['ID']['output'];
  /** The name of the participant. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp when the participant was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/**
 * Per-account block of the report (mirrors the household-level Composition,
 * Activity Summary, and Market Value chart, scoped to one account).
 */
export type PerAccountSection = {
  __typename?: 'PerAccountSection';
  /** Savvy account ID this block describes. */
  accountId: Scalars['ID']['output'];
  /** Display name for the account, shown as the section header. */
  accountName: Scalars['String']['output'];
  /** Activity Summary rows (MTD, QTD, YTD, Inception) scoped to this account. */
  activitySummaryRows: Array<ActivitySummaryRow>;
  /** Daily points for the per-account 'Invested Value Comparison' chart, filtered to the report date range. */
  marketValueSeries: Array<MarketValuePoint>;
  /** Asset-category pie slices for this account (sums to 100%). */
  portfolioAllocation: Array<AllocationSlice>;
};

/** Performance of a particular entity over a specified amount of time. */
export type Performance = {
  __typename?: 'Performance';
  /** Total contributions during this time period. */
  contributions: Maybe<Scalars['BigDecimal']['output']>;
  /** Total distributions during this time period. */
  distributions: Maybe<Scalars['BigDecimal']['output']>;
  endDate: Scalars['ISO8601Date']['output'];
  endPrice: Maybe<Scalars['BigDecimal']['output']>;
  endUnits: Maybe<Scalars['BigDecimal']['output']>;
  endValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Internal rate of return */
  irr: Maybe<Scalars['BigDecimal']['output']>;
  /** Total merge-in transfers during this time period. */
  mergeIn: Maybe<Scalars['BigDecimal']['output']>;
  /** Total merge-out transfers during this time period. */
  mergeOut: Maybe<Scalars['BigDecimal']['output']>;
  /** Percent allocation of total portfolio value at the end of the time period. */
  percent: Maybe<Scalars['BigDecimal']['output']>;
  /** Realized gain/loss during this time period. */
  realizedGainLoss: Maybe<Scalars['BigDecimal']['output']>;
  /** Long-term realized gain/loss during this time period. */
  realizedGainLossLongTerm: Maybe<Scalars['BigDecimal']['output']>;
  /** Short-term realized gain/loss during this time period. */
  realizedGainLossShortTerm: Maybe<Scalars['BigDecimal']['output']>;
  startDate: Scalars['ISO8601Date']['output'];
  startValue: Maybe<Scalars['BigDecimal']['output']>;
  timePeriod: Maybe<PerformanceTimePeriodName>;
  /** Time weighted rate of return */
  twr: Maybe<Scalars['BigDecimal']['output']>;
  usdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Performance by Account" PDF. Provides all data
 * needed to render the three-page report: cover page (accounts list), Activity
 * Summary (per-account time-weighted returns across the date range / QTD / YTD /
 * Since Inception, plus a household total row), and Appendix – Summary of Accounts
 * (Relationship Summary by Account Type). Replaces the Orion path when
 * feature-flagged on (HAWK-77).
 */
export type PerformanceByAccount = {
  __typename?: 'PerformanceByAccount';
  /** Activity Summary: one per-account time-weighted-return row, sorted by account name. */
  accountRows: Array<PerformanceByAccountRow>;
  /** Per-account rows for the Appendix – Summary of Accounts page (name, type, masked number, management style, market value). */
  accountSummaries: Array<AccountEntry>;
  /** Primary advisor's display name shown on the cover. */
  advisorName: Maybe<Scalars['String']['output']>;
  /** Accounts listed on the cover page (name + masked number, sorted by account name). */
  coverAccounts: Array<AccountEntry>;
  /** When the underlying performance snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end date (as-of date for QTD / YTD / Since Inception). */
  endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name. Falls back to "Savvy" when the household's advisor has no organization branding. */
  firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL. Falls back to the Savvy logo when no organization branding is set. */
  firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and page headers. */
  householdName: Scalars['String']['output'];
  /** Activity Summary household total row (bold), with is_household: true. */
  householdReturn: PerformanceByAccountRow;
  /** Stable identifier for this report scope (household + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across all accounts; labels the 'Since' Activity Summary column. Null when unknown. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** User-selected start date (first column of the Activity Summary). */
  startDate: Scalars['ISO8601Date']['output'];
};

/**
 * A row in the 'Activity Summary' table — one account, or the bold household total
 * row. Each row carries the four time-weighted-return columns: the user-selected
 * date range, Quarter to Date, Year to Date, and Since Inception. The household
 * total row sets is_household: true with a null account_id / masked_number.
 */
export type PerformanceByAccountRow = {
  __typename?: 'PerformanceByAccountRow';
  /** Internal Savvy account ID. Null on the household total row. */
  accountId: Maybe<Scalars['ID']['output']>;
  /** True for the household total row; false for per-account rows. */
  isHousehold: Scalars['Boolean']['output'];
  /** Masked account number (XXX-XX####). Null on the household total row. */
  maskedNumber: Maybe<Scalars['String']['output']>;
  /** Account display name, or the household name on the total row. */
  name: Scalars['String']['output'];
  /** Time-weighted return over the user-selected date range (fraction, e.g. 0.012 = 1.2%). */
  periodReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return (fraction). */
  qtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Since-inception (all-time) time-weighted return (fraction). */
  sinceInceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return (fraction). */
  ytdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Performance Report – Allocations". Provides the
 * full data payload for the multi-page PDF over a user-selected date range.
 * Sections: cover, relationship summary, activity summary, MV chart, allocation
 * pies, portfolio performance by asset class, holdings report, transactions, and
 * appendix. Replaces the Orion path when feature-flagged on.
 */
export type PerformanceReportAllocations = {
  __typename?: 'PerformanceReportAllocations';
  /** Accounts included in the report (relationship summary). */
  accounts: Array<PerformanceReportAllocationsAccountSummaryRow>;
  /** Activity summary rows — QTD, YTD, and Inception periods. */
  activitySummary: Array<ActivitySummaryRow>;
  /** Primary advisor's display name. */
  advisorName: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Fixed Income / Cash / Alternatives). */
  allocationByCategory: Array<AllocationSlice>;
  /** Slices of the Asset Class pie (US Equity / Intl Developed / Cash / …). */
  allocationByClass: Array<AllocationSlice>;
  /** Per-day per-asset-class allocation time series derived from Orion PortfolioDaily factors. */
  allocationOverTime: Array<PerformanceReportAllocationsAllocationOverTimePoint>;
  /** Portfolio performance by asset class with TWR, yield, projected income, and benchmarks. */
  assetClassPerformance: Array<PerformanceReportAllocationsAssetClassPerformanceRow>;
  /** When the underlying snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end of the report period. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name; falls back to "Savvy". */
  firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL; falls back to the Savvy logo. */
  firmLogoUrl: Scalars['String']['output'];
  /** Per-holding rows for the Holdings Report, grouped by asset class on the frontend. */
  holdings: Array<HoldingsSummaryRow>;
  /** Household display name. */
  householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across the household's accounts. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily portfolio-level market value + net invested from inception through end_date. */
  marketValueSeries: Array<MarketValuePoint>;
  /** Holdings grouped per account (one Orion "Holdings Report (Managed)" block per account). */
  perAccountSections: Array<PerformanceReportIntegratedPerAccountHoldingsSection>;
  /** Beginning of quarter for end_date (QTD period start). */
  quarterStartDate: Scalars['ISO8601Date']['output'];
  /** Market-value summary for the user-selected date range (first activity-summary column). */
  selectedPeriodSummary: Maybe<PerformanceReportAllocationsSelectedPeriodSummary>;
  /** User-selected start of the report period. */
  startDate: Scalars['ISO8601Date']['output'];
  /** Taxable income line items (dividends, interest) for YTD and since-inception; taxable accounts only. */
  taxableIncomeSummary: Maybe<PerformanceReportAllocationsTaxableIncomeSummary>;
  /** Realized short/long-term gain & loss for YTD and since-inception; taxable accounts only. */
  taxableRealizedGainLoss: Maybe<PerformanceReportAllocationsTaxableRealizedGainLoss>;
  /** Purchases, sales, and advisory fees within the selected date range. */
  transactions: Array<PerformanceReportAllocationsTransactionRow>;
  /** Jan 1 of end_date year (YTD period start). */
  yearStartDate: Scalars['ISO8601Date']['output'];
};

/** One account row in the Relationship Summary section. */
export type PerformanceReportAllocationsAccountSummaryRow = {
  __typename?: 'PerformanceReportAllocationsAccountSummaryRow';
  /** Savvy account ID. */
  accountId: Scalars['ID']['output'];
  /** Display name of the account. */
  accountName: Scalars['String']['output'];
  /** Masked account number (e.g. "XXX-XX4792"). */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Display account type (e.g. "Roth IRA"); null for Orion accounts without a Savvy enum. */
  accountType: Maybe<Scalars['String']['output']>;
  /** Custodian name. */
  custodian: Maybe<Scalars['String']['output']>;
  /** Appendix grouping: "Managed" (Orion-tracked) or "Unmanaged". */
  managementStyle: Scalars['String']['output'];
  /** Ending market value in USD; null until per-account snapshots land. */
  marketValue: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Tax-treatment bucket for the Relationship Summary: "Taxable Accounts",
   * "Retirement Accounts - Tax Deferred", or "Retirement Accounts - Tax Exempt".
   */
  taxCategory: Scalars['String']['output'];
};

/** Per-asset-class allocation snapshot for one day (stacked area chart data). */
export type PerformanceReportAllocationsAllocationOverTimePoint = {
  __typename?: 'PerformanceReportAllocationsAllocationOverTimePoint';
  /** Date of this snapshot. */
  date: Scalars['ISO8601Date']['output'];
  /**
   * Per-asset-class slice. percent = fraction (0.55 = 55%), value =
   * back-calculated MV in USD. NOTE: back-calculation uses the TWR factor chain
   * and does not account for intra-period cash flows — the allocation percentages
   * are approximations when positions were significantly changed mid-period.
   */
  slices: Array<AllocationSlice>;
};

/** Per-asset-class performance row with TWR, yield, projected income, and benchmark comparison. */
export type PerformanceReportAllocationsAssetClassPerformanceRow = {
  __typename?: 'PerformanceReportAllocationsAssetClassPerformanceRow';
  /** Portfolio allocation as a fraction (0.55 = 55%). */
  allocation: Maybe<Scalars['BigDecimal']['output']>;
  /** Asset class name (e.g. "US Equity"), category name, or household name. */
  assetClass: Scalars['String']['output'];
  /** Since-inception TWR for the benchmark as a fraction. */
  benchmarkInceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Display name of the firm-configured benchmark; null when none. */
  benchmarkName: Maybe<Scalars['String']['output']>;
  /** QTD TWR for the benchmark as a fraction. */
  benchmarkQtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD TWR for the benchmark as a fraction. */
  benchmarkYtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value in USD. */
  endingValue: Scalars['BigDecimal']['output'];
  /** Since-inception TWR as a fraction. */
  inceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Hierarchy level: "household", "category", or "class" (drives indentation + bolding). */
  level: Scalars['String']['output'];
  /** Estimated annual income in USD. */
  projectedIncome: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date TWR as a fraction. */
  qtdReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Earliest funded date for this asset class. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Current yield as a fraction (0.022 = 2.2%). */
  yieldPct: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date TWR as a fraction. */
  ytdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** Market-value summary for the user-selected date range (first activity-summary column). */
export type PerformanceReportAllocationsSelectedPeriodSummary = {
  __typename?: 'PerformanceReportAllocationsSelectedPeriodSummary';
  /** Portfolio market value at start_date. */
  beginningValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end of the selected range. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at end_date. */
  endingValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Net cash flows during the selected range. */
  netAdditions: Maybe<Scalars['BigDecimal']['output']>;
  /** Market value increase minus net additions. */
  netGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start of the selected range. */
  startDate: Scalars['ISO8601Date']['output'];
};

/** Taxable income line items for the YTD and since-inception periods. */
export type PerformanceReportAllocationsTaxableIncomeSummary = {
  __typename?: 'PerformanceReportAllocationsTaxableIncomeSummary';
  /** Since-inception column. */
  inception: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
  /** Year-to-date column. */
  ytd: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
};

/** Realized short/long-term gain & loss for the YTD and since-inception periods. */
export type PerformanceReportAllocationsTaxableRealizedGainLoss = {
  __typename?: 'PerformanceReportAllocationsTaxableRealizedGainLoss';
  /** Since-inception column. */
  inception: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
  /** Year-to-date column. */
  ytd: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
};

/** One transaction within the selected date range. */
export type PerformanceReportAllocationsTransactionRow = {
  __typename?: 'PerformanceReportAllocationsTransactionRow';
  /** Masked account number (e.g. "XXX-XX4792"). */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Per-unit price in USD; null for fee transactions. */
  price: Maybe<Scalars['BigDecimal']['output']>;
  /** Security / fund display name. */
  securityName: Maybe<Scalars['String']['output']>;
  /** Ticker symbol. */
  ticker: Maybe<Scalars['String']['output']>;
  /** Total transaction amount in USD (negative = outflow). */
  total: Scalars['BigDecimal']['output'];
  /** Date the transaction was executed. */
  transactionDate: Scalars['ISO8601Date']['output'];
  /** "purchase", "sale", or "advisory_fee". */
  transactionType: Scalars['String']['output'];
  /** Number of units transacted; null for fee transactions. */
  units: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Client Portfolio Review Report" (Consolidated).
 * Provides the full data payload needed to render the multi-page PDF — Accounts
 * Included, two Portfolio Valuation Composition pies (Asset Category + Asset
 * Class), QTD/YTD/Inception Activity Summary, Invested Value Comparison chart,
 * Account Performance table, Estimated Income, per-asset-class returns,
 * per-account sub-reports, and the full Portfolio Appraisal holdings table.
 * Replaces the Orion path when feature-flagged on (HAWK-29).
 */
export type PerformanceReportConsolidated = {
  __typename?: 'PerformanceReportConsolidated';
  /** Rows of the 'Account Performance' table — per-account market value plus YTD / Rolling 1-Year / Inception returns. */
  accountPerformance: Array<AccountPerformanceRow>;
  /** Rows of the 'Accounts Included in this Report' table on page 1. */
  accounts: Array<AccountSummaryRow>;
  /** Rows of the 'Activity Summary' table — one per reporting period (QTD, YTD, Inception). */
  activitySummary: Array<ActivitySummaryRow>;
  /** Primary advisor's display name shown on the cover. */
  advisorName: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Cash & Cash Equivalents / …). Sums to 100%. */
  allocationByCategory: Array<AllocationSlice>;
  /** Slices of the Asset Class pie (US Equity / International Developed / Cash / …). Sums to 100%. */
  allocationByClass: Array<AllocationSlice>;
  /**
   * Per-asset-class returns (Ending Value + QTD/YTD/Inception %) rendered as a
   * section between the household summary and per-account blocks.
   */
  assetClassReturns: Array<AssetClassReturn>;
  /** When the underlying performance snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Inclusive end date of the report (the user-selected as-of date). */
  endDate: Scalars['ISO8601Date']['output'];
  /** Rows of the 'Estimated Income' table — one per asset class plus a derived total handled client-side. */
  estimatedIncome: Array<EstimatedIncomeRow>;
  /** Branded firm name shown on the cover. Falls back to "Savvy" when the household's advisor has no organization branding. */
  firmDisplayName: Scalars['String']['output'];
  /**
   * Branded firm logo URL shown on the cover. Falls back to the Savvy logo when
   * the household's advisor has no organization branding.
   */
  firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and section headers. */
  householdName: Scalars['String']['output'];
  /** Household-level trailing one-year TWR (fraction) for the Account Performance 'Total' row; null when unavailable. */
  householdRollingOneYearReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Stable identifier for this report scope (household + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across the report's accounts; used for the 'Since Inception' column. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily points for the household-level 'Invested Value Comparison' chart (Market Value vs Net Amount Invested). */
  marketValueSeries: Array<MarketValuePoint>;
  /** Per-account sub-reports (mini composition + activity + market value chart for each account). */
  perAccountSections: Array<PerAccountSection>;
  /** Per-holding rows for the 'Portfolio Appraisal' table (pages 5+ of the PDF), grouped by asset class on the frontend. */
  portfolioAppraisal: Array<HoldingsSummaryRow>;
  /** Inclusive start of the QTD period (resolved from end_date — the user only picks an as-of date). */
  startDate: Scalars['ISO8601Date']['output'];
  /** Inclusive start of the YTD period (Jan 1 of the end-date year). */
  yearStartDate: Scalars['ISO8601Date']['output'];
};

/**
 * Reporting periods covered by the Performance Report (Consolidated) summary
 * tables — month-to-date, quarter-to-date, year-to-date, and since-inception.
 */
export type PerformanceReportConsolidatedPeriod =
  /** inception */
  | 'inception'
  /** month_to_date */
  | 'month_to_date'
  /** quarter_to_date */
  | 'quarter_to_date'
  /** year_to_date */
  | 'year_to_date';

/**
 * Native rebuild of the Orion "Performance Report – Integrated". Full data payload
 * for the multi-page PDF: activity summary (QTD/YTD/Previous Year/Rolling
 * 3-Year/Inception), portfolio value over time, allocation pie + allocation over
 * time, household holdings report, per-account holdings, YTD fees by account,
 * taxable income summary, taxable realized gain/loss, and return by account.
 * Replaces the Orion path when feature-flagged on.
 */
export type PerformanceReportIntegrated = {
  __typename?: 'PerformanceReportIntegrated';
  /** Activity summary rows — QTD, YTD, Previous Year, Rolling 3-Year, Inception. */
  activitySummary: Array<PerformanceReportIntegratedActivitySummaryRow>;
  /** Primary advisor's display name. */
  advisorName: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Fixed Income / Cash / Alternatives). */
  allocationByCategory: Array<AllocationSlice>;
  /** Per-day per-asset-class allocation time series (stacked-area chart). */
  allocationOverTime: Array<PerformanceReportAllocationsAllocationOverTimePoint>;
  /** When the underlying snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end of the report period (as-of date). */
  endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name; falls back to "Savvy". */
  firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL; falls back to the Savvy logo. */
  firmLogoUrl: Scalars['String']['output'];
  /** Household-level holdings (one row per security, aggregated across accounts). */
  holdings: Array<HoldingsSummaryRow>;
  /** Household display name. */
  householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across the household's accounts. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily portfolio-level market value + net invested from inception through end_date. */
  marketValueSeries: Array<MarketValuePoint>;
  /** Per-account holdings report blocks. */
  perAccountSections: Array<PerformanceReportIntegratedPerAccountHoldingsSection>;
  /** Dec 31 of the prior calendar year (tax column header). */
  previousYearEndDate: Scalars['ISO8601Date']['output'];
  /** Beginning of quarter for end_date (QTD period start). */
  quarterStartDate: Scalars['ISO8601Date']['output'];
  /** Per-account ending value, net additions, and period returns (household total first). */
  returnByAccount: Array<PerformanceReportIntegratedReturnByAccountRow>;
  /** User-selected start of the report period (header). */
  startDate: Scalars['ISO8601Date']['output'];
  /** Taxable income line items (prior calendar year + YTD). */
  taxableIncomeSummary: Maybe<PerformanceReportIntegratedTaxableIncomeSummary>;
  /** Taxable realized gain/loss (prior calendar year + YTD). */
  taxableRealizedGainLoss: Maybe<PerformanceReportIntegratedTaxableRealizedGainLoss>;
  /** Jan 1 of end_date year (YTD period start). */
  yearStartDate: Scalars['ISO8601Date']['output'];
  /** YTD advisory fees per account. */
  ytdFeesByAccount: Array<PerformanceReportIntegratedYtdFeeRow>;
};

/** Beginning/Ending value, net additions, net gains and TWR for one period. */
export type PerformanceReportIntegratedActivitySummaryRow = {
  __typename?: 'PerformanceReportIntegratedActivitySummaryRow';
  /** Beginning market value incl. accrued interest. */
  beginningValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive period end. */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Ending market value incl. accrued interest. */
  endingValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Human label shown as the column header. */
  label: Scalars['String']['output'];
  /** Net cash flows (contributions − distributions). */
  netAdditions: Maybe<Scalars['BigDecimal']['output']>;
  /** Net gains: ending − beginning market value − net additions. */
  netGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Period key (quarter_to_date / year_to_date / previous_year / rolling_3_year / inception). */
  period: Scalars['String']['output'];
  /** Inclusive period start. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Time-weighted return as a fraction (annualized for >1yr). */
  timeWeightedReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single account's holdings, grouped by asset class on the frontend. */
export type PerformanceReportIntegratedPerAccountHoldingsSection = {
  __typename?: 'PerformanceReportIntegratedPerAccountHoldingsSection';
  /** Savvy account id. */
  accountId: Scalars['ID']['output'];
  /** Account display name. */
  accountName: Scalars['String']['output'];
  /** Masked account number. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** This account's holdings. */
  holdings: Array<HoldingsSummaryRow>;
  /** Account-level YTD time-weighted return fraction. */
  totalYtdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** Realized gain/loss line items for one period column. */
export type PerformanceReportIntegratedRealizedGainLossColumn = {
  __typename?: 'PerformanceReportIntegratedRealizedGainLossColumn';
  /** Gross long-term realized gain. */
  longTermGain: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross long-term realized loss (negative). */
  longTermLoss: Maybe<Scalars['BigDecimal']['output']>;
  /** Net long-term realized gain/loss. */
  longTermNet: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross short-term realized gain. */
  shortTermGain: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross short-term realized loss (negative). */
  shortTermLoss: Maybe<Scalars['BigDecimal']['output']>;
  /** Net short-term realized gain/loss. */
  shortTermNet: Maybe<Scalars['BigDecimal']['output']>;
  /** Total realized gain/loss. */
  total: Maybe<Scalars['BigDecimal']['output']>;
};

/** Ending value, net additions and period returns for one account (or the household total). */
export type PerformanceReportIntegratedReturnByAccountRow = {
  __typename?: 'PerformanceReportIntegratedReturnByAccountRow';
  /** Savvy account id, or "total" for the household roll-up. */
  accountId: Scalars['ID']['output'];
  /** Account display name (or household name for the total row). */
  accountName: Scalars['String']['output'];
  /** Masked account number. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** Ending market value in USD. */
  endingValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized since-inception TWR fraction. */
  inceptionReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Prior calendar year TWR fraction. */
  lastYearReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD net additions in USD. */
  netAdditions: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized rolling 3-year TWR fraction. */
  rollingThreeYearReturn: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date TWR fraction. */
  ytdReturn: Maybe<Scalars['BigDecimal']['output']>;
};

/** Taxable income line items for one period column. */
export type PerformanceReportIntegratedTaxableIncomeColumn = {
  __typename?: 'PerformanceReportIntegratedTaxableIncomeColumn';
  /** Ordinary dividends in USD. */
  dividends: Maybe<Scalars['BigDecimal']['output']>;
  /** Interest income in USD. */
  interest: Maybe<Scalars['BigDecimal']['output']>;
  /** Long-term capital gain distributions in USD. */
  longTermGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Sum of non-qualified income line items. */
  nonQualified: Maybe<Scalars['BigDecimal']['output']>;
  /** Qualified dividends in USD. */
  qualifiedDividends: Maybe<Scalars['BigDecimal']['output']>;
  /** Return of capital in USD. */
  returnOfCapital: Maybe<Scalars['BigDecimal']['output']>;
  /** Short-term capital gain distributions in USD. */
  shortTermGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Taxes withheld in USD. */
  taxesWithheld: Maybe<Scalars['BigDecimal']['output']>;
  /** Total taxable income in USD. */
  total: Maybe<Scalars['BigDecimal']['output']>;
};

/** Taxable income line items for the prior calendar year and YTD. */
export type PerformanceReportIntegratedTaxableIncomeSummary = {
  __typename?: 'PerformanceReportIntegratedTaxableIncomeSummary';
  /** Prior full-calendar-year column. */
  priorYear: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
  /** Dec 31 of the prior calendar year (column header). */
  priorYearEndDate: Scalars['ISO8601Date']['output'];
  /** Year-to-date column. */
  ytd: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
};

/** Realized gain/loss for the prior calendar year and YTD. */
export type PerformanceReportIntegratedTaxableRealizedGainLoss = {
  __typename?: 'PerformanceReportIntegratedTaxableRealizedGainLoss';
  /** Prior full-calendar-year column. */
  priorYear: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
  /** Dec 31 of the prior calendar year (column header). */
  priorYearEndDate: Scalars['ISO8601Date']['output'];
  /** Year-to-date column. */
  ytd: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
};

/** YTD advisory fees for a single account. */
export type PerformanceReportIntegratedYtdFeeRow = {
  __typename?: 'PerformanceReportIntegratedYtdFeeRow';
  /** Savvy account id. */
  accountId: Scalars['ID']['output'];
  /** Account display name. */
  accountName: Scalars['String']['output'];
  /** Masked account number. */
  accountNumberMasked: Maybe<Scalars['String']['output']>;
  /** YTD advisory fees in USD (negative). */
  fees: Maybe<Scalars['BigDecimal']['output']>;
};

/** Represents an activity summary for an Orion portfolio. */
export type PerformanceSummary = {
  __typename?: 'PerformanceSummary';
  advisoryFeesPaid: Maybe<Value>;
  beginningMarketValue: Maybe<Value>;
  contributions: Maybe<Value>;
  distributions: Maybe<Value>;
  dividendsAndInterest: Maybe<Value>;
  endDate: Scalars['ISO8601Date']['output'];
  endingMarketValue: Maybe<Value>;
  /** Market value increase/decrease for the window — the residual that reconciles the summary to ending market value. */
  marketValueChange: Maybe<Value>;
  netAdditions: Maybe<Value>;
  netGains: Maybe<Value>;
  startDate: Scalars['ISO8601Date']['output'];
  timePeriod: PerformanceTimePeriodName;
  /** Inbound account transfers (Merge In + Journal In) folded into contributions, signed positive. Null when unavailable. */
  transfersIn: Maybe<Value>;
  /** Outbound account transfers (Merge Out + Journal Out) folded into distributions, signed negative. Null when unavailable. */
  transfersOut: Maybe<Value>;
  twr: Maybe<Scalars['Float']['output']>;
};

export type PerformanceTimePeriodName =
  | 'all_time'
  | 'last_quarter'
  | 'past_month'
  | 'past_three_months'
  | 'past_year'
  | 'year_to_date';

/** Reporting periods covered by the Performance Report (Unified) summary table. */
export type PeriodEnum =
  /** all_time */
  | 'all_time'
  /** last_three_years */
  | 'last_three_years'
  /** past_year */
  | 'past_year'
  /** report_window */
  | 'report_window'
  /** year_to_date */
  | 'year_to_date';

/** Per-period total return for one series — used by both Account Performance and Performance vs Benchmark tables. */
export type PeriodReturnRow = {
  __typename?: 'PeriodReturnRow';
  /** Reporting period. */
  period: PeriodEnum;
  /**
   * Annualized time-weighted return over the period, expressed as a fraction (0.05
   * = 5%); equals the cumulative return for periods of one year or less. This is
   * the figure Orion shows in the Account Performance and Performance vs Benchmark
   * tables. Null when data is unavailable.
   */
  returnAnnualized: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return over the period, expressed as a fraction (0.05 = 5%); null when data is unavailable. */
  returnCumulative: Maybe<Scalars['BigDecimal']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** Type of personal account */
export type PersonalAccountTypeName =
  /** _529 */
  | '_529'
  /** brokerage */
  | 'brokerage'
  /** brokerage_with_margin */
  | 'brokerage_with_margin'
  /** schwab_one */
  | 'schwab_one'
  /** schwab_one_with_margin */
  | 'schwab_one_with_margin'
  /** trust */
  | 'trust';

export type PlaidProduct =
  /** Retrieve and verify bank account information. */
  | 'auth'
  /** View holding and transactions from investment accounts. */
  | 'investments'
  /** Retrieve up to 24 months of transaction data from accounts. */
  | 'transactions';

export type PlanFinancialSnapshot = {
  __typename?: 'PlanFinancialSnapshot';
  /** Snapshot as-of date */
  asOfDate: Scalars['ISO8601Date']['output'];
  /** Plan assets in dollars */
  assets: Maybe<Scalars['Float']['output']>;
  /** Plan assets stored as integer cents */
  assetsCents: Maybe<Scalars['BigInt']['output']>;
  /** When the snapshot was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Number of participants */
  participantCount: Maybe<Scalars['Int']['output']>;
  /** Quarter period (e.g. 2026-Q1) */
  period: Scalars['String']['output'];
  /** Entry source: manual | import */
  source: Scalars['String']['output'];
  /** When the snapshot was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Plan Review (Investments, Fees, Plan Health) variant */
export type PlanReviewInput = {
  /** Plan name (household name when a household is selected, else free text) */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** Plan sponsor meeting date */
  planSponsorMeetingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Recordkeeper */
  recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Review kinds — at least one required */
  reviewTypes: Array<CorporateRetirementPlanReviewTypeName>;
  /** Specific focus areas */
  specificFocusAreas?: InputMaybe<Scalars['String']['input']>;
  /** Target delivery date */
  targetDeliveryDate: Scalars['ISO8601Date']['input'];
};

/**
 * An account held as an asset. A row whose kind is credit or loan becomes a
 * liability instead: every account kind here is an asset.
 */
export type PlanningAccount = {
  __typename?: 'PlanningAccount';
  /** The Savvy record this came from. */
  accountId: Scalars['String']['output'];
  /** Who inherits it. */
  beneficiaries: Maybe<PlanningBeneficiaries>;
  /** The current balance in dollars. */
  currentBalance: Scalars['BigDecimal']['output'];
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The fields specific to this kind of account. */
  details: PlanningAccountDetails;
  /** The engine's identifier for this account. */
  externalId: Maybe<Scalars['String']['output']>;
  /** The income contributions are taken from, when they are linked to one. */
  linkToIncome: Maybe<PlanningLinkToIncome>;
  /** Who owns it. */
  owners: PlanningOwners;
  /** The provider this account is synced from. Null when we own the row. */
  source: Maybe<PlanningAccountSource>;
  /** What kind of account it is. Derived from the details, so a kind and the fields it implies cannot disagree. */
  type: PlanningAccountType;
};

/** The fields only one kind of account has. The account kind is derived from this rather than stored beside it. */
export type PlanningAccountDetails = PlanningAccountDetailsBank | PlanningAccountDetailsEmployerRetirement | PlanningAccountDetailsHsa | PlanningAccountDetailsIra | PlanningAccountDetailsNonQualified | PlanningAccountDetailsPlan529 | PlanningAccountDetailsRoth;

/** A cash account. The only variant with an interest rate rather than a portfolio. */
export type PlanningAccountDetailsBank = {
  __typename?: 'PlanningAccountDetailsBank';
  /** Recurring contributions in. */
  contributions: Maybe<Array<PlanningScheduledContribution>>;
  /** Annual interest, as a whole-number percentage. */
  interestRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether this account is drawn on first to cover a shortfall. */
  prioritizeDeficitCoverage: Maybe<Scalars['Boolean']['output']>;
  /** Which kind of cash account. */
  type: PlanningBankType;
  /** When the balance was assessed. */
  valuationDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** An employer-sponsored plan: a 401(k) or a 403(b). */
export type PlanningAccountDetailsEmployerRetirement = {
  __typename?: 'PlanningAccountDetailsEmployerRetirement';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  applyTenYearRule: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  contributions: Maybe<PlanningEmployerPlanContributions>;
  /** The basis in dollars, when known. */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether required minimum distributions are delayed. */
  delayRmds: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
  /** Last year's closing value, which RMDs are calculated from. */
  previousEoyMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Which kind of employer plan. */
  type: PlanningEmployerRetirementType;
};

/** A health savings account. No cost basis, for the same reason as a Roth. */
export type PlanningAccountDetailsHsa = {
  __typename?: 'PlanningAccountDetailsHsa';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  contributions: Maybe<PlanningHsaContributions>;
  /** Whether the employer sponsors the account. */
  employerSponsored: Maybe<Scalars['Boolean']['output']>;
  /** Whether coverage is family rather than single, which sets the contribution limit. */
  familyCoverage: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
};

/** A traditional IRA. Alone among the retirement shapes it asks about work-plan coverage, which is what decides deductibility. */
export type PlanningAccountDetailsIra = {
  __typename?: 'PlanningAccountDetailsIra';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  applyTenYearRule: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  contributions: Maybe<PlanningTaxAdvantagedContributions>;
  /** The basis in dollars, when known. */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether required minimum distributions are delayed. */
  delayRmds: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
  /** Last year's closing value, which RMDs are calculated from. */
  previousEoyMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Who is covered by a work-based plan, when either is. */
  workPlanCoverage: Maybe<PlanningWorkPlanCoverage>;
};

/** A taxable brokerage account. The only variant that asks where interest and dividends go. */
export type PlanningAccountDetailsNonQualified = {
  __typename?: 'PlanningAccountDetailsNonQualified';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  applyTenYearRule: Maybe<Scalars['Boolean']['output']>;
  /** Recurring contributions in. */
  contributions: Maybe<Array<PlanningScheduledContribution>>;
  /** The basis in dollars, when known. */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether interest and dividends are paid out to cashflow rather than reinvested. */
  distributeToCashflow: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** Whether the balance is held back from covering a shortfall. */
  holdBackFromDeficitCoverage: Maybe<Scalars['Boolean']['output']>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
};

/** A 529 education savings account. */
export type PlanningAccountDetailsPlan529 = {
  __typename?: 'PlanningAccountDetailsPlan529';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  applyTenYearRule: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  contributions: Maybe<PlanningTaxAdvantagedContributions>;
  /** The basis in dollars, when known. */
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
};

/** A Roth IRA. No cost basis: the balance is already after tax. */
export type PlanningAccountDetailsRoth = {
  __typename?: 'PlanningAccountDetailsRoth';
  /** Whether the plan may reallocate it. */
  allowReallocation: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  applyTenYearRule: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  contributions: Maybe<PlanningTaxAdvantagedContributions>;
  /** External fees, when any are charged. */
  fees: Maybe<PlanningAccountFees>;
  /** The model portfolio it is invested in. */
  portfolio: Maybe<PlanningPortfolio>;
};

/** External account fees. The rate is a percentage, not a cash amount. */
export type PlanningAccountFees = {
  __typename?: 'PlanningAccountFees';
  /** The annual fee rate, as a whole-number percentage. */
  annualPercentage: Maybe<Scalars['BigDecimal']['output']>;
  /** How often the fee is charged. */
  frequency: Maybe<PlanningFeeFrequency>;
};

/** Which external provider a row is synced from. Absent when the row is ours. */
export type PlanningAccountSource =
  /** MONEYKIT */
  | 'MONEYKIT'
  /** ORION */
  | 'ORION'
  /** PLAID */
  | 'PLAID';

/** What kind of account this is. Derived from the details rather than stored beside them, so the two cannot disagree. */
export type PlanningAccountType =
  /** brokerage */
  | 'brokerage'
  /** certificate_of_deposit */
  | 'certificate_of_deposit'
  /** checking */
  | 'checking'
  /** hsa */
  | 'hsa'
  /** ira */
  | 'ira'
  /** money_market */
  | 'money_market'
  /** other_bank */
  | 'other_bank'
  /** plan_529 */
  | 'plan_529'
  /** retirement_401k */
  | 'retirement_401k'
  /** retirement_403b */
  | 'retirement_403b'
  /** roth_ira */
  | 'roth_ira'
  /** savings */
  | 'savings';

/** The person is already retired, so there is no future retirement date. */
export type PlanningAlreadyRetired = {
  __typename?: 'PlanningAlreadyRetired';
  /** Always true. Present because GraphQL object types cannot be empty. */
  isAlreadyRetired: Scalars['Boolean']['output'];
};

/** Whether a money figure was entered per period or as an annual total */
export type PlanningAmountBasis =
  /** annual */
  | 'annual'
  /** per_period */
  | 'per_period';

/** Anything the household owns: an account, a lifestyle asset, an equity incentive, or a rental property. */
export type PlanningAsset = PlanningAccount | PlanningEquityIncentive | PlanningLifestyleAsset | PlanningRentalProperty;

/** The kind of cash account: checking, savings, money market, CD, or other. */
export type PlanningBankType =
  /** certificate_of_deposit */
  | 'certificate_of_deposit'
  /** checking */
  | 'checking'
  /** money_market */
  | 'money_market'
  /** other_bank */
  | 'other_bank'
  /** savings */
  | 'savings';

/** Whether a deferral is taken before or after tax. */
export type PlanningBeforeOrAfterTax =
  /** after_tax */
  | 'after_tax'
  /** before_tax */
  | 'before_tax';

/** How an account names its beneficiaries. */
export type PlanningBeneficiaries = PlanningBeneficiariesMultiple | PlanningBeneficiariesPrimaryAndContingent;

/** A list of named beneficiaries with no designation, the shape a 529 uses. */
export type PlanningBeneficiariesMultiple = {
  __typename?: 'PlanningBeneficiariesMultiple';
  /** The named beneficiaries. */
  members: Maybe<Array<PlanningNamedBeneficiary>>;
};

/** A primary and a contingent designation, the shape most account types use. */
export type PlanningBeneficiariesPrimaryAndContingent = {
  __typename?: 'PlanningBeneficiariesPrimaryAndContingent';
  /** The contingent beneficiary, which defaults to the estate. */
  contingent: Maybe<PlanningBeneficiaryPerson>;
  /** The primary beneficiary. */
  primary: Maybe<PlanningBeneficiaryPerson>;
};

/** A household member. */
export type PlanningBeneficiaryClient = {
  __typename?: 'PlanningBeneficiaryClient';
  /** The household member named as beneficiary. */
  clientProfileId: Maybe<Scalars['String']['output']>;
};

/** A dependant. */
export type PlanningBeneficiaryDependant = {
  __typename?: 'PlanningBeneficiaryDependant';
  /** The Savvy contact named as beneficiary. */
  contactId: Maybe<Scalars['String']['output']>;
};

/** The client's estate rather than a person. */
export type PlanningBeneficiaryEstate = {
  __typename?: 'PlanningBeneficiaryEstate';
  /** Always true. Present because GraphQL object types cannot be empty. */
  isEstate: Scalars['Boolean']['output'];
};

/** Who a beneficiary designation names. */
export type PlanningBeneficiaryPerson = PlanningBeneficiaryClient | PlanningBeneficiaryDependant | PlanningBeneficiaryEstate;

/** What a cash-reserve target is measured against. */
export type PlanningCashReserveBasis =
  /** custom_amount */
  | 'custom_amount'
  /** monthly_expenses */
  | 'monthly_expenses'
  /** monthly_salary */
  | 'monthly_salary';

/** Whether contributions are a percentage of salary or fixed dollar amounts. */
export type PlanningContributionBasis = PlanningContributionBasisAmount | PlanningContributionBasisPercent;

/** Contributions as fixed dollar amounts, each indexed separately. */
export type PlanningContributionBasisAmount = {
  __typename?: 'PlanningContributionBasisAmount';
  /** Employee contribution in dollars. */
  employeeDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the employee amount grows. */
  employeeIndexation: Maybe<PlanningIndexation>;
  /** Employer contribution in dollars. */
  employerDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the employer amount grows. */
  employerIndexation: Maybe<PlanningIndexation>;
};

/** Contributions as a percentage of salary. A percentage of a growing salary re-bases itself, so there is no indexation here. */
export type PlanningContributionBasisPercent = {
  __typename?: 'PlanningContributionBasisPercent';
  /** Employee contribution, as a whole-number percentage of salary. */
  employeePercentage: Maybe<Scalars['BigDecimal']['output']>;
  /** Employer contribution, as a whole-number percentage of salary. */
  employerPercentage: Maybe<Scalars['BigDecimal']['output']>;
};

/** How often a contribution is made */
export type PlanningContributionFrequency =
  /** annually */
  | 'annually'
  /** bimonthly */
  | 'bimonthly'
  /** monthly */
  | 'monthly'
  /** one_time */
  | 'one_time'
  /** quarterly */
  | 'quarterly'
  /** semi_annually */
  | 'semi_annually';

/** A depreciation basis with no fixed period — land, building or qualified improvement property. */
export type PlanningCostPool = {
  __typename?: 'PlanningCostPool';
  /** Depreciation already claimed, split by owner. */
  accumulatedDepreciation: Maybe<Array<PlanningPerOwnerAmount>>;
  /** The original cost in dollars. */
  originalCost: Maybe<Scalars['BigDecimal']['output']>;
};

/** When something starts or stops: a date, a plan event, or an age. */
export type PlanningDateBoundary = PlanningDateBoundaryAtAge | PlanningDateBoundaryAtEvent | PlanningDateBoundaryOnDate;

/** A boundary at a household member's age. */
export type PlanningDateBoundaryAtAge = {
  __typename?: 'PlanningDateBoundaryAtAge';
  /** The age in years. */
  age: Maybe<Scalars['Int']['output']>;
};

/** A boundary that moves with a named plan event. */
export type PlanningDateBoundaryAtEvent = {
  __typename?: 'PlanningDateBoundaryAtEvent';
  /** The event it hangs off. */
  event: Maybe<PlanningPlanEvent>;
};

/** A boundary fixed to a calendar date. */
export type PlanningDateBoundaryOnDate = {
  __typename?: 'PlanningDateBoundaryOnDate';
  /** The date. */
  date: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A dependant of the household. */
export type PlanningDependant = {
  __typename?: 'PlanningDependant';
  /** Date of birth. */
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The Savvy contact this came from. */
  contactId: Scalars['String']['output'];
  /** Which household members the dependant belongs to. */
  dependentOf: Maybe<PlanningOwners>;
  /** The engine's identifier for this dependant. */
  externalId: Maybe<Scalars['String']['output']>;
  /** First name. */
  firstName: Scalars['String']['output'];
  /** Last name. */
  lastName: Maybe<Scalars['String']['output']>;
  /** How they relate to the household. */
  relationship: Maybe<PlanningDependantRelationship>;
  /** State of residence. */
  state: Maybe<StateCode>;
};

/** How a dependant relates to the household */
export type PlanningDependantRelationship =
  /** child */
  | 'child'
  /** extended_family_member */
  | 'extended_family_member'
  /** grandchild */
  | 'grandchild'
  /** grandparent */
  | 'grandparent'
  /** other */
  | 'other'
  /** parent */
  | 'parent';

/** A depreciation basis that runs over a fixed number of years, such as appliances and furniture. */
export type PlanningDepreciablePool = {
  __typename?: 'PlanningDepreciablePool';
  /** Depreciation already claimed, split by owner. */
  accumulatedDepreciation: Maybe<Array<PlanningPerOwnerAmount>>;
  /** How many years the basis depreciates over. */
  depreciationPeriodYears: Maybe<Scalars['Int']['output']>;
  /** The original cost in dollars. */
  originalCost: Maybe<Scalars['BigDecimal']['output']>;
};

/** How much goes into an employer plan: an elected level, or the maximum. */
export type PlanningEmployerPlanContributions = PlanningEmployerPlanContributionsElected | PlanningEmployerPlanContributionsMaxOut;

/** A chosen contribution level, as a percentage of salary or a dollar amount. */
export type PlanningEmployerPlanContributionsElected = {
  __typename?: 'PlanningEmployerPlanContributionsElected';
  /** Whether the contribution is a percentage of salary or a dollar amount. */
  contributionBasis: Maybe<PlanningContributionBasis>;
  /** Whether the deferral is taken before or after tax. */
  deferralTaxTreatment: Maybe<PlanningBeforeOrAfterTax>;
  /** When contributions stop. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** When contributions start. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** Contribute the statutory maximum. Carries no deferral tax treatment, unlike the tax-advantaged max-out. */
export type PlanningEmployerPlanContributionsMaxOut = {
  __typename?: 'PlanningEmployerPlanContributionsMaxOut';
  /** When contributions stop. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** When contributions start. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** Which employer-sponsored retirement plan this is. */
export type PlanningEmployerRetirementType =
  /** retirement_401k */
  | 'retirement_401k'
  /** retirement_403b */
  | 'retirement_403b';

/** An equity grant, its vesting schedule, and any exercises and sales against it. */
export type PlanningEquityIncentive = {
  __typename?: 'PlanningEquityIncentive';
  /** The primary and contingent designation. Equity never uses the multi-beneficiary shape. */
  beneficiaries: Maybe<PlanningBeneficiariesPrimaryAndContingent>;
  /** A free-text label. */
  description: Maybe<Scalars['String']['output']>;
  /** Exercises against the grant. */
  exercises: Maybe<Array<PlanningExercise>>;
  /** When the options expire. */
  expiry: Maybe<Scalars['ISO8601Date']['output']>;
  /** The engine's identifier for this grant. */
  externalId: Maybe<Scalars['String']['output']>;
  /** When it was granted. */
  grantDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** How many options the grant covers. */
  options: Maybe<Scalars['BigDecimal']['output']>;
  /** Who holds the grant. */
  owners: Maybe<PlanningOwners>;
  /** Assumed annual return, as a whole-number percentage. */
  returnRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Sales of exercised shares. */
  sales: Maybe<Array<PlanningShareSale>>;
  /** The strike price. */
  strikePrice: Maybe<Scalars['BigDecimal']['output']>;
  /** The kind of grant. */
  type: PlanningEquityIncentiveType;
  /** The current unit price. */
  unitPrice: Maybe<Scalars['BigDecimal']['output']>;
  /** When the unit price was assessed. */
  unitPriceValuation: Maybe<Scalars['ISO8601Date']['output']>;
  /** How the grant vests. */
  vesting: Maybe<PlanningVesting>;
};

/** The kind of equity grant */
export type PlanningEquityIncentiveType =
  /** incentive_stock_options */
  | 'incentive_stock_options'
  /** nonqualified_stock_options */
  | 'nonqualified_stock_options'
  /** restricted_stock */
  | 'restricted_stock';

/** An exercise of vested options. */
export type PlanningExercise = {
  __typename?: 'PlanningExercise';
  /** Past or planned. */
  detail: Maybe<PlanningExerciseDetail>;
  /** Whether every vested option was exercised. */
  exercisedAllVested: Maybe<Scalars['Boolean']['output']>;
  /** How many shares were exercised. */
  numberOfShares: Maybe<Scalars['BigDecimal']['output']>;
};

/** A past or planned exercise. The two carry genuinely different fields. */
export type PlanningExerciseDetail = PlanningExerciseFuture | PlanningExercisePast;

/** A planned exercise, which carries an intent and a schedule rather than a price. */
export type PlanningExerciseFuture = {
  __typename?: 'PlanningExerciseFuture';
  /** Whether the shares are held or sold. */
  intent: Maybe<PlanningFutureExerciseIntent>;
  /** When it is planned for. */
  schedule: Maybe<PlanningOccurrence>;
};

/** An exercise that has already happened, so it carries what was paid rather than an intent. */
export type PlanningExercisePast = {
  __typename?: 'PlanningExercisePast';
  /** When it was exercised. */
  exercisedOn: Maybe<PlanningDateBoundary>;
  /** Whether the resulting shares are still held. */
  sharesStillHeld: Maybe<Scalars['Boolean']['output']>;
  /** The unit price paid. */
  unitPrice: Maybe<Scalars['BigDecimal']['output']>;
};

/** A plan expense. */
export type PlanningExpense = {
  __typename?: 'PlanningExpense';
  /** Whether it is deductible above the line. */
  aboveTheLineDeduction: Maybe<Scalars['Boolean']['output']>;
  /** Whether the amount is per period or already annual. */
  amountBasis: Maybe<PlanningAmountBasis>;
  /** The amount restated annually. Null for a one-time expense, which has no annual rate. */
  annualDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** A free-text label. */
  description: Maybe<Scalars['String']['output']>;
  /** The amount in dollars, as entered. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** When it stops. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this expense. */
  externalId: Maybe<Scalars['String']['output']>;
  /** How often it recurs. */
  frequency: Maybe<PlanningExpenseFrequency>;
  /** How the amount grows. */
  indexation: Maybe<PlanningIndexation>;
  /** Who the expense belongs to. */
  owners: Maybe<PlanningOwners>;
  /** When it starts. */
  startsOn: Maybe<PlanningDateBoundary>;
  /** What kind of expense it is. */
  type: PlanningExpenseType;
};

/** How often an expense recurs. */
export type PlanningExpenseFrequency = PlanningExpenseFrequencyEvery | PlanningExpenseFrequencyEveryNYears;

/** An expense on one of the standard cashflow periods. */
export type PlanningExpenseFrequencyEvery = {
  __typename?: 'PlanningExpenseFrequencyEvery';
  /** The period. */
  period: Maybe<PlanningFrequency>;
};

/** An expense that recurs on a multi-year cycle, which the standard periods cannot express. */
export type PlanningExpenseFrequencyEveryNYears = {
  __typename?: 'PlanningExpenseFrequencyEveryNYears';
  /** The number of years between occurrences. */
  years: Maybe<Scalars['Int']['output']>;
};

/** What kind of expense this is */
export type PlanningExpenseType =
  /** alimony */
  | 'alimony'
  /** carrying_charges_and_interest */
  | 'carrying_charges_and_interest'
  /** charitable_donation */
  | 'charitable_donation'
  /** child_support */
  | 'child_support'
  /** discretionary */
  | 'discretionary'
  /** medical */
  | 'medical'
  /** necessity */
  | 'necessity'
  /** other_deductible_amounts */
  | 'other_deductible_amounts'
  /** self_employment_business */
  | 'self_employment_business';

/** How often a fee is charged */
export type PlanningFeeFrequency =
  /** annually */
  | 'annually'
  /** bimonthly */
  | 'bimonthly'
  /** monthly */
  | 'monthly'
  /** quarterly */
  | 'quarterly'
  /** semi_annually */
  | 'semi_annually';

/** How often a cashflow recurs */
export type PlanningFrequency =
  /** annually */
  | 'annually'
  /** bimonthly */
  | 'bimonthly'
  /** biweekly */
  | 'biweekly'
  /** daily */
  | 'daily'
  /** monthly */
  | 'monthly'
  /** one_time */
  | 'one_time'
  /** quarterly */
  | 'quarterly'
  /** semi_annually */
  | 'semi_annually'
  /** twice_monthly */
  | 'twice_monthly'
  /** weekly */
  | 'weekly';

/** Whether a planned exercise holds or sells the shares */
export type PlanningFutureExerciseIntent =
  /** exercise_and_hold */
  | 'exercise_and_hold'
  /** exercise_to_sell */
  | 'exercise_to_sell'
  /** sell_to_cover */
  | 'sell_to_cover';

/** Something the household is saving for, and also the retirement and moves the plan is built around. */
export type PlanningGoal = {
  __typename?: 'PlanningGoal';
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The fields specific to what the goal is for. */
  details: Maybe<PlanningGoalDetails>;
  /** The engine's identifier for this goal. */
  externalId: Maybe<Scalars['String']['output']>;
  /** Whose goal it is. */
  owners: Maybe<PlanningOwners>;
  /** How it is tracking against its funding. */
  status: Maybe<PlanningGoalStatus>;
  /** What the goal is for. */
  type: PlanningGoalType;
};

/**
 * Where the money for a goal comes from. Nothing checks that the lines add up to
 * the goal's cost — a partly funded goal is the normal case, not an error.
 */
export type PlanningGoalAllocations = {
  __typename?: 'PlanningGoalAllocations';
  /** Whether the engine may cover the rest from investments and surplus cashflow. */
  automaticallyUseInvestmentsAndCashFlow: Maybe<Scalars['Boolean']['output']>;
  /** Funded from cash, in dollars. */
  bankAccountDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Funded by borrowing, in dollars. */
  lineOfCreditDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Funded from taxable accounts, in dollars. */
  nonQualifiedDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Funded from qualified accounts, split by owner. */
  qualifiedPerOwner: Maybe<Array<PlanningPerOwnerAmount>>;
  /** Funded from Roth accounts, in dollars. */
  rothDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
};

/** The fields specific to what a goal is for. */
export type PlanningGoalDetails = PlanningGoalDetailsCashReserve | PlanningGoalDetailsOneOffExpense | PlanningGoalDetailsResidence | PlanningGoalDetailsRetirement;

/** An emergency fund, measured against salary, expenses, or a figure typed in. */
export type PlanningGoalDetailsCashReserve = {
  __typename?: 'PlanningGoalDetailsCashReserve';
  /** What the target is measured against. */
  basis: Maybe<PlanningCashReserveBasis>;
  /** The plan-side accounts holding the reserve, so one spread over two names both. */
  fundedByAccountRefs: Maybe<Array<Scalars['String']['output']>>;
  /** How much of the reserve is a line of credit rather than cash. */
  fundedByLineOfCreditDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the target grows. */
  indexation: Maybe<PlanningIndexation>;
  /** How many months of the basis to hold. It multiplies salary or expenses; the target stands alone on a custom amount. */
  months: Maybe<Scalars['Int']['output']>;
  /** The target in dollars. */
  targetDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single cost at a point in time. Several goal types share this shape, so the goal's type is what tells them apart. */
export type PlanningGoalDetailsOneOffExpense = {
  __typename?: 'PlanningGoalDetailsOneOffExpense';
  /** Where the money comes from. */
  allocations: Maybe<PlanningGoalAllocations>;
  /** What it costs, in dollars. */
  costDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the cost grows before it is spent. */
  indexation: Maybe<PlanningIndexation>;
  /** When it happens. */
  occursOn: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * Buying a home. Repeats four of the one-off fields rather than extending them: a
 * sealed union cannot share a base, and only a residence appreciates.
 */
export type PlanningGoalDetailsResidence = {
  __typename?: 'PlanningGoalDetailsResidence';
  /** Where the money comes from. */
  allocations: Maybe<PlanningGoalAllocations>;
  /** What it costs, in dollars. */
  costDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the property appreciates once owned, as a whole-number percentage. */
  growthRate: Maybe<Scalars['BigDecimal']['output']>;
  /** How the cost grows before it is spent. */
  indexation: Maybe<PlanningIndexation>;
  /** When it is bought. */
  occursOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether it becomes the principal residence. */
  principalResidence: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One goal per member: whose retirement this is comes from the goal's owners, so a
 * couple has two and neither is the other's co-client.
 */
export type PlanningGoalDetailsRetirement = {
  __typename?: 'PlanningGoalDetailsRetirement';
  /** When the member retires. */
  retires: Maybe<PlanningMemberRetirement>;
};

/** How the goal is tracking against its funding. */
export type PlanningGoalStatus =
  /** at_risk */
  | 'at_risk'
  /** funded */
  | 'funded'
  /** not_started */
  | 'not_started'
  /** on_track */
  | 'on_track';

/** What the goal is for. Several types share one details shape, so this is what tells them apart. */
export type PlanningGoalType =
  /** cash_reserve */
  | 'cash_reserve'
  /** major_expense */
  | 'major_expense'
  /** personal_property */
  | 'personal_property'
  /** recurring_expense */
  | 'recurring_expense'
  /** residence */
  | 'residence'
  /** retirement */
  | 'retirement'
  /** vacation */
  | 'vacation'
  /** vehicle */
  | 'vehicle'
  /** wedding */
  | 'wedding';

/** A person in the household — the client or the co-client. */
export type PlanningHouseholdMember = {
  __typename?: 'PlanningHouseholdMember';
  /** Date of birth. */
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The Savvy client profile this came from. */
  clientProfileId: Scalars['String']['output'];
  /** Estimated age at death, when overridden. */
  deathAgeEstimated: Maybe<Scalars['Int']['output']>;
  /** Employers, for linking income to accounts. */
  employers: Maybe<Array<Scalars['String']['output']>>;
  /** The engine's identifier for this person. */
  externalId: Maybe<Scalars['String']['output']>;
  /** First name. */
  firstName: Scalars['String']['output'];
  /** Whether the person has a disability. */
  hasDisability: Maybe<Scalars['Boolean']['output']>;
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** Sex at birth, which drives mortality assumptions. */
  sexAtBirth: Maybe<PlanningSexAtBirth>;
  /** State of residence. */
  state: Maybe<StateCode>;
  /** Filing status. */
  taxStatus: Maybe<PlanningTaxStatus>;
};

/** How an HSA is funded: a self-funded amount, or the annual limit. */
export type PlanningHsaContributions = PlanningHsaContributionsMaxOut | PlanningHsaContributionsSelfFunded;

/** Contribute the annual limit. Bounded by tax year rather than by date, because the limit is annual. */
export type PlanningHsaContributionsMaxOut = {
  __typename?: 'PlanningHsaContributionsMaxOut';
  /** Last tax year to contribute in. */
  endTaxYear: Maybe<Scalars['Int']['output']>;
  /** The plan-side account the money comes from, when one is named. */
  sourceAccountRef: Maybe<Scalars['String']['output']>;
  /** First tax year to contribute in. */
  startTaxYear: Maybe<Scalars['Int']['output']>;
};

/** A flat amount the household pays in itself. */
export type PlanningHsaContributionsSelfFunded = {
  __typename?: 'PlanningHsaContributionsSelfFunded';
  /** The amount in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
};

/** A plan income. */
export type PlanningIncome = {
  __typename?: 'PlanningIncome';
  /** A free-text label. */
  description: Maybe<Scalars['String']['output']>;
  /** The kind-specific details. */
  details: Maybe<PlanningIncomeDetails>;
  /** The engine's identifier for this income. */
  externalId: Maybe<Scalars['String']['output']>;
  /** The Savvy record this came from. */
  incomeSourceId: Scalars['String']['output'];
  /** Who receives it. */
  owners: PlanningOwners;
  /** What kind of income it is. */
  type: PlanningIncomeType;
};

/** A defined benefit pension. */
export type PlanningIncomeDefinedBenefitPension = {
  __typename?: 'PlanningIncomeDefinedBenefitPension';
  /** The IRC 7520 rate used for estate valuation, as a whole-number percentage. */
  irc7520Rate: Maybe<Scalars['BigDecimal']['output']>;
  /** The share payable to a survivor, as a whole-number percentage. */
  payableToSurvivor: Maybe<Scalars['BigDecimal']['output']>;
  /** When payments start. */
  paymentStartsOn: Maybe<PlanningDateBoundary>;
  /** Lifetime income or a lump sum. */
  payout: Maybe<PlanningPensionPayout>;
  /** Primary benefit indexation, as a whole-number percentage. */
  primaryBenefitIndexation: Maybe<Scalars['BigDecimal']['output']>;
  /** The monthly primary benefit in dollars. */
  primaryBenefitMonthlyDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * The details of an income. The three kinds carry genuinely different fields,
 * which is why this is a union rather than one flat type.
 */
export type PlanningIncomeDetails = PlanningIncomeDefinedBenefitPension | PlanningIncomeSocialSecurity | PlanningIncomeStandard;

/** Social Security, which carries a retirement benefit and a survivor benefit rather than a plain amount. */
export type PlanningIncomeSocialSecurity = {
  __typename?: 'PlanningIncomeSocialSecurity';
  /** The retirement benefit. */
  retirement: Maybe<PlanningSocialSecurityRetirement>;
  /** The survivor benefit. */
  survivor: Maybe<PlanningSurvivorBenefit>;
};

/** Ordinary income: an amount on a schedule, with boundaries and indexation. */
export type PlanningIncomeStandard = {
  __typename?: 'PlanningIncomeStandard';
  /** Whether the amount is per period or already annual. */
  amountBasis: Maybe<PlanningAmountBasis>;
  /** The amount restated annually. Null for one-time income, which has no annual rate. */
  annualDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** The amount in dollars, as entered. */
  dollarAmount: Scalars['BigDecimal']['output'];
  /** When it stops. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** Whether the income is exempt from Social Security tax. */
  excludeFromSocialSecurityTax: Maybe<Scalars['Boolean']['output']>;
  /** How often it is received. */
  frequency: PlanningFrequency;
  /** How the amount grows. */
  indexation: Maybe<PlanningIndexation>;
  /** When it starts. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** What kind of income this is */
export type PlanningIncomeType =
  /** bonus */
  | 'bonus'
  /** capital_gains */
  | 'capital_gains'
  /** defined_benefit_pension */
  | 'defined_benefit_pension'
  /** dividends */
  | 'dividends'
  /** gratuities */
  | 'gratuities'
  /** interest */
  | 'interest'
  /** other_taxable */
  | 'other_taxable'
  /** salary */
  | 'salary'
  /** self_employment */
  | 'self_employment'
  /** social_security */
  | 'social_security'
  /** tax_free */
  | 'tax_free';

/** Plan-wide index rates. Unrelated to the per-item additional index rate on incomes and expenses. */
export type PlanningIndexRates = {
  __typename?: 'PlanningIndexRates';
  /** Federal indexation, as a whole-number percentage. */
  federalIndexation: Maybe<Scalars['BigDecimal']['output']>;
  /** Plan inflation, as a whole-number percentage. */
  planInflation: Maybe<Scalars['BigDecimal']['output']>;
  /** State indexation, as a whole-number percentage. */
  stateIndexation: Maybe<Scalars['BigDecimal']['output']>;
  /** Wage-related indexation, as a whole-number percentage. */
  wageRelatedIndexation: Maybe<Scalars['BigDecimal']['output']>;
};

/** How a money figure grows over the life of the plan. */
export type PlanningIndexation = {
  __typename?: 'PlanningIndexation';
  /** Growth on top of inflation, as a whole-number percentage. */
  additionalRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether the figure tracks plan inflation. */
  toInflation: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A debt. It can come from our liabilities table or from an accounts row whose
 * kind is credit or loan, which is why its reference names the table too.
 */
export type PlanningLiability = {
  __typename?: 'PlanningLiability';
  /** Annual interest, as a whole-number percentage. */
  annualInterestPercentage: Maybe<Scalars['BigDecimal']['output']>;
  /** When the balance was assessed. */
  balanceAsOfDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The outstanding balance in dollars. */
  balanceOwingDollarAmount: Scalars['BigDecimal']['output'];
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The engine's identifier for this debt. */
  externalId: Maybe<Scalars['String']['output']>;
  /** Whether the interest is deductible. */
  interestIsTaxDeductible: Maybe<Scalars['Boolean']['output']>;
  /** Who owes it. */
  owners: PlanningOwners;
  /** How the debt is serviced. */
  payment: Maybe<PlanningLiabilityPayment>;
  /** The Savvy row this came from. */
  savvyRef: PlanningSavvyRef;
  /** The provider this debt is synced from, for the accounts rows. Null for a liabilities row, which only we write. */
  source: Maybe<PlanningAccountSource>;
  /** What kind of debt it is. */
  type: PlanningLiabilityType;
};

/** Which side of the amortisation is given: the term or the payment. */
export type PlanningLiabilityAmortisation = PlanningLiabilityAmortisationPayment | PlanningLiabilityAmortisationTerm;

/** Amortised from a fixed payment, with the term falling out of it. */
export type PlanningLiabilityAmortisationPayment = {
  __typename?: 'PlanningLiabilityAmortisationPayment';
  /** The payment in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
};

/** Amortised over a fixed number of years, with the payment falling out of it. */
export type PlanningLiabilityAmortisationTerm = {
  __typename?: 'PlanningLiabilityAmortisationTerm';
  /** The term in years. */
  years: Maybe<Scalars['Int']['output']>;
};

/** How the debt is serviced: interest only, or principal and interest. */
export type PlanningLiabilityPayment = PlanningLiabilityPaymentInterestOnly | PlanningLiabilityPaymentPrincipalAndInterest;

/** Interest is serviced and the principal is not repaid. */
export type PlanningLiabilityPaymentInterestOnly = {
  __typename?: 'PlanningLiabilityPaymentInterestOnly';
  /** A credit limit on a revolving debt, a payment on a loan. The liability type decides which. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How often the payment is made. */
  paymentFrequency: Maybe<PlanningFrequency>;
};

/** The debt amortises: each payment covers interest and reduces the principal. */
export type PlanningLiabilityPaymentPrincipalAndInterest = {
  __typename?: 'PlanningLiabilityPaymentPrincipalAndInterest';
  /** Whether the term or the payment is the given side. */
  calculateBy: Maybe<PlanningLiabilityAmortisation>;
  /** How often interest compounds. */
  compoundFrequency: Maybe<PlanningFrequency>;
  /** How often the payment is made. */
  paymentFrequency: Maybe<PlanningFrequency>;
};

/** What kind of debt this is. It is also what decides whether the interest-only amount reads as a credit limit or as a payment. */
export type PlanningLiabilityType =
  /** auto */
  | 'auto'
  /** business_loan */
  | 'business_loan'
  /** credit_card */
  | 'credit_card'
  /** line_of_credit */
  | 'line_of_credit'
  /** mortgage */
  | 'mortgage'
  /** other */
  | 'other'
  /** personal_loan */
  | 'personal_loan'
  /** reverse_mortgage */
  | 'reverse_mortgage'
  /** student_loan */
  | 'student_loan';

/** How long the plan assumes each member lives. */
export type PlanningLifeExpectancy = {
  __typename?: 'PlanningLifeExpectancy';
  /** The client's life expectancy in years. */
  clientAge: Maybe<Scalars['Int']['output']>;
  /** The co-client's life expectancy in years. */
  coClientAge: Maybe<Scalars['Int']['output']>;
};

/** A real asset the household lives with rather than rents out. */
export type PlanningLifestyleAsset = PlanningRealAsset & {
  __typename?: 'PlanningLifestyleAsset';
  /** The Savvy record this came from. */
  assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  availableForEstateLiquidity: Maybe<Scalars['Boolean']['output']>;
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  externalId: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  growthRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  owners: PlanningOwners;
  /** Whether this is the principal residence. Nothing enforces at most one across a plan. */
  principalResidence: Maybe<Scalars['Boolean']['output']>;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  propertyTax: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  purchaseDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** What kind of asset it is. */
  type: PlanningLifestyleAssetType;
  /** When the market value was assessed. */
  valuationDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** What kind of lifestyle asset this is. */
export type PlanningLifestyleAssetType =
  /** collectible */
  | 'collectible'
  /** insurance_policy */
  | 'insurance_policy'
  /** other_asset */
  | 'other_asset'
  /** personal_property */
  | 'personal_property'
  /** residence */
  | 'residence'
  /** vehicle */
  | 'vehicle';

/** The income an account contribution is taken from. */
export type PlanningLinkToIncome =
  /** employer_income */
  | 'employer_income'
  /** self_employment */
  | 'self_employment';

/** When a household member retires. */
export type PlanningMemberRetirement = PlanningAlreadyRetired | PlanningRetireAtAge | PlanningRetireOnDate;

/** A named beneficiary. Excludes the estate, which cannot appear in a multi-beneficiary list. */
export type PlanningNamedBeneficiary = PlanningBeneficiaryClient | PlanningBeneficiaryDependant;

/** A one-time or repeating occurrence. A one-time occurrence has no end date and a repeating one always does. */
export type PlanningOccurrence = PlanningOccurrenceOnce | PlanningOccurrenceRepeating;

/** Something that happens on a single date. */
export type PlanningOccurrenceOnce = {
  __typename?: 'PlanningOccurrenceOnce';
  /** The date it happens. */
  on: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Something that happens on a repeating schedule, which therefore has both boundaries. */
export type PlanningOccurrenceRepeating = {
  __typename?: 'PlanningOccurrenceRepeating';
  /** When it stops. */
  endsOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** How often it repeats. */
  frequency: Maybe<PlanningFrequency>;
  /** When it starts. */
  startsOn: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Who owns an item. Named profiles rather than a client/co-client pair, so a jointly owned item says which two people own it. */
export type PlanningOwners = {
  __typename?: 'PlanningOwners';
  /** The household members who own this item. */
  clientProfileIds: Array<Scalars['String']['output']>;
  /** Individual or joint. */
  ownershipType: Maybe<PlanningOwnershipType>;
};

/** Whether an item is owned individually or jointly */
export type PlanningOwnershipType =
  /** individual */
  | 'individual'
  /** joint */
  | 'joint';

/** A pension paid as income for life. */
export type PlanningPensionLifetimeIncome = {
  __typename?: 'PlanningPensionLifetimeIncome';
  /** The Social Security offset, as a whole-number percentage, when the pension integrates with it. */
  socialSecurityOffset: Maybe<Scalars['BigDecimal']['output']>;
};

/** A pension taken as a single payment. */
export type PlanningPensionLumpSum = {
  __typename?: 'PlanningPensionLumpSum';
  /** The lump sum in dollars. */
  payoutDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Where the lump sum is transferred. */
  transferTo: Maybe<PlanningPensionTransferTarget>;
};

/** How a defined benefit pension pays out. */
export type PlanningPensionPayout = PlanningPensionLifetimeIncome | PlanningPensionLumpSum;

/** Where a pension lump sum is transferred to */
export type PlanningPensionTransferTarget =
  /** new_ira */
  | 'new_ira'
  /** not_applicable */
  | 'not_applicable';

/** A dollar amount attributed to one owner, for where a jointly held item splits a figure between the people who own it. */
export type PlanningPerOwnerAmount = {
  __typename?: 'PlanningPerOwnerAmount';
  /** The amount in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** The owner the amount belongs to. */
  owner: Maybe<Scalars['String']['output']>;
};

/** A financial plan: an identifier from the planning engine, and the inputs the projection was built from. */
export type PlanningPlan = {
  __typename?: 'PlanningPlan';
  /** The engine's identifier for this plan. */
  id: Scalars['String']['output'];
  /** The inputs the plan was built from. */
  planData: PlanningPlanData;
};

/**
 * The inputs a plan is built from: the household, what it owns and owes, what
 * comes in and goes out, and what it is saving for.
 */
export type PlanningPlanData = {
  __typename?: 'PlanningPlanData';
  /** What the household owns. */
  assets: Maybe<Array<PlanningAsset>>;
  /** The client. */
  client: PlanningHouseholdMember;
  /** The co-client, on a couple. */
  coClient: Maybe<PlanningHouseholdMember>;
  /** Who depends on the household. */
  dependants: Maybe<Array<PlanningDependant>>;
  /** What goes out. */
  expenses: Maybe<Array<PlanningExpense>>;
  /** What it is saving for. */
  goals: Maybe<Array<PlanningGoal>>;
  /** What comes in. */
  incomes: Maybe<Array<PlanningIncome>>;
  /** What it owes. */
  liabilities: Maybe<Array<PlanningLiability>>;
  /** The assumptions the projection runs on. */
  planSettings: Maybe<PlanningPlanSettings>;
};

/** A named point in the plan that a boundary can hang off */
export type PlanningPlanEvent =
  /** death */
  | 'death'
  /** first_to_die */
  | 'first_to_die'
  /** first_to_retire */
  | 'first_to_retire'
  /** last_to_die */
  | 'last_to_die'
  /** last_to_retire */
  | 'last_to_retire'
  /** plan_date */
  | 'plan_date'
  /** retirement */
  | 'retirement'
  /** start_of_plan_year */
  | 'start_of_plan_year';

/** Plan-wide assumptions. */
export type PlanningPlanSettings = {
  __typename?: 'PlanningPlanSettings';
  /** The default external account fee, which an account can override. */
  defaultAccountFees: Maybe<PlanningAccountFees>;
  /** Whether tax provisions expire as currently legislated. */
  expireAsLegislated: Maybe<Scalars['Boolean']['output']>;
  /** Plan-wide index rates. */
  indexRates: Maybe<PlanningIndexRates>;
  /** How long each member lives. */
  lifeExpectancy: Maybe<PlanningLifeExpectancy>;
};

/** The model portfolio an account is invested in. */
export type PlanningPortfolio =
  /** aggressive */
  | 'aggressive'
  /** all_equity */
  | 'all_equity'
  /** all_fixed */
  | 'all_fixed'
  /** conservative */
  | 'conservative'
  /** current */
  | 'current'
  /** moderate */
  | 'moderate'
  /** moderately_aggressive */
  | 'moderately_aggressive'
  /** moderately_conservative */
  | 'moderately_conservative';

/** Property tax stated as a rate or as a dollar amount. */
export type PlanningPropertyTax = PlanningPropertyTaxAmount | PlanningPropertyTaxRate;

/** Property tax as a fixed dollar amount, which does need indexation. */
export type PlanningPropertyTaxAmount = {
  __typename?: 'PlanningPropertyTaxAmount';
  /** The amount in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** How the amount grows. */
  indexation: Maybe<PlanningIndexation>;
};

/** Property tax as a percentage of market value. It re-bases on the growing value each year, so it needs no indexation. */
export type PlanningPropertyTaxRate = {
  __typename?: 'PlanningPropertyTaxRate';
  /** The rate, as a whole-number percentage. */
  percentage: Maybe<Scalars['BigDecimal']['output']>;
};

/** An asset held for its own sake rather than for a return. */
export type PlanningRealAsset = {
  /** The Savvy record this came from. */
  assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  availableForEstateLiquidity: Maybe<Scalars['Boolean']['output']>;
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  externalId: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  growthRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  owners: PlanningOwners;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  propertyTax: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  purchaseDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** When the market value was assessed. */
  valuationDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** How a rental property depreciates. The pools differ between residential and commercial. */
export type PlanningRentalDepreciation = PlanningRentalDepreciationCommercial | PlanningRentalDepreciationResidential;

/** Commercial rental depreciation, which has qualified improvement property in place of appliances and furniture. */
export type PlanningRentalDepreciationCommercial = {
  __typename?: 'PlanningRentalDepreciationCommercial';
  /** The building basis. */
  building: Maybe<PlanningCostPool>;
  /** The land basis. */
  land: Maybe<PlanningCostPool>;
  /** The qualified improvement property basis. */
  qualifiedImprovementProperty: Maybe<PlanningCostPool>;
};

/** Residential rental depreciation. Appliances and furniture depreciate over a fixed period, so they are a separate pool. */
export type PlanningRentalDepreciationResidential = {
  __typename?: 'PlanningRentalDepreciationResidential';
  /** The appliances and furniture basis. */
  appliancesAndFurniture: Maybe<PlanningDepreciablePool>;
  /** The building basis. */
  building: Maybe<PlanningCostPool>;
  /** The land basis. */
  land: Maybe<PlanningCostPool>;
};

/** A real asset that earns rent and can therefore claim depreciation. */
export type PlanningRentalProperty = PlanningRealAsset & {
  __typename?: 'PlanningRentalProperty';
  /** The Savvy record this came from. */
  assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  availableForEstateLiquidity: Maybe<Scalars['Boolean']['output']>;
  /** Whether the plan claims depreciation on this property. */
  claimDepreciation: Maybe<Scalars['Boolean']['output']>;
  /** The depreciation basis, residential or commercial. */
  depreciation: Maybe<PlanningRentalDepreciation>;
  /** A free-text label. */
  description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  externalId: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  growthRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  owners: PlanningOwners;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  propertyTax: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  purchaseDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** When the market value was assessed. */
  valuationDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Retirement at a given age. */
export type PlanningRetireAtAge = {
  __typename?: 'PlanningRetireAtAge';
  /** The retirement age. */
  age: Maybe<Scalars['Int']['output']>;
};

/** Retirement on a fixed date. */
export type PlanningRetireOnDate = {
  __typename?: 'PlanningRetireOnDate';
  /** The retirement date. */
  date: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Where the proceeds of a share sale go. */
export type PlanningSaleDestination = PlanningSaleToExistingAccount | PlanningSaleToNewNonQualified;

/** Proceeds go to an account already in the plan. */
export type PlanningSaleToExistingAccount = {
  __typename?: 'PlanningSaleToExistingAccount';
  /** The account the proceeds go to. */
  accountRef: Maybe<Scalars['String']['output']>;
};

/** Proceeds go to a new non-qualified account. */
export type PlanningSaleToNewNonQualified = {
  __typename?: 'PlanningSaleToNewNonQualified';
  /** Always true. Present because GraphQL object types cannot be empty. */
  isNewNonQualified: Scalars['Boolean']['output'];
};

/** A reference to one of our rows for an item that can come from more than one table, so the table is named alongside the id. */
export type PlanningSavvyRef = {
  __typename?: 'PlanningSavvyRef';
  /** The row id. */
  id: Maybe<Scalars['String']['output']>;
  /** Which table the row is in. */
  objectType: Maybe<PlanningSavvyRefObjectType>;
};

/** Which of our tables a plan item was read from. */
export type PlanningSavvyRefObjectType =
  /** account */
  | 'account'
  /** liability */
  | 'liability';

/** A recurring contribution into an account, bounded at both ends. */
export type PlanningScheduledContribution = {
  __typename?: 'PlanningScheduledContribution';
  /** Extra growth, as a percentage. A bare rate, not an indexation: the row has no inflation toggle. */
  additionalIndexRate: Maybe<Scalars['BigDecimal']['output']>;
  /** The amount in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** When it stops. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** How often it is paid in. */
  frequency: Maybe<PlanningContributionFrequency>;
  /** When it starts. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** Sex at birth, which drives mortality assumptions */
export type PlanningSexAtBirth =
  /** female */
  | 'female'
  /** male */
  | 'male'
  /** unspecified */
  | 'unspecified';

/** A sale of exercised shares. */
export type PlanningShareSale = {
  __typename?: 'PlanningShareSale';
  /** Where the proceeds go. */
  destination: Maybe<PlanningSaleDestination>;
  /** A free-text note on why. */
  purpose: Maybe<Scalars['String']['output']>;
  /** When the sale happens. */
  schedule: Maybe<PlanningOccurrence>;
  /** Whether every exercised share is sold. */
  sellAllExercised: Maybe<Scalars['Boolean']['output']>;
};

/** Social Security already being paid, so the monthly amount is known. */
export type PlanningSocialSecurityAlreadyReceiving = {
  __typename?: 'PlanningSocialSecurityAlreadyReceiving';
  /** How the benefit grows. */
  indexation: Maybe<PlanningIndexation>;
  /** The monthly benefit in dollars. */
  monthlyDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  voluntaryWithholding: Maybe<Scalars['BigDecimal']['output']>;
};

/** Social Security not yet claimed, so the start and the benefit are both estimates. */
export type PlanningSocialSecurityNotYetReceiving = {
  __typename?: 'PlanningSocialSecurityNotYetReceiving';
  /** Whether the spousal benefit calculation is included. */
  includeSpousalBenefit: Maybe<Scalars['Boolean']['output']>;
  /** How the benefit grows. */
  indexation: Maybe<PlanningIndexation>;
  /** The monthly benefit in dollars at full retirement age, when manually entered. */
  monthlyDollarAmountAtFullRetirementAge: Maybe<Scalars['BigDecimal']['output']>;
  /** When benefits are expected to start. */
  startsOn: Maybe<PlanningDateBoundary>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  voluntaryWithholding: Maybe<Scalars['BigDecimal']['output']>;
};

/** Whether Social Security is already being received or not yet claimed. */
export type PlanningSocialSecurityRetirement = PlanningSocialSecurityAlreadyReceiving | PlanningSocialSecurityNotYetReceiving;

/** The Social Security survivor benefit. */
export type PlanningSurvivorBenefit = {
  __typename?: 'PlanningSurvivorBenefit';
  /** Whether future survivor benefits are included. */
  includeFutureBenefits: Maybe<Scalars['Boolean']['output']>;
  /** How the benefit grows. */
  indexation: Maybe<PlanningIndexation>;
  /** The monthly benefit in dollars. */
  monthlyDollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  voluntaryWithholding: Maybe<Scalars['BigDecimal']['output']>;
};

/** How much goes into a tax-advantaged account: an elected amount, or the maximum. */
export type PlanningTaxAdvantagedContributions = PlanningTaxAdvantagedContributionsElected | PlanningTaxAdvantagedContributionsMaxOut;

/** A chosen contribution amount on a schedule. */
export type PlanningTaxAdvantagedContributionsElected = {
  __typename?: 'PlanningTaxAdvantagedContributionsElected';
  /** Whether the contribution is deducted. Never defaulted: the answer has a tax consequence. */
  deductible: Maybe<Scalars['Boolean']['output']>;
  /** The amount in dollars. */
  dollarAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** When contributions stop. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** How often it is paid in. */
  frequency: Maybe<PlanningContributionFrequency>;
  /** How the amount grows. */
  indexation: Maybe<PlanningIndexation>;
  /** When contributions start. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** Contribute the statutory maximum, still answering whether it is deducted. */
export type PlanningTaxAdvantagedContributionsMaxOut = {
  __typename?: 'PlanningTaxAdvantagedContributionsMaxOut';
  /** Whether the contribution is deducted. */
  deductible: Maybe<Scalars['Boolean']['output']>;
  /** When contributions stop. */
  endsOn: Maybe<PlanningDateBoundary>;
  /** When contributions start. */
  startsOn: Maybe<PlanningDateBoundary>;
};

/** Filing status for tax projections */
export type PlanningTaxStatus =
  /** head_of_household */
  | 'head_of_household'
  /** married_filing_jointly */
  | 'married_filing_jointly'
  /** married_filing_separately */
  | 'married_filing_separately'
  /** single */
  | 'single';

/**
 * How a grant vests. Retirement and death are booleans on the grant rather than
 * schedule entries, matching how the engine models them.
 */
export type PlanningVesting = {
  __typename?: 'PlanningVesting';
  /** The vesting tranches. */
  activity: Maybe<Array<PlanningVestingActivity>>;
  /** Whether the grant vests fully at death. */
  atDeath: Maybe<Scalars['Boolean']['output']>;
  /** Whether the grant vests fully at retirement. */
  atRetirement: Maybe<Scalars['Boolean']['output']>;
};

/** A tranche of shares vesting on a schedule. */
export type PlanningVestingActivity = {
  __typename?: 'PlanningVestingActivity';
  /** The share of the grant that vests, as a whole-number percentage. */
  percentOfShares: Maybe<Scalars['BigDecimal']['output']>;
  /** When it vests. */
  schedule: Maybe<PlanningOccurrence>;
};

/** Who is covered by a work-based retirement plan, which is what decides whether IRA contributions are deductible. */
export type PlanningWorkPlanCoverage =
  /** both */
  | 'both'
  /** owner */
  | 'owner'
  /** spouse */
  | 'spouse';

/** A portfolio under a household. */
export type Portfolio = {
  __typename?: 'Portfolio';
  accounts: Maybe<Array<Account>>;
  /** When the investment policy was last confirmed */
  confirmedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  /** The household that the portfolio belongs to. */
  household: Household;
  /** @deprecated Use household instead */
  householdId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  investmentObjective: Maybe<InvestmentObjectiveName>;
  isPersonal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orionHouseholdId: Scalars['Int']['output'];
  portfolioStrategies: Maybe<Array<PortfolioStrategy>>;
  riskAssessment: Maybe<RiskAssessmentName>;
  taxSensitivity: Maybe<PortfolioTaxSensitivityName>;
  timeHorizon: Maybe<TimeHorizonName>;
  userId: Scalars['ID']['output'];
};

/** Portfolio graph value used for time series graph display */
export type PortfolioGraphValue = {
  __typename?: 'PortfolioGraphValue';
  date: Scalars['ISO8601Date']['output'];
  /**
   * Whether or not to include this data point in an all time graph. We need this
   * to graph all time data properly because data returned from our data provider
   * has different frequency intervals depending on how far back it goes.
   */
  includeInAllTime: Scalars['Boolean']['output'];
  netInvestedUsd: Maybe<Scalars['BigDecimal']['output']>;
  valueUsd: Scalars['BigDecimal']['output'];
};

/** Accounts, assets and liabilities classified together into an PortfolioItemGroup. */
export type PortfolioItem = Account | Asset | Liability;

/** A group of PortfolioItem objects. */
export type PortfolioItemGroup = {
  __typename?: 'PortfolioItemGroup';
  /** An array of accounts */
  accounts: Array<Account>;
  /** An array of assets */
  assets: Array<Asset>;
  /** Historical values for hidden items in the group */
  hiddenFromClientHistoricalValues: Array<HistoricalValue>;
  /** The total value of all hidden items in the group. */
  hiddenFromClientTotalValue: Value;
  /** Historical values for the group */
  historicalValues: Array<HistoricalValue>;
  /**
   * An array of portfolio items
   * @deprecated Use the accounts, assets, and liabilities fields instead.
   */
  items: Array<PortfolioItem>;
  /** An array of liabilities */
  liabilities: Array<Liability>;
  /** The name of the group. */
  name: PortfolioItemGroupName;
  /** The total value of all items in the group. */
  totalValue: Value;
};

export type PortfolioItemGroupName =
  | 'BANK_ACCOUNTS'
  | 'COMPANY_EQUITY'
  | 'OTHER_ASSETS'
  | 'OTHER_INVESTMENTS'
  | 'OTHER_LIABILITIES'
  | 'REAL_ESTATE'
  | 'SAVVY_ACCOUNTS';

/** Which table a portfolio item id names. Ids are not unique across assets and liabilities. */
export type PortfolioItemKind =
  /** asset */
  | 'asset'
  /** liability */
  | 'liability';

export type PortfolioItemTypeName =
  | 'auto'
  | 'commercial'
  | 'consumer'
  | 'credit'
  | 'cryptocurrency'
  | 'depository'
  | 'employer_equity'
  | 'fund_investment'
  | 'general'
  | 'home_equity'
  | 'insurance'
  | 'investment'
  | 'line_of_credit'
  | 'loan'
  | 'mortgage'
  | 'other'
  | 'private_investment'
  | 'student';

/** Data used for client performance reporting. */
export type PortfolioPerformanceReport = {
  __typename?: 'PortfolioPerformanceReport';
  /** Per-account performance breakdowns for multi-account and portfolio queries */
  accountPerformanceBreakdowns: Maybe<Array<AccountPerformanceBreakdown>>;
  assetCategoryGrouping: Array<AssetGrouping>;
  assetClassGrouping: Array<AssetGrouping>;
  /** Backend-computed performance for the comparison window. Null when no comparison was requested. */
  comparisonSummary: Maybe<ComparisonPerformanceSummary>;
  /** Per-account performance for the custom Range A window. Null unless range_a_date_range is set. */
  customRangeAAccountPerformance: Maybe<Array<AccountWindowPerformance>>;
  /** Backend-computed performance for the primary window when an arbitrary range was supplied. Null otherwise. */
  customRangeASummary: Maybe<ComparisonPerformanceSummary>;
  /** When Orion last updated the underlying performance snapshot data */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  holdings: Array<ReportedHolding>;
  /** A unique identifier for Apollo to use for caching */
  id: Scalars['String']['output'];
  performanceOverTime: Array<Performance>;
  performanceSummaries: Maybe<Array<PerformanceSummary>>;
  portfolioGraphValues: Array<PortfolioGraphValue>;
  /** Per-quarter performance columns for the Summary section. Null unless quarterly_breakdown is requested. */
  quarterlySummaries: Maybe<Array<QuarterlyPerformanceSummary>>;
  /** @deprecated Use tax_groups_by_period instead */
  taxTypeGrouping: Maybe<Array<TaxTypeGrouping>>;
  taxTypeGroupingsByPeriod: Maybe<Array<TaxTypeGroupingsByPeriod>>;
};

/**
 * Risk and benchmark-relative statistics for a household portfolio over a report
 * date range - backs the report-builder Statistical Summary section. A household
 * with more than one configured benchmark uses only the first valid one (CSV
 * order) for the 7 benchmark-relative fields below - unlike the
 * cumulative-benchmark chart, which plots every configured leg.
 */
export type PortfolioStatisticalSummary = {
  __typename?: 'PortfolioStatisticalSummary';
  /**
   * True when the 7 benchmark-relative fields below are populated. False both when
   * the household has no configured Orion benchmark, and when one is configured
   * but its daily data does not sufficiently overlap the report window (e.g. a
   * newly-configured benchmark or a very short window).
   */
  benchmarkConfigured: Scalars['Boolean']['output'];
  /** Beta vs the benchmark; null unless benchmarkConfigured, or when benchmark variance is zero. */
  betaCoefficient: Maybe<Scalars['Float']['output']>;
  /** Covariance of portfolio and benchmark daily returns; null unless benchmarkConfigured. */
  covariance: Maybe<Scalars['Float']['output']>;
  /** Downside capture ratio; null unless benchmarkConfigured, or when there are no negative-benchmark-return days. */
  downsideCaptureRatio: Maybe<Scalars['Float']['output']>;
  /** Maximum peak-to-trough drawdown over the window, as a fraction. */
  drawdown: Scalars['Float']['output'];
  /** Jensen's alpha; null unless benchmarkConfigured, or when beta is unavailable. */
  jensensAlpha: Maybe<Scalars['Float']['output']>;
  /** Mean periodic return, as a fraction. */
  meanReturn: Scalars['Float']['output'];
  /** Squared correlation with the benchmark; null unless benchmarkConfigured. */
  rSquared: Maybe<Scalars['Float']['output']>;
  /** Annualized Sharpe ratio (unitless). */
  sharpeRatio: Scalars['Float']['output'];
  /** Annualized Sortino ratio (unitless). */
  sortinoRatio: Scalars['Float']['output'];
  /** Annualized standard deviation of periodic returns, as a fraction (0.12 = 12%). */
  standardDeviation: Scalars['Float']['output'];
  /** Treynor ratio; null unless benchmarkConfigured, or when beta is zero/unavailable. */
  treynorRatio: Maybe<Scalars['Float']['output']>;
  /** Upside capture ratio; null unless benchmarkConfigured, or when there are no positive-benchmark-return days. */
  upsideCaptureRatio: Maybe<Scalars['Float']['output']>;
  /** Annualized variance of returns (standardDeviation squared), fraction-scale. */
  variance: Scalars['Float']['output'];
};

export type PortfolioStrategy = {
  __typename?: 'PortfolioStrategy';
  accountSleeve: Maybe<AccountSleeve>;
  accounts: Maybe<Array<Account>>;
  cashRequirements: Maybe<Scalars['String']['output']>;
  /**
   * True when this strategy is Direct Indexing: its name says so, Orion
   * sub-advises it through Direct Indexing, or the owning account is the Savvy
   * Direct Indexing product.
   */
  directIndexing: Scalars['Boolean']['output'];
  doNotSellHoldings: Maybe<Array<Holding>>;
  excludedHoldings: Maybe<Array<Holding>>;
  feeInBasisPoints: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  nonTradedAccounts: Maybe<Array<Account>>;
  overlayIncluded: Maybe<Scalars['Boolean']['output']>;
  portfolioId: Scalars['ID']['output'];
  reallocationFrequency: Maybe<Scalars['String']['output']>;
  reallocationType: Maybe<Scalars['String']['output']>;
  strategyName: Scalars['String']['output'];
  strategyType: Maybe<StrategyTypeName>;
  taxSensitivity: Maybe<Scalars['String']['output']>;
};

/**
 * Native rebuild of the Orion "Portfolio Summary - Comprehensive" PDF. Superset of
 * the Simple report: cover + Appendix Summary of Accounts, Performance Report
 * (Relationship Summary + Activity Summary + Portfolio Value Over Time),
 * Allocation Over Time, Group Performance (per-holding returns by asset category),
 * and the full Holdings detail. Replaces the Orion path when feature-flagged on (HAWK-73).
 */
export type PortfolioSummaryComprehensive = {
  __typename?: 'PortfolioSummaryComprehensive';
  /** Per-account rows for the Appendix – Summary of Accounts page. */
  accountSummaries: Array<AccountEntry>;
  /** Relationship Summary by Account Type: household total followed by Taxable / Tax Deferred / Tax Exempt sub-totals. */
  accountTypeGroups: Array<AccountTypeGroup>;
  /** Four-column Activity Summary table: custom date range, QTD, YTD, Since Inception. */
  activityPeriods: Array<ActivityPeriod>;
  /** Primary advisor's display name shown on the cover. */
  advisorName: Maybe<Scalars['String']['output']>;
  /**
   * Long-format allocation series (one point per date per asset category) for the
   * stacked-area Allocation Over Time chart. Empty when the live Orion lookup is
   * unavailable — the chart is then omitted.
   */
  allocationOverTime: Array<AllocationOverTimePoint>;
  /** Accounts listed on the cover page (name + masked number). */
  coverAccounts: Array<AccountEntry>;
  /** When the underlying performance snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end date (as-of date for QTD / YTD / Since Inception). */
  endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name. Falls back to "Savvy" when the household's advisor has no organization branding. */
  firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL. Falls back to the Savvy logo when no organization branding is set. */
  firmLogoUrl: Scalars['String']['output'];
  /** Per-holding returns grouped by asset category (Group Performance table, pages 4–6). */
  groupPerformance: Array<GroupPerformanceRow>;
  /** Asset-category subtotal rows for the Group Performance table. */
  groupPerformanceTotals: Array<GroupPerformanceTotal>;
  /** Full holdings detail (one row per position), grouped on the template by asset category → sub-asset class. */
  holdings: Array<HoldingsSummaryRow>;
  /** Total cost basis across all holdings. */
  holdingsTotalCostBasis: HoldingsSummaryMoney;
  /** Total market value across all holdings. */
  holdingsTotalMarketValue: HoldingsSummaryMoney;
  /** Total unrealized gain/loss across all holdings. */
  holdingsTotalUnrealizedGainLoss: HoldingsSummaryMoney;
  /** Household display name shown on the cover and page headers. */
  householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across all accounts; used as the 'Since Inception' period start. Null when unknown. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Managed Assets Total inception-to-date TWR as a fraction. Null when unavailable. */
  managedTotalInceptionToDateReturn: Maybe<Scalars['Float']['output']>;
  /** Managed Assets Total market value, in USD. Null when unavailable. */
  managedTotalMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Managed Assets Total trailing one-year TWR as a fraction. Null when unavailable. */
  managedTotalOneYearReturn: Maybe<Scalars['Float']['output']>;
  /** Managed Assets Total year-to-date TWR as a fraction. Null when unavailable. */
  managedTotalYearToDateReturn: Maybe<Scalars['Float']['output']>;
  /** Daily points for the 'Portfolio Value Over Time' chart, spanning the custom date range. */
  marketValueSeries: Array<MarketValuePoint>;
  /** User-selected start date (first column of the Activity Summary). */
  startDate: Scalars['ISO8601Date']['output'];
};

/**
 * Reporting periods covered by the Portfolio Summary (Simple) activity table —
 * custom date range, quarter-to-date, year-to-date, and since inception.
 */
export type PortfolioSummarySimplePeriod =
  /** custom_range */
  | 'custom_range'
  /** quarter_to_date */
  | 'quarter_to_date'
  /** since_inception */
  | 'since_inception'
  /** year_to_date */
  | 'year_to_date';

export type PortfolioTaxSensitivityName =
  | 'high'
  | 'low'
  | 'moderate';

/** The primary advisor for a prospect or client. */
export type PrimaryAdvisor = {
  __typename?: 'PrimaryAdvisor';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

export type ProbabilityOfClosing =
  | 'high'
  | 'low'
  | 'medium';

/** Autogenerated input type of ProcessOnboardedClient */
export type ProcessOnboardedClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orionHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcessOnboardedClient. */
export type ProcessOnboardedClientPayload = {
  __typename?: 'ProcessOnboardedClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProfessionalRelationship = {
  __typename?: 'ProfessionalRelationship';
  /** When the relationship was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The relationship edge id */
  id: Scalars['ID']['output'];
  /** Optional per-relationship notes */
  notes: Maybe<Scalars['String']['output']>;
  /** The month/year the referral happened (referred relationships only) */
  referredOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** The nature of the relationship (serves, referred) */
  relationshipType: ProfessionalRelationshipType;
  /** Category of contact for a RetirementPlan target */
  retirementPlanContactGroup: Maybe<ProfessionalRelationshipContactGroup>;
  /** Active/inactive status of a contact for a RetirementPlan target */
  retirementPlanContactStatus: Maybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role toward the household (serves relationships) */
  role: Maybe<ProfessionalRelationshipRole>;
  /** The acting end (User or CenterOfInfluenceRep) */
  source: ProfessionalRelationshipSource;
  /** The receiving end (Household, CenterOfInfluenceRep, or RetirementPlan) */
  target: ProfessionalRelationshipTarget;
  /** When the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ProfessionalRelationship. */
export type ProfessionalRelationshipConnection = {
  __typename?: 'ProfessionalRelationshipConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProfessionalRelationshipEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ProfessionalRelationship>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

export type ProfessionalRelationshipContactGroup =
  /** internal_team */
  | 'internal_team'
  /** other */
  | 'other'
  /** plan_sponsor */
  | 'plan_sponsor'
  /** service_provider */
  | 'service_provider';

export type ProfessionalRelationshipContactStatus =
  /** active */
  | 'active'
  /** inactive */
  | 'inactive';

/** An edge in a connection. */
export type ProfessionalRelationshipEdge = {
  __typename?: 'ProfessionalRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ProfessionalRelationship>;
};

export type ProfessionalRelationshipRole =
  /** accountant */
  | 'accountant'
  /** attorney */
  | 'attorney'
  /** cpa */
  | 'cpa'
  /** estate_planner */
  | 'estate_planner'
  /** financial_planner */
  | 'financial_planner'
  /** insurance_agent */
  | 'insurance_agent'
  /** other */
  | 'other';

/**
 * The source end of a professional relationship: a CenterOfInfluenceRep, a
 * Household (a client referred out to a contact), or a User (reference-only
 * referral source)
 */
export type ProfessionalRelationshipSource = CenterOfInfluenceRep | Household | PublicParticipantUser;

/** The receiving end of a professional relationship: a Household, CenterOfInfluenceRep, or RetirementPlan */
export type ProfessionalRelationshipTarget = CenterOfInfluenceRep | Household | RetirementPlan;

export type ProfessionalRelationshipType =
  /** referred */
  | 'referred'
  /** referred_out */
  | 'referred_out'
  /** serves */
  | 'serves';

/** Autogenerated input type of PromoteEnrollment */
export type PromoteEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The enrollment's uuid. */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteEnrollment. */
export type PromoteEnrollmentPayload = {
  __typename?: 'PromoteEnrollmentPayload';
  /** Households linked to a canonical household that already existed on this advisor's book. */
  adoptedCount: Scalars['Int']['output'];
  /** Households blocked during this run. */
  blockedCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The enrollment after promotion. */
  enrollment: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** Households newly promoted in this run. */
  promotedCount: Scalars['Int']['output'];
  /** Households already promoted and skipped in this run. */
  skippedCount: Scalars['Int']['output'];
  /** Households left unlinked in this run, with the reason. */
  skippedHouseholds: Array<PromoteSkippedHousehold>;
  /** Whether the operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** A staged household a promote run left unlinked, and why. */
export type PromoteSkippedHousehold = {
  __typename?: 'PromoteSkippedHousehold';
  /** Operator-facing detail behind the reason. */
  detail: Scalars['String']['output'];
  /** Household name from the imported book. */
  householdName: Maybe<Scalars['String']['output']>;
  /** Household onboarding request id. */
  id: Scalars['ID']['output'];
  /**
   * Why it was skipped: client_on_another_book, ambiguous_household,
   * household_not_onboardable, already_in_cockpit, seat_mismatch, or
   * duplicate_on_create.
   */
  reason: Scalars['String']['output'];
};

/** Autogenerated input type of PromoteToSavvyTemplate */
export type PromoteToSavvyTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The workflow template to promote */
  taskWorkflowTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteToSavvyTemplate. */
export type PromoteToSavvyTemplatePayload = {
  __typename?: 'PromoteToSavvyTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The new Savvy template created from the source */
  taskWorkflowTemplate: Maybe<TaskWorkflowTemplate>;
};

export type ProspectDatum = {
  __typename?: 'ProspectDatum';
  advisorProfile: Advisor;
  advisorUser: User;
  createdAt: Scalars['ISO8601DateTime']['output'];
  estimatedAum: Maybe<Scalars['Int']['output']>;
  household: Maybe<Household>;
  id: Scalars['ID']['output'];
  probabilityOfClosing: Maybe<ProbabilityOfClosing>;
  salesforceId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Prospecting Trend Analysis variant */
export type ProspectingTrendAnalysisInput = {
  /** Analysis period */
  analysisPeriod: CorporateRetirementPlanAnalysisPeriodName;
  /** Custom period end (required when analysis_period is custom) */
  customPeriodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Custom period start (required when analysis_period is custom) */
  customPeriodStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Metrics to highlight */
  metricsToHighlight?: InputMaybe<Scalars['String']['input']>;
  /** Plan name */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper */
  recordkeeper?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAccount = {
  __typename?: 'ProviderAccount';
  accessToken: Maybe<Scalars['String']['output']>;
  accounts: Maybe<Array<Account>>;
  /**
   * Whether this connection is keeping up and whether the client can repair it.
   * Always resolves, including for connections with no accounts and for Orion and Plaid sources
   */
  freshness: ProviderAccountFreshness;
  id: Scalars['ID']['output'];
  providerName: Maybe<Scalars['String']['output']>;
  scope: Maybe<Scalars['String']['output']>;
  source: ProviderAccountSource;
  sourceProviderAccountId: Maybe<Scalars['String']['output']>;
  sourceStatus: Maybe<Scalars['String']['output']>;
};

/**
 * Whether a linked connection is keeping up, and whether the client has to do
 * anything about it. Every field is non-null except lastSyncedAt, which is null
 * only when the connection has never synced.
 */
export type ProviderAccountFreshness = {
  __typename?: 'ProviderAccountFreshness';
  /**
   * The link needs the client to act — ITEM_LOGIN_REQUIRED, FAILED, NO_ACCOUNTS,
   * or PASSWORD_RESET_REQUIRED. Matches the set the live net-worth banner already
   * treats as actionable, so the two surfaces agree; read linkStatus for which of the four it is
   */
  disconnected: Scalars['Boolean']['output'];
  /** When the freshest account under this connection last changed. Null when syncStatus is NEVER_SYNCED, and only then */
  lastSyncedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Link health, independent of freshness. STALE with an ACTIVE link is a slow
   * feed; STALE with ITEM_LOGIN_REQUIRED is a broken one
   */
  linkStatus: ProviderAccountLinkStatus;
  /**
   * Whether the client can repair this connection themselves. False only for Orion
   * — MoneyKit and Plaid links both have a client-facing reconnect
   */
  reconnectSupported: Scalars['Boolean']['output'];
  /** Time-based freshness: FRESH, STALE, or NEVER_SYNCED */
  syncStatus: ProviderAccountSyncStatus;
};

/** The health of the link itself, mirroring ProviderAccount#source_status with UNKNOWN standing in for the nullable column */
export type ProviderAccountLinkStatus =
  /** The link is working */
  | 'ACTIVE'
  /** The provider reported a failure the client cannot fix by re-authenticating */
  | 'FAILED'
  /** The institution needs the client to re-authenticate */
  | 'ITEM_LOGIN_REQUIRED'
  /** The link is mid-sync */
  | 'LOADING'
  /** The link succeeded but exposes no accounts */
  | 'NO_ACCOUNTS'
  /** The institution needs the client to reset their password */
  | 'PASSWORD_RESET_REQUIRED'
  /** The connection has never reported a status */
  | 'UNKNOWN';

export type ProviderAccountSource =
  | 'MONEYKIT'
  | 'ORION'
  | 'PLAID';

/**
 * How recently a linked connection last sent balances, on the 48-hour bar owned by
 * ProviderAccounts::Moneykit::StalenessEvaluator
 */
export type ProviderAccountSyncStatus =
  /** The connection sent balances inside the staleness threshold */
  | 'FRESH'
  /**
   * The connection has no accounts to date, so there is no sync for it to be
   * behind on. Distinct from STALE: a client who has just linked belongs here, not in a warning
   */
  | 'NEVER_SYNCED'
  /**
   * The connection last sent balances before the staleness threshold — it may be a
   * slow feed rather than a broken link, so read linkStatus before asking the client to act
   */
  | 'STALE';

export type PublicAdvisor = {
  __typename?: 'PublicAdvisor';
  bio: Scalars['String']['output'];
  calendlyLink: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  profilePicUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** A User participating in a calendar event (limited public view) */
export type PublicParticipantUser = {
  __typename?: 'PublicParticipantUser';
  /** Email address */
  email: Scalars['String']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** Full name */
  name: Scalars['String']['output'];
};

/** Autogenerated input type of PublishDraftTask */
export type PublishDraftTaskInput = {
  /** Whether the published client task should include Calendly scheduling. */
  addCalendlyScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current task assignee ID to apply before publishing. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Box folder ID to attach before publishing. */
  boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current human task description or instructions to apply before publishing. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Current task due date to apply before publishing. */
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether the client should be notified when the draft is published. */
  notifyClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current task priority to apply before publishing. */
  priority?: InputMaybe<TaskPriority>;
  /** Whether the published client task should send email reminders. */
  sendClientEmailReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the client should receive an SMS when the draft is published. */
  smsClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Active status to publish the draft as. Defaults to TODO. */
  status?: InputMaybe<TaskStatus>;
  /** The ID of the draft task to publish */
  taskId: Scalars['ID']['input'];
  /** Current task title to apply before publishing. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishDraftTask. */
export type PublishDraftTaskPayload = {
  __typename?: 'PublishDraftTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The published task */
  task: Maybe<Task>;
};

/** Autogenerated input type of PublishFinancialPlan */
export type PublishFinancialPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Conquest story ID to publish/unpublish. Null to unlink a deleted story. */
  conquestStoryId?: InputMaybe<Scalars['String']['input']>;
  /** Financial plan ID to update */
  financialPlanId: Scalars['ID']['input'];
  /** Target status (DRAFT or PUBLISHED) */
  status: DigitalStoryStatus;
};

/** Autogenerated return type of PublishFinancialPlan. */
export type PublishFinancialPlanPayload = {
  __typename?: 'PublishFinancialPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated financial plan */
  financialPlan: Maybe<FinancialPlan>;
};

/** Backend-authoritative forecast of what publishing a service catalog template will send */
export type PublishForecast = {
  __typename?: 'PublishForecast';
  /** Soonest automated-email send time across all items (null when nothing would send) */
  firstSendAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The service catalog item group being forecast */
  groupId: Scalars['ID']['output'];
  /** Per-item send forecast */
  items: Array<PublishForecastItem>;
  /** Number of automated emails whose send date is already past. SendDueEmailsJob holds these rather than sending them */
  totalImmediateSends: Scalars['Int']['output'];
};

/** Per-item send forecast for publishing a service catalog template */
export type PublishForecastItem = {
  __typename?: 'PublishForecastItem';
  /** The service catalog item ID */
  itemId: Scalars['ID']['output'];
  /** The item name */
  itemName: Scalars['String']['output'];
  /** Soonest automated-email send time across enrollments (null when the item sends no email) */
  nextSendAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Enrolled households that will receive this item on publish */
  recipientCount: Scalars['Int']['output'];
  /** Enrolled recipient households (name + email) that will receive this item on publish */
  recipients: Array<PublishForecastRecipient>;
  /** Whether at least one email for this item already has a past send date, so it will be held rather than sent */
  sendsImmediately: Scalars['Boolean']['output'];
};

/** A household that will receive a service catalog item on publish, and the email(s) it would be delivered to */
export type PublishForecastRecipient = {
  __typename?: 'PublishForecastRecipient';
  /** Comma-joined client email(s) the invite would be delivered to (blank when no client email exists) */
  email: Scalars['String']['output'];
  /** The recipient household name */
  householdName: Scalars['String']['output'];
};

/** Autogenerated input type of PublishMeetingPrepOperation */
export type PublishMeetingPrepOperationInput = {
  /** Scheduled occurrence selected for create-or-reuse */
  calendarEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Existing meeting-prep document selected for refresh */
  canvasDocumentId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Validated canonical meeting-prep content */
  content: Scalars['JSON']['input'];
  /** Advisor-owned conversation for unscheduled creation */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** Optimistic generated-content revision */
  expectedRevision?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting-prep operation intent discriminator */
  intentKind: Scalars['String']['input'];
  /** Generated section selected for scoped replacement */
  section?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-provided tentative date for unscheduled creation */
  tentativeDate?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-provided meeting title for unscheduled creation */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishMeetingPrepOperation. */
export type PublishMeetingPrepOperationPayload = {
  __typename?: 'PublishMeetingPrepOperationPayload';
  /** Published or preserved meeting-prep document */
  canvasDocumentId: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Publication outcome */
  outcome: Scalars['String']['output'];
  /** Current generated-content revision */
  revision: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of PublishReport */
export type PublishReportInput = {
  /** When to surface the report in the client portal. Defaults to nil (not yet visible). */
  addedToPortalAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiry datetime after which the report is no longer accessible. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Household receiving the published report. */
  householdId: Scalars['ID']['input'];
  /** Serialized ReportViewPayload, enriched by the FE with advisorName/logoUrl. */
  snapshot: Scalars['JsonHash']['input'];
  /** Display title for the published report. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of PublishReport. */
export type PublishReportPayload = {
  __typename?: 'PublishReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly published report. */
  publishedReport: PublishedReport;
};

/** Autogenerated input type of PublishServiceCatalogItemGroup */
export type PublishServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishServiceCatalogItemGroup. */
export type PublishServiceCatalogItemGroupPayload = {
  __typename?: 'PublishServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The published service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/**
 * A read-only snapshot of a Report Builder configuration, published by an advisor
 * for a household to view in the client portal.
 */
export type PublishedReport = {
  __typename?: 'PublishedReport';
  /** When this report was surfaced in the client portal. Null until the advisor adds it. */
  addedToPortalAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the report was published. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this report expires and is no longer accessible. Null means it never expires. */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The household this report was published to. */
  household: Household;
  /** The unique identifier for the published report. */
  id: Scalars['ID']['output'];
  /** The advisor who published the report. */
  publishedBy: User;
  /** Serialized ReportViewPayload captured at publish time. */
  snapshot: Scalars['JSON']['output'];
  /** Display title shown to the client. */
  title: Scalars['String']['output'];
  /** Which renderer the snapshot belongs to. */
  type: PublishedReportType;
};

/** Summary of a published report for client portal list views (no snapshot payload). */
export type PublishedReportSummary = {
  __typename?: 'PublishedReportSummary';
  /** When surfaced in the client portal. Null until shared — lets the advisor UI tell "Prepared" from "Live". */
  addedToPortalAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Client-facing attribution: the publisher if an advisor, else the household
   * advisor, else null. Never a CSA or assistant, unlike published_by_name.
   */
  attributedAdvisorName: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the advisor named by attributed_advisor_name. */
  attributedAdvisorProfilePicUrl: Maybe<Scalars['String']['output']>;
  /** Canvas document this report was published from, for deep-linking back into the canvas. Null for Report Builder reports. */
  canvasDocumentId: Maybe<Scalars['ID']['output']>;
  /** When the report was published. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this report expires. Null means it never expires. */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique identifier for the published report. */
  id: Scalars['ID']['output'];
  /**
   * Raw publisher, which may be a CSA or an assistant. Advisor-facing only: null
   * for client viewers, who get attributed_advisor_name instead.
   */
  publishedByName: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the raw publisher. Advisor-facing only: null for client viewers. */
  publishedByProfilePicUrl: Maybe<Scalars['String']['output']>;
  /** Whether the report link is live or expired, derived from expires_at. */
  status: Scalars['String']['output'];
  /** Display title shown to the client. */
  title: Scalars['String']['output'];
  /** Which renderer the snapshot belongs to. */
  type: PublishedReportType;
  /** When the report was last modified. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Which renderer a published report snapshot belongs to */
export type PublishedReportType =
  /** canvas */
  | 'canvas'
  /** report_builder */
  | 'report_builder';

export type PushNotificationOpened = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the opened notification. Paired with the sent count to compute per-notification engagement. */
  notificationId: Scalars['String']['input'];
  /** Type/category of the opened notification. */
  notificationType?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type PushNotificationsToggled = {
  /** Whether the user turned the device push-notification preference on (true) or off (false). */
  enabled: Scalars['Boolean']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** One period column of the Report Builder Summary quarterly breakdown. */
export type QuarterlyPerformanceSummary = {
  __typename?: 'QuarterlyPerformanceSummary';
  /** Portfolio market value at window start. */
  beginningMarketValue: Maybe<Value>;
  /** Total contributions in the window. */
  contributions: Maybe<Value>;
  /** Total distributions in the window. */
  distributions: Maybe<Value>;
  /** Total dividends and interest received in the window. */
  dividendsAndInterest: Maybe<Value>;
  /** The window end. */
  endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at window end. */
  endingMarketValue: Maybe<Value>;
  /** Column header: Q1/Q2/Q3, QTD, YTD, or Inception. */
  label: Scalars['String']['output'];
  /** Net gains in the window (end - start - net flows). */
  netGains: Maybe<Value>;
  /** The window start. */
  startDate: Scalars['ISO8601Date']['output'];
  /**
   * Inbound account transfers (Merge In + Journal In), signed positive. Null on
   * the snapshot path where merge/journal are unavailable.
   */
  transfersIn: Maybe<Value>;
  /**
   * Outbound account transfers (Merge Out + Journal Out), signed negative. Null on
   * the snapshot path where merge/journal are unavailable.
   */
  transfersOut: Maybe<Value>;
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). */
  twr: Maybe<Scalars['Float']['output']>;
};

/** A single quarter's time-weighted return, used by the Quarterly Returns bar chart. */
export type QuarterlyReturn = {
  __typename?: 'QuarterlyReturn';
  /** Last calendar day of the quarter. */
  quarterEnd: Scalars['ISO8601Date']['output'];
  /** Time-weighted return for the quarter, expressed as a fraction (0.05 = 5%). */
  twr: Scalars['BigDecimal']['output'];
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountNewsArticles: Array<NewsArticle>;
  accountSleeve: AccountSleeve;
  accountTrendingHeadlines: Array<TrendingHeadline>;
  /** Touchpoint totals, recency and channel mix for a household window */
  activityTimelineContactSummary: ActivityTimelineContactSummary;
  /** Fetches activity entry items for a household */
  activityTimelineEntryItems: Entries;
  /** Distinct months with activity for a household timeline (powers the month rail) */
  activityTimelineMonths: Array<Month>;
  adminServiceObjects: Array<AdminServiceObject>;
  advisor: Advisor;
  /**
   * Returns a list of accounts accessible to the current user
   * @deprecated Use advisor.accounts instead
   */
  advisorAccounts: AccountConnection;
  /** Read-only global Activities feed for the current advisor */
  advisorActivities: AdvisorActivityConnection;
  /** Per-day activity counts for the current advisor; drives the Activity feed timeline minimap. */
  advisorActivityDailyCounts: Array<AdvisorActivityDailyCount>;
  /** A single event from any of the advisor's calendars by id, with household + meeting prep */
  advisorCalendarEvent: Maybe<AdvisorCalendarEvent>;
  /** Advisor calendar events across all of their calendars between two dates (advisor tz), with household + prep doc id */
  advisorCalendarEvents: Array<AdvisorCalendarEvent>;
  /** Admin query to get all clients for a specific advisor with their associated data */
  advisorClients: Array<AdvisorClient>;
  /** Get paginated client households for the advisor dashboard with filtering and sorting */
  advisorDashboardClients: HouseholdConnection;
  /** Admin: advisor-led onboarding LD status + provenance for an advisor */
  advisorDirectedOnboardingStatus: AdvisorDirectedOnboardingStatus;
  /** Firm-wide advisor directory with server-side search + facets (advisor or admin) */
  advisorDirectory: AdvisorDirectoryEntryConnection;
  /** Returns a list of fee schedules created for an advisor */
  advisorFeeSchedules: Array<FeeSchedule>;
  /** Distinct US state codes across primary clients in the advisor's accessible households, for populating the state filter */
  advisorHouseholdStates: Array<Scalars['String']['output']>;
  /** Fetch an advisor identity profile (voice DNA + future kinds). */
  advisorIdentityProfile: Maybe<AdvisorIdentityProfile>;
  /** Pre-flight for the admin book upload page: whether an advisor can receive a book and what is already staged. */
  advisorOnboardingBookUploadReadiness: Maybe<BookUploadReadiness>;
  /** Whether the current advisor is enrolled in the onboarding revamp and eligible for the intake wizard. */
  advisorOnboardingEligible: Scalars['Boolean']['output'];
  /** Look up an advisor onboarding enrollment by uuid for the intake wizard gate + resume. */
  advisorOnboardingEnrollment: Maybe<AdvisorOnboardingEnrollment>;
  /** The advisor's most recent onboarding book import, for surfacing skipped-row import errors in the cockpit. */
  advisorOnboardingLatestBookImport: Maybe<BulkImport>;
  /** The current advisor's saved onboarding personalization for the intake wizard personalize step. */
  advisorOnboardingPersonalization: Maybe<AdvisorOnboardingPersonalization>;
  /** Look up one staged household by id for the confirm-accounts screen. */
  advisorOnboardingStagedHousehold: Maybe<AdvisorOnboardingStagedHousehold>;
  /** The current advisor's Ops contact (CSA) for the onboarding welcome screen */
  advisorOpsContact: Maybe<AdvisorOpsContact>;
  /** List all published reports for a household (live and expired) for advisor-side management */
  advisorPublishedReports: Array<PublishedReportSummary>;
  /** Paginated referral edges backing the referral ledger */
  advisorReferralLedger: ProfessionalRelationshipConnection;
  /** Book-wide referral analytics and per-source totals for the acting advisor */
  advisorReferralMetrics: ReferralMetricsSummary;
  /** All report schedules visible to the current advisor, with household reach and latest execution status */
  advisorReportSchedules: Array<AdvisorReportSchedule>;
  /** Internal-admin query: advisor-tier team members whose level can be managed */
  advisorTierTeamMembers: Array<User>;
  /** Action Center filter-chip counts grouped by alert type. */
  alertCountsByType: AlertCountsBy;
  alerts: AlertConnection;
  /** Admin query for internal tools to fetch advisors */
  allAdvisors: Array<Advisor>;
  alternativeFunds: Array<AlternativeFund>;
  /** Per-asset-class returns with benchmark comparisons (HAWK-112). */
  assetClassReturns: Array<AssetClassReturn>;
  /** Advisors in the plan's organization, selectable as a project row assignee */
  assignableAdvisorsForRetirementPlan: Array<AssignableAdvisor>;
  auditHouseholdAccess: Array<HouseholdAccessAuditResult>;
  /** Distinct event keys the advisor has activities for; drives the Activity Type filter. */
  availableActivityEventKeys: Array<Scalars['String']['output']>;
  /** Distinct alert types the advisor has active inbox alerts for; drives the Inbox Type filter. */
  availableInboxAlertTypes: Array<Scalars['String']['output']>;
  /** Look up the canonical bank name for an ABA routing number (UNO-206 suggestion chip) */
  bankNameForRoutingNumber: Maybe<Scalars['String']['output']>;
  /** List a household's live Box Client Uploads files with extraction status */
  boxClientUploadStatements: Array<BoxClientUploadStatement>;
  boxConfiguration: BoxConfiguration;
  boxMarketingConfiguration: BoxMarketingConfiguration;
  boxThumbnails: Array<BoxFileThumbnail>;
  /** Get a list of brokerage account statements */
  brokerageAccountStatements: Array<BrokerageAccountStatement>;
  /** Get a bulk import by ID */
  bulkImport: Maybe<BulkImport>;
  /** Get the most recent bulk imports */
  bulkImports: Array<BulkImport>;
  /** Get the status of a bulk report generation job */
  bulkReportGenerationJob: Maybe<BulkReportGenerationJob>;
  /** Status of a bulk upload-to-Box job (poll after bulkUploadFilesToBox) */
  bulkUploadFilesToBoxStatus: Maybe<BulkUploadFilesToBoxStatus>;
  /** Work items for the advisor calendar (tasks with due dates and events) in a time range */
  calendarWorkItems: CalendarWorkItemConnection;
  /**
   * Folder-downscoped Box token (read-level file access + Box AI) for the Savvy
   * Intelligence canvas agent harness to read a household's Box documents
   * server-side, gated by household access. Agent-harness use only — not a
   * general-purpose Box token.
   */
  canvasHouseholdBoxToken: Maybe<CanvasBoxToken>;
  centerOfInfluenceReps: Array<CenterOfInfluenceRep>;
  client: Client;
  /** Client endpoint for the comparison index a client-portal return figure is measured against. */
  clientPortalBenchmarkComparison: Maybe<ClientPortalBenchmarkComparison>;
  /** Client endpoint for the household's own return series, charted against the comparison index. */
  clientPortalPortfolioReturnSeries: Maybe<Array<ClientPortalReturnSeriesPoint>>;
  /** Search for client profiles by name & associated info */
  clientProfiles: ClientConnection;
  /** Users a comment on this subject can @-mention. */
  commentMentionCandidates: Array<CommentMentionCandidate>;
  /** A subject's internal comment thread for the current user, newest first. */
  comments: CommentFeed;
  /** Companies accessible to the current advisor */
  companies: Array<Company>;
  /** A company by ID */
  company: Company;
  /** Conquest-computed calc results (projection + net-worth breakdown) for a household's plan (calls Conquest) */
  conquestPlanCalcs: Maybe<Scalars['JSON']['output']>;
  /** The raw IntegrationPlanData body of a household's Conquest plan, returned as-is for the frontend to map (calls Conquest) */
  conquestPlanRawData: Maybe<Scalars['JSON']['output']>;
  currentUser: CurrentUser;
  /** Get the status of a data export */
  dataExport: Maybe<DataExport>;
  /** Progress of a demo environment reseed. */
  demoReseedRun: Maybe<DemoReseedRun>;
  dialpadCall: DialpadCallApi;
  dialpadTranscript: DialpadTranscript;
  /** Direct Indexing-eligible accounts the current user can access (used by the Direct Index Report account picker). */
  directIndexingEligibleAccounts: Array<Account>;
  /** Canonical advisor spoken-language taxonomy for directory facets + picker */
  directoryLanguages: Array<DirectoryLanguage>;
  /** Distinct advisor states for the directory location facet */
  directoryLocations: Array<Scalars['String']['output']>;
  /** Canonical advisor specialty taxonomy for directory facets + picker */
  directorySpecialties: Array<DirectorySpecialty>;
  /** Organizations with at least one listed directory advisor, for the directory Organization facet */
  directoryTeams: Array<DirectoryTeam>;
  /** Available disqualified reason options */
  disqualifiedReasonOptions: Array<Scalars['String']['output']>;
  docusignEnvelopeLink: Maybe<Scalars['String']['output']>;
  docusignRecipientLink: Scalars['String']['output'];
  /** DocuSign tracker envelope rows for the current advisor (or org-wide if can_edit_organization) */
  docusignTrackerEnvelopes: Array<DocusignTrackerEnvelope>;
  /** ECI custodian-transfer onboarding request + sidecars for the magic-link holder */
  eciClientOnboarding: EciClientOnboarding;
  /** Renders the ECI client-onboarding email to inlined HTML for a live preview. */
  eciClientOnboardingEmailPreview: EmailPreview;
  /** Fetch a single email message, scoped to a household, for the activity-timeline email detail view. */
  emailMessage: Maybe<EmailMessage>;
  /** Semantic (vector) nearest-neighbor search over a household's email threads for the Savvy Intelligence canvas agent. */
  emailThreadSemanticSearch: Maybe<Array<EmailThreadSemanticSearchHit>>;
  /** Native Estimated Cash Flow report — replaces the Orion-generated Estimated Income PDF (HAWK-34). */
  estimatedCashFlow: EstimatedCashFlowReport;
  /** Get Extend-extracted document data for a household */
  extendExtractedDatum: Array<ExtendExtractedDatum>;
  /** Returns a list of family members for a specific household */
  familyMembers: Array<FamilyMember>;
  financialOfferings: Array<FinancialOffering>;
  /** Returns a financial plan for a household (WIP) */
  financialPlan: Maybe<FinancialPlan>;
  financialPlanReportFile: FinancialPlanningBoxFolderData;
  financialRecommendations: Array<FinancialRecommendation>;
  /** Advisor-only lookup of a user by email for the Add Household Member dialog (4C1T-42). */
  findUserByEmail: Maybe<UserLookupResult>;
  /** Advisors in the current firm admin's organization eligible to seed a new team */
  firmTeamCandidates: Array<FirmTeamCandidate>;
  goals: Array<Goal>;
  googleCloudOAuthUrl: Scalars['String']['output'];
  /** Native holdings summary report — replaces the Orion-generated PDF (HAWK-23). */
  holdingsSummary: HoldingsSummary;
  household: Household;
  /** Current Orion benchmark value for a household (e.g. "191531_P"). */
  householdBenchmark: Maybe<Scalars['String']['output']>;
  /** Human-created blended benchmarks an advisor can pick for a household. */
  householdBenchmarkBlends: Array<HouseholdBenchmarkBlend>;
  /** A single calendar event scoped to a household, so its note + transcript resolve under that household context */
  householdCalendarEvent: Maybe<CalendarEvent>;
  /** Cumulative return vs benchmark series for a household. */
  householdCumulativeBenchmarkReport: Array<BenchmarkSeries>;
  /** Returns non-canceled source-backed ECI account onboarding tasks for a household's custodian transfer flow */
  householdEciAccountOnboardingTasks: Array<Task>;
  /** The services one household is enrolled in, from the enrollment's service foreign key */
  householdEnrolledServices: Array<HouseholdEnrolledService>;
  /** Returns the last used fee schedule for a household */
  householdFeeSchedule: Maybe<HouseholdFeeSchedule>;
  /** The "Keep in mind" section for a household; null when the section should not appear at all */
  householdKeepInMind: Maybe<HouseholdKeepInMind>;
  /** Returns the household's managed accounts whose registration subtype is currently supported for eci transfer */
  householdManagedAccounts: Array<Account>;
  /** Returns the CenterOfInfluenceReps with a serves relationship to a household */
  householdServedCenterOfInfluenceReps: Array<CenterOfInfluenceRep>;
  /** One household's service occurrences, oldest first, both shapes */
  householdServiceOccurrences: Array<HouseholdServiceOccurrence>;
  householdTasks: Array<Task>;
  /** Tax info for household */
  householdTaxPage: TaxPage;
  /** Search for households by name and associated client information */
  households: HouseholdSearchConnection;
  /** Get Orion Connect models explicitly enabled for the current advisor groups */
  investmentProposalOrionModels: Array<InvestmentProposalOrionModel>;
  /** Native Invoice (Fee Review) report — replaces the Orion-generated Client Invoice PDF (HAWK-32). */
  invoiceFeeReview: InvoiceFeeReview;
  /** A household's selectable Orion bills for the Invoice (Fee Review) invoice/quarter picker. */
  invoiceFeeReviewBills: Array<InvoiceFeeReviewBillOption>;
  /** Checks if the provided password is the current user's password */
  isValidPassword: Scalars['Boolean']['output'];
  /** Available lead source options */
  leadSourceOptions: Array<Scalars['String']['output']>;
  /** Admin: poll a Linked Bank Accounts import by ID */
  linkedBankAccountImport: Maybe<LinkedBankAccountImport>;
  /** Available loss reason options */
  lossReasonOptions: Array<Scalars['String']['output']>;
  /** Returns a single meeting agenda template by ID, if visible to the current advisor */
  meetingAgendaTemplate: Maybe<MeetingAgendaTemplate>;
  /** Returns the meeting agenda templates visible to the current advisor */
  meetingAgendaTemplates: MeetingAgendaTemplateConnection;
  /** Returns canonical meeting-prep context for an authorized scheduled or unscheduled target */
  meetingPrepOperationContext: Scalars['JSON']['output'];
  /** Returns a bounded outline for a currently visible meeting agenda template */
  meetingPrepTemplateOutline: Maybe<Scalars['JSON']['output']>;
  /** Client endpoint for the beneficiary designations on one of the viewer's accounts */
  myAccountBeneficiaries: Array<ClientAccountBeneficiary>;
  /** Client endpoint for the outside specialists who serve the viewer's household */
  myProfessionalContacts: Array<ClientProfessionalContact>;
  /** Client endpoint for tax info */
  myTaxPage: TaxPage;
  /** Get the status of a native async report generation job */
  nativeReport: Maybe<NativeReport>;
  /** Paginated Fidelity NFS audit log. Admin-only. */
  nfsAuditEntries: NfsAuditEntryConnection;
  /** Full-text search over the NFS audit index. Admin-only. */
  nfsAuditSearch: NfsAuditSearchResults;
  notes: Array<Note>;
  /** Per-account / per-household alert mutes for a user. */
  notificationAlertMutes: Array<NotificationAlertMute>;
  /** Effective catalog notification routing for a user. */
  notificationRouting: Array<NotificationRoutePreference>;
  /** The advisor's in-flight book transfer households for the onboarding cockpit table. */
  onboardingCockpit: OnboardingCockpitRowConnection;
  onboardingTasks: Array<Task>;
  /** Returns aggregate information about opportunities */
  opportunitiesTableHeaders: OpportunitiesTableHeader;
  /** Returns data needed for the Opportunities view */
  opportunitiesTableRows: OpportunitiesTableRowConnection;
  /** Distinct primary advisors across opportunities accessible to the current user. */
  opportunityPrimaryAdvisors: Array<PrimaryAdvisor>;
  opsTasks: Maybe<Array<Task>>;
  /** Get an organization by ID */
  organization: Organization;
  /** Admin query to fetch all organizations */
  organizations: OrganizationConnection;
  /** Allowed Orion ad-hoc reports for this environment */
  orionAdHocReports: Array<OrionAdHocReport>;
  /** Get Orion portfolio documents */
  orionPortfolioDocuments: Array<OrionPortfolioDocument>;
  /** Orion quarterly reports available for generation in this environment */
  orionQuarterlyReports: Array<OrionQuarterlyReport>;
  /** Get the status of an Orion report generation */
  orionReportGeneration: Maybe<OrionReportGeneration>;
  /** Returns a list of Orion report templates */
  orionReportTemplates: Array<OrionReportTemplate>;
  orionSearch: Array<OrionSearch>;
  orionSecurity: OrionSecurity;
  orionSsoUrl: Scalars['String']['output'];
  /** Get the current Orion data sync status for a user */
  orionSyncStatus: OrionSyncStatus;
  /** Scheduled report executions awaiting the current advisor's review */
  pendingReviewExecutions: Array<ReportScheduleExecution>;
  /** Native Performance by Account report — replaces the Orion-generated "Performance by Account" PDF (HAWK-77). */
  performanceByAccount: PerformanceByAccount;
  /** Native Performance Report (Allocations) — replaces the Orion-generated "Performance Report – Allocations" PDF. */
  performanceReportAllocations: PerformanceReportAllocations;
  /** Native Performance Report (Consolidated) — replaces the Orion-generated "Client Portfolio Review Report" PDF (HAWK-29). */
  performanceReportConsolidated: PerformanceReportConsolidated;
  /** Native Performance Report (Integrated) — replaces the Orion-generated "Performance Report – Integrated" PDF (HAWK-27). */
  performanceReportIntegrated: PerformanceReportIntegrated;
  /** Native Performance Report (Portfolio Group) — replaces the Orion-generated PDF (HAWK-30). */
  performanceReportPortfolioGroup: Report;
  /** Native Performance Report (Unified) — replaces the Orion-generated PDF (HAWK-25). */
  performanceReportUnified: Report;
  /** Fetch a financial plan and the inputs it was built from */
  plan: Maybe<PlanningPlan>;
  portfolio: NetWorthPortfolioData;
  /** One manually valued portfolio item (asset or liability) by id and kind, for a per-item detail surface. */
  portfolioItem: PortfolioItem;
  portfolioPerformanceReport: PortfolioPerformanceReport;
  /** Statistical Summary report-builder section - portfolio risk stats plus benchmark-relative stats. */
  portfolioStatisticalSummary: PortfolioStatisticalSummary;
  portfolioStrategy: PortfolioStrategy;
  /**
   * Native Portfolio Summary (Comprehensive) report — replaces the Orion-generated
   * "Portfolio Summary - Comprehensive" PDF (HAWK-73).
   */
  portfolioSummaryComprehensive: PortfolioSummaryComprehensive;
  /** For tag-create flows: matching households (smart) or all advisor households (manual). */
  previewTagApplicationCandidates: Array<Household>;
  prospectData: ProspectDatum;
  publicAdvisor: PublicAdvisor;
  /** Fetch a published report by ID (for the client portal /dashboard/reports/:id) */
  publishedReport: Maybe<PublishedReport>;
  /** List portal-visible published reports for a household (client portal Reports tab) */
  publishedReports: Array<PublishedReportSummary>;
  quickTradeAccountInformation: Maybe<QuickTradeAccountInformation>;
  quickTradeEligibility: Scalars['Boolean']['output'];
  quickTradeValidation: Array<QuickTradeValidationResponse>;
  /** Raw Savvy plan data for a household, read-only (does not call Conquest); the frontend maps it to the Conquest shape */
  rawSavvyPlanData: Maybe<RawSavvyPlanData>;
  /** Real-time (or delayed, per entitlement) market quotes from Orion Eclipse for the given tickers. */
  realTimePrices: Array<RealTimePrice>;
  /** CSA-facing: the editable canonical field set + current values for a remediation subtask, keyed by remediation type. */
  remediationEditableFields: Maybe<EciRemediationEditableFields>;
  /** Look up the DocuSign link for a repaper envelope by trackingId */
  repaperEnvelopeStatus: Maybe<Scalars['String']['output']>;
  /** Batched: look up DocuSign links for multiple repaper envelopes by trackingId */
  repaperEnvelopeStatuses: Array<RepaperEnvelopeStatus>;
  /** Recent scheduled report execution history for a household */
  reportScheduleExecutionsForHousehold: Array<ReportScheduleExecution>;
  /** Active report schedules targeting a household with latest execution status */
  reportSchedulesForHousehold: Array<HouseholdReportSchedule>;
  /** Fetch a single retirement plan by ID (gated behind retirementPlans flag) */
  retirementPlan: Maybe<RetirementPlan>;
  /** Distinct company names entered on retirement plan contacts, for autocomplete */
  retirementPlanContactCompanyNames: Array<Scalars['String']['output']>;
  /** Fetch a single retirement plan project row (step) by ID (gated behind retirementPlans flag) */
  retirementPlanProjectRow: Maybe<RetirementPlanProjectRow>;
  /** Fetch a single retirement plan project template by ID (gated behind retirementPlans flag) */
  retirementPlanProjectTemplate: Maybe<RetirementPlanProjectTemplate>;
  /** Retirement plan project templates for the current advisor's organization (gated behind retirementPlans flag) */
  retirementPlanProjectTemplates: Array<RetirementPlanProjectTemplate>;
  /** List retirement plans for the current advisor (gated behind retirementPlans flag) */
  retirementPlans: Array<RetirementPlan>;
  riskQuestionnaires: Array<RiskQuestionnaire>;
  rmds: Array<Rmd>;
  sandbox: Scalars['String']['output'];
  /** Saved report builder configurations for the current advisor */
  savedReportTemplates: Array<SavedReportTemplate>;
  /** Get all Savvy strategies in the catalog (raw holdings excluded) */
  savvyStrategies: Array<SavvyStrategy>;
  /** Get a single Savvy strategy by Orion Connect model id (supports performanceSeries) */
  savvyStrategy: Maybe<SavvyStrategy>;
  /** Returns the globally-available Savvy workflow templates */
  savvyWorkflowTemplates: TaskConnection;
  /** Schwab OAuth authorize URL for connecting Savvy as a Schwab API client (admin only) */
  schwabAuthorizeUrl: Scalars['String']['output'];
  /** Admin: outcome of the newest firm-wide Schwab standing-authorizations sync, or of a specific run. */
  schwabImportRunSummary: Maybe<SchwabImportRunSummary>;
  /** Admin-only: search all active users by name for @mention autocomplete in task comments */
  searchMentionableUsers: Array<TaskCommentMentionCandidate>;
  serviceCalendarHouseholdOptions: Array<ServiceCalendarSettingTemplate>;
  /** Pull service calendar items by user hosuehold */
  serviceCalendarItems: Array<ServiceCalendarItem>;
  /** Returns all of the service calendar meetings for a household */
  serviceCalendarMeetings: Array<ServiceCalendarMeeting>;
  /** Resolver to pull calendar settings for a user household */
  serviceCalendarSettings: Array<ServiceCalendarSetting>;
  /** Admin query to export service calendar v1 data for a specific advisor */
  serviceCalendarV1Export: ExportPayload;
  /** Render a SC v2 catalog email template into HTML for the in-app preview dialog */
  serviceCatalogEmailTemplatePreview: EmailTemplatePreview;
  /** Fetch a single service catalog item by ID */
  serviceCatalogItem: Maybe<ServiceCatalogItem>;
  /** Fetch a single service catalog item group by ID */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
  /** Forecast what publishing a service catalog item group will send */
  serviceCatalogItemGroupPublishForecast: Maybe<PublishForecast>;
  /** List service catalog item groups */
  serviceCatalogItemGroups: Array<ServiceCatalogItemGroup>;
  /** List per-assignment overrides */
  serviceCatalogItemHouseholdOverrides: Array<ServiceCatalogItemHouseholdOverride>;
  /** List service catalog item household assignments */
  serviceCatalogItemHouseholds: Array<ServiceCatalogItemHousehold>;
  /** List service catalog items for an advisor group */
  serviceCatalogItems: Array<ServiceCatalogItem>;
  /** SC v2 task display items: server-grouped multi-household occurrences + flat tasks */
  serviceItemOccurrences: ServiceItemOccurrenceConnection;
  /** Won households the advisor can access, with advisor + tags, for the Service schedules tab */
  serviceScheduleRows: Array<ServiceScheduleRow>;
  /** Organizations a retirement plan can be shared with (excludes its own organization) */
  shareableOrganizationsForRetirementPlan: Array<ShareableOrganization>;
  /** Savvy Portfolio Finance loan-length + estimated-rate options; readable by internal staff (advisors/CSAs/admins) */
  swimLoanLengthOptions: Array<SwimLoanLengthOption>;
  /** SWIM enrollment strategies and their fees (basis points); readable by internal staff (advisors/CSAs/admins) */
  swimStrategies: Array<SwimStrategy>;
  task: Maybe<Task>;
  /** Resolve task activities by task ID */
  taskActivities: Array<TaskActivity>;
  /** Fetch a task by its UUID (used for draft pre-filling) */
  taskByUuid: Maybe<Task>;
  /** Contact-card details for a task comment author, scoped to the household task context */
  taskCommentAuthor: Maybe<TaskCommentAuthor>;
  /** Eligible users for @mention autocomplete in task comments */
  taskCommentMentionCandidates: Array<TaskCommentMentionCandidate>;
  /** Renders a client task email to inlined HTML for the task-creation preview, one entry per recipient. */
  taskEmailPreview: Array<TaskEmailPreviewCopy>;
  /** Effective v6 task notification routing cells for a user. */
  taskNotificationRouting: Array<NotificationTaskRoutingCell>;
  /** Returns paginated workflow task templates with filtering and sorting */
  taskWorkflowTemplates: TaskConnection;
  tasks: Array<Task>;
  /** Returns paginated tasks with filtering and sorting */
  tasksTable: TaskConnection;
  /** Returns aggregated data for the task table */
  tasksTableAggregatedData: TasksTableAggregatedData;
  /** Returns aggregate information about tax enrollments */
  taxEnrollmentsTableHeaders: TaxEnrollmentsTableHeader;
  /** Returns tax enrollment data organized by household */
  taxEnrollmentsTableRows: TaxEnrollmentsTableRowConnection;
  /** Today's calendar events across all of the current user's calendars */
  todaysCalendarEvents: Array<CalendarEvent>;
  transactions: Array<Transaction>;
  /** Get transcript consent form information for clients */
  transcriptConsentForm: TranscriptConsentFormResponse;
  /** KYC readiness status and computed errors for a user */
  userKycStatus: UserKycStatus;
  /** Saved view/preferences for the current user scoped by provided keys */
  userSavedViews: Array<UserSavedView>;
  /** Transient voice prompt fragment from an in-progress capture session (step-4 preview; not persisted). */
  voiceProfilePreviewFragment: Maybe<Scalars['String']['output']>;
  /** Paginated households for a specific stat card drill-down */
  workbenchStatHouseholds: WorkbenchStatHouseholdConnection;
  /** Summary values for all workbench stat cards */
  workbenchStatsSummary: WorkbenchStatSummary;
  /** Returns Wrike marketing requests and if the current user is in an advisor group */
  wrikeMarketingRequests: Maybe<WrikeMarketingRequests>;
  zoomMeetingTranscript: ZoomMeetingTranscript;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountNewsArticlesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountSleeveArgs = {
  accountSleeveId: Scalars['ID']['input'];
};


export type QueryAccountTrendingHeadlinesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryActivityTimelineContactSummaryArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryActivityTimelineEntryItemsArgs = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  linkedHouseholdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  newerThan?: InputMaybe<EntryPositionInput>;
  olderThan?: InputMaybe<EntryPositionInput>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  pinnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<ItemTypeEnum>>;
};


export type QueryActivityTimelineMonthsArgs = {
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  linkedHouseholdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<ItemTypeEnum>>;
};


export type QueryAdvisorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvisorAccountsArgs = {
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  balanceRange?: InputMaybe<BalanceRangeInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  feeSchedules?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUnassignedAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioMustBePresent?: InputMaybe<Scalars['Boolean']['input']>;
  providerNames?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<AccountSortValues>;
  strategyFilter?: InputMaybe<StrategyFilterInput>;
};


export type QueryAdvisorActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorActivityDailyCountsArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvisorCalendarEventsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryAdvisorClientsArgs = {
  advisorId: Scalars['ID']['input'];
  pullProspects: Scalars['Boolean']['input'];
};


export type QueryAdvisorDashboardClientsArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludedAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedHouseholdTagCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedHouseholdTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedLastContactDaysSince?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludedPrimaryAddressStates?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdTagCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  inactiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeProspectStages?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastContactDaysSince?: InputMaybe<Array<Scalars['Int']['input']>>;
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddressStates?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewDue?: InputMaybe<Scalars['Boolean']['input']>;
  servicesDue?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryAdvisorDirectedOnboardingStatusArgs = {
  advisorUserId: Scalars['ID']['input'];
};


export type QueryAdvisorDirectoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdvisorDirectorySortEnum>;
  specialties?: InputMaybe<Array<Scalars['String']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenure?: InputMaybe<Array<AdvisorTenureBucketEnum>>;
};


export type QueryAdvisorFeeSchedulesArgs = {
  householdId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorIdentityProfileArgs = {
  advisorId: Scalars['ID']['input'];
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorOnboardingBookUploadReadinessArgs = {
  advisorId: Scalars['ID']['input'];
};


export type QueryAdvisorOnboardingEnrollmentArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryAdvisorOnboardingLatestBookImportArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvisorOnboardingStagedHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvisorPublishedReportsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryAdvisorReferralLedgerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  direction?: InputMaybe<ReferralDirectionEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<ReferralOutcomeEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorReferralMetricsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAlertCountsByTypeArgs = {
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryAlertsArgs = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  alertTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  applyRouting?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBulk?: InputMaybe<Scalars['Boolean']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<AlertStatusName>;
  userId: Scalars['ID']['input'];
};


export type QueryAssetClassReturnsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryAssignableAdvisorsForRetirementPlanArgs = {
  retirementPlanId: Scalars['ID']['input'];
};


export type QueryAuditHouseholdAccessArgs = {
  advisorUserId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailableActivityEventKeysArgs = {
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAvailableInboxAlertTypesArgs = {
  primaryAdvisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryBankNameForRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type QueryBoxClientUploadStatementsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryBoxConfigurationArgs = {
  actAsUserId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleteInScope?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBoxMarketingConfigurationArgs = {
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryBoxThumbnailsArgs = {
  boxFileIds: Array<Scalars['ID']['input']>;
};


export type QueryBrokerageAccountStatementsArgs = {
  householdId: Scalars['ID']['input'];
  statementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBulkImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBulkReportGenerationJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkUploadFilesToBoxStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCalendarWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limitPerDay?: InputMaybe<Scalars['Int']['input']>;
  onlyTasksWithDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  taskFilters?: InputMaybe<TasksTableFilterInput>;
  timeMax: Scalars['ISO8601DateTime']['input'];
  timeMin: Scalars['ISO8601DateTime']['input'];
};


export type QueryCanvasHouseholdBoxTokenArgs = {
  boxFolderId: Scalars['String']['input'];
};


export type QueryClientArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientPortalBenchmarkComparisonArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryClientPortalPortfolioReturnSeriesArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryClientProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isProspect?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryCommentMentionCandidatesArgs = {
  relationId: Scalars['ID']['input'];
  relationType: Scalars['String']['input'];
};


export type QueryCommentsArgs = {
  relationId: Scalars['ID']['input'];
  relationType: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConquestPlanCalcsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryConquestPlanRawDataArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryDataExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDemoReseedRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDialpadCallArgs = {
  dialpadCallId: Scalars['String']['input'];
};


export type QueryDialpadTranscriptArgs = {
  dialpadCallId: Scalars['String']['input'];
};


export type QueryDocusignEnvelopeLinkArgs = {
  trackingId: Scalars['String']['input'];
};


export type QueryDocusignRecipientLinkArgs = {
  envelopeId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type QueryDocusignTrackerEnvelopesArgs = {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  scope: DocusignTrackerScope;
  statusFilter?: InputMaybe<DocusignEnvelopeStatusFilter>;
};


export type QueryEciClientOnboardingEmailPreviewArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailMessageArgs = {
  householdId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryEmailThreadSemanticSearchArgs = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryEstimatedCashFlowArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryExtendExtractedDatumArgs = {
  datumIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdId: Scalars['ID']['input'];
};


export type QueryFamilyMembersArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialPlanArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialPlanReportFileArgs = {
  actAsUserId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleteInScope?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialRecommendationsArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryFindUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGoalsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHoldingsSummaryArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHouseholdBenchmarkArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdBenchmarkBlendsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdCalendarEventArgs = {
  calendarEventId: Scalars['ID']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdCumulativeBenchmarkReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  dateRangeId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdEciAccountOnboardingTasksArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryHouseholdEnrolledServicesArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdFeeScheduleArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdKeepInMindArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdManagedAccountsArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryHouseholdServedCenterOfInfluenceRepsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdServiceOccurrencesArgs = {
  householdId: Scalars['ID']['input'];
  lookbackMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHouseholdTasksArgs = {
  householdId: Scalars['ID']['input'];
  showHiddenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  taskType?: InputMaybe<TaskTypeName>;
};


export type QueryHouseholdTaxPageArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdStage?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceFeeReviewArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  billId?: InputMaybe<Scalars['ID']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryInvoiceFeeReviewBillsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryIsValidPasswordArgs = {
  password: Scalars['String']['input'];
};


export type QueryLinkedBankAccountImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingAgendaTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingAgendaTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateTypes?: InputMaybe<Array<MeetingAgendaTemplateType>>;
};


export type QueryMeetingPrepOperationContextArgs = {
  calendarEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  tentativeDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeetingPrepTemplateOutlineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyAccountBeneficiariesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryMyProfessionalContactsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyTaxPageArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNativeReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNfsAuditEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<NfsAuditDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gateway?: InputMaybe<NfsAuditGateway>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<NfsAuditOperation>;
  recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<NfsAuditStatus>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNfsAuditSearchArgs = {
  direction?: InputMaybe<NfsAuditDirection>;
  from?: InputMaybe<Scalars['Int']['input']>;
  gateway?: InputMaybe<NfsAuditGateway>;
  operation?: InputMaybe<NfsAuditOperation>;
  recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationAlertMutesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryNotificationRoutingArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryOnboardingCockpitArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<OnboardingCockpitSortField>;
  status?: InputMaybe<OnboardingCockpitStatus>;
};


export type QueryOnboardingTasksArgs = {
  statuses?: InputMaybe<Array<TaskStatus>>;
};


export type QueryOpportunitiesTableHeadersArgs = {
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdTagCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  leadSources?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityType?: InputMaybe<OpportunityTypeFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOpportunitiesTableRowsArgs = {
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdTagCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leadSources?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityType?: InputMaybe<OpportunityTypeFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<OpportunitySortValues>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOpsTasksArgs = {
  type?: InputMaybe<TaskTypeName>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrionPortfolioDocumentsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryOrionReportGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrionSearchArgs = {
  searchInput: Scalars['String']['input'];
};


export type QueryOrionSecurityArgs = {
  ticker: Scalars['String']['input'];
};


export type QueryOrionSyncStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPerformanceByAccountArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportAllocationsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportConsolidatedArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryPerformanceReportIntegratedArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportPortfolioGroupArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startFromInception?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPerformanceReportUnifiedArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startFromInception?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortfolioArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPortfolioItemArgs = {
  id: Scalars['ID']['input'];
  kind: PortfolioItemKind;
};


export type QueryPortfolioPerformanceReportArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountSleeveId?: InputMaybe<Scalars['ID']['input']>;
  allocationAsOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allocationPeriod?: InputMaybe<PerformanceTimePeriodName>;
  clientUserId?: InputMaybe<Scalars['ID']['input']>;
  compareDateRange?: InputMaybe<DateRangeInput>;
  compareQuickDate?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  quarterlyBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  rangeADateRange?: InputMaybe<DateRangeInput>;
};


export type QueryPortfolioStatisticalSummaryArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryPortfolioStrategyArgs = {
  portfolioStrategyId: Scalars['ID']['input'];
};


export type QueryPortfolioSummaryComprehensiveArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPreviewTagApplicationCandidatesArgs = {
  isSmart: Scalars['Boolean']['input'];
  organizationHouseholdCategoryId?: InputMaybe<Scalars['ID']['input']>;
  ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProspectDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicAdvisorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedReportsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuickTradeAccountInformationArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryQuickTradeEligibilityArgs = {
  trades: Array<QuickTradeEligibilityInput>;
};


export type QueryQuickTradeValidationArgs = {
  trades: Array<QuickTradeValidationInput>;
};


export type QueryRawSavvyPlanDataArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryRealTimePricesArgs = {
  tickers: Array<Scalars['String']['input']>;
};


export type QueryRemediationEditableFieldsArgs = {
  subtaskId: Scalars['ID']['input'];
};


export type QueryRepaperEnvelopeStatusArgs = {
  trackingId: Scalars['ID']['input'];
};


export type QueryRepaperEnvelopeStatusesArgs = {
  trackingIds: Array<Scalars['ID']['input']>;
};


export type QueryReportScheduleExecutionsForHouseholdArgs = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportSchedulesForHouseholdArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryRetirementPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetirementPlanProjectRowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetirementPlanProjectTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRiskQuestionnairesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRmdsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QuerySavvyStrategyArgs = {
  orionConnectModelId: Scalars['String']['input'];
};


export type QuerySavvyWorkflowTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchwabImportRunSummaryArgs = {
  runId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMentionableUsersArgs = {
  query: Scalars['String']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


export type QueryServiceCalendarHouseholdOptionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarItemsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarMeetingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarSettingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarV1ExportArgs = {
  advisorId: Scalars['ID']['input'];
  pullProspects: Scalars['Boolean']['input'];
};


export type QueryServiceCatalogEmailTemplatePreviewArgs = {
  body: Scalars['String']['input'];
  calendlyLink?: InputMaybe<Scalars['String']['input']>;
  emailCcUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailLeadTimeDays: Scalars['Int']['input'];
  emailSenderId?: InputMaybe<Scalars['ID']['input']>;
  meetingDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  serviceCatalogItemHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
};


export type QueryServiceCatalogItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupPublishForecastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupsArgs = {
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceCatalogItemHouseholdOverridesArgs = {
  serviceCatalogItemHouseholdId: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemHouseholdsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  serviceCatalogItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceCatalogItemsArgs = {
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceItemOccurrencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TasksTableFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaskSortValues>;
  tz?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShareableOrganizationsForRetirementPlanArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  retirementPlanId: Scalars['ID']['input'];
};


export type QueryTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceTaskId: Scalars['String']['input'];
};


export type QueryTaskActivitiesArgs = {
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskByUuidArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskCommentAuthorArgs = {
  householdPublicId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryTaskCommentMentionCandidatesArgs = {
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskEmailPreviewArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
  kind: ClientTaskEmailKind;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskNotificationRoutingArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTaskWorkflowTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkflowTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<WorkflowTemplateSortValues>;
};


export type QueryTasksArgs = {
  household?: InputMaybe<Scalars['Boolean']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  showHiddenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  taskType?: InputMaybe<TaskTypeName>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTasksTableArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TasksTableFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaskSortValues>;
};


export type QueryTasksTableAggregatedDataArgs = {
  filters?: InputMaybe<TasksTableFilterInput>;
};


export type QueryTaxEnrollmentsTableRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enrollmentTypeFilter?: InputMaybe<Array<TaxEnrollmentTypeName>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireAdvisorActionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  requireClientActionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaxEnrollmentSortValues>;
  statusFilter?: InputMaybe<Array<TaxEnrollmentStatus>>;
  taxYearFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  waitingOnThirdPartyFilter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountSleeveId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTranscriptConsentFormArgs = {
  isPrimaryClient: Scalars['Boolean']['input'];
};


export type QueryUserKycStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserSavedViewsArgs = {
  keys: Array<Scalars['String']['input']>;
};


export type QueryVoiceProfilePreviewFragmentArgs = {
  advisorId: Scalars['ID']['input'];
  calibrationDerivedTraits?: InputMaybe<Array<CalibrationDerivedTraitInput>>;
  scenarioReplies?: InputMaybe<Array<ScenarioReplyInput>>;
  source: Scalars['String']['input'];
};


export type QueryWorkbenchStatHouseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  statKey: WorkbenchStatKey;
};


export type QueryWorkbenchStatsSummaryArgs = {
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryZoomMeetingTranscriptArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Orion Eclipse account information for quick trade operations. ECI accounts read
 * live balances from Account.eciBalances instead.
 */
export type QuickTradeAccountInformation = {
  __typename?: 'QuickTradeAccountInformation';
  accountId: Maybe<Scalars['String']['output']>;
  buyingPower: Maybe<Scalars['Float']['output']>;
  cashAvailable: Maybe<Scalars['Float']['output']>;
  /** Available cash (buying power minus pending trade amounts in Created or Processed status). */
  freeCashAvailable: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  portfolioId: Maybe<Scalars['Int']['output']>;
};

export type QuickTradeEligibilityInput = {
  accountId: Scalars['Int']['input'];
  additionalDetails: Scalars['String']['input'];
  securityId: Scalars['Int']['input'];
  validationState: Scalars['String']['input'];
};

export type QuickTradeValidationInput = {
  accountId: Scalars['Int']['input'];
  action: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
  tradeAmount?: InputMaybe<Scalars['Float']['input']>;
  tradePercent?: InputMaybe<Scalars['Float']['input']>;
  tradeShares?: InputMaybe<Scalars['Int']['input']>;
};

export type QuickTradeValidationResponse = {
  __typename?: 'QuickTradeValidationResponse';
  /** The account ID for the trade */
  accountId: Maybe<Scalars['Int']['output']>;
  /** Any validation errors */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The portfolio ID for the trade */
  portfolioId: Maybe<Scalars['Int']['output']>;
  /** The validated price for the trade */
  price: Maybe<Scalars['Float']['output']>;
  /** The security ID for the trade */
  securityId: Maybe<Scalars['Int']['output']>;
};

/** An account in the raw Savvy plan data — unmapped Savvy fields for the frontend to map */
export type RawSavvyAccount = {
  __typename?: 'RawSavvyAccount';
  accountType: Maybe<Scalars['String']['output']>;
  coManagerIsAccountHolder: Maybe<Scalars['Boolean']['output']>;
  currentBalance: Maybe<Scalars['Float']['output']>;
  /** Sum of holdings cost basis (null if no holdings) */
  holdingsCostBasis: Maybe<Scalars['Float']['output']>;
  /** Sum of holdings market value (null if no holdings) */
  holdingsMarketValue: Maybe<Scalars['Float']['output']>;
  iraType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  primaryClientIsAccountHolder: Maybe<Scalars['Boolean']['output']>;
  registrationType: Maybe<Scalars['String']['output']>;
  subtype: Maybe<Scalars['String']['output']>;
  /** Savvy account type_of enum (e.g. investment, credit, loan) */
  typeOf: Maybe<Scalars['String']['output']>;
  /** Owner user id, so the frontend can bucket by member */
  userId: Maybe<Scalars['ID']['output']>;
};

/** A lifestyle asset or rental property in the raw Savvy plan data */
export type RawSavvyAsset = {
  __typename?: 'RawSavvyAsset';
  /** Raw Savvy asset_class — the FE maps it to the Conquest lifestyle-asset type */
  assetClass: Maybe<Scalars['String']['output']>;
  costBasis: Maybe<Scalars['Float']['output']>;
  description: Maybe<Scalars['String']['output']>;
  marketValue: Maybe<Scalars['Float']['output']>;
  /** The owning member — the FE buckets assets per member (Conquest nests them under members) */
  userId: Maybe<Scalars['ID']['output']>;
};

/** A dependant in the raw Savvy plan data */
export type RawSavvyDependant = {
  __typename?: 'RawSavvyDependant';
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** Raw Savvy relation string (unmapped) */
  relationship: Maybe<Scalars['String']['output']>;
};

/** An income in the raw Savvy plan data, owner-tagged via userId */
export type RawSavvyIncome = {
  __typename?: 'RawSavvyIncome';
  annualAmount: Maybe<Scalars['Float']['output']>;
  employer: Maybe<Scalars['String']['output']>;
  incomeType: Maybe<Scalars['String']['output']>;
  /** Owner user id, so the frontend can bucket by member */
  userId: Maybe<Scalars['ID']['output']>;
};

/** A liability record in the raw Savvy plan data */
export type RawSavvyLiability = {
  __typename?: 'RawSavvyLiability';
  /** Annual interest as a percent (5.0 = 5%) */
  annualInterestPercent: Maybe<Scalars['Float']['output']>;
  currentBalance: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  originalBalance: Maybe<Scalars['Float']['output']>;
  /** Savvy liability type_of enum (e.g. mortgage, line_of_credit) */
  typeOf: Maybe<Scalars['String']['output']>;
};

/** A client or co-client in the raw Savvy plan data */
export type RawSavvyMember = {
  __typename?: 'RawSavvyMember';
  addressLine1: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  city: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  employer: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  maritalStatus: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  retirementDate: Maybe<Scalars['ISO8601Date']['output']>;
  state: Maybe<Scalars['String']['output']>;
  /** Savvy user id, so the frontend can bucket owned items by member */
  userId: Maybe<Scalars['ID']['output']>;
};

/**
 * Raw Savvy plan data for a household — unmapped source fields the frontend maps
 * into the Conquest shape. Read-only; does not call Conquest.
 */
export type RawSavvyPlanData = {
  __typename?: 'RawSavvyPlanData';
  /** All accounts across both members (including credit/loan; the frontend filters) */
  accounts: Array<RawSavvyAccount>;
  /** The primary client */
  client: Maybe<RawSavvyMember>;
  /** The co-client, if the household has one */
  coClient: Maybe<RawSavvyMember>;
  /** Household dependants */
  dependants: Array<RawSavvyDependant>;
  /** The household the data was sourced for */
  householdId: Scalars['ID']['output'];
  /** Incomes across both members, owner-tagged via userId */
  incomes: Array<RawSavvyIncome>;
  /** Liability records across both members */
  liabilities: Array<RawSavvyLiability>;
  /** Non-rental assets across both members */
  lifestyleAssets: Array<RawSavvyAsset>;
  /** Rental real-estate assets across both members */
  rentalProperties: Array<RawSavvyAsset>;
};

/** A real-time (or delayed, per entitlement) market quote from Orion Eclipse. */
export type RealTimePrice = {
  __typename?: 'RealTimePrice';
  /** Current ask price. */
  ask: Scalars['Float']['output'];
  /** Ask size. */
  askQuantity: Scalars['Float']['output'];
  /** Average 30-day volume. */
  averageThirtyDayVolume: Maybe<Scalars['String']['output']>;
  /** Current bid price. */
  bid: Scalars['Float']['output'];
  /** Bid size. */
  bidQuantity: Scalars['Float']['output'];
  /** CUSIP identifier. */
  cusip: Maybe<Scalars['String']['output']>;
  /** Timestamp of the quote (ISO-8601). */
  date: Maybe<Scalars['String']['output']>;
  /** Quote delay in seconds. */
  delay: Scalars['Float']['output'];
  /** Orion price source label (e.g. "Delayed"). */
  eclipsePriceSource: Maybe<Scalars['String']['output']>;
  /** Session high price. */
  high: Scalars['Float']['output'];
  /** True when the quote is delayed (no real-time entitlement). */
  isDelayedQuote: Scalars['Boolean']['output'];
  /** True when the quote is real-time. */
  isRealTimeQuote: Scalars['Boolean']['output'];
  /** Last traded price. */
  last: Scalars['Float']['output'];
  /** Previous session's closing price; reference for the day change. */
  lastClosePrice: Scalars['Float']['output'];
  /** Session low price. */
  low: Scalars['Float']['output'];
  /** Security name. */
  name: Maybe<Scalars['String']['output']>;
  /** Session opening price. */
  open: Scalars['Float']['output'];
  /** Market-data registration/entitlement message. */
  registrationStatusMessage: Maybe<Scalars['String']['output']>;
  /** Ticker symbol. */
  symbol: Maybe<Scalars['String']['output']>;
  /** Session volume. */
  volume: Scalars['Float']['output'];
};

/** Autogenerated input type of ReconcileClientProfileStage */
export type ReconcileClientProfileStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReconcileClientProfileStage. */
export type ReconcileClientProfileStagePayload = {
  __typename?: 'ReconcileClientProfileStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The client_profile.stage after reconciliation */
  clientStage: Scalars['String']['output'];
};

/** End condition for recurring tasks */
export type RecurrenceEndCondition =
  /** by_count */
  | 'by_count'
  /** by_date */
  | 'by_date'
  /** indefinite */
  | 'indefinite';

/** Recurrence frequency for recurring tasks */
export type RecurrenceFrequency =
  /** annually */
  | 'annually'
  /** biweekly */
  | 'biweekly'
  /** daily */
  | 'daily'
  /** monthly */
  | 'monthly'
  /** quarterly */
  | 'quarterly'
  /** semi_annual */
  | 'semi_annual'
  /** weekly */
  | 'weekly';

/** Input for configuring task recurrence */
export type RecurrenceInput = {
  /** Month of year (1..12) for annual recurrences. */
  byMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Day of month (1..31) for monthly/quarterly/annual recurrences anchored to a specific date. */
  byMonthDay?: InputMaybe<Scalars['Int']['input']>;
  /** Ordinal occurrence within month for monthly recurrences (1..5, or -1 for last). Requires a single byday code. */
  bySetPos?: InputMaybe<Scalars['Int']['input']>;
  /** Comma-separated RFC 5545 BYDAY codes (e.g. "FR" or "MO,TU,WE,TH,FR"). */
  byday?: InputMaybe<Scalars['String']['input']>;
  /** When the recurrence ends (defaults to indefinite on create) */
  endCondition?: InputMaybe<RecurrenceEndCondition>;
  /** Number of occurrences (required when end_condition is by_count) */
  endCount?: InputMaybe<Scalars['Int']['input']>;
  /** End date (required when end_condition is by_date) */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Recurrence frequency (daily, weekly, monthly, quarterly, annually) */
  frequency: RecurrenceFrequency;
  /** Interval between occurrences (e.g., every 2 weeks) */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** IANA timezone for scheduling (defaults to America/New_York) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or replacing a RecurrencePattern on a catalog item */
export type RecurrencePatternAttributesInput = {
  /** ISO 8601 date string for the recurrence start (YYYY-MM-DD) */
  dtstart: Scalars['String']['input'];
  /** iCalendar RRULE string (e.g. FREQ=WEEKLY;INTERVAL=1) */
  rrule: Scalars['String']['input'];
};

/** Which way a referral points relative to the acting advisor. */
export type ReferralDirectionEnum =
  /** Clients the advisor referred out to a contact. */
  | 'GIVEN'
  /** Referrals sent to the advisor. */
  | 'RECEIVED';

/** Book-wide referral analytics for the acting advisor */
export type ReferralMetricsSummary = {
  __typename?: 'ReferralMetricsSummary';
  /** Total savvy AUM across converted referrals */
  aumInfluenced: Scalars['BigInt']['output'];
  /** converted / (converted + inFollowUp + lost), or null when no referral carries a bucketed stage */
  conversionRate: Maybe<Scalars['Float']['output']>;
  /** Referred households now at the won stage */
  converted: Scalars['Int']['output'];
  /** Referred households still in an open stage */
  inFollowUp: Scalars['Int']['output'];
  /** Referred households at a lost or disqualified stage */
  lost: Scalars['Int']['output'];
  /** Every referral received, including households in stages that fall into no outcome bucket */
  referralsIn: Scalars['Int']['output'];
  /** Per-source totals, ordered by referral count descending */
  topSources: Array<ReferralSourceStat>;
};

/** An outcome bucket for a referred household, matching the At-a-glance totals. */
export type ReferralOutcomeEnum =
  | 'CONVERTED'
  | 'IN_FOLLOW_UP'
  | 'LOST';

/** Referral totals for a single referral source in the advisor's book */
export type ReferralSourceStat = {
  __typename?: 'ReferralSourceStat';
  /** Total savvy AUM across this source's converted referrals */
  aumInfluenced: Scalars['BigInt']['output'];
  /** Referrals from this source now at the won stage */
  converted: Scalars['Int']['output'];
  /** Stable key for the source, formatted "<SourceType>:<id>" */
  id: Scalars['ID']['output'];
  /** Referrals from this source still in an open stage */
  inFollowUp: Scalars['Int']['output'];
  /** Referrals from this source at a lost or disqualified stage */
  lost: Scalars['Int']['output'];
  /** Referrals received from this source */
  referrals: Scalars['Int']['output'];
  /** The referring party — a client User or a CenterOfInfluenceRep */
  source: ProfessionalRelationshipSource;
};

/** Autogenerated input type of RefreshProviderAccount */
export type RefreshProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ProviderAccount to refresh. */
  providerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of RefreshProviderAccount. */
export type RefreshProviderAccountPayload = {
  __typename?: 'RefreshProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Short-lived token for the appropriate Connect SDK (Plaid Link or @moneykit/connect). */
  linkToken: Scalars['String']['output'];
};

/** Autogenerated input type of RegenerateMeetingSummary */
export type RegenerateMeetingSummaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The recap template to regenerate from; omit for the built-in outline */
  meetingAgendaTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** The Savvy meeting summary to regenerate */
  meetingSummaryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateMeetingSummary. */
export type RegenerateMeetingSummaryPayload = {
  __typename?: 'RegenerateMeetingSummaryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The summary being regenerated, unchanged until the job lands */
  meetingSummary: MeetingSummary;
  /** The status of the queued regeneration */
  status: MeetingSummaryRegenerationStatus;
};

/** Autogenerated input type of RegenerateStaleServiceCatalogTasks */
export type RegenerateStaleServiceCatalogTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item id */
  serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateStaleServiceCatalogTasks. */
export type RegenerateStaleServiceCatalogTasksPayload = {
  __typename?: 'RegenerateStaleServiceCatalogTasksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of pending tasks refreshed */
  refreshedCount: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of RegisterPushToken */
export type RegisterPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device platform: ios or android */
  platform: Scalars['String']['input'];
  /** Expo push token for this device */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of RegisterPushToken. */
export type RegisterPushTokenPayload = {
  __typename?: 'RegisterPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the registration succeeded */
  success: Scalars['Boolean']['output'];
};

/** Type of account registration */
export type RegistrationTypeName =
  /** individual */
  | 'individual'
  /** joint_tenants_with_rights_of_survivorship */
  | 'joint_tenants_with_rights_of_survivorship';

/** Autogenerated input type of ReissueEnvelopeWithCurrentPhone */
export type ReissueEnvelopeWithCurrentPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReissueEnvelopeWithCurrentPhone. */
export type ReissueEnvelopeWithCurrentPhonePayload = {
  __typename?: 'ReissueEnvelopeWithCurrentPhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RejectScheduledReportExecution */
export type RejectScheduledReportExecutionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ReportScheduleExecution IDs to reject */
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RejectScheduledReportExecution. */
export type RejectScheduledReportExecutionPayload = {
  __typename?: 'RejectScheduledReportExecutionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** One error message per failed id, in the same order as failed_ids */
  errors: Array<Scalars['String']['output']>;
  /** IDs that were no longer pending review */
  failedIds: Array<Scalars['ID']['output']>;
  /** IDs that were rejected */
  rejectedIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of ReleaseOnboardingToSend */
export type ReleaseOnboardingToSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The awaiting-ops household to release. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReleaseOnboardingToSend. */
export type ReleaseOnboardingToSendPayload = {
  __typename?: 'ReleaseOnboardingToSendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The household after the release. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RelinkSignedEnvelope */
export type RelinkSignedEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The correct signed DocuSign envelope ID to link. */
  envelopeId: Scalars['String']['input'];
  /** The blocked staged household to repair. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of RelinkSignedEnvelope. */
export type RelinkSignedEnvelopePayload = {
  __typename?: 'RelinkSignedEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RemoveAdvisorFromAdvisorGroup */
export type RemoveAdvisorFromAdvisorGroupInput = {
  /** ID of the advisor group to remove the advisor from */
  advisorGroupId: Scalars['ID']['input'];
  /** User ID of the advisor to remove */
  advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAdvisorFromAdvisorGroup. */
export type RemoveAdvisorFromAdvisorGroupPayload = {
  __typename?: 'RemoveAdvisorFromAdvisorGroupPayload';
  /** The advisor group the advisor was removed from */
  advisorGroup: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveAdvisorsFromOrganization */
export type RemoveAdvisorsFromOrganizationInput = {
  advisorUserIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAdvisorsFromOrganization. */
export type RemoveAdvisorsFromOrganizationPayload = {
  __typename?: 'RemoveAdvisorsFromOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Scalars['String']['output']>;
  organization: Maybe<Organization>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveHouseholdMember */
export type RemoveHouseholdMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household membership to remove. */
  membershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveHouseholdMember. */
export type RemoveHouseholdMemberPayload = {
  __typename?: 'RemoveHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the membership was destroyed. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveNotificationAlertMute */
export type RemoveNotificationAlertMuteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The mute to remove. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveNotificationAlertMute. */
export type RemoveNotificationAlertMutePayload = {
  __typename?: 'RemoveNotificationAlertMutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the mute was removed. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveOnboardingHousehold */
export type RemoveOnboardingHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to remove. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOnboardingHousehold. */
export type RemoveOnboardingHouseholdPayload = {
  __typename?: 'RemoveOnboardingHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household was removed from the cockpit. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveServiceCatalogItemFromGroup */
export type RemoveServiceCatalogItemFromGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item group id */
  serviceCatalogItemGroupId: Scalars['ID']['input'];
  /** Service catalog item id */
  serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveServiceCatalogItemFromGroup. */
export type RemoveServiceCatalogItemFromGroupPayload = {
  __typename?: 'RemoveServiceCatalogItemFromGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** ID of the deleted membership, if one existed */
  deletedMembershipId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of RemoveStagedCoClient */
export type RemoveStagedCoClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged co-client to remove. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveStagedCoClient. */
export type RemoveStagedCoClientPayload = {
  __typename?: 'RemoveStagedCoClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The id of the removed staged co-client. */
  deletedId: Maybe<Scalars['ID']['output']>;
  /** Whether the staged co-client was removed. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveStagedHousehold */
export type RemoveStagedHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to remove. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveStagedHousehold. */
export type RemoveStagedHouseholdPayload = {
  __typename?: 'RemoveStagedHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The id of the removed staged household. */
  deletedId: Maybe<Scalars['ID']['output']>;
  /** Whether the staged household was removed. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveTaskRecurrence */
export type RemoveTaskRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, also delete the open occurrences in the series with instance_date
   * after the acted-on task. The acted-on occurrence and every earlier one (past,
   * today, completed) are kept, as is the series template. When false/omitted, the
   * recurrence is ended but existing occurrences are left in place.
   */
  removeUpcomingOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Savvy task ID (UUID) */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTaskRecurrence. */
export type RemoveTaskRecurrencePayload = {
  __typename?: 'RemoveTaskRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The updated task. Null if the acted-on task was itself a removed future occurrence. */
  task: Maybe<Task>;
};

/** Autogenerated input type of RenewInvite */
export type RenewInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteToken: Scalars['String']['input'];
  taskType: TaskTypeName;
};

/** Autogenerated return type of RenewInvite. */
export type RenewInvitePayload = {
  __typename?: 'RenewInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReorderServiceCatalogItemHouseholds */
export type ReorderServiceCatalogItemHouseholdsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  householdId: Scalars['ID']['input'];
  /** Assignment IDs in the desired display order */
  orderedIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReorderServiceCatalogItemHouseholds. */
export type ReorderServiceCatalogItemHouseholdsPayload = {
  __typename?: 'ReorderServiceCatalogItemHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Assignments in their new order */
  serviceCatalogItemHouseholds: Array<ServiceCatalogItemHousehold>;
};

/** Autogenerated input type of ReorderSubtask */
export type ReorderSubtaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the sub-task to reorder. */
  id: Scalars['ID']['input'];
  /** The 1-indexed position the sub-task should occupy among its siblings. Clamped to [1, sibling_count]. */
  newPosition: Scalars['Int']['input'];
};

/** Autogenerated return type of ReorderSubtask. */
export type ReorderSubtaskPayload = {
  __typename?: 'ReorderSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The reordered sub-task with its updated position. */
  subtask: Maybe<Subtask>;
  /** The parent task. Returned so clients can refresh the sub-task list. Its status is NOT mutated by this mutation. */
  task: Maybe<Task>;
};

/**
 * Status of a single repaper envelope. docusignLink is nil while the
 * CreateDocusignEnvelopeWorker is still creating the envelope.
 */
export type RepaperEnvelopeStatus = {
  __typename?: 'RepaperEnvelopeStatus';
  /** DocuSign URL for the envelope, or nil while the worker is still processing */
  docusignLink: Maybe<Scalars['String']['output']>;
  /** Failure detail when failed is true; nil otherwise. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /**
   * True when orchestration failed for this tracking ID — the client should stop
   * polling and surface the error instead of waiting out the timeout.
   */
  failed: Scalars['Boolean']['output'];
  /** Tracking ID returned from createRepaperEnvelope */
  trackingId: Scalars['ID']['output'];
};

/** Presigned S3 PUT URL grant for uploading a single repaper PDF (HAWK-70). */
export type RepaperPdfUploadGrant = {
  __typename?: 'RepaperPdfUploadGrant';
  /** When this presigned URL stops accepting uploads. */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** S3 object key the FE passes to createRepaperEnvelope as formDocuments[].s3Key. */
  s3Key: Scalars['String']['output'];
  /** Presigned S3 PUT URL the FE uses to upload PDF bytes directly (15 min TTL). */
  uploadUrl: Scalars['String']['output'];
};

/**
 * Native rebuild of the Orion-generated Performance Report (Unified). Provides all
 * data needed to render the multi-page PDF — replaces the Orion path when
 * feature-flagged on (HAWK-25).
 */
export type Report = {
  __typename?: 'Report';
  /** Per-account blocks for the 'Account Performance' section. */
  accountPerformance: Array<AccountPerformance>;
  /** Primary advisor's display name shown on the cover. */
  advisorName: Maybe<Scalars['String']['output']>;
  /**
   * Series for the 'Performance vs Benchmark' chart and table — household plus
   * Morningstar Target Risk benchmarks. Empty when benchmark data is unavailable
   * for this household.
   */
  benchmarkSeries: Array<BenchmarkSeries>;
  /** When the underlying performance snapshot was last refreshed. */
  dataLastUpdated: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Inclusive end date of the report. */
  endDate: Scalars['ISO8601Date']['output'];
  /**
   * Branded firm name shown on the cover (e.g. "Colorado Wealth Group"). Falls
   * back to "Savvy" when the household's advisor has no organization branding.
   */
  firmDisplayName: Scalars['String']['output'];
  /**
   * Branded firm logo URL shown on the cover. Falls back to the Savvy logo when
   * the household's advisor has no organization branding.
   */
  firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and section headers. */
  householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + accounts + date range). */
  id: Scalars['ID']['output'];
  /** Earliest funded date across the report's accounts; used for the 'Since Inception' column header. */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily points for the 'Market Value and Net Additions' chart, filtered to the report date range. */
  marketValueSeries: Array<MarketValuePoint>;
  /** Slices of the household portfolio allocation pie, summing to 100%. */
  portfolioAllocation: Array<AllocationSlice>;
  /** Quarter-by-quarter time-weighted returns for the 'Cumulative Performance and Quarterly Returns' bar chart. */
  quarterlyReturns: Array<QuarterlyReturn>;
  /** Inclusive start date of the report. */
  startDate: Scalars['ISO8601Date']['output'];
  /** Rows of the Portfolio Value Summary table — one per period (YTD, last 12 months, last 3 years, since inception). */
  valueSummaryRows: Array<ValueSummaryRow>;
};

/** Curated font families available for advisor report branding */
export type ReportFontFamilyEnum =
  /** Georgia */
  | 'GEORGIA'
  /** Inter */
  | 'INTER'
  /** Merriweather */
  | 'MERRIWEATHER'
  /** Playfair Display */
  | 'PLAYFAIR_DISPLAY';

/** Font size scale presets applied across generated advisor reports and proposals */
export type ReportFontSizeScaleEnum =
  /** Standard font sizes across generated reports and proposals */
  | 'DEFAULT'
  /** Larger font sizes across generated reports and proposals */
  | 'LARGE'
  /** Smaller font sizes across generated reports and proposals */
  | 'SMALL';

/** Automated delivery schedule for a saved report template. */
export type ReportSchedule = {
  __typename?: 'ReportSchedule';
  /** Whether the schedule is currently enabled */
  active: Scalars['Boolean']['output'];
  /** When the schedule was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The advisor who created this schedule */
  createdByUserId: Scalars['ID']['output'];
  /** Whether to upload generated PDFs to Box */
  deliverToBox: Scalars['Boolean']['output'];
  /** Whether to publish generated reports to the client portal */
  deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  deliveryMonth: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  frequency: Scalars['String']['output'];
  /** The unique identifier for the report schedule */
  id: Scalars['ID']['output'];
  /** When the schedule last fired */
  lastRunAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  nextDueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Custom PDF filename pattern; null uses the default pattern */
  pdfFilenamePattern: Maybe<Scalars['String']['output']>;
  /** Whether generated reports need advisor approval before delivery */
  requireReview: Scalars['Boolean']['output'];
  /** The saved template this schedule automates */
  savedReportTemplateId: Scalars['ID']['output'];
  /** When the schedule was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Audit record for a single scheduled report generation run. */
export type ReportScheduleExecution = {
  __typename?: 'ReportScheduleExecution';
  /** Box file ID once delivered to the household's own Box folder */
  boxFileId: Maybe<Scalars['String']['output']>;
  /** When execution completed or failed */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the execution record was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Error detail when status is failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The household the report was generated for */
  householdId: Scalars['ID']['output'];
  /** The household's display name, for the Pending Reviews table. */
  householdName: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the execution record */
  id: Scalars['ID']['output'];
  /** Authenticated URL to preview/download the generated PDF; present once attached. */
  pdfDownloadUrl: Maybe<Scalars['String']['output']>;
  /** Published report ID if portal delivery succeeded */
  publishedReportId: Maybe<Scalars['ID']['output']>;
  /** The parent schedule that triggered this run */
  reportScheduleId: Scalars['ID']['output'];
  /** Box file ID of the advisor's private review-folder copy, present while pending_review; distinct from box_file_id. */
  reviewBoxFileId: Maybe<Scalars['String']['output']>;
  /** The advisor's Box review folder, for the Pending Reviews table header link. */
  reviewBoxFolderUrl: Maybe<Scalars['String']['output']>;
  /** Template name for display in advisor client reports tab. */
  savedReportTemplateName: Maybe<Scalars['String']['output']>;
  /** When execution started */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Execution status: pending, processing, pending_review, completed, rejected, or failed */
  status: Scalars['String']['output'];
};

/** Product holding reported by performance reporting software - (Orion). */
export type ReportedHolding = {
  __typename?: 'ReportedHolding';
  /** The Savvy account ID this holding belongs to */
  accountId: Maybe<Scalars['ID']['output']>;
  /** The Savvy account sleeve ID this holding belongs to */
  accountSleeveId: Maybe<Scalars['ID']['output']>;
  assetCategory: Maybe<Scalars['String']['output']>;
  assetClass: Maybe<Scalars['String']['output']>;
  costBasis: Maybe<Scalars['BigDecimal']['output']>;
  costBasisLots: Maybe<Array<CostBasisLot>>;
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  name: Scalars['String']['output'];
  /** Percent allocation of total parent entity value. */
  percent: Maybe<Scalars['BigDecimal']['output']>;
  performanceOverTime: Array<Performance>;
  /** Current price for the units in this holding. Usually from last market close. */
  priceUsd: Maybe<Scalars['BigDecimal']['output']>;
  /** Current quantity of this holding. */
  quantity: Maybe<Scalars['BigDecimal']['output']>;
  riskCategory: Maybe<Scalars['String']['output']>;
  ticker: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** Most recent value of this holding. Usually from last market close. */
  value: Maybe<ReportedHoldingValue>;
};

/** Monetary value. */
export type ReportedHoldingValue = {
  __typename?: 'ReportedHoldingValue';
  /** The numerical amount of monetary value. */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency codes and unofficial currency codes. */
  currencyCode: Scalars['String']['output'];
};

/** Autogenerated input type of RequestPastTranscriptsFromApril */
export type RequestPastTranscriptsFromAprilInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Transcript request input */
  input: RequestTranscriptInput;
};

/** Autogenerated return type of RequestPastTranscriptsFromApril. */
export type RequestPastTranscriptsFromAprilPayload = {
  __typename?: 'RequestPastTranscriptsFromAprilPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** URL to the consent form */
  consentFormUrl: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors: Maybe<Scalars['String']['output']>;
  /** Success or not */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestRepaperPdfUploadUrls */
export type RequestRepaperPdfUploadUrlsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Number of upload URLs to issue (1-50). Matches the number of pre-filled PDFs the FE has for a single household. */
  formCount: Scalars['Int']['input'];
};

/** Autogenerated return type of RequestRepaperPdfUploadUrls. */
export type RequestRepaperPdfUploadUrlsPayload = {
  __typename?: 'RequestRepaperPdfUploadUrlsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Ordered list of upload grants. FE PUTs each PDF to the matching upload_url and sends s3_key as formDocuments[].s3Key. */
  grants: Array<RepaperPdfUploadGrant>;
};

/** Input for requesting an IRS transcript via April */
export type RequestTranscriptInput = {
  /** Address line 1 */
  addressLine1: Scalars['String']['input'];
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** If client has accepted April's terms and conditions */
  aprilTermsAccepted: Scalars['Boolean']['input'];
  /**
   * Base64-encoded wet signature image. WARNING: Only reuse a stored signature if
   * the transcript request data has not changed since it was captured. Any change
   * requires a new signature.
   */
  base64ImageSignature?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** date of birth */
  dateOfBirth: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** phone number */
  phoneNumber: Scalars['String']['input'];
  /** Signature date (YYYY-MM-DD) */
  signatureDate: Scalars['String']['input'];
  /** Social security number */
  socialSecurityNumber: Scalars['String']['input'];
  /** State */
  state: Scalars['String']['input'];
  /**
   * Typed full name as signature. WARNING: Only reuse a stored signature if the
   * transcript request data has not changed since it was captured. Any change
   * requires a new signature.
   */
  textSignature?: InputMaybe<Scalars['String']['input']>;
  /** Transcript type (e.g., INDIVIDUAL) */
  transcriptType: Scalars['String']['input'];
  /** User who's information we are editing */
  userId: Scalars['ID']['input'];
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

/** The variant of an account maintenance request */
export type RequestTypeName =
  /** account_consolidation */
  | 'account_consolidation'
  /** add_advisor_to_account */
  | 'add_advisor_to_account'
  /** add_options_and_margin */
  | 'add_options_and_margin'
  /** beneficiary_update */
  | 'beneficiary_update'
  /** link_a_bank */
  | 'link_a_bank';

/** Autogenerated input type of RescheduleServiceOccurrence */
export type RescheduleServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new occurrence date. Today or later */
  date: Scalars['ISO8601Date']['input'];
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  revision: Scalars['String']['input'];
};

/** Autogenerated return type of RescheduleServiceOccurrence. */
export type RescheduleServiceOccurrencePayload = {
  __typename?: 'RescheduleServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The occurrence at its new date, or null once it no longer belongs to the household stream */
  occurrence: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ReseedDemoEnvironment */
export type ReseedDemoEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Shape of the book to build. Omit for the defaults. */
  options?: InputMaybe<DemoReseedOptions>;
};

/** Autogenerated return type of ReseedDemoEnvironment. */
export type ReseedDemoEnvironmentPayload = {
  __typename?: 'ReseedDemoEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The queued reseed. Poll demoReseedRun with its id. */
  run: DemoReseedRun;
};

/** Autogenerated input type of ResendDocusignEnvelope */
export type ResendDocusignEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** DocuSign envelope ID to resend a reminder for */
  envelopeId: Scalars['String']['input'];
};

/** Autogenerated return type of ResendDocusignEnvelope. */
export type ResendDocusignEnvelopePayload = {
  __typename?: 'ResendDocusignEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** When the throttle window opens (set when the call was throttled) */
  nextResendAvailableAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the reminder was queued */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendEmail */
export type ResendEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailType: Email;
};

/** Autogenerated return type of ResendEmail. */
export type ResendEmailPayload = {
  __typename?: 'ResendEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendOnboardingInvite */
export type ResendOnboardingInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which clients to resend to, from OnboardingCockpitRow.inviteRecipients. Omit
   * to resend to every eligible client on the household.
   */
  clientOnboardingRequestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The staged household to resend the invite for. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendOnboardingInvite. */
export type ResendOnboardingInvitePayload = {
  __typename?: 'ResendOnboardingInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** The clients that were emailed. */
  resentTo: Maybe<Array<InviteRecipient>>;
  /**
   * Selected clients that were not emailed — either they have no email on file, or
   * they already submitted. Their links are left untouched.
   */
  skipped: Maybe<Array<InviteRecipient>>;
  /** The staged household after resend. */
  stagedHousehold: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the resend succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendOtp */
export type ResendOtpInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

/** Autogenerated return type of ResendOtp. */
export type ResendOtpPayload = {
  __typename?: 'ResendOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResendServiceCatalogReminder */
export type ResendServiceCatalogReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ServiceCatalogItemHousehold id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendServiceCatalogReminder. */
export type ResendServiceCatalogReminderPayload = {
  __typename?: 'ResendServiceCatalogReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated assignment */
  serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
};

/** Autogenerated input type of ResendServiceOccurrenceReminder */
export type ResendServiceOccurrenceReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  revision: Scalars['String']['input'];
};

/** Autogenerated return type of ResendServiceOccurrenceReminder. */
export type ResendServiceOccurrenceReminderPayload = {
  __typename?: 'ResendServiceOccurrenceReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The occurrence after the send, or null once it no longer belongs to the household stream */
  occurrence: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ResetClientIntakeData */
export type ResetClientIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resetToInvited?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ResetClientIntakeData. */
export type ResetClientIntakeDataPayload = {
  __typename?: 'ResetClientIntakeDataPayload';
  clientIntakeData: ClientIntakeData;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResetDemoHousehold */
export type ResetDemoHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetDemoHousehold. */
export type ResetDemoHouseholdPayload = {
  __typename?: 'ResetDemoHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  household: Maybe<Household>;
  softError: Maybe<DemoProspectResetterError>;
};

/** Autogenerated input type of ResetNotificationRouting */
export type ResetNotificationRoutingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user whose catalog notification routing to reset. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetNotificationRouting. */
export type ResetNotificationRoutingPayload = {
  __typename?: 'ResetNotificationRoutingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Effective catalog notification routing after the reset. */
  routing: Array<NotificationRoutePreference>;
  /** Whether the reset succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  /** email of user to reset */
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** success */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetServiceCalendar */
export type ResetServiceCalendarInput = {
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ResetServiceCalendar. */
export type ResetServiceCalendarPayload = {
  __typename?: 'ResetServiceCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetTaskNotificationRouting */
export type ResetTaskNotificationRoutingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResetTaskNotificationRouting. */
export type ResetTaskNotificationRoutingPayload = {
  __typename?: 'ResetTaskNotificationRoutingPayload';
  /** Effective task routing cells after the reset (all defaults). */
  cells: Array<NotificationTaskRoutingCell>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the reset succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResolveContributionAlert */
export type ResolveContributionAlertInput = {
  /** The ContributionReceived alert the advisor acted on */
  alertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The task created from that action */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveContributionAlert. */
export type ResolveContributionAlertPayload = {
  __typename?: 'ResolveContributionAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResubmitEciRemediation */
export type ResubmitEciRemediationInput = {
  /** Full beneficiary list to persist; replaces any existing beneficiaries */
  beneficiaries?: InputMaybe<Array<EciBeneficiaryInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Joint/TIC ownership details. Also updates registrationType, which
   * jointAccountType derives — the one slice that writes a field the form
   * otherwise renders read-only.
   */
  jointOwnership?: InputMaybe<EciJointOwnershipInput>;
  /** Per-owner personal information and/or citizenship & tax status edits */
  owners?: InputMaybe<Array<EciRemediationOwnerInput>>;
  /** The remediation Subtask being resubmitted. The onboarding request is derived from it. */
  subtaskId: Scalars['ID']['input'];
  /** Delivering-firm details for the TOA leg */
  transferFundingSource?: InputMaybe<EciTransferFundingSourceInput>;
  /** Trust legal information */
  trust?: InputMaybe<EciTrustDetailsInput>;
};

/** Autogenerated return type of ResubmitEciRemediation. */
export type ResubmitEciRemediationPayload = {
  __typename?: 'ResubmitEciRemediationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** All validation errors across every slice, collected together */
  errors: Array<Scalars['String']['output']>;
  /** Whether every slice persisted and the event was emitted */
  success: Scalars['Boolean']['output'];
};

export type RetirementPlan = {
  __typename?: 'RetirementPlan';
  /** Advisor-defined freeform notes about this plan */
  additionalNotes: Maybe<Scalars['String']['output']>;
  /** Sponsor address(es) */
  address: Maybe<Scalars['String']['output']>;
  /** Date the advisory relationship began */
  advisoryEffectiveDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Advisory type (e.g. 3(38), 3(21)) */
  advisoryType: Maybe<Scalars['String']['output']>;
  /** Annual fee in dollars */
  annualFee: Maybe<Scalars['Float']['output']>;
  /** Annual fee as a percentage */
  annualFeePercent: Maybe<Scalars['Float']['output']>;
  /** Billing method (e.g. 'Sponsor pays fee directly to Advisor') */
  billingMethod: Maybe<Scalars['String']['output']>;
  /** Plan contacts grouped by role */
  contacts: Array<RetirementPlanContact>;
  /** Name of the person who signed the contract */
  contractSignedBy: Maybe<Scalars['String']['output']>;
  /** Date the contract was signed */
  contractSignedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Corporate structure (e.g. PLLC, LLC, S-Corp) */
  corporateStructure: Maybe<Scalars['String']['output']>;
  /** When the plan was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest plan assets from quarterly snapshot */
  currentAssets: Maybe<Scalars['Float']['output']>;
  /** Latest participant count from quarterly snapshot */
  currentParticipantCount: Maybe<Scalars['Int']['output']>;
  /** Plan design details (eligibility, payroll, testing, match/vesting). Null until first saved. */
  design: Maybe<RetirementPlanDesign>;
  /** Employer Identification Number */
  ein: Maybe<Scalars['String']['output']>;
  /** Source of fee payment */
  feeSource: Maybe<Scalars['String']['output']>;
  /** Fee structure description */
  feeStructure: Maybe<Scalars['String']['output']>;
  /** Fiduciary type (e.g. 3(21), 3(38)) */
  fiduciaryType: Maybe<Scalars['String']['output']>;
  /** Quarterly financial snapshots ordered by as_of_date DESC */
  financialSnapshots: Array<PlanFinancialSnapshot>;
  /** Health band derived from risk_score: healthy (≥80), watch (50–79), at_risk (<50). Null when no milestones exist. */
  healthBand: Maybe<Scalars['String']['output']>;
  /** Linked household, if any */
  household: Maybe<Household>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Professional relationship edges targeting this plan (e.g. Professional Contacts that serve it) */
  incomingProfessionalRelationships: Array<ProfessionalRelationship>;
  /**
   * Advisors selectable as "logged by" — the plan's own organization, or the
   * viewer's own organization when viewing via a share
   */
  loggableAdvisors: Array<AssignableAdvisor>;
  /** Compliance milestones ordered by due_date ASC */
  milestones: Array<RetirementPlanMilestone>;
  /** Plan name */
  name: Scalars['String']['output'];
  /** Plan notes ordered by noted_on DESC */
  notes: Array<RetirementPlanNote>;
  /** Plan owners/partners */
  owners: Maybe<Scalars['String']['output']>;
  /** Parent company name */
  parentCompany: Maybe<Scalars['String']['output']>;
  /** Participant interaction logs ordered by logged_on DESC */
  participantLogs: Array<RetirementPlanParticipantLog>;
  /** Date the plan was established */
  planInceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Human-readable plan identifier (e.g. PLAN-0421) */
  planNumber: Scalars['String']['output'];
  /** Plan type (e.g. 401(k), 403(b)) */
  planType: Maybe<Scalars['String']['output']>;
  /** Plan year end date */
  planYearEnd: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prior employers whose service counts toward eligibility */
  predecessorService: Maybe<Scalars['String']['output']>;
  /** Special projects, optionally instantiated from a project template */
  projects: Array<RetirementPlanProject>;
  /** Recordkeeper name */
  recordkeeper: Maybe<Scalars['String']['output']>;
  /** Plan ID at the recordkeeper */
  recordkeeperPlanId: Maybe<Scalars['String']['output']>;
  /** Computed health score (0–100). Null when no milestones exist. */
  riskScore: Maybe<Scalars['Int']['output']>;
  /** Service type */
  serviceType: Maybe<Scalars['String']['output']>;
  /** The organization that shared this plan with the viewer's organization, if the viewer is accessing it via a share */
  sharedByOrganization: Maybe<ShareableOrganization>;
  /** Organizations this plan has been shared with */
  sharedWithOrganizations: Array<ShareableOrganization>;
  /** Health status: on_track | at_risk | overdue */
  status: Scalars['String']['output'];
  /** Third-party administrator name */
  tpa: Maybe<Scalars['String']['output']>;
  /** When the plan was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Sponsor's website */
  website: Maybe<Scalars['String']['output']>;
};

export type RetirementPlanContact = {
  __typename?: 'RetirementPlanContact';
  /** Whether this contact is still active on the plan */
  active: Scalars['Boolean']['output'];
  /** Company this contact belongs to (free text) */
  companyName: Maybe<Scalars['String']['output']>;
  /** Group: plan_sponsor | service_provider | internal_team | other */
  contactGroup: Scalars['String']['output'];
  /** When the contact was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email address */
  email: Maybe<Scalars['String']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Contact name */
  name: Scalars['String']['output'];
  /** Free-text notes about this contact */
  notes: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Job title */
  title: Maybe<Scalars['String']['output']>;
  /** When the contact was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanDesign = {
  __typename?: 'RetirementPlanDesign';
  /** ADP/ACP test method (current year / prior year) */
  adpAcpTestMethod: Maybe<Scalars['String']['output']>;
  /** Automatic enrollment terms, if any */
  automaticEnrollment: Maybe<Scalars['String']['output']>;
  /** Compensation definition (e.g. W-2, 415, 3401(a)) */
  compensationDefinition: Maybe<Scalars['String']['output']>;
  /** Compensation exclusions */
  compensationExclusions: Maybe<Scalars['String']['output']>;
  /** When the design was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Default deferral percentage under automatic enrollment */
  defaultDeferralPercentage: Maybe<Scalars['Float']['output']>;
  /** Deferral eligibility rule */
  deferralEligibility: Maybe<Scalars['String']['output']>;
  /** Deferral entry dates */
  deferralEntryDates: Maybe<Scalars['String']['output']>;
  /** Employee classes excluded from the plan */
  excludedEmployeeClasses: Maybe<Scalars['String']['output']>;
  /** HCE determination method */
  hceDetermination: Maybe<Scalars['String']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Match eligibility rule */
  matchEligibility: Maybe<Scalars['String']['output']>;
  /** Match entry dates */
  matchEntryDates: Maybe<Scalars['String']['output']>;
  /** Match formula */
  matchFormula: Maybe<Scalars['String']['output']>;
  /** Match vesting schedule */
  matchVestingSchedule: Maybe<Scalars['String']['output']>;
  /** Payroll frequency */
  payrollFrequency: Maybe<Scalars['String']['output']>;
  /** Payroll provider (e.g. Paycom, ADP) */
  payrollProvider: Maybe<Scalars['String']['output']>;
  /** Profit sharing eligibility rule */
  profitSharingEligibility: Maybe<Scalars['String']['output']>;
  /** Profit sharing entry dates */
  profitSharingEntryDates: Maybe<Scalars['String']['output']>;
  /** Profit sharing formula */
  profitSharingFormula: Maybe<Scalars['String']['output']>;
  /** Profit sharing vesting schedule */
  profitSharingVestingSchedule: Maybe<Scalars['String']['output']>;
  /** Safe harbor terms, if any */
  safeHarbor: Maybe<Scalars['String']['output']>;
  /** When the design was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanMilestone = {
  __typename?: 'RetirementPlanMilestone';
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  category: Maybe<Scalars['String']['output']>;
  /** When the milestone was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Due date */
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether this milestone was auto-generated from a template */
  fromTemplate: Scalars['Boolean']['output'];
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Advisor team member who logged this entry */
  loggedBy: Maybe<AssignableAdvisor>;
  /** Milestone name */
  name: Scalars['String']['output'];
  /** Free-text notes */
  notes: Maybe<Scalars['String']['output']>;
  /** Plan contact responsible for this milestone */
  owner: Maybe<RetirementPlanContact>;
  /** Status: on_track | due_soon | overdue | done */
  status: Scalars['String']['output'];
  /** When the milestone was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanNote = {
  __typename?: 'RetirementPlanNote';
  /** Contact who authored this note */
  author: Maybe<RetirementPlanContact>;
  /** Note body text */
  body: Scalars['String']['output'];
  /** When the note was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Date the note applies to */
  notedOn: Scalars['ISO8601Date']['output'];
  /** Optional note title (e.g. meeting name) */
  title: Maybe<Scalars['String']['output']>;
  /** When the note was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Retirement Plan Onboarding variant */
export type RetirementPlanOnboardingInput = {
  /** Current recordkeeper (required when onboarding_type is recordkeeper_change) */
  currentRecordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Estimated plan AUM */
  estimatedPlanAum?: InputMaybe<Scalars['Float']['input']>;
  /** New recordkeeper */
  newRecordkeeper: Scalars['String']['input'];
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Number of participants */
  numberOfParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** New plan or recordkeeper change */
  onboardingType: CorporateRetirementPlanOnboardingTypeName;
  /** Plan effective date */
  planEffectiveDate: Scalars['ISO8601Date']['input'];
  /** Plan name */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** Plan sponsor contact email */
  planSponsorContactEmail: Scalars['String']['input'];
  /** Plan sponsor contact name */
  planSponsorContactName: Scalars['String']['input'];
};

export type RetirementPlanParticipantLog = {
  __typename?: 'RetirementPlanParticipantLog';
  /** Follow-up action item */
  actionItem: Maybe<Scalars['String']['output']>;
  /** When the log was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Type: education_meeting | enrollment_question | loan_question | distribution_request | follow_up | call | zoom | email */
  interactionType: Scalars['String']['output'];
  /** Advisor team member who logged this entry */
  loggedBy: Maybe<AssignableAdvisor>;
  /** Date of the interaction */
  loggedOn: Scalars['ISO8601Date']['output'];
  /** Free-text notes about the interaction */
  notes: Maybe<Scalars['String']['output']>;
  /** Plan contact who handled this interaction */
  owner: Maybe<RetirementPlanContact>;
  /** Participant email address */
  participantEmail: Maybe<Scalars['String']['output']>;
  /** Participant full name */
  participantName: Scalars['String']['output'];
  /** Participant phone number */
  participantPhone: Maybe<Scalars['String']['output']>;
  /** When the log was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProject = {
  __typename?: 'RetirementPlanProject';
  /** When the project was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Project description */
  description: Maybe<Scalars['String']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Project name */
  name: Scalars['String']['output'];
  /** The retirement plan this project belongs to */
  retirementPlan: RetirementPlan;
  /** Ordered checklist rows for this project */
  rows: Array<RetirementPlanProjectRow>;
  /** Anchor date row due dates were computed from, when created from a template */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Project status */
  status: Maybe<Scalars['String']['output']>;
  /** The template this project was created from, if any */
  template: Maybe<RetirementPlanProjectTemplate>;
  /** When the project was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectRow = {
  __typename?: 'RetirementPlanProjectRow';
  /** Advisor from the plan organization assigned to this row */
  assignee: Maybe<AssignableAdvisor>;
  /** When the row was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this row is due */
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Row name (e.g. "Termination Notice") */
  name: Scalars['String']['output'];
  /** Free-text notes for this row */
  notes: Maybe<Scalars['String']['output']>;
  /** Zero-based ordering of this row within the project */
  position: Scalars['Int']['output'];
  /** The organization responsible for this row (e.g. "Schwab", "Newport") */
  responsibleOrg: Maybe<Scalars['String']['output']>;
  /** The project this row belongs to */
  retirementPlanProject: RetirementPlanProject;
  /** Status: todo | in_progress | done | cancelled */
  status: Scalars['String']['output'];
  /** The task created from this row, if any */
  task: Maybe<Task>;
  /** When the row was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectTemplate = {
  __typename?: 'RetirementPlanProjectTemplate';
  /** When the template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Template description */
  description: Maybe<Scalars['String']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Template name */
  name: Scalars['String']['output'];
  /** Organization this template belongs to */
  organization: Organization;
  /** Ordered steps in this template */
  steps: Array<RetirementPlanProjectTemplateStep>;
  /** When the template was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectTemplateStep = {
  __typename?: 'RetirementPlanProjectTemplateStep';
  /** Days relative to the project start date this step is due */
  dueDateOffsetDays: Maybe<Scalars['Int']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Step name (e.g. "Termination Notice") */
  name: Scalars['String']['output'];
  /** Free-text notes for this step */
  notes: Maybe<Scalars['String']['output']>;
  /** Zero-based ordering of this step within the template */
  position: Scalars['Int']['output'];
  /** The organization responsible for this step (e.g. "Schwab", "Newport") */
  responsibleOrg: Maybe<Scalars['String']['output']>;
};

/** Input for a single step within a retirement plan project template. */
export type RetirementPlanProjectTemplateStepInput = {
  /** Days relative to the project start date this step is due. */
  dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** Step name (e.g. "Termination Notice"). */
  name: Scalars['String']['input'];
  /** Free-text notes for this step. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this step within the template. */
  position: Scalars['Int']['input'];
  /** The organization responsible for this step (e.g. "Schwab", "Newport"). */
  responsibleOrg?: InputMaybe<Scalars['String']['input']>;
};

/** Retirement Plan Proposal Generator variant */
export type RetirementPlanProposalInput = {
  /** Current fee structure */
  currentFeeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Current recordkeeper */
  currentRecordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Estimated plan AUM */
  estimatedPlanAum?: InputMaybe<Scalars['Float']['input']>;
  /** Number of participants */
  numberOfParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** Plan name (household name when a household is selected) */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** Prospect meeting date */
  prospectMeetingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prospect / plan name */
  prospectName: Scalars['String']['input'];
  /** Specific angles to address */
  specificAngles?: InputMaybe<Scalars['String']['input']>;
  /** Target delivery date */
  targetDeliveryDate: Scalars['ISO8601Date']['input'];
};

/** A single point in a cumulative-return time series (used by Performance vs Benchmark and Account Performance charts). */
export type ReturnPoint = {
  __typename?: 'ReturnPoint';
  /** Cumulative time-weighted return from the series start through this date, expressed as a fraction (0.05 = 5%). */
  cumulativeReturn: Scalars['BigDecimal']['output'];
  /** As-of date for this point. */
  date: Scalars['ISO8601Date']['output'];
};

export type RiskAssessmentName =
  | 'aggressive'
  | 'conservative'
  | 'moderate';

export type RiskQuestionnaire = {
  __typename?: 'RiskQuestionnaire';
  answers: Array<RiskQuestionnaireAnswer>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  model: RiskQuestionnaireModel;
  scoreLevel: Maybe<SchwabRiskToleranceScoreLevel>;
  submittedByUser: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type RiskQuestionnaireAnswer = {
  __typename?: 'RiskQuestionnaireAnswer';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

/** Attributes for a single answer to a risk questionnaire */
export type RiskQuestionnaireAnswerInput = {
  answer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
  questionType: RiskQuestionnaireQuestion;
  score: Scalars['Int']['input'];
};

export type RiskQuestionnaireModel =
  /** schwab */
  | 'schwab';

export type RiskQuestionnaireQuestion =
  /** risk_tolerance */
  | 'risk_tolerance'
  /** time_horizon */
  | 'time_horizon';

/** Required Minimum Distribution (RMD) for an account */
export type Rmd = {
  __typename?: 'Rmd';
  /** The account associated with this RMD. */
  account: Account;
  /**
   * Whether the account was created this year.
   * @deprecated Calculate from account.createdAt instead
   */
  accountCreatedThisYear: Scalars['Boolean']['output'];
  /**
   * The age of the account holder.
   * @deprecated Use account association to access holder information
   */
  accountHolderAge: Maybe<Scalars['Int']['output']>;
  /**
   * The date of birth of the account holder.
   * @deprecated Use account association to access holder information
   */
  accountHolderDob: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The name of the account holder.
   * @deprecated Use account association to access holder information
   */
  accountHolderName: Scalars['String']['output'];
  /** The Savvy ID of the account. */
  accountId: Scalars['ID']['output'];
  /**
   * The title of the note
   * @deprecated Use account.displayName instead
   */
  accountName: Scalars['String']['output'];
  /**
   * The account number of the account.
   * @deprecated Use account.mask instead
   */
  accountNumber: Scalars['String']['output'];
  /** The value of the account at the end of the year in question. */
  accountYearEndValue: Maybe<Scalars['Float']['output']>;
  /** The additional manual distributions for the year not tracked in Savvy. */
  additionalDistributions: Maybe<Scalars['Float']['output']>;
  /** The advisor of this client. */
  advisor: Advisor;
  /** The Savvy ID of the advisor of this client. */
  advisorId: Scalars['ID']['output'];
  /** The RMD amount. */
  amount: Scalars['Float']['output'];
  /** When the RMD was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The amount distributed for the year so far. */
  distributions: Scalars['Float']['output'];
  /** The Savvy ID of the RMD. */
  id: Scalars['ID']['output'];
  /** The remaining amount that needs to be distributed still. */
  remaining: Scalars['Float']['output'];
  /** The factor used to calculate the RMD. */
  rmdFactor: Maybe<Scalars['Float']['output']>;
  /** The status of the RMD. */
  status: Scalars['String']['output'];
  /** The timestamp the RMD was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The year of the RMD. */
  year: Scalars['Int']['output'];
};

/** Argument metadata for running an admin service object */
export type RunAdminServiceObjectArg = {
  /** Information about how to fetch the argument, such as a Household record, from the database */
  argFromDb?: InputMaybe<RunAdminServiceObjectArgFromDb>;
  /** The name of the argument - use this ONLY if the argument is a keyword argument and not a positional arg */
  argKey?: InputMaybe<Scalars['String']['input']>;
  /** The value of the argument - use this if the argument is a scalar */
  argValue?: InputMaybe<Scalars['String']['input']>;
};

/** Information about how to fetch the argument, such as a Household record, from the database */
export type RunAdminServiceObjectArgFromDb = {
  /** A list of key value pairs to find a record by. Example: {id: 1} */
  findBy: Array<RunAdminServiceObjectFindBy>;
  /** The class of the record to find by. Example: "User" */
  klass: Scalars['String']['input'];
};

/** A key value pair to find a record by. */
export type RunAdminServiceObjectFindBy = {
  /** The key to find by */
  key: Scalars['String']['input'];
  /** The value to find by */
  value: Scalars['String']['input'];
};

/** Autogenerated input type of RunAdminServiceObject */
export type RunAdminServiceObjectInput = {
  /** The name of the service object to run */
  adminServiceObject: Scalars['String']['input'];
  /** The arguments to pass to the service object */
  args?: InputMaybe<Array<RunAdminServiceObjectArg>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RunAdminServiceObject. */
export type RunAdminServiceObjectPayload = {
  __typename?: 'RunAdminServiceObjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RunInternalAdminAction */
export type RunInternalAdminActionInput = {
  /** The action to run */
  action: InternalAdminAction;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce account ID to use for the action */
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The user ID (advisor) for BackfillConquestPlans action */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RunInternalAdminAction. */
export type RunInternalAdminActionPayload = {
  __typename?: 'RunInternalAdminActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciAccountPurposeAndSourceOfFunds */
export type SaveEciAccountPurposeAndSourceOfFundsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Account purpose for the custodian opening envelope */
  purpose: AccountPurposeName;
  /** Free-text purpose when purpose is other */
  purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Source of funds for the custodian opening envelope */
  sourceOfFunds: SourceOfFundsName;
  /** Free-text source of funds when source_of_funds is other */
  sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciAccountPurposeAndSourceOfFunds. */
export type SaveEciAccountPurposeAndSourceOfFundsPayload = {
  __typename?: 'SaveEciAccountPurposeAndSourceOfFundsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciBeneficiaries */
export type SaveEciBeneficiariesInput = {
  /** Full beneficiary list to persist; replaces any existing beneficiaries */
  beneficiaries: Array<EciBeneficiaryInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciBeneficiaries. */
export type SaveEciBeneficiariesPayload = {
  __typename?: 'SaveEciBeneficiariesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the save succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciDecedentDetails */
export type SaveEciDecedentDetailsInput = {
  /** Inherited beneficiary or entity shape */
  bdaBeneficiaryKind: EciBdaBeneficiaryKind;
  /** Original depositor's NFS account number */
  bdaParentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor citizenship country */
  citizenshipCountryCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor date of birth */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Original depositor date of death */
  dateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Original depositor first name */
  firstName: Scalars['String']['input'];
  /** Inherited Traditional or Inherited Roth registration */
  inheritedIraType: EciInheritedIraType;
  /** Original depositor last name */
  lastName: Scalars['String']['input'];
  /** Original depositor middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Original depositor tax ID */
  taxId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveEciDecedentDetails. */
export type SaveEciDecedentDetailsPayload = {
  __typename?: 'SaveEciDecedentDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciEmployerDetails */
export type SaveEciEmployerDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Employer legal name */
  entityName: Scalars['String']['input'];
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Employer EIN */
  taxId: Scalars['String']['input'];
};

/** Autogenerated return type of SaveEciEmployerDetails. */
export type SaveEciEmployerDetailsPayload = {
  __typename?: 'SaveEciEmployerDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciJointOwnerDetails */
export type SaveEciJointOwnerDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** JTWROS, TIC, TBE, or community property; sets the request registration type */
  jointAccountType: EciJointAccountType;
  /** The complete owner set (exactly two), exactly one primary (`self`) */
  owners: Array<EciOwnerInput>;
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciJointOwnerDetails. */
export type SaveEciJointOwnerDetailsPayload = {
  __typename?: 'SaveEciJointOwnerDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciTrustDetails */
export type SaveEciTrustDetailsInput = {
  /** Whether the entity is an accredited investor */
  accreditedInvestor: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ISO country code where the trust was organized */
  countryOfOrganizationCode: Scalars['String']['input'];
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Full legal name of the trust entity */
  entityName: Scalars['String']['input'];
  /** Household users acting as grantors */
  grantorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Trust home address */
  homeAddress: StrictAddressInput;
  /** Mailing address; required when mailing_address_same_as_home is false */
  mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Whether the entity is a registered broker-dealer */
  registeredBrokerDealer: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment advisor */
  registeredInvestmentAdvisor: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment company */
  registeredInvestmentCompany: Scalars['Boolean']['input'];
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Tax ID number */
  taxId: Scalars['String']['input'];
  /** Tax ID type */
  taxIdType: EciTrustTaxIdType;
  /** Date the trust was established (ISO 8601) */
  trustDate: Scalars['ISO8601Date']['input'];
  /** Trust revocability */
  trustRevocability: EciTrustRevocability;
  /** Trust type */
  trustType: EciTrustType;
  /** Household users acting as trustees */
  trusteeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SaveEciTrustDetails. */
export type SaveEciTrustDetailsPayload = {
  __typename?: 'SaveEciTrustDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciTrustedContacts */
export type SaveEciTrustedContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the client declined to provide a trusted contact */
  optedOut: Scalars['Boolean']['input'];
  /** Full trusted-contact list to persist; replaces any existing contacts */
  trustedContacts?: InputMaybe<Array<EciTrustedContactInput>>;
};

/** Autogenerated return type of SaveEciTrustedContacts. */
export type SaveEciTrustedContactsPayload = {
  __typename?: 'SaveEciTrustedContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the save succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveHouseholdKeepInMindVote */
export type SaveHouseholdKeepInMindVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional free text; omit it to leave any stored comment alone */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The `generatedAt` the item was rendered from; a vote against a superseded generation is rejected */
  generatedAt: Scalars['ISO8601DateTime']['input'];
  /** Household whose section the item belongs to */
  householdId: Scalars['ID']['input'];
  /** Optional reason; only meaningful alongside a DOWN vote */
  issueType?: InputMaybe<HouseholdKeepInMindIssueTypeEnum>;
  /** Position of the item in the payload's `items` */
  itemIndex: Scalars['Int']['input'];
  /** The thumb */
  vote: HouseholdKeepInMindVoteEnum;
};

/** Autogenerated return type of SaveHouseholdKeepInMindVote. */
export type SaveHouseholdKeepInMindVotePayload = {
  __typename?: 'SaveHouseholdKeepInMindVotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the vote was recorded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveReportTemplate */
export type SaveReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Serialized report builder configuration (must include dateRangeId and sections array) */
  config: Scalars['JsonHash']['input'];
  /** Whether this template represents a report bundle */
  isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the template */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveReportTemplate. */
export type SaveReportTemplatePayload = {
  __typename?: 'SaveReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The newly created template */
  savedReportTemplate: SavedReportTemplate;
};

/** Autogenerated input type of SaveRetirementPlanProjectAsTemplate */
export type SaveRetirementPlanProjectAsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  name: Scalars['String']['input'];
  /** The project to snapshot */
  retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveRetirementPlanProjectAsTemplate. */
export type SaveRetirementPlanProjectAsTemplatePayload = {
  __typename?: 'SaveRetirementPlanProjectAsTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created template */
  retirementPlanProjectTemplate: Maybe<RetirementPlanProjectTemplate>;
};

/** A team-shared report builder configuration. Visible to every member of every AdvisorGroup the template fans out to. */
export type SavedReportTemplate = {
  __typename?: 'SavedReportTemplate';
  /**
   * Advisor group IDs this template is shared with, filtered to the viewer's own
   * memberships so cross-team metadata isn't leaked to teammates outside those groups.
   */
  advisorGroupIds: Array<Scalars['ID']['output']>;
  /** Advisor groups this template is shared with (id + name), filtered to the viewer's own memberships. */
  advisorGroups: Array<AdvisorGroup>;
  /** Serialized GeneratedConfig payload from the report builder */
  config: Scalars['JSON']['output'];
  /** When the template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The user who created this template */
  createdByUserId: Scalars['ID']['output'];
  /** The unique identifier for the saved report template */
  id: Scalars['ID']['output'];
  /** Whether this template is a report bundle */
  isBundle: Scalars['Boolean']['output'];
  /** Whether this template is one of the system-seeded default templates */
  isDefault: Scalars['Boolean']['output'];
  /** Stable key identifying which seeded default template this is (e.g. investment_proposal); null for user-created templates */
  kind: Maybe<Scalars['String']['output']>;
  /** Display name for the template */
  name: Scalars['String']['output'];
  /** Automated delivery schedule for this template, if configured */
  schedule: Maybe<ReportSchedule>;
  /** When the template was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Savvy investment strategy in the catalog (raw holdings excluded) */
export type SavvyStrategy = {
  __typename?: 'SavvyStrategy';
  /** The allocation family the strategy belongs to */
  allocation: Scalars['String']['output'];
  /** An optional human-friendly display name */
  displayName: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the strategy */
  id: Scalars['ID']['output'];
  /** The earliest known rebalance date for the strategy */
  inceptionDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the strategy is archived */
  isArchived: Scalars['Boolean']['output'];
  /** The Orion Connect model id for the strategy */
  orionConnectModelId: Scalars['String']['output'];
  /**
   * Faithful, rebalance-aware performance value history as [timestampMs, value,
   * isoWeek] tuples (value normalized to ~1.0 at inception). Null until computed
   * from the uploaded holdings; consumers fall back to the current-weights
   * backtest while null. Heavy — request for a single selected strategy
   * (savvyStrategy query), not the full catalog list.
   */
  performanceSeries: Maybe<Scalars['JSON']['output']>;
  /** The name of the strategy */
  strategyName: Scalars['String']['output'];
};

/** An advisor's reply to a capture-survey scenario. */
export type ScenarioReplyInput = {
  /** Canonical scenario id the reply answers (e.g. scenario_anxious_market). */
  scenario: Scalars['String']['input'];
  /** The advisor's reply text. Max 2000 chars, enforced server-side. */
  text: Scalars['String']['input'];
};

/** Autogenerated input type of ScheduleNativeReport */
export type ScheduleNativeReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Report end date */
  endDate: Scalars['ISO8601Date']['input'];
  /** Savvy household ID */
  householdId: Scalars['ID']['input'];
  /**
   * The report type to generate. Valid values: performance_report_allocations,
   * performance_report_account, performance_report_household,
   * performance_report_security, performance_report_asset_class,
   * portfolio_summary_simple, portfolio_summary_cash_flows,
   * performance_report_consolidated, performance_report_holistic,
   * performance_report_portfolio_group, portfolio_summary_comprehensive,
   * performance_report_integrated
   */
  reportType: Scalars['String']['input'];
  /** Report start date (required for date-range reports) */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of ScheduleNativeReport. */
export type ScheduleNativeReportPayload = {
  __typename?: 'ScheduleNativeReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The scheduled job. Poll nativeReport(id) { status, dataJson } for status and data. */
  nativeReport: NativeReport;
};

/** One reason accounts could not be read during a Schwab sync, with how many accounts hit it. */
export type SchwabImportRunCause = {
  __typename?: 'SchwabImportRunCause';
  /** Schwab's error code, e.g. SEC-0001 (dead firm token) or SEC-0100 (account not entitled). A 400 carries no code. */
  code: Maybe<Scalars['String']['output']>;
  /** How many accounts failed for this reason across the whole run */
  count: Scalars['Int']['output'];
  /** HTTP status Schwab returned, or null when the call never reached Schwab (rate limiter, timeout) */
  status: Maybe<Scalars['Int']['output']>;
  /** Schwab's error title, e.g. Unauthorized */
  title: Maybe<Scalars['String']['output']>;
};

/** An advisor whose whole sync failed, as opposed to one that merely could not read some of its accounts. */
export type SchwabImportRunFailedAdvisor = {
  __typename?: 'SchwabImportRunFailedAdvisor';
  /** The advisor this run was scoped to */
  advisorId: Maybe<Scalars['ID']['output']>;
  /** Advisor full name, null if the user no longer exists */
  advisorName: Maybe<Scalars['String']['output']>;
};

export type SchwabImportRunState =
  /** Every advisor read every account */
  | 'completed'
  /** Some accounts could not be read; everything else was applied */
  | 'completed_with_gaps'
  /** Every advisor failed and nothing was applied */
  | 'failed'
  /** Advisors are still queued or running */
  | 'in_progress';

/**
 * Outcome of one firm-wide Schwab standing-authorizations sync, grouped by cause
 * rather than by advisor. Derived from the run's import rows plus its Sidekiq
 * batch; there is no run table.
 */
export type SchwabImportRunSummary = {
  __typename?: 'SchwabImportRunSummary';
  /** Client accounts Schwab did not answer successfully */
  accountsFailed: Scalars['Int']['output'];
  /** Client accounts Schwab answered successfully */
  accountsRead: Scalars['Int']['output'];
  /** Client accounts held at Schwab that this run attempted, across every advisor */
  accountsTotal: Scalars['Int']['output'];
  /** Advisors whose sync finished */
  advisorsCompleted: Scalars['Int']['output'];
  /** Advisors whose sync failed outright and applied nothing */
  advisorsFailed: Scalars['Int']['output'];
  /** Advisors still queued or running, from the Sidekiq batch */
  advisorsPending: Scalars['Int']['output'];
  /** Advisors enqueued for this run, from the Sidekiq batch, falling back to the row count once batch data expires */
  advisorsTotal: Scalars['Int']['output'];
  /** Advisors that finished but could not read every account */
  advisorsWithGaps: Scalars['Int']['output'];
  /** Bank links this run created */
  banksAdded: Scalars['Int']['output'];
  /** Advisors whose sync failed outright, capped at 10 */
  failedAdvisors: Array<SchwabImportRunFailedAdvisor>;
  /** Why accounts could not be read, most common first */
  failuresByCause: Array<SchwabImportRunCause>;
  /** When the last advisor import last changed. Null while anything is still in flight. */
  finishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Sidekiq batch id that identifies this run */
  runId: Scalars['String']['output'];
  /** When the run's first advisor import was created */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the run is still going, finished cleanly, finished with unread accounts, or failed outright */
  state: SchwabImportRunState;
  /** Name of the admin who started the run, or null for the scheduled run */
  triggeredBy: Maybe<Scalars['String']['output']>;
};

export type SchwabRiskToleranceScoreLevel =
  /** aggressive */
  | 'aggressive'
  /** conservative */
  | 'conservative'
  /** moderate */
  | 'moderate'
  /** moderately_aggressive */
  | 'moderately_aggressive'
  /** moderately_conservative */
  | 'moderately_conservative';

export type SecondaryEmail = {
  __typename?: 'SecondaryEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  user: User;
};

export type SecondaryEmailInput = {
  /** The email address */
  email: Scalars['String']['input'];
  /** The label for this email (e.g., "Personal", "Work") */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryPhone = {
  __typename?: 'SecondaryPhone';
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  user: User;
};

export type SecondaryPhoneInput = {
  /** The label for this phone (e.g., "Mobile", "Work") */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The phone number */
  phoneNumber: Scalars['String']['input'];
};

/** Security held by the user in an account. */
export type Security = {
  __typename?: 'Security';
  /** The close price of the security from the source provider. */
  closePrice: Maybe<Value>;
  /** The timestamp that is associated with the close_price for the security */
  closePriceAsOf: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The CUSIP identifier  of the security. */
  cusip: Maybe<Scalars['String']['output']>;
  /** The primary exchange that the security is traded on. */
  exchange: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the security. */
  id: Scalars['ID']['output'];
  /** The ISIN identifier of the security. */
  isin: Maybe<Scalars['String']['output']>;
  /** The timestamp the security was last updated with information from the source provider. */
  lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** Metadata about the security. */
  metadata: Maybe<Scalars['JSON']['output']>;
  /** The Savvy ID of the security. */
  name: Maybe<Scalars['String']['output']>;
  /** The SEDOL identifier of the security. */
  sedol: Maybe<Scalars['String']['output']>;
  /** The subtype of the security */
  subtype: Maybe<Scalars['String']['output']>;
  /** The ticker symbol of the security. */
  tickerSymbol: Maybe<Scalars['String']['output']>;
  /** The type of the security */
  type: SecurityTypeName;
};

export type SecurityTypeName =
  | 'bond'
  | 'cash'
  | 'cryptocurrency'
  | 'derivative'
  | 'equity'
  | 'etf'
  | 'fixed_income'
  | 'loan'
  | 'money_market'
  | 'multi_asset_strategy'
  | 'mutual_fund'
  | 'options'
  | 'other';

/** Select/tag filter with operator and values array */
export type SelectFilterInput = {
  /** Select filter operator */
  operator: SelectFilterOperatorEnum;
  /** Filter values array (not required for isEmpty operator) */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Select/tag filter operators */
export type SelectFilterOperatorEnum =
  /** Any of the selected values */
  | 'ANY_OF'
  /** Field is empty or null */
  | 'IS_EMPTY'
  /** None of the selected values */
  | 'NONE_OF';

/** Autogenerated input type of SendClientBookingEmail */
export type SendClientBookingEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isReminder?: InputMaybe<Scalars['Boolean']['input']>;
  meetingId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendClientBookingEmail. */
export type SendClientBookingEmailPayload = {
  __typename?: 'SendClientBookingEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  meeting: Maybe<ServiceCalendarMeeting>;
  primaryClientId: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendClientWelcomeEmail */
export type SendClientWelcomeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of SendClientWelcomeEmail. */
export type SendClientWelcomeEmailPayload = {
  __typename?: 'SendClientWelcomeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendCreatePasswordEmail */
export type SendCreatePasswordEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of SendCreatePasswordEmail. */
export type SendCreatePasswordEmailPayload = {
  __typename?: 'SendCreatePasswordEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendEmailMessage */
export type SendEmailMessageInput = {
  /** BCC email addresses */
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Email body as HTML */
  body: Scalars['String']['input'];
  /** CC email addresses */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email subject */
  subject: Scalars['String']['input'];
  /** Recipient email addresses */
  to: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of SendEmailMessage. */
export type SendEmailMessagePayload = {
  __typename?: 'SendEmailMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error messages if the operation failed */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the email was enqueued successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendFileShareEmail */
export type SendFileShareEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileInstructions?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileShareUrl: Scalars['String']['input'];
  isFolder: Scalars['Boolean']['input'];
  selectedClientIds: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of SendFileShareEmail. */
export type SendFileShareEmailPayload = {
  __typename?: 'SendFileShareEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendOnboarding */
export type SendOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  emailBody: Scalars['String']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  sendReminders: Scalars['Boolean']['input'];
  /** The staged household to send onboarding for. */
  stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated input type of SendOnboardingInviteToOps */
export type SendOnboardingInviteToOpsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendOnboardingInviteToOps. */
export type SendOnboardingInviteToOpsPayload = {
  __typename?: 'SendOnboardingInviteToOpsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** Whether the send succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendOnboarding. */
export type SendOnboardingPayload = {
  __typename?: 'SendOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** The staged household after send. */
  stagedHousehold: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendOnboardingToClient */
export type SendOnboardingToClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce task ID */
  salesforceTaskId: Scalars['String']['input'];
};

/** Autogenerated return type of SendOnboardingToClient. */
export type SendOnboardingToClientPayload = {
  __typename?: 'SendOnboardingToClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the onboarding task was sent to the client */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendRepaperEnvelope */
export type SendRepaperEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tracking ID returned from createRepaperEnvelope */
  trackingId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendRepaperEnvelope. */
export type SendRepaperEnvelopePayload = {
  __typename?: 'SendRepaperEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if enqueue failed */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the send job was successfully enqueued */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendSignOnboardingDocumentsReminder */
export type SendSignOnboardingDocumentsReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentType: OnboardingDocument;
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of SendSignOnboardingDocumentsReminder. */
export type SendSignOnboardingDocumentsReminderPayload = {
  __typename?: 'SendSignOnboardingDocumentsReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendTaskEmail */
export type SendTaskEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the notification must be treated as a reminder */
  isReminder?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['String']['input'];
};

/** Autogenerated return type of SendTaskEmail. */
export type SendTaskEmailPayload = {
  __typename?: 'SendTaskEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Detail for the senior-political-figure disclosure (required when the answer is yes). */
export type SeniorPoliticalFigureDetailInput = {
  /** ISO-3166-1 alpha-2 country code */
  countryCode: Scalars['String']['input'];
  /** Family member name (optional; only when applicable) */
  familyMemberName?: InputMaybe<Scalars['String']['input']>;
  /** Office / position held */
  officePosition: Scalars['String']['input'];
  /** Relationship to the senior political figure (self, spouse, parent, child, sibling) */
  relationship: Scalars['String']['input'];
};

/** A single service calendar item on a household's Service Calendar. */
export type ServiceCalendarItem = {
  __typename?: 'ServiceCalendarItem';
  completionDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  dueDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  serviceCalendarSettingId: Scalars['ID']['output'];
  status: ServiceCalendarItemStatus;
  title: Scalars['String']['output'];
};

export type ServiceCalendarItemStatus =
  | 'complete'
  | 'incomplete'
  | 'skipped';

/** A service calendar meeting */
export type ServiceCalendarMeeting = {
  __typename?: 'ServiceCalendarMeeting';
  /** Calendly cancel URL */
  calendlyCancelUrl: Maybe<Scalars['String']['output']>;
  /** Calendly reschedule URL */
  calendlyRescheduleUrl: Maybe<Scalars['String']['output']>;
  /** Due date for the meeting */
  dueDate: Scalars['ISO8601DateTime']['output'];
  /** Expected quarter of the meeting */
  expectedQuarter: Scalars['String']['output'];
  /** Household ID */
  householdId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Date of the meeting */
  meetingDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Meeting request dates */
  meetingRequestDates: Array<Scalars['ISO8601Date']['output']>;
  /** Date of the automated meeting */
  sendAutomatedMeetingDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date of the automated meeting reminder */
  sendAutomatedMeetingReminderDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Service calendar meeting type ID */
  serviceCalendarMeetingTypeId: Scalars['ID']['output'];
  /** Meeting status (scheduled, completed, cancelled) */
  status: ServiceCalendarMeetingStatus;
  /** Completion date of the meeting */
  statusUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Title of the meeting */
  title: Scalars['String']['output'];
};

export type ServiceCalendarMeetingDateUnit =
  /** days */
  | 'days'
  /** months */
  | 'months'
  /** weeks */
  | 'weeks';

export type ServiceCalendarMeetingExpectedQuarter =
  /** q1 */
  | 'q1'
  /** q2 */
  | 'q2'
  /** q3 */
  | 'q3'
  /** q4 */
  | 'q4';

export type ServiceCalendarMeetingStatus =
  /** complete */
  | 'complete'
  /** incomplete */
  | 'incomplete'
  /** skipped */
  | 'skipped';

/** A template for service calendar meeting types */
export type ServiceCalendarMeetingTypeTemplate = {
  __typename?: 'ServiceCalendarMeetingTypeTemplate';
  /** Advisor profile ID */
  advisorProfileId: Scalars['ID']['output'];
  /** Expected quarter for the meeting */
  expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  id: Scalars['ID']['output'];
  /** Unit for the automated meeting reminder */
  sendAutomatedMeetingReminderUnit: Maybe<ServiceCalendarMeetingDateUnit>;
  /** Value for the automated meeting reminder */
  sendAutomatedMeetingReminderValue: Maybe<Scalars['Int']['output']>;
  /** Unit for the automated meeting */
  sendAutomatedMeetingUnit: Maybe<ServiceCalendarMeetingDateUnit>;
  /** Value for the automated meeting */
  sendAutomatedMeetingValue: Maybe<Scalars['Int']['output']>;
  /** Template title */
  title: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSetting = {
  __typename?: 'ServiceCalendarSetting';
  active: Scalars['Boolean']['output'];
  byEndOfYear: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  q1: Scalars['Boolean']['output'];
  q2: Scalars['Boolean']['output'];
  q3: Scalars['Boolean']['output'];
  q4: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSettingTemplate = {
  __typename?: 'ServiceCalendarSettingTemplate';
  active: Scalars['Boolean']['output'];
  byEndOfYear: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  q1: Scalars['Boolean']['output'];
  q2: Scalars['Boolean']['output'];
  q3: Scalars['Boolean']['output'];
  q4: Scalars['Boolean']['output'];
  required: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  typeOf: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSettingTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  byEndOfYear?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  q1?: InputMaybe<Scalars['Boolean']['input']>;
  q2?: InputMaybe<Scalars['Boolean']['input']>;
  q3?: InputMaybe<Scalars['Boolean']['input']>;
  q4?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Per-household outcome of enrolling a batch of households in one service */
export type ServiceCatalogEnrollmentResult = {
  __typename?: 'ServiceCatalogEnrollmentResult';
  /**
   * The service already enrolling this household; null unless the status is
   * BLOCKED_BY_OTHER_SERVICE, and null on it too when the caller cannot read that
   * service — a blocking service can belong to another advisor group. Scalars
   * rather than the service object, which raises on a denied read instead of
   * nulling the field
   */
  blockingServiceCatalogItemGroupId: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the service already enrolling this household, for the skip line; null
   * unless the status is BLOCKED_BY_OTHER_SERVICE, and null on it too when the
   * caller cannot read that service. Fall back to an unnamed 'another service'
   * line when it is null on a blocked result
   */
  blockingServiceCatalogItemGroupName: Maybe<Scalars['String']['output']>;
  /** Items of the service the household was newly activated on; 0 for every status other than ENROLLED */
  enrolledItemCount: Scalars['Int']['output'];
  /** The household this outcome is for */
  householdId: Scalars['ID']['output'];
  /**
   * Advisor-facing notice that this household failed; null unless the status is
   * FAILED. The underlying reason is logged, not returned
   */
  message: Maybe<Scalars['String']['output']>;
  /** Whether the household was enrolled, was already enrolled, was blocked by another service, or failed */
  status: ServiceCatalogEnrollmentStatus;
};

/** Outcome of enrolling one household in one service */
export type ServiceCatalogEnrollmentStatus =
  /** The household was already active on every item of the service; nothing changed */
  | 'ALREADY_ENROLLED'
  /**
   * The household is already enrolled in a different service and v3 allows only
   * one; nothing changed. The blocking service is named on the result
   */
  | 'BLOCKED_BY_OTHER_SERVICE'
  /** The household landed on at least one item it was not already active on */
  | 'ENROLLED'
  /** This attempt was rolled back for this household; whatever it was enrolled in before is unchanged */
  | 'FAILED';

/** A service catalog item — the template that generates recurring tasks/events for assigned households */
export type ServiceCatalogItem = {
  __typename?: 'ServiceCatalogItem';
  /** Whether new tasks should be generated */
  active: Scalars['Boolean']['output'];
  /** The advisor group that owns the item */
  advisorGroup: AdvisorGroup;
  /** AfterPrevious cadence in days, if set */
  afterPreviousOffsetDays: Maybe<Scalars['Int']['output']>;
  /** When archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Cadence preset jsonb configuration */
  cadencePreset: Maybe<Scalars['JSON']['output']>;
  /** Optional calendly URL placeholder for email body */
  calendlyLink: Maybe<Scalars['String']['output']>;
  /** Created timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the item */
  createdBy: User;
  /** User assigned by default */
  defaultAssignee: Maybe<User>;
  /** User ID assigned by default */
  defaultAssigneeId: Maybe<Scalars['ID']['output']>;
  /** Default priority 1-4 for generated tasks */
  defaultPriority: Maybe<Scalars['Int']['output']>;
  /** Long-form description */
  description: Maybe<Scalars['String']['output']>;
  /** Email body template */
  emailBody: Maybe<Scalars['String']['output']>;
  /** Days before instance_date to dispatch email */
  emailLeadTimeDays: Scalars['Int']['output'];
  /** HH:MM (24-hour) send time in advisor TZ; null = 9am default */
  emailSendTimeOfDay: Maybe<Scalars['String']['output']>;
  /** Email subject template */
  emailSubject: Maybe<Scalars['String']['output']>;
  /** ISO 8601 duration */
  estimatedDuration: Maybe<Scalars['String']['output']>;
  /** The item ID */
  id: Scalars['ID']['output'];
  /** task or event */
  itemType: Scalars['String']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** RRULE recurrence pattern ID, if set */
  recurrencePatternId: Maybe<Scalars['ID']['output']>;
  /** RRULE string from the associated recurrence pattern */
  recurrencePatternRrule: Maybe<Scalars['String']['output']>;
  /** Days-before-occurrence offsets to send booking reminders (0 = day of) */
  reminderOffsetsDays: Array<Scalars['Int']['output']>;
  /** Whether to dispatch email when due */
  sendNotification: Scalars['Boolean']['output'];
  /** Whether to send booking reminders for unbooked Calendly events */
  sendReminders: Scalars['Boolean']['output'];
  /** Whether the invite and booking reminders also go out as a text message */
  sendTextNotification: Scalars['Boolean']['output'];
  /** Groups the item belongs to */
  serviceCatalogItemGroups: Array<ServiceCatalogItemGroup>;
  /** Household assignments */
  serviceCatalogItemHouseholds: Array<ServiceCatalogItemHousehold>;
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Who can see generated items */
  visibility: ServiceCatalogVisibility;
};

/** Attributes for creating or updating a ServiceCatalogItem */
export type ServiceCatalogItemAttributesInput = {
  /** Whether the item generates new tasks */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** AfterPrevious cadence in days */
  afterPreviousOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** Cadence preset jsonb configuration */
  cadencePreset?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional calendly URL */
  calendlyLink?: InputMaybe<Scalars['String']['input']>;
  /** User assigned by default */
  defaultAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Default priority 1-4 */
  defaultPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Long-form description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email body template */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  /** Days before due to dispatch email */
  emailLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  /** HH:MM (24-hour) send time in advisor TZ; null = 9am default */
  emailSendTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  /** Email subject template */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** ISO 8601 duration */
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  /** task or event */
  itemType?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Attributes to create or replace the item's RecurrencePattern. Mutually exclusive with recurrence_pattern_id. */
  recurrencePatternAttributes?: InputMaybe<RecurrencePatternAttributesInput>;
  /** Existing RRULE pattern ID */
  recurrencePatternId?: InputMaybe<Scalars['ID']['input']>;
  /** Days-before-occurrence offsets to send booking reminders (0 = day of) */
  reminderOffsetsDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Whether to send email when due */
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send booking reminders for unbooked Calendly events */
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to also text the invite and booking reminders. Only valid on an event
   * with a Calendly link and send_notification on.
   */
  sendTextNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Visibility scope */
  visibility?: InputMaybe<ServiceCatalogVisibility>;
};

/** A named group of service catalog items */
export type ServiceCatalogItemGroup = {
  __typename?: 'ServiceCatalogItemGroup';
  /** Owning advisor group */
  advisorGroup: AdvisorGroup;
  /** Owning advisor group ID */
  advisorGroupId: Scalars['ID']['output'];
  /** When archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Colour key for the service identity chip */
  color: Scalars['String']['output'];
  /** Created timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the group */
  createdBy: ServiceCreator;
  /** User who created the group */
  createdById: Scalars['ID']['output'];
  /** Long-form description */
  description: Maybe<Scalars['String']['output']>;
  /** Users CC'd on this template's automated emails */
  emailCcUserIds: Array<Scalars['ID']['output']>;
  /** Users CC'd on this template's automated emails */
  emailCcUsers: Array<User>;
  /**
   * Members of the advisor group that owns this service, selectable as its email
   * sender or CC. Resolved off the owning group rather than the viewer's, so an
   * org-wide service offers exactly the people the save accepts.
   */
  emailIdentityCandidates: Array<ServiceEmailIdentity>;
  /** User whose name/email sends this template's automated emails */
  emailSender: Maybe<User>;
  /** User whose name/email sends this template's automated emails */
  emailSenderId: Maybe<Scalars['ID']['output']>;
  /**
   * Number of distinct households currently enrolled in this service — the
   * assignments unenrolling it would release: one naming this service, or one
   * naming none whose item only this live service still holds. Unlike
   * householdCount it is not derived from item overlap, so an item shared with
   * another live service does not inflate it, and it excludes paused assignments —
   * pausing is how unenrollment is recorded.
   */
  enrolledHouseholdCount: Scalars['Int']['output'];
  /**
   * Households currently enrolled in this service, ordered by name. Scoped exactly
   * like enrolledHouseholdCount, so the editor's enrolled-households dialog and
   * its counter cannot disagree, which also means the list deliberately holds
   * households the viewer cannot read.
   */
  enrolledHouseholds: Array<EnrolledHousehold>;
  /** Number of distinct households with at least one item from this group assigned */
  householdCount: Scalars['Int']['output'];
  /** Icon key for the service identity chip */
  icon: Scalars['String']['output'];
  /** The group ID */
  id: Scalars['ID']['output'];
  /** Whether the group is the advisor group default */
  isDefault: Scalars['Boolean']['output'];
  /**
   * When a household was most recently enrolled in this service, whether or not it
   * is still enrolled; null if never. Re-enrolling a household, or moving one here
   * from another service, counts as a new enrollment.
   */
  lastEnrolledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Group name */
  name: Scalars['String']['output'];
  /** When the group was last published */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Membership rows */
  serviceCatalogItemGroupMemberships: Array<ServiceCatalogItemGroupMembership>;
  /** Items in the group */
  serviceCatalogItems: Array<ServiceCatalogItem>;
  /** When an advisor confirmed consent to text clients */
  smsConsentAcknowledgedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Publish lifecycle status (draft or published) */
  status: ServiceCatalogItemGroupStatus;
  /** Whether any advisor in the owning advisor group is set up to send texts */
  textMessagingAvailable: Scalars['Boolean']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Whether the viewer may save changes to this service — the same decision
   * updateServiceCatalogItemGroup makes, so the editor renders read-only instead
   * of offering a save the server would refuse. False for advisors outside the
   * owning advisor group (or organization, once org-scoping is on for them), for
   * read-only admins — including one impersonating an owning advisor — and on a
   * read-only OAuth token.
   */
  viewerCanEdit: Scalars['Boolean']['output'];
};

/** Attributes for creating or updating a ServiceCatalogItemGroup */
export type ServiceCatalogItemGroupAttributesInput = {
  /** Colour key for the service identity chip */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Long-form description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Users (advisor-group members) CC'd on this template's automated emails */
  emailCcUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** User (advisor-group member) whose name/email sends this template's automated emails */
  emailSenderId?: InputMaybe<Scalars['ID']['input']>;
  /** Icon key for the service identity chip */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Whether the group is the advisor group default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set true to record that the acting user confirmed consent to text this template's enrolled clients */
  smsConsentAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Join row associating a service catalog item with a group */
export type ServiceCatalogItemGroupMembership = {
  __typename?: 'ServiceCatalogItemGroupMembership';
  /** Created timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The membership ID */
  id: Scalars['ID']['output'];
  /** Member item */
  serviceCatalogItem: ServiceCatalogItem;
  /** Parent group */
  serviceCatalogItemGroup: ServiceCatalogItemGroup;
  /** Group ID */
  serviceCatalogItemGroupId: Scalars['ID']['output'];
  /** Catalog item ID */
  serviceCatalogItemId: Scalars['ID']['output'];
  /** Display order within the group */
  sortOrder: Scalars['Int']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Publish lifecycle status of a service catalog item group */
export type ServiceCatalogItemGroupStatus =
  | 'draft'
  | 'published';

/** Join between a service catalog item and a household it is assigned to */
export type ServiceCatalogItemHousehold = {
  __typename?: 'ServiceCatalogItemHousehold';
  /** When the assignment was made */
  assignedAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the assignment */
  assignedBy: User;
  /** User who created the assignment */
  assignedById: Scalars['ID']['output'];
  /** Created timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Booking for the next upcoming meeting occurrence, else the most recent past occurrence. */
  currentMeetingBooking: Maybe<MeetingBooking>;
  /** The assigned household */
  household: Household;
  /** Assigned household ID */
  householdId: Scalars['ID']['output'];
  /** The row ID */
  id: Scalars['ID']['output'];
  /** When this assignment was last marked done */
  lastCompletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the reminder email was last sent for this assignment */
  lastReminderSentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled occurrence after now, or nil when paused / no future occurrence is scheduled. */
  nextOccurrence: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Per-assignment overrides */
  overrides: Array<ServiceCatalogItemHouseholdOverride>;
  /** When true, assignment is soft-disabled */
  paused: Scalars['Boolean']['output'];
  /** The parent catalog item */
  serviceCatalogItem: ServiceCatalogItem;
  /** The service (template) this enrollment came from */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
  /** Service (template) this enrollment came from; null for rows the backfill could not resolve */
  serviceCatalogItemGroupId: Maybe<Scalars['ID']['output']>;
  /** Parent catalog item ID */
  serviceCatalogItemId: Scalars['ID']['output'];
  /** Display order within a household's service list */
  sortOrder: Scalars['Int']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Per-assignment override of a service catalog item for a household */
export type ServiceCatalogItemHouseholdOverride = {
  __typename?: 'ServiceCatalogItemHouseholdOverride';
  /** Created timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Override ID */
  id: Scalars['ID']['output'];
  /** Whether the occurrence should be skipped */
  isSkipped: Scalars['Boolean']['output'];
  /** Override occurrence date */
  overrideDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Override RRULE dtstart */
  overrideDtstart: Maybe<Scalars['ISO8601Date']['output']>;
  /** Override email body for the occurrence */
  overrideEmailBody: Maybe<Scalars['String']['output']>;
  /** Override email subject for the occurrence */
  overrideEmailSubject: Maybe<Scalars['String']['output']>;
  /** Override RRULE string */
  overrideRrule: Maybe<Scalars['String']['output']>;
  /** Parent catalog item */
  serviceCatalogItem: ServiceCatalogItem;
  /** Parent assignment */
  serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
  /** Parent assignment ID */
  serviceCatalogItemHouseholdId: Scalars['ID']['output'];
  /** Parent catalog item ID */
  serviceCatalogItemId: Scalars['ID']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Per-household outcome of unenrolling a batch of households from one service */
export type ServiceCatalogUnenrollmentResult = {
  __typename?: 'ServiceCatalogUnenrollmentResult';
  /** The household this outcome is for */
  householdId: Scalars['ID']['output'];
  /**
   * Advisor-facing notice that this household failed; null unless the status is
   * FAILED. The underlying reason is logged, not returned
   */
  message: Maybe<Scalars['String']['output']>;
  /** Whether the household was unenrolled, was not enrolled, or failed */
  status: ServiceCatalogUnenrollmentStatus;
  /** Enrollments in the service that were paused (0 when the household was not enrolled) */
  unenrolledItemCount: Scalars['Int']['output'];
};

/** Outcome of unenrolling one household from one service */
export type ServiceCatalogUnenrollmentStatus =
  /** Unenrollment was rolled back for this household; its enrollments are unchanged */
  | 'FAILED'
  /** The household had no active enrollment in the service; nothing changed */
  | 'NOT_ENROLLED'
  /** At least one active enrollment in the service was paused */
  | 'UNENROLLED';

/** Visibility level for a service catalog item */
export type ServiceCatalogVisibility =
  | 'creator'
  | 'firm'
  | 'team';

/**
 * Name and photo of the user who created a service — what a created-by cell
 * renders. Readable by anyone who can read the service itself: unlike Models::User
 * it carries no AdvisorPolicy check, which authorizes by shared advisor group and
 * so would deny (and, because an unauthorized object raises, fail the whole query
 * for) an org-wide service created by an advisor in another group.
 */
export type ServiceCreator = {
  __typename?: 'ServiceCreator';
  /** First name */
  firstName: Scalars['String']['output'];
  /** Display name (first + last) */
  fullName: Scalars['String']['output'];
  /** The creator's user id */
  id: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Photo URL; null falls back to initials */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** AI-drafted email subject + body for a service calendar event. */
export type ServiceEmailDraft = {
  __typename?: 'ServiceEmailDraft';
  /** Drafted email body; null on failure. */
  body: Maybe<Scalars['String']['output']>;
  /** False when generation failed; the FE shows a graceful error. */
  generated: Scalars['Boolean']['output'];
  /** Drafted subject line; null on failure. */
  subject: Maybe<Scalars['String']['output']>;
};

/**
 * A person selectable as the sender of, or a CC on, a service's automated emails —
 * a member of the advisor group that owns the service, which is the set the save
 * validates against. Scalars rather than Models::User: an org-wide service can be
 * owned by another advisor group, whose members AdvisorPolicy denies, and a denied
 * object raises rather than nulls — that would fail the whole editor query.
 */
export type ServiceEmailIdentity = {
  __typename?: 'ServiceEmailIdentity';
  /** First name */
  firstName: Scalars['String']['output'];
  /** Display name (first + last) */
  fullName: Scalars['String']['output'];
  /** The user id */
  id: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Photo URL; null falls back to initials */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** A group of tasks sharing the same service catalog item and occurrence date (2+ households) */
export type ServiceItemGroupOccurrence = {
  __typename?: 'ServiceItemGroupOccurrence';
  /** Distinct households across the group's tasks */
  householdCount: Scalars['Int']['output'];
  /** Synthetic id: "sourceCatalogItemId|occurrenceDate" (ISO8601 date or "no-date") */
  id: Scalars['ID']['output'];
  /** Earliest `due_at` across the group's tasks */
  nextDueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Bucket date in the viewer's timezone (null when none of the tasks have a due date) */
  occurrenceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Most common assignee across the group, tie-broken by earliest due */
  primaryAssignee: Maybe<User>;
  /** The service catalog item all tasks in this group belong to */
  sourceCatalogItem: ServiceCatalogItem;
  /** Counts of tasks by display status */
  statusCounts: ServiceItemStatusCounts;
  /** The underlying task rows, in walk order */
  tasks: Array<Task>;
};

/** Historical service calendar v1 item instance for export */
export type ServiceItemInstance = {
  __typename?: 'ServiceItemInstance';
  completionDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  dueDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A display item in the SC v2 tasks list: either a multi-household group or a single flat task */
export type ServiceItemOccurrence = FlatTaskOccurrence | ServiceItemGroupOccurrence;

/** The connection type for ServiceItemOccurrence. */
export type ServiceItemOccurrenceConnection = {
  __typename?: 'ServiceItemOccurrenceConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ServiceItemOccurrenceEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ServiceItemOccurrence>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceItemOccurrenceEdge = {
  __typename?: 'ServiceItemOccurrenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ServiceItemOccurrence>;
};

/** Counts of tasks by display status within a service-item occurrence group */
export type ServiceItemStatusCounts = {
  __typename?: 'ServiceItemStatusCounts';
  /** Tasks with `cancelled` status */
  cancelled: Scalars['Int']['output'];
  /** Tasks with `done` status */
  done: Scalars['Int']['output'];
  /** Tasks with `in_progress` status */
  inProgress: Scalars['Int']['output'];
  /** Open todo tasks whose `due_at` is in the past */
  overdue: Scalars['Int']['output'];
  /** Tasks with `todo` status that are not overdue */
  todo: Scalars['Int']['output'];
};

/** A household row for the Service schedules tab, resolved in bulk without per-object authorization */
export type ServiceScheduleRow = {
  __typename?: 'ServiceScheduleRow';
  /** Primary advisor first name */
  advisorFirstName: Maybe<Scalars['String']['output']>;
  /** Primary advisor last name */
  advisorLastName: Maybe<Scalars['String']['output']>;
  /** Primary advisor profile picture URL */
  advisorProfilePicUrl: Maybe<Scalars['String']['output']>;
  /** Household id */
  id: Scalars['ID']['output'];
  /** Last contact timestamp */
  lastContactAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Meeting follow-up status: 'not_scheduled' (passed meeting never
   * booked/canceled), 'scheduled' (has a booked meeting), or null
   */
  meetingStatus: Maybe<Scalars['String']['output']>;
  /** Name of the service item driving the meeting status */
  meetingStatusItemName: Maybe<Scalars['String']['output']>;
  /** Occurrence date driving the meeting status */
  meetingStatusOccurrenceAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Household name */
  name: Scalars['String']['output'];
  /** Display-only household tags */
  tags: Array<ServiceScheduleTag>;
  /** Public-facing household UUID (route target) */
  uuid: Scalars['String']['output'];
};

/** Display-only household tag (name + category color) for the Service schedules list */
export type ServiceScheduleTag = {
  __typename?: 'ServiceScheduleTag';
  /** Category color */
  hexColorCode: Maybe<Scalars['String']['output']>;
  /** HouseholdTag id */
  id: Scalars['ID']['output'];
  /** Organization household tag name */
  name: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SetAccountConnectionReminderPreference */
export type SetAccountConnectionReminderPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the reminder should be disabled for this household. */
  disabled: Scalars['Boolean']['input'];
  /** The ID of the household to update. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAccountConnectionReminderPreference. */
export type SetAccountConnectionReminderPreferencePayload = {
  __typename?: 'SetAccountConnectionReminderPreferencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The new reminder-disabled state for the household. */
  disabled: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetActivityEntryPinned */
export type SetActivityEntryPinnedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the activity timeline entry to pin or unpin */
  id: Scalars['ID']['input'];
  /** True to pin the entry, false to unpin it */
  isPinned: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SetActivityEntryPinned. */
export type SetActivityEntryPinnedPayload = {
  __typename?: 'SetActivityEntryPinnedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated activity timeline entry */
  entry: Entry;
};

/** Autogenerated input type of SetAdvisorTierLevel */
export type SetAdvisorTierLevelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The advisor-tier level to set. */
  level: AdvisorTierLevel;
  /** The advisor-tier team member whose level to set. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAdvisorTierLevel. */
export type SetAdvisorTierLevelPayload = {
  __typename?: 'SetAdvisorTierLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The team member with the updated level. */
  user: User;
};

/** Autogenerated input type of SetClientIncomeSources */
export type SetClientIncomeSourcesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Database ID of the client profile */
  clientProfileId: Scalars['ID']['input'];
  /** The complete set of income sources, in display order. Rows absent from this list are soft-deleted. */
  incomeSources: Array<ClientIncomeSourceInput>;
};

/** Autogenerated return type of SetClientIncomeSources. */
export type SetClientIncomeSourcesPayload = {
  __typename?: 'SetClientIncomeSourcesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated client profile */
  clientProfile: Client;
};

/** Autogenerated input type of SetContactAccountRelation */
export type SetContactAccountRelationInput = {
  accountId: Scalars['ID']['input'];
  beneficiaryPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  relationType: ContactRelationTypeName;
};

/** Autogenerated return type of SetContactAccountRelation. */
export type SetContactAccountRelationPayload = {
  __typename?: 'SetContactAccountRelationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetGovernmentId */
export type SetGovernmentIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expirationDate: Scalars['String']['input'];
  /** Optional - The GovernmentId model id */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The number on the client's actual ID */
  idNumber: Scalars['String']['input'];
  issueDate: Scalars['String']['input'];
  issuingAuthority?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** Autogenerated return type of SetGovernmentId. */
export type SetGovernmentIdPayload = {
  __typename?: 'SetGovernmentIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  governmentId: Maybe<GovernmentId>;
};

/** Autogenerated input type of SetHouseholdBenchmark */
export type SetHouseholdBenchmarkInput = {
  /** Orion benchmark key(s) to assign, e.g. "191531_P" or "489_B,202_B". */
  benchmarkValue: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update. */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetHouseholdBenchmark. */
export type SetHouseholdBenchmarkPayload = {
  __typename?: 'SetHouseholdBenchmarkPayload';
  /** The benchmark value that was set. */
  benchmarkValue: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SetServiceCatalogItemHouseholdNextOccurrence */
export type SetServiceCatalogItemHouseholdNextOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  id: Scalars['ID']['input'];
  /** The new next-occurrence date */
  nextOccurrence: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of SetServiceCatalogItemHouseholdNextOccurrence. */
export type SetServiceCatalogItemHouseholdNextOccurrencePayload = {
  __typename?: 'SetServiceCatalogItemHouseholdNextOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created or updated override */
  serviceCatalogItemHouseholdOverride: ServiceCatalogItemHouseholdOverride;
};

/** Autogenerated input type of SetSwimLoanLengthOptions */
export type SetSwimLoanLengthOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Full ordered set of options; replaces the stored list */
  options: Array<SwimLoanLengthOptionInput>;
};

/** Autogenerated return type of SetSwimLoanLengthOptions. */
export type SetSwimLoanLengthOptionsPayload = {
  __typename?: 'SetSwimLoanLengthOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** The stored options after the write, in order */
  swimLoanLengthOptions: Array<SwimLoanLengthOption>;
};

/** Autogenerated input type of SetSwimStrategies */
export type SetSwimStrategiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Full ordered set of strategies; replaces the stored list */
  strategies: Array<SwimStrategyInput>;
};

/** Autogenerated return type of SetSwimStrategies. */
export type SetSwimStrategiesPayload = {
  __typename?: 'SetSwimStrategiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** The stored strategies after the write, in order */
  swimStrategies: Array<SwimStrategy>;
};

/** Autogenerated input type of SetTaskRecurrence */
export type SetTaskRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Recurrence configuration */
  recurrence: RecurrenceInput;
  /** The Savvy task ID (UUID) */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetTaskRecurrence. */
export type SetTaskRecurrencePayload = {
  __typename?: 'SetTaskRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The updated task */
  task: Maybe<Task>;
};

/** Autogenerated input type of SetUpAdvisorOrganization */
export type SetUpAdvisorOrganizationInput = {
  /** User IDs of advisors to add to the team */
  advisorUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Turn org branding on (creates the branding row). Omit/null defers branding_enabled to the LD default (HAWK-819). */
  enableBranding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Team / firm name, used for both the organization and the advisor group */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SetUpAdvisorOrganization. */
export type SetUpAdvisorOrganizationPayload = {
  __typename?: 'SetUpAdvisorOrganizationPayload';
  /** The created advisor group */
  advisorGroup: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** The created organization */
  organization: Maybe<Organization>;
  /** Whether the setup succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetupTaskReminders */
export type SetupTaskRemindersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetupTaskReminders. */
export type SetupTaskRemindersPayload = {
  __typename?: 'SetupTaskRemindersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ShareHouseholdWithAdvisorGroup */
export type ShareHouseholdWithAdvisorGroupInput = {
  advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShareHouseholdWithAdvisorGroup. */
export type ShareHouseholdWithAdvisorGroupPayload = {
  __typename?: 'ShareHouseholdWithAdvisorGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SharePublishedReport */
export type SharePublishedReportInput = {
  /** When true and not yet surfaced, stamps added_to_portal_at so the client can see it. */
  addToPortal: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiry datetime. Null leaves the report without an expiration. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** UUID of the published report to share. */
  publishedReportId: Scalars['ID']['input'];
  /** Display title the client sees in their portal. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of SharePublishedReport. */
export type SharePublishedReportPayload = {
  __typename?: 'SharePublishedReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The report after sharing. */
  publishedReport: PublishedReportSummary;
};

/** Autogenerated input type of ShareRetirementPlanWithOrganization */
export type ShareRetirementPlanWithOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The organization to share the plan with */
  organizationId: Scalars['ID']['input'];
  /** The plan to share */
  retirementPlanId: Scalars['ID']['input'];
  /** full (3(38), default) | simple */
  sharingMode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShareRetirementPlanWithOrganization. */
export type ShareRetirementPlanWithOrganizationPayload = {
  __typename?: 'ShareRetirementPlanWithOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated plan */
  retirementPlan: Maybe<RetirementPlan>;
};

export type ShareableOrganization = {
  __typename?: 'ShareableOrganization';
  /** Full names of this organization's advisors and assistants, shown when choosing who to share a plan with */
  advisorNames: Array<Scalars['String']['output']>;
  /** Database ID */
  id: Scalars['ID']['output'];
  /** Organization name */
  name: Scalars['String']['output'];
  /**
   * full (3(38)) | simple — set only when this organization is returned from a
   * retirement plan share (null when browsing shareable organizations)
   */
  sharingMode: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SignTaxAddendum */
export type SignTaxAddendumInput = {
  /** Attestations the user agreed to before signing */
  attestations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** True to sign as primary client, false to sign as co-client (of current user's household) */
  isPrimaryClient: Scalars['Boolean']['input'];
  /** The signature value, usually the client's name */
  value: Scalars['String']['input'];
};

/** Autogenerated return type of SignTaxAddendum. */
export type SignTaxAddendumPayload = {
  __typename?: 'SignTaxAddendumPayload';
  /** The client agreement record */
  clientAgreement: Maybe<ClientAgreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The ID of the created signature */
  signatureId: Scalars['ID']['output'];
};

export type SignUpError =
  | 'unexpected_error'
  | 'user_must_accept_tos';

/** Autogenerated input type of SignUpForSavvy */
export type SignUpForSavvyInput = {
  acceptedTos: Scalars['Boolean']['input'];
  advisorLeadSource?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  otherLeadSource?: InputMaybe<Scalars['String']['input']>;
  referralSourceEmail?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the center of influence rep that referred the user */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignUpForSavvy. */
export type SignUpForSavvyPayload = {
  __typename?: 'SignUpForSavvyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  softError: Maybe<SignUpError>;
};

/** A DocuSign anchor-bound signer tab on a pre-filled IWS/Schwab app PDF */
export type SignerTabInput = {
  /** Anchor string stamped into the filled PDF (e.g. \sig_personal_primary\) */
  anchorString: Scalars['String']['input'];
  /** Pixel x-offset from the anchor when DocuSign places the tab */
  anchorXOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Pixel y-offset from the anchor when DocuSign places the tab */
  anchorYOffset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Conditional flag: always | co_client_only | joint_only | trust_co_trustee_only
   * | trust_third_trustee_only | ach_present_only
   */
  condition?: InputMaybe<Scalars['String']['input']>;
  /**
   * DocuSign 1-indexed page number that scopes the anchor search to a single page.
   * Optional during the HAWK-167 FE rollout; absent values fall back to the legacy
   * whole-document scan.
   */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Signer role: primary_client | co_client | trustee_primary | trustee_co | trustee_third | inheritor | advisor */
  signerRole: Scalars['String']['input'];
  /** DocuSign tab type: signHere | dateSigned */
  tabType: Scalars['String']['input'];
};

/** Tasks that only require the base set of fields. Not tasks that require complex data, e.g. onboarding tasks. */
export type SimpleTaskTypeName =
  | 'account_maintenance'
  | 'account_setup'
  | 'client_info_change'
  | 'client_other'
  | 'financial_planning'
  | 'initial_intake_form'
  | 'investment_management_direct_indexing'
  | 'money_movement_request'
  | 'onboarding_flow'
  | 'other'
  | 'other_investment_task'
  | 'pre_review_check_in'
  | 'rejected_fee'
  | 'risk_questionnaire'
  | 'self_reminder'
  | 'transition_analysis';

/** Autogenerated input type of SkipServiceOccurrence */
export type SkipServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  revision: Scalars['String']['input'];
};

/** Autogenerated return type of SkipServiceOccurrence. */
export type SkipServiceOccurrencePayload = {
  __typename?: 'SkipServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  occurrence: Maybe<HouseholdServiceOccurrence>;
};

/** Performance breakdown for a specific account sleeve within an account. */
export type SleevePerformanceBreakdown = {
  __typename?: 'SleevePerformanceBreakdown';
  /** The custodial account number of the sleeve */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** The Savvy account sleeve ID */
  accountSleeveId: Scalars['ID']['output'];
  /** Performance data for this sleeve across time periods */
  performanceOverTime: Array<Performance>;
  /** The display name of the sleeve */
  sleeveName: Maybe<Scalars['String']['output']>;
  /** The name of the strategy the sleeve is enrolled in */
  strategyName: Maybe<Scalars['String']['output']>;
};

/** A text message log entry representing an SMS between an advisor and a client */
export type SmsLog = {
  __typename?: 'SmsLog';
  /** The advisor profile associated with this SMS log. */
  advisorProfile: Advisor;
  /** The client profile associated with this SMS log. */
  clientProfile: Client;
  /** The client profile ID associated with this SMS log. */
  clientProfileId: Scalars['ID']['output'];
  /** Content of the text message. */
  content: Scalars['String']['output'];
  /** Timestamp when the SMS log was created in Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time when the SMS was sent or received. */
  date: Scalars['ISO8601DateTime']['output'];
  /** Direction of the message: inbound or outbound. */
  direction: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the SMS log. */
  id: Scalars['ID']['output'];
  /** The phone number the message was sent to or received from. */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Timestamp when the SMS log was last updated in Savvy. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Sort direction */
export type SortDirection =
  /** Ascending */
  | 'ASC'
  /** Descending */
  | 'DESC';

/** Information about the source account for account opening transfers */
export type SourceAccountInput = {
  /** Source account name */
  accountName: Scalars['String']['input'];
  /** Source account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Source account type (optional) */
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** Name of the firm holding the source account */
  firmName: Scalars['String']['input'];
  /** If the source account has multiple accounts */
  hasMultipleSourceAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the source account has mutual funds */
  hasMutualFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source account registration type */
  registrationType: SourceAccountRegistrationTypeName;
  /** Source account registration type when Other is selected */
  registrationTypeOther?: InputMaybe<Scalars['String']['input']>;
};

/** Registration types for source accounts */
export type SourceAccountRegistrationTypeName =
  /** individual */
  | 'individual'
  /** inherited_ira */
  | 'inherited_ira'
  /** joint_tenants_with_rights_of_survivorship */
  | 'joint_tenants_with_rights_of_survivorship'
  /** other */
  | 'other'
  /** roth_ira */
  | 'roth_ira'
  /** sep_ira */
  | 'sep_ira'
  /** simple_ira */
  | 'simple_ira'
  /** traditional_ira */
  | 'traditional_ira'
  /** trust */
  | 'trust';

/** Source of funds for the account */
export type SourceOfFundsName =
  /** family_relatives_inheritance */
  | 'family_relatives_inheritance'
  /** gambling_lottery */
  | 'gambling_lottery'
  /** gifts */
  | 'gifts'
  /** investment_capital_gains */
  | 'investment_capital_gains'
  /** other */
  | 'other'
  /** salary_wages_savings */
  | 'salary_wages_savings'
  /** sale_of_property_or_business */
  | 'sale_of_property_or_business'
  /** social_security_benefits */
  | 'social_security_benefits';

export type SpecialAsset = {
  __typename?: 'SpecialAsset';
  name: Maybe<Scalars['String']['output']>;
  ticker: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of StartSchwabApiImport */
export type StartSchwabApiImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StartSchwabApiImport. */
export type StartSchwabApiImportPayload = {
  __typename?: 'StartSchwabApiImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Always null: the firm-wide sync fans out per advisor with no single import to poll */
  linkedBankAccountImport: Maybe<LinkedBankAccountImport>;
  /** True when there is no usable Schwab token: nothing was enqueued and the admin must reconnect (OAuth) before a sync can run */
  reconnectNeeded: Scalars['Boolean']['output'];
};

/** A US state or territory code. */
export type StateCode =
  /** AK */
  | 'AK'
  /** AL */
  | 'AL'
  /** AR */
  | 'AR'
  /** AZ */
  | 'AZ'
  /** CA */
  | 'CA'
  /** CO */
  | 'CO'
  /** CT */
  | 'CT'
  /** DC */
  | 'DC'
  /** DE */
  | 'DE'
  /** FL */
  | 'FL'
  /** GA */
  | 'GA'
  /** HI */
  | 'HI'
  /** IA */
  | 'IA'
  /** ID */
  | 'ID'
  /** IL */
  | 'IL'
  /** IN */
  | 'IN'
  /** KS */
  | 'KS'
  /** KY */
  | 'KY'
  /** LA */
  | 'LA'
  /** MA */
  | 'MA'
  /** MD */
  | 'MD'
  /** ME */
  | 'ME'
  /** MI */
  | 'MI'
  /** MN */
  | 'MN'
  /** MO */
  | 'MO'
  /** MS */
  | 'MS'
  /** MT */
  | 'MT'
  /** NC */
  | 'NC'
  /** ND */
  | 'ND'
  /** NE */
  | 'NE'
  /** NH */
  | 'NH'
  /** NJ */
  | 'NJ'
  /** NM */
  | 'NM'
  /** NV */
  | 'NV'
  /** NY */
  | 'NY'
  /** OH */
  | 'OH'
  /** OK */
  | 'OK'
  /** OR */
  | 'OR'
  /** PA */
  | 'PA'
  /** RI */
  | 'RI'
  /** SC */
  | 'SC'
  /** SD */
  | 'SD'
  /** TN */
  | 'TN'
  /** TX */
  | 'TX'
  /** UT */
  | 'UT'
  /** VA */
  | 'VA'
  /** VT */
  | 'VT'
  /** WA */
  | 'WA'
  /** WI */
  | 'WI'
  /** WV */
  | 'WV'
  /** WY */
  | 'WY';

/** A state filing for a tax enrollment */
export type StateFiling = {
  __typename?: 'StateFiling';
  /** The state code for this filing */
  stateCode: Scalars['String']['output'];
  /** The status of the state filing */
  status: TaxReturnStatus;
};

/** Autogenerated input type of StopImpersonatingUser */
export type StopImpersonatingUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StopImpersonatingUser. */
export type StopImpersonatingUserPayload = {
  __typename?: 'StopImpersonatingUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User being impersonated */
  currentUser: User;
  /** True user (admin / admin ID) */
  trueUser: User;
};

/** Autogenerated input type of StopSharingRetirementPlanOrganizations */
export type StopSharingRetirementPlanOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organizations to remove from the share list */
  organizationIds: Array<Scalars['ID']['input']>;
  /** The plan to stop sharing */
  retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of StopSharingRetirementPlanOrganizations. */
export type StopSharingRetirementPlanOrganizationsPayload = {
  __typename?: 'StopSharingRetirementPlanOrganizationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated plan */
  retirementPlan: Maybe<RetirementPlan>;
};

/** Input type for filtering accounts by strategy enrollment */
export type StrategyFilterInput = {
  /**
   * Include accounts that are not enrolled in any strategy
   * @deprecated Use strategy_types instead
   */
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter accounts enrolled in these specific strategies */
  strategyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter accounts by strategy type: first_party, third_party, or unassigned */
  strategyTypes?: InputMaybe<Array<StrategyTypeFilter>>;
};

/** Filter accounts by strategy type */
export type StrategyTypeFilter =
  /** first_party */
  | 'first_party'
  /** third_party */
  | 'third_party'
  /** unassigned */
  | 'unassigned';

export type StrategyTypeName =
  /** first_party */
  | 'first_party'
  /** third_party */
  | 'third_party';

/** Strict address input */
export type StrictAddressInput = {
  /** Address line 1 */
  addressLine1: Scalars['String']['input'];
  /** Optional address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** State */
  state: Scalars['String']['input'];
  /** Zip code */
  zip: Scalars['String']['input'];
};

/** Autogenerated input type of SubmitEciAccountOnboarding */
export type SubmitEciAccountOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  emailBody: Scalars['String']['input'];
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  householdPublicId: Scalars['ID']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  sendReminders: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubmitEciAccountOnboarding. */
export type SubmitEciAccountOnboardingPayload = {
  __typename?: 'SubmitEciAccountOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the submit succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitEciClientOnboarding */
export type SubmitEciClientOnboardingInput = {
  /** Attestations the client agreed to before signing */
  attestations: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The signature value, usually the client's typed legal name */
  signature: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitEciClientOnboarding. */
export type SubmitEciClientOnboardingPayload = {
  __typename?: 'SubmitEciClientOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the submission was persisted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitEciUpgradeCustodian */
export type SubmitEciUpgradeCustodianInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  emailBody: Scalars['String']['input'];
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  householdPublicId: Scalars['ID']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  sendReminders: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubmitEciUpgradeCustodian. */
export type SubmitEciUpgradeCustodianPayload = {
  __typename?: 'SubmitEciUpgradeCustodianPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the submit succeeded */
  success: Scalars['Boolean']['output'];
};

/** A sub-task belonging to a parent task. */
export type Subtask = {
  __typename?: 'Subtask';
  /**
   * The due date this sub-task resolves to from its anchor + offset business days
   * (the run's launch/due date for roots, or the dependency completion date once a
   * gated step is released). Null until it has both an anchor and an offset. The
   * date picker offers this as the relative option to return to after a fixed date is set.
   */
  anchoredDueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user assigned to this sub-task. */
  assignee: Maybe<User>;
  /** The client profile this sub-task is associated with, if any. */
  clientProfile: Maybe<Client>;
  /** When the sub-task was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The sub-task this one is gated on, or null if it is a root. */
  dependency: Maybe<Subtask>;
  /**
   * The id of the sub-task this one is gated on (waits for), or null if it is a
   * root. Frontend builds the dependency forest from these ids.
   */
  dependsOnSubtaskId: Maybe<Scalars['ID']['output']>;
  /** The description of the sub-task. */
  description: Maybe<Scalars['String']['output']>;
  /** When the sub-task is due. */
  dueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Calendar days before the parent due date. When the parent is recurring, each occurrence re-computes the sub-task due_at. */
  dueDateOffsetDays: Maybe<Scalars['Int']['output']>;
  /** Indicates which terminal Fidelity failure this sub-task addresses. */
  eciRemediationType: Maybe<EciRemediationType>;
  /**
   * True when this sub-task waits on a dependency that is not yet complete: its
   * status cannot change and its due date is unresolved until the dependency is
   * done or cancelled.
   */
  gated: Scalars['Boolean']['output'];
  /** The household this sub-task is associated with, if any. */
  household: Maybe<Household>;
  /** The Savvy ID of the sub-task. */
  id: Scalars['ID']['output'];
  /** True when this sub-task tracks a Footprint KYC failure. Requires manual intervention. */
  isKycRemediation: Scalars['Boolean']['output'];
  /** The name of the sub-task. */
  name: Scalars['String']['output'];
  /**
   * The 1-indexed manual position of the sub-task among its siblings on the same
   * parent task. Set automatically on create and updated by reorderSubtask.
   */
  position: Maybe<Scalars['Int']['output']>;
  /** The status of the sub-task. */
  status: SubtaskStatus;
  /** The parent task this sub-task belongs to. */
  task: Task;
  /** When the sub-task was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The work item this sub-task is associated with, if any. */
  workItem: Maybe<WorkItem>;
};

/** Input for creating a subtask as part of a parent task creation request. */
export type SubtaskCreationInput = {
  /** The ID of the user to assign the subtask to. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The key of another subtask in this same payload that must complete before this
   * one ungates. Forms the gating dependency edge.
   */
  dependsOnKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional description of the subtask. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** When the subtask is due. */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Calendar days before the parent task due date. Used when the parent is recurring. */
  dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Client-supplied key identifying this subtask within the payload, referenced by
   * other subtasks' dependsOnKey. Required only when something depends on this subtask.
   */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The name of the subtask. */
  name: Scalars['String']['input'];
};

export type SubtaskStatus =
  /** cancelled */
  | 'cancelled'
  /** done */
  | 'done'
  /** in_progress */
  | 'in_progress'
  /** todo */
  | 'todo';

export type SwimLoanLengthOption = {
  __typename?: 'SwimLoanLengthOption';
  /** Loan length in whole months; the tenor label is derived on the client */
  months: Scalars['Int']['output'];
  /** Estimated rate range, high end (percent) */
  rateHigh: Scalars['Float']['output'];
  /** Estimated rate range, low end (percent) */
  rateLow: Scalars['Float']['output'];
};

export type SwimLoanLengthOptionInput = {
  /** Loan length in whole months (> 0) */
  months: Scalars['Int']['input'];
  /** Estimated rate range, high end (percent); must be >= rateLow */
  rateHigh: Scalars['Float']['input'];
  /** Estimated rate range, low end (percent) */
  rateLow: Scalars['Float']['input'];
};

export type SwimRequest = {
  __typename?: 'SwimRequest';
  accountImplementationDetails: Maybe<Scalars['String']['output']>;
  accountManagementType: Maybe<Scalars['String']['output']>;
  /**
   * Accounts linked via swim_request_accounts. Used to render account details when
   * the deprecated included_accounts string column is empty.
   */
  accounts: Maybe<Array<Account>>;
  advisorCustomModelType: Maybe<Scalars['String']['output']>;
  aggregateCollateralValue: Maybe<Scalars['String']['output']>;
  allocationModel: Maybe<Scalars['String']['output']>;
  annualIncome: Maybe<Scalars['String']['output']>;
  bondTypeForTaxableAccount: Maybe<Scalars['String']['output']>;
  cashRequirementContext: Maybe<Scalars['String']['output']>;
  cashReservesPerAccount: Maybe<Array<CashReservesPerAccount>>;
  coveredCallsStocks: Maybe<Array<SpecialAsset>>;
  dcaConfigs: Maybe<Array<DcaAccountConfig>>;
  doNotSellAssets: Maybe<Array<SpecialAsset>>;
  /** Client estimated federal tax rate as a percentage, collected for municipal fixed income strategies */
  estimatedFederalTaxRate: Maybe<Scalars['String']['output']>;
  estimatedLiquidNetWorth: Maybe<Scalars['String']['output']>;
  estimatedNetWorth: Maybe<Scalars['String']['output']>;
  /** Client estimated state and local tax rate as a percentage, collected for municipal fixed income strategies */
  estimatedStateLocalTaxRate: Maybe<Scalars['String']['output']>;
  /** Illustrative taxable equivalent yield shown to the advisor at submit; a snapshot, not recomputed */
  estimatedTaxableEquivalentYield: Maybe<Scalars['String']['output']>;
  extraImplementationDetails: Maybe<Scalars['String']['output']>;
  feeAssumption: Maybe<Scalars['String']['output']>;
  /**
   * Fixed income strategy applied as part of a Savvy Total Portfolios combination;
   * standalone enrollments carry it in strategyType instead
   */
  fixedIncomeStrategy: Maybe<Scalars['String']['output']>;
  /** How the fixed income strategy is funded: cash or existing_portfolio */
  fundingSource: Maybe<Scalars['String']['output']>;
  heldAwayAccountsIncluded: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  implementationBudget: Maybe<Scalars['String']['output']>;
  includedAccounts: Maybe<Array<Scalars['String']['output']>>;
  includedHeldAwayAccounts: Maybe<Array<Scalars['String']['output']>>;
  indexToTrack: Maybe<Scalars['String']['output']>;
  isSleeved: Maybe<Scalars['Boolean']['output']>;
  isTaxAware: Maybe<Scalars['Boolean']['output']>;
  keepReserveCash: Maybe<Scalars['Boolean']['output']>;
  loanAmount: Maybe<Scalars['String']['output']>;
  loanLength: Maybe<Scalars['String']['output']>;
  maturityRange: Maybe<Scalars['String']['output']>;
  maxGainsPreference: Maybe<Scalars['Float']['output']>;
  nonDiscretionaryAccounts: Maybe<Array<Scalars['String']['output']>>;
  optionsAndMarginEnabled: Maybe<Scalars['Boolean']['output']>;
  optionsApplicationForClient: Maybe<Scalars['String']['output']>;
  overlay: Maybe<Scalars['String']['output']>;
  requestDca: Maybe<Scalars['Boolean']['output']>;
  retainedAssets: Maybe<Array<SpecialAsset>>;
  selectedModelRationale: Maybe<Scalars['String']['output']>;
  sleeves: Maybe<Array<SwimRequestSleeve>>;
  /** @deprecated No longer used by frontend */
  spacing: Maybe<Scalars['String']['output']>;
  /** Client state of residency, collected for municipal fixed income strategies */
  stateOfResidency: Maybe<Scalars['String']['output']>;
  strategyDetails: Maybe<Scalars['String']['output']>;
  strategyType: Maybe<Scalars['String']['output']>;
  systematicWithdrawalsDetails: Maybe<Scalars['String']['output']>;
  taxSensitivity: Maybe<Scalars['String']['output']>;
  thirdPartyModelType: Maybe<Scalars['String']['output']>;
  thirdPartyStrategy: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used by frontend */
  tilt: Maybe<Scalars['String']['output']>;
  usEquityIndex: Maybe<Scalars['String']['output']>;
  utilizeDirectIndexing: Maybe<Scalars['Boolean']['output']>;
  utilizeOverlay: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer used by frontend */
  utilizeTilt: Maybe<Scalars['Boolean']['output']>;
  willHaveSystematicWithdrawals: Maybe<Scalars['Boolean']['output']>;
  yearlyGainsBudget: Maybe<Scalars['String']['output']>;
};

export type SwimRequestSleeve = {
  __typename?: 'SwimRequestSleeve';
  allocation: Maybe<Scalars['String']['output']>;
  percent: Maybe<Scalars['String']['output']>;
  strategy: Maybe<Scalars['String']['output']>;
};

/** Input for swim request task specific data */
export type SwimRequestTaskInput = {
  /** Account IDs to associate with the swim request */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountImplementationDetails?: InputMaybe<Scalars['String']['input']>;
  accountManagementType?: InputMaybe<Scalars['String']['input']>;
  advisorCustomModelType?: InputMaybe<Scalars['String']['input']>;
  aggregateCollateralValue?: InputMaybe<Scalars['String']['input']>;
  allocationModel?: InputMaybe<Scalars['String']['input']>;
  annualIncome?: InputMaybe<Scalars['String']['input']>;
  bondTypeForTaxableAccount?: InputMaybe<Scalars['String']['input']>;
  cashRequirementContext?: InputMaybe<Scalars['String']['input']>;
  cashReservesPerAccount?: InputMaybe<Array<Scalars['JSON']['input']>>;
  coveredCallsStocks?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Per-account DCA configuration */
  dcaConfigs?: InputMaybe<Array<DcaAccountConfigInput>>;
  doNotSellAssets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Client estimated federal tax rate as a percentage, collected for municipal fixed income strategies */
  estimatedFederalTaxRate?: InputMaybe<Scalars['String']['input']>;
  estimatedLiquidNetWorth?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['String']['input']>;
  /** Client estimated state and local tax rate as a percentage, collected for municipal fixed income strategies */
  estimatedStateLocalTaxRate?: InputMaybe<Scalars['String']['input']>;
  /** Illustrative taxable equivalent yield shown to the advisor at submit; a snapshot, not recomputed server-side */
  estimatedTaxableEquivalentYield?: InputMaybe<Scalars['String']['input']>;
  extraImplementationDetails?: InputMaybe<Scalars['String']['input']>;
  feeAssumption?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fixed income strategy applied as part of a Savvy Total Portfolios combination;
   * standalone enrollments carry it in strategy_type instead
   */
  fixedIncomeStrategy?: InputMaybe<Scalars['String']['input']>;
  /** How the fixed income strategy is funded: cash or existing_portfolio */
  fundingSource?: InputMaybe<Scalars['String']['input']>;
  heldAwayAccountsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  implementationBudget?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use account_ids instead */
  includedAccounts?: InputMaybe<Array<Scalars['String']['input']>>;
  includedHeldAwayAccounts?: InputMaybe<Array<Scalars['String']['input']>>;
  indexToTrack?: InputMaybe<Scalars['String']['input']>;
  isSleeved?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxAware?: InputMaybe<Scalars['Boolean']['input']>;
  keepReserveCash?: InputMaybe<Scalars['Boolean']['input']>;
  loanAmount?: InputMaybe<Scalars['String']['input']>;
  loanLength?: InputMaybe<Scalars['String']['input']>;
  maturityRange?: InputMaybe<Scalars['String']['input']>;
  maxGainsPreference?: InputMaybe<Scalars['Float']['input']>;
  nonDiscretionaryAccounts?: InputMaybe<Array<Scalars['String']['input']>>;
  optionsAndMarginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  optionsApplicationForClient?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['String']['input']>;
  retainedAssets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  selectedModelRationale?: InputMaybe<Scalars['String']['input']>;
  sleeves?: InputMaybe<Array<Scalars['JSON']['input']>>;
  spacing?: InputMaybe<Scalars['String']['input']>;
  /** Client state of residency, collected for municipal fixed income strategies so Ops knows which state issuance applies */
  stateOfResidency?: InputMaybe<Scalars['String']['input']>;
  strategyDetails?: InputMaybe<Scalars['String']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
  systematicWithdrawalsDetails?: InputMaybe<Scalars['String']['input']>;
  taxSensitivity?: InputMaybe<Scalars['String']['input']>;
  thirdPartyModelType?: InputMaybe<Scalars['String']['input']>;
  thirdPartyStrategy?: InputMaybe<Scalars['String']['input']>;
  tilt?: InputMaybe<Scalars['String']['input']>;
  usEquityIndex?: InputMaybe<Scalars['String']['input']>;
  utilizeDirectIndexing?: InputMaybe<Scalars['Boolean']['input']>;
  utilizeOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  utilizeTilt?: InputMaybe<Scalars['Boolean']['input']>;
  willHaveSystematicWithdrawals?: InputMaybe<Scalars['Boolean']['input']>;
  yearlyGainsBudget?: InputMaybe<Scalars['String']['input']>;
};

export type SwimStrategy = {
  __typename?: 'SwimStrategy';
  /** Fee in basis points, high end */
  feeBpsHigh: Scalars['Int']['output'];
  /** Fee in basis points, low end (equals feeBpsHigh for a fixed fee) */
  feeBpsLow: Scalars['Int']['output'];
  /** Stable strategy identifier; enrollment field/step config is keyed by this. Not editable in the admin UI */
  key: Scalars['String']['output'];
  /** Display label shown in enrollment and the admin list */
  name: Scalars['String']['output'];
};

export type SwimStrategyInput = {
  /** Fee in basis points, high end; must be >= feeBpsLow */
  feeBpsHigh: Scalars['Int']['input'];
  /** Fee in basis points, low end (equals feeBpsHigh for a fixed fee) */
  feeBpsLow: Scalars['Int']['input'];
  /** Stable strategy identifier; must be unique within the set */
  key: Scalars['String']['input'];
  /** Display label */
  name: Scalars['String']['input'];
};

/** Autogenerated input type of SwitchActiveHousehold */
export type SwitchActiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to make active for the current user. */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchActiveHousehold. */
export type SwitchActiveHouseholdPayload = {
  __typename?: 'SwitchActiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated viewer user. */
  user: User;
};

/** Autogenerated input type of SyncEciAccountOnboardingRequestSelection */
export type SyncEciAccountOnboardingRequestSelectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  householdPublicId: Scalars['ID']['input'];
  /** Set of selected savvy account ids to transfer */
  sourceAccountIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncEciAccountOnboardingRequestSelection. */
export type SyncEciAccountOnboardingRequestSelectionPayload = {
  __typename?: 'SyncEciAccountOnboardingRequestSelectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the sync succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncOrionData */
export type SyncOrionDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncOrionData. */
export type SyncOrionDataPayload = {
  __typename?: 'SyncOrionDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncStandingInstructionSelections */
export type SyncStandingInstructionSelectionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Carry-over selection updates to apply to recurring transfers */
  recurringTransferSelectionUpdates?: InputMaybe<Array<CarryOverSelectionInput>>;
  /** Carry-over selection updates to apply to standing instructions */
  standingInstructionSelectionUpdates?: InputMaybe<Array<CarryOverSelectionInput>>;
  /** Account onboarding task id (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncStandingInstructionSelections. */
export type SyncStandingInstructionSelectionsPayload = {
  __typename?: 'SyncStandingInstructionSelectionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the update succeeded */
  success: Scalars['Boolean']['output'];
};

export type Task = {
  __typename?: 'Task';
  /** Accounts associated with the task. Only present for Account Confirmation tasks */
  accountConfirmationAccounts: Array<Account>;
  /** Account maintenance request data. */
  accountMaintenanceRequest: Maybe<AccountMaintenanceRequest>;
  /** Setup type for Account Confirmation tasks. Could be: account transfer or account opening */
  accountSetupType: Maybe<Scalars['String']['output']>;
  /** Type of account transfer. Could be: Fidelity -> Fidelity or Schwab -> Schwab */
  accountTransferType: Maybe<Scalars['String']['output']>;
  /** Boolean to indicate if we should add Calendly scheduling to a task */
  addCalendlyScheduling: Maybe<Scalars['Boolean']['output']>;
  /** Alternative investments purchase request data. */
  alternativeInvestmentsPurchaseRequest: Maybe<AlternativeInvestmentsPurchaseRequest>;
  /** The user assigned to this task */
  assignee: Maybe<User>;
  boxFolderId: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current viewer is allowed to write extended-palette statuses
   * (sub_status, reviewed_ready_for_work) on this task. Mirrors
   * TaskPolicy#can_change_extended_status?.
   */
  canChangeExtendedStatus: Scalars['Boolean']['output'];
  /**
   * Whether this task type supports duplication. A type capability, not a viewer
   * permission — duplicating opens a prefilled creation form, which authorizes the
   * destination household on submit. Mirrors Tasks::Duplication.duplicable?, so a
   * type becomes duplicable everywhere once registered.
   */
  canDuplicate: Scalars['Boolean']['output'];
  /**
   * Whether the current viewer can clear an advisor-blocked sub_status via the
   * banner Mark as done button. Mirrors
   * TaskPolicy#can_mark_advisor_requirements_done?.
   */
  canMarkAdvisorRequirementsDone: Scalars['Boolean']['output'];
  /** The category of the task */
  category: Maybe<TaskCategory>;
  /** Client billing request data. */
  clientBillingRequest: Maybe<ClientBillingRequest>;
  /** Client info change request data. */
  clientInfoChangeRequest: Maybe<ClientInfoChangeRequest>;
  /** Client review presentation request data. */
  clientReviewPresentationRequest: Maybe<ClientReviewPresentationRequest>;
  /** Comment notification summary for this task */
  commentSummary: TaskCommentSummary;
  /** Who receives the task-completed client email. Null falls back to every household account holder. */
  completedEmailRecipients: Maybe<TaskCompletedEmailRecipients>;
  /** Corporate retirement plan request data. */
  corporateRetirementPlanRequest: Maybe<CorporateRetirementPlanRequest>;
  /** When the task was created in Savvy. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the task */
  description: Maybe<Scalars['String']['output']>;
  /** Plain-text version of the description, HTML stripped. */
  descriptionText: Maybe<Scalars['String']['output']>;
  /** Destination custodian for account opening or transfer tasks. Could be: Schwab or Fidelity */
  destinationCustodian: Maybe<Scalars['String']['output']>;
  /** DocuSign envelope status. */
  docusignEnvelopeStatus: Maybe<Scalars['String']['output']>;
  /** DocuSign recipients for this task. */
  docusignRecipients: Maybe<Array<DocusignRecipient>>;
  /** Serialized form state for wizard-based draft tasks */
  draftPayload: Maybe<Scalars['String']['output']>;
  /** When the task is due */
  dueAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ECI account onboarding request associated with this task, if any */
  eciAccountOnboardingRequest: Maybe<EciAccountOnboarding>;
  /** The Savvy ID of the task. */
  id: Scalars['ID']['output'];
  /** Investment proposal request data. */
  investmentProposalRequest: Maybe<InvestmentProposalRequest>;
  /**
   * Whether this task is the main/template task of a recurring series (the
   * schedule anchor). The FE branches the delete prompt on this.
   */
  isRecurrenceTemplate: Scalars['Boolean']['output'];
  /** Whether this task is part of a recurrence series */
  isRecurring: Scalars['Boolean']['output'];
  /** Indicates if a docusign has possibly been signed. Uses the "wrong way" mentioned here: https://tinyurl.com/yr8fcybh */
  maybeDocusignSigned: Maybe<Scalars['Boolean']['output']>;
  /** Metadata about the task. */
  metadata: Maybe<Scalars['JSON']['output']>;
  /** Money movement request data. */
  moneyMovementRequest: Maybe<MoneyMovementRequest>;
  /** The name of the task */
  name: Scalars['String']['output'];
  /** The note associated with this task, if there is one */
  note: Maybe<Note>;
  /** Onboarding task data. */
  onboardingTask: Maybe<OnboardingTaskDatum>;
  /** Open new account request data. */
  openNewAccountRequest: Maybe<OpenNewAccountRequest>;
  /** Other-investment task structured data. */
  otherInvestmentTaskRequest: Maybe<OtherInvestmentTaskRequest>;
  /** The priority level of the task */
  priority: TaskPriority;
  /** The retirement plan project step this task was created from, if any. */
  retirementPlanProjectRow: Maybe<RetirementPlanProjectRow>;
  salesforceTaskId: Maybe<Scalars['String']['output']>;
  /** Whether to email the client when the task completes. Null inherits the organization default. */
  sendEmailWhenCompleted: Maybe<Scalars['Boolean']['output']>;
  /** Calendly booking tracking for a Service Calendar v2 meeting occurrence. */
  serviceCatalogMeetingBooking: Maybe<MeetingBooking>;
  /** The SC v2 catalog item that materialized this task. Null for non-SC tasks. (4C1T-94) */
  sourceCatalogItem: Maybe<ServiceCatalogItem>;
  /** The status of the task */
  status: TaskStatus;
  /**
   * In Progress sub-status for Client Services and Investment Ops tasks. Null for
   * other categories or when the task is not In Progress.
   */
  subStatus: Maybe<TaskSubStatus>;
  /** Sub-tasks belonging to this task, ordered by their manual position (id breaks ties; nil positions sort to the end). */
  subtasks: Array<Subtask>;
  /** Swim request data. */
  swimRequest: Maybe<SwimRequest>;
  /** Accounts associated with this task via account confirmation or SWIM enrollment. */
  taskAccounts: Array<Account>;
  /** The time the task email was sent as String */
  taskEmailSentAt: Maybe<Scalars['String']['output']>;
  /** Ops paperwork reminder from the organization of the task owner's household advisor. Shown on task details for CSAs. */
  taskInstructionsForOps: Maybe<Scalars['String']['output']>;
  /** The recurrence schedule for this task */
  taskRecurrence: Maybe<TaskRecurrence>;
  /** The URL for the task */
  taskUrl: Maybe<Scalars['String']['output']>;
  /** The launch details of this workflow run (present only for launched workflow tasks). */
  taskWorkflow: Maybe<TaskWorkflow>;
  /** The workflow template this task defines (present only for workflow_template tasks). */
  taskWorkflowTemplate: Maybe<TaskWorkflowTemplate>;
  /** Trading request data. */
  tradingRequest: Maybe<TradingRequest>;
  /** Transfer of assets request data. */
  transferOfAssetsRequest: Maybe<TransferOfAssetsRequest>;
  /** The type of task */
  type: TaskTypeName;
  /** Sibling tasks in the same recurrence series with due_at strictly after this task, ordered by due_at and capped at 5. */
  upcomingMaterializedOccurrences: Array<Task>;
  /** When the task was last updated in Savvy. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  /** Client profiles associated with this task through its work item */
  workItemClients: Array<Client>;
  /** Households associated with this task through its work item */
  workItemHouseholds: Array<Household>;
};

export type TaskActivity = {
  __typename?: 'TaskActivity';
  /** List of Box file IDs attached to a comment */
  attachments: Maybe<Array<Scalars['String']['output']>>;
  /** Author that created the activity */
  author: User;
  /** Content of Task Activity */
  content: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Activity ID */
  id: Scalars['ID']['output'];
  /**
   * Users explicitly @-mentioned in this comment (the picker selections),
   * persisted so edits and highlights resolve the exact people instead of
   * re-deriving from free text.
   */
  mentionedUsers: Array<TaskCommentMentionCandidate>;
  /**
   * The workflow this task was launched from, present only on the task-created
   * activity. Lets the timeline link the creation event back to its source workflow.
   */
  sourceWorkflowTemplate: Maybe<TaskWorkflowTemplate>;
  /** Activity/title of Task Activity */
  title: Scalars['String']['output'];
  /** Type of Task Activity */
  typeOf: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task category */
export type TaskCategory =
  /** advisor */
  | 'advisor'
  /** client */
  | 'client'
  /** ops */
  | 'ops';

/** Contact-card projection of a task comment author, used by the mobile profile sheet. */
export type TaskCommentAuthor = {
  __typename?: 'TaskCommentAuthor';
  /** User email address */
  email: Scalars['String']['output'];
  /** User full name */
  fullName: Scalars['String']['output'];
  /** User id */
  id: Scalars['ID']['output'];
  /** User phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** User profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
  /** User role, UPCASED at the GQL boundary */
  role: UserRole;
  /** Configured IANA timezone; null until set */
  timezone: Maybe<Scalars['String']['output']>;
};

/** A task comment @mention candidate */
export type TaskCommentMentionCandidate = {
  __typename?: 'TaskCommentMentionCandidate';
  /** User full name */
  fullName: Scalars['String']['output'];
  /** User id */
  id: Scalars['ID']['output'];
  /** Whether this candidate is from the Ops team */
  opsTeam: Scalars['Boolean']['output'];
  /** User profile picture URL */
  profilePicUrl: Maybe<Scalars['String']['output']>;
};

/** Comment notification summary for a task list row */
export type TaskCommentSummary = {
  __typename?: 'TaskCommentSummary';
  /** One of none|inactive|active|active_mention */
  state: Scalars['String']['output'];
  /** Total number of comments on the task */
  totalCount: Scalars['Int']['output'];
  /** Unread comments since the user last opened task details */
  unreadCount: Scalars['Int']['output'];
  /** Unread mentions of the current user on this task */
  unreadMentionCount: Scalars['Int']['output'];
};

export type TaskCompleted = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  /** Status the task moved from, for funnel analysis. */
  previousStatus?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task that was marked complete. */
  taskId: Scalars['String']['input'];
  /** Type/category of the completed task, when known (the swipe/bulk paths operate on a narrowed task row without it). */
  taskType?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** Who receives the task-completed client email */
export type TaskCompletedEmailRecipients =
  /** both */
  | 'both'
  /** co_client */
  | 'co_client'
  /** primary_client */
  | 'primary_client';

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Task>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

export type TaskCreated = {
  /** Public id of the household the task belongs to, when created in a household context. */
  householdPublicId?: InputMaybe<Scalars['String']['input']>;
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the created task. */
  taskId: Scalars['String']['input'];
  /** Type/category of the created task. */
  taskType: Scalars['String']['input'];
  urlQueryParams: Scalars['JSON']['input'];
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Task>;
};

/**
 * One recipient's copy of a client task email, named so the advisor knows whose it
 * is. Most task emails produce exactly one; account setup produces two.
 */
export type TaskEmailPreviewCopy = {
  __typename?: 'TaskEmailPreviewCopy';
  /** The rendered email as this recipient receives it. */
  preview: EmailPreview;
  /** Address this copy is delivered to. */
  recipientEmail: Scalars['String']['output'];
  /** Full name of the person this copy is addressed to. */
  recipientName: Scalars['String']['output'];
};

/**
 * Task count for a single group bucket; key is the serialized filter value
 * (status, sub_status, assignee id, "unassigned", or due bucket)
 */
export type TaskGroupCount = {
  __typename?: 'TaskGroupCount';
  /** Number of tasks in this bucket */
  count: Scalars['Int']['output'];
  /** Group key: the serialized filter value used to fetch this bucket */
  key: Scalars['String']['output'];
};

/** Task priority level */
export type TaskPriority =
  /** high */
  | 'high'
  /** low */
  | 'low'
  /** medium */
  | 'medium'
  /** none */
  | 'none';

/** A recurrence schedule attached to a task */
export type TaskRecurrence = {
  __typename?: 'TaskRecurrence';
  /** Whether the recurrence is active */
  active: Scalars['Boolean']['output'];
  /** Month of year (1..12) anchor. */
  byMonth: Maybe<Scalars['Int']['output']>;
  /** Day of month (1..31) anchor. */
  byMonthDay: Maybe<Scalars['Int']['output']>;
  /** Ordinal occurrence within month (1..5 or -1). */
  bySetPos: Maybe<Scalars['Int']['output']>;
  /** Comma-separated RFC 5545 BYDAY codes (e.g. "FR" or "MO,TU,WE,TH,FR"). */
  byday: Maybe<Scalars['String']['output']>;
  /** When the recurrence ends */
  endCondition: RecurrenceEndCondition;
  /** Max occurrences for by_count end condition */
  endCount: Maybe<Scalars['Int']['output']>;
  /** End date for by_date end condition */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** How often the task recurs */
  frequency: RecurrenceFrequency;
  /** The ID of the recurrence */
  id: Scalars['ID']['output'];
  /** Interval between occurrences */
  interval: Scalars['Int']['output'];
  /** Number of occurrences generated so far */
  occurrencesGenerated: Scalars['Int']['output'];
  /** IANA timezone for scheduling */
  timezone: Scalars['String']['output'];
};

/** Sort values for tasks table */
export type TaskSortValues =
  /** ASSIGNEE_NAME */
  | 'ASSIGNEE_NAME'
  /** CATEGORY */
  | 'CATEGORY'
  /** COMMENT_STATUS */
  | 'COMMENT_STATUS'
  /** CREATED_AT */
  | 'CREATED_AT'
  /** DESCRIPTION */
  | 'DESCRIPTION'
  /** DUE_AT */
  | 'DUE_AT'
  /** HOUSEHOLD_NAME */
  | 'HOUSEHOLD_NAME'
  /** NAME */
  | 'NAME'
  /** PRIORITY */
  | 'PRIORITY'
  /** STATUS */
  | 'STATUS'
  /** TYPE */
  | 'TYPE'
  /** UPDATED_AT */
  | 'UPDATED_AT';

export type TaskStatus =
  /** cancelled */
  | 'cancelled'
  /** done */
  | 'done'
  /** draft */
  | 'draft'
  /** failed */
  | 'failed'
  /** hidden */
  | 'hidden'
  /** in_progress */
  | 'in_progress'
  /** pending */
  | 'pending'
  /** sent */
  | 'sent'
  /** todo */
  | 'todo';

export type TaskStatusChanged = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  /** Status the task moved from, when known. */
  previousStatus?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Status the task moved to. */
  status: Scalars['String']['input'];
  /** Sub-status set alongside the new status, when one applies. */
  subStatus?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task whose status changed. */
  taskId: Scalars['String']['input'];
  /** Type/category of the task, when known. */
  taskType?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

export type TaskSubStatus =
  /** active_working */
  | 'active_working'
  /** paused_blocked */
  | 'paused_blocked'
  /** pending_advisor */
  | 'pending_advisor'
  /** pending_client */
  | 'pending_client'
  /** pending_custodian */
  | 'pending_custodian'
  /** reviewed_ready_for_work */
  | 'reviewed_ready_for_work';

export type TaskSuggestion = {
  __typename?: 'TaskSuggestion';
  /** The description of the task suggestion */
  description: Maybe<Scalars['String']['output']>;
  /** When the task is due */
  dueDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Savvy ID of the task suggestion */
  id: Scalars['ID']['output'];
  /** Metadata about the task */
  metadata: Maybe<Scalars['JSON']['output']>;
  /** The name of the task suggestion */
  name: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the note this task suggestion is associated with */
  noteId: Scalars['ID']['output'];
  /** The status of the task suggestion */
  status: TaskSuggestionStatus;
  /** The Savvy ID of the task (if created) from this suggestion */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Type of task suggested */
  type: TaskTypeName;
};

export type TaskSuggestionStatus =
  | 'accepted'
  | 'pending'
  | 'rejected';

export type TaskTypeName =
  /** account_maintenance */
  | 'account_maintenance'
  /** account_onboarding */
  | 'account_onboarding'
  /** account_setup */
  | 'account_setup'
  /** alternative_investments_purchase */
  | 'alternative_investments_purchase'
  /** birthday_reminder */
  | 'birthday_reminder'
  /** client_billing */
  | 'client_billing'
  /** client_info_change */
  | 'client_info_change'
  /** client_other */
  | 'client_other'
  /** client_review */
  | 'client_review'
  /** client_review_meeting */
  | 'client_review_meeting'
  /** client_review_meeting_material_request */
  | 'client_review_meeting_material_request'
  /** client_review_presentation */
  | 'client_review_presentation'
  /** client_transition_flow */
  | 'client_transition_flow'
  /** contract */
  | 'contract'
  /** contract_change */
  | 'contract_change'
  /** corporate_retirement_plan */
  | 'corporate_retirement_plan'
  /** data_info_maintenance */
  | 'data_info_maintenance'
  /** eci_household_onboarding */
  | 'eci_household_onboarding'
  /** emoney */
  | 'emoney'
  /** file_upload */
  | 'file_upload'
  /** financial_planning */
  | 'financial_planning'
  /** general */
  | 'general'
  /** initial_intake_form */
  | 'initial_intake_form'
  /** investment_management */
  | 'investment_management'
  /** investment_management_direct_indexing */
  | 'investment_management_direct_indexing'
  /** investment_management_wealthcare */
  | 'investment_management_wealthcare'
  /** investment_proposal_generation */
  | 'investment_proposal_generation'
  /** investment_proposal_presentation */
  | 'investment_proposal_presentation'
  /** investment_proposal_request */
  | 'investment_proposal_request'
  /** marketing */
  | 'marketing'
  /** money_movement_request */
  | 'money_movement_request'
  /** onboarding_flow */
  | 'onboarding_flow'
  /** open_new_account */
  | 'open_new_account'
  /** other */
  | 'other'
  /** other_investment_task */
  | 'other_investment_task'
  /** pre_review_check_in */
  | 'pre_review_check_in'
  /** rejected_fee */
  | 'rejected_fee'
  /** reporting */
  | 'reporting'
  /** risk_questionnaire */
  | 'risk_questionnaire'
  /** self_reminder */
  | 'self_reminder'
  /** swim_request */
  | 'swim_request'
  /** trades_cash_management */
  | 'trades_cash_management'
  /** trading_request */
  | 'trading_request'
  /** transfer */
  | 'transfer'
  /** transfer_of_assets */
  | 'transfer_of_assets'
  /** transition_analysis */
  | 'transition_analysis'
  /** workflow */
  | 'workflow'
  /** workflow_template */
  | 'workflow_template';

export type TaskViewed = {
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the viewed task. */
  taskId: Scalars['String']['input'];
  /** Type/category of the viewed task. */
  taskType: Scalars['String']['input'];
  urlQueryParams: Scalars['JSON']['input'];
};

/** The launch details of a workflow run — the sidecar of a task with type_of = workflow. */
export type TaskWorkflow = {
  __typename?: 'TaskWorkflow';
  /** The Savvy ID of the workflow run. */
  id: Scalars['ID']['output'];
  /** Schedule anchor chosen at launch: launch_date or due_date. */
  schedule: TaskWorkflowTemplateSchedule;
  /**
   * Launch date (launch_date schedule) or target due date (due_date schedule)
   * chosen at launch; null when the workflow was launched with no date.
   */
  targetDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A reusable workflow template — the sidecar of a task with type_of = workflow. */
export type TaskWorkflowTemplate = {
  __typename?: 'TaskWorkflowTemplate';
  /** Whether the current advisor's organization has already cloned this Savvy template into its Resources. */
  addedToResources: Scalars['Boolean']['output'];
  /** Whether the current user can edit this workflow template. */
  canEdit: Scalars['Boolean']['output'];
  /** User IDs granted edit access on a team template; empty means everyone in the group can edit. */
  editorIds: Array<Scalars['ID']['output']>;
  /** The Savvy ID of the workflow. */
  id: Scalars['ID']['output'];
  /** Count of active (not completed or cancelled) launches the current user can access. */
  inProgressCount: Scalars['Int']['output'];
  /** When this workflow was last launched. */
  lastUsedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Tasks launched from this workflow, newest first. */
  launches: TaskConnection;
  /** Whether the current user can promote this template to a globally-available Savvy template. */
  promotableToSavvy: Scalars['Boolean']['output'];
  /** Schedule anchor: launch_date or due_date. */
  schedule: TaskWorkflowTemplateSchedule;
  /** The template task this workflow describes. */
  task: Task;
  /** Who can see this workflow: private (owner only) or firm. */
  visibility: TaskWorkflowTemplateVisibility;
};


/** A reusable workflow template — the sidecar of a task with type_of = workflow. */
export type TaskWorkflowTemplateLaunchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Action an ACL entry grants on a workflow template: edit */
export type TaskWorkflowTemplateAclAction =
  /** edit */
  | 'edit';

/** Schedule anchor for a task workflow: launch_date or due_date */
export type TaskWorkflowTemplateSchedule =
  /** due_date */
  | 'due_date'
  /** launch_date */
  | 'launch_date';

/** Visibility of a task workflow: private (owner only) or firm */
export type TaskWorkflowTemplateVisibility =
  /** firm */
  | 'firm'
  /** private */
  | 'private';

/** Aggregated data for tasks table including counts before and after filtering */
export type TasksTableAggregatedData = {
  __typename?: 'TasksTableAggregatedData';
  /** Filtered task counts grouped by assignee id; unassigned tasks use the key "unassigned" */
  assigneeCounts: Array<TaskGroupCount>;
  /** Filtered task counts per mutually-exclusive due bucket; keys match the TasksTableDueFilter grouping ladder */
  dueCounts: Array<TaskGroupCount>;
  /** Task counts after applying filters */
  filteredCounts: TasksTableCategoryCounts;
  /** Counts of filtered tasks with status todo or in_progress */
  filteredOpenCounts: TasksTableCategoryCounts;
  /** Filtered task counts grouped by status; key is a TaskStatus value */
  statusCounts: Array<TaskGroupCount>;
  /** Filtered task counts grouped by sub_status (in_progress tasks only); key is a TaskSubStatus value */
  subStatusCounts: Array<TaskGroupCount>;
  /** Task counts before applying filters */
  unfilteredCounts: TasksTableCategoryCounts;
};

/** Filter tasks by assignment: me, team, or clients */
export type TasksTableAssignedToFilter =
  /** all */
  | 'all'
  /** clients */
  | 'clients'
  /** me */
  | 'me'
  /** team */
  | 'team';

/** Task counts by category */
export type TasksTableCategoryCounts = {
  __typename?: 'TasksTableCategoryCounts';
  /** Count of advisor tasks */
  advisor: Scalars['Int']['output'];
  /** Count of client tasks */
  client: Scalars['Int']['output'];
  /** Count of ops tasks */
  ops: Scalars['Int']['output'];
  /** Total count of all tasks */
  total: Scalars['Int']['output'];
};

/** Filter tasks by comment notification state */
export type TasksTableCommentStatusFilter =
  /** no_comments */
  | 'no_comments'
  /** unread_comments */
  | 'unread_comments'
  /** unread_mentions_to_me */
  | 'unread_mentions_to_me'
  /** up_to_date */
  | 'up_to_date';

/**
 * Filter tasks by a single due-at bucket (today, overdue, no_due_date, and the
 * exclusive grouping ladder next_7_days_excluding_today / next_30_days /
 * next_30_days_plus)
 */
export type TasksTableDueFilter =
  /** next_7_days */
  | 'next_7_days'
  /** next_7_days_excluding_today */
  | 'next_7_days_excluding_today'
  /** next_30_days */
  | 'next_30_days'
  /** next_30_days_plus */
  | 'next_30_days_plus'
  /** no_due_date */
  | 'no_due_date'
  /** overdue */
  | 'overdue'
  /** this_month */
  | 'this_month'
  /** today */
  | 'today'
  /** upcoming */
  | 'upcoming';

/** Filter options for tasks table */
export type TasksTableFilterInput = {
  /** Filter assignment for me, team, or clients */
  assignedTo?: InputMaybe<TasksTableAssignedToFilter>;
  /** Filter by assignee user IDs */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by task category */
  category?: InputMaybe<TaskCategory>;
  /** Filter by comment notification state */
  commentStatus?: InputMaybe<Array<TasksTableCommentStatusFilter>>;
  /** Filter tasks by a single due-at bucket (e.g. today, next_7_days, overdue) */
  due?: InputMaybe<TasksTableDueFilter>;
  /** Filter tasks by one or more due-at buckets, ORed together. Unioned with the singular `due`. */
  dues?: InputMaybe<Array<TasksTableDueFilter>>;
  /** Filter by household IDs */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by household tag IDs */
  householdTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include SC v2 automation tasks (pending/sent/failed). Default false preserves v1 semantics. */
  includeCatalogAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by one or more task priority levels */
  priorities?: InputMaybe<Array<TaskPriority>>;
  /** Search query for task names and descriptions */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by task statuses */
  statuses?: InputMaybe<Array<TaskStatus>>;
  /**
   * When true, restrict to tasks with no sub_status (AND-combined). Pair with
   * statuses:[IN_PROGRESS] to fetch the bare in-progress group.
   */
  subStatusNone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by task sub-statuses; narrows within status=in_progress per the DB CHECK constraint. */
  subStatuses?: InputMaybe<Array<TaskSubStatus>>;
  /** Filter by the source workflow(s) a task was launched from. ORed together (a task has at most one source workflow). */
  taskWorkflowIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by task types */
  typesOf?: InputMaybe<Array<TaskTypeName>>;
  /** When true, also include tasks with no assignee (assignee_id IS NULL). Combines OR-style with assignee_ids. */
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Downscoped Box access token and file ID for previewing the tax addendum template */
export type TaxAddendumPreview = {
  __typename?: 'TaxAddendumPreview';
  /** Downscoped Box access token with item_preview scope */
  accessToken: Maybe<Scalars['String']['output']>;
  /** Box file ID of the current tax addendum template */
  fileId: Maybe<Scalars['String']['output']>;
};

/** Tax enrollment for clients. */
export type TaxEnrollment = {
  __typename?: 'TaxEnrollment';
  /** The billable client for this enrollment. */
  billableClient: Client;
  /** When the tax enrollment was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The type of tax enrollment. */
  enrollmentType: TaxEnrollmentTypeName;
  /** The status of the federal return. */
  federalReturnStatus: TaxReturnStatus;
  /** The Savvy ID of the tax enrollment. */
  id: Scalars['ID']['output'];
  /** The non-billable client for this enrollment. */
  nonBillableClient: Maybe<Client>;
  /** The price for this tax enrollment. */
  price: Maybe<Scalars['BigDecimal']['output']>;
  /** The state filings for this tax enrollment. */
  stateFilings: Array<StateFiling>;
  /** The status of the state return. */
  stateReturnStatus: TaxReturnStatus;
  /** The state return status data (JSONB - deprecated, use state_filings). */
  stateReturnStatusData: Maybe<Scalars['JSON']['output']>;
  /** The tax year for this enrollment. */
  taxYear: Scalars['Int']['output'];
  /** When the tax enrollment was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The status of the filing process in April for a tax enrollment */
export type TaxEnrollmentAprilAppStatus =
  /** cancelled */
  | 'cancelled'
  /** exempt_from_filing */
  | 'exempt_from_filing'
  /** not_started */
  | 'not_started'
  /** questionnaire_completed */
  | 'questionnaire_completed'
  /** questionnaire_in_progress */
  | 'questionnaire_in_progress'
  /** ready_to_submit */
  | 'ready_to_submit'
  /** submitted */
  | 'submitted';

/** Which tax enrollment banner to display on the tax page */
export type TaxEnrollmentBannerStatus =
  /** filing_needed */
  | 'filing_needed'
  /** none */
  | 'none'
  /** signature_needed */
  | 'signature_needed';

/** Sort values for tax enrollments table row */
export type TaxEnrollmentSortValues =
  /** client_name */
  | 'client_name'
  /** federal_return_status */
  | 'federal_return_status'
  /** filing_type */
  | 'filing_type'
  /** price */
  | 'price'
  /** tax_status */
  | 'tax_status'
  /** tax_year */
  | 'tax_year';

export type TaxEnrollmentStatus =
  /** federal_accepted */
  | 'federal_accepted'
  /** federal_rejected */
  | 'federal_rejected'
  /** federal_submitted */
  | 'federal_submitted'
  /** in_progress */
  | 'in_progress'
  /** not_interested */
  | 'not_interested'
  /** not_started */
  | 'not_started'
  /** registered */
  | 'registered'
  /** state_accepted */
  | 'state_accepted'
  /** state_rejected */
  | 'state_rejected'
  /** state_submitted */
  | 'state_submitted';

export type TaxEnrollmentTypeName =
  /** external_cpa */
  | 'external_cpa'
  /** other */
  | 'other'
  /** savvy_joint */
  | 'savvy_joint'
  /** savvy_single */
  | 'savvy_single'
  /** transcript_services_only */
  | 'transcript_services_only';

export type TaxEnrollmentsTableHeader = {
  __typename?: 'TaxEnrollmentsTableHeader';
  /** Number of clients with missing tax enrollments */
  requireAdvisorActionCount: Scalars['Int']['output'];
  /** Number of clients with tax enrollments but no tax transcript requests */
  requireClientActionCount: Scalars['Int']['output'];
  /** Number of clients with tax transcript requests with status "requested" */
  waitingOnThirdPartyCount: Scalars['Int']['output'];
};

/** A row in the tax enrollments table representing a household's tax enrollment */
export type TaxEnrollmentsTableRow = {
  __typename?: 'TaxEnrollmentsTableRow';
  /** The status of the filing process in April for this tax enrollment */
  aprilAppStatus: Maybe<TaxEnrollmentAprilAppStatus>;
  /** The client id */
  clientId: Scalars['ID']['output'];
  /** The client associated with the tax enrollment */
  clientName: Maybe<Scalars['String']['output']>;
  /** When the enrollment was created */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The status of the tax enrollment */
  enrollmentStatus: TaxEnrollmentStatus;
  /** The type of tax enrollment (single, joint, etc.) */
  enrollmentType: Maybe<TaxEnrollmentTypeName>;
  /** The status of the federal return */
  federalReturnStatus: Maybe<TaxReturnStatus>;
  /** The name of the household */
  householdName: Scalars['String']['output'];
  /** The price of the tax enrollment */
  price: Maybe<Scalars['BigDecimal']['output']>;
  /** The id of the row */
  rowId: Scalars['ID']['output'];
  /** The salesforce id of the household */
  salesforceId: Maybe<Scalars['String']['output']>;
  /** The state filings for this tax enrollment */
  stateFilings: Array<StateFiling>;
  /** The state return status data (JSONB - deprecated, use state_filings) */
  stateReturnStatusData: Maybe<Scalars['JSON']['output']>;
  /** The status of the tax enrollment - remove after updating FE to use enrollment_status */
  status: TaxEnrollmentStatus;
  /** The id of the tax enrollment */
  taxEnrollmentId: Maybe<Scalars['ID']['output']>;
  /** The tax year for this enrollment */
  taxYear: Maybe<Scalars['Int']['output']>;
  /** The status of the transcript request */
  transcriptStatus: Maybe<TaxTranscriptRequestStatus>;
};

/** The connection type for TaxEnrollmentsTableRow. */
export type TaxEnrollmentsTableRowConnection = {
  __typename?: 'TaxEnrollmentsTableRowConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TaxEnrollmentsTableRowEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<TaxEnrollmentsTableRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxEnrollmentsTableRowEdge = {
  __typename?: 'TaxEnrollmentsTableRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TaxEnrollmentsTableRow>;
};

export type TaxGroupTypeName =
  /** Not Available */
  | 'NOT_AVAILABLE'
  /** taxable */
  | 'TAXABLE'
  /** tax deferred */
  | 'TAX_DEFERRED'
  /** tax free */
  | 'TAX_FREE';

/** Tax page data for a household */
export type TaxPage = {
  __typename?: 'TaxPage';
  /** Co-client of the household */
  coClient: Maybe<TaxPageClient>;
  /** Primary client of the household */
  primaryClient: TaxPageClient;
  /** Downscoped Box preview config for the tax addendum template */
  taxAddendumPreview: Maybe<TaxAddendumPreview>;
};

/** Client data for the tax page */
export type TaxPageClient = {
  __typename?: 'TaxPageClient';
  /** The client agreements for the user */
  clientAgreements: Maybe<Array<ClientAgreement>>;
  /** The date and time the onboarding IAA was created for the user */
  onboardingIaaCreatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Tax enrollments for this client */
  taxEnrollments: Maybe<Array<TaxEnrollment>>;
  /** Tax transcript requests for this client */
  taxTranscriptRequests: Maybe<Array<TaxTranscriptRequest>>;
  /** Tax transcript data */
  taxTranscripts: Maybe<Array<TaxTranscript>>;
  /** The full name of the user */
  userFullName: Scalars['String']['output'];
  /** The ID of the user */
  userId: Scalars['ID']['output'];
  /** The KYC status of the user */
  userKycStatus: FootprintStatus;
};

export type TaxReturnStatus =
  /** accepted */
  | 'accepted'
  /** filed_pending_response */
  | 'filed_pending_response'
  /** none */
  | 'none'
  /** not_filed */
  | 'not_filed'
  /** rejected */
  | 'rejected';

/** Tax transcript */
export type TaxTranscript = {
  __typename?: 'TaxTranscript';
  /** adjusted gross income */
  adjustedGrossIncome: Maybe<Scalars['Int']['output']>;
  /** federal tax witheld */
  federalIncomeTaxWitheld: Maybe<Scalars['Int']['output']>;
  /** tax refund, positive = received from gov, negative = need to pay */
  federalRefund: Maybe<Scalars['Int']['output']>;
  /** taxes owed to federal gov */
  federalTaxLiability: Maybe<Scalars['Int']['output']>;
  /** record ID */
  id: Scalars['ID']['output'];
  /** Standard or itemized deduction amount */
  standardOrItemizedDeduction: Maybe<Scalars['Int']['output']>;
  /** tax year */
  taxYear: Scalars['Int']['output'];
  /** taxable income */
  taxableIncome: Maybe<Scalars['Int']['output']>;
  /** Total tax deductions */
  totalDeductions: Maybe<Scalars['Int']['output']>;
  /** total income */
  totalIncome: Maybe<Scalars['Int']['output']>;
  /** YoY comparisons */
  yoyChange: Maybe<TaxYoyChange>;
};

/** Tax transcript request for clients. */
export type TaxTranscriptRequest = {
  __typename?: 'TaxTranscriptRequest';
  /** The client for this tax transcript request. */
  client: Client;
  /** When the tax transcript request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the tax transcript request. */
  id: Scalars['ID']['output'];
  /** The status of the tax transcript request. */
  status: TaxTranscriptRequestStatus;
  /** When the tax transcript request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The status of a tax transcript request. */
export type TaxTranscriptRequestStatus =
  /** completed */
  | 'completed'
  /** requested */
  | 'requested';

/** Grouping of portfolio by tax type. */
export type TaxTypeGrouping = {
  __typename?: 'TaxTypeGrouping';
  taxType: TaxGroupTypeName;
  value: Maybe<Value>;
};

/** Grouping of portfolio by tax type. */
export type TaxTypeGroupingsByPeriod = {
  __typename?: 'TaxTypeGroupingsByPeriod';
  taxTypeGroupings: Maybe<Array<TaxTypeGrouping>>;
  timePeriod: Maybe<PerformanceTimePeriodName>;
};

/** YoY percentage changes for tax metrics */
export type TaxYoyChange = {
  __typename?: 'TaxYoyChange';
  /** Year-over-year percentage change in federal refund */
  federalRefundPct: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in federal tax liability */
  federalTaxLiabilityPct: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in deductions */
  totalDeductionsPct: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in total income */
  totalIncomePct: Maybe<Scalars['Float']['output']>;
};

/** Text filter with operator and value */
export type TextFilterInput = {
  /** Text filter operator */
  operator: TextFilterOperatorEnum;
  /** Filter value (not required for isEmpty operator) */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Text filter operators */
export type TextFilterOperatorEnum =
  /** Contains the value */
  | 'CONTAINS'
  /** Ends with the value */
  | 'ENDS_WITH'
  /** Equals the value exactly */
  | 'EQUALS'
  /** Field is empty or null */
  | 'IS_EMPTY'
  /** Starts with the value */
  | 'STARTS_WITH';

export type TextReplacement = {
  /** Text in the template that identifies the placeholder text to be replaced. */
  placeholder: Scalars['String']['input'];
  /** The text to replace the placeholder with. */
  replaceWithText: Scalars['String']['input'];
};

export type TimeHorizonName =
  | 'ten_plus_years'
  | 'three_to_ten_years'
  | 'zero_to_three_years';

/** Autogenerated input type of ToggleCommentReaction */
export type ToggleCommentReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to react to */
  commentId: Scalars['ID']['input'];
  /** One of the fixed reaction emoji offered by the UI */
  emoji: Scalars['String']['input'];
};

/** Autogenerated return type of ToggleCommentReaction. */
export type ToggleCommentReactionPayload = {
  __typename?: 'ToggleCommentReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The comment with its updated reactions */
  comment: Comment;
  /** True when the reaction was added, false when it was removed */
  reacted: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TrackEvent */
export type TrackEventInput = {
  alertArchived?: InputMaybe<AlertArchived>;
  alertSnoozed?: InputMaybe<AlertSnoozed>;
  backgroundMeetingPrepDocumentOpen?: InputMaybe<BackgroundMeetingPrepDocumentOpen>;
  backgroundMeetingPrepNotificationClick?: InputMaybe<BackgroundMeetingPrepNotificationClick>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentSent?: InputMaybe<CommentSent>;
  elementImpression?: InputMaybe<ElementImpression>;
  elementViewDuration?: InputMaybe<ElementViewDuration>;
  noteDetailOpen?: InputMaybe<NoteDetailOpen>;
  noteDetailViewDuration?: InputMaybe<NoteDetailViewDuration>;
  pageImpression?: InputMaybe<PageImpression>;
  pageViewDuration?: InputMaybe<PageViewDuration>;
  pushNotificationOpened?: InputMaybe<PushNotificationOpened>;
  pushNotificationsToggled?: InputMaybe<PushNotificationsToggled>;
  taskCompleted?: InputMaybe<TaskCompleted>;
  taskCreated?: InputMaybe<TaskCreated>;
  taskStatusChanged?: InputMaybe<TaskStatusChanged>;
  taskViewed?: InputMaybe<TaskViewed>;
  userInteraction?: InputMaybe<UserInteraction>;
};

/** Autogenerated return type of TrackEvent. */
export type TrackEventPayload = {
  __typename?: 'TrackEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TradingRequest = {
  __typename?: 'TradingRequest';
  account: Scalars['String']['output'];
  additionalDetails: Maybe<Scalars['String']['output']>;
  holdings: Array<TradingRequestHolding>;
  id: Scalars['ID']['output'];
};

export type TradingRequestHolding = {
  __typename?: 'TradingRequestHolding';
  /** Savvy id of the account the order trades in. */
  accountId: Maybe<Scalars['ID']['output']>;
  action: Scalars['String']['output'];
  amount: TradingRequestHoldingAmount;
  holdingName: Scalars['String']['output'];
  marketValue: Maybe<Scalars['String']['output']>;
  /** Orion security id resolved when the order was placed. */
  securityId: Maybe<Scalars['ID']['output']>;
  /** Security name Orion resolved for the ticker. */
  securityName: Maybe<Scalars['String']['output']>;
  /** Ticker symbol the advisor entered. */
  ticker: Maybe<Scalars['String']['output']>;
};

export type TradingRequestHoldingAmount = {
  __typename?: 'TradingRequestHoldingAmount';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Input for creating a trading request */
export type TradingRequestInput = {
  /** The account identifier for the trade */
  account: Scalars['String']['input'];
  /** Additional details or notes about the trade */
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Array of holdings/securities to trade */
  holdings: Array<Scalars['JSON']['input']>;
};

/** Transaction associated with an account */
export type Transaction = {
  __typename?: 'Transaction';
  /** The Savvy ID of the account associated with the transaction */
  accountId: Scalars['ID']['output'];
  /** The Savvy ID of the transaction. */
  id: Scalars['ID']['output'];
  /** Number of units of the transacted security */
  quantity: Scalars['BigDecimal']['output'];
  /** The Savvy ID of the security associated with the transaction */
  securityId: Scalars['ID']['output'];
  /** Name of transacted security. */
  securityName: Scalars['String']['output'];
  /** Type of transacted security. */
  securityType: SecurityTypeName;
  source: TransactionSourceName;
  /** The unique ID of the transaction given by the source */
  sourceTransactionId: Scalars['ID']['output'];
  /** Status of transaction */
  status: TransactionStatus;
  /** Ticker symbol of transacted security. */
  tickerSymbol: Scalars['String']['output'];
  /** Timestamp for when the transaction occured */
  transactedAt: Scalars['ISO8601DateTime']['output'];
  /** Type of transaction */
  typeOf: TransactionTypeName;
  /** Average value of each security of the transacted asset */
  unitPrice: Scalars['BigDecimal']['output'];
  /** The total value of the transaction */
  value: Scalars['BigDecimal']['output'];
};

export type TransactionSourceName =
  | 'moneykit'
  | 'orion'
  | 'plaid';

export type TransactionStatus =
  | 'complete'
  | 'inactive'
  | 'pending'
  | 'pending_corporate_action'
  | 'rejected'
  | 'reversed';

export type TransactionTypeName =
  | 'administrative_fee'
  | 'administrative_fee_adjustment'
  | 'adr_fee'
  | 'adr_fee_credit'
  | 'advisory_fee'
  | 'advisory_fee_credit'
  | 'annuity_bonus'
  | 'bd_fee'
  | 'benefit_change_transfer_in'
  | 'benefit_change_transfer_out'
  | 'buy'
  | 'buy_exchange'
  | 'buy_from_custodial_cash'
  | 'cancel_account'
  | 'capital_distribution'
  | 'client_contribution'
  | 'client_deposit'
  | 'client_distribution'
  | 'client_withdrawal'
  | 'death_benefit'
  | 'decrease_in_value'
  | 'dividend_offset'
  | 'dividend_paid_from_cash'
  | 'dividend_reinvested'
  | 'dividend_tax'
  | 'dividend_to_cash'
  | 'employer_contribution'
  | 'employer_distribution'
  | 'external_account_activity_in'
  | 'external_account_activity_out'
  | 'federal_tax_withheld'
  | 'fee_credit'
  | 'folio_balance_adjustment'
  | 'folio_contribution'
  | 'folio_distribution'
  | 'foreign_dividend_tax'
  | 'foreign_tax_paid'
  | 'foreign_tax_withheld'
  | 'fund_fee'
  | 'fund_fee_adjustment'
  | 'idle_cash_interest'
  | 'income_paid'
  | 'income_reinvested'
  | 'increase_in_value'
  | 'interest_paid'
  | 'interest_paid_e'
  | 'interest_paid_in_cash'
  | 'interest_receivable'
  | 'interest_reinvested'
  | 'internal_account_in_not_billed'
  | 'internal_account_out_not_billed'
  | 'journal_in'
  | 'journal_out'
  | 'legal_and_accounting_fees'
  | 'loan_default'
  | 'loan_distribution'
  | 'loan_interest_paid'
  | 'loan_payment'
  | 'loan_repayment'
  | 'loan_setup'
  | 'long_term_gain_negative_adjustment'
  | 'long_term_gain_reinvested'
  | 'long_term_gain_tax'
  | 'long_term_gain_to_cash'
  | 'm_and_e_band_transfer_in'
  | 'm_and_e_band_transfer_out'
  | 'management_fee'
  | 'management_style_change_in'
  | 'management_style_change_out'
  | 'margin_interest_credit'
  | 'merge_in_exchange'
  | 'merge_in_from_other_account'
  | 'merge_out_exchange'
  | 'merge_out_to_other_account'
  | 'option_assigned'
  | 'option_exercised'
  | 'option_expired'
  | 'orf_fee'
  | 'prior_return_of_bond_principal'
  | 'qualified_dividend_reinvested'
  | 'qualified_dividend_to_cash'
  | 'redemption_fee'
  | 'remark'
  | 'reportable_transfer_in'
  | 'return_of_bond_principal'
  | 'return_of_capital'
  | 'reversal'
  | 'reverse_stock_split'
  | 'rfs_transaction_fee'
  | 'rollover_contribution'
  | 'sec_fee'
  | 'sell'
  | 'sell_exchange'
  | 'sell_to_custodial_cash'
  | 'short_starting_value'
  | 'short_term_gain_reinvested'
  | 'short_term_gain_tax'
  | 'short_term_gain_to_cash'
  | 'spin_off_in'
  | 'spin_off_out'
  | 'starting_value'
  | 'state_tax_withheld'
  | 'step_up_buy'
  | 'stock_split'
  | 'systematic_withdrawal'
  | 'tax_basis_negative_adjustment'
  | 'tax_basis_positive_adjustment'
  | 'tax_credit'
  | 'tax_free_exchange_in'
  | 'tax_free_exchange_out'
  | 'taxes_withheld'
  | 'trading_expense'
  | 'transaction_fee'
  | 'transfer_in_non_taxable'
  | 'transfer_out_non_taxable'
  | 'unknown_contribution'
  | 'unknown_cost_basis'
  | 'unknown_distribution'
  | 'wire_fee'
  | 'wire_fee_credit';

/** Response containing transcript consent text from April */
export type TranscriptConsentFormResponse = {
  __typename?: 'TranscriptConsentFormResponse';
  /** The address line 1 of the client */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** The address line 2 of the client */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** The city of the client */
  city: Maybe<Scalars['String']['output']>;
  /** The consent text if successful */
  consentText: Maybe<Scalars['String']['output']>;
  /** Error message if consent textrequest failed */
  consentTextError: Maybe<Scalars['String']['output']>;
  /** The date of birth of the client */
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** The first name of the client */
  firstName: Scalars['String']['output'];
  /** The ID of the client */
  id: Scalars['ID']['output'];
  /** The last name of the client */
  lastName: Scalars['String']['output'];
  /** The middle name of the client */
  middleName: Maybe<Scalars['String']['output']>;
  /** The phone number of the client */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** The social security number of the client */
  socialSecurityNumber: Maybe<Scalars['String']['output']>;
  /** The state of the client */
  state: Maybe<Scalars['String']['output']>;
  /** The zip code of the client */
  zipCode: Maybe<Scalars['String']['output']>;
};

export type TranscriptKind =
  /** DialpadCallTranscript */
  | 'DialpadCallTranscript'
  /** ZoomMeetingTranscript */
  | 'ZoomMeetingTranscript';

/** Input for transfer of assets task specific data */
export type TransferOfAssetsInput = {
  /** Savvy account IDs that will receive the transferred assets */
  accountIds: Array<Scalars['String']['input']>;
  /** Name on the account at the contra custodian */
  accountName: Scalars['String']['input'];
  /** Account number at the contra custodian */
  accountNumber: Scalars['String']['input'];
  /** Legal registration type (e.g. Individual, Joint, Trust) */
  accountRegistration: Scalars['String']['input'];
  /** The sending institution (e.g. Vanguard, Fidelity) */
  contraCustodian: Scalars['String']['input'];
  /** Details of what to transfer when transfer_type is partial */
  partialTransferDetails?: InputMaybe<Scalars['String']['input']>;
  /** Type of transfer: full or partial */
  transferType: Scalars['String']['input'];
};

/** Transfer of assets request data associated with a task */
export type TransferOfAssetsRequest = {
  __typename?: 'TransferOfAssetsRequest';
  /** IDs of the receiving Savvy accounts. */
  accountIds: Array<Scalars['String']['output']>;
  /** Name on the account at the contra custodian. */
  accountName: Scalars['String']['output'];
  /** Account number at the contra custodian. */
  accountNumber: Scalars['String']['output'];
  /** Legal registration of the account (e.g. Individual, Joint). */
  accountRegistration: Scalars['String']['output'];
  /** The sending institution (e.g. Vanguard, TD Ameritrade). */
  contraCustodian: Scalars['String']['output'];
  /** The Savvy ID of the request. */
  id: Scalars['ID']['output'];
  /** Details of what to transfer (only set when transfer_type is partial). */
  partialTransferDetails: Maybe<Scalars['String']['output']>;
  /** Whether the transfer is full or partial. */
  transferType: Scalars['String']['output'];
};

export type TrendingHeadline = {
  __typename?: 'TrendingHeadline';
  headline: Scalars['String']['output'];
  publishedDate: Scalars['ISO8601DateTime']['output'];
  sentiment: NewsSentimentName;
  text: Scalars['String']['output'];
  tickers: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UnarchiveHousehold */
export type UnarchiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to unarchive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveHousehold. */
export type UnarchiveHouseholdPayload = {
  __typename?: 'UnarchiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household stage was updated */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnarchiveServiceCatalogItemGroup */
export type UnarchiveServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveServiceCatalogItemGroup. */
export type UnarchiveServiceCatalogItemGroupPayload = {
  __typename?: 'UnarchiveServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of UnassignServiceCatalogItemFromHousehold */
export type UnassignServiceCatalogItemFromHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  householdId: Scalars['ID']['input'];
  /** Service catalog item id */
  serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnassignServiceCatalogItemFromHousehold. */
export type UnassignServiceCatalogItemFromHouseholdPayload = {
  __typename?: 'UnassignServiceCatalogItemFromHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item household */
  serviceCatalogItemHousehold: Maybe<ServiceCatalogItemHousehold>;
};

/** Autogenerated input type of UnenrollHouseholdsFromServiceCatalogItemGroup */
export type UnenrollHouseholdsFromServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Households to unenroll: at least one, at most 25 per call. Duplicates are
   * collapsed; every id must exist and be reachable, or the whole call is refused.
   * At most 200 enrollments to remove — the matching active assignment rows, which
   * include items since removed from the service and items now archived, not
   * households x active items
   */
  householdIds: Array<Scalars['ID']['input']>;
  /** The service (template) to unenroll from; an archived service still accepts unenrollment */
  serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnenrollHouseholdsFromServiceCatalogItemGroup. */
export type UnenrollHouseholdsFromServiceCatalogItemGroupPayload = {
  __typename?: 'UnenrollHouseholdsFromServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Households whose unenrollment rolled back; their enrollments are unchanged */
  failedHouseholdCount: Scalars['Int']['output'];
  /** Per-household outcome, in the order the households were given */
  results: Array<ServiceCatalogUnenrollmentResult>;
  /** Households with no active enrollment in this service; nothing changed for them */
  skippedHouseholdCount: Scalars['Int']['output'];
  /** Households whose enrollments in this service were paused */
  unenrolledHouseholdCount: Scalars['Int']['output'];
};

/** Autogenerated input type of UnlinkOrionHousehold */
export type UnlinkOrionHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household to unlink from Orion */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkOrionHousehold. */
export type UnlinkOrionHouseholdPayload = {
  __typename?: 'UnlinkOrionHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the household was unlinked from Orion */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnlinkTimelineItemFromContact */
export type UnlinkTimelineItemFromContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contact id */
  contactId: Scalars['ID']['input'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  contactType: Scalars['String']['input'];
  /** The timeline item id */
  timelineItemId: Scalars['ID']['input'];
  /** The timeline item type */
  timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of UnlinkTimelineItemFromContact. */
export type UnlinkTimelineItemFromContactPayload = {
  __typename?: 'UnlinkTimelineItemFromContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the pair is unlinked (true even if it was already unlinked) */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnregisterPushToken */
export type UnregisterPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expo push token to remove */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UnregisterPushToken. */
export type UnregisterPushTokenPayload = {
  __typename?: 'UnregisterPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Always true; deletion is idempotent */
  success: Scalars['Boolean']['output'];
};

/** Information about unsupported account types */
export type UnsupportedAccount = {
  __typename?: 'UnsupportedAccount';
  /** Account number */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Account type (IRA or Personal) */
  accountType: Scalars['String']['output'];
  /** Account ID */
  id: Scalars['ID']['output'];
  /** Account name */
  name: Scalars['String']['output'];
  /** Specific account type (simple_ira, sep_ira, trust, 529) */
  specificType: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateAccount */
export type UpdateAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  beneficiaries?: InputMaybe<Array<BeneficiaryInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currentBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  custody?: InputMaybe<AccountCustodyName>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customNote?: InputMaybe<Scalars['String']['input']>;
  deleteCustomName?: InputMaybe<Scalars['Boolean']['input']>;
  deleteCustomNote?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of this account */
  purpose?: InputMaybe<Scalars['String']['input']>;
  /** Custom purpose when purpose is set to other */
  purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Source of the funds for this account */
  sourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  /** Custom source of funds when source_of_funds is set to other */
  sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<AccountSubtypeName>;
  type?: InputMaybe<AccountTypeName>;
  voidedCheckRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account: Account;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccountSleeve */
export type UpdateAccountSleeveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customNote?: InputMaybe<Scalars['String']['input']>;
  deleteCustomName?: InputMaybe<Scalars['Boolean']['input']>;
  deleteCustomNote?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAccountSleeve. */
export type UpdateAccountSleevePayload = {
  __typename?: 'UpdateAccountSleevePayload';
  accountSleeve: AccountSleeve;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccountTransferDatum */
export type UpdateAccountTransferDatumInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountOwner: AccountOwner;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAccountTransferDatum. */
export type UpdateAccountTransferDatumPayload = {
  __typename?: 'UpdateAccountTransferDatumPayload';
  accountTransferDatum: AccountTransferDatum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateActionCenterVisited */
export type UpdateActionCenterVisitedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateActionCenterVisited. */
export type UpdateActionCenterVisitedPayload = {
  __typename?: 'UpdateActionCenterVisitedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAddress. */
export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorAiDisclosureAcceptance */
export type UpdateAdvisorAiDisclosureAcceptanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAdvisorAiDisclosureAcceptance. */
export type UpdateAdvisorAiDisclosureAcceptancePayload = {
  __typename?: 'UpdateAdvisorAiDisclosureAcceptancePayload';
  advisorProfile: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorAlertSettings */
export type UpdateAdvisorAlertSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<AlertSettingsInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorAlertSettings. */
export type UpdateAdvisorAlertSettingsPayload = {
  __typename?: 'UpdateAdvisorAlertSettingsPayload';
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorCaptiveStatus */
export type UpdateAdvisorCaptiveStatusInput = {
  /** User id of the advisor */
  advisorId: Scalars['ID']['input'];
  /** Whether the advisor is employed under Savvy's RIA (captive) rather than running their own book (owned) */
  captive: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAdvisorCaptiveStatus. */
export type UpdateAdvisorCaptiveStatusPayload = {
  __typename?: 'UpdateAdvisorCaptiveStatusPayload';
  /** The updated advisor */
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorCsa */
export type UpdateAdvisorCsaInput = {
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csaId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorCsa. */
export type UpdateAdvisorCsaPayload = {
  __typename?: 'UpdateAdvisorCsaPayload';
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorDirectoryProfile */
export type UpdateAdvisorDirectoryProfileInput = {
  /** Whether to list the advisor in the directory. False deactivates their listing. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show the computed AUM band on the profile. */
  aumShareOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisor bio. */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Designations, e.g. ["CFP®"]. */
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Client-facing DBA email address. Blank clears it (falls back to login email). */
  dbaEmail?: InputMaybe<Scalars['String']['input']>;
  /** Raw intake question→answer pairs to persist, in order. */
  intakeAnswers?: InputMaybe<Array<IntakeAnswerInput>>;
  /** Canonical spoken-language keys (from directoryLanguages). */
  languageKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** LinkedIn profile URL. */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** Advisor phone number for client-facing reports. Blank clears it. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Prior firm. */
  priorFirm?: InputMaybe<Scalars['String']['input']>;
  /** Canonical specialty keys (from directorySpecialties). */
  specialtyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** State. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Advisor title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Years of experience. */
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateAdvisorGroupSettings */
export type UpdateAdvisorGroupSettingsInput = {
  advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settings: AdvisorGroupSettingsInput;
};

/** Autogenerated return type of UpdateAdvisorGroupSettings. */
export type UpdateAdvisorGroupSettingsPayload = {
  __typename?: 'UpdateAdvisorGroupSettingsPayload';
  advisorGroup: AdvisorGroup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorOnboardingCohort */
export type UpdateAdvisorOnboardingCohortInput = {
  /** User id of the advisor */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the advisor is a new advisor or an existing one. Null clears the classification back to unknown. */
  onboardingCohort?: InputMaybe<AdvisorOnboardingCohort>;
};

/** Autogenerated return type of UpdateAdvisorOnboardingCohort. */
export type UpdateAdvisorOnboardingCohortPayload = {
  __typename?: 'UpdateAdvisorOnboardingCohortPayload';
  /** The updated advisor */
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorProfile */
export type UpdateAdvisorProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAdvisorProfile. */
export type UpdateAdvisorProfilePayload = {
  __typename?: 'UpdateAdvisorProfilePayload';
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorSettings */
export type UpdateAdvisorSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<AdvisorSettingsInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorSettings. */
export type UpdateAdvisorSettingsPayload = {
  __typename?: 'UpdateAdvisorSettingsPayload';
  advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAlert */
export type UpdateAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  snoozedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<AlertStatusName>;
  surfaceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of UpdateAlert. */
export type UpdateAlertPayload = {
  __typename?: 'UpdateAlertPayload';
  alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAsset */
export type UpdateAssetInput = {
  assetClass?: InputMaybe<AssetClassName>;
  assetSubclass?: InputMaybe<AssetSubclassName>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEquityCompanyName?: InputMaybe<Scalars['String']['input']>;
  companyEquityCompanyTicker?: InputMaybe<Scalars['String']['input']>;
  companyEquityCurrentPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityExercisePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityGrantType?: InputMaybe<Scalars['String']['input']>;
  companyEquitySharesIssued?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingCliff?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingDuration?: InputMaybe<Scalars['BigDecimal']['input']>;
  companyEquityVestingRate?: InputMaybe<Scalars['String']['input']>;
  companyEquityVestingStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currentValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAsset. */
export type UpdateAssetPayload = {
  __typename?: 'UpdateAssetPayload';
  asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateClientDetails */
export type UpdateClientDetailsInput = {
  /**
   * Deprecated: use addresses instead
   * @deprecated Use addresses
   */
  address?: InputMaybe<AddressInput>;
  /** The addresses of the user */
  addresses?: InputMaybe<Array<AddressInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The client profile of the user */
  clientProfile?: InputMaybe<ClientProfileInput>;
  /** The email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The (optional) legal middle name of the user */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the user */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The preferred name of the user */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /** The secondary emails of the user */
  secondaryEmails?: InputMaybe<Array<SecondaryEmailInput>>;
  /** The secondary phones of the user */
  secondaryPhones?: InputMaybe<Array<SecondaryPhoneInput>>;
  /** The ID of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClientDetails. */
export type UpdateClientDetailsPayload = {
  __typename?: 'UpdateClientDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  /** The user */
  user: Maybe<User>;
};

/** Autogenerated input type of UpdateClientEmploymentDetails */
export type UpdateClientEmploymentDetailsInput = {
  /** The annual gross income of the user */
  annualGrossIncome?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the employer */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** The employment status of the user */
  employmentStatus?: InputMaybe<EmploymentStatusName>;
  /** The job title of the user */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The retirement date of the user */
  retirementDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The university of the user */
  university?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClientEmploymentDetails. */
export type UpdateClientEmploymentDetailsPayload = {
  __typename?: 'UpdateClientEmploymentDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The Client Profile */
  clientProfile: Maybe<Client>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Input for updating a client profile and its associated user */
export type UpdateClientInput = {
  /** Address details */
  address?: InputMaybe<AddressInput>;
  /** Client profile details including SSN and date of birth */
  clientProfile?: InputMaybe<ClientProfileInput>;
  /** The ID of the client profile */
  clientProfileId: Scalars['ID']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /** The new role for the client (primary or member) */
  role?: InputMaybe<ClientRole>;
  /** Secondary email addresses */
  secondaryEmails?: InputMaybe<Array<SecondaryEmailInput>>;
  /** Secondary phone numbers */
  secondaryPhones?: InputMaybe<Array<SecondaryPhoneInput>>;
};

/** Autogenerated input type of UpdateClientIntakeData */
export type UpdateClientIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataKey: Scalars['String']['input'];
  dataType?: InputMaybe<Scalars['String']['input']>;
  dataValue: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateClientIntakeData. */
export type UpdateClientIntakeDataPayload = {
  __typename?: 'UpdateClientIntakeDataPayload';
  clientIntakeData: ClientIntakeData;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateClientPortalMessage */
export type UpdateClientPortalMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coClientHasRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  primaryClientHasRead?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceAccountId: Scalars['String']['input'];
  status?: InputMaybe<ClientPortalMessageStatusName>;
};

/** Autogenerated return type of UpdateClientPortalMessage. */
export type UpdateClientPortalMessagePayload = {
  __typename?: 'UpdateClientPortalMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientPortalMessage: Maybe<ClientPortalMessage>;
};

/** Autogenerated input type of UpdateClientProfile */
export type UpdateClientProfileInput = {
  annualGrossIncome?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** 2 letter country code for client citizenship */
  citizenship?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coManagerSsn?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** The date the client passed away, if applicable. ISO8601 date string. */
  dateOfDeath?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatusName>;
  id: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client occupation */
  occupation?: InputMaybe<Scalars['String']['input']>;
  soloPropEntityName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ClientStage>;
};

/** Autogenerated return type of UpdateClientProfile. */
export type UpdateClientProfilePayload = {
  __typename?: 'UpdateClientProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientProfile: Client;
};

/** Autogenerated input type of UpdateClients */
export type UpdateClientsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of client updates */
  clientUpdates: Array<UpdateClientInput>;
  /** The ID of the household */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClients. */
export type UpdateClientsPayload = {
  __typename?: 'UpdateClientsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** The updated household */
  household: Maybe<Household>;
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCommentAttachmentSync */
export type UpdateCommentAttachmentSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The attachment to update */
  commentAttachmentId: Scalars['ID']['input'];
  /**
   * True files a copy of the attachment under the client-visible Additional
   * Materials folder; false deletes that copy. The Box work happens here, so the
   * id stored and the object it names are written by the same actor.
   */
  syncedToBox: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateCommentAttachmentSync. */
export type UpdateCommentAttachmentSyncPayload = {
  __typename?: 'UpdateCommentAttachmentSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated attachment */
  commentAttachment: CommentAttachment;
};

/** Autogenerated input type of UpdateComment */
export type UpdateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to edit */
  commentId: Scalars['ID']['input'];
  /** Replacement plain text, may contain @Full Name mentions */
  content: Scalars['String']['input'];
  /**
   * Replacement thread header. Omit to leave it as it is; pass null or an empty
   * string to remove it. Only valid on a thread root.
   */
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateComment. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The comment after the edit */
  comment: Comment;
};

/** Autogenerated input type of UpdateContact */
export type UpdateContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateContact. */
export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  contact: Maybe<Contact>;
};

/** Autogenerated input type of UpdateDialpadCallNotes */
export type UpdateDialpadCallNotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DialpadCall to update */
  id: Scalars['ID']['input'];
  /** Notes to set on the DialpadCall */
  notes: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateDialpadCallNotes. */
export type UpdateDialpadCallNotesPayload = {
  __typename?: 'UpdateDialpadCallNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated DialpadCall */
  dialpadCall: Maybe<DialpadCall>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateDialpadEventContent */
export type UpdateDialpadEventContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Content to update on the DialpadEvent */
  content: Scalars['String']['input'];
  /** Dialpad ID to find the event (alternative to id) */
  dialpadId?: InputMaybe<Scalars['BigInt']['input']>;
  /** ID of the DialpadEvent to update */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateDialpadEventContent. */
export type UpdateDialpadEventContentPayload = {
  __typename?: 'UpdateDialpadEventContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated DialpadEvent */
  dialpadEvent: Maybe<DialpadEvent>;
};

/** Autogenerated input type of UpdateEciCitizenshipTaxStatus */
export type UpdateEciCitizenshipTaxStatusInput = {
  /** Alien registration number (A-Number / USCIS number) for permanent residents and non-citizens */
  alienId?: InputMaybe<Scalars['String']['input']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  citizenshipCodes: Array<Scalars['String']['input']>;
  /** Whether claiming tax treaty benefits (W-8BEN path) */
  claimingTreatyBenefits: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  /** Foreign tax identification number (W-8BEN path) */
  foreignTaxId?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty article and paragraph */
  treatyArticleParagraph?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  treatyCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty rate of withholding */
  treatyWithholdingRate?: InputMaybe<Scalars['String']['input']>;
  /** US citizenship status: one of citizen, permanent_resident, non_citizen */
  usCitizenshipStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether the applicant is a U.S. resident */
  usTaxResident: Scalars['Boolean']['input'];
  /** Whether the W-9 certification was acknowledged (U.S. path) */
  w9Certification: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateEciCitizenshipTaxStatus. */
export type UpdateEciCitizenshipTaxStatusPayload = {
  __typename?: 'UpdateEciCitizenshipTaxStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciCurrentStep */
export type UpdateEciCurrentStepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The step the client has just completed */
  currentStep: EciCurrentStep;
};

/** Autogenerated return type of UpdateEciCurrentStep. */
export type UpdateEciCurrentStepPayload = {
  __typename?: 'UpdateEciCurrentStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the cursor write succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciFinancialProfile */
export type UpdateEciFinancialProfileInput = {
  /** Annual household income, in cents */
  annualIncomeCents: Scalars['BigInt']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One of: limited, good, extensive */
  investingExperience: Scalars['String']['input'];
  /** One of: growth, income, preservation, speculation */
  investmentObjective: Scalars['String']['input'];
  /** Liquid net worth, in cents */
  liquidNetWorthCents: Scalars['BigInt']['input'];
  /** One of: conservative, moderate, aggressive */
  riskTolerance: Scalars['String']['input'];
  /** One of: short_term, medium_term, long_term */
  timeHorizon: Scalars['String']['input'];
  /** Total net worth, in cents */
  totalNetWorthCents: Scalars['BigInt']['input'];
};

/** Autogenerated return type of UpdateEciFinancialProfile. */
export type UpdateEciFinancialProfilePayload = {
  __typename?: 'UpdateEciFinancialProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciPersonalInformation */
export type UpdateEciPersonalInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth (ISO 8601) */
  dateOfBirth: Scalars['ISO8601Date']['input'];
  /** Email address */
  email: Scalars['String']['input'];
  /** Employer name (required by model when employment_status is employed or self_employed) */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** One of: employed, self_employed, student, homemaker, retired, non_employed */
  employmentStatus: Scalars['String']['input'];
  /** Legal first name */
  firstName: Scalars['String']['input'];
  /** Home address */
  homeAddress: StrictAddressInput;
  /** Job title (required by model when employment_status is employed or self_employed) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  lastName: Scalars['String']['input'];
  /** Additional legal residence when other than the United States */
  legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address; required when mailing_address_same_as_home is false */
  mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Legal middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Occupation category for custodian opening envelopes */
  occupation: ClientOccupation;
  /** Phone number; accepts formatted US input or E.164. Stored as E.164. */
  phoneNumber: Scalars['String']['input'];
  /** SSN; XXX-XX-XXXX format */
  ssn: Scalars['String']['input'];
  /** Suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEciPersonalInformation. */
export type UpdateEciPersonalInformationPayload = {
  __typename?: 'UpdateEciPersonalInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciRegulatoryDisclosure */
export type UpdateEciRegulatoryDisclosureInput = {
  /** Is an accredited investor */
  accreditedInvestor: Scalars['Boolean']['input'];
  /** Associated with a US registered broker-dealer */
  brokerDealerAssociated: Scalars['Boolean']['input'];
  /** Required when broker_dealer_associated is true */
  brokerDealerDetail?: InputMaybe<BrokerDealerDetailInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Self or household member is a director / 10%+ shareholder / executive officer of a public company */
  directorOr10pctShareholder: Scalars['Boolean']['input'];
  /** Required when director_or_10pct_shareholder is true */
  directorOrShareholderDetail?: InputMaybe<DirectorOrShareholderDetailInput>;
  /** Self or household member is registered with / employed by a FINRA member firm */
  finraMemberFirmAssociated: Scalars['Boolean']['input'];
  /** Associated with a US registered investment advisor */
  registeredInvestmentAdvisorAssociated: Scalars['Boolean']['input'];
  /** Self or immediate family is a senior political figure */
  seniorPoliticalFigure: Scalars['Boolean']['input'];
  /** Required when senior_political_figure is true */
  seniorPoliticalFigureDetail?: InputMaybe<SeniorPoliticalFigureDetailInput>;
};

/** Autogenerated return type of UpdateEciRegulatoryDisclosure. */
export type UpdateEciRegulatoryDisclosurePayload = {
  __typename?: 'UpdateEciRegulatoryDisclosurePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEnrollment */
export type UpdateEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target wizard step (step1 through step5). */
  currentStep: Scalars['String']['input'];
  /** The enrollment's uuid. */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateEnrollment. */
export type UpdateEnrollmentPayload = {
  __typename?: 'UpdateEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated enrollment. */
  enrollment: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  errors: Maybe<Array<MutationError>>;
  /** Whether the operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateFamilyMember */
export type UpdateFamilyMemberInput = {
  /** Street address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in ISO format */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  dependentOfHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  dependentOfUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Entity date established in ISO format */
  entityDateEstablished?: InputMaybe<Scalars['String']['input']>;
  /** Entity date of death in ISO format */
  entityDateOfDeath?: InputMaybe<Scalars['String']['input']>;
  /** Entity EIN */
  entityEin?: InputMaybe<Scalars['String']['input']>;
  /** Executor name for estate entities */
  entityExecutorName?: InputMaybe<Scalars['String']['input']>;
  /** Entity display name */
  entityName?: InputMaybe<Scalars['String']['input']>;
  /** Organization type for organization entities */
  entityOrganizationType?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact role for organization entities */
  entityPrimaryContactRole?: InputMaybe<Scalars['String']['input']>;
  /** Trust type for trust entities */
  entityTrustType?: InputMaybe<Scalars['String']['input']>;
  /** Trustee name for trust entities */
  entityTrusteeName?: InputMaybe<Scalars['String']['input']>;
  /** Entity type for Trust, Organization, or Estate contacts */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household */
  householdId: Scalars['ID']['input'];
  /** ID of the family member to update */
  id: Scalars['ID']['input'];
  /** Whether this contact is a beneficiary */
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection. Sending this
   * makes dependentOfHouseholdId and dependentOfUserId authoritative: a named
   * target replaces the stored one and an omitted pair clears it. Omit all three
   * to leave the dependency untouched
   */
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this contact is a trusted contact */
  isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Preferred nickname */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Freeform notes about the contact */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the household */
  relation?: InputMaybe<Scalars['String']['input']>;
  /** Social Security Number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP / postal code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateFamilyMember. */
export type UpdateFamilyMemberPayload = {
  __typename?: 'UpdateFamilyMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated family member */
  familyMember: FamilyMember;
};

/** Autogenerated input type of UpdateFeeSchedule */
export type UpdateFeeScheduleInput = {
  /** The type of amount for the fee schedule */
  amountType?: InputMaybe<FeeScheduleAmountTypes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the fee schedule */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of fee schedule */
  feeType?: InputMaybe<FeeScheduleFeeTypes>;
  /** The flat fee amount for the fee schedule */
  flatFeeAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The ID of the fee schedule to update */
  id: Scalars['ID']['input'];
  /** The minimum fee for the fee schedule */
  minimumFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The name of the fee schedule */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The tiers for the fee schedule */
  tiers?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of UpdateFeeSchedule. */
export type UpdateFeeSchedulePayload = {
  __typename?: 'UpdateFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Error message if updating was not successful */
  error: Maybe<Scalars['String']['output']>;
  /** The fee schedule that was updated */
  feeSchedule: Maybe<FeeSchedule>;
  /** Whether the fee schedule was updated */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateFinancialOffering */
export type UpdateFinancialOfferingInput = {
  /** Editable rich-text body (HTML); sanitized server-side before save */
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short card description (required, <= 150 chars) */
  description: Scalars['String']['input'];
  /** Optional note shown beneath the Fee structure section */
  feeStructureDescription?: InputMaybe<Scalars['String']['input']>;
  /** Full set of fee rows */
  fees: Array<FinancialOfferingDetailInput>;
  /** Offering id */
  id: Scalars['ID']['input'];
  /** Full set of key-fact rows */
  keyFacts: Array<FinancialOfferingDetailInput>;
  /** Optional note shown beneath the Key facts section */
  keyFactsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Full set of link rows */
  links: Array<FinancialOfferingLinkInput>;
  /** Optimistic-concurrency token from the offering as loaded */
  lockVersion: Scalars['Int']['input'];
  /** Long description shown on the detail page */
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** Offering name / card title (<= 100 chars); rejected on system-managed offerings */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Per-provider copy updates */
  providers: Array<FinancialOfferingProviderInput>;
};

/** Autogenerated return type of UpdateFinancialOffering. */
export type UpdateFinancialOfferingPayload = {
  __typename?: 'UpdateFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated offering */
  financialOffering: Maybe<FinancialOffering>;
};

/** Autogenerated input type of UpdateGoal */
export type UpdateGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  percentFunded?: InputMaybe<Scalars['BigDecimal']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  status?: InputMaybe<GoalStatusName>;
  targetUsd?: InputMaybe<Scalars['BigDecimal']['input']>;
  type?: InputMaybe<GoalTypeName>;
};

/** Autogenerated return type of UpdateGoal. */
export type UpdateGoalPayload = {
  __typename?: 'UpdateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  goal: Goal;
};

/** Autogenerated input type of UpdateHouseholdAccess */
export type UpdateHouseholdAccessInput = {
  /** edit or no access */
  accessLevel: HouseholdAccessLevel;
  /** advisor we are updating access for */
  advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** household we are updating permissions of */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateHouseholdAccess. */
export type UpdateHouseholdAccessPayload = {
  __typename?: 'UpdateHouseholdAccessPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** failures */
  errors: Array<Scalars['String']['output']>;
  /** successes */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateHousehold */
export type UpdateHouseholdInput = {
  /** Whether this household is an accredited investor */
  accreditedInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is an accredited investor */
  accreditedInvestorRationale?: InputMaybe<Scalars['String']['input']>;
  /** The source of the lead for this household */
  advisorLeadSource?: InputMaybe<Scalars['String']['input']>;
  /** Freeform detail describing an "Other" lead source. Only persisted when the lead source is "Other"; cleared otherwise. */
  advisorLeadSourceDetail?: InputMaybe<Scalars['String']['input']>;
  /** The bio/summary information for this household */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The date this household signed the contract */
  contractSignatureDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The reason this household was disqualified */
  disqualifiedReason?: InputMaybe<Scalars['String']['input']>;
  /** The estimated AUM for this household */
  estimatedAum?: InputMaybe<Scalars['Int']['input']>;
  /** Family information for this household */
  familyInfo?: InputMaybe<Scalars['String']['input']>;
  /** The fee schedule for this household */
  feeSchedule?: InputMaybe<Scalars['String']['input']>;
  /** The lead funnel stage of this household */
  householdStage?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update */
  id: Scalars['ID']['input'];
  /** The reason this household was lost */
  lossReason?: InputMaybe<Scalars['String']['input']>;
  /** The name of the household */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The probability of closing for this household */
  probabilityOfClosing?: InputMaybe<Scalars['String']['input']>;
  /** Whether this household is a qualified client */
  qualifiedClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is a qualified client */
  qualifiedClientRationale?: InputMaybe<Scalars['String']['input']>;
  /** Whether this household is a qualified purchaser */
  qualifiedPurchaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is a qualified purchaser */
  qualifiedPurchaserRationale?: InputMaybe<Scalars['String']['input']>;
  /** The contact for the referral */
  referralContact?: InputMaybe<Scalars['String']['input']>;
  /** The name of the referral contact */
  referralContactName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the entity (User or CenterOfInfluenceRep) that referred this household */
  referralEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the referral entity (User or CenterOfInfluenceRep) */
  referralEntityType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateHouseholdMember */
export type UpdateHouseholdMemberInput = {
  /** Whether the member can sign client agreements for the household. */
  canSignClientAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the member is an account holder on household accounts. */
  isAccountHolder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The household membership to update. */
  membershipId: Scalars['ID']['input'];
  /** The member's role in the household. */
  role?: InputMaybe<HouseholdMembershipRole>;
  /** Free-form description of the member's trustee capacity, if applicable. */
  trusteeCapacity?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateHouseholdMember. */
export type UpdateHouseholdMemberPayload = {
  __typename?: 'UpdateHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated household membership. */
  membership: HouseholdMembership;
};

/** Autogenerated return type of UpdateHousehold. */
export type UpdateHouseholdPayload = {
  __typename?: 'UpdateHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The household that was updated */
  household: Household;
};

/** Autogenerated input type of UpdateHouseholdTags */
export type UpdateHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
  organizationHouseholdTagIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateHouseholdTags. */
export type UpdateHouseholdTagsPayload = {
  __typename?: 'UpdateHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  household: Household;
};

/** Autogenerated input type of UpdateLiability */
export type UpdateLiabilityInput = {
  acquiredAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  annualInterestPercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currentBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  originalBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  timeToMaturity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<LiabilityTypeName>;
};

/** Autogenerated return type of UpdateLiability. */
export type UpdateLiabilityPayload = {
  __typename?: 'UpdateLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  liability: Liability;
};

/** Autogenerated input type of UpdateMeetingAgendaTemplate */
export type UpdateMeetingAgendaTemplateInput = {
  /** The agenda outline */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When to use this template */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The template ID */
  id: Scalars['ID']['input'];
  /** The template title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** private (creator only) or firm-wide */
  visibility?: InputMaybe<MeetingAgendaTemplateVisibility>;
};

/** Autogenerated return type of UpdateMeetingAgendaTemplate. */
export type UpdateMeetingAgendaTemplatePayload = {
  __typename?: 'UpdateMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated template */
  meetingAgendaTemplate: Maybe<MeetingAgendaTemplate>;
};

/** Autogenerated input type of UpdateNote */
export type UpdateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateNote. */
export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  note: Note;
};

/** Autogenerated input type of UpdateNotificationRoute */
export type UpdateNotificationRouteInput = {
  /** The catalog alert type to update. */
  alertType: NotificationRouteAlert;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The destination: inbox, activity, or off. */
  destination: NotificationRouteDestination;
  /** ID of the user whose route to update. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateNotificationRoute. */
export type UpdateNotificationRoutePayload = {
  __typename?: 'UpdateNotificationRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Effective catalog notification routing after the update. */
  routing: Array<NotificationRoutePreference>;
  /** Whether the update succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOnboardingPersonalization */
export type UpdateOnboardingPersonalizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded firm logo (PNG or JPG, ≤2MB). Uploaded to Cloudinary; the returned URL is stored. */
  firmLogoBase64?: InputMaybe<Scalars['String']['input']>;
  /** Advisor firm name used for onboarding email branding */
  firmName?: InputMaybe<Scalars['String']['input']>;
  /** When true, clears the stored firm logo. Ignored when a new firm_logo_base64 is provided in the same call. */
  shouldDeleteLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom welcome message shown to onboarding clients */
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOnboardingPersonalization. */
export type UpdateOnboardingPersonalizationPayload = {
  __typename?: 'UpdateOnboardingPersonalizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Maybe<Array<MutationError>>;
  /** The updated personalization record */
  onboardingPersonalization: Maybe<AdvisorOnboardingPersonalization>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOnboardingTaskData */
export type UpdateOnboardingTaskDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custodian associated with the onboarding task */
  custodian?: InputMaybe<Scalars['String']['input']>;
  /** Docusign envelope ID. Pass empty string to clear. */
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce task ID */
  salesforceTaskId: Scalars['String']['input'];
  /** Box file ID. Pass empty string to clear. */
  signableDocumentBoxFileId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOnboardingTaskData. */
export type UpdateOnboardingTaskDataPayload = {
  __typename?: 'UpdateOnboardingTaskDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /**
   * The custodian associated with the onboarding task
   * @deprecated Use onboardingTask.custodian instead
   */
  custodian: Scalars['String']['output'];
  /**
   * Docusign envelope ID
   * @deprecated Use onboardingTask.docusignEnvelopeId instead
   */
  docusignEnvelopeId: Maybe<Scalars['String']['output']>;
  /** The updated onboarding task data */
  onboardingTask: OnboardingTaskDatum;
  /**
   * Box file ID
   * @deprecated Use onboardingTask.signableDocumentBoxFileId instead
   */
  signableDocumentBoxFileId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOpportunity */
export type UpdateOpportunityInput = {
  arr?: InputMaybe<Scalars['Int']['input']>;
  aum?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client Profile ID this opportunity this belongs to */
  clientProfileId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** expected close date */
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Next steps to close client */
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** next steps due date */
  nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** ID to edit */
  opportunityId: Scalars['ID']['input'];
  /** Prob of closing */
  probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** Status */
  status?: InputMaybe<OpportunityStatus>;
};

/** Autogenerated return type of UpdateOpportunity. */
export type UpdateOpportunityPayload = {
  __typename?: 'UpdateOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  opportunity: Maybe<Opportunity>;
};

/** Autogenerated input type of UpdateOrganizationBranding */
export type UpdateOrganizationBrandingInput = {
  /** Branding configuration to update */
  brandingInput: OrganizationBrandingInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOrganizationBranding. */
export type UpdateOrganizationBrandingPayload = {
  __typename?: 'UpdateOrganizationBrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Maybe<Array<MutationError>>;
  /** The updated organization branding */
  organizationBranding: Maybe<OrganizationBranding>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOrganizationHouseholdCategory */
export type UpdateOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  hexColorCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOrganizationHouseholdCategory. */
export type UpdateOrganizationHouseholdCategoryPayload = {
  __typename?: 'UpdateOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  organizationHouseholdCategory: Maybe<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of UpdateOrganizationHouseholdTagHouseholds */
export type UpdateOrganizationHouseholdTagHouseholdsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The desired final set of advisor-managed household IDs that should carry this
   * tag. Existing applications not in this list will be removed.
   */
  householdIds: Array<Scalars['ID']['input']>;
  /** The tag whose household applications are being synced. */
  organizationHouseholdTagId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOrganizationHouseholdTagHouseholds. */
export type UpdateOrganizationHouseholdTagHouseholdsPayload = {
  __typename?: 'UpdateOrganizationHouseholdTagHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated tag, with refreshed household_count. */
  organizationHouseholdTag: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of UpdateOrganizationHouseholdTag */
export type UpdateOrganizationHouseholdTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSmart?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationHouseholdCategoryId?: InputMaybe<Scalars['ID']['input']>;
  ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of UpdateOrganizationHouseholdTag. */
export type UpdateOrganizationHouseholdTagPayload = {
  __typename?: 'UpdateOrganizationHouseholdTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  organizationHouseholdTag: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of UpdateOrganizationSettings */
export type UpdateOrganizationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Settings to update. Omitted fields are left unchanged. */
  settings: OrganizationSettingsInput;
};

/** Autogenerated return type of UpdateOrganizationSettings. */
export type UpdateOrganizationSettingsPayload = {
  __typename?: 'UpdateOrganizationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated organization */
  organization: Organization;
  /** Whether the settings were saved */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOrganizationTaskInstructions */
export type UpdateOrganizationTaskInstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ops instructions message. Pass an empty string to clear it. */
  taskInstructionsForOps: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOrganizationTaskInstructions. */
export type UpdateOrganizationTaskInstructionsPayload = {
  __typename?: 'UpdateOrganizationTaskInstructionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated organization */
  organization: Organization;
};

/** Autogenerated input type of UpdateOrionReportEnrollments */
export type UpdateOrionReportEnrollmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the households should be enrolled for the report type */
  enrolled: Scalars['Boolean']['input'];
  /** IDs of accounts to exclude from the report (Savvy account IDs) */
  excludedAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of households to update */
  householdIds: Array<Scalars['ID']['input']>;
  /** The Orion report type to update */
  reportType: OrionReport;
};

/** Autogenerated return type of UpdateOrionReportEnrollments. */
export type UpdateOrionReportEnrollmentsPayload = {
  __typename?: 'UpdateOrionReportEnrollmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of errors that occurred during the update */
  errors: Array<Scalars['String']['output']>;
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdatePlanFinancialSnapshot */
export type UpdatePlanFinancialSnapshotInput = {
  /** Snapshot as-of date */
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Plan assets stored as integer cents */
  assetsCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot ID */
  id: Scalars['ID']['input'];
  /** Number of participants */
  participantCount?: InputMaybe<Scalars['Int']['input']>;
  /** Quarter period (e.g. 2026-Q1) */
  period?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePlanFinancialSnapshot. */
export type UpdatePlanFinancialSnapshotPayload = {
  __typename?: 'UpdatePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated snapshot */
  planFinancialSnapshot: Maybe<PlanFinancialSnapshot>;
};

/** Autogenerated input type of UpdatePortfolio */
export type UpdatePortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  investmentObjective?: InputMaybe<InvestmentObjectiveName>;
  riskAssessment?: InputMaybe<RiskAssessmentName>;
  taxSensitivity?: InputMaybe<PortfolioTaxSensitivityName>;
  timeHorizon?: InputMaybe<TimeHorizonName>;
};

/** Autogenerated return type of UpdatePortfolio. */
export type UpdatePortfolioPayload = {
  __typename?: 'UpdatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  portfolio: Maybe<Portfolio>;
};

/** Autogenerated input type of UpdatePortfolioStrategy */
export type UpdatePortfolioStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Portfolio strategy ID */
  id: Scalars['ID']['input'];
  /** New strategy name */
  strategyName: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePortfolioStrategy. */
export type UpdatePortfolioStrategyPayload = {
  __typename?: 'UpdatePortfolioStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Validation errors */
  errors: Array<Scalars['String']['output']>;
  /** Updated portfolio strategy */
  portfolioStrategy: Maybe<PortfolioStrategy>;
};

/** Autogenerated input type of UpdateProfessionalRelationship */
export type UpdateProfessionalRelationshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The relationship edge id */
  id: Scalars['ID']['input'];
  /** The per-relationship notes (null clears them) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The month/year the referral happened (null clears it) */
  referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Category of contact for a RetirementPlan target (null clears it) */
  retirementPlanContactGroup?: InputMaybe<ProfessionalRelationshipContactGroup>;
  /** Active/inactive status of a contact for a RetirementPlan target (null clears it) */
  retirementPlanContactStatus?: InputMaybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role toward the household (null clears it) */
  role?: InputMaybe<ProfessionalRelationshipRole>;
};

/** Autogenerated return type of UpdateProfessionalRelationship. */
export type UpdateProfessionalRelationshipPayload = {
  __typename?: 'UpdateProfessionalRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated relationship edge */
  professionalRelationship: Maybe<ProfessionalRelationship>;
};

/** Autogenerated input type of UpdateProspectOpportunity */
export type UpdateProspectOpportunityInput = {
  arr?: InputMaybe<Scalars['Int']['input']>;
  aum?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdStage?: InputMaybe<HouseholdStage>;
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  opportunityId: Scalars['ID']['input'];
  probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
};

/** Autogenerated return type of UpdateProspectOpportunity. */
export type UpdateProspectOpportunityPayload = {
  __typename?: 'UpdateProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  opportunity: Maybe<Opportunity>;
};

/** Autogenerated input type of UpdateProviderAccount */
export type UpdateProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  plaidPublicToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProviderAccount. */
export type UpdateProviderAccountPayload = {
  __typename?: 'UpdateProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  providerAccount: ProviderAccount;
};

/** Autogenerated input type of UpdateReportSchedule */
export type UpdateReportScheduleInput = {
  /** Enable or pause the schedule */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Upload generated PDFs to Box */
  deliverToBox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Publish generated reports to the client portal */
  deliverToPortal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Day of month (1-28) */
  deliveryDay?: InputMaybe<Scalars['Int']['input']>;
  /** Month (1-12) for annual schedules; omit to preserve, or pass null to use January */
  deliveryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** monthly | quarterly | annually */
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** Schedule to update */
  id: Scalars['ID']['input'];
  /**
   * Custom PDF filename pattern; supports {template_name}, {household_name},
   * {date}, {quarter}, {year}, {month}. Omit to preserve, or pass null to use the
   * default pattern
   */
  pdfFilenamePattern?: InputMaybe<Scalars['String']['input']>;
  /** Require advisor approval before delivering generated reports */
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateReportSchedule. */
export type UpdateReportSchedulePayload = {
  __typename?: 'UpdateReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated schedule */
  reportSchedule: ReportSchedule;
};

/** Autogenerated input type of UpdateReportTemplate */
export type UpdateReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New configuration payload */
  config?: InputMaybe<Scalars['JsonHash']['input']>;
  /** ID of the template to update */
  id: Scalars['ID']['input'];
  /** New display name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateReportTemplate. */
export type UpdateReportTemplatePayload = {
  __typename?: 'UpdateReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated template */
  savedReportTemplate: SavedReportTemplate;
};

/** Autogenerated input type of UpdateRetirementPlanContact */
export type UpdateRetirementPlanContactInput = {
  /** Whether this contact is still active on the plan */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company this contact belongs to (free text) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** plan_sponsor | service_provider | internal_team | other */
  contactGroup?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Contact ID */
  id: Scalars['ID']['input'];
  /** Contact name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanContact. */
export type UpdateRetirementPlanContactPayload = {
  __typename?: 'UpdateRetirementPlanContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated contact */
  retirementPlanContact: Maybe<RetirementPlanContact>;
};

/** Autogenerated input type of UpdateRetirementPlanDesign */
export type UpdateRetirementPlanDesignInput = {
  /** ADP/ACP test method (current year / prior year) */
  adpAcpTestMethod?: InputMaybe<Scalars['String']['input']>;
  /** Automatic enrollment terms, if any */
  automaticEnrollment?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Compensation definition (e.g. W-2, 415, 3401(a)) */
  compensationDefinition?: InputMaybe<Scalars['String']['input']>;
  /** Compensation exclusions */
  compensationExclusions?: InputMaybe<Scalars['String']['input']>;
  /** Default deferral percentage under automatic enrollment */
  defaultDeferralPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Deferral eligibility rule */
  deferralEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Deferral entry dates */
  deferralEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Employee classes excluded from the plan */
  excludedEmployeeClasses?: InputMaybe<Scalars['String']['input']>;
  /** HCE determination method */
  hceDetermination?: InputMaybe<Scalars['String']['input']>;
  /** Match eligibility rule */
  matchEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Match entry dates */
  matchEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Match formula */
  matchFormula?: InputMaybe<Scalars['String']['input']>;
  /** Match vesting schedule */
  matchVestingSchedule?: InputMaybe<Scalars['String']['input']>;
  /** Payroll frequency */
  payrollFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Payroll provider (e.g. Paycom, ADP) */
  payrollProvider?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing eligibility rule */
  profitSharingEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing entry dates */
  profitSharingEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing formula */
  profitSharingFormula?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing vesting schedule */
  profitSharingVestingSchedule?: InputMaybe<Scalars['String']['input']>;
  /** The plan this design belongs to */
  retirementPlanId: Scalars['ID']['input'];
  /** Safe harbor terms, if any */
  safeHarbor?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanDesign. */
export type UpdateRetirementPlanDesignPayload = {
  __typename?: 'UpdateRetirementPlanDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created or updated design */
  retirementPlanDesign: Maybe<RetirementPlanDesign>;
};

/** Autogenerated input type of UpdateRetirementPlan */
export type UpdateRetirementPlanInput = {
  /** Advisor-defined freeform notes about this plan */
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor address(es) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Advisory effective date */
  advisoryEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisory type */
  advisoryType?: InputMaybe<Scalars['String']['input']>;
  /** Annual fee stored as integer cents */
  annualFeeCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Annual fee as a percentage */
  annualFeePercent?: InputMaybe<Scalars['Float']['input']>;
  /** Billing method */
  billingMethod?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person who signed the contract */
  contractSignedBy?: InputMaybe<Scalars['String']['input']>;
  /** Date the contract was signed */
  contractSignedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Corporate structure */
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  /** Employer Identification Number */
  ein?: InputMaybe<Scalars['String']['input']>;
  /** Fee source */
  feeSource?: InputMaybe<Scalars['String']['input']>;
  /** Fee structure */
  feeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Fiduciary type */
  fiduciaryType?: InputMaybe<Scalars['String']['input']>;
  /** Linked household (pass null to unlink) */
  householdId?: InputMaybe<Scalars['ID']['input']>;
  /** Database ID of the retirement plan */
  id: Scalars['ID']['input'];
  /** Plan name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Plan owners/partners */
  owners?: InputMaybe<Scalars['String']['input']>;
  /** Parent company */
  parentCompany?: InputMaybe<Scalars['String']['input']>;
  /** Plan inception date */
  planInceptionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Plan type */
  planType?: InputMaybe<Scalars['String']['input']>;
  /** Plan year end date */
  planYearEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prior employers whose service counts toward eligibility */
  predecessorService?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper name */
  recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper plan ID */
  recordkeeperPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Service type */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** Plan status: on_track | at_risk | overdue */
  status?: InputMaybe<Scalars['String']['input']>;
  /** TPA name */
  tpa?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor's website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateRetirementPlanMilestone */
export type UpdateRetirementPlanMilestoneInput = {
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Due date (pass null to clear) */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Milestone ID */
  id: Scalars['ID']['input'];
  /** Advisor profile ID of the team member logging this (null to clear) */
  loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Milestone name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Owner contact ID (pass null to clear) */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Status: on_track | due_soon | overdue | done */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanMilestone. */
export type UpdateRetirementPlanMilestonePayload = {
  __typename?: 'UpdateRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated milestone */
  retirementPlanMilestone: Maybe<RetirementPlanMilestone>;
};

/** Autogenerated input type of UpdateRetirementPlanNote */
export type UpdateRetirementPlanNoteInput = {
  /** Author contact ID (null to clear) */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Note body text */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Note ID */
  id: Scalars['ID']['input'];
  /** Date the note applies to */
  notedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Note title (null to clear) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanNote. */
export type UpdateRetirementPlanNotePayload = {
  __typename?: 'UpdateRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated note */
  retirementPlanNote: Maybe<RetirementPlanNote>;
};

/** Autogenerated input type of UpdateRetirementPlanParticipantLog */
export type UpdateRetirementPlanParticipantLogInput = {
  /** Follow-up action item */
  actionItem?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Log entry ID */
  id: Scalars['ID']['input'];
  /** Interaction type */
  interactionType?: InputMaybe<Scalars['String']['input']>;
  /** Advisor profile ID of the team member logging this (null to clear) */
  loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Date of the interaction */
  loggedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Owner contact ID (null to clear) */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Participant email address */
  participantEmail?: InputMaybe<Scalars['String']['input']>;
  /** Participant full name */
  participantName?: InputMaybe<Scalars['String']['input']>;
  /** Participant phone number */
  participantPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanParticipantLog. */
export type UpdateRetirementPlanParticipantLogPayload = {
  __typename?: 'UpdateRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated log entry */
  retirementPlanParticipantLog: Maybe<RetirementPlanParticipantLog>;
};

/** Autogenerated return type of UpdateRetirementPlan. */
export type UpdateRetirementPlanPayload = {
  __typename?: 'UpdateRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated retirement plan */
  retirementPlan: Maybe<RetirementPlan>;
};

/** Autogenerated input type of UpdateRetirementPlanProject */
export type UpdateRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  id: Scalars['ID']['input'];
  /** Project name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Project start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Project status */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanProject. */
export type UpdateRetirementPlanProjectPayload = {
  __typename?: 'UpdateRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated project */
  retirementPlanProject: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectRow */
export type UpdateRetirementPlanProjectRowInput = {
  /** Advisor from the plan organization assigned to this row (null to clear) */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this row is due (null to clear) */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Row ID */
  id: Scalars['ID']['input'];
  /** Row name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes (null to clear) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this row within the project */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The organization responsible for this row (null to clear) */
  responsibleOrg?: InputMaybe<Scalars['String']['input']>;
  /** Status: todo | in_progress | done | cancelled */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanProjectRow. */
export type UpdateRetirementPlanProjectRowPayload = {
  __typename?: 'UpdateRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated row */
  retirementPlanProjectRow: Maybe<RetirementPlanProjectRow>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectTemplateFromProject */
export type UpdateRetirementPlanProjectTemplateFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The project whose source template should be updated */
  retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRetirementPlanProjectTemplateFromProject. */
export type UpdateRetirementPlanProjectTemplateFromProjectPayload = {
  __typename?: 'UpdateRetirementPlanProjectTemplateFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated template */
  retirementPlanProjectTemplate: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectTemplate */
export type UpdateRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The template to update */
  id: Scalars['ID']['input'];
  /** Template name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ordered steps. When provided, replaces the existing steps. */
  steps?: InputMaybe<Array<RetirementPlanProjectTemplateStepInput>>;
};

/** Autogenerated return type of UpdateRetirementPlanProjectTemplate. */
export type UpdateRetirementPlanProjectTemplatePayload = {
  __typename?: 'UpdateRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated template */
  retirementPlanProjectTemplate: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of UpdateRmd */
export type UpdateRmdInput = {
  accountYearEndValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  additionalDistributions?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRmd. */
export type UpdateRmdPayload = {
  __typename?: 'UpdateRmdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  rmd: Rmd;
};

/** Autogenerated input type of UpdateServiceCalendarItem */
export type UpdateServiceCalendarItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: ServiceCalendarItemStatus;
};

/** Autogenerated return type of UpdateServiceCalendarItem. */
export type UpdateServiceCalendarItemPayload = {
  __typename?: 'UpdateServiceCalendarItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceCalendarItem: ServiceCalendarItem;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateServiceCalendarMeeting */
export type UpdateServiceCalendarMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: ServiceCalendarMeetingStatus;
};

/** Autogenerated return type of UpdateServiceCalendarMeeting. */
export type UpdateServiceCalendarMeetingPayload = {
  __typename?: 'UpdateServiceCalendarMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceCalendarMeeting: ServiceCalendarMeeting;
};

/** Autogenerated input type of UpdateServiceCalendarSettingTemplates */
export type UpdateServiceCalendarSettingTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceCalendarSettingTemplateInputs: Array<ServiceCalendarSettingTemplateInput>;
};

/** Autogenerated return type of UpdateServiceCalendarSettingTemplates. */
export type UpdateServiceCalendarSettingTemplatesPayload = {
  __typename?: 'UpdateServiceCalendarSettingTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceCalendarSettingTemplates: Array<ServiceCalendarSettingTemplate>;
};

/** Autogenerated input type of UpdateServiceCalendarSettings */
export type UpdateServiceCalendarSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceCalendarSettingInputs: Array<ServiceCalendarSettingTemplateInput>;
};

/** Autogenerated return type of UpdateServiceCalendarSettings. */
export type UpdateServiceCalendarSettingsPayload = {
  __typename?: 'UpdateServiceCalendarSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceCalendarSettings: Array<ServiceCalendarSetting>;
};

/** Creating or updating settings for a service on a client household Service Calendar based on Advisor settings. */
export type UpdateServiceCalendarWithAdvisorSettingsInput = {
  active: Scalars['Boolean']['input'];
  byEndOfYear?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  q1?: InputMaybe<Scalars['Boolean']['input']>;
  q2?: InputMaybe<Scalars['Boolean']['input']>;
  q3?: InputMaybe<Scalars['Boolean']['input']>;
  q4?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateServiceCatalogItemGroup */
export type UpdateServiceCatalogItemGroupInput = {
  /** Attributes */
  attributes: ServiceCatalogItemGroupAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateServiceCatalogItemGroup. */
export type UpdateServiceCatalogItemGroupPayload = {
  __typename?: 'UpdateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  serviceCatalogItemGroup: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of UpdateServiceCatalogItemHouseholdOverride */
export type UpdateServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
  /** Is skipped */
  isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override date */
  overrideDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override dtstart */
  overrideDtstart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override email body */
  overrideEmailBody?: InputMaybe<Scalars['String']['input']>;
  /** Override email subject */
  overrideEmailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Override rrule */
  overrideRrule?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateServiceCatalogItemHouseholdOverride. */
export type UpdateServiceCatalogItemHouseholdOverridePayload = {
  __typename?: 'UpdateServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Service catalog item household override */
  serviceCatalogItemHouseholdOverride: Maybe<ServiceCatalogItemHouseholdOverride>;
};

/** Autogenerated input type of UpdateServiceCatalogItem */
export type UpdateServiceCatalogItemInput = {
  /** Attributes to merge */
  attributes: ServiceCatalogItemAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Item ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateServiceCatalogItem. */
export type UpdateServiceCatalogItemPayload = {
  __typename?: 'UpdateServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated item */
  serviceCatalogItem: Maybe<ServiceCatalogItem>;
};

/** Autogenerated input type of UpdateSimpleTask */
export type UpdateSimpleTaskInput = {
  /**
   * When the task is a recurring occurrence and due_at is being changed, also
   * shift due_at on the template and every open future occurrence by the same
   * delta. Ignored when the task is not part of an active recurrence or due_at did not change.
   */
  applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce task ID */
  salesforceTaskId: Scalars['String']['input'];
  /** The fields to update */
  taskInput: UpdateTaskFields;
};

/** Autogenerated return type of UpdateSimpleTask. */
export type UpdateSimpleTaskPayload = {
  __typename?: 'UpdateSimpleTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']['output']>;
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
  /** The updated task */
  task: Maybe<Task>;
};

/** Autogenerated input type of UpdateStagedAccountDestination */
export type UpdateStagedAccountDestinationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custodian this account is headed to. */
  destination: EciDestinationCustodian;
  /** The staged account to route. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStagedAccountDestination. */
export type UpdateStagedAccountDestinationPayload = {
  __typename?: 'UpdateStagedAccountDestinationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated staged account. */
  stagedAccount: AdvisorOnboardingStagedAccount;
};

/** Autogenerated input type of UpdateStagedClient */
export type UpdateStagedClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client date of birth. */
  dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Client email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The staged client to edit. */
  id: Scalars['ID']['input'];
  /** Client last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client phone. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Client SSN (write-only; stored encrypted). */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateStagedClient. */
export type UpdateStagedClientPayload = {
  __typename?: 'UpdateStagedClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated staged client. */
  stagedClient: AdvisorOnboardingStagedClient;
};

/** Autogenerated input type of UpdateStagedHousehold */
export type UpdateStagedHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated assets under management. */
  estAum?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Stable dedup key from the source book. */
  externalKey?: InputMaybe<Scalars['String']['input']>;
  /** Household name from the transition spreadsheet. */
  householdName?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to edit. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStagedHousehold. */
export type UpdateStagedHouseholdPayload = {
  __typename?: 'UpdateStagedHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated staged household. */
  stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/**
 * Fields that can be updated on a sub-task. All optional for partial updates;
 * passing explicit null clears clearable fields (assignee, due date, description).
 */
export type UpdateSubtaskFields = {
  /** New assignee user ID. Pass null to clear. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** New description. Pass null to clear. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New due date. Pass null to clear. */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Calendar days before the parent task's due date. Pass null to clear and fall back to absolute due_at. */
  dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** New name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New status. */
  status?: InputMaybe<SubtaskStatus>;
};

/** Autogenerated input type of UpdateSubtask */
export type UpdateSubtaskInput = {
  /**
   * When the parent is a recurring task, also apply these field changes (excluding
   * status) to the template and every future occurrence.
   */
  applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The fields to update. Omitted keys are unchanged; explicit null clears clearable keys. */
  fields: UpdateSubtaskFields;
  /** The Savvy ID of the sub-task to update. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSubtask. */
export type UpdateSubtaskPayload = {
  __typename?: 'UpdateSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated sub-task. */
  subtask: Maybe<Subtask>;
  /**
   * The parent task. Returned so clients can refresh derived counts. Its status
   * may be reverted to in_progress when the subtask moves away from done.
   */
  task: Maybe<Task>;
};

/** Autogenerated input type of UpdateTaskComment */
export type UpdateTaskCommentInput = {
  /** Update the Box file IDs attached to this comment */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskActivityId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTaskComment. */
export type UpdateTaskCommentPayload = {
  __typename?: 'UpdateTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  comment: TaskActivity;
};

/** Fields that can be updated on a simple task (all fields optional for partial updates) */
export type UpdateTaskFields = {
  /** The account transfer status (for onboarding tasks) */
  accountTransferStatus?: InputMaybe<Scalars['String']['input']>;
  /** The user that the task is assigned to */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the box folder that the task is associated with */
  boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Who receives the task-completed email; household-wide when unset. Pass null to clear. */
  completedEmailRecipients?: InputMaybe<TaskCompletedEmailRecipients>;
  /** The custodian name (for onboarding tasks) */
  custodian?: InputMaybe<Scalars['String']['input']>;
  /** The description of the task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The DocuSign envelope ID (for onboarding tasks) */
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The investment model recommendation (for investment proposal presentations) */
  investmentModelRecommendation?: InputMaybe<Scalars['String']['input']>;
  /** Semicolon-separated list of presentation slides (for client review presentations) */
  presentationSlides?: InputMaybe<Scalars['String']['input']>;
  /** The previous wealth management firm (for onboarding tasks) */
  previousWmFirm?: InputMaybe<Scalars['String']['input']>;
  /** The priority level of the task */
  priority?: InputMaybe<TaskPriority>;
  /** The request type (for investment proposal presentations) */
  requestType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to email the client when the task completes; falls back to the
   * organization default when unset. Pass null to clear.
   */
  sendEmailWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Box file ID for signable document (for onboarding tasks) */
  signableDocumentBoxFileId?: InputMaybe<Scalars['String']['input']>;
  /** The status of the task */
  status?: InputMaybe<TaskStatus>;
  /** In Progress sub-status for Client Services and Investment Ops tasks. Pass null to clear. */
  subStatus?: InputMaybe<TaskSubStatus>;
  /** The title of the task */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateTask */
export type UpdateTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maybeDocusignSigned?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TaskStatus>;
  subStatus?: InputMaybe<TaskSubStatus>;
};

/** Autogenerated input type of UpdateTaskNotificationRoute */
export type UpdateTaskNotificationRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The destination: inbox, activity, or off. */
  destination: Scalars['String']['input'];
  /** The task event: tasks_due, comments, or status. */
  event: Scalars['String']['input'];
  /** The viewer relationship: assignee, creator, primary, or all_other. */
  relationship: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTaskNotificationRoute. */
export type UpdateTaskNotificationRoutePayload = {
  __typename?: 'UpdateTaskNotificationRoutePayload';
  /** Effective task routing cells after the update. */
  cells: Array<NotificationTaskRoutingCell>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the update succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateTask. */
export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  task: Task;
};

/** Autogenerated input type of UpdateTaskSuggestion */
export type UpdateTaskSuggestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<TaskSuggestionStatus>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTaskSuggestion. */
export type UpdateTaskSuggestionPayload = {
  __typename?: 'UpdateTaskSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  taskSuggestion: TaskSuggestion;
};

/** Autogenerated input type of UpdateTaskWorkItem */
export type UpdateTaskWorkItemInput = {
  /**
   * When this is a recurring task, also apply name/instructions/priority/assignee
   * (not due date) to the template and every future occurrence.
   */
  applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user that the task is assigned to — pass null to unassign */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Full intended set of client profile IDs. nil preserves existing; [] removes all */
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due — pass null to clear */
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Full intended set of household IDs. nil preserves existing; [] removes all */
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the task to update */
  id: Scalars['ID']['input'];
  /** Additional instructions for the task — pass null to clear */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** The name of the task */
  name: Scalars['String']['input'];
  /** Task priority level — pass null to clear */
  priority?: InputMaybe<TaskPriority>;
};

/** Autogenerated return type of UpdateTaskWorkItem. */
export type UpdateTaskWorkItemPayload = {
  __typename?: 'UpdateTaskWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  errors: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTaskWorkflowTemplate */
export type UpdateTaskWorkflowTemplateInput = {
  /** Editors for a team workflow, replacing the existing set. Empty means everyone in the group can edit. */
  acl?: InputMaybe<Array<WorkflowTemplateAclInput>>;
  /** Advisor to assign the workflow to. Must be an advisor in your firm. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Workflow description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow name */
  name: Scalars['String']['input'];
  /** Reassign the workflow to a different advisor owner. Must be an advisor in your firm. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule anchor: launch_date or due_date */
  schedule: TaskWorkflowTemplateSchedule;
  /** Subtasks. When provided, replaces the existing subtasks. */
  subtasks?: InputMaybe<Array<SubtaskCreationInput>>;
  /** The workflow task to update */
  taskId: Scalars['ID']['input'];
  /** Visibility: private or firm */
  visibility: TaskWorkflowTemplateVisibility;
};

/** Autogenerated return type of UpdateTaskWorkflowTemplate. */
export type UpdateTaskWorkflowTemplatePayload = {
  __typename?: 'UpdateTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The updated workflow */
  taskWorkflowTemplate: Maybe<TaskWorkflowTemplate>;
};

/** Autogenerated input type of UpdateTaxEnrollment */
export type UpdateTaxEnrollmentInput = {
  /** Client who will pay the price */
  billableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enum type about enrollment */
  enrollmentType?: InputMaybe<TaxEnrollmentTypeName>;
  /** ID of Tax Enrollment */
  id: Scalars['ID']['input'];
  /** Client who will be filed jointly, will not be charged */
  nonBillableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** Price to charge billable client */
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Tax year for this enrollment */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateTaxEnrollment. */
export type UpdateTaxEnrollmentPayload = {
  __typename?: 'UpdateTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** errors */
  error: Maybe<Scalars['String']['output']>;
  /** success boolean */
  success: Scalars['Boolean']['output'];
  /** object */
  taxEnrollment: Maybe<TaxEnrollment>;
};

/** Autogenerated input type of UpdateUserContact */
export type UpdateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the contact */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Email of the contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact */
  id: Scalars['ID']['input'];
  /** Whether the contact is a beneficiary */
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  relation?: InputMaybe<BeneficiaryRelationship>;
  /** SSN of the contact */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserContact. */
export type UpdateUserContactPayload = {
  __typename?: 'UpdateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  contact: Maybe<Contact>;
};

/** Autogenerated input type of UpdateUserDataInAprilFiling */
export type UpdateUserDataInAprilFilingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tax enrollment ID */
  taxEnrollmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserDataInAprilFiling. */
export type UpdateUserDataInAprilFilingPayload = {
  __typename?: 'UpdateUserDataInAprilFilingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors: Maybe<Scalars['String']['output']>;
  /** Success or not */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The caller's existing password. Required to change a password from a session, but not from an invite or reset token. */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  profilePicUrl?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone id; when present, persists as the user's configured zone. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of UpdateUserSecurityAttribute */
export type UpdateUserSecurityAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  otp?: InputMaybe<Scalars['String']['input']>;
  otpRequiredForLogin?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserSecurityAttribute. */
export type UpdateUserSecurityAttributePayload = {
  __typename?: 'UpdateUserSecurityAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  otpError: Scalars['String']['output'];
  user: User;
};

/** Autogenerated input type of UploadFileToBox */
export type UploadFileToBoxInput = {
  /** Type of Box folder */
  boxFolderType: BoxFolderTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the document to upload */
  documentName: Scalars['String']['input'];
  /** URL of the document to upload */
  documentUrl: Scalars['String']['input'];
  /** ID of household */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated input type of UploadLinkedBankAccountImport */
export type UploadLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custodian: schwab or fidelity */
  custodian: Scalars['String']['input'];
  /** Import kind: savvy_wide (default) or advisor */
  docType?: InputMaybe<LinkedBankAccountImportDocType>;
  /** Base64-encoded file contents */
  fileContent: Scalars['String']['input'];
  /** Original file name (used to derive content type) */
  fileName: Scalars['String']['input'];
};

/** Autogenerated return type of UploadLinkedBankAccountImport. */
export type UploadLinkedBankAccountImportPayload = {
  __typename?: 'UploadLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** The created import record (poll for diff readiness) */
  linkedBankAccountImport: Maybe<LinkedBankAccountImport>;
};

/** Result of uploading a file to Box */
export type UploadToBoxResult = {
  __typename?: 'UploadToBoxResult';
  /** The ID of the file in Box */
  boxFileId: Maybe<Scalars['String']['output']>;
  /** The ID of the document that was uploaded */
  documentId: Scalars['String']['output'];
  /** Error message if the upload failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Whether the upload was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpsertUserSavedViews */
export type UpsertUserSavedViewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entries to upsert (value=null deletes the key) */
  savedViews: Array<UserSavedViewInput>;
};

/** Autogenerated return type of UpsertUserSavedViews. */
export type UpsertUserSavedViewsPayload = {
  __typename?: 'UpsertUserSavedViewsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Current rows for touched keys after upsert/delete */
  userSavedViews: Array<UserSavedView>;
};

export type User = {
  __typename?: 'User';
  /** The household the user currently has selected (falls back to the highest-priority member household) */
  activeHousehold: Maybe<Household>;
  addresses: Array<Address>;
  /** Advisor-tier level (assistant/advisor/admin) derived from role + can_edit_organization; null for non-advisor-tier users. */
  advisorTierLevel: Maybe<AdvisorTierLevel>;
  /** Feature flag for opt-in the AI experience. Cannot be handled with LaunchDarkly */
  aiExperienceOptIn: Scalars['Boolean']['output'];
  /** @deprecated This field has been moved to client.rb */
  assignedCampaigns: Array<AssignedCampaign>;
  /** Client stage of user to become fully onboarded */
  clientStage: Maybe<ClientStage>;
  /** Confirmation status of user for email confirmation */
  confirmationStatus: UserConfirmationStatus;
  /** User creation timestamp */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /**
   * The household associated with this user. Pass id to scope to a specific
   * household the user is a member of; falls back to the ClientProfile-derived
   * household otherwise.
   */
  household: Maybe<Household>;
  id: Scalars['ID']['output'];
  isPrimaryClient: Scalars['Boolean']['output'];
  /** Footprint kyc status */
  kycStatus: FootprintStatus;
  lastName: Scalars['String']['output'];
  /** Timestamp of the user's last sign in */
  lastSignInAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  mailgunMessages: Array<MailgunMessage>;
  /** Households this user is a member of via HouseholdMembership */
  memberHouseholds: Array<Household>;
  middleName: Maybe<Scalars['String']['output']>;
  otpRequiredForLogin: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This field is only used for mobile 1.1 launch and will be removed soon. */
  personalPortfolioId: Maybe<Scalars['ID']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  preferredName: Maybe<Scalars['String']['output']>;
  primaryAddress: Maybe<Address>;
  /**
   * The email of this client's primary (household) advisor; null for non-clients.
   * Powers advisor-scoped LaunchDarkly targeting.
   */
  primaryAdvisorEmail: Maybe<Scalars['String']['output']>;
  profileId: Scalars['ID']['output'];
  profilePicUrl: Maybe<Scalars['String']['output']>;
  profileType: UserProfile;
  /** User roles, backend deals with lowercase, GQL deals with UPCASED */
  role: UserRole;
  /** Salesforce contact ID (only present for clients) */
  salesforceContactId: Maybe<Scalars['String']['output']>;
  /** Salesforce user ID (only present for advisors) */
  salesforceUserId: Maybe<Scalars['String']['output']>;
  secondaryEmails: Array<SecondaryEmail>;
  secondaryPhones: Array<SecondaryPhone>;
  status: UserStatus;
  /**
   * Configured IANA timezone; null until set via the account timezone picker. Null
   * = unset; reads fall back to Eastern via User#effective_timezone.
   */
  timezone: Maybe<Scalars['String']['output']>;
};


export type UserHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserConfirmationStatus =
  /** active user */
  | 'ACTIVE'
  /** user still needs to confirm their email address with savvy */
  | 'PENDING_EMAIL_CONFIRMATION';

export type UserInteraction = {
  /** The name of the item that was clicked or touched - e.g. "create_prospect_button" */
  elementName: Scalars['String']['input'];
  /** The HTML element that was clicked or touched - e.g. "div" */
  htmlElement: Scalars['String']['input'];
  /** The type of interaction that occurred - e.g. "click" */
  interactionType: Scalars['String']['input'];
  isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  /** The name of the parent element that the interaction occurred on - e.g. "create_prospect_dialog" */
  parentElementName?: InputMaybe<Scalars['String']['input']>;
  /** The type of the parent element that the interaction occurred on - e.g. "dialog" */
  parentElementType?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  source?: InputMaybe<Scalars['String']['input']>;
  urlQueryParams: Scalars['JSON']['input'];
};

/** KYC readiness status and computed errors for a user */
export type UserKycStatus = {
  __typename?: 'UserKycStatus';
  /** Fields present but with bad data */
  invalidFields: Array<KycField>;
  /** Required fields that are blank */
  missingFields: Array<KycField>;
  /** ready or not_ready */
  readinessStatus: Scalars['String']['output'];
};

/** Minimal user info returned to advisors for the Add Household Member lookup — only exposes fields needed to confirm identity. */
export type UserLookupResult = {
  __typename?: 'UserLookupResult';
  /**
   * Whether the current advisor can add this user to a household they manage.
   * Returns false when the user is a client of another advisor outside the current
   * advisor's groups — the Add Household Member dialog uses this to render an
   * "advised by another advisor" message instead of proceeding.
   */
  accessibleByCurrentAdvisor: Scalars['Boolean']['output'];
  /** The user's email address. */
  email: Scalars['String']['output'];
  /** The user's first name. */
  firstName: Scalars['String']['output'];
  /** The user's full name. */
  fullName: Scalars['String']['output'];
  /** The user ID. */
  id: Scalars['ID']['output'];
  /** The user's last name. */
  lastName: Scalars['String']['output'];
};

export type UserProfile =
  /** Savvy financial advisor */
  | 'ADVISOR'
  /** Savvy client */
  | 'CLIENT';

/** User role enum, expected input and output are UPPERCASE */
export type UserRole =
  | 'ADMIN'
  | 'ADMIN_CSA'
  | 'ADVISOR'
  | 'ASSISTANT'
  | 'CLIENT'
  | 'CSA'
  | 'NON_ADVISORY_USER'
  | 'READ_ONLY_ADMIN';

export type UserSavedView = {
  __typename?: 'UserSavedView';
  /** Saved view row id */
  id: Scalars['ID']['output'];
  /** Storage key name */
  key: Scalars['String']['output'];
  /** Last write timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Stored JSON payload */
  value: Maybe<Scalars['JSON']['output']>;
};

export type UserSavedViewInput = {
  /** Storage key to upsert */
  key: Scalars['String']['input'];
  /** JSON payload to persist; null deletes the key */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserStatus =
  | 'active'
  | 'deleted'
  | 'invited'
  | 'prospected';

/** Autogenerated input type of ValidateInvestmentProposalTickers */
export type ValidateInvestmentProposalTickersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tickers to validate. Case-insensitive; trimmed and uppercased server-side. */
  tickers: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateInvestmentProposalTickers. */
export type ValidateInvestmentProposalTickersPayload = {
  __typename?: 'ValidateInvestmentProposalTickersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Input tickers Orion could not price at all. Normalized (uppercase, trimmed) from the request. */
  invalidTickers: Array<Scalars['String']['output']>;
  /** Canonical form Orion returned for each valid input ticker (e.g. BRK-B -> BRK/B). */
  validTickers: Array<Scalars['String']['output']>;
};

/** Monetary value. */
export type Value = {
  __typename?: 'Value';
  /** The numerical amount of monetary value. */
  amount: Scalars['BigDecimal']['output'];
  /** ISO currency codes and unofficial currency codes. */
  currencyCode: Scalars['String']['output'];
};

/** One row of the Portfolio Value Summary table — a single reporting period. */
export type ValueSummaryRow = {
  __typename?: 'ValueSummaryRow';
  /** Market value at the start of the period, in USD; null when data is unavailable. */
  beginningMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period as resolved against the snapshot. */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Market value at the end of the period, in USD; null when data is unavailable. */
  endingMarketValue: Maybe<Scalars['BigDecimal']['output']>;
  /** Net contributions over the period (deposits minus withdrawals minus fees), in USD; null when data is unavailable. */
  netAdditions: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Investment gains over the period (ending market value minus beginning market
   * value minus net additions), in USD; null when data is unavailable.
   */
  netGains: Maybe<Scalars['BigDecimal']['output']>;
  /** Which reporting period this row covers. */
  period: PeriodEnum;
  /**
   * Annualized time-weighted return over the period as a fraction (0.05 = 5%);
   * null when the period is shorter than a year or data is unavailable.
   */
  returnAnnualized: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return over the period as a fraction (0.05 = 5%); null when data is unavailable. */
  returnCumulative: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start date of this period as resolved against the snapshot. */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Autogenerated input type of VerifyEciOnboardingIdentity */
export type VerifyEciOnboardingIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth (ISO 8601) to verify */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Legal last name to verify */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** SSN to verify; any format */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VerifyEciOnboardingIdentity. */
export type VerifyEciOnboardingIdentityPayload = {
  __typename?: 'VerifyEciOnboardingIdentityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Unexpected errors, if any */
  errors: Array<Scalars['String']['output']>;
  /** Whether the client's identity was verified against the values on file */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VoiceProfileCommit */
export type VoiceProfileCommitInput = {
  /** AdvisorProfile id whose voice profile to commit. */
  advisorId: Scalars['ID']['input'];
  /** Wizard calibration picks mapped to trait values; folded into the payload. */
  calibrationDerivedTraits?: InputMaybe<Array<CalibrationDerivedTraitInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The advisor's capture-survey replies; folded into payload['examples'] tagged source:'survey'. */
  scenarioReplies?: InputMaybe<Array<ScenarioReplyInput>>;
  /** scan | game | game_plus_scan | seeded */
  source: Scalars['String']['input'];
};

/** Autogenerated return type of VoiceProfileCommit. */
export type VoiceProfileCommitPayload = {
  __typename?: 'VoiceProfileCommitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The committed voice profile. */
  profile: Maybe<AdvisorIdentityProfile>;
};

/** Voice DNA payload — what SAI drafts from. Stable contract for the consumer. */
export type VoiceProfilePayload = {
  __typename?: 'VoiceProfilePayload';
  /**
   * Deprecated alias of voicePromptFragment.
   * @deprecated Renamed to voicePromptFragment. Falls back to the new field; will be removed after consumers migrate.
   */
  draftPromptFragment: Maybe<Scalars['String']['output']>;
  /** Number of outbound emails contributing to the staged re-run read. */
  draftSourceMessageCount: Maybe<Scalars['Int']['output']>;
  /** Status of a staged re-run extraction: extracting | ready | failed. Null when no re-run is staged. */
  draftStatus: Maybe<Scalars['String']['output']>;
  /** Trait hash from the staged re-run read (same shape and legacy fold as `traits`). Null when no re-run is staged. */
  draftTraits: Maybe<Scalars['JSON']['output']>;
  /** Curated anonymized example messages used as few-shot for SAI drafting. */
  examples: Array<Scalars['JSON']['output']>;
  /** When extraction completed. */
  extractedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 0.0–1.0 overall confidence the profile is grounded in examples. */
  extractionConfidence: Maybe<Scalars['Float']['output']>;
  /** Phrases the advisor consistently avoids. */
  neverSay: Array<Scalars['String']['output']>;
  /** Number of outbound emails contributing to this profile. */
  sourceMessageCount: Maybe<Scalars['Int']['output']>;
  /**
   * Short headline characterization of the voice (e.g., "Warm, direct, plain
   * English"). Null until tagline confidence threshold is met.
   */
  tagline: Maybe<Scalars['String']['output']>;
  /**
   * Hash of trait_name → VoiceTraitDescriptor. Canonical keys: warmth, jargon,
   * numbers, directness, sign_off. Legacy eight-key payloads (energy, greeting,
   * formality) fold into these five on read.
   */
  traits: Scalars['JSON']['output'];
  /** Pre-built voice prompt fragment SAI drafting splices into its system prompt. Null until commit. */
  voicePromptFragment: Maybe<Scalars['String']['output']>;
  /**
   * Display-only generated "how SAI drafts in your voice" sample ({ scenario,
   * text, generatedAt }), null until generated. NEVER folded into the prompt
   * fragment — kept out of few-shot drafting.
   */
  voiceSample: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of VoiceProfileRemoveExample */
export type VoiceProfileRemoveExampleInput = {
  /** AdvisorProfile id whose voice profile owns the example. */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based index into payload.examples */
  exampleIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of VoiceProfileRemoveExample. */
export type VoiceProfileRemoveExamplePayload = {
  __typename?: 'VoiceProfileRemoveExamplePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Updated voice profile after removing the example. */
  profile: Maybe<AdvisorIdentityProfile>;
};

/** Autogenerated input type of VoiceProfileRerunCapture */
export type VoiceProfileRerunCaptureInput = {
  /** AdvisorProfile id to re-run voice extraction for. */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VoiceProfileRerunCapture. */
export type VoiceProfileRerunCapturePayload = {
  __typename?: 'VoiceProfileRerunCapturePayload';
  /** True when an existing run is still in flight; no new job was enqueued. */
  alreadyInFlight: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Sidekiq jid; null if a run was already in flight. */
  jobId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of VoiceProfileSetSample */
export type VoiceProfileSetSampleInput = {
  /** AdvisorProfile id whose voice profile owns the sample. */
  advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Canonical scenario id the sample answers. */
  scenario: Scalars['String']['input'];
  /** The generated sample reply text. Capped server-side. */
  text: Scalars['String']['input'];
};

/** Autogenerated return type of VoiceProfileSetSample. */
export type VoiceProfileSetSamplePayload = {
  __typename?: 'VoiceProfileSetSamplePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Updated voice profile after caching the sample. */
  profile: Maybe<AdvisorIdentityProfile>;
};

/** Autogenerated input type of VoidDocusignEnvelope */
export type VoidDocusignEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** DocuSign envelope ID to void */
  envelopeId: Scalars['String']['input'];
  /** Optional reason recorded on the envelope (defaults to a generic Pinetree string) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VoidDocusignEnvelope. */
export type VoidDocusignEnvelopePayload = {
  __typename?: 'VoidDocusignEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the envelope was voided */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WealthboxImportPreviewMutation */
export type WealthboxImportPreviewMutationInput = {
  /** Wealthbox personal access token. Validated via /v1/me. Never persisted. */
  accessToken: Scalars['String']['input'];
  /** Advisor whose existing households we suggest matches against. */
  advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WealthboxImportPreviewMutation. */
export type WealthboxImportPreviewMutationPayload = {
  __typename?: 'WealthboxImportPreviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Surfaced errors (auth failure, workspace too large, etc.). */
  errors: Array<Scalars['String']['output']>;
  /** Per-household summary. */
  households: Array<ImportHouseholdSummary>;
  /** Wealthbox Organization contacts that will be skipped. */
  skippedOrganizationCount: Scalars['Int']['output'];
  /** Names of the Wealthbox Organization contacts that will be skipped. */
  skippedOrganizationNames: Array<Scalars['String']['output']>;
  /** Wealthbox Trust contacts that will be skipped (not yet supported). */
  skippedTrustCount: Scalars['Int']['output'];
  /** Display name of the matched Wealthbox user for the selected advisor. Nil if no match found. */
  wealthboxAdvisorName: Maybe<Scalars['String']['output']>;
  /** Wealthbox user ID of the matched advisor. Passed back to the import submission for worker-side filtering. */
  wealthboxAdvisorUserId: Maybe<Scalars['Int']['output']>;
  /** Display name of the connected Wealthbox workspace. */
  workspaceName: Maybe<Scalars['String']['output']>;
};

/** A work item (task, event, or service) */
export type WorkItem = {
  __typename?: 'WorkItem';
  /** When the work item was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The work item ID */
  id: Scalars['ID']['output'];
  /** The task or calendar event represented by this work item */
  item: Maybe<WorkItemSource>;
  /** The type of the work item */
  itemType: WorkItemTypeName;
  /** When the work item was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An edge in a connection. */
export type WorkItemEdge = {
  __typename?: 'WorkItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WorkItem>;
};

/** Union of work item source types (Task, CalendarEvent, MeetingBooking) */
export type WorkItemSource = CalendarEvent | MeetingBooking | Task;

/** The type of a work item */
export type WorkItemTypeName =
  /** event */
  | 'event'
  /** service */
  | 'service'
  /** task */
  | 'task';

/** The connection type for Household. */
export type WorkbenchStatHouseholdConnection = {
  __typename?: 'WorkbenchStatHouseholdConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WorkbenchStatHouseholdEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Household>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of households in this stat */
  totalCount: Scalars['Int']['output'];
};

/** Edge wrapping a Household with stat-specific detail text */
export type WorkbenchStatHouseholdEdge = {
  __typename?: 'WorkbenchStatHouseholdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Household>;
  /** Stat-specific detail for this household (e.g. meeting time, task count) */
  statDetail: Maybe<Scalars['String']['output']>;
};

/** Available stat card keys for the workbench landing page */
export type WorkbenchStatKey =
  /** Households due for annual review */
  | 'annualReviews'
  /** Total assets across your book */
  | 'aum'
  /** Scheduled household meetings today */
  | 'meetings'
  /** Households being onboarded */
  | 'onboarding'
  /** Prospect households in your funnel */
  | 'pipeline'
  /** Open tasks tied to households */
  | 'tasks';

/** Summary values for all workbench stat cards */
export type WorkbenchStatSummary = {
  __typename?: 'WorkbenchStatSummary';
  /** Number of households with reviews due this quarter */
  annualReviewsCount: Scalars['Int']['output'];
  /** Number of households with overdue reviews */
  annualReviewsOverdue: Scalars['Int']['output'];
  /** Total AUM across all client households */
  aum: Scalars['BigInt']['output'];
  /** Number of households with meetings scheduled today */
  meetingsCount: Scalars['Int']['output'];
  /** Number of client households added in the last 30 days */
  newClientsCount: Scalars['Int']['output'];
  /** Formatted start time of the next meeting today (e.g. "11:00 AM") */
  nextMeetingTime: Maybe<Scalars['String']['output']>;
  /** Number of households in onboarding stage */
  onboardingCount: Scalars['Int']['output'];
  /** Number of open tasks */
  openTasksCount: Scalars['Int']['output'];
  /** Total estimated AUM across prospects */
  pipelineAum: Scalars['BigInt']['output'];
  /** Number of prospect households */
  pipelineCount: Scalars['Int']['output'];
  /** Number of prospect households added in the last 30 days */
  pipelineNewCount: Scalars['Int']['output'];
  /** Number of tasks due today */
  tasksDueToday: Scalars['Int']['output'];
};

/** Grants a user an action (e.g. edit) on a workflow template. */
export type WorkflowTemplateAclInput = {
  /** The action to grant. */
  action: TaskWorkflowTemplateAclAction;
  /** The user the action is granted to. */
  userId: Scalars['ID']['input'];
};

/** Sort values for the workflows table */
export type WorkflowTemplateSortValues =
  /** IN_PROGRESS */
  | 'IN_PROGRESS'
  /** LAST_USED */
  | 'LAST_USED'
  /** NAME */
  | 'NAME'
  /** OWNER */
  | 'OWNER'
  /** SCHEDULE */
  | 'SCHEDULE'
  /** SUBTASKS_COUNT */
  | 'SUBTASKS_COUNT'
  /** UPDATED_AT */
  | 'UPDATED_AT'
  /** VISIBILITY */
  | 'VISIBILITY';

export type WorkflowTemplatesFilterInput = {
  /** Filter by the workflow owner user id */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Search query for workflow names */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by schedule type */
  schedule?: InputMaybe<TaskWorkflowTemplateSchedule>;
  /** Filter by visibility. Private workflows are always restricted to the current advisor regardless of this filter. */
  visibility?: InputMaybe<TaskWorkflowTemplateVisibility>;
};

/** Type definition for a Wrike marketing request */
export type WrikeMarketingRequest = {
  __typename?: 'WrikeMarketingRequest';
  /** The advisor group label of the marketing request */
  advisorGroupLabel: Maybe<Scalars['String']['output']>;
  /** The advisor label of the marketing request */
  advisorLabel: Maybe<Scalars['String']['output']>;
  /** The first name of the assignee of the marketing request */
  assigneeFirstName: Maybe<Scalars['String']['output']>;
  /** The date and time the marketing request was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time the marketing request is due */
  dueDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The issue ID of the marketing request */
  issueId: Scalars['ID']['output'];
  /** The status of the marketing request */
  status: Scalars['String']['output'];
  /** The title of the marketing request */
  title: Scalars['String']['output'];
};

/** The response type for the Wrike marketing requests resolver */
export type WrikeMarketingRequests = {
  __typename?: 'WrikeMarketingRequests';
  /** The marketing requests accessible to the current user */
  requests: Array<WrikeMarketingRequest>;
  /** Whether the current user is in an advisor group */
  userIsInAdvisorGroup: Scalars['Boolean']['output'];
};

/** Transcript of a Zoom meeting recording. */
export type ZoomMeetingTranscript = {
  __typename?: 'ZoomMeetingTranscript';
  /** Recorded length in whole minutes, rounded up; null when either recording timestamp is missing. */
  durationMinutes: Maybe<Scalars['Int']['output']>;
  /** A bounded plain-text excerpt from the start of the transcript, skipping notetaker-bot lines. */
  excerpt: Maybe<Scalars['String']['output']>;
  /** When the transcript was fetched from Zoom. */
  fetchedAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the household this transcript belongs to. */
  householdName: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the transcript record. */
  id: Scalars['ID']['output'];
  /** Transcript lines as { name, content }. */
  lines: Maybe<Array<ZoomMeetingTranscriptLine>>;
  /** The Zoom meeting topic. */
  meetingTopic: Maybe<Scalars['String']['output']>;
  /** Distinct speaker names in the order they first speak, excluding notetaker bots. */
  participantNames: Array<Scalars['String']['output']>;
  /** When the recording started, falling back to when the row was created. */
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Transcript ingestion status: available or unavailable. */
  status: Scalars['String']['output'];
};

/** Transcript line of a Zoom meeting recording. */
export type ZoomMeetingTranscriptLine = {
  __typename?: 'ZoomMeetingTranscriptLine';
  /** Content of the speech */
  content: Maybe<Scalars['String']['output']>;
  /** Name of the speaker */
  name: Maybe<Scalars['String']['output']>;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', salesforceAccessToken: string | null, user: { __typename?: 'User', createdAt: string | null, email: string, phoneNumber: string | null, firstName: string, id: string, lastName: string, role: UserRole, confirmationStatus: UserConfirmationStatus, clientStage: ClientStage | null, profileType: UserProfile, profileId: string, profilePicUrl: string | null, isPrimaryClient: boolean, otpRequiredForLogin: boolean | null, personalPortfolioId: string | null, aiExperienceOptIn: boolean, primaryAdvisorEmail: string | null, timezone: string | null, addresses: Array<{ __typename?: 'Address', id: string }> } | null } };

export type ClientHouseholdQueryVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
}>;


export type ClientHouseholdQuery = { __typename?: 'Query', household: { __typename?: 'Household', id: string, demo: boolean, householdStage: HouseholdStage | null } };

export type InviteTokenUserQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteTokenUserQuery = { __typename?: 'Query', client: { __typename?: 'Client', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, role: UserRole } } };

export type XResetClientIntakeDataFooterButtonMutationVariables = Exact<{
  input: ResetClientIntakeDataInput;
}>;


export type XResetClientIntakeDataFooterButtonMutation = { __typename?: 'Mutation', resetClientIntakeData: { __typename?: 'ResetClientIntakeDataPayload', clientIntakeData: { __typename?: 'ClientIntakeData', id: string, intakeData: unknown } } | null };

export type UseTrackEventMutationVariables = Exact<{
  input: TrackEventInput;
}>;


export type UseTrackEventMutation = { __typename?: 'Mutation', trackEvent: { __typename: 'TrackEventPayload' } | null };

export type GenerateDataForPortfolioItemGroupsFragment = { __typename?: 'PortfolioItemGroup', name: PortfolioItemGroupName, accounts: Array<{ __typename: 'Account' }>, assets: Array<{ __typename: 'Asset' }>, hiddenFromClientHistoricalValues: Array<{ __typename?: 'HistoricalValue', date: string, value: { __typename?: 'Value', amount: string, currencyCode: string } }>, historicalValues: Array<{ __typename?: 'HistoricalValue', date: string, value: { __typename?: 'Value', amount: string, currencyCode: string } }>, liabilities: Array<{ __typename: 'Liability' }> } & { ' $fragmentName'?: 'GenerateDataForPortfolioItemGroupsFragment' };

export type AssetSubtitleFragment = { __typename?: 'Asset', assetClass: AssetClassName, assetSubclass: AssetSubclassName | null, companyEquityGrantType: string | null } & { ' $fragmentName'?: 'AssetSubtitleFragment' };

export type GenerateSalesforceAccessTokenMutationVariables = Exact<{
  input: GenerateSalesforceAccessTokenInput;
}>;


export type GenerateSalesforceAccessTokenMutation = { __typename?: 'Mutation', generateSalesforceAccessToken: { __typename?: 'GenerateSalesforceAccessTokenPayload', accessToken: string } | null };

export type XAccountDetailsGraphFragment = { __typename?: 'Query', account: (
    { __typename?: 'Account', displayName: string, id: string, providerLogoUrl: string | null, displayBalance: { __typename?: 'Value', amount: string }, performance: Array<{ __typename?: 'Performance', timePeriod: PerformanceTimePeriodName | null, twr: string | null }> | null }
    & { ' $fragmentRefs'?: { 'XPortfolioAccountRowTitleFragment': XPortfolioAccountRowTitleFragment;'XPortfolioAccountRowSubtitleFragment': XPortfolioAccountRowSubtitleFragment } }
  ), portfolioPerformanceReport: { __typename?: 'PortfolioPerformanceReport', portfolioGraphValues: Array<{ __typename?: 'PortfolioGraphValue', date: string, valueUsd: string, netInvestedUsd: string | null }> } } & { ' $fragmentName'?: 'XAccountDetailsGraphFragment' };

export type MobileAccountQueryVariables = Exact<{
  clientUserId: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;


export type MobileAccountQuery = (
  { __typename?: 'Query', account: { __typename?: 'Account', id: string }, portfolioPerformanceReport: (
    { __typename?: 'PortfolioPerformanceReport', id: string }
    & { ' $fragmentRefs'?: { 'XAssetCategoryAllocationsFragment': XAssetCategoryAllocationsFragment;'XPortfolioHoldingsFragment': XPortfolioHoldingsFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'XAccountDetailsGraphFragment': XAccountDetailsGraphFragment } }
);

export type XClientFacingNetWorthPageFragment = (
  { __typename?: 'NetWorthPortfolioData', portfolioItemGroups: Array<(
    { __typename?: 'PortfolioItemGroup', name: PortfolioItemGroupName, totalValue: { __typename?: 'Value', amount: string } }
    & { ' $fragmentRefs'?: { 'XNetWorthPortfolioItemGroupSectionFragment': XNetWorthPortfolioItemGroupSectionFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'XNetWorthGraphFragment': XNetWorthGraphFragment } }
) & { ' $fragmentName'?: 'XClientFacingNetWorthPageFragment' };

export type XNetWorthAccountIconFragment = { __typename?: 'Account', id: string, custody: AccountCustodyName, offeredBySavvy: boolean, providerLogoUrl: string | null, type: PortfolioItemTypeName } & { ' $fragmentName'?: 'XNetWorthAccountIconFragment' };

export type XNetWorthAccountRowFragment = (
  { __typename?: 'Account', id: string, custody: AccountCustodyName, displayName: string, lastUpdatedAt: string, type: PortfolioItemTypeName, offeredBySavvy: boolean, displayBalance: { __typename?: 'Value', amount: string } }
  & { ' $fragmentRefs'?: { 'XNetWorthAccountIconFragment': XNetWorthAccountIconFragment } }
) & { ' $fragmentName'?: 'XNetWorthAccountRowFragment' };

export type XNetWorthAccountsFragment = { __typename?: 'PortfolioItemGroup', accounts: Array<(
    { __typename?: 'Account', id: string }
    & { ' $fragmentRefs'?: { 'XNetWorthAccountRowFragment': XNetWorthAccountRowFragment } }
  )> } & { ' $fragmentName'?: 'XNetWorthAccountsFragment' };

export type XNetWorthAssetIconFragment = { __typename?: 'Asset', id: string, assetClass: AssetClassName, assetSubclass: AssetSubclassName | null } & { ' $fragmentName'?: 'XNetWorthAssetIconFragment' };

export type XNetWorthAssetRowFragment = (
  { __typename?: 'Asset', id: string, description: string, lastUpdatedAt: string, value: { __typename?: 'Value', amount: string } }
  & { ' $fragmentRefs'?: { 'AssetSubtitleFragment': AssetSubtitleFragment;'XNetWorthAssetIconFragment': XNetWorthAssetIconFragment } }
) & { ' $fragmentName'?: 'XNetWorthAssetRowFragment' };

export type XNetWorthAssetsFragment = { __typename?: 'PortfolioItemGroup', assets: Array<(
    { __typename?: 'Asset', id: string }
    & { ' $fragmentRefs'?: { 'XNetWorthAssetRowFragment': XNetWorthAssetRowFragment } }
  )> } & { ' $fragmentName'?: 'XNetWorthAssetsFragment' };

export type XNetWorthGraphFragment = { __typename?: 'NetWorthPortfolioData', netWorth: { __typename?: 'Value', amount: string }, portfolioItemGroups: Array<(
    { __typename?: 'PortfolioItemGroup' }
    & { ' $fragmentRefs'?: { 'GenerateDataForPortfolioItemGroupsFragment': GenerateDataForPortfolioItemGroupsFragment } }
  )> } & { ' $fragmentName'?: 'XNetWorthGraphFragment' };

export type XNetWorthLiabilitiesFragment = { __typename?: 'PortfolioItemGroup', liabilities: Array<(
    { __typename?: 'Liability', id: string }
    & { ' $fragmentRefs'?: { 'XNetWorthLiabilityRowFragment': XNetWorthLiabilityRowFragment } }
  )> } & { ' $fragmentName'?: 'XNetWorthLiabilitiesFragment' };

export type XNetWorthLiabilityIconFragment = { __typename?: 'Liability', id: string, type: PortfolioItemTypeName } & { ' $fragmentName'?: 'XNetWorthLiabilityIconFragment' };

export type XNetWorthLiabilityRowFragment = (
  { __typename?: 'Liability', id: string, name: string, type: PortfolioItemTypeName, lastUpdatedAt: string, currentBalance: { __typename?: 'Value', amount: string } }
  & { ' $fragmentRefs'?: { 'XNetWorthLiabilityIconFragment': XNetWorthLiabilityIconFragment } }
) & { ' $fragmentName'?: 'XNetWorthLiabilityRowFragment' };

export type XNetWorthPortfolioItemGroupSectionFragment = (
  { __typename?: 'PortfolioItemGroup', name: PortfolioItemGroupName, totalValue: { __typename?: 'Value', amount: string }, accounts: Array<{ __typename: 'Account' }>, assets: Array<{ __typename: 'Asset' }>, liabilities: Array<{ __typename: 'Liability' }> }
  & { ' $fragmentRefs'?: { 'XNetWorthAccountsFragment': XNetWorthAccountsFragment;'XNetWorthAssetsFragment': XNetWorthAssetsFragment;'XNetWorthLiabilitiesFragment': XNetWorthLiabilitiesFragment } }
) & { ' $fragmentName'?: 'XNetWorthPortfolioItemGroupSectionFragment' };

export type XPortfolioAccountRowSubtitleFragment = { __typename?: 'Account', accountName: string, custody: AccountCustodyName, loanProvider: string | null, offeredBySavvy: boolean, officialName: string | null, subtype: AccountSubtypeName | null, type: PortfolioItemTypeName, providerAccount: { __typename?: 'ProviderAccount', providerName: string | null } | null } & { ' $fragmentName'?: 'XPortfolioAccountRowSubtitleFragment' };

export type XPortfolioAccountRowTitleFragment = { __typename?: 'Account', accountName: string, custody: AccountCustodyName, officialName: string | null, subtype: AccountSubtypeName | null, type: PortfolioItemTypeName, providerAccount: { __typename?: 'ProviderAccount', providerName: string | null } | null } & { ' $fragmentName'?: 'XPortfolioAccountRowTitleFragment' };

export type XPortfolioAccountRowFragment = (
  { __typename?: 'Account', id: string, hiddenFromNetWorth: boolean | null, lastUpdatedAt: string, displayBalance: { __typename?: 'Value', amount: string }, providerAccount: { __typename?: 'ProviderAccount', id: string, sourceStatus: string | null } | null }
  & { ' $fragmentRefs'?: { 'XPortfolioAccountIconFragment': XPortfolioAccountIconFragment;'XPortfolioAccountRowSubtitleFragment': XPortfolioAccountRowSubtitleFragment;'XPortfolioAccountRowTitleFragment': XPortfolioAccountRowTitleFragment } }
) & { ' $fragmentName'?: 'XPortfolioAccountRowFragment' };

export type XPortfolioAccountsFragment = { __typename?: 'PortfolioItemGroup', accounts: Array<(
    { __typename?: 'Account', id: string }
    & { ' $fragmentRefs'?: { 'XPortfolioAccountRowFragment': XPortfolioAccountRowFragment } }
  )> } & { ' $fragmentName'?: 'XPortfolioAccountsFragment' };

export type XPortfolioAccountIconFragment = { __typename?: 'Account', custody: AccountCustodyName, offeredBySavvy: boolean, providerLogoUrl: string | null, type: PortfolioItemTypeName } & { ' $fragmentName'?: 'XPortfolioAccountIconFragment' };

export type XAssetCategoryAllocationRowFragment = { __typename?: 'AssetGrouping', name: string, percent: string, value: { __typename?: 'Value', amount: string } } & { ' $fragmentName'?: 'XAssetCategoryAllocationRowFragment' };

export type XAssetCategoryAllocationsFragment = { __typename?: 'PortfolioPerformanceReport', assetCategoryGrouping: Array<(
    { __typename?: 'AssetGrouping', name: string, value: { __typename?: 'Value', amount: string } }
    & { ' $fragmentRefs'?: { 'XAssetCategoryAllocationRowFragment': XAssetCategoryAllocationRowFragment } }
  )> } & { ' $fragmentName'?: 'XAssetCategoryAllocationsFragment' };

export type XClientFacingPortfolioPageFragment = (
  { __typename?: 'Query', portfolioPerformanceReport: (
    { __typename?: 'PortfolioPerformanceReport', id: string }
    & { ' $fragmentRefs'?: { 'XAssetCategoryAllocationsFragment': XAssetCategoryAllocationsFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'XPortfolioTabsWithContentFragment': XPortfolioTabsWithContentFragment;'XManagedBySavvvyGraphFragment': XManagedBySavvvyGraphFragment } }
) & { ' $fragmentName'?: 'XClientFacingPortfolioPageFragment' };

export type XClientFacingPortfolioPageSlowFragment = (
  { __typename?: 'Query' }
  & { ' $fragmentRefs'?: { 'XPortfolioTabsWithContentSlowFragment': XPortfolioTabsWithContentSlowFragment } }
) & { ' $fragmentName'?: 'XClientFacingPortfolioPageSlowFragment' };

export type XManagedBySavvvyGraphFragment = { __typename?: 'Query', portfolioPerformanceReport: { __typename?: 'PortfolioPerformanceReport', id: string, portfolioGraphValues: Array<{ __typename?: 'PortfolioGraphValue', date: string, netInvestedUsd: string | null, valueUsd: string }>, performanceOverTime: Array<{ __typename?: 'Performance', startDate: string, timePeriod: PerformanceTimePeriodName | null, twr: string | null }> }, portfolio: { __typename?: 'NetWorthPortfolioData', savvyAccounts: { __typename?: 'Value', amount: string } } } & { ' $fragmentName'?: 'XManagedBySavvvyGraphFragment' };

export type XPortfolioAssetClassesRowHoldingsRowFragment = { __typename?: 'ReportedHolding', name: string, ticker: string, percent: string | null, value: { __typename?: 'ReportedHoldingValue', amount: string | null } | null } & { ' $fragmentName'?: 'XPortfolioAssetClassesRowHoldingsRowFragment' };

export type XPortfolioAssetClassesRowFragment = { __typename?: 'AssetGrouping', name: string, percent: string, performanceOverTime: Array<{ __typename?: 'Performance', startDate: string, endDate: string, timePeriod: PerformanceTimePeriodName | null, twr: string | null, usdReturn: string | null }> | null, value: { __typename?: 'Value', amount: string } } & { ' $fragmentName'?: 'XPortfolioAssetClassesRowFragment' };

export type XPortfolioAssetClassesRowHoldingFragment = (
  { __typename?: 'ReportedHolding', assetCategory: string | null, percent: string | null, ticker: string }
  & { ' $fragmentRefs'?: { 'XPortfolioAssetClassesRowHoldingsRowFragment': XPortfolioAssetClassesRowHoldingsRowFragment } }
) & { ' $fragmentName'?: 'XPortfolioAssetClassesRowHoldingFragment' };

export type XPortfolioAssetClassesFragment = { __typename?: 'PortfolioPerformanceReport', assetClassGrouping: Array<(
    { __typename?: 'AssetGrouping', name: string, percent: string }
    & { ' $fragmentRefs'?: { 'XPortfolioAssetClassesRowFragment': XPortfolioAssetClassesRowFragment } }
  )>, holdings: Array<(
    { __typename?: 'ReportedHolding', assetClass: string | null, name: string, percent: string | null }
    & { ' $fragmentRefs'?: { 'XPortfolioAssetClassesRowHoldingFragment': XPortfolioAssetClassesRowHoldingFragment } }
  )> } & { ' $fragmentName'?: 'XPortfolioAssetClassesFragment' };

export type XPortfolioHoldingsRowFragment = { __typename?: 'ReportedHolding', name: string, ticker: string, percent: string | null, value: { __typename?: 'ReportedHoldingValue', amount: string | null } | null } & { ' $fragmentName'?: 'XPortfolioHoldingsRowFragment' };

export type XPortfolioHoldingsFragment = { __typename?: 'PortfolioPerformanceReport', id: string, holdings: Array<(
    { __typename?: 'ReportedHolding', ticker: string }
    & { ' $fragmentRefs'?: { 'XPortfolioHoldingsRowFragment': XPortfolioHoldingsRowFragment } }
  )> } & { ' $fragmentName'?: 'XPortfolioHoldingsFragment' };

export type XPortfolioTabsWithContentFragment = { __typename?: 'Query', portfolio: { __typename?: 'NetWorthPortfolioData', id: string | null, portfolioItemGroups: Array<(
      { __typename?: 'PortfolioItemGroup', name: PortfolioItemGroupName }
      & { ' $fragmentRefs'?: { 'XPortfolioAccountsFragment': XPortfolioAccountsFragment } }
    )> } } & { ' $fragmentName'?: 'XPortfolioTabsWithContentFragment' };

export type XPortfolioTabsWithContentSlowFragment = { __typename?: 'Query', portfolioPerformanceReport: (
    { __typename?: 'PortfolioPerformanceReport', id: string }
    & { ' $fragmentRefs'?: { 'XPortfolioAssetClassesFragment': XPortfolioAssetClassesFragment;'XPortfolioHoldingsFragment': XPortfolioHoldingsFragment } }
  ) } & { ' $fragmentName'?: 'XPortfolioTabsWithContentSlowFragment' };

export type XDisableMfaDialogMutationVariables = Exact<{
  input: UpdateUserSecurityAttributeInput;
}>;


export type XDisableMfaDialogMutation = { __typename?: 'Mutation', updateUserSecurityAttribute: { __typename?: 'UpdateUserSecurityAttributePayload', user: { __typename?: 'User', id: string, otpRequiredForLogin: boolean | null } } | null };

export type XEnableMfaDialogOtpMutationVariables = Exact<{
  input: UpdateUserSecurityAttributeInput;
}>;


export type XEnableMfaDialogOtpMutation = { __typename?: 'Mutation', updateUserSecurityAttribute: { __typename?: 'UpdateUserSecurityAttributePayload', user: { __typename?: 'User', id: string, otpRequiredForLogin: boolean | null } } | null };

export type XEnableMfaDialogPhoneMutationVariables = Exact<{
  input: BeginMfaEnrollmentInput;
}>;


export type XEnableMfaDialogPhoneMutation = { __typename?: 'Mutation', beginMfaEnrollment: { __typename?: 'BeginMfaEnrollmentPayload', channel: string | null } | null };

export type XUpdateMfaDialogPasswordQueryVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type XUpdateMfaDialogPasswordQuery = { __typename?: 'Query', isValidPassword: boolean };

export type LoginFormFragment = { __typename?: 'Client', user: { __typename?: 'User', email: string } } & { ' $fragmentName'?: 'LoginFormFragment' };

export type XLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type XLoginQuery = { __typename?: 'Query', client: (
    { __typename?: 'Client', user: { __typename?: 'User', email: string, firstName: string, phoneNumber: string | null }, household: { __typename?: 'Household', coClient: { __typename?: 'Client', user: { __typename?: 'User', firstName: string } } | null } }
    & { ' $fragmentRefs'?: { 'LoginFormFragment': LoginFormFragment } }
  ) };

export type OtpFormMutationVariables = Exact<{
  input: ResendOtpInput;
}>;


export type OtpFormMutation = { __typename?: 'Mutation', resendOtp: { __typename?: 'ResendOtpPayload', error: string | null } | null };

export type OtpLoginFormMutationVariables = Exact<{
  input: ResendOtpInput;
}>;


export type OtpLoginFormMutation = { __typename?: 'Mutation', resendOtp: { __typename?: 'ResendOtpPayload', error: string | null } | null };

export type XResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type XResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordPayload', success: boolean, errorMessage: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  updateInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', firstName: string, email: string } } | null };

export type XUserProfileFragment = { __typename?: 'Client', assignedAdvisor: { __typename?: 'Advisor', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, phoneNumber: string | null, email: string } } } & { ' $fragmentName'?: 'XUserProfileFragment' };

export const XPortfolioAccountRowTitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XPortfolioAccountRowTitleFragment, unknown>;
export const XPortfolioAccountRowSubtitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XPortfolioAccountRowSubtitleFragment, unknown>;
export const XAccountDetailsGraphFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAccountDetailsGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioGraphValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestedUsd"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XAccountDetailsGraphFragment, unknown>;
export const GenerateDataForPortfolioItemGroupsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerateDataForPortfolioItemGroups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromClientHistoricalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"historicalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GenerateDataForPortfolioItemGroupsFragment, unknown>;
export const XNetWorthGraphFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NetWorthPortfolioData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"netWorth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioItemGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerateDataForPortfolioItemGroups"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerateDataForPortfolioItemGroups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromClientHistoricalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"historicalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<XNetWorthGraphFragment, unknown>;
export const XNetWorthAccountIconFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XNetWorthAccountIconFragment, unknown>;
export const XNetWorthAccountRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountIcon"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XNetWorthAccountRowFragment, unknown>;
export const XNetWorthAccountsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountIcon"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}}]}}]} as unknown as DocumentNode<XNetWorthAccountsFragment, unknown>;
export const AssetSubtitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}},{"kind":"Field","name":{"kind":"Name","value":"companyEquityGrantType"}}]}}]} as unknown as DocumentNode<AssetSubtitleFragment, unknown>;
export const XNetWorthAssetIconFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}}]}}]} as unknown as DocumentNode<XNetWorthAssetIconFragment, unknown>;
export const XNetWorthAssetRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetIcon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}},{"kind":"Field","name":{"kind":"Name","value":"companyEquityGrantType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}}]}}]} as unknown as DocumentNode<XNetWorthAssetRowFragment, unknown>;
export const XNetWorthAssetsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}},{"kind":"Field","name":{"kind":"Name","value":"companyEquityGrantType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetIcon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XNetWorthAssetsFragment, unknown>;
export const XNetWorthLiabilityIconFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XNetWorthLiabilityIconFragment, unknown>;
export const XNetWorthLiabilityRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XNetWorthLiabilityRowFragment, unknown>;
export const XNetWorthLiabilitiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}}]} as unknown as DocumentNode<XNetWorthLiabilitiesFragment, unknown>;
export const XNetWorthPortfolioItemGroupSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthPortfolioItemGroupSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccounts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssets"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilities"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountIcon"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}},{"kind":"Field","name":{"kind":"Name","value":"companyEquityGrantType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetIcon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityRow"}}]}}]}}]} as unknown as DocumentNode<XNetWorthPortfolioItemGroupSectionFragment, unknown>;
export const XClientFacingNetWorthPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XClientFacingNetWorthPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NetWorthPortfolioData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthGraph"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioItemGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthPortfolioItemGroupSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerateDataForPortfolioItemGroups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromClientHistoricalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"historicalValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountIcon"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccountRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}},{"kind":"Field","name":{"kind":"Name","value":"companyEquityGrantType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"assetSubclass"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssetRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetIcon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthAssets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssetRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilityRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Liability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityIcon"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthLiabilities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilityRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NetWorthPortfolioData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"netWorth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioItemGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerateDataForPortfolioItemGroups"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XNetWorthPortfolioItemGroupSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAccounts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthAssets"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XNetWorthLiabilities"}}]}}]} as unknown as DocumentNode<XClientFacingNetWorthPageFragment, unknown>;
export const XPortfolioAccountIconFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XPortfolioAccountIconFragment, unknown>;
export const XPortfolioAccountRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountIcon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromNetWorth"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceStatus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<XPortfolioAccountRowFragment, unknown>;
export const XPortfolioAccountsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRow"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountIcon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromNetWorth"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceStatus"}}]}}]}}]} as unknown as DocumentNode<XPortfolioAccountsFragment, unknown>;
export const XPortfolioTabsWithContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioTabsWithContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioItemGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccounts"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountIcon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromNetWorth"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceStatus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRow"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<XPortfolioTabsWithContentFragment, unknown>;
export const XManagedBySavvvyGraphFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XManagedBySavvvyGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioGraphValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestedUsd"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savvyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<XManagedBySavvvyGraphFragment, unknown>;
export const XAssetCategoryAllocationRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XAssetCategoryAllocationRowFragment, unknown>;
export const XAssetCategoryAllocationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetCategoryGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XAssetCategoryAllocationsFragment, unknown>;
export const XClientFacingPortfolioPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XClientFacingPortfolioPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioTabsWithContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XManagedBySavvvyGraph"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAssetCategoryAllocations"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountIcon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountIcon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromNetWorth"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceStatus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccounts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioItemGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRow"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioTabsWithContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioItemGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccounts"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XManagedBySavvvyGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioGraphValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestedUsd"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savvyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetCategoryGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<XClientFacingPortfolioPageFragment, unknown>;
export const XPortfolioAssetClassesRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}},{"kind":"Field","name":{"kind":"Name","value":"usdReturn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XPortfolioAssetClassesRowFragment, unknown>;
export const XPortfolioAssetClassesRowHoldingsRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XPortfolioAssetClassesRowHoldingsRowFragment, unknown>;
export const XPortfolioAssetClassesRowHoldingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"}},{"kind":"Field","name":{"kind":"Name","value":"assetCategory"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XPortfolioAssetClassesRowHoldingFragment, unknown>;
export const XPortfolioAssetClassesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClasses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}},{"kind":"Field","name":{"kind":"Name","value":"usdReturn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"}},{"kind":"Field","name":{"kind":"Name","value":"assetCategory"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]} as unknown as DocumentNode<XPortfolioAssetClassesFragment, unknown>;
export const XPortfolioHoldingsRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XPortfolioHoldingsRowFragment, unknown>;
export const XPortfolioHoldingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldingsRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<XPortfolioHoldingsFragment, unknown>;
export const XPortfolioTabsWithContentSlowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioTabsWithContentSlow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClasses"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}},{"kind":"Field","name":{"kind":"Name","value":"usdReturn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"}},{"kind":"Field","name":{"kind":"Name","value":"assetCategory"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClasses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldingsRow"}}]}}]}}]} as unknown as DocumentNode<XPortfolioTabsWithContentSlowFragment, unknown>;
export const XClientFacingPortfolioPageSlowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XClientFacingPortfolioPageSlow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioTabsWithContentSlow"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"performanceOverTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}},{"kind":"Field","name":{"kind":"Name","value":"usdReturn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHoldingsRow"}},{"kind":"Field","name":{"kind":"Name","value":"assetCategory"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAssetClasses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClassesRowHolding"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldingsRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioTabsWithContentSlow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAssetClasses"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldings"}}]}}]}}]} as unknown as DocumentNode<XClientFacingPortfolioPageSlowFragment, unknown>;
export const LoginFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoginForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<LoginFormFragment, unknown>;
export const XUserProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XUserProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedAdvisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<XUserProfileFragment, unknown>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientStage"}},{"kind":"Field","name":{"kind":"Name","value":"profileType"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimaryClient"}},{"kind":"Field","name":{"kind":"Name","value":"otpRequiredForLogin"}},{"kind":"Field","name":{"kind":"Name","value":"personalPortfolioId"}},{"kind":"Field","name":{"kind":"Name","value":"aiExperienceOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"primaryAdvisorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesforceAccessToken"}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const ClientHouseholdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientHousehold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesforceAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"household"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"salesforceAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesforceAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"demo"}},{"kind":"Field","name":{"kind":"Name","value":"householdStage"}}]}}]}}]} as unknown as DocumentNode<ClientHouseholdQuery, ClientHouseholdQueryVariables>;
export const InviteTokenUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteTokenUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<InviteTokenUserQuery, InviteTokenUserQueryVariables>;
export const XResetClientIntakeDataFooterButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XResetClientIntakeDataFooterButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetClientIntakeDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetClientIntakeData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientIntakeData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intakeData"}}]}}]}}]}}]} as unknown as DocumentNode<XResetClientIntakeDataFooterButtonMutation, XResetClientIntakeDataFooterButtonMutationVariables>;
export const UseTrackEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UseTrackEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UseTrackEventMutation, UseTrackEventMutationVariables>;
export const GenerateSalesforceAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateSalesforceAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSalesforceAccessTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSalesforceAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<GenerateSalesforceAccessTokenMutation, GenerateSalesforceAccessTokenMutationVariables>;
export const MobileAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MobileAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAccountDetailsGraph"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAssetCategoryAllocations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"custody"}},{"kind":"Field","name":{"kind":"Name","value":"loanProvider"}},{"kind":"Field","name":{"kind":"Name","value":"offeredBySavvy"}},{"kind":"Field","name":{"kind":"Name","value":"officialName"}},{"kind":"Field","name":{"kind":"Name","value":"providerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGrouping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldingsRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportedHolding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAccountDetailsGraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioAccountRowSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"twr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerLogoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolioPerformanceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioGraphValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"netInvestedUsd"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XAssetCategoryAllocations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetCategoryGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"XAssetCategoryAllocationRow"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"XPortfolioHoldings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioPerformanceReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"XPortfolioHoldingsRow"}}]}}]}}]} as unknown as DocumentNode<MobileAccountQuery, MobileAccountQueryVariables>;
export const XDisableMfaDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XDisableMfaDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSecurityAttributeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSecurityAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otpRequiredForLogin"}}]}}]}}]}}]} as unknown as DocumentNode<XDisableMfaDialogMutation, XDisableMfaDialogMutationVariables>;
export const XEnableMfaDialogOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XEnableMfaDialogOtp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSecurityAttributeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSecurityAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otpRequiredForLogin"}}]}}]}}]}}]} as unknown as DocumentNode<XEnableMfaDialogOtpMutation, XEnableMfaDialogOtpMutationVariables>;
export const XEnableMfaDialogPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XEnableMfaDialogPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BeginMfaEnrollmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beginMfaEnrollment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}}]}}]}}]} as unknown as DocumentNode<XEnableMfaDialogPhoneMutation, XEnableMfaDialogPhoneMutationVariables>;
export const XUpdateMfaDialogPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"XUpdateMfaDialogPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValidPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<XUpdateMfaDialogPasswordQuery, XUpdateMfaDialogPasswordQueryVariables>;
export const XLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"XLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoginForm"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"household"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coClient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoginForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<XLoginQuery, XLoginQueryVariables>;
export const OtpFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OtpForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendOtpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<OtpFormMutation, OtpFormMutationVariables>;
export const OtpLoginFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OtpLoginForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendOtpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<OtpLoginFormMutation, OtpLoginFormMutationVariables>;
export const XResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<XResetPasswordMutation, XResetPasswordMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;